
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8N7MV", function(module, exports) {
var $503e8d9230dc05b9$export$c23e925a9f49ee3c = /*#__PURE__*/ function(ConfluenceGraphQLDateFilterFieldType) {
    ConfluenceGraphQLDateFilterFieldType["LASTMODIFIED"] = "LASTMODIFIED";
    ConfluenceGraphQLDateFilterFieldType["CREATED"] = "CREATED,";
    return ConfluenceGraphQLDateFilterFieldType;
}({});


const $2d377a309015f04b$export$52e069b7e2e3e8fb = 'ari:cloud:confluence::site/';
const $2d377a309015f04b$var$MAX_RESULTS_PAGE_BLOG_ATTACHMENTS = 10;
const $2d377a309015f04b$var$MAX_RESULTS_SPACES = 3;
const $2d377a309015f04b$export$9101978d57f6d48a = 'ati:cloud:confluence:page';
const $2d377a309015f04b$export$5e59c260151d03b2 = 'ati:cloud:confluence:blogpost';
const $2d377a309015f04b$var$ATTACHMENT_ATI = 'ati:cloud:confluence:attachment';
const $2d377a309015f04b$export$71fb3a6d48f3d84f = [
    $2d377a309015f04b$export$9101978d57f6d48a,
    $2d377a309015f04b$export$5e59c260151d03b2,
    $2d377a309015f04b$var$ATTACHMENT_ATI
];
const $2d377a309015f04b$var$graphQLFilterMapper = (filters)=>{
    const confluenceFilters = {};
    filters.forEach((filter)=>{
        switch(filter['@type']){
            case 'spaces':
                confluenceFilters['spacesFilter'] = filter.spaceKeys;
                break;
            case 'verified':
                confluenceFilters['isVerified'] = filter.verified;
                break;
            case 'contributors':
                confluenceFilters['contributorsFilter'] = filter.accountIds;
                break;
            case 'lastModified':
                confluenceFilters['range'] = {
                    field: (0, $503e8d9230dc05b9$export$c23e925a9f49ee3c).LASTMODIFIED,
                    gt: filter.from,
                    lt: filter.to
                };
                break;
            case 'titleMatchOnly':
                confluenceFilters['titleMatchOnly'] = filter.enabled;
                break;
            default:
                break;
        }
    });
    return confluenceFilters;
};
const $2d377a309015f04b$export$74c39e342047d9d1 = (filters)=>filters.some((filter)=>{
        if (filter['@type'] === 'spaces' && filter.spaceKeys && filter.spaceKeys.length > 0) return true;
        else if (filter['@type'] === 'contributors' && filter.accountIds && filter.accountIds.length > 0) return true;
        else if (filter['@type'] === 'lastModified' && filter.from && filter.to) return true;
        return false;
    });
const $2d377a309015f04b$export$76ca4f6f223de78a = ({ query: query, filters: filters, contentEntities: contentEntities = $2d377a309015f04b$export$71fb3a6d48f3d84f, analyticsInfo: analyticsInfo, cloudId: cloudId, pageBlogAttachmentLimit: pageBlogAttachmentLimit = $2d377a309015f04b$var$MAX_RESULTS_PAGE_BLOG_ATTACHMENTS, spaceLimit: spaceLimit = $2d377a309015f04b$var$MAX_RESULTS_SPACES, includeAncestors: includeAncestors = false, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers })=>{
    return {
        query: query,
        cloudIdARI: `${$2d377a309015f04b$export$52e069b7e2e3e8fb}${cloudId}`,
        pageBlogAttachmentLimit: pageBlogAttachmentLimit,
        spaceLimit: spaceLimit,
        includeAncestors: includeAncestors,
        contentEntities: contentEntities,
        confluenceFilters: $2d377a309015f04b$var$graphQLFilterMapper(filters),
        searchSessionId: analyticsInfo?.searchSessionId,
        queryVersion: analyticsInfo?.queryVersion,
        includeSpaces: !$2d377a309015f04b$export$74c39e342047d9d1(filters),
        experimentContext: {
            experimentId: experimentId,
            shadowExperimentId: shadowExperimentId,
            experimentLayers: experimentLayers
        }
    };
};
module.exports["CONFLUENCE_ARI_PREFIX"] = $2d377a309015f04b$export$52e069b7e2e3e8fb;
module.exports["PAGE_ATI"] = $2d377a309015f04b$export$9101978d57f6d48a;
module.exports["BLOGPOST_ATI"] = $2d377a309015f04b$export$5e59c260151d03b2;

});

parcelRegister("hOJLU", function(module, exports) {

var $jR2a0 = parcelRequire("jR2a0");


var $7tsC5 = parcelRequire("7tsC5");


var $7Mvs5 = parcelRequire("7Mvs5");


var $4ut97 = parcelRequire("4ut97");


var $9Ppk1 = parcelRequire("9Ppk1");


var $lqSug = parcelRequire("lqSug");


var $bzYTC = parcelRequire("bzYTC");


var $ah5yI = parcelRequire("ah5yI");


var $hJYQM = parcelRequire("hJYQM");


var $e7vVr = parcelRequire("e7vVr");

const $b8247b760e499566$export$3f23d3d88b2b0734 = `
description
iconUrl
id
title
type
url
__typename
`;
const $b8247b760e499566$export$9f64d624a5905b0b = ()=>{
    return `
		${(0, $lqSug.getConfluencePartials)()}
		${(0, $bzYTC.getJiraPartials)()}
		${(0, $e7vVr.getTrelloPartials)()}
		${(0, $4ut97.getAtlasPartials)()}
		${(0, $9Ppk1.getCompassPartials)()}
		${(0, $hJYQM.getGooglePartials)()}
		${(0, $hJYQM.getMicrosoftPartials)()}
		${(0, $hJYQM.getSlackPartials)()}
		${(0, $ah5yI.getGraphPartials)()}
	`;
};
const $b8247b760e499566$export$5db520940cf00715 = 'SearchPageQuery';
const $b8247b760e499566$export$bcad4d0714f0772f = ()=>{
    const partials = $b8247b760e499566$export$9f64d624a5905b0b();
    const graphQuery = `
	query ${$b8247b760e499566$export$5db520940cf00715}(
		$query: String!
		$cloudIdARI: String!
		$tenantId: ID!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$after: String
		$disableQueryReplacement: Boolean
	) {
		search {
			results: search(
				experience: "search-page"
				query: $query
				first: $limit
				after: $after
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: [$cloudIdARI]
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					thirdPartyFilters: $thirdPartyFilters
				}
		analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sourceProduct: $sourceProduct
				}
		experimentContext: {
			experimentId: $experimentId
			shadowExperimentId: $shadowExperimentId
			experimentLayers: $experimentLayers
		}
			) {
				edges {
					node {
						${$b8247b760e499566$export$3f23d3d88b2b0734}
						${partials}
					}
				}
				queryInfo {
					originalQuery
					replacementQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
        pageInfo {
          endCursor
        }
			}
		}
	}
	`;
    return graphQuery;
};
const $b8247b760e499566$export$59ff8b98cf7da770 = 'ResultsCountQuery';
const $b8247b760e499566$export$35addfdbe1c7b563 = ()=>{
    const graphQuery = `
	query ${$b8247b760e499566$export$59ff8b98cf7da770}(
		$query: String!
		$cloudIdARI: String!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$disableQueryReplacement: Boolean
	) {
		search {
			results: search(
				experience: "search-page"
				query: $query
				first: $limit
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: [$cloudIdARI]
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					thirdPartyFilters: $thirdPartyFilters
				}
		analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sourceProduct: $sourceProduct
				}
		experimentContext: {
			experimentId: $experimentId
			shadowExperimentId: $shadowExperimentId
			experimentLayers: $experimentLayers
		}
			) {

				queryInfo {
					originalQuery
					replacementQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
			}
		}
	}
	`;
    return graphQuery;
};


const $24090ff8296dcc65$export$69a3209f1a06c04d = (0, $7Mvs5.inMemoryCache)();
const $24090ff8296dcc65$export$a4f9b7f788f9e71f = (variables, originalQuery)=>{
    /**
   * Results once fetched will be used for upto 15 minutes from an in memory cache.
   * 1. Generate key based on query, entities, filters
   * 2. Serve from cache if present without resetting the expiration, evict if results are expired
   * 3. If not present or expired then invoke the api
   * 4. If API is invoked then store response in the cache with expiration and return back the response
   */ const keyObj = {
        query: variables.query,
        entities: variables.entities,
        commonFilters: variables.commonFilters,
        confluenceFilters: variables.confluenceFilters,
        jiraFilters: variables.jiraFilters,
        thirdPartyFilters: variables.thirdPartyFilters,
        cloudIdARI: variables.cloudIdARI,
        sortField: variables.sort.at(0)?.field ?? '',
        sortOrder: variables.sort.at(0)?.order ?? '',
        after: variables.after,
        originalQuery: originalQuery
    };
    return (0, $7tsC5.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or edges are empty
const $24090ff8296dcc65$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.search.results.edges.length === 0;
};
const $24090ff8296dcc65$export$8d55189398f4cde7 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery })=>{
    const graphQuery = (0, $b8247b760e499566$export$bcad4d0714f0772f)();
    return $24090ff8296dcc65$export$69a3209f1a06c04d.inMemoryDecorator($24090ff8296dcc65$export$a4f9b7f788f9e71f(variables, originalQuery), ()=>(0, $jR2a0.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: $b8247b760e499566$export$5db520940cf00715
        }), $24090ff8296dcc65$var$expireWhen);
};
const $24090ff8296dcc65$export$3dbd5bda6e5269b6 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery })=>{
    const graphQuery = (0, $b8247b760e499566$export$35addfdbe1c7b563)();
    return $24090ff8296dcc65$export$69a3209f1a06c04d.inMemoryDecorator($24090ff8296dcc65$export$a4f9b7f788f9e71f(variables, originalQuery), ()=>(0, $jR2a0.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: (0, $b8247b760e499566$export$59ff8b98cf7da770)
        }));
};
module.exports["cache"] = $24090ff8296dcc65$export$69a3209f1a06c04d;
module.exports["searchPageQuery"] = $24090ff8296dcc65$export$8d55189398f4cde7;
module.exports["resultsCountQuery"] = $24090ff8296dcc65$export$3dbd5bda6e5269b6;

});

parcelRegister("4XdCR", function(module, exports) {
const $baaceea3a5cc891e$export$fdf34174678f07b6 = {
    LAST_MODIFIED_DATE: 'latestModifiedDate',
    CREATED_DATE: 'createdDate'
};
const $baaceea3a5cc891e$export$d33cb9b119034d29 = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $baaceea3a5cc891e$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC = `${$baaceea3a5cc891e$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$baaceea3a5cc891e$export$d33cb9b119034d29.DESC}`;
const $baaceea3a5cc891e$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC = `${$baaceea3a5cc891e$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$baaceea3a5cc891e$export$d33cb9b119034d29.ASC}`;
const $baaceea3a5cc891e$var$SORT_FIELD_KEY_CREATED_DATE_DESC = `${$baaceea3a5cc891e$export$fdf34174678f07b6.CREATED_DATE}${$baaceea3a5cc891e$export$d33cb9b119034d29.DESC}`;
const $baaceea3a5cc891e$var$SORT_FIELD_KEY_CREATED_DATE_ASC = `${$baaceea3a5cc891e$export$fdf34174678f07b6.CREATED_DATE}${$baaceea3a5cc891e$export$d33cb9b119034d29.ASC}`;
const $baaceea3a5cc891e$export$6b492fdcc7e8d1f4 = {
    [$baaceea3a5cc891e$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC]: {
        field: $baaceea3a5cc891e$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $baaceea3a5cc891e$export$d33cb9b119034d29.DESC,
        labelKey: $baaceea3a5cc891e$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC,
        selectedLabelKey: `${$baaceea3a5cc891e$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC}Selected`,
        drawerOrder: 0
    },
    [$baaceea3a5cc891e$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC]: {
        field: $baaceea3a5cc891e$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $baaceea3a5cc891e$export$d33cb9b119034d29.ASC,
        labelKey: $baaceea3a5cc891e$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC,
        selectedLabelKey: `${$baaceea3a5cc891e$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC}Selected`,
        drawerOrder: 1
    },
    [$baaceea3a5cc891e$var$SORT_FIELD_KEY_CREATED_DATE_DESC]: {
        field: $baaceea3a5cc891e$export$fdf34174678f07b6.CREATED_DATE,
        order: $baaceea3a5cc891e$export$d33cb9b119034d29.DESC,
        labelKey: $baaceea3a5cc891e$var$SORT_FIELD_KEY_CREATED_DATE_DESC,
        selectedLabelKey: `${$baaceea3a5cc891e$var$SORT_FIELD_KEY_CREATED_DATE_DESC}Selected`,
        drawerOrder: 2
    },
    [$baaceea3a5cc891e$var$SORT_FIELD_KEY_CREATED_DATE_ASC]: {
        field: $baaceea3a5cc891e$export$fdf34174678f07b6.CREATED_DATE,
        order: $baaceea3a5cc891e$export$d33cb9b119034d29.ASC,
        labelKey: $baaceea3a5cc891e$var$SORT_FIELD_KEY_CREATED_DATE_ASC,
        selectedLabelKey: `${$baaceea3a5cc891e$var$SORT_FIELD_KEY_CREATED_DATE_ASC}Selected`,
        drawerOrder: 3
    }
};
const $baaceea3a5cc891e$export$76673e1b214c1378 = Object.values($baaceea3a5cc891e$export$6b492fdcc7e8d1f4).sort((a, b)=>a.drawerOrder - b.drawerOrder);
const $baaceea3a5cc891e$export$d3cbda30e53df6f6 = (field, order)=>`${field}${order}`;
module.exports["SORT_FIELD_KEY"] = $baaceea3a5cc891e$export$fdf34174678f07b6;
module.exports["SORT_ORDER"] = $baaceea3a5cc891e$export$d33cb9b119034d29;
module.exports["RESULTS_SORT_FIELDS"] = $baaceea3a5cc891e$export$6b492fdcc7e8d1f4;
module.exports["ResultsSortOptions"] = $baaceea3a5cc891e$export$76673e1b214c1378;
module.exports["getOptionKey"] = $baaceea3a5cc891e$export$d3cbda30e53df6f6;

});

parcelRegister("hz3c4", function(module, exports) {

var $htTgH = parcelRequire("htTgH");


var $37AYo = parcelRequire("37AYo");


var $3Q5mv = parcelRequire("3Q5mv");


var $jpB6G = parcelRequire("jpB6G");

const $af5d0da7acc49c77$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $af5d0da7acc49c77$var$MICROSOFT_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $af5d0da7acc49c77$var$WEB_CRAWLER_INTEGRATION_ARI = 'ari:cloud:platform::integration/atlassian-web-crawler';
const $af5d0da7acc49c77$var$GITHUB_INTEGRATION_ARI = 'ari:cloud:platform::integration/github';
const $af5d0da7acc49c77$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $af5d0da7acc49c77$var$FIGMA_INTEGRATION_ARI = 'ari:cloud:platform::integration/figma';
const $af5d0da7acc49c77$var$LOOM_INTEGRATION_ARI = 'ari:cloud:platform::integration/loom';
const $af5d0da7acc49c77$var$DROPBOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/dropbox';
const $af5d0da7acc49c77$var$SLACK_INTEGRATION_ARI = 'ari:cloud:platform::integration/slack';
const $af5d0da7acc49c77$var$AIRTABLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/airtable';
const $af5d0da7acc49c77$var$BITBUCKET_INTEGRATION_ARI = 'ari:cloud:platform::integration/bitbucket';
const $af5d0da7acc49c77$var$NOTION_INTEGRATION_ARI = 'ari:cloud:platform::integration/notion';
const $af5d0da7acc49c77$var$MIRO_INTEGRATION_ARI = 'ari:cloud:platform::integration/miro';
const $af5d0da7acc49c77$export$b7b676578c62639d = ()=>({
        commonFilters: {},
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: []
        },
        jiraFilters: {
            issueFilter: {
                assigneeARIs: [],
                projectARIs: []
            }
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: [],
            integrations: []
        }
    });
const $af5d0da7acc49c77$export$79cd775d0d5c2a2 = (from, to)=>{
    const fromDate = from ? new Date(from) : new Date();
    const startOfTheFromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0);
    const toDate = to ? new Date(to) : new Date();
    const endOfTheToDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999);
    return {
        gt: from ? startOfTheFromDate.toISOString().split('Z')[0] : undefined,
        lt: to ? endOfTheToDate.toISOString().split('Z')[0] : undefined
    };
};
const $af5d0da7acc49c77$export$8db446d8af54b4b5 = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    return {
        gt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime() - fromOffset * 86400000).toISOString().split('Z')[0],
        lt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999).getTime() - toOffset * 86400000).toISOString().split('Z')[0]
    };
};
const $af5d0da7acc49c77$export$50da93f10cdc6a84 = (lastUpdated)=>{
    let dateRangeValues;
    switch(lastUpdated){
        case 'today':
            dateRangeValues = $af5d0da7acc49c77$export$8db446d8af54b4b5(0, 0);
            break;
        case 'yesterday':
            dateRangeValues = $af5d0da7acc49c77$export$8db446d8af54b4b5(1, 1);
            break;
        case 'past7Days':
            dateRangeValues = $af5d0da7acc49c77$export$8db446d8af54b4b5(7, 0);
            break;
        case 'past30Days':
            dateRangeValues = $af5d0da7acc49c77$export$8db446d8af54b4b5(30, 0);
            break;
        case 'pastYear':
            dateRangeValues = $af5d0da7acc49c77$export$8db446d8af54b4b5(365, 0);
            break;
        default:
            dateRangeValues = {
                gt: '',
                lt: ''
            };
    }
    return dateRangeValues;
};
const $af5d0da7acc49c77$export$e048252fb7949a77 = (from, to)=>{
    const { gt: gt, lt: lt } = $af5d0da7acc49c77$export$79cd775d0d5c2a2(from, to);
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
const $af5d0da7acc49c77$export$405f2efecb6f5de6 = (selectedDateOption)=>{
    const dateRangeValues = $af5d0da7acc49c77$export$50da93f10cdc6a84(selectedDateOption);
    const { gt: gt, lt: lt } = dateRangeValues;
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
const $af5d0da7acc49c77$export$d82a82f2333502ad = {
    [(0, $3Q5mv.ProductKey).GoogleDrive]: $af5d0da7acc49c77$var$GOOGLE_INTEGRATION_ARI,
    [(0, $3Q5mv.ProductKey).Sharepoint]: $af5d0da7acc49c77$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $3Q5mv.ProductKey).AtlassianWebCrawler]: $af5d0da7acc49c77$var$WEB_CRAWLER_INTEGRATION_ARI,
    [(0, $3Q5mv.ProductKey).Teams]: $af5d0da7acc49c77$var$TEAMS_INTEGRATION_ARI,
    [(0, $3Q5mv.ProductKey).Figma]: $af5d0da7acc49c77$var$FIGMA_INTEGRATION_ARI,
    [(0, $3Q5mv.ProductKey).Loom]: $af5d0da7acc49c77$var$LOOM_INTEGRATION_ARI,
    [(0, $3Q5mv.ProductKey).OneDrive]: $af5d0da7acc49c77$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $3Q5mv.ProductKey).Github]: $af5d0da7acc49c77$var$GITHUB_INTEGRATION_ARI,
    [(0, $3Q5mv.ProductKey).Airtable]: $af5d0da7acc49c77$var$AIRTABLE_INTEGRATION_ARI,
    [(0, $3Q5mv.ProductKey).Notion]: $af5d0da7acc49c77$var$NOTION_INTEGRATION_ARI,
    [(0, $3Q5mv.ProductKey).Miro]: $af5d0da7acc49c77$var$MIRO_INTEGRATION_ARI
};
const $af5d0da7acc49c77$export$3766c9ce0c94452 = (products, titleMatchValue, entities, outboundAuthConfigs, baseIntegrationARIs, range)=>{
    if (!products.length || products.some((p)=>(0, $37AYo.products)[p]?.is3P || p === (0, $3Q5mv.ProductKey).Bitbucket)) {
        const typeMapping = (0, $jpB6G.getTypeMapping)();
        // Conditionally create the dynamic integration ARIs based on the config
        const getIntegrationARIsFromConfig = ()=>{
            const integrationMap = {};
            (0, $htTgH.ThirdPartyConfigs).forEach((config, productKey3P)=>{
                if (config.isEnabled()) integrationMap[productKey3P] = config.integrationAri;
            });
            return integrationMap;
        };
        const integrationARIsFromConfig = getIntegrationARIsFromConfig();
        // Combine static and dynamic integration ARIs
        // fg('rovo-full-page-search-3p-static-config') => false
        let productToIntegrationARIMap = baseIntegrationARIs;
        {
            productToIntegrationARIMap = {
                ...productToIntegrationARIMap,
                [(0, $3Q5mv.ProductKey).Dropbox]: $af5d0da7acc49c77$var$DROPBOX_INTEGRATION_ARI
            };
            const isAllSelectedAndSlackAllDisabled = products.length > 1 && true;
            if (!isAllSelectedAndSlackAllDisabled) productToIntegrationARIMap = {
                ...productToIntegrationARIMap,
                [(0, $3Q5mv.ProductKey).Slack]: $af5d0da7acc49c77$var$SLACK_INTEGRATION_ARI
            };
        }
        // get the subtypes by looking at each type's subcategories
        const subtypes = entities.flatMap((entity)=>typeMapping[entity]?.subCategories ?? []);
        if (Object.keys(productToIntegrationARIMap).length !== 0) {
            const integrationARIs = products.filter((product)=>!(0, $37AYo.products)[product]?.is3P || !outboundAuthConfigs[product]?.userNeedsOAuth).map((product)=>productToIntegrationARIMap[product]).filter((ari)=>!!ari)//remove duplicates (eg sharepoint, teams)
            .filter((ari, pos, arr)=>{
                return arr.indexOf(ari) === pos;
            });
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: subtypes,
                integrations: integrationARIs
            };
        } else return {
            range: range,
            titleMatchOnly: titleMatchValue,
            subtypes: subtypes
        };
    }
    return {
        titleMatchOnly: false,
        subtypes: [],
        integrations: []
    };
};
var $af5d0da7acc49c77$export$b367612b2293421c = /*#__PURE__*/ function(DateRangeError) {
    DateRangeError["FROM_AFTER_TO_ERROR"] = "fromAfterToError";
    DateRangeError["FROM_IN_FUTURE_ERROR"] = "fromInFutureError";
    DateRangeError["TO_IN_FUTURE_ERROR"] = "toInFutureError";
    return DateRangeError;
}({});
const $af5d0da7acc49c77$export$d3eb8baea7b2ff96 = (from, to)=>{
    if (!from && !to) return null;
    const dateFrom = new Date(`${from}${from ? 'T00:00:00' : ''}`);
    const dateTo = new Date(`${to}${to ? 'T00:00:00' : ''}`);
    if (dateFrom > dateTo) return "fromAfterToError";
    return null;
};
const $af5d0da7acc49c77$export$ef6dfb919b1d7267 = (filterId)=>{
    const productsForFilter = [];
    (0, $htTgH.ThirdPartyConfigs).forEach((_, productKey3P)=>{
        if ((0, $htTgH.ThirdPartyConfigs).get(productKey3P)?.filters?.includes(filterId)) productsForFilter.push(productKey3P);
    });
    return productsForFilter;
};
module.exports["getEmptySelectedFilters"] = $af5d0da7acc49c77$export$b7b676578c62639d;
module.exports["convertCustomDateToRange"] = $af5d0da7acc49c77$export$79cd775d0d5c2a2;
module.exports["convertLastUpdatedToDateRange"] = $af5d0da7acc49c77$export$50da93f10cdc6a84;
module.exports["getConfluenceDateOptionFromCustomDates"] = $af5d0da7acc49c77$export$e048252fb7949a77;
module.exports["getConfluenceDateOptionValues"] = $af5d0da7acc49c77$export$405f2efecb6f5de6;
module.exports["baseIntegrationARIs"] = $af5d0da7acc49c77$export$d82a82f2333502ad;
module.exports["getThirdPartyFilters"] = $af5d0da7acc49c77$export$3766c9ce0c94452;
module.exports["DateRangeError"] = $af5d0da7acc49c77$export$b367612b2293421c;
module.exports["getInvalidDateRange"] = $af5d0da7acc49c77$export$d3eb8baea7b2ff96;
module.exports["getProducts3PFromConfigForFilter"] = $af5d0da7acc49c77$export$ef6dfb919b1d7267;

});

parcelRegister("37AYo", function(module, exports) {
/* products.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $NlHoa = parcelRequire("NlHoa");

var $bltJZ = parcelRequire("bltJZ");


var $htTgH = parcelRequire("htTgH");


var $kEOJV = parcelRequire("kEOJV");


var $2JxTe = parcelRequire("2JxTe");


var $g022q = parcelRequire("g022q");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");




const $d86d21a43941b110$export$b0a52366c3fb9b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.555 30.1532C8.07887 30.1532 2 24.0743 2 16.5981C2 9.12199 8.07887 3.04312 15.555 3.04312V5.2012C9.26799 5.2012 4.15883 10.3104 4.15883 16.5974C4.15883 22.8844 9.26799 27.9936 15.555 27.9936V30.1517V30.1532Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.5547 30.1532V27.9951C21.8417 27.9951 26.9509 22.8859 26.9509 16.5989H29.109C29.109 24.075 23.0301 30.1539 15.554 30.1539L15.5547 30.1532Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M29.1099 16.5981H26.9519C26.9519 10.3111 21.8427 5.20194 15.5557 5.20194V3.04385C23.0318 3.04385 29.1107 9.12272 29.1107 16.5989L29.1099 16.5981Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.3291 20.7481C19.8899 20.4665 18.7539 19.9558 16.8662 19.1007C16.345 18.8715 15.7714 18.611 15.1147 18.3189C14.7186 18.1415 14.3539 17.985 13.9885 17.8292C11.1422 16.5674 9.57795 15.8793 7.65948 15.8793C6.31461 15.8793 5.30297 16.244 4.73986 16.9321C4.35422 17.3911 4.19772 17.985 4.31229 18.5585L2.19539 18.9652C1.96625 17.7558 2.27851 16.515 3.0715 15.5558C3.75966 14.7216 5.11502 13.7205 7.65948 13.7205C10.037 13.7205 11.9554 14.5756 14.8646 15.8583C15.2188 16.0148 15.5842 16.1818 15.9803 16.348C16.6475 16.6401 17.2316 16.9007 17.7527 17.1403C19.5566 17.9535 20.5473 18.402 21.7462 18.6312L21.3291 20.7481V20.7481Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M23.437 20.9562C22.7174 20.9562 22.0292 20.8933 21.3306 20.7481L21.7477 18.6312C22.3108 18.7457 22.8634 18.7982 23.437 18.7982C24.7714 18.7982 25.783 18.4642 26.3671 17.8284C26.9512 17.1927 26.9721 16.4207 26.9407 16.0141L29.0883 15.8261C29.2028 17.1395 28.8067 18.3706 27.9621 19.2879C27.2634 20.0487 25.9185 20.9562 23.437 20.9562Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.555 30.1531V27.9951C18.652 27.9951 20.4971 24.8358 20.4971 19.5492C20.4971 14.2626 18.6206 9.83109 14.7732 5.73358L16.3479 4.25317C20.5915 8.76777 22.656 13.7728 22.656 19.5492C22.656 26.0871 19.9348 30.1531 15.555 30.1531V30.1531Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.5535 30.1532C10.8929 30.1532 8.22339 26.3582 8.22339 19.7372C8.22339 12.0109 11.602 7.69399 14.7613 4.26367L16.3465 5.72311C12.6661 9.72702 10.3822 13.4599 10.3822 19.7364C10.3822 26.5656 13.1978 27.9943 15.5543 27.9943V30.1524L15.5535 30.1532Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M9.77765 17.7244C11.1712 17.7244 12.3012 16.5944 12.3012 15.2009C12.3012 13.8073 11.1712 12.6774 9.77765 12.6774C8.38411 12.6774 7.25415 13.8073 7.25415 15.2009C7.25415 16.5944 8.38411 17.7244 9.77765 17.7244Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.4429 22.0727C22.8365 22.0727 23.9664 20.9427 23.9664 19.5492C23.9664 18.1556 22.8365 17.0257 21.4429 17.0257C20.0494 17.0257 18.9194 18.1556 18.9194 19.5492C18.9194 20.9427 20.0494 22.0727 21.4429 22.0727V22.0727Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.5526 7.047C16.9461 7.047 18.0761 5.91704 18.0761 4.5235C18.0761 3.12996 16.9461 2 15.5526 2C14.159 2 13.0291 3.12996 13.0291 4.5235C13.0291 5.91704 14.159 7.047 15.5526 7.047V7.047Z",
            fill: "#1868DB"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.555 30.1532C8.07887 30.1532 2 24.0743 2 16.5981C2 9.12199 8.07887 3.04312 15.555 3.04312V5.2012C9.26799 5.2012 4.15883 10.3104 4.15883 16.5974C4.15883 22.8844 9.26799 27.9936 15.555 27.9936V30.1517V30.1532Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.5547 30.1532V27.9951C21.8417 27.9951 26.9509 22.8859 26.9509 16.5989H29.109C29.109 24.075 23.0301 30.1539 15.554 30.1539L15.5547 30.1532Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M29.1099 16.5981H26.9519C26.9519 10.3111 21.8427 5.20194 15.5557 5.20194V3.04385C23.0318 3.04385 29.1107 9.12272 29.1107 16.5989L29.1099 16.5981Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.3291 20.7481C19.8899 20.4665 18.7539 19.9558 16.8662 19.1007C16.345 18.8715 15.7714 18.611 15.1147 18.3189C14.7186 18.1415 14.3539 17.985 13.9885 17.8292C11.1422 16.5674 9.57795 15.8793 7.65948 15.8793C6.31461 15.8793 5.30297 16.244 4.73986 16.9321C4.35422 17.3911 4.19772 17.985 4.31229 18.5585L2.19539 18.9652C1.96625 17.7558 2.27851 16.515 3.0715 15.5558C3.75966 14.7216 5.11502 13.7205 7.65948 13.7205C10.037 13.7205 11.9554 14.5756 14.8646 15.8583C15.2188 16.0148 15.5842 16.1818 15.9803 16.348C16.6475 16.6401 17.2316 16.9007 17.7527 17.1403C19.5566 17.9535 20.5473 18.402 21.7462 18.6312L21.3291 20.7481V20.7481Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M23.437 20.9562C22.7174 20.9562 22.0292 20.8933 21.3306 20.7481L21.7477 18.6312C22.3108 18.7457 22.8634 18.7982 23.437 18.7982C24.7714 18.7982 25.783 18.4642 26.3671 17.8284C26.9512 17.1927 26.9721 16.4207 26.9407 16.0141L29.0883 15.8261C29.2028 17.1395 28.8067 18.3706 27.9621 19.2879C27.2634 20.0487 25.9185 20.9562 23.437 20.9562Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.555 30.1531V27.9951C18.652 27.9951 20.4971 24.8358 20.4971 19.5492C20.4971 14.2626 18.6206 9.83109 14.7732 5.73358L16.3479 4.25317C20.5915 8.76777 22.656 13.7728 22.656 19.5492C22.656 26.0871 19.9348 30.1531 15.555 30.1531V30.1531Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.5535 30.1532C10.8929 30.1532 8.22339 26.3582 8.22339 19.7372C8.22339 12.0109 11.602 7.69399 14.7613 4.26367L16.3465 5.72311C12.6661 9.72702 10.3822 13.4599 10.3822 19.7364C10.3822 26.5656 13.1978 27.9943 15.5543 27.9943V30.1524L15.5535 30.1532Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.77765 17.7244C11.1712 17.7244 12.3012 16.5944 12.3012 15.2009C12.3012 13.8073 11.1712 12.6774 9.77765 12.6774C8.38411 12.6774 7.25415 13.8073 7.25415 15.2009C7.25415 16.5944 8.38411 17.7244 9.77765 17.7244Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.4429 22.0727C22.8365 22.0727 23.9664 20.9427 23.9664 19.5492C23.9664 18.1556 22.8365 17.0257 21.4429 17.0257C20.0494 17.0257 18.9194 18.1556 18.9194 19.5492C18.9194 20.9427 20.0494 22.0727 21.4429 22.0727V22.0727Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.5526 7.047C16.9461 7.047 18.0761 5.91704 18.0761 4.5235C18.0761 3.12996 16.9461 2 15.5526 2C14.159 2 13.0291 3.12996 13.0291 4.5235C13.0291 5.91704 14.159 7.047 15.5526 7.047V7.047Z",
        fill: "#1868DB"
    }));











const $5c451e3a13391ed4$export$93ca83db1787dea = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_6321_165872)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M26.4672 20.5704C19.2874 16.9391 17.1899 16.3965 14.1647 16.3965C10.6151 16.3965 7.58992 17.9409 4.88739 22.2817L4.4437 22.9913C4.08067 23.5757 4 23.7843 4 24.0348C4 24.2852 4.12101 24.4939 4.56471 24.7861L9.12269 27.7496C9.36471 27.9165 9.56639 28 9.76807 28C10.0101 28 10.1714 27.8748 10.4134 27.4991L11.1395 26.3304C12.2689 24.5357 13.2773 23.9513 14.5681 23.9513C15.6975 23.9513 17.0286 24.2852 18.6824 25.12L23.442 27.4574C23.9261 27.7078 24.4504 27.5826 24.6924 26.9983L26.9513 21.8226C27.1933 21.2383 27.0319 20.8626 26.4672 20.5704ZM5.53277 11.4296C12.7126 15.0609 14.8101 15.6035 17.8353 15.6035C21.3849 15.6035 24.4101 14.0591 27.1126 9.71826L27.5563 9.0087C27.9193 8.42435 28 8.21565 28 7.96522C28 7.71478 27.879 7.50609 27.4353 7.21391L22.8773 4.25043C22.6353 4.08348 22.4336 4 22.2319 4C21.9899 4 21.8286 4.12522 21.5866 4.50087L20.8605 5.66957C19.7311 7.46435 18.7227 8.0487 17.4319 8.0487C16.3025 8.0487 14.9714 7.71478 13.3176 6.88L8.55798 4.54261C8.07395 4.29217 7.54958 4.41739 7.30756 5.00174L5.04874 10.1774C4.80672 10.7617 4.96807 11.1374 5.53277 11.4296Z",
            fill: "#357DE8"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_6321_165872"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(4 4)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_6321_165872)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M26.4672 20.5704C19.2874 16.9391 17.1899 16.3965 14.1647 16.3965C10.6151 16.3965 7.58992 17.9409 4.88739 22.2817L4.4437 22.9913C4.08067 23.5757 4 23.7843 4 24.0348C4 24.2852 4.12101 24.4939 4.56471 24.7861L9.12269 27.7496C9.36471 27.9165 9.56639 28 9.76807 28C10.0101 28 10.1714 27.8748 10.4134 27.4991L11.1395 26.3304C12.2689 24.5357 13.2773 23.9513 14.5681 23.9513C15.6975 23.9513 17.0286 24.2852 18.6824 25.12L23.442 27.4574C23.9261 27.7078 24.4504 27.5826 24.6924 26.9983L26.9513 21.8226C27.1933 21.2383 27.0319 20.8626 26.4672 20.5704ZM5.53277 11.4296C12.7126 15.0609 14.8101 15.6035 17.8353 15.6035C21.3849 15.6035 24.4101 14.0591 27.1126 9.71826L27.5563 9.0087C27.9193 8.42435 28 8.21565 28 7.96522C28 7.71478 27.879 7.50609 27.4353 7.21391L22.8773 4.25043C22.6353 4.08348 22.4336 4 22.2319 4C21.9899 4 21.8286 4.12522 21.5866 4.50087L20.8605 5.66957C19.7311 7.46435 18.7227 8.0487 17.4319 8.0487C16.3025 8.0487 14.9714 7.71478 13.3176 6.88L8.55798 4.54261C8.07395 4.29217 7.54958 4.41739 7.30756 5.00174L5.04874 10.1774C4.80672 10.7617 4.96807 11.1374 5.53277 11.4296Z",
        fill: "#357DE8"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_6321_165872"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(4 4)"
    }))));



var $lFtQw = parcelRequire("lFtQw");


var $7hnNi = parcelRequire("7hnNi");


var $bZjBf = parcelRequire("bZjBf");


var $32Uuv = parcelRequire("32Uuv");


var $98L7N = parcelRequire("98L7N");


var $6eZhJ = parcelRequire("6eZhJ");


var $jPcqU = parcelRequire("jPcqU");


var $34Ycr = parcelRequire("34Ycr");


var $7IRSQ = parcelRequire("7IRSQ");










const $172c125895e8315c$export$f68d29dbb4f2da82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16 14V16M16 18V16M16 16H18M16 16H14",
            stroke: "#E2483D",
            strokeWidth: "0.0333333",
            strokeDasharray: "0.13 0.13"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_6321_165880)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.7181 20.2933H9.56828C6.32599 20.2933 4 18.3226 4 15.4369H15.5595C16.1586 15.4369 16.5463 15.8592 16.5463 16.4575V28C13.6564 28 11.7181 25.6774 11.7181 22.4399V20.2933ZM17.4273 14.5572H15.2775C12.0352 14.5572 9.70925 12.6217 9.70925 9.73607H21.2687C21.8678 9.73607 22.2907 10.1232 22.2907 10.7214V22.2639C19.4009 22.2639 17.4273 19.9413 17.4273 16.7038V14.5572ZM23.1718 8.85631H21.022C17.7797 8.85631 15.4537 6.88563 15.4537 4H27.0132C27.6123 4 28 4.42229 28 4.98534V16.5279C25.1101 16.5279 23.1718 14.2053 23.1718 10.9677V8.85631Z",
            fill: "#357DE8"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_6321_165880"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(4 4)"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16 14V16M16 18V16M16 16H18M16 16H14",
        stroke: "#E2483D",
        strokeWidth: "0.0333333",
        strokeDasharray: "0.13 0.13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_6321_165880)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.7181 20.2933H9.56828C6.32599 20.2933 4 18.3226 4 15.4369H15.5595C16.1586 15.4369 16.5463 15.8592 16.5463 16.4575V28C13.6564 28 11.7181 25.6774 11.7181 22.4399V20.2933ZM17.4273 14.5572H15.2775C12.0352 14.5572 9.70925 12.6217 9.70925 9.73607H21.2687C21.8678 9.73607 22.2907 10.1232 22.2907 10.7214V22.2639C19.4009 22.2639 17.4273 19.9413 17.4273 16.7038V14.5572ZM23.1718 8.85631H21.022C17.7797 8.85631 15.4537 6.88563 15.4537 4H27.0132C27.6123 4 28 4.42229 28 4.98534V16.5279C25.1101 16.5279 23.1718 14.2053 23.1718 10.9677V8.85631Z",
        fill: "#357DE8"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_6321_165880"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(4 4)"
    }))));



var $1irrG = parcelRequire("1irrG");


var $7TNej = parcelRequire("7TNej");


var $aR8pO = parcelRequire("aR8pO");


var $6CAIO = parcelRequire("6CAIO");


var $2ocDV = parcelRequire("2ocDV");


var $5b9Mo = parcelRequire("5b9Mo");


var $4R0et = parcelRequire("4R0et");


var $8kImw = parcelRequire("8kImw");


var $12a6Y = parcelRequire("12a6Y");


var $eIKlJ = parcelRequire("eIKlJ");


var $77zKA = parcelRequire("77zKA");


var $7Wn3K = parcelRequire("7Wn3K");


var $ew2HG = parcelRequire("ew2HG");


var $4aQS7 = parcelRequire("4aQS7");


var $1tbRi = parcelRequire("1tbRi");


var $gc2TU = parcelRequire("gc2TU");


var $kUPAS = parcelRequire("kUPAS");

const $3c16d1704c5e11ab$var$iconStyles = null;
const $3c16d1704c5e11ab$var$iconSizeStyles = {
    small: "_3OOH8Rey7F _45mhctey7F",
    medium: "_3OOH8RoWWg _45mhctoWWg",
    large: "_3OOH8RUofl _45mhctUofl"
};
const $3c16d1704c5e11ab$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Opsgenie: 'opsgenie',
    Trello: 'trello'
};
const $3c16d1704c5e11ab$export$93aa518ca2694c2d = (0, $htTgH.DO_NOT_IMPORT_ProductKeys3P);
const $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c = {
    ...$3c16d1704c5e11ab$var$ProductKeys1P,
    ...(0, $htTgH.DO_NOT_IMPORT_ProductKeys3P)
};
const $3c16d1704c5e11ab$export$73be91b73ebbdb05 = Object.values($3c16d1704c5e11ab$export$ef2c0ffddaaaf76c);
const $3c16d1704c5e11ab$export$57043b2770b3924d = Object.values((0, $htTgH.DO_NOT_IMPORT_ProductKeys3P));
const $3c16d1704c5e11ab$export$225f36a2f261b1e7 = Object.values($3c16d1704c5e11ab$var$ProductKeys1P);
const $3c16d1704c5e11ab$export$ae4856d6227d0649 = (key)=>$3c16d1704c5e11ab$export$57043b2770b3924d.includes(key); // This is different to ProductKeys, it represents products we have support for mounting Search Page in
const $3c16d1704c5e11ab$export$15d12effc8830544 = {
    // Fully supported as GA
    Atlas: 'townsquare',
    Confluence: 'confluence',
    // In development
    Jira: 'jira',
    Mercury: 'mercury',
    Elevate: 'elevate'
};
const $3c16d1704c5e11ab$var$sizesCorrection = {
    xxsmall: 'small',
    small: 'medium',
    medium: 'large'
};
const $3c16d1704c5e11ab$export$16b26cd5e98d9100 = ({ label: label, icon: icon })=>{
    return ({ size: size = 'medium' })=>/*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
                $3c16d1704c5e11ab$var$iconSizeStyles[$3c16d1704c5e11ab$var$sizesCorrection[size]]
            ])
        }, icon({
            'aria-label': label
        }));
}; /**
    * This is the source of truth for the products that are supported in Full Page Search.
    * Note: there is additional logic in controllers/store/bootstrap/utils.ts for products being rolled out.
    *
    * QS-5444 3P references in this object are being deprecated. Please add to ./3p-product-configs
    */ 
const $3c16d1704c5e11ab$export$b6aad051bad07f12 = {
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Confluence]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).confluence),
        Icon: (0, $bltJZ.ConfluenceIcon),
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $5c451e3a13391ed4$export$93ca83db1787dea),
            label: (0, $kUPAS.messages).confluence.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Atlas]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).atlas),
        Icon: (0, $NlHoa.AtlassianIcon),
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $d86d21a43941b110$export$b0a52366c3fb9b),
            label: (0, $kUPAS.messages).atlas.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Jira]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).jira),
        Icon: (0, $bltJZ.JiraIcon),
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $172c125895e8315c$export$f68d29dbb4f2da82),
            label: (0, $kUPAS.messages).jira.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.JiraProductDiscovery]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).jiraProductDiscovery),
        Icon: (0, $bltJZ.JiraProductDiscoveryIcon)
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.JiraServiceManagement]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).jiraServiceManagement),
        Icon: (0, $bltJZ.JiraServiceManagementIcon)
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Bitbucket]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).bitbucket),
        Icon: (0, $bltJZ.BitbucketIcon),
        SearchResultIcon: (0, $bltJZ.BitbucketIcon)
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Trello]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).trello),
        Icon: (0, $bltJZ.TrelloIcon)
    },
    // [ProductKeys.Opsgenie]: {
    // 	displayName: 'Opsgenie',
    // 	Icon: OpsgenieIcon,
    // },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Compass]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).compass),
        Icon: (0, $bltJZ.CompassIcon)
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.GoogleDrive]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).googleDrive),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $34Ycr.GoogleDriveIcon),
            label: (0, $kUPAS.messages).googleDrive.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $7IRSQ.GoogleDriveSearchResultIcon),
            label: (0, $kUPAS.messages).googleDrive.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Sharepoint]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).microsoftSharepoint),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $8kImw.SharePointIcon),
            label: (0, $kUPAS.messages).sharepoint.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $12a6Y.SharePointSearchResultIcon),
            label: (0, $kUPAS.messages).sharepoint.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.AtlassianWebCrawler]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).webPage),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $4aQS7.WebDomainIcon),
            label: (0, $kUPAS.messages).atlassianWebCrawler.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $1tbRi.WebDomainSearchResultIcon),
            label: (0, $kUPAS.messages).atlassianWebCrawler.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Teams]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).teams),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $7Wn3K.TeamsIcon),
            label: (0, $kUPAS.messages).teams.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $ew2HG.TeamsSearchResultIcon),
            label: (0, $kUPAS.messages).teams.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Loom]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).loom),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $1irrG.LoomIcon),
            label: (0, $kUPAS.messages).loom.defaultMessage
        }),
        is3P: true
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.OneDrive]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).oneDrive),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $5b9Mo.OneDriveIcon),
            label: (0, $kUPAS.messages).oneDrive.defaultMessage
        }),
        is3P: true
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Slack]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).slack),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $eIKlJ.SlackIcon),
            label: (0, $kUPAS.messages).slack.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $77zKA.SlackSearchResultIcon),
            label: (0, $kUPAS.messages).slack.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Github]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).github),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $32Uuv.GithubIcon),
            label: (0, $kUPAS.messages).github.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $98L7N.GithubSearchResultIcon),
            label: (0, $kUPAS.messages).github.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Figma]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).figma),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $7hnNi.FigmaIcon),
            label: (0, $kUPAS.messages).figma.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $bZjBf.FigmaSearchResultIcon),
            label: (0, $kUPAS.messages).figma.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Dropbox]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).dropbox),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $lFtQw.DropboxIcon),
            label: (0, $kUPAS.messages).dropbox.defaultMessage
        }),
        is3P: true
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.GoogleCalendar]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).googleCalendar),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $jPcqU.GoogleCalendarIcon),
            label: (0, $kUPAS.messages).googleCalendar.defaultMessage
        }),
        is3P: true
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Gmail]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).gmail),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $6eZhJ.GmailIcon),
            label: (0, $kUPAS.messages).gmail.defaultMessage
        }),
        is3P: true
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.OutlookCalendar]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).outlookCalendar),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $4R0et.OutlookCalendarIcon),
            label: (0, $kUPAS.messages).outlookCalendar.defaultMessage
        }),
        is3P: true
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Airtable]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).airtable),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $2JxTe.AirtableFilterIcon),
            label: (0, $kUPAS.messages).airtable.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $kEOJV.AirtableIcon),
            label: (0, $kUPAS.messages).airtable.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Asana]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).asana),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $g022q.AsanaIcon),
            label: (0, $kUPAS.messages).asana.defaultMessage
        }),
        is3P: true
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Zendesk]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).zendesk),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $gc2TU.ZendeskIcon),
            label: (0, $kUPAS.messages).zendesk.defaultMessage
        }),
        is3P: true
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Notion]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).notion),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $2ocDV.NotionFilterIcon),
            label: (0, $kUPAS.messages).notion.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $6CAIO.NotionIcon),
            label: (0, $kUPAS.messages).notion.defaultMessage
        })
    },
    [$3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Miro]: {
        displayName: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $kUPAS.messages).miro),
        Icon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $aR8pO.MiroFilterIcon),
            label: (0, $kUPAS.messages).miro.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $3c16d1704c5e11ab$export$16b26cd5e98d9100({
            icon: (0, $7TNej.MiroIcon),
            label: (0, $kUPAS.messages).miro.defaultMessage
        })
    }
};
const $3c16d1704c5e11ab$export$64c23f2d9ef43822 = [
    $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Confluence,
    $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Jira,
    $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Atlas,
    $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Trello,
    $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Bitbucket,
    $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Opsgenie,
    $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c.Compass,
    ...(0, $htTgH.DO_NOT_IMPORT_ProductsOrder3P)
];
module.exports["ProductKeys3P"] = $3c16d1704c5e11ab$export$93aa518ca2694c2d;
module.exports["ProductKeys"] = $3c16d1704c5e11ab$export$ef2c0ffddaaaf76c;
module.exports["allProductKeys"] = $3c16d1704c5e11ab$export$73be91b73ebbdb05;
module.exports["all1pProductKeys"] = $3c16d1704c5e11ab$export$225f36a2f261b1e7;
module.exports["products"] = $3c16d1704c5e11ab$export$b6aad051bad07f12;

});

parcelRegister("3yqh5", function(module, exports) {
/**
 * @generated SignedSource<<80c3c990d7b34b85502d2e1fcd942281>>
 * @relayHash 92c054ec87105eceb11beb31723f69c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 89e658cd3b2db7689fb583d9d8727c51a184fe45869f170c937504395bf5f105
const $3016448950218a49$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKeys"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKeys",
                    "variableName": "spaceKeys"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useGetSpaceIdFromSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useGetSpaceIdFromSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "89e658cd3b2db7689fb583d9d8727c51a184fe45869f170c937504395bf5f105",
            "metadata": {},
            "name": "useGetSpaceIdFromSpaceKeyQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3016448950218a49$var$node.hash = "b0222c2296e4b6c56b7da0af2f53839f";
var $3016448950218a49$export$2e2bcd8739ae039 = $3016448950218a49$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $d5gEx = parcelRequire("d5gEx");


var $cfM7x = parcelRequire("cfM7x");

const $0b5926ceca3c2388$export$50f68914d42bd134 = ()=>{
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const environment = (0, $d5gEx.useRelayEnvironmentProvider)().getEnvironment({});
    return (0, $cozmU.useCallback)(async (spaceKeys)=>{
        if (spaceKeys.length === 0) return [];
        try {
            const data = await (0, $6SsN4.fetchQuery)(environment, (0, $3016448950218a49$export$2e2bcd8739ae039), {
                spaceKeys: spaceKeys
            }).toPromise();
            const spaceIds = (data?.spaces?.nodes ?? []).map((node)=>node?.id ?? '').filter((id)=>!!id);
            return spaceIds;
        } catch (error) {
            submitError?.(error);
        }
        return [];
    }, [
        submitError,
        environment
    ]);
};
module.exports["useGetSpaceIdsFromSpaceKeys"] = $0b5926ceca3c2388$export$50f68914d42bd134;

});

parcelRegister("ik71g", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");











var $55fM8 = parcelRequire("55fM8");

const $e0f6b39825d0c965$var$WidthObserverContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e0f6b39825d0c965$export$75f7910544138d14 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [elements, setElements] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {};
        $[1] = t2;
    } else t2 = $[1];
    const [callbacks, setCallbacks] = (0, $cozmU.useState)(t2);
    let t3;
    let t4;
    if ($[2] !== callbacks || $[3] !== elements) {
        t3 = ()=>{
            const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
                entries.forEach((entry)=>{
                    const id = entry.target.getAttribute("data-width-observer-id");
                    if (id && callbacks[id]) {
                        const width = entry.contentRect.width;
                        callbacks[id].forEach((callback)=>callback(width));
                    }
                });
            }, 100, {
                leading: true,
                trailing: true
            });
            const observer = new ResizeObserver(handleResize);
            Object.values(elements).forEach((element)=>observer.observe(element));
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            elements,
            callbacks
        ];
        $[2] = callbacks;
        $[3] = elements;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (id_0, element_0)=>{
            setElements((prev)=>({
                    ...prev,
                    [id_0]: element_0
                }));
        };
        $[6] = t5;
    } else t5 = $[6];
    const registerElement = t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (id_1)=>{
            setElements((prev_0)=>{
                const newElements = {
                    ...prev_0
                };
                delete newElements[id_1];
                return newElements;
            });
        };
        $[7] = t6;
    } else t6 = $[7];
    const unregisterElement = t6;
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (id_2, callback_0)=>{
            setCallbacks((prev_1)=>({
                    ...prev_1,
                    [id_2]: [
                        ...prev_1[id_2] || [],
                        callback_0
                    ]
                }));
            return ()=>{
                setCallbacks((prev_2)=>({
                        ...prev_2,
                        [id_2]: (prev_2[id_2] || []).filter((cb)=>cb !== callback_0)
                    }));
            };
        };
        $[8] = t7;
    } else t7 = $[8];
    const subscribe = t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            registerElement: registerElement,
            unregisterElement: unregisterElement,
            subscribe: subscribe
        };
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== children) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f6b39825d0c965$var$WidthObserverContext.Provider, {
            value: t8
        }, children);
        $[10] = children;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
} : ({ children: children })=>{
    const [elements, setElements] = (0, $cozmU.useState)({});
    const [callbacks, setCallbacks] = (0, $cozmU.useState)({});
    (0, $cozmU.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
            entries.forEach((entry)=>{
                const id = entry.target.getAttribute('data-width-observer-id');
                if (id && callbacks[id]) {
                    const width = entry.contentRect.width;
                    callbacks[id].forEach((callback)=>callback(width));
                }
            });
        }, 100, {
            leading: true,
            trailing: true
        });
        const observer = new ResizeObserver(handleResize);
        Object.values(elements).forEach((element)=>observer.observe(element));
        return ()=>{
            observer.disconnect();
        };
    }, [
        elements,
        callbacks
    ]);
    const registerElement = (0, $cozmU.useCallback)((id_0, element_0)=>{
        setElements((prev)=>({
                ...prev,
                [id_0]: element_0
            }));
    }, [
        setElements
    ]);
    const unregisterElement = (0, $cozmU.useCallback)((id_1)=>{
        setElements((prev_0)=>{
            const newElements = {
                ...prev_0
            };
            delete newElements[id_1];
            return newElements;
        });
    }, [
        setElements
    ]);
    const subscribe = (0, $cozmU.useCallback)((id_2, callback_0)=>{
        setCallbacks((prev_1)=>({
                ...prev_1,
                [id_2]: [
                    ...prev_1[id_2] || [],
                    callback_0
                ]
            }));
        return ()=>{
            setCallbacks((prev_2)=>({
                    ...prev_2,
                    [id_2]: (prev_2[id_2] || []).filter((cb)=>cb !== callback_0)
                }));
        };
    }, [
        setCallbacks
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f6b39825d0c965$var$WidthObserverContext.Provider, {
        value: {
            registerElement: registerElement,
            unregisterElement: unregisterElement,
            subscribe: subscribe
        }
    }, children);
};
const $e0f6b39825d0c965$export$b78842cb7cd02769 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($e0f6b39825d0c965$var$WidthObserverContext);
    if (!context) throw new Error("useWidthObserver must be used within a WidthObserverProvider");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($e0f6b39825d0c965$var$WidthObserverContext);
    if (!context) throw new Error('useWidthObserver must be used within a WidthObserverProvider');
    return context;
};
const $e0f6b39825d0c965$export$f8586f54f6b8f867 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { id: id, children: children } = t0;
    const { registerElement: registerElement, unregisterElement: unregisterElement } = $e0f6b39825d0c965$export$b78842cb7cd02769();
    const elementRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== id || $[1] !== registerElement || $[2] !== unregisterElement) {
        t1 = ()=>{
            const element = elementRef.current;
            if (element) {
                element.setAttribute("data-width-observer-id", id);
                registerElement(id, element);
            }
            return ()=>{
                unregisterElement(id);
            };
        };
        t2 = [
            id,
            registerElement,
            unregisterElement
        ];
        $[0] = id;
        $[1] = registerElement;
        $[2] = unregisterElement;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[5] !== children) {
        let t4;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                ref: elementRef
            };
            $[7] = t4;
        } else t4 = $[7];
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(children, t4);
        $[5] = children;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ id: id, children: children })=>{
    const { registerElement: registerElement, unregisterElement: unregisterElement } = $e0f6b39825d0c965$export$b78842cb7cd02769();
    const elementRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            element.setAttribute('data-width-observer-id', id);
            registerElement(id, element);
        }
        return ()=>{
            unregisterElement(id);
        };
    }, [
        id,
        registerElement,
        unregisterElement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(children, {
        ref: elementRef
    }));
};
const $e0f6b39825d0c965$export$1217913212f99c7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (id)=>{
    const $ = (0, $bDgLe.c)(4);
    const { subscribe: subscribe } = $e0f6b39825d0c965$export$b78842cb7cd02769();
    const [width, setWidth] = (0, $cozmU.useState)(0);
    let t0;
    let t1;
    if ($[0] !== id || $[1] !== subscribe) {
        t0 = ()=>{
            const unsubscribe = subscribe(id, setWidth);
            return ()=>{
                unsubscribe();
            };
        };
        t1 = [
            id,
            subscribe
        ];
        $[0] = id;
        $[1] = subscribe;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return width;
} : (id)=>{
    const { subscribe: subscribe } = $e0f6b39825d0c965$export$b78842cb7cd02769();
    const [width, setWidth] = (0, $cozmU.useState)(0);
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = subscribe(id, setWidth);
        return ()=>{
            unsubscribe();
        };
    }, [
        id,
        subscribe
    ]);
    return width;
};
const $e0f6b39825d0c965$export$f29cb180c1a7eb72 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { target: id, children: children } = t0;
    const width = $e0f6b39825d0c965$export$1217913212f99c7(id);
    if (width === 0) return null;
    let t1;
    if ($[0] !== children || $[1] !== width) {
        t1 = children(width);
        $[0] = children;
        $[1] = width;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ target: id, children: children })=>{
    const width = $e0f6b39825d0c965$export$1217913212f99c7(id);
    if (width === 0) return null;
    return children(width);
};
const $e0f6b39825d0c965$var$breakpoints = {
    xxs: 0,
    xs: 480,
    sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1768
};
const $e0f6b39825d0c965$export$c44b7f69e7aa026 = ({ width: width, above: above, below: below })=>{
    return above && width > $e0f6b39825d0c965$var$breakpoints[above] || below && width < $e0f6b39825d0c965$var$breakpoints[below] || false;
};
const $e0f6b39825d0c965$export$f6a3d19be20f5819 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { target: target, above: above, below: below, children: children } = t0;
    let t1;
    if ($[0] !== above || $[1] !== below || $[2] !== children) {
        t1 = (width)=>{
            if ($e0f6b39825d0c965$export$c44b7f69e7aa026({
                width: width,
                above: above,
                below: below
            })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
        };
        $[0] = above;
        $[1] = below;
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t1 || $[5] !== target) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f6b39825d0c965$export$f29cb180c1a7eb72, {
            target: target
        }, t1);
        $[4] = t1;
        $[5] = target;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f6b39825d0c965$export$f29cb180c1a7eb72, {
        target: target
    }, (width)=>{
        if ($e0f6b39825d0c965$export$c44b7f69e7aa026({
            width: width,
            above: above,
            below: below
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    });
};
const $e0f6b39825d0c965$export$bed28288a051538 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { target: target, above: above, below: below, children: children } = t0;
    let t1;
    if ($[0] !== above || $[1] !== below || $[2] !== children) {
        t1 = (width)=>{
            if ($e0f6b39825d0c965$export$c44b7f69e7aa026({
                width: width,
                above: above,
                below: below
            })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        };
        $[0] = above;
        $[1] = below;
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t1 || $[5] !== target) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f6b39825d0c965$export$f29cb180c1a7eb72, {
            target: target
        }, t1);
        $[4] = t1;
        $[5] = target;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f6b39825d0c965$export$f29cb180c1a7eb72, {
        target: target
    }, (width)=>{
        if ($e0f6b39825d0c965$export$c44b7f69e7aa026({
            width: width,
            above: above,
            below: below
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    });
};












var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");










// https://atlassian-2y.sentry.io/projects/search-page/getting-started
const $68a7b8b82f99049a$export$6faa4a850bc4d0ce = 'https://dcf49f8a57e71c9e77d30808a7708f8c@o55978.ingest.us.sentry.io/4506951588773888';
const $68a7b8b82f99049a$export$ea77880e3935182d = 'unknown';
const $68a7b8b82f99049a$export$d60e93659f587f71 = {
    companyHub: true // Used to filter out errors that are not from company hub projects
};

/* eslint-disable @repo/internal/react/no-class-components */ 


class $1c87bcc298048c5f$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onException(error);
    }
    render() {
        if (this.state.error) return this.props.fallback !== undefined ? this.props.fallback : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            error: undefined
        };
    }
}

// @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 */ const $c39ff4750ab3b266$export$668f31ea3127f48f = window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION;



let $db7a314196e66e2e$var$Sentry;
const $db7a314196e66e2e$var$getEnvironment = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
const $db7a314196e66e2e$var$beforeSend = (event)=>{
    if (event.environment === 'development') return null;
    // Ignore errors that do not come from company hub projects
    if (!event.tags?.companyHub) return null;
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    return event;
};

const $db7a314196e66e2e$export$f553e8b08ef59d31 = async ()=>{
    if (!$db7a314196e66e2e$var$Sentry) $db7a314196e66e2e$var$Sentry = Promise.resolve((parcelRequire("eieXD"))).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $68a7b8b82f99049a$export$6faa4a850bc4d0ce),
            attachStacktrace: true,
            release: (0, $c39ff4750ab3b266$export$668f31ea3127f48f) || (0, $68a7b8b82f99049a$export$ea77880e3935182d),
            environment: $db7a314196e66e2e$var$getEnvironment(),
            beforeSend: $db7a314196e66e2e$var$beforeSend
        });
        return SentryModule;
    }).catch(()=>{
    // TODO: Retry mechanism for chunk loading failures?
    });
    return $db7a314196e66e2e$var$Sentry;
};



var $1UWNP = parcelRequire("1UWNP");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");


var $iTSOb = parcelRequire("iTSOb");

var $aaa3fcc9c0025f59$export$a82073022ded66e8 = /*#__PURE__*/ function(UserStatus) {
    UserStatus["Unauthenticated"] = "unauthenticated";
    UserStatus["Anonymous"] = "anonymous";
    UserStatus["Authenticated"] = "authenticated";
    return UserStatus;
}({});



var $bU7gQ = parcelRequire("bU7gQ");

const $122441d1a555945e$var$HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $122441d1a555945e$export$d4c72bab9d6cc13a = {
    products: [],
    allFilterExcludedProducts: [],
    outboundAuthConfigs: {},
    searchSessionId: 'searchSessionId',
    queryParams: {},
    prevQueryParams: {},
    initialSpaceARIs: [],
    experimentConfig: {
        backendExperiment: undefined,
        frontendExperiments: undefined
    },
    isNounsAvailable: false,
    features: {
        // These feature defaults are included to be backwards-compatible with initial search implementation forked from search pkg
        quickSearch: {
            enabled: false
        },
        inlineSearch: {
            enabled: true
        },
        autoSuggestion: {
            enabled: true
        },
        recentSearches: {
            enabled: true
        },
        recentViews: {
            enabled: true
        },
        peopleAndTeamsSearch: {
            enabled: true
        },
        fetchInitialResults: {
            enabled: true
        },
        engagement: {
            enabled: true
        }
    }
};
const $122441d1a555945e$export$e324594224ef24da = {
    setState: (partialState)=>({ setState: setState })=>{
            setState(partialState);
        },
    loadUserPicture: ()=>({ setState: setState, getState: getState })=>{
            const userState = getState().user;
            const userId = userState?.id;
            if (!userState || !userId || !!userState.picture) return;
            (0, $iTSOb.userQuery)(userId).then((x)=>{
                setState({
                    user: {
                        id: userState.id,
                        name: userState.name,
                        email: userState.email,
                        picture: x.data?.user.picture ?? null
                    }
                });
            }).catch((_)=>{
            // TODO: >>>> Send warning to sentry
            });
        },
    setQueryParams: (queryParam)=>({}, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            const areEqualQueryParams = (0, $bU7gQ.areAllEqualQueryParams)(queryParam, (0, $bU7gQ.parseQueryParams)(queryParams ?? {}));
            if (areEqualQueryParams) return;
            queryParamsCallback((0, $bU7gQ.toQueryParamsRaw)(queryParam));
        },
    syncQueryParams: ()=>({ setState: setState, getState: getState }, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            // queryParams is the query params coming from the URL or React Router in this case
            const { prevQueryParams: prevQueryParams, // Previously saved query params - this is to prevent infinitely updating queryParams
            queryParams: diffQueryParamsState // The 'internal' query params state
             } = getState();
            const queryParamsURL = (0, $bU7gQ.parseQueryParams)(queryParams ?? {});
            const prevQueryParamsString = (0, $bU7gQ.toQueryString)(prevQueryParams);
            const diffQueryParamsURLString = (0, $bU7gQ.toQueryString)(queryParamsURL);
            const diffQueryParamsStateString = (0, $bU7gQ.toQueryString)(diffQueryParamsState);
            const allQueryParamsAreEqual = (0, $bU7gQ.areAllEqualQueryParams)(queryParamsURL, prevQueryParams, diffQueryParamsState);
            if (allQueryParamsAreEqual) return;
            // Any changes from the url takes the highest precedence
            const hasURLQueryParams = !!queryParams;
            if (hasURLQueryParams && prevQueryParamsString !== diffQueryParamsURLString) {
                setState({
                    prevQueryParams: queryParamsURL,
                    queryParams: queryParamsURL
                });
                return;
            }
            if (prevQueryParamsString !== diffQueryParamsStateString) {
                //  NOTE: If you are running the callback and you don't see the query params being updated,
                //  the callback might be sanitising the query parameters. This is the case for Confluence.
                queryParamsCallback((0, $bU7gQ.toQueryParamsRaw)(diffQueryParamsState));
                setState({
                    prevQueryParams: diffQueryParamsState,
                    queryParams: diffQueryParamsState
                });
                return;
            }
        },
    initializeSpaceARIsFromSpaceKeys: (spaceKeys)=>async ({ setState: setState, getState: getState }, { getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys })=>{
            const { cloudId: cloudId } = getState();
            if (spaceKeys.length === 0 || !getSpaceIdsFromSpaceKeys) return;
            const spaceIds = await getSpaceIdsFromSpaceKeys(spaceKeys);
            const spaceARIs = spaceIds.map((id)=>`ari:cloud:confluence:${cloudId}:space/${id}`);
            setState({
                initialSpaceARIs: spaceARIs
            });
        },
    clearSpaceARIs: ()=>({ setState: setState })=>{
            setState({
                initialSpaceARIs: []
            });
        }
};
// Keep store private and use hooks to access state and actions
const $122441d1a555945e$var$Store = (0, $8s9DV.createStore)({
    initialState: $122441d1a555945e$export$d4c72bab9d6cc13a,
    actions: $122441d1a555945e$export$e324594224ef24da,
    name: 'dynamic-cards-bootstrap'
});
const $122441d1a555945e$var$buildProducts = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));
const $122441d1a555945e$export$7d8c755e49b2156f = (initialState, initialProps)=>{
    const defaultFeatures = initialState.features || {};
    const overrideFeatures = initialProps.features || {};
    // TODO: Fix any
    const mergedFeatures = {
        ...defaultFeatures
    };
    for(const key in overrideFeatures){
        const typedKey = key;
        if (overrideFeatures[typedKey] !== undefined) mergedFeatures[typedKey] = {
            ...defaultFeatures[typedKey],
            ...overrideFeatures[typedKey]
        };
    }
    return mergedFeatures;
};
const $122441d1a555945e$export$557bf45c8d0f5bd = (0, $j8on0.createContainer)($122441d1a555945e$var$Store, {
    onInit: ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { initialProps: initialProps, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $bU7gQ.parseQueryParams)(queryParams);
            const initialState = getState();
            const initState = {
                ...initialState,
                ...initialProps,
                ...queryParams && {
                    queryParams: parsedQueryParams
                },
                referrer: parsedQueryParams?.referrer,
                features: $122441d1a555945e$export$7d8c755e49b2156f(initialState, initialProps)
            };
            setState(initState);
            dispatch($122441d1a555945e$export$e324594224ef24da.loadUserPicture());
        },
    onUpdate: ()=>({ setState: setState, getState: getState, dispatch: dispatch }, { initialProps: initialProps, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $bU7gQ.parseQueryParams)(queryParams);
            const initialState = getState();
            const products = $122441d1a555945e$var$buildProducts(initialState.products, initialProps?.products ?? []);
            setState({
                ...initialState,
                ...initialProps,
                products: products,
                referrer: parsedQueryParams?.referrer,
                features: $122441d1a555945e$export$7d8c755e49b2156f(initialState, initialProps)
            });
            if (parsedQueryParams?.spaces) dispatch($122441d1a555945e$export$e324594224ef24da.initializeSpaceARIsFromSpaceKeys(parsedQueryParams.spaces));
            else dispatch($122441d1a555945e$export$e324594224ef24da.clearSpaceARIs());
            dispatch($122441d1a555945e$export$e324594224ef24da.syncQueryParams());
        }
});
const $122441d1a555945e$export$cf715ed8590c209b = (0, $kBr4q.createActionsHook)($122441d1a555945e$var$Store);
const $122441d1a555945e$export$9ba1f1f28043c5bf = (0, $kBr4q.createHook)($122441d1a555945e$var$Store);
const $122441d1a555945e$export$1fd8522aeddaccda = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.analyticsAttributes
});
const $122441d1a555945e$export$5afbfe6edea8e998 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.products
});
const $122441d1a555945e$export$f7c6299b3492081c = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.products.length === 0
});
const $122441d1a555945e$export$92c6f3c7c09f3247 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.primaryProduct
});
const $122441d1a555945e$export$e1e7a4797df1a656 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.searchSessionId
});
const $122441d1a555945e$export$1a0be923fb1117e4 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.cloudId === $122441d1a555945e$var$HELLO_TENANT_ID
});
const $122441d1a555945e$export$4a39035bacc4ed76 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.features
});
const $122441d1a555945e$export$7c355de7fd01eb66 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.components
});
const $122441d1a555945e$export$4f9dad8ddb27a630 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.styleOverrides
});
const $122441d1a555945e$export$b9e6179ff71a6122 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.experimentConfig
});
const $122441d1a555945e$export$9e89c81d9ff2c758 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.experimentConfig.backendExperiment
});
const $122441d1a555945e$export$d2c28b106f1bf70b = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.experimentConfig.frontendExperiments
});
const $122441d1a555945e$export$8ab143228c6f49a2 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.intercomHmac
});
const $122441d1a555945e$export$efd66ec4f7062878 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.isNounsAvailable
});
const $122441d1a555945e$export$23bbbc4533528f03 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>{
        const user = state.user;
        if (!user || !user.id) return {
            status: (0, $aaa3fcc9c0025f59$export$a82073022ded66e8).Unauthenticated,
            id: null,
            name: null,
            email: null
        };
        if (user.id === 'unidentified') return {
            status: (0, $aaa3fcc9c0025f59$export$a82073022ded66e8).Anonymous,
            ...user
        };
        return {
            status: (0, $aaa3fcc9c0025f59$export$a82073022ded66e8).Authenticated,
            ...user
        };
    }
});
const $122441d1a555945e$export$e99d08753f6dce85 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.referrer
});
const $122441d1a555945e$export$52a03a3207af3687 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.orgId
});
const $122441d1a555945e$export$9da0f7c65f28ed16 = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.cloudId
    ], (cloudId)=>cloudId)
});
const $122441d1a555945e$export$b37ee0d76c6d2fbc = (0, $kBr4q.createHook)($122441d1a555945e$var$Store, {
    selector: (state)=>state.queryParams
});


const $298b6709c80d740f$export$67ff3bc9583d7c16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [t0] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { user: user, primaryProduct: primaryProduct } = t0;
    let t1;
    if ($[0] !== primaryProduct || $[1] !== user?.id) {
        t1 = async (error)=>{
            try {
                const SentryClient = await (0, $db7a314196e66e2e$export$f553e8b08ef59d31)();
                if (!SentryClient) return;
                SentryClient.withScope((scope)=>{
                    for (const [key, value] of Object.entries((0, $68a7b8b82f99049a$export$d60e93659f587f71)))scope.setTag(key, value);
                    scope.setUser({
                        id: user?.id || (0, $68a7b8b82f99049a$export$ea77880e3935182d)
                    });
                    scope.setTag("product", primaryProduct || (0, $68a7b8b82f99049a$export$ea77880e3935182d));
                    SentryClient.captureException(error, scope);
                });
            } catch (t2) {
                const error_0 = t2;
                console.error(error_0);
            }
        };
        $[0] = primaryProduct;
        $[1] = user?.id;
        $[2] = t1;
    } else t1 = $[2];
    user?.id;
    return t1;
} : ()=>{
    const [{ user: user, primaryProduct: primaryProduct }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    return (0, $cozmU.useCallback)(async (error)=>{
        try {
            const SentryClient = await (0, $db7a314196e66e2e$export$f553e8b08ef59d31)();
            if (!SentryClient) return;
            SentryClient.withScope((scope)=>{
                for (const [key, value] of Object.entries((0, $68a7b8b82f99049a$export$d60e93659f587f71)))scope.setTag(key, value);
                scope.setUser({
                    id: user?.id || (0, $68a7b8b82f99049a$export$ea77880e3935182d)
                });
                scope.setTag('product', primaryProduct || (0, $68a7b8b82f99049a$export$ea77880e3935182d));
                SentryClient.captureException(error, scope);
            });
        } catch (error_0) {
            // When there was an error with Sentry, just output to console
            // eslint-disable-next-line no-console
            console.error(error_0);
        }
    }, [
        primaryProduct,
        user?.id
    ]);
};
const $298b6709c80d740f$export$e926676385687eaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const onException = $298b6709c80d740f$export$67ff3bc9583d7c16();
    let t0;
    if ($[0] !== onException || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c87bcc298048c5f$export$e926676385687eaf), {
            ...props,
            onException: onException
        }, props.children);
        $[0] = onException;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const onException = $298b6709c80d740f$export$67ff3bc9583d7c16();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c87bcc298048c5f$export$e926676385687eaf), {
        ...props,
        onException: onException
    }, props.children);
};













var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $ebe274384907606f$var$containerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $ebe274384907606f$var$filterStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small',
    height: 'size.300',
    width: 'size.600'
});
const $ebe274384907606f$export$d5722e1c0b3e12f1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $ebe274384907606f$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $ebe274384907606f$var$filterStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $ebe274384907606f$var$filterStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $ebe274384907606f$var$filterStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $ebe274384907606f$var$filterStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $ebe274384907606f$var$filterStyles
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $ebe274384907606f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $ebe274384907606f$var$filterStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $ebe274384907606f$var$filterStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $ebe274384907606f$var$filterStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $ebe274384907606f$var$filterStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $ebe274384907606f$var$filterStyles
    }));
};














var $kz1Yj = parcelRequire("kz1Yj");

var $2wCqQ = parcelRequire("2wCqQ");




var $lCzjG = parcelRequire("lCzjG");


var $37AYo = parcelRequire("37AYo");


var $2Va9o = parcelRequire("2Va9o");





var $ko90a = parcelRequire("ko90a");


var $hYdYN = parcelRequire("hYdYN");


var $bPX0r = parcelRequire("bPX0r");


var $h4cPw = parcelRequire("h4cPw");


var $bkXhB = parcelRequire("bkXhB");


var $7ayyq = parcelRequire("7ayyq");


var $10JkG = parcelRequire("10JkG");


var $lBu63 = parcelRequire("lBu63");


var $cqf3V = parcelRequire("cqf3V");


var $5EzaL = parcelRequire("5EzaL");











var $kSwu1 = parcelRequire("kSwu1");











var $jLnA6 = parcelRequire("jLnA6");


var $aj8Vc = parcelRequire("aj8Vc");

var $3GNtk = parcelRequire("3GNtk");











var $7sJoX = parcelRequire("7sJoX");






var $kh0hi = parcelRequire("kh0hi");







var $824lD = parcelRequire("824lD");


var $1LOGx = parcelRequire("1LOGx");


var $2hJf7 = parcelRequire("2hJf7");


var $3fO5l = parcelRequire("3fO5l");


var $hMaHH = parcelRequire("hMaHH");


var $g9ioO = parcelRequire("g9ioO");


var $iFXu4 = parcelRequire("iFXu4");


var $4R9Nm = parcelRequire("4R9Nm");


var $d2UzA = parcelRequire("d2UzA");


var $EzOZy = parcelRequire("EzOZy");

const $ad603b57dbb5d1f1$export$16b26cd5e98d9100 = ({ filterOrControlId: filterOrControlId, isSelected: isSelected, label: label = '' })=>{
    switch(filterOrControlId){
        case 'owner':
        case 'assignee':
        case 'contributor':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'verified':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'label':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($EzOZy))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'content':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'lastUpdated':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'space':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'onlyTitleMatch':
            return null;
        // Title match doesn't show an icon, only a checkbox
        case 'universalTypeFilter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'dropdown':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1LOGx))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'sort':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4R9Nm))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
    }
};


const $9ff944adaafb586c$var$baseStyles = (0, $buxP3.xcss)({
    height: '32px',
    paddingInline: 'space.150',
    width: '100%',
    borderRadius: 'radius.small',
    color: 'color.text',
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $9ff944adaafb586c$var$selectedStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.accent.blue',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $9ff944adaafb586c$var$buttonIconStyles = (0, $buxP3.xcss)({
    display: 'flex'
});
const $9ff944adaafb586c$var$ButtonIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { filterOrControlId: filterOrControlId, isSelected: isSelected } = t0;
    let t1;
    if ($[0] !== filterOrControlId || $[1] !== isSelected) {
        t1 = (0, $ad603b57dbb5d1f1$export$16b26cd5e98d9100)({
            filterOrControlId: filterOrControlId,
            isSelected: isSelected
        });
        $[0] = filterOrControlId;
        $[1] = isSelected;
        $[2] = t1;
    } else t1 = $[2];
    const buttonIcon = t1;
    let t2;
    if ($[3] !== buttonIcon) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $9ff944adaafb586c$var$buttonIconStyles
        }, buttonIcon);
        $[3] = buttonIcon;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ filterOrControlId: filterOrControlId, isSelected: isSelected })=>{
    const buttonIcon = (0, $ad603b57dbb5d1f1$export$16b26cd5e98d9100)({
        filterOrControlId: filterOrControlId,
        isSelected: isSelected
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $9ff944adaafb586c$var$buttonIconStyles
    }, buttonIcon);
};
const $9ff944adaafb586c$var$buttonWrapperStyles = (0, $buxP3.xcss)({
    maxWidth: '280px' // matches dropdown of 312px (and padding)
});
const $9ff944adaafb586c$var$textStyles = (0, $buxP3.xcss)({
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: 'font.body',
    fontWeight: 'font.weight.medium'
});
const $9ff944adaafb586c$export$fb46dd9777cc6db0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { otherProps: otherProps, isSelected: isSelected, filterOrControlId: filterOrControlId, label: label, selectionBadge: selectionBadge, onClick: onClick, onKeyDown: onKeyDown, wide: wide, testId: testId } = t0;
    const t1 = !wide && $9ff944adaafb586c$var$buttonWrapperStyles;
    const t2 = isSelected && $9ff944adaafb586c$var$selectedStyles;
    let t3;
    if ($[0] !== t2) {
        t3 = [
            $9ff944adaafb586c$var$baseStyles,
            t2
        ];
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== filterOrControlId || $[3] !== isSelected) {
        t4 = filterOrControlId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ff944adaafb586c$var$ButtonIcon, {
            filterOrControlId: filterOrControlId,
            isSelected: isSelected
        });
        $[2] = filterOrControlId;
        $[3] = isSelected;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== label) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $9ff944adaafb586c$var$textStyles
        }, label);
        $[5] = label;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== selectionBadge || $[8] !== t4 || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            alignBlock: "center",
            alignInline: "start",
            xcss: $9ff944adaafb586c$var$textStyles,
            space: "space.100"
        }, t4, t5, selectionBadge);
        $[7] = selectionBadge;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== filterOrControlId || $[12] !== isSelected) {
        t7 = filterOrControlId !== "dropdown" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)",
            size: "small"
        });
        $[11] = filterOrControlId;
        $[12] = isSelected;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t6 || $[15] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            alignInline: "start",
            space: "space.100",
            spread: "space-between",
            alignBlock: "center"
        }, t6, t7);
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== onClick || $[18] !== onKeyDown || $[19] !== otherProps || $[20] !== t3 || $[21] !== t8 || $[22] !== testId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            onClick: onClick,
            onKeyDown: onKeyDown,
            ...otherProps,
            testId: testId,
            xcss: t3
        }, t8);
        $[17] = onClick;
        $[18] = onKeyDown;
        $[19] = otherProps;
        $[20] = t3;
        $[21] = t8;
        $[22] = testId;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== t1 || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t1
        }, t9);
        $[24] = t1;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    return t10;
} : ({ otherProps: otherProps, isSelected: isSelected, filterOrControlId: filterOrControlId, label: label, selectionBadge: selectionBadge, onClick: onClick, onKeyDown: onKeyDown, wide: wide, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: !wide && $9ff944adaafb586c$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        onClick: onClick,
        onKeyDown: onKeyDown,
        ...otherProps,
        testId: testId,
        xcss: [
            $9ff944adaafb586c$var$baseStyles,
            isSelected && $9ff944adaafb586c$var$selectedStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignInline: "start",
        space: "space.100",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        alignInline: "start",
        xcss: $9ff944adaafb586c$var$textStyles,
        space: "space.100"
    }, filterOrControlId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ff944adaafb586c$var$ButtonIcon, {
        filterOrControlId: filterOrControlId,
        isSelected: isSelected
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $9ff944adaafb586c$var$textStyles
    }, label), selectionBadge), filterOrControlId !== 'dropdown' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)",
        size: "small"
    }))));
};

















var $l9ukq = parcelRequire("l9ukq");

const $b1c8da9d090d09bd$var$boxStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    boxSizing: 'border-box'
});
const $b1c8da9d090d09bd$export$7a7fa4424cb20976 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] !== props) {
        t0 = props.selectProps.isSearchable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            paddingInline: "space.100",
            paddingBlockStart: "space.100",
            xcss: $b1c8da9d090d09bd$var$boxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Control, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.selectProps.isSearchable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        paddingInline: "space.100",
        paddingBlockStart: "space.100",
        xcss: $b1c8da9d090d09bd$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Control, props)));



























const $808b9bd643085cbe$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    searchClearFilterLabel: {
        id: "dynamic-cards-search-page.filter.clear.filter.label",
        defaultMessage: "Clear filter"
    }
});


const $cf6b96718f8347fa$var$clearFilterOptionsButtonStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-input, #FFFFFF)",
    color: 'color.text.subtle',
    border: 'none',
    paddingLeft: 'space.250',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '36px',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    },
    ':disabled': {
        color: 'color.text.accent.gray',
        cursor: 'default'
    }
});
const $cf6b96718f8347fa$var$ClearFilterOptionsButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { disabled: disabled, onClick: onClick, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== disabled || $[2] !== onClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            onClick: onClick,
            xcss: $cf6b96718f8347fa$var$clearFilterOptionsButtonStyles,
            isDisabled: disabled
        }, children);
        $[0] = children;
        $[1] = disabled;
        $[2] = onClick;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ disabled: disabled, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        onClick: onClick,
        xcss: $cf6b96718f8347fa$var$clearFilterOptionsButtonStyles,
        isDisabled: disabled
    }, children);
};
const $cf6b96718f8347fa$var$menuFooterStyles = (0, $buxP3.xcss)({
    borderTop: `${"var(--ds-border, #0B120E24)"} solid ${"var(--ds-border-width, 1px)"}`
});
const $cf6b96718f8347fa$export$d4c4e98c5044dc8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).MenuList, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== formatMessage || $[3] !== props.selectProps) {
        t1 = props.selectProps.canClearFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf6b96718f8347fa$var$ClearFilterOptionsButton, {
            disabled: props.selectProps.clearOptionsDisabled,
            onClick: ()=>props.selectProps.onClearOptions()
        }, formatMessage((0, $808b9bd643085cbe$export$a7357cdd1f0b0168).searchClearFilterLabel));
        $[2] = formatMessage;
        $[3] = props.selectProps;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $cf6b96718f8347fa$var$menuFooterStyles
        }, t1);
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t0 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, t2);
        $[7] = t0;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).MenuList, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $cf6b96718f8347fa$var$menuFooterStyles
    }, props.selectProps.canClearFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf6b96718f8347fa$var$ClearFilterOptionsButton, {
        disabled: props.selectProps.clearOptionsDisabled,
        onClick: ()=>props.selectProps.onClearOptions()
    }, formatMessage((0, $808b9bd643085cbe$export$a7357cdd1f0b0168).searchClearFilterLabel))));
};


const $0b2237e2073a9152$var$SelectFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { defaultIsOpen: t1, isSearchable: t2, isLoading: t3, clearOptionsDisabled: t4, canClearFilter: t5, checkboxIndicators: t6, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, selectedOptions: selectedOptions, label: label, noOptionsMessage: noOptionsMessage, filterOrControlId: filterOrControlId, getFirstSelectedLabel: getFirstSelectedLabel, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, testId: testId } = t0;
    const defaultIsOpen = t1 === undefined ? false : t1;
    const isSearchable = t2 === undefined ? false : t2;
    const isLoading = t3 === undefined ? false : t3;
    const clearOptionsDisabled = t4 === undefined ? false : t4;
    const canClearFilter = t5 === undefined ? false : t5;
    const checkboxIndicators = t6 === undefined ? false : t6;
    const numSelectedOptions = selectedOptions.length;
    const firstSelected = selectedOptions[0];
    const debounceTimeout = (0, $cozmU.useRef)(null);
    const [currentSearchInput, setCurrentSearchInput] = (0, $cozmU.useState)(searchInput);
    let t7;
    if ($[0] !== onSearchInputChange) {
        t7 = (value, action)=>{
            if (action.action !== "input-change") return;
            setCurrentSearchInput(value);
            if (!onSearchInputChange) return;
            if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
            debounceTimeout.current = setTimeout(()=>{
                onSearchInputChange(value);
            }, 300);
        };
        $[0] = onSearchInputChange;
        $[1] = t7;
    } else t7 = $[1];
    const handleInputChange = t7;
    let t8;
    if ($[2] !== onSelectChange) {
        t8 = (value_0)=>{
            onSelectChange(value_0);
        };
        $[2] = onSelectChange;
        $[3] = t8;
    } else t8 = $[3];
    const handleChange = t8;
    let t9;
    if ($[4] !== onDropdownClose) {
        t9 = ()=>{
            setCurrentSearchInput("");
            onDropdownClose?.();
        };
        $[4] = onDropdownClose;
        $[5] = t9;
    } else t9 = $[5];
    const t10 = !checkboxIndicators;
    let t11;
    if ($[6] !== currentSearchInput || $[7] !== noOptionsMessage) {
        t11 = currentSearchInput ? undefined : ()=>noOptionsMessage;
        $[6] = currentSearchInput;
        $[7] = noOptionsMessage;
        $[8] = t11;
    } else t11 = $[8];
    let t12;
    if ($[9] !== checkboxIndicators) {
        t12 = {
            Control: $b1c8da9d090d09bd$export$7a7fa4424cb20976,
            MenuList: $cf6b96718f8347fa$export$d4c4e98c5044dc8,
            ...checkboxIndicators ? {
                Option: (0, $aj8Vc.CheckboxOption)
            } : {}
        };
        $[9] = checkboxIndicators;
        $[10] = t12;
    } else t12 = $[10];
    let t13;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = {
            name: "offset",
            options: {
                offset: [
                    0,
                    8
                ]
            }
        };
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = {
            modifiers: [
                t13,
                {
                    name: "preventOverflow",
                    options: {
                        rootBoundary: "viewport"
                    },
                    enabled: false
                }
            ]
        };
        $[12] = t14;
    } else t14 = $[12];
    let t15;
    if ($[13] !== filterOrControlId || $[14] !== firstSelected || $[15] !== getFirstSelectedLabel || $[16] !== label || $[17] !== numSelectedOptions || $[18] !== testId) {
        t15 = (t16)=>{
            const { isOpen: isOpen, ...triggerProps } = t16;
            const firstSelectedLabel = getFirstSelectedLabel?.(firstSelected) || firstSelected?.label;
            let labelElement = label;
            if (typeof label === "string") labelElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, label, firstSelectedLabel ? `: ${firstSelectedLabel}${numSelectedOptions > 1 ? "," : ""}` : "");
            const isSelected = isOpen || numSelectedOptions > 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ff944adaafb586c$export$fb46dd9777cc6db0), {
                testId: testId ? `${testId}-button` : undefined,
                otherProps: triggerProps,
                isSelected: isSelected,
                label: labelElement,
                filterOrControlId: filterOrControlId,
                selectionBadge: numSelectedOptions > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), {
                    appearance: "informationBold"
                }, `+${numSelectedOptions - 1}`) : undefined
            });
        };
        $[13] = filterOrControlId;
        $[14] = firstSelected;
        $[15] = getFirstSelectedLabel;
        $[16] = label;
        $[17] = numSelectedOptions;
        $[18] = testId;
        $[19] = t15;
    } else t15 = $[19];
    let t16;
    if ($[20] !== canClearFilter || $[21] !== clearOptionsDisabled || $[22] !== currentSearchInput || $[23] !== defaultIsOpen || $[24] !== formatOptionLabel || $[25] !== handleChange || $[26] !== handleInputChange || $[27] !== isLoading || $[28] !== isSearchable || $[29] !== minMenuWidth || $[30] !== onClearOptions || $[31] !== onDropdownOpen || $[32] !== options || $[33] !== placeholder || $[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t15 || $[38] !== t9) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
            placeholder: placeholder,
            onMenuOpen: onDropdownOpen,
            onMenuClose: t9,
            minMenuWidth: minMenuWidth,
            maxMenuWidth: "22rem",
            maxMenuHeight: 400,
            menuPlacement: "bottom",
            defaultIsOpen: defaultIsOpen,
            closeMenuOnSelect: t10,
            isSearchable: isSearchable,
            searchThreshold: -1,
            blurInputOnSelect: false,
            tabSelectsValue: false,
            backspaceRemovesValue: false,
            hideSelectedOptions: false,
            controlShouldRenderValue: false,
            isClearable: false,
            defaultOptions: false,
            isLoading: isLoading,
            clearOptionsDisabled: clearOptionsDisabled,
            inputValue: currentSearchInput,
            onInputChange: handleInputChange,
            noOptionsMessage: t11,
            canClearFilter: canClearFilter,
            onChange: handleChange,
            onClearOptions: onClearOptions,
            formatOptionLabel: formatOptionLabel,
            options: options,
            isOptionSelected: $0b2237e2073a9152$var$_temp,
            shouldCloseMenuOnTab: false,
            components: t12,
            popperProps: t14,
            target: t15
        });
        $[20] = canClearFilter;
        $[21] = clearOptionsDisabled;
        $[22] = currentSearchInput;
        $[23] = defaultIsOpen;
        $[24] = formatOptionLabel;
        $[25] = handleChange;
        $[26] = handleInputChange;
        $[27] = isLoading;
        $[28] = isSearchable;
        $[29] = minMenuWidth;
        $[30] = onClearOptions;
        $[31] = onDropdownOpen;
        $[32] = options;
        $[33] = placeholder;
        $[34] = t10;
        $[35] = t11;
        $[36] = t12;
        $[37] = t15;
        $[38] = t9;
        $[39] = t16;
    } else t16 = $[39];
    return t16;
} : ({ defaultIsOpen: defaultIsOpen = false, isSearchable: isSearchable = false, isLoading: isLoading = false, clearOptionsDisabled: clearOptionsDisabled = false, canClearFilter: canClearFilter = false, checkboxIndicators: checkboxIndicators = false, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, selectedOptions: selectedOptions, label: label, noOptionsMessage: noOptionsMessage, filterOrControlId: filterOrControlId, getFirstSelectedLabel: getFirstSelectedLabel, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, testId: testId })=>{
    const numSelectedOptions = selectedOptions.length;
    const firstSelected = selectedOptions[0];
    const debounceTimeout = (0, $cozmU.useRef)(null);
    // TODO: this can be removed if we have debounce in the store when lookup
    const [currentSearchInput, setCurrentSearchInput] = (0, $cozmU.useState)(searchInput);
    const handleInputChange = (0, $cozmU.useCallback)((value, action)=>{
        if (action.action !== 'input-change') return;
        setCurrentSearchInput(value);
        if (!onSearchInputChange) return;
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(()=>{
            onSearchInputChange(value);
        }, 300);
    }, [
        onSearchInputChange
    ]);
    const handleChange = (0, $cozmU.useCallback)((value_0)=>{
        onSelectChange(value_0);
    }, [
        onSelectChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
        placeholder: placeholder,
        onMenuOpen: onDropdownOpen,
        onMenuClose: ()=>{
            setCurrentSearchInput('');
            onDropdownClose?.();
        },
        minMenuWidth: minMenuWidth,
        maxMenuWidth: "22rem",
        maxMenuHeight: 400,
        menuPlacement: "bottom",
        defaultIsOpen: defaultIsOpen,
        closeMenuOnSelect: !checkboxIndicators,
        isSearchable: isSearchable,
        searchThreshold: -1,
        blurInputOnSelect: false,
        tabSelectsValue: false,
        backspaceRemovesValue: false,
        hideSelectedOptions: false,
        controlShouldRenderValue: false,
        isClearable: false,
        defaultOptions: false,
        isLoading: isLoading,
        clearOptionsDisabled: clearOptionsDisabled,
        inputValue: currentSearchInput,
        onInputChange: handleInputChange,
        noOptionsMessage: currentSearchInput ? undefined : ()=>noOptionsMessage,
        canClearFilter: canClearFilter,
        onChange: handleChange,
        onClearOptions: onClearOptions,
        formatOptionLabel: formatOptionLabel,
        options: options,
        isOptionSelected: (option)=>option.isSelected,
        shouldCloseMenuOnTab: false,
        components: {
            Control: $b1c8da9d090d09bd$export$7a7fa4424cb20976,
            MenuList: $cf6b96718f8347fa$export$d4c4e98c5044dc8,
            ...checkboxIndicators ? {
                Option: (0, $aj8Vc.CheckboxOption)
            } : {}
        },
        popperProps: {
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        rootBoundary: 'viewport'
                    },
                    enabled: false
                }
            ]
        },
        target: ({ isOpen: isOpen, ...triggerProps })=>{
            let firstSelectedLabel = getFirstSelectedLabel?.(firstSelected) || firstSelected?.label;
            let labelElement = label;
            if (typeof label === 'string') labelElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, label, firstSelectedLabel ? `: ${firstSelectedLabel}${numSelectedOptions > 1 ? `,` : ''}` : '');
            const isSelected = isOpen || numSelectedOptions > 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ff944adaafb586c$export$fb46dd9777cc6db0), {
                testId: testId ? `${testId}-button` : undefined,
                otherProps: triggerProps,
                isSelected: isSelected,
                label: labelElement,
                filterOrControlId: filterOrControlId,
                selectionBadge: numSelectedOptions > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), {
                    appearance: "informationBold"
                }, `+${numSelectedOptions - 1}`) : undefined
            });
        }
    });
};
var $0b2237e2073a9152$export$2e2bcd8739ae039 = $0b2237e2073a9152$var$SelectFilter;
function $0b2237e2073a9152$var$_temp(option) {
    return option.isSelected;
}












var $arQY7 = parcelRequire("arQY7");




var $kA6Zo = parcelRequire("kA6Zo");





const $75445f2e61bf27fb$var$optionTextWrapperStyles = (0, $buxP3.xcss)({
    font: 'font.body',
    marginLeft: 'space.100',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $75445f2e61bf27fb$export$2cf7ef1e2dd6c6b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { option: option, state: state, children: children } = t0;
    if (state.context === "menu" || state.context === "value") {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                menu: "space.050",
                value: undefined
            };
            $[0] = t1;
        } else t1 = $[0];
        const spaces = t1;
        const t2 = spaces[state.context];
        let t3;
        if ($[1] !== option.label) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $75445f2e61bf27fb$var$optionTextWrapperStyles
            }, option.label);
            $[1] = option.label;
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] !== children || $[4] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
                alignItems: "center"
            }, children, t3);
            $[3] = children;
            $[4] = t3;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== t2 || $[7] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
                space: t2
            }, t4);
            $[6] = t2;
            $[7] = t4;
            $[8] = t5;
        } else t5 = $[8];
        return t5;
    }
    let t1;
    if ($[9] !== option.label) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $75445f2e61bf27fb$var$optionTextWrapperStyles
        }, option.label);
        $[9] = option.label;
        $[10] = t1;
    } else t1 = $[10];
    return t1;
} : ({ option: option, state: state, children: children })=>{
    if (state.context === 'menu' || state.context === 'value') {
        const spaces = {
            menu: 'space.050',
            value: undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            space: spaces[state.context]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            alignItems: "center"
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $75445f2e61bf27fb$var$optionTextWrapperStyles
        }, option.label)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $75445f2e61bf27fb$var$optionTextWrapperStyles
    }, option.label);
};
const $75445f2e61bf27fb$export$100d0de045bdee7c = (Component)=>(option, state)=>{
        const props = {
            option: option,
            state: state
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($75445f2e61bf27fb$export$2cf7ef1e2dd6c6b1, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props));
    };
const $75445f2e61bf27fb$var$AvatarOptionLabel = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.option.avatarUrl) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: props.option.avatarUrl,
            appearance: "circle",
            size: "small",
            borderColor: "none"
        });
        $[0] = props.option.avatarUrl;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: props.option.avatarUrl,
        appearance: "circle",
        size: "small",
        borderColor: "none"
    });
const $75445f2e61bf27fb$export$aaa1dc33930567f9 = $75445f2e61bf27fb$export$100d0de045bdee7c($75445f2e61bf27fb$var$AvatarOptionLabel);



var $iueFH = parcelRequire("iueFH");







const $af3b3682c97974c5$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    assignee: {
        id: "dynamic-cards-search-page.filters.names.assignee",
        defaultMessage: "Assignee"
    },
    jiraFilterContributorPlaceholder: {
        id: "dynamic-cards-search-page.jira.filter.assignee.placeholder",
        defaultMessage: "Find people"
    },
    jiraFilterAssigneeLabelSelected: {
        id: "dynamic-cards-search-page.jira.filter.assignee.selected",
        defaultMessage: "Selected"
    },
    jiraFilterAssigneeLabelUnselected: {
        id: "dynamic-cards-search-page.jira.filter.assignee.unselected",
        defaultMessage: "Suggested"
    }
});


const $dbe28d9253b856e0$var$AssigneeFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(31);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $ko90a.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [filterData, t1] = (0, $iueFH.useSelectFilter)(t0);
    const { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t1;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $af3b3682c97974c5$export$a7357cdd1f0b0168).jiraFilterAssigneeLabelSelected);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== selectedOptions || $[4] !== t2) {
        t3 = {
            label: t2,
            options: selectedOptions
        };
        $[3] = selectedOptions;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $af3b3682c97974c5$export$a7357cdd1f0b0168).jiraFilterAssigneeLabelUnselected);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== suggestedOptions || $[9] !== t4) {
        t5 = {
            label: t4,
            options: suggestedOptions
        };
        $[8] = suggestedOptions;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = [
            t3,
            t5
        ];
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const groupedOptions = t6;
    const t7 = isLookupActive ? options : groupedOptions;
    let t8;
    if ($[14] !== formatMessage) {
        t8 = formatMessage((0, $af3b3682c97974c5$export$a7357cdd1f0b0168).assignee);
        $[14] = formatMessage;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== formatMessage) {
        t9 = formatMessage((0, $af3b3682c97974c5$export$a7357cdd1f0b0168).jiraFilterContributorPlaceholder);
        $[16] = formatMessage;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== clearLookupInput || $[19] !== clearOptions || $[20] !== isLoading || $[21] !== isLookupDefined || $[22] !== loadInitialOptions || $[23] !== lookupInput || $[24] !== selectedOptions || $[25] !== setLookupInput || $[26] !== setOption || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
            canClearFilter: true,
            checkboxIndicators: true,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSearchInputChange: setLookupInput,
            onSelectChange: setOption,
            options: t7,
            selectedOptions: selectedOptions,
            label: t8,
            placeholder: t9,
            filterOrControlId: "assignee",
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            formatOptionLabel: (0, $75445f2e61bf27fb$export$aaa1dc33930567f9),
            onClearOptions: clearOptions
        });
        $[18] = clearLookupInput;
        $[19] = clearOptions;
        $[20] = isLoading;
        $[21] = isLookupDefined;
        $[22] = loadInitialOptions;
        $[23] = lookupInput;
        $[24] = selectedOptions;
        $[25] = setLookupInput;
        $[26] = setOption;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $iueFH.useSelectFilter)({
        filterId: (0, $ko90a.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $af3b3682c97974c5$export$a7357cdd1f0b0168).jiraFilterAssigneeLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $af3b3682c97974c5$export$a7357cdd1f0b0168).jiraFilterAssigneeLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $af3b3682c97974c5$export$a7357cdd1f0b0168).assignee),
        placeholder: formatMessage((0, $af3b3682c97974c5$export$a7357cdd1f0b0168).jiraFilterContributorPlaceholder),
        filterOrControlId: 'assignee',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $75445f2e61bf27fb$export$aaa1dc33930567f9),
        onClearOptions: clearOptions
    });
};
var $dbe28d9253b856e0$export$2e2bcd8739ae039 = $dbe28d9253b856e0$var$AssigneeFilter;















var $2qJQZ = parcelRequire("2qJQZ");












const $4f248f76e2a9eb23$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    content: {
        id: "dynamic-cards-search-page.filters.names.content",
        defaultMessage: "Content under"
    },
    confluenceFilterPlaceholder: {
        id: "dynamic-cards-search-page.confluence.filter.content.placeholder",
        defaultMessage: "Find content"
    },
    confluenceFilterLabelSelected: {
        id: "dynamic-cards-search-page.confluence.filter.content.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "dynamic-cards-search-page.confluence.filter.content.unselected",
        defaultMessage: "Suggested"
    }
});


const $02138afe90418c8c$var$formatContentIconOptionLabel = (0, $75445f2e61bf27fb$export$100d0de045bdee7c)(({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qJQZ.default), {
        label: option.label
    }));
const $02138afe90418c8c$var$ContentFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(31);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $hYdYN.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [filterData, t1] = (0, $iueFH.useSelectFilter)(t0);
    const { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t1;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $4f248f76e2a9eb23$export$a7357cdd1f0b0168).confluenceFilterLabelSelected);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== selectedOptions || $[4] !== t2) {
        t3 = {
            label: t2,
            options: selectedOptions
        };
        $[3] = selectedOptions;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $4f248f76e2a9eb23$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== suggestedOptions || $[9] !== t4) {
        t5 = {
            label: t4,
            options: suggestedOptions
        };
        $[8] = suggestedOptions;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = [
            t3,
            t5
        ];
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const groupedOptions = t6;
    const t7 = isLookupActive ? options : groupedOptions;
    let t8;
    if ($[14] !== formatMessage) {
        t8 = formatMessage((0, $4f248f76e2a9eb23$export$a7357cdd1f0b0168).content);
        $[14] = formatMessage;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== formatMessage) {
        t9 = formatMessage((0, $4f248f76e2a9eb23$export$a7357cdd1f0b0168).confluenceFilterPlaceholder);
        $[16] = formatMessage;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== clearLookupInput || $[19] !== clearOptions || $[20] !== isLoading || $[21] !== isLookupDefined || $[22] !== loadInitialOptions || $[23] !== lookupInput || $[24] !== selectedOptions || $[25] !== setLookupInput || $[26] !== setOption || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
            canClearFilter: true,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSearchInputChange: setLookupInput,
            onSelectChange: setOption,
            options: t7,
            selectedOptions: selectedOptions,
            label: t8,
            placeholder: t9,
            filterOrControlId: "content",
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            formatOptionLabel: $02138afe90418c8c$var$formatContentIconOptionLabel,
            onClearOptions: clearOptions
        });
        $[18] = clearLookupInput;
        $[19] = clearOptions;
        $[20] = isLoading;
        $[21] = isLookupDefined;
        $[22] = loadInitialOptions;
        $[23] = lookupInput;
        $[24] = selectedOptions;
        $[25] = setLookupInput;
        $[26] = setOption;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $iueFH.useSelectFilter)({
        filterId: (0, $hYdYN.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $4f248f76e2a9eb23$export$a7357cdd1f0b0168).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $4f248f76e2a9eb23$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $4f248f76e2a9eb23$export$a7357cdd1f0b0168).content),
        placeholder: formatMessage((0, $4f248f76e2a9eb23$export$a7357cdd1f0b0168).confluenceFilterPlaceholder),
        filterOrControlId: 'content',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: $02138afe90418c8c$var$formatContentIconOptionLabel,
        onClearOptions: clearOptions
    });
};
var $02138afe90418c8c$export$2e2bcd8739ae039 = $02138afe90418c8c$var$ContentFilter;

























const $4479c9dc635c02ed$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    contributor: {
        id: "dynamic-cards-search-page.filters.names.contributor",
        defaultMessage: "Contributor"
    },
    confluenceFilterContributorPlaceholder: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterContributorLabelSelected: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterContributorLabelUnselected: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.label.unselected",
        defaultMessage: "Suggested"
    }
});


const $1d960a81357422df$var$ContributorFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(31);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $bPX0r.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [filterData, t1] = (0, $iueFH.useSelectFilter)(t0);
    const { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t1;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $4479c9dc635c02ed$export$a7357cdd1f0b0168).confluenceFilterContributorLabelSelected);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== selectedOptions || $[4] !== t2) {
        t3 = {
            label: t2,
            options: selectedOptions
        };
        $[3] = selectedOptions;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $4479c9dc635c02ed$export$a7357cdd1f0b0168).confluenceFilterContributorLabelUnselected);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== suggestedOptions || $[9] !== t4) {
        t5 = {
            label: t4,
            options: suggestedOptions
        };
        $[8] = suggestedOptions;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = [
            t3,
            t5
        ];
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const groupedOptions = t6;
    const t7 = isLookupActive ? options : groupedOptions;
    let t8;
    if ($[14] !== formatMessage) {
        t8 = formatMessage((0, $4479c9dc635c02ed$export$a7357cdd1f0b0168).contributor);
        $[14] = formatMessage;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== formatMessage) {
        t9 = formatMessage((0, $4479c9dc635c02ed$export$a7357cdd1f0b0168).confluenceFilterContributorPlaceholder);
        $[16] = formatMessage;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== clearLookupInput || $[19] !== clearOptions || $[20] !== isLoading || $[21] !== isLookupDefined || $[22] !== loadInitialOptions || $[23] !== lookupInput || $[24] !== selectedOptions || $[25] !== setLookupInput || $[26] !== setOption || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
            canClearFilter: true,
            checkboxIndicators: true,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSearchInputChange: setLookupInput,
            onSelectChange: setOption,
            options: t7,
            selectedOptions: selectedOptions,
            label: t8,
            placeholder: t9,
            filterOrControlId: "contributor",
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            formatOptionLabel: (0, $75445f2e61bf27fb$export$aaa1dc33930567f9),
            onClearOptions: clearOptions
        });
        $[18] = clearLookupInput;
        $[19] = clearOptions;
        $[20] = isLoading;
        $[21] = isLookupDefined;
        $[22] = loadInitialOptions;
        $[23] = lookupInput;
        $[24] = selectedOptions;
        $[25] = setLookupInput;
        $[26] = setOption;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $iueFH.useSelectFilter)({
        filterId: (0, $bPX0r.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $4479c9dc635c02ed$export$a7357cdd1f0b0168).confluenceFilterContributorLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $4479c9dc635c02ed$export$a7357cdd1f0b0168).confluenceFilterContributorLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $4479c9dc635c02ed$export$a7357cdd1f0b0168).contributor),
        placeholder: formatMessage((0, $4479c9dc635c02ed$export$a7357cdd1f0b0168).confluenceFilterContributorPlaceholder),
        filterOrControlId: 'contributor',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $75445f2e61bf27fb$export$aaa1dc33930567f9),
        onClearOptions: clearOptions
    });
};
var $1d960a81357422df$export$2e2bcd8739ae039 = $1d960a81357422df$var$ContributorFilter;


















var $ad7Ou = parcelRequire("ad7Ou");


var $3vgx3 = parcelRequire("3vgx3");









































































const $3072205aaf4be7e8$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    label: {
        id: "dynamic-cards-search-page.filters.names.labels",
        defaultMessage: "Label"
    },
    confluenceFilterLabelPlaceholder: {
        id: "dynamic-cards-search-page.confluence.filter.labels.placeholder",
        defaultMessage: "Find labels"
    },
    confluenceFilterLabelSelected: {
        id: "dynamic-cards-search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelsNoText: {
        id: "dynamic-cards-search-page.advanced-search.labels.filter.no.text",
        defaultMessage: "Start typing to search for a label"
    }
});


const $bd1fbd1aa52151f3$var$LabelFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(26);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $h4cPw.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [filterData, t1] = (0, $iueFH.useSelectFilter)(t0);
    const { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t1;
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $3072205aaf4be7e8$export$a7357cdd1f0b0168).confluenceFilterLabelSelected);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== selectedOptions || $[4] !== t2) {
        t3 = [
            {
                label: t2,
                options: selectedOptions
            }
        ];
        $[3] = selectedOptions;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const groupedOptions = t3;
    const t4 = isLookupActive ? options : groupedOptions;
    let t5;
    if ($[6] !== formatMessage) {
        t5 = formatMessage((0, $3072205aaf4be7e8$export$a7357cdd1f0b0168).label);
        $[6] = formatMessage;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== formatMessage) {
        t6 = formatMessage((0, $3072205aaf4be7e8$export$a7357cdd1f0b0168).confluenceFilterLabelsNoText);
        $[8] = formatMessage;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== formatMessage) {
        t7 = formatMessage((0, $3072205aaf4be7e8$export$a7357cdd1f0b0168).confluenceFilterLabelPlaceholder);
        $[10] = formatMessage;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== clearLookupInput || $[13] !== clearOptions || $[14] !== isLoading || $[15] !== isLookupDefined || $[16] !== loadInitialOptions || $[17] !== lookupInput || $[18] !== selectedOptions || $[19] !== setLookupInput || $[20] !== setOption || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
            canClearFilter: true,
            checkboxIndicators: true,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSearchInputChange: setLookupInput,
            onSelectChange: setOption,
            options: t4,
            selectedOptions: selectedOptions,
            label: t5,
            noOptionsMessage: t6,
            placeholder: t7,
            filterOrControlId: "label",
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            onClearOptions: clearOptions,
            minMenuWidth: "360px"
        });
        $[12] = clearLookupInput;
        $[13] = clearOptions;
        $[14] = isLoading;
        $[15] = isLookupDefined;
        $[16] = loadInitialOptions;
        $[17] = lookupInput;
        $[18] = selectedOptions;
        $[19] = setLookupInput;
        $[20] = setOption;
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $iueFH.useSelectFilter)({
        filterId: (0, $h4cPw.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $3072205aaf4be7e8$export$a7357cdd1f0b0168).confluenceFilterLabelSelected),
            options: selectedOptions
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $3072205aaf4be7e8$export$a7357cdd1f0b0168).label),
        noOptionsMessage: formatMessage((0, $3072205aaf4be7e8$export$a7357cdd1f0b0168).confluenceFilterLabelsNoText),
        placeholder: formatMessage((0, $3072205aaf4be7e8$export$a7357cdd1f0b0168).confluenceFilterLabelPlaceholder),
        filterOrControlId: 'label',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: clearOptions,
        minMenuWidth: '360px'
    });
};
var $bd1fbd1aa52151f3$export$2e2bcd8739ae039 = $bd1fbd1aa52151f3$var$LabelFilter;



























var $5wHqn = parcelRequire("5wHqn");







var $jp2Q3 = parcelRequire("jp2Q3");





















const $9a9cbbce65435af6$var$itemStyles = (0, $buxP3.xcss)({
    cursor: 'default',
    borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid`,
    borderColor: 'color.border.inverse',
    ':hover': {
        borderColor: 'color.border.selected',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $9a9cbbce65435af6$var$insideItemStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.negative.025'
});
const $9a9cbbce65435af6$var$itemHoveredStyles = (0, $buxP3.xcss)({
    borderColor: 'color.border.selected',
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $9a9cbbce65435af6$var$itemSelectedStyles = (0, $buxP3.xcss)({
    borderColor: 'color.border.selected',
    backgroundColor: 'color.background.selected'
});
const $9a9cbbce65435af6$var$DateOption = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { option: option, hovered: hovered, onClick: onClick } = t0;
    const t1 = option.isSelected && $9a9cbbce65435af6$var$itemSelectedStyles;
    const t2 = hovered && $9a9cbbce65435af6$var$itemHoveredStyles;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = [
            $9a9cbbce65435af6$var$itemStyles,
            t1,
            t2
        ];
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== option.label) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $9a9cbbce65435af6$var$insideItemStyles
        }, option.label);
        $[3] = option.label;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== onClick || $[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            xcss: t3,
            onClick: onClick,
            paddingInline: "space.150",
            paddingBlock: "space.075"
        }, t4);
        $[5] = onClick;
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ option: option, hovered: hovered, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        xcss: [
            $9a9cbbce65435af6$var$itemStyles,
            option.isSelected && $9a9cbbce65435af6$var$itemSelectedStyles,
            hovered && $9a9cbbce65435af6$var$itemHoveredStyles
        ],
        onClick: onClick,
        paddingInline: "space.150",
        paddingBlock: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $9a9cbbce65435af6$var$insideItemStyles
    }, option.label));
var $9a9cbbce65435af6$export$2e2bcd8739ae039 = $9a9cbbce65435af6$var$DateOption;


















var $lF9wS = parcelRequire("lF9wS");


var $24dy7 = parcelRequire("24dy7");








var $6Pqow = parcelRequire("6Pqow");




var $hz3c4 = parcelRequire("hz3c4");




const $aa664134cf3ba5b9$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    dateFilterTitle: {
        id: "dynamic-cards-search-page.date.filter.title",
        defaultMessage: "Last updated"
    },
    dateFilterFromTitle: {
        id: "dynamic-cards-search-page.date.filter.from.title",
        defaultMessage: "From"
    },
    dateFilterToTitle: {
        id: "dynamic-cards-search-page.date.filter.to.title",
        defaultMessage: "To"
    },
    dateFilterDateInputPlaceholder: {
        id: "dynamic-cards-search-page.date.filter.input.placeholder",
        defaultMessage: "Choose a date"
    },
    dateFilterAnyTime: {
        id: "dynamic-cards-search-page.date.filter.any.time",
        defaultMessage: "Anytime"
    },
    dateFilterToday: {
        id: "dynamic-cards-search-page.date.filter.today",
        defaultMessage: "Today"
    },
    dateFilterYesterday: {
        id: "dynamic-cards-search-page.date.filter.yesterday",
        defaultMessage: "Yesterday"
    },
    dateFilterLastWeek: {
        id: "dynamic-cards-search-page.date.filter.last.week",
        defaultMessage: "Past 7 days"
    },
    dateFilterLastMonth: {
        id: "dynamic-cards-search-page.date.filter.last.month",
        defaultMessage: "Past 30 days"
    },
    dateFilterLastYear: {
        id: "dynamic-cards-search-page.date.filter.last.year",
        defaultMessage: "Past year"
    },
    dateFilterCustom: {
        id: "dynamic-cards-search-page.date.filter.custom",
        defaultMessage: "Custom"
    },
    dateFilterCustomInvalidDateAfterToday: {
        id: "dynamic-cards-search-page.date.filter.custom.invalid.after.today",
        defaultMessage: "The From date can\u2019t be in the future"
    },
    dateFilterCustomInvalidToDateAfterToday: {
        id: "dynamic-cards-search-page.date.filter.custom.invalid.to.after.today",
        defaultMessage: "The To date can\u2019t be in the future"
    },
    dateFilterCustomInvalidDateAfterEnd: {
        id: "dynamic-cards-search-page.date.filter.custom.invalid.after.end",
        defaultMessage: "The From date has to be before the To date"
    },
    dateFilterToRange: {
        id: "dynamic-cards-search-page.date.filter.to.range",
        defaultMessage: "to"
    },
    dateFilterUpdateButton: {
        id: "dynamic-cards-search-page.date.filter.update.button",
        defaultMessage: "Update"
    },
    dateFilterBeforeLabel: {
        id: "dynamic-cards-search-page.date.filter.before.label",
        defaultMessage: "before"
    },
    dateFilterAfterLabel: {
        id: "dynamic-cards-search-page.date.filter.after.label",
        defaultMessage: "after"
    }
});


const $bf1acbbffd98510b$export$1dc6c6b3e4774b92 = {
    [(0, $hz3c4.DateRangeError).FROM_AFTER_TO_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterCustomInvalidDateAfterEnd),
    [(0, $hz3c4.DateRangeError).FROM_IN_FUTURE_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterCustomInvalidDateAfterToday),
    [(0, $hz3c4.DateRangeError).TO_IN_FUTURE_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterCustomInvalidToDateAfterToday)
};
const $bf1acbbffd98510b$var$datePickerWrapper = (0, $buxP3.xcss)({
    width: '140px'
});
const $bf1acbbffd98510b$var$DateRangePicker = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { onCustomDateRangeChange: onCustomDateRangeChange, customDateRange: customDateRange } = t0;
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const [selectedFromDate, setSelectedFromDate] = (0, $cozmU.useState)(customDateRange.from);
    const [selectedToDate, setSelectedToDate] = (0, $cozmU.useState)(customDateRange.to);
    let t1;
    if ($[0] !== selectedFromDate || $[1] !== selectedToDate) {
        t1 = (0, $hz3c4.getInvalidDateRange)(selectedFromDate, selectedToDate);
        $[0] = selectedFromDate;
        $[1] = selectedToDate;
        $[2] = t1;
    } else t1 = $[2];
    const invalidDateRange = t1;
    let t2;
    if ($[3] !== invalidDateRange || $[4] !== onCustomDateRangeChange || $[5] !== selectedFromDate || $[6] !== selectedToDate) {
        t2 = ()=>{
            if (Boolean(invalidDateRange)) return;
            onCustomDateRangeChange(selectedFromDate, selectedToDate);
        };
        $[3] = invalidDateRange;
        $[4] = onCustomDateRangeChange;
        $[5] = selectedFromDate;
        $[6] = selectedToDate;
        $[7] = t2;
    } else t2 = $[7];
    const handleUpdateSelectedDates = t2;
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (date)=>setSelectedFromDate(date);
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== formatMessage) {
        t4 = formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterFromTitle);
        $[9] = formatMessage;
        $[10] = t4;
    } else t4 = $[10];
    const t5 = Boolean(invalidDateRange);
    let t6;
    if ($[11] !== locale || $[12] !== selectedFromDate || $[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $bf1acbbffd98510b$var$datePickerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
            onChange: t3,
            defaultValue: selectedFromDate,
            placeholder: t4,
            isInvalid: t5,
            locale: locale,
            shouldShowCalendarButton: true
        }));
        $[11] = locale;
        $[12] = selectedFromDate;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== formatMessage) {
        t7 = formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterToRange);
        $[16] = formatMessage;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, t7);
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (date_0)=>setSelectedToDate(date_0);
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== formatMessage) {
        t10 = formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterToTitle);
        $[21] = formatMessage;
        $[22] = t10;
    } else t10 = $[22];
    const t11 = invalidDateRange === (0, $hz3c4.DateRangeError).FROM_AFTER_TO_ERROR;
    let t12;
    if ($[23] !== locale || $[24] !== selectedToDate || $[25] !== t10 || $[26] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $bf1acbbffd98510b$var$datePickerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
            onChange: t9,
            defaultValue: selectedToDate,
            placeholder: t10,
            isInvalid: t11,
            locale: locale,
            shouldShowCalendarButton: true
        }));
        $[23] = locale;
        $[24] = selectedToDate;
        $[25] = t10;
        $[26] = t11;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== t12 || $[29] !== t6 || $[30] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            alignInline: "start",
            alignBlock: "center",
            spread: "space-between"
        }, t6, t8, t12);
        $[28] = t12;
        $[29] = t6;
        $[30] = t8;
        $[31] = t13;
    } else t13 = $[31];
    let t14;
    if ($[32] !== invalidDateRange) {
        t14 = invalidDateRange ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            paddingBlock: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: "Date range error"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            color: "color.text.danger"
        }, $bf1acbbffd98510b$export$1dc6c6b3e4774b92[invalidDateRange]))) : null;
        $[32] = invalidDateRange;
        $[33] = t14;
    } else t14 = $[33];
    const t15 = Boolean(invalidDateRange);
    let t16;
    if ($[34] !== formatMessage) {
        t16 = formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterUpdateButton);
        $[34] = formatMessage;
        $[35] = t16;
    } else t16 = $[35];
    let t17;
    if ($[36] !== handleUpdateSelectedDates || $[37] !== t15 || $[38] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            isDisabled: t15,
            onClick: handleUpdateSelectedDates
        }, t16));
        $[36] = handleUpdateSelectedDates;
        $[37] = t15;
        $[38] = t16;
        $[39] = t17;
    } else t17 = $[39];
    let t18;
    if ($[40] !== t13 || $[41] !== t14 || $[42] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            paddingInline: "space.150",
            paddingBlock: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            space: "space.150"
        }, t13, t14, t17));
        $[40] = t13;
        $[41] = t14;
        $[42] = t17;
        $[43] = t18;
    } else t18 = $[43];
    return t18;
} : ({ onCustomDateRangeChange: onCustomDateRangeChange, customDateRange: customDateRange })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const [selectedFromDate, setSelectedFromDate] = (0, $cozmU.useState)(customDateRange.from);
    const [selectedToDate, setSelectedToDate] = (0, $cozmU.useState)(customDateRange.to);
    const invalidDateRange = (0, $hz3c4.getInvalidDateRange)(selectedFromDate, selectedToDate);
    const handleUpdateSelectedDates = ()=>{
        if (Boolean(invalidDateRange)) return;
        onCustomDateRangeChange(selectedFromDate, selectedToDate);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        paddingInline: "space.150",
        paddingBlock: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignInline: "start",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $bf1acbbffd98510b$var$datePickerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
        onChange: (date)=>setSelectedFromDate(date),
        defaultValue: selectedFromDate,
        placeholder: formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterFromTitle),
        isInvalid: Boolean(invalidDateRange),
        locale: locale,
        shouldShowCalendarButton: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterToRange)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $bf1acbbffd98510b$var$datePickerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lF9wS.default), {
        onChange: (date_0)=>setSelectedToDate(date_0),
        defaultValue: selectedToDate,
        placeholder: formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterToTitle),
        isInvalid: invalidDateRange === (0, $hz3c4.DateRangeError).FROM_AFTER_TO_ERROR,
        locale: locale,
        shouldShowCalendarButton: true
    }))), invalidDateRange ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        paddingBlock: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "Date range error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        color: "color.text.danger"
    }, $bf1acbbffd98510b$export$1dc6c6b3e4774b92[invalidDateRange]))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        isDisabled: Boolean(invalidDateRange),
        onClick: handleUpdateSelectedDates
    }, formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterUpdateButton)))));
};
var $bf1acbbffd98510b$export$2e2bcd8739ae039 = $bf1acbbffd98510b$var$DateRangePicker;



// a higher layer is needed to make sure the popup is on top of the dropdown menu rendered on top of a modal
const $e7045c4af1bc24bf$var$layerAbovePopupInModal = (0, $jp2Q3.layers).flag();
const $e7045c4af1bc24bf$var$containerStyles = (0, $buxP3.xcss)({
    boxSizing: 'border-box',
    width: '360px',
    overflow: 'visible',
    backgroundColor: 'elevation.surface.overlay',
    ':focus': {
        outline: 'none'
    },
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay'
});
const $e7045c4af1bc24bf$var$PopupComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            ...props,
            paddingBlock: "space.100",
            ref: ref,
            xcss: $e7045c4af1bc24bf$var$containerStyles,
            "data-testid": undefined
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        ...props,
        paddingBlock: "space.100",
        ref: ref,
        xcss: $e7045c4af1bc24bf$var$containerStyles,
        "data-testid": undefined
    }));
const $e7045c4af1bc24bf$var$formatDate = (dateString, locale)=>{
    // to keep date string in local time, not UTC:
    // https://stackoverflow.com/questions/39223481/incorrect-date-shown-in-new-date-in-javascript
    const modifiedDateString = dateString.concat('T00:00');
    return new Date(modifiedDateString).toLocaleDateString(locale);
};
const $e7045c4af1bc24bf$var$createDatePickerLabel = (locale, afterString, beforeString, from, to)=>{
    if (from && !to) {
        const localeFromDate = $e7045c4af1bc24bf$var$formatDate(from, locale);
        return `${afterString} ${localeFromDate}`;
    }
    if (!from && to) {
        const localeToDate = $e7045c4af1bc24bf$var$formatDate(to, locale);
        return `${beforeString} ${localeToDate}`;
    }
    if (from && to) {
        const localeFromDate = $e7045c4af1bc24bf$var$formatDate(from, locale);
        const localeToDate = $e7045c4af1bc24bf$var$formatDate(to, locale);
        return `${localeFromDate} - ${localeToDate}`;
    }
};
const $e7045c4af1bc24bf$var$getButtonLabel = (isSelected, isCustomDateSelected, selectedLabel, label, afterString, beforeString, locale, from, to)=>{
    if (!isSelected) return label;
    if (isCustomDateSelected && (from || to)) {
        const valueLabel = $e7045c4af1bc24bf$var$createDatePickerLabel(locale, afterString, beforeString, from, to);
        return `${label}: ${valueLabel}`;
    }
    return `${label}: ${selectedLabel}`;
};
const $e7045c4af1bc24bf$var$DateFilterWithCustomRangePicker = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { options: options, onDropdownOpen: onDropdownOpen, onSelectChange: onSelectChange, selectedOptions: selectedOptions, customDateRange: customDateRange, label: label, testId: testId } = t0;
    const [open, setOpen] = (0, $cozmU.useState)(false);
    const [customDateOpen, setCustomDateOpen] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const [focusedOption, setFocusedOption] = (0, $cozmU.useState)(0);
    const [mouseHovered, setMouseHovered] = (0, $cozmU.useState)(false);
    const buttonRef = (0, $cozmU.useRef)(null);
    const isSelected = selectedOptions.length > 0;
    const firstSelected = selectedOptions[0];
    const isCustomDateSelected = firstSelected?.value === (0, $lCzjG.CUSTOM_OPTION_VALUE);
    let t1;
    if ($[0] !== customDateRange.from || $[1] !== customDateRange.to || $[2] !== firstSelected?.label || $[3] !== formatMessage || $[4] !== isCustomDateSelected || $[5] !== isSelected || $[6] !== label || $[7] !== locale) {
        t1 = $e7045c4af1bc24bf$var$getButtonLabel(isSelected, isCustomDateSelected, firstSelected?.label || "", label, formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterAfterLabel), formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterBeforeLabel), locale, customDateRange.from, customDateRange.to);
        $[0] = customDateRange.from;
        $[1] = customDateRange.to;
        $[2] = firstSelected?.label;
        $[3] = formatMessage;
        $[4] = isCustomDateSelected;
        $[5] = isSelected;
        $[6] = label;
        $[7] = locale;
        $[8] = t1;
    } else t1 = $[8];
    const labelToDisplay = t1;
    let t2;
    if ($[9] !== customDateRange || $[10] !== onSelectChange) {
        t2 = (option)=>{
            if (option.value === (0, $lCzjG.CUSTOM_OPTION_VALUE)) setCustomDateOpen(true);
            else {
                setCustomDateOpen(false);
                onSelectChange(option, customDateRange);
                setOpen(false);
            }
        };
        $[9] = customDateRange;
        $[10] = onSelectChange;
        $[11] = t2;
    } else t2 = $[11];
    const handleOptionClick = t2;
    let t3;
    if ($[12] !== onSelectChange || $[13] !== options) {
        t3 = (from, to)=>{
            const option_0 = options.find($e7045c4af1bc24bf$var$_temp);
            if (!option_0) return;
            onSelectChange(option_0, {
                from: from,
                to: to
            });
            setOpen(false);
        };
        $[12] = onSelectChange;
        $[13] = options;
        $[14] = t3;
    } else t3 = $[14];
    const handleCustomDateRangeChange = t3;
    let t4;
    if ($[15] !== onDropdownOpen || $[16] !== open) {
        t4 = ()=>{
            if (!open && onDropdownOpen) onDropdownOpen();
            setOpen(!open);
            setFocusedOption(0);
            buttonRef.current?.focus();
        };
        $[15] = onDropdownOpen;
        $[16] = open;
        $[17] = t4;
    } else t4 = $[17];
    const handleClickDropdownBtn = t4;
    let t5;
    if ($[18] !== focusedOption || $[19] !== handleOptionClick || $[20] !== open || $[21] !== options) {
        t5 = (event)=>{
            if (event.key === "ArrowDown") {
                event.preventDefault();
                setFocusedOption((prev)=>(prev + 1) % options.length);
            }
            if (event.key === "ArrowUp") {
                event.preventDefault();
                setFocusedOption((prev_0)=>(prev_0 - 1 + options.length) % options.length);
            }
            if (event.key === "Enter" && open) {
                event.preventDefault();
                handleOptionClick(options[focusedOption]);
            }
        };
        $[18] = focusedOption;
        $[19] = handleOptionClick;
        $[20] = open;
        $[21] = options;
        $[22] = t5;
    } else t5 = $[22];
    const handleKeyDown = t5;
    let t6;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setOpen(false);
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== customDateOpen || $[25] !== customDateRange || $[26] !== focusedOption || $[27] !== handleCustomDateRangeChange || $[28] !== handleOptionClick || $[29] !== isCustomDateSelected || $[30] !== mouseHovered || $[31] !== options) {
        t7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                onMouseOver: ()=>setMouseHovered(true),
                onMouseOut: ()=>setMouseHovered(false)
            }, options.map((option_1, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9a9cbbce65435af6$export$2e2bcd8739ae039), {
                    hovered: !mouseHovered && focusedOption === index,
                    key: option_1.value,
                    option: option_1,
                    onClick: ()=>handleOptionClick(option_1)
                })), (customDateOpen || isCustomDateSelected) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf1acbbffd98510b$export$2e2bcd8739ae039), {
                onCustomDateRangeChange: handleCustomDateRangeChange,
                customDateRange: customDateRange
            }));
        $[24] = customDateOpen;
        $[25] = customDateRange;
        $[26] = focusedOption;
        $[27] = handleCustomDateRangeChange;
        $[28] = handleOptionClick;
        $[29] = isCustomDateSelected;
        $[30] = mouseHovered;
        $[31] = options;
        $[32] = t7;
    } else t7 = $[32];
    let t8;
    if ($[33] !== handleClickDropdownBtn || $[34] !== handleKeyDown || $[35] !== isSelected || $[36] !== labelToDisplay || $[37] !== testId) {
        t8 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ff944adaafb586c$export$fb46dd9777cc6db0), {
                label: labelToDisplay,
                filterOrControlId: "lastUpdated",
                otherProps: triggerProps,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                testId: testId ? `${testId}-button` : undefined,
                onKeyDown: handleKeyDown,
                wide: true
            });
        $[33] = handleClickDropdownBtn;
        $[34] = handleKeyDown;
        $[35] = isSelected;
        $[36] = labelToDisplay;
        $[37] = testId;
        $[38] = t8;
    } else t8 = $[38];
    let t9;
    if ($[39] !== open || $[40] !== t7 || $[41] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            placement: "bottom-start",
            onClose: t6,
            isOpen: open,
            zIndex: $e7045c4af1bc24bf$var$layerAbovePopupInModal,
            autoFocus: false,
            popupComponent: $e7045c4af1bc24bf$var$PopupComponent,
            content: t7,
            trigger: t8
        });
        $[39] = open;
        $[40] = t7;
        $[41] = t8;
        $[42] = t9;
    } else t9 = $[42];
    return t9;
} : ({ options: options, onDropdownOpen: onDropdownOpen, onSelectChange: onSelectChange, selectedOptions: selectedOptions, customDateRange: customDateRange, label: label, testId: testId })=>{
    const [open, setOpen] = (0, $cozmU.useState)(false);
    const [customDateOpen, setCustomDateOpen] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const [focusedOption, setFocusedOption] = (0, $cozmU.useState)(0);
    const [mouseHovered, setMouseHovered] = (0, $cozmU.useState)(false);
    const buttonRef = (0, $cozmU.useRef)(null);
    const isSelected = selectedOptions.length > 0;
    const firstSelected = selectedOptions[0];
    const isCustomDateSelected = firstSelected?.value === (0, $lCzjG.CUSTOM_OPTION_VALUE);
    const labelToDisplay = $e7045c4af1bc24bf$var$getButtonLabel(isSelected, isCustomDateSelected, firstSelected?.label || '', label, formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterAfterLabel), formatMessage((0, $aa664134cf3ba5b9$export$a7357cdd1f0b0168).dateFilterBeforeLabel), locale, customDateRange.from, customDateRange.to);
    const handleOptionClick = (option)=>{
        if (option.value === (0, $lCzjG.CUSTOM_OPTION_VALUE)) setCustomDateOpen(true);
        else {
            setCustomDateOpen(false);
            onSelectChange(option, customDateRange);
            setOpen(false);
        }
    };
    const handleCustomDateRangeChange = (from, to)=>{
        const option_0 = options.find((o)=>o.value === (0, $lCzjG.CUSTOM_OPTION_VALUE));
        if (!option_0) return;
        onSelectChange(option_0, {
            from: from,
            to: to
        });
        setOpen(false);
    };
    const handleClickDropdownBtn = ()=>{
        if (!open && onDropdownOpen) onDropdownOpen();
        setOpen(!open);
        setFocusedOption(0);
        buttonRef.current?.focus();
    };
    const handleKeyDown = (event)=>{
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev + 1) % options.length);
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            setFocusedOption((prev_0)=>(prev_0 - 1 + options.length) % options.length);
        }
        if (event.key === 'Enter' && open) {
            event.preventDefault();
            handleOptionClick(options[focusedOption]);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        placement: "bottom-start",
        onClose: ()=>setOpen(false),
        isOpen: open,
        zIndex: $e7045c4af1bc24bf$var$layerAbovePopupInModal,
        autoFocus: false,
        popupComponent: $e7045c4af1bc24bf$var$PopupComponent,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                onMouseOver: ()=>setMouseHovered(true),
                onMouseOut: ()=>setMouseHovered(false)
            }, options.map((option_1, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9a9cbbce65435af6$export$2e2bcd8739ae039), {
                    hovered: !mouseHovered && focusedOption === index,
                    key: option_1.value,
                    option: option_1,
                    onClick: ()=>handleOptionClick(option_1)
                })), (customDateOpen || isCustomDateSelected) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf1acbbffd98510b$export$2e2bcd8739ae039), {
                onCustomDateRangeChange: handleCustomDateRangeChange,
                customDateRange: customDateRange
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ff944adaafb586c$export$fb46dd9777cc6db0), {
                label: labelToDisplay,
                filterOrControlId: 'lastUpdated',
                otherProps: triggerProps,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                testId: testId ? `${testId}-button` : undefined,
                onKeyDown: handleKeyDown,
                wide: true
            })
    });
};
var $e7045c4af1bc24bf$export$2e2bcd8739ae039 = $e7045c4af1bc24bf$var$DateFilterWithCustomRangePicker;
function $e7045c4af1bc24bf$var$_temp(o) {
    return o.value === (0, $lCzjG.CUSTOM_OPTION_VALUE);
}








const $b6bd6f1ee65b7144$export$a7357cdd1f0b0168 = {
    lastUpdated: {
        id: 'dynamic-cards-search-page.filters.names.lastUpdated',
        defaultMessage: 'Last updated',
        description: 'Label for filtering by last updated time'
    }
};


const $0fdd2922a207f2ea$var$LastUpdatedFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(12);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $bkXhB.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [filterData, t1] = (0, $iueFH.useSelectFilter)(t0);
    const { setOption: setOption, loadInitialOptions: loadInitialOptions } = t1;
    if (!filterData) return null;
    const { options: options, selectedOptions: selectedOptions, customValue: customValue } = filterData;
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $b6bd6f1ee65b7144$export$a7357cdd1f0b0168).lastUpdated);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== customValue) {
        t3 = customValue || {
            from: "",
            to: ""
        };
        $[3] = customValue;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== loadInitialOptions || $[6] !== options || $[7] !== selectedOptions || $[8] !== setOption || $[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e7045c4af1bc24bf$export$2e2bcd8739ae039), {
            options: options,
            onSelectChange: setOption,
            label: t2,
            onDropdownOpen: loadInitialOptions,
            selectedOptions: selectedOptions,
            customDateRange: t3,
            testId: "universal-last-updated-filter"
        });
        $[5] = loadInitialOptions;
        $[6] = options;
        $[7] = selectedOptions;
        $[8] = setOption;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions }] = (0, $iueFH.useSelectFilter)({
        filterId: (0, $bkXhB.filter).id
    });
    if (!filterData) return null;
    const { options: options, selectedOptions: selectedOptions, customValue: customValue } = filterData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e7045c4af1bc24bf$export$2e2bcd8739ae039), {
        options: options,
        onSelectChange: setOption,
        label: formatMessage((0, $b6bd6f1ee65b7144$export$a7357cdd1f0b0168).lastUpdated),
        onDropdownOpen: loadInitialOptions,
        selectedOptions: selectedOptions,
        customDateRange: customValue || {
            from: '',
            to: ''
        },
        testId: "universal-last-updated-filter"
    });
};
var $0fdd2922a207f2ea$export$2e2bcd8739ae039 = $0fdd2922a207f2ea$var$LastUpdatedFilter;

























const $8a23da993cc0525c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    owner: {
        id: "dynamic-cards-search-page.filters.names.owner",
        defaultMessage: "Owner"
    },
    confluenceFilterOwnerPlaceholder: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterOwnerLabelSelected: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterOwnerLabelUnselected: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.label.unselected",
        defaultMessage: "Suggested"
    }
});


const $0dbae90f7e497bab$var$OwnerFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(31);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $7ayyq.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [filterData, t1] = (0, $iueFH.useSelectFilter)(t0);
    const { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t1;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $8a23da993cc0525c$export$a7357cdd1f0b0168).confluenceFilterOwnerLabelSelected);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== selectedOptions || $[4] !== t2) {
        t3 = {
            label: t2,
            options: selectedOptions
        };
        $[3] = selectedOptions;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $8a23da993cc0525c$export$a7357cdd1f0b0168).confluenceFilterOwnerLabelUnselected);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== suggestedOptions || $[9] !== t4) {
        t5 = {
            label: t4,
            options: suggestedOptions
        };
        $[8] = suggestedOptions;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = [
            t3,
            t5
        ];
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const groupedOptions = t6;
    const t7 = isLookupActive ? options : groupedOptions;
    let t8;
    if ($[14] !== formatMessage) {
        t8 = formatMessage((0, $8a23da993cc0525c$export$a7357cdd1f0b0168).owner);
        $[14] = formatMessage;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== formatMessage) {
        t9 = formatMessage((0, $8a23da993cc0525c$export$a7357cdd1f0b0168).confluenceFilterOwnerPlaceholder);
        $[16] = formatMessage;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== clearLookupInput || $[19] !== clearOptions || $[20] !== isLoading || $[21] !== isLookupDefined || $[22] !== loadInitialOptions || $[23] !== lookupInput || $[24] !== selectedOptions || $[25] !== setLookupInput || $[26] !== setOption || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
            canClearFilter: true,
            checkboxIndicators: true,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSearchInputChange: setLookupInput,
            onSelectChange: setOption,
            options: t7,
            selectedOptions: selectedOptions,
            label: t8,
            placeholder: t9,
            filterOrControlId: "owner",
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            formatOptionLabel: (0, $75445f2e61bf27fb$export$aaa1dc33930567f9),
            onClearOptions: clearOptions
        });
        $[18] = clearLookupInput;
        $[19] = clearOptions;
        $[20] = isLoading;
        $[21] = isLookupDefined;
        $[22] = loadInitialOptions;
        $[23] = lookupInput;
        $[24] = selectedOptions;
        $[25] = setLookupInput;
        $[26] = setOption;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $iueFH.useSelectFilter)({
        filterId: (0, $7ayyq.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $8a23da993cc0525c$export$a7357cdd1f0b0168).confluenceFilterOwnerLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $8a23da993cc0525c$export$a7357cdd1f0b0168).confluenceFilterOwnerLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $8a23da993cc0525c$export$a7357cdd1f0b0168).owner),
        placeholder: formatMessage((0, $8a23da993cc0525c$export$a7357cdd1f0b0168).confluenceFilterOwnerPlaceholder),
        filterOrControlId: 'owner',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $75445f2e61bf27fb$export$aaa1dc33930567f9),
        onClearOptions: clearOptions
    });
};
var $0dbae90f7e497bab$export$2e2bcd8739ae039 = $0dbae90f7e497bab$var$OwnerFilter;

























const $7cd47402c185a18c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    project: {
        id: "dynamic-cards-search-page.filters.names.project",
        defaultMessage: "Project"
    },
    jiraFilterProjectPlaceholder: {
        id: "dynamic-cards-search-page.jira.filter.project.placeholder",
        defaultMessage: "Find projects"
    },
    jiraFilterProjectLabelSelected: {
        id: "dynamic-cards-search-page.jira.filter.project.selected",
        defaultMessage: "Selected"
    },
    jiraFilterProjectLabelUnselected: {
        id: "dynamic-cards-search-page.jira.filter.project.unselected",
        defaultMessage: "Suggested"
    }
});


const $a555b534cdd219ee$var$ProjectFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(31);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $10JkG.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [filterData, t1] = (0, $iueFH.useSelectFilter)(t0);
    const { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t1;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $7cd47402c185a18c$export$a7357cdd1f0b0168).jiraFilterProjectLabelSelected);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== selectedOptions || $[4] !== t2) {
        t3 = {
            label: t2,
            options: selectedOptions
        };
        $[3] = selectedOptions;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $7cd47402c185a18c$export$a7357cdd1f0b0168).jiraFilterProjectLabelUnselected);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== suggestedOptions || $[9] !== t4) {
        t5 = {
            label: t4,
            options: suggestedOptions
        };
        $[8] = suggestedOptions;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = [
            t3,
            t5
        ];
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const groupedOptions = t6;
    const t7 = isLookupActive ? options : groupedOptions;
    let t8;
    if ($[14] !== formatMessage) {
        t8 = formatMessage((0, $7cd47402c185a18c$export$a7357cdd1f0b0168).project);
        $[14] = formatMessage;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== formatMessage) {
        t9 = formatMessage((0, $7cd47402c185a18c$export$a7357cdd1f0b0168).jiraFilterProjectPlaceholder);
        $[16] = formatMessage;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== clearLookupInput || $[19] !== clearOptions || $[20] !== isLoading || $[21] !== isLookupDefined || $[22] !== loadInitialOptions || $[23] !== lookupInput || $[24] !== selectedOptions || $[25] !== setLookupInput || $[26] !== setOption || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
            canClearFilter: true,
            checkboxIndicators: true,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSearchInputChange: setLookupInput,
            onSelectChange: setOption,
            options: t7,
            selectedOptions: selectedOptions,
            label: t8,
            placeholder: t9,
            filterOrControlId: "project",
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            formatOptionLabel: (0, $75445f2e61bf27fb$export$aaa1dc33930567f9),
            onClearOptions: clearOptions
        });
        $[18] = clearLookupInput;
        $[19] = clearOptions;
        $[20] = isLoading;
        $[21] = isLookupDefined;
        $[22] = loadInitialOptions;
        $[23] = lookupInput;
        $[24] = selectedOptions;
        $[25] = setLookupInput;
        $[26] = setOption;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $iueFH.useSelectFilter)({
        filterId: (0, $10JkG.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $7cd47402c185a18c$export$a7357cdd1f0b0168).jiraFilterProjectLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $7cd47402c185a18c$export$a7357cdd1f0b0168).jiraFilterProjectLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $7cd47402c185a18c$export$a7357cdd1f0b0168).project),
        placeholder: formatMessage((0, $7cd47402c185a18c$export$a7357cdd1f0b0168).jiraFilterProjectPlaceholder),
        filterOrControlId: 'project',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $75445f2e61bf27fb$export$aaa1dc33930567f9),
        onClearOptions: clearOptions
    });
};
var $a555b534cdd219ee$export$2e2bcd8739ae039 = $a555b534cdd219ee$var$ProjectFilter;


















var $4XdCR = parcelRequire("4XdCR");











const $1ad56976fd0f49f1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    latestModifiedDateDESC: {
        id: "dynamic-cards-search-page.results-sort.latestModifiedDateDESC",
        defaultMessage: "Updated (newest)"
    },
    latestModifiedDateDESCSelected: {
        id: "dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected",
        defaultMessage: "Sort by updated (newest)"
    },
    latestModifiedDateASC: {
        id: "dynamic-cards-search-page.results-sort.latestModifiedDateASC",
        defaultMessage: "Updated (oldest)"
    },
    latestModifiedDateASCSelected: {
        id: "dynamic-cards-search-page.results-sort.latestModifiedDateASC.selected",
        defaultMessage: "Sort by updated (oldest)"
    },
    createdDateDESC: {
        id: "dynamic-cards-search-page.results-sort.createdDateDESC",
        defaultMessage: "Created (newest)"
    },
    createdDateDESCSelected: {
        id: "dynamic-cards-search-page.results-sort.createdDate.selected",
        defaultMessage: "Sort by created (newest)"
    },
    createdDateASC: {
        id: "dynamic-cards-search-page.results-sort.createdDateASC",
        defaultMessage: "Created (oldest)"
    },
    createdDateASCSelected: {
        id: "dynamic-cards-search-page.results-sort.createdDateASC.selected",
        defaultMessage: "Sort by created (oldest)"
    },
    sortOptionsLabel: {
        id: "dynamic-cards-search-page.results-sort.sort-options.label",
        defaultMessage: "Change list sorting"
    }
});


const $4ab1350f99bd7925$export$66a8c50d62eea7ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(23);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [t0, t1] = (0, $2Va9o.useResultsSort)();
    const { order: order, field: field } = t0;
    const { setResultsSort: setResultsSort } = t1;
    let t2;
    if ($[0] !== setResultsSort) {
        t2 = (option)=>{
            setResultsSort({
                order: (0, $4XdCR.RESULTS_SORT_FIELDS)[option.value].order,
                field: (0, $4XdCR.RESULTS_SORT_FIELDS)[option.value].field
            });
        };
        $[0] = setResultsSort;
        $[1] = t2;
    } else t2 = $[1];
    const handleSelectOption = t2;
    if (selectedProduct !== (0, $37AYo.ProductKeys).Confluence) return null;
    let t3;
    if ($[2] !== field || $[3] !== order) {
        t3 = (0, $4XdCR.getOptionKey)(field, order);
        $[2] = field;
        $[3] = order;
        $[4] = t3;
    } else t3 = $[4];
    const selectedOptionKey = t3;
    let t4;
    if ($[5] !== formatMessage || $[6] !== selectedOptionKey) {
        t4 = (0, $4XdCR.ResultsSortOptions).map((option_0)=>({
                label: formatMessage((0, $1ad56976fd0f49f1$export$defe85febe8b728c)[option_0.labelKey]),
                value: option_0.labelKey,
                isSelected: option_0.labelKey === selectedOptionKey
            }));
        $[5] = formatMessage;
        $[6] = selectedOptionKey;
        $[7] = t4;
    } else t4 = $[7];
    const options = t4;
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage((0, $1ad56976fd0f49f1$export$defe85febe8b728c).sortOptionsLabel);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== handleSelectOption) {
        t6 = (value)=>value && handleSelectOption(value);
        $[10] = handleSelectOption;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            strategy: "fixed",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: false
                }
            ]
        };
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== field || $[14] !== formatMessage || $[15] !== order || $[16] !== selectedOptionKey) {
        t8 = (t9)=>{
            const { isOpen: isOpen, ...triggerProps } = t9;
            const isSelected = isOpen || field !== (0, $4XdCR.SORT_FIELD_KEY).LAST_MODIFIED_DATE || order !== (0, $4XdCR.SORT_ORDER).DESC;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ff944adaafb586c$export$fb46dd9777cc6db0), {
                isSelected: isSelected,
                otherProps: triggerProps,
                label: formatMessage((0, $1ad56976fd0f49f1$export$defe85febe8b728c)[(0, $4XdCR.RESULTS_SORT_FIELDS)[selectedOptionKey].selectedLabelKey]),
                filterOrControlId: "sort"
            });
        };
        $[13] = field;
        $[14] = formatMessage;
        $[15] = order;
        $[16] = selectedOptionKey;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== options || $[19] !== t5 || $[20] !== t6 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
            label: t5,
            blurInputOnSelect: false,
            tabSelectsValue: false,
            backspaceRemovesValue: false,
            hideSelectedOptions: false,
            controlShouldRenderValue: false,
            isClearable: false,
            maxMenuWidth: "22rem",
            maxMenuHeight: 400,
            menuPlacement: "bottom",
            isOptionSelected: $4ab1350f99bd7925$var$_temp,
            onChange: t6,
            options: options,
            popperProps: t7,
            target: t8
        });
        $[18] = options;
        $[19] = t5;
        $[20] = t6;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [{ order: order, field: field }, { setResultsSort: setResultsSort }] = (0, $2Va9o.useResultsSort)();
    const handleSelectOption = (option)=>{
        setResultsSort({
            order: (0, $4XdCR.RESULTS_SORT_FIELDS)[option.value].order,
            field: (0, $4XdCR.RESULTS_SORT_FIELDS)[option.value].field
        });
    };
    if (selectedProduct !== (0, $37AYo.ProductKeys).Confluence) return null;
    const selectedOptionKey = (0, $4XdCR.getOptionKey)(field, order);
    const options = (0, $4XdCR.ResultsSortOptions).map((option_0)=>({
            label: formatMessage((0, $1ad56976fd0f49f1$export$defe85febe8b728c)[option_0.labelKey]),
            value: option_0.labelKey,
            isSelected: option_0.labelKey === selectedOptionKey
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
        label: formatMessage((0, $1ad56976fd0f49f1$export$defe85febe8b728c).sortOptionsLabel),
        blurInputOnSelect: false,
        tabSelectsValue: false,
        backspaceRemovesValue: false,
        hideSelectedOptions: false,
        controlShouldRenderValue: false,
        isClearable: false,
        maxMenuWidth: "22rem",
        maxMenuHeight: 400,
        menuPlacement: "bottom",
        isOptionSelected: (option_1)=>option_1.isSelected,
        onChange: (value)=>value && handleSelectOption(value),
        options: options,
        popperProps: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ]
        },
        target: ({ isOpen: isOpen, ...triggerProps })=>{
            const isSelected = isOpen || field !== (0, $4XdCR.SORT_FIELD_KEY).LAST_MODIFIED_DATE || order !== (0, $4XdCR.SORT_ORDER).DESC;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ff944adaafb586c$export$fb46dd9777cc6db0), {
                isSelected: isSelected,
                otherProps: triggerProps,
                label: formatMessage((0, $1ad56976fd0f49f1$export$defe85febe8b728c)[(0, $4XdCR.RESULTS_SORT_FIELDS)[selectedOptionKey].selectedLabelKey]),
                filterOrControlId: 'sort'
            });
        }
    });
};
function $4ab1350f99bd7925$var$_temp(option_1) {
    return option_1.isSelected;
}

























const $3b980a69db578211$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    space: {
        id: "dynamic-cards-search-page.filters.names.space",
        defaultMessage: "Space"
    },
    confluenceFilterSpacePlaceholder: {
        id: "dynamic-cards-search-page.confluence.filter.space.placeholder",
        defaultMessage: "Find spaces"
    },
    confluenceFilterLabelSelected: {
        id: "dynamic-cards-search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "dynamic-cards-search-page.confluence.filter.label.unselected",
        defaultMessage: "Suggested"
    }
});


const $95f45597f9e7f4f1$var$SpaceFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(31);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $lBu63.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [filterData, t1] = (0, $iueFH.useSelectFilter)(t0);
    const { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t1;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $3b980a69db578211$export$a7357cdd1f0b0168).confluenceFilterLabelSelected);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== selectedOptions || $[4] !== t2) {
        t3 = {
            label: t2,
            options: selectedOptions
        };
        $[3] = selectedOptions;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $3b980a69db578211$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== suggestedOptions || $[9] !== t4) {
        t5 = {
            label: t4,
            options: suggestedOptions
        };
        $[8] = suggestedOptions;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = [
            t3,
            t5
        ];
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const groupedOptions = t6;
    const t7 = isLookupActive ? options : groupedOptions;
    let t8;
    if ($[14] !== formatMessage) {
        t8 = formatMessage((0, $3b980a69db578211$export$a7357cdd1f0b0168).space);
        $[14] = formatMessage;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== formatMessage) {
        t9 = formatMessage((0, $3b980a69db578211$export$a7357cdd1f0b0168).confluenceFilterSpacePlaceholder);
        $[16] = formatMessage;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== clearLookupInput || $[19] !== clearOptions || $[20] !== isLoading || $[21] !== isLookupDefined || $[22] !== loadInitialOptions || $[23] !== lookupInput || $[24] !== selectedOptions || $[25] !== setLookupInput || $[26] !== setOption || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
            canClearFilter: true,
            checkboxIndicators: true,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSearchInputChange: setLookupInput,
            onSelectChange: setOption,
            options: t7,
            selectedOptions: selectedOptions,
            label: t8,
            placeholder: t9,
            filterOrControlId: "space",
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            formatOptionLabel: (0, $75445f2e61bf27fb$export$aaa1dc33930567f9),
            onClearOptions: clearOptions
        });
        $[18] = clearLookupInput;
        $[19] = clearOptions;
        $[20] = isLoading;
        $[21] = isLookupDefined;
        $[22] = loadInitialOptions;
        $[23] = lookupInput;
        $[24] = selectedOptions;
        $[25] = setLookupInput;
        $[26] = setOption;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $iueFH.useSelectFilter)({
        filterId: (0, $lBu63.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $3b980a69db578211$export$a7357cdd1f0b0168).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $3b980a69db578211$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $3b980a69db578211$export$a7357cdd1f0b0168).space),
        placeholder: formatMessage((0, $3b980a69db578211$export$a7357cdd1f0b0168).confluenceFilterSpacePlaceholder),
        filterOrControlId: 'space',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $75445f2e61bf27fb$export$aaa1dc33930567f9),
        onClearOptions: clearOptions
    });
};
var $95f45597f9e7f4f1$export$2e2bcd8739ae039 = $95f45597f9e7f4f1$var$SpaceFilter;
























var $2uDbg = parcelRequire("2uDbg");






const $9ec77ad7cac7f1e7$var$containerStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.150',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    boxSizing: 'border-box',
    borderRadius: 'radius.small',
    maxWidth: '280px' // matches filter button
});
const $9ec77ad7cac7f1e7$var$backgroundStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $9ec77ad7cac7f1e7$var$containerCheckedStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.selected'
});
const $9ec77ad7cac7f1e7$var$labelStyles = (0, $buxP3.xcss)({
    fontWeight: 'font.weight.medium'
});
const $9ec77ad7cac7f1e7$var$labelActiveStyle = (0, $buxP3.xcss)({
    color: 'color.text.selected'
});
const $9ec77ad7cac7f1e7$export$2e955e9ca7bb51ef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { children: children, onChange: onChange, isChecked: isChecked, autoFocus: t1, isFilterInDropdown: t2 } = t0;
    const autoFocus = t1 === undefined ? false : t1;
    const isFilterInDropdown = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== isChecked || $[1] !== isFilterInDropdown) {
        t3 = [
            $9ec77ad7cac7f1e7$var$containerStyles,
            ...!isFilterInDropdown ? [
                $9ec77ad7cac7f1e7$var$backgroundStyles,
                isChecked && $9ec77ad7cac7f1e7$var$containerCheckedStyles
            ] : []
        ];
        $[0] = isChecked;
        $[1] = isFilterInDropdown;
        $[2] = t3;
    } else t3 = $[2];
    const t4 = isChecked && $9ec77ad7cac7f1e7$var$labelActiveStyle;
    let t5;
    if ($[3] !== t4) {
        t5 = [
            $9ec77ad7cac7f1e7$var$labelStyles,
            t4
        ];
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== children || $[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t5
        }, children);
        $[5] = children;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== autoFocus || $[9] !== isChecked || $[10] !== onChange || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: t6,
            onChange: onChange,
            isChecked: isChecked,
            autoFocus: autoFocus
        });
        $[8] = autoFocus;
        $[9] = isChecked;
        $[10] = onChange;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t3 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t3
        }, t7);
        $[13] = t3;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ({ children: children, onChange: onChange, isChecked: isChecked, autoFocus: autoFocus = false, isFilterInDropdown: isFilterInDropdown = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $9ec77ad7cac7f1e7$var$containerStyles,
            ...!isFilterInDropdown ? [
                $9ec77ad7cac7f1e7$var$backgroundStyles,
                isChecked && $9ec77ad7cac7f1e7$var$containerCheckedStyles
            ] : []
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $9ec77ad7cac7f1e7$var$labelStyles,
                isChecked && $9ec77ad7cac7f1e7$var$labelActiveStyle
            ]
        }, children),
        onChange: onChange,
        isChecked: isChecked,
        autoFocus: autoFocus
    }));
};



var $2Pix2 = parcelRequire("2Pix2");







const $71ab62d0a8663f06$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    onlyTitleMatch: {
        id: "dynamic-cards-search-page.filters.names.titleMatchOnly",
        defaultMessage: "Title match"
    }
});


const $9b412b36af3b0b3b$var$TitleMatchOnlyFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { isFilterInDropdown: t1 } = t0;
    const isFilterInDropdown = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            filterId: (0, $cqf3V.filter).id
        };
        $[0] = t2;
    } else t2 = $[0];
    const [state, t3] = (0, $2Pix2.useBooleanFilter)(t2);
    const { toggle: toggle } = t3;
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    let t4;
    if ($[1] !== formatMessage) {
        t4 = formatMessage((0, $71ab62d0a8663f06$export$a7357cdd1f0b0168).onlyTitleMatch);
        $[1] = formatMessage;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== autoFocus || $[4] !== isFilterInDropdown || $[5] !== t4 || $[6] !== toggle || $[7] !== value) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ec77ad7cac7f1e7$export$2e955e9ca7bb51ef), {
            onChange: toggle,
            isChecked: value,
            autoFocus: autoFocus,
            isFilterInDropdown: isFilterInDropdown
        }, t4);
        $[3] = autoFocus;
        $[4] = isFilterInDropdown;
        $[5] = t4;
        $[6] = toggle;
        $[7] = value;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ isFilterInDropdown: isFilterInDropdown = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [state, { toggle: toggle }] = (0, $2Pix2.useBooleanFilter)({
        filterId: (0, $cqf3V.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ec77ad7cac7f1e7$export$2e955e9ca7bb51ef), {
        onChange: toggle,
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown
    }, formatMessage((0, $71ab62d0a8663f06$export$a7357cdd1f0b0168).onlyTitleMatch));
};
var $9b412b36af3b0b3b$export$2e2bcd8739ae039 = $9b412b36af3b0b3b$var$TitleMatchOnlyFilter;






















var $jpB6G = parcelRequire("jpB6G");










const $878042468b086226$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    type: {
        id: "dynamic-cards-search-page.filters.names.type",
        defaultMessage: "Type"
    },
    filterTypePlaceholder: {
        id: "dynamic-cards-search-page.filter.type.placeholder",
        defaultMessage: "Find type"
    }
});


const $ea9858919c3c2574$var$getOptionsToProducts = (typeMapping)=>{
    const optionsToProducts = {};
    (0, $lCzjG.allTypeFilterValueKeys).forEach((type)=>{
        optionsToProducts[type] = typeMapping[type].products || [];
    });
    return optionsToProducts;
};
const $ea9858919c3c2574$var$TypeFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(17);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        const typeMapping = (0, $jpB6G.getTypeMapping)();
        t0 = $ea9858919c3c2574$var$getOptionsToProducts(typeMapping);
        $[0] = t0;
    } else t0 = $[0];
    const optionsToProducts = t0;
    const [productSelected] = (0, $2Va9o.useSelectedProduct)();
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            filterId: (0, $lCzjG.universalTypeFilterId),
            optionsToProducts: optionsToProducts
        };
        $[1] = t1;
    } else t1 = $[1];
    const [filterData, t2] = (0, $iueFH.useUniversalSelectFilter)(t1);
    const { setOption: setOption, loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t2;
    if (!filterData) return null;
    if (productSelected === (0, $37AYo.ProductKeys).Atlas) return null;
    const { options: options, lookupInput: lookupInput, selectedOptions: selectedOptions } = filterData;
    let t3;
    if ($[2] !== formatMessage) {
        t3 = formatMessage((0, $878042468b086226$export$a7357cdd1f0b0168).type);
        $[2] = formatMessage;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== formatMessage) {
        t4 = formatMessage((0, $878042468b086226$export$a7357cdd1f0b0168).filterTypePlaceholder);
        $[4] = formatMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== clearLookupInput || $[7] !== clearOptions || $[8] !== loadInitialOptions || $[9] !== lookupInput || $[10] !== options || $[11] !== selectedOptions || $[12] !== setLookupInput || $[13] !== setOption || $[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSelectChange: setOption,
            options: options,
            selectedOptions: selectedOptions,
            label: t3,
            placeholder: t4,
            filterOrControlId: (0, $lCzjG.universalTypeFilterId),
            searchInput: lookupInput,
            onSearchInputChange: setLookupInput,
            isSearchable: true,
            onClearOptions: clearOptions,
            testId: "universal-type-filter"
        });
        $[6] = clearLookupInput;
        $[7] = clearOptions;
        $[8] = loadInitialOptions;
        $[9] = lookupInput;
        $[10] = options;
        $[11] = selectedOptions;
        $[12] = setLookupInput;
        $[13] = setOption;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const typeMapping = (0, $jpB6G.getTypeMapping)();
    const optionsToProducts = $ea9858919c3c2574$var$getOptionsToProducts(typeMapping);
    const [productSelected] = (0, $2Va9o.useSelectedProduct)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $iueFH.useUniversalSelectFilter)({
        filterId: (0, $lCzjG.universalTypeFilterId),
        optionsToProducts: optionsToProducts
    });
    if (!filterData) return null;
    // Do not show TypeFilter for Atlas since that is handled by Noun filters
    if (productSelected === (0, $37AYo.ProductKeys).Atlas) return null;
    const { options: options, lookupInput: lookupInput, selectedOptions: selectedOptions } = filterData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2237e2073a9152$export$2e2bcd8739ae039), {
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSelectChange: setOption,
        options: options,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $878042468b086226$export$a7357cdd1f0b0168).type),
        placeholder: formatMessage((0, $878042468b086226$export$a7357cdd1f0b0168).filterTypePlaceholder),
        filterOrControlId: (0, $lCzjG.universalTypeFilterId),
        searchInput: lookupInput,
        onSearchInputChange: setLookupInput,
        isSearchable: true,
        onClearOptions: clearOptions,
        testId: "universal-type-filter"
    });
};
var $ea9858919c3c2574$export$2e2bcd8739ae039 = $ea9858919c3c2574$var$TypeFilter;

































const $739802f5e5c88323$var$baseStyles = (0, $buxP3.xcss)({
    height: '32px',
    paddingInline: 'space.150',
    width: '100%',
    borderRadius: 'radius.small',
    color: 'color.text',
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $739802f5e5c88323$var$selectedStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.accent.blue',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $739802f5e5c88323$var$buttonWrapperStyles = (0, $buxP3.xcss)({
    maxWidth: '280px' // matches dropdown of 312px (and padding)
});
const $739802f5e5c88323$var$textStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    font: 'font.body',
    fontWeight: 'font.weight.medium'
});
const $739802f5e5c88323$var$PressableToggleFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { icon: icon, label: label, onClick: onClick, isSelected: isSelected, autoFocus: autoFocus } = t0;
    const t1 = isSelected && $739802f5e5c88323$var$selectedStyles;
    let t2;
    if ($[0] !== t1) {
        t2 = [
            $739802f5e5c88323$var$baseStyles,
            t1
        ];
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== icon) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            alignBlock: "center",
            alignInline: "center"
        }, icon);
        $[2] = icon;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== label || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            alignBlock: "center",
            alignInline: "start",
            xcss: $739802f5e5c88323$var$textStyles,
            space: "space.100"
        }, t3, label);
        $[4] = label;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== autoFocus || $[8] !== onClick || $[9] !== t2 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $739802f5e5c88323$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            onClick: onClick,
            autoFocus: autoFocus,
            xcss: t2
        }, t4));
        $[7] = autoFocus;
        $[8] = onClick;
        $[9] = t2;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ icon: icon, label: label, onClick: onClick, isSelected: isSelected, autoFocus: autoFocus })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $739802f5e5c88323$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        onClick: onClick,
        autoFocus: autoFocus,
        xcss: [
            $739802f5e5c88323$var$baseStyles,
            isSelected && $739802f5e5c88323$var$selectedStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        alignInline: "start",
        xcss: $739802f5e5c88323$var$textStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        alignInline: "center"
    }, icon), label)));
};
var $739802f5e5c88323$export$2e2bcd8739ae039 = $739802f5e5c88323$var$PressableToggleFilter;











const $a9c7afc92b2e0056$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    verified: {
        id: "dynamic-cards-search-page.filters.names.verified",
        defaultMessage: "Verified"
    }
});


const $e30755d381a97954$var$VerifiedFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $5EzaL.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [state, t1] = (0, $2Pix2.useBooleanFilter)(t0);
    const { toggle: toggle } = t1;
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    let t2;
    if ($[1] !== value) {
        t2 = (0, $ad603b57dbb5d1f1$export$16b26cd5e98d9100)({
            filterOrControlId: (0, $5EzaL.filter).id,
            isSelected: value
        });
        $[1] = value;
        $[2] = t2;
    } else t2 = $[2];
    const buttonIcon = t2;
    let t3;
    if ($[3] !== formatMessage) {
        t3 = formatMessage((0, $a9c7afc92b2e0056$export$a7357cdd1f0b0168).verified);
        $[3] = formatMessage;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== autoFocus || $[6] !== buttonIcon || $[7] !== t3 || $[8] !== toggle || $[9] !== value) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $739802f5e5c88323$export$2e2bcd8739ae039), {
            icon: buttonIcon,
            label: t3,
            onClick: toggle,
            isSelected: value,
            autoFocus: autoFocus
        });
        $[5] = autoFocus;
        $[6] = buttonIcon;
        $[7] = t3;
        $[8] = toggle;
        $[9] = value;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [state, { toggle: toggle }] = (0, $2Pix2.useBooleanFilter)({
        filterId: (0, $5EzaL.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    const buttonIcon = (0, $ad603b57dbb5d1f1$export$16b26cd5e98d9100)({
        filterOrControlId: (0, $5EzaL.filter).id,
        isSelected: value
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $739802f5e5c88323$export$2e2bcd8739ae039), {
        icon: buttonIcon,
        label: formatMessage((0, $a9c7afc92b2e0056$export$a7357cdd1f0b0168).verified),
        onClick: toggle,
        isSelected: value,
        autoFocus: autoFocus
    });
};
var $e30755d381a97954$export$2e2bcd8739ae039 = $e30755d381a97954$var$VerifiedFilter;





const $154fa34ea1b9effd$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    title: {
        id: "dynamic-cards-search-page.filters.dropdown.title",
        defaultMessage: "Filter"
    },
    clearAll: {
        id: "dynamic-cards-search-page.filters.dropdown.clear-all",
        defaultMessage: "Clear all"
    }
});


const $5923c2dfe1969b25$var$dropdownContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.200',
    width: '312px'
});
const $5923c2dfe1969b25$var$filters = {
    [(0, $lCzjG.universalTypeFilterId)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea9858919c3c2574$export$2e2bcd8739ae039), {
        key: (0, $lCzjG.universalTypeFilterId)
    }),
    [(0, $bkXhB.filter).id]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0fdd2922a207f2ea$export$2e2bcd8739ae039), {
        key: (0, $bkXhB.filter).id
    }),
    [(0, $bPX0r.filter).id]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d960a81357422df$export$2e2bcd8739ae039), {
        key: (0, $bPX0r.filter).id
    }),
    [(0, $7ayyq.filter).id]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0dbae90f7e497bab$export$2e2bcd8739ae039), {
        key: (0, $7ayyq.filter).id
    }),
    [(0, $lBu63.filter).id]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95f45597f9e7f4f1$export$2e2bcd8739ae039), {
        key: (0, $lBu63.filter).id
    }),
    [(0, $ko90a.filter).id]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dbe28d9253b856e0$export$2e2bcd8739ae039), {
        key: (0, $ko90a.filter).id
    }),
    [(0, $10JkG.filter).id]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a555b534cdd219ee$export$2e2bcd8739ae039), {
        key: (0, $10JkG.filter).id
    }),
    [(0, $hYdYN.filter).id]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02138afe90418c8c$export$2e2bcd8739ae039), {
        key: (0, $hYdYN.filter).id
    }),
    [(0, $cqf3V.filter).id]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9b412b36af3b0b3b$export$2e2bcd8739ae039), {
        key: (0, $cqf3V.filter).id,
        isFilterInDropdown: true
    }),
    [(0, $5EzaL.filter).id]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e30755d381a97954$export$2e2bcd8739ae039), {
        key: (0, $5EzaL.filter).id
    }),
    [(0, $h4cPw.filter).id]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd1fbd1aa52151f3$export$2e2bcd8739ae039), {
        key: (0, $h4cPw.filter).id
    })
};
const $5923c2dfe1969b25$var$dividerStyles = (0, $buxP3.xcss)({
    borderBottomWidth: 'border.width',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTop: 0
});
const $5923c2dfe1969b25$var$DropdownFilter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(22);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [t0] = (0, $2Va9o.useSelectedFilterCount)();
    const { selectedFilterCount: selectedFilterCount } = t0;
    const [t1] = (0, $2Va9o.useFiltersToDisplay)();
    const { filtersInDropdown: filtersInDropdown } = t1;
    const { clearAllAvailableFilters: clearAllAvailableFilters } = (0, $2Va9o.useSearchActions)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const isConfluence = selectedProduct === (0, $37AYo.ProductKeys).Confluence;
    let t2;
    if ($[0] !== formatMessage || $[1] !== selectedFilterCount) {
        t2 = (t3)=>{
            const { triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ff944adaafb586c$export$fb46dd9777cc6db0), {
                otherProps: {
                    ...providedProps,
                    ref: triggerRef
                },
                isSelected: selectedFilterCount > 0,
                filterOrControlId: "dropdown",
                label: formatMessage((0, $154fa34ea1b9effd$export$a7357cdd1f0b0168).title),
                selectionBadge: selectedFilterCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), {
                    appearance: "informationBold"
                }, selectedFilterCount) : null
            });
        };
        $[0] = formatMessage;
        $[1] = selectedFilterCount;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== filtersInDropdown) {
        t3 = filtersInDropdown.map($5923c2dfe1969b25$var$_temp);
        $[3] = filtersInDropdown;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isConfluence) {
        t4 = isConfluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ab1350f99bd7925$export$66a8c50d62eea7ce), null);
        $[5] = isConfluence;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            space: "space.200"
        }, t3, t4);
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            as: "div",
            xcss: $5923c2dfe1969b25$var$dividerStyles
        });
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== formatMessage) {
        t7 = formatMessage((0, $154fa34ea1b9effd$export$a7357cdd1f0b0168).clearAll);
        $[11] = formatMessage;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== clearAllAvailableFilters || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: clearAllAvailableFilters
        }, t7));
        $[13] = clearAllAvailableFilters;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t5 || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            xcss: $5923c2dfe1969b25$var$dropdownContainerStyles,
            space: "space.200"
        }, t5, t6, t8);
        $[16] = t5;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== t2 || $[20] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            trigger: t2
        }, t9);
        $[19] = t2;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    return t10;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [{ selectedFilterCount: selectedFilterCount }] = (0, $2Va9o.useSelectedFilterCount)();
    const [{ filtersInDropdown: filtersInDropdown }] = (0, $2Va9o.useFiltersToDisplay)();
    const { clearAllAvailableFilters: clearAllAvailableFilters } = (0, $2Va9o.useSearchActions)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const isConfluence = selectedProduct === (0, $37AYo.ProductKeys).Confluence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ff944adaafb586c$export$fb46dd9777cc6db0), {
                otherProps: {
                    ...providedProps,
                    ref: triggerRef
                },
                isSelected: selectedFilterCount > 0,
                filterOrControlId: "dropdown",
                label: formatMessage((0, $154fa34ea1b9effd$export$a7357cdd1f0b0168).title),
                selectionBadge: selectedFilterCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), {
                    appearance: "informationBold"
                }, selectedFilterCount) : null
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        xcss: $5923c2dfe1969b25$var$dropdownContainerStyles,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.200"
    }, filtersInDropdown.map((filterId)=>{
        // TODO: remove the typecast here
        // (was added so that product type filters didn't have to be included in the filters object)
        return $5923c2dfe1969b25$var$filters[filterId];
    }), isConfluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ab1350f99bd7925$export$66a8c50d62eea7ce), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        as: "div",
        xcss: $5923c2dfe1969b25$var$dividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: clearAllAvailableFilters
    }, formatMessage((0, $154fa34ea1b9effd$export$a7357cdd1f0b0168).clearAll)))));
};
var $5923c2dfe1969b25$export$2e2bcd8739ae039 = $5923c2dfe1969b25$var$DropdownFilter;
function $5923c2dfe1969b25$var$_temp(filterId) {
    return $5923c2dfe1969b25$var$filters[filterId];
}











const $c3a7cda21919a9a1$var$filters = {
    [(0, $bkXhB.filter).id]: (0, $0fdd2922a207f2ea$export$2e2bcd8739ae039),
    [(0, $lCzjG.universalTypeFilterId)]: (0, $ea9858919c3c2574$export$2e2bcd8739ae039),
    [(0, $bPX0r.filter).id]: (0, $1d960a81357422df$export$2e2bcd8739ae039),
    [(0, $lBu63.filter).id]: (0, $95f45597f9e7f4f1$export$2e2bcd8739ae039),
    [(0, $5EzaL.filter).id]: (0, $e30755d381a97954$export$2e2bcd8739ae039),
    [(0, $ko90a.filter).id]: (0, $dbe28d9253b856e0$export$2e2bcd8739ae039),
    [(0, $10JkG.filter).id]: (0, $a555b534cdd219ee$export$2e2bcd8739ae039),
    [(0, $hYdYN.filter).id]: (0, $02138afe90418c8c$export$2e2bcd8739ae039),
    [(0, $cqf3V.filter).id]: (0, $9b412b36af3b0b3b$export$2e2bcd8739ae039),
    [(0, $7ayyq.filter).id]: (0, $0dbae90f7e497bab$export$2e2bcd8739ae039),
    [(0, $h4cPw.filter).id]: (0, $bd1fbd1aa52151f3$export$2e2bcd8739ae039)
};
const $c3a7cda21919a9a1$var$useOverflowFilterObserver = (0, $gtMdU.isReactCompilerActivePlatform)() ? (containerRef, filterRefs, filterIds)=>{
    const $ = (0, $bDgLe.c)(8);
    const observerRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== containerRef) {
        t0 = ()=>{
            const observer = new IntersectionObserver($c3a7cda21919a9a1$var$_temp2, {
                root: containerRef.current,
                threshold: 0.85
            });
            observerRef.current = observer;
            return ()=>{
                observer.disconnect();
            };
        };
        t1 = [
            containerRef
        ];
        $[0] = containerRef;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== filterRefs) {
        t2 = ()=>{
            const observer_0 = observerRef.current;
            if (!observer_0) return;
            filterRefs.current.forEach((filterRef)=>{
                observer_0.observe(filterRef?.current);
            });
        };
        $[3] = filterRefs;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== filterIds || $[6] !== filterRefs) {
        t3 = [
            filterRefs,
            filterIds
        ];
        $[5] = filterIds;
        $[6] = filterRefs;
        $[7] = t3;
    } else t3 = $[7];
    (0, $cozmU.useEffect)(t2, t3);
} : (containerRef, filterRefs, filterIds)=>{
    const observerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const target = entry.target;
                if (entry.isIntersecting) target.style.visibility = 'visible';
                else target.style.visibility = 'hidden';
            });
        }, {
            root: containerRef.current,
            threshold: 0.85
        });
        observerRef.current = observer;
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        const observer_0 = observerRef.current;
        if (!observer_0) return;
        filterRefs.current.forEach((filterRef)=>{
            observer_0.observe(filterRef?.current);
        });
    }, [
        filterRefs,
        filterIds
    ]);
};
const $c3a7cda21919a9a1$var$flexStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    flexWrap: 'wrap',
    padding: 'space.050'
});
const $c3a7cda21919a9a1$var$stackedStyles = (0, $buxP3.xcss)({
    maxWidth: '280px',
    padding: 'space.0'
});
const $c3a7cda21919a9a1$var$ProductFilters = ()=>{
    const [{ filtersInLine: filtersInLine }] = (0, $2Va9o.useFiltersToDisplay)();
    const [productSelected] = (0, $2Va9o.useSelectedProduct)();
    const filterContainerRef = (0, $cozmU.useRef)();
    const filterRefs = (0, $cozmU.useRef)([]);
    const isConfluence = productSelected === (0, $37AYo.ProductKeys).Confluence;
    filterRefs.current = filtersInLine.filter((id)=>$c3a7cda21919a9a1$var$filters[id]).map((_, i)=>filterRefs.current[i] ?? /*#__PURE__*/ (0, $cozmU.createRef)());
    $c3a7cda21919a9a1$var$useOverflowFilterObserver(filterContainerRef, filterRefs, filtersInLine);
    const renderInlineFilters = ()=>{
        return filtersInLine.map((id_0, index)=>{
            const Filter = $c3a7cda21919a9a1$var$filters[id_0];
            if (!Filter) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                key: id_0,
                ref: filterRefs.current[index]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Filter, null));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        ref: filterContainerRef,
        space: "space.100",
        xcss: $c3a7cda21919a9a1$var$flexStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5923c2dfe1969b25$export$2e2bcd8739ae039), null), renderInlineFilters(), isConfluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ab1350f99bd7925$export$66a8c50d62eea7ce), null));
};
var $c3a7cda21919a9a1$export$2e2bcd8739ae039 = $c3a7cda21919a9a1$var$ProductFilters;
const $c3a7cda21919a9a1$export$9f76702cd2492a41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { filtersToHide: filtersToHide } = t0;
    const [t1] = (0, $2Va9o.useFiltersToDisplay)();
    const { filtersInLine: filtersInLine } = t1;
    let t2;
    if ($[0] !== filtersInLine || $[1] !== filtersToHide) {
        t2 = ()=>filtersInLine.filter((id)=>!filtersToHide.includes(id)).map($c3a7cda21919a9a1$var$_temp3);
        $[0] = filtersInLine;
        $[1] = filtersToHide;
        $[2] = t2;
    } else t2 = $[2];
    const renderInlineFilters = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            $c3a7cda21919a9a1$var$flexStyles,
            $c3a7cda21919a9a1$var$stackedStyles
        ];
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== renderInlineFilters) {
        t4 = renderInlineFilters();
        $[4] = renderInlineFilters;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            space: "space.100",
            xcss: t3
        }, t4);
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ filtersToHide: filtersToHide })=>{
    const [{ filtersInLine: filtersInLine }] = (0, $2Va9o.useFiltersToDisplay)();
    const renderInlineFilters = ()=>{
        return filtersInLine.filter((id)=>!filtersToHide.includes(id)).map((id_0, index)=>{
            const Filter = $c3a7cda21919a9a1$var$filters[id_0];
            if (!Filter) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                key: id_0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Filter, null));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100",
        xcss: [
            $c3a7cda21919a9a1$var$flexStyles,
            $c3a7cda21919a9a1$var$stackedStyles
        ]
    }, renderInlineFilters());
};
function $c3a7cda21919a9a1$var$_temp(entry) {
    const target = entry.target;
    if (entry.isIntersecting) target.style.visibility = "visible";
    else target.style.visibility = "hidden";
}
function $c3a7cda21919a9a1$var$_temp2(entries) {
    entries.forEach($c3a7cda21919a9a1$var$_temp);
}
function $c3a7cda21919a9a1$var$_temp3(id_0, index) {
    const Filter = $c3a7cda21919a9a1$var$filters[id_0];
    if (!Filter) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        key: id_0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Filter, null));
}


const $1d98235a0e8ddb8b$export$92a576f896a9bf72 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [bootstrapLoading] = (0, $122441d1a555945e$export$f7c6299b3492081c)();
    if (bootstrapLoading) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ebe274384907606f$export$d5722e1c0b3e12f1), null);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3a7cda21919a9a1$export$2e2bcd8739ae039), null)));
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [bootstrapLoading] = (0, $122441d1a555945e$export$f7c6299b3492081c)();
    if (bootstrapLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ebe274384907606f$export$d5722e1c0b3e12f1), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3a7cda21919a9a1$export$2e2bcd8739ae039), null)));
};
const $1d98235a0e8ddb8b$var$FiltersWithErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d98235a0e8ddb8b$export$92a576f896a9bf72, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d98235a0e8ddb8b$export$92a576f896a9bf72, null));
};
var $1d98235a0e8ddb8b$export$2e2bcd8739ae039 = $1d98235a0e8ddb8b$var$FiltersWithErrorBoundary;
const $1d98235a0e8ddb8b$export$4f7c5f9bd9ac3227 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { filtersToHide: filtersToHide } = t0;
    const [bootstrapLoading] = (0, $122441d1a555945e$export$f7c6299b3492081c)();
    if (bootstrapLoading) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ebe274384907606f$export$d5722e1c0b3e12f1), null);
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    let t1;
    if ($[1] !== filtersToHide) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3a7cda21919a9a1$export$9f76702cd2492a41), {
            filtersToHide: filtersToHide
        });
        $[1] = filtersToHide;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ filtersToHide: filtersToHide })=>{
    const [bootstrapLoading] = (0, $122441d1a555945e$export$f7c6299b3492081c)();
    if (bootstrapLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ebe274384907606f$export$d5722e1c0b3e12f1), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3a7cda21919a9a1$export$9f76702cd2492a41), {
        filtersToHide: filtersToHide
    });
};












var $cbY7C = parcelRequire("cbY7C");


























const $3a2567ac224fb8e0$export$d4c72bab9d6cc13a = {
    showDropdown: false,
    dropdownLoading: true,
    prefetchedRecentViewsResults: undefined,
    prefetchedRecentSearchResults: [],
    peopleAndTeamsResults: {
        results: [],
        duration: -1
    },
    recentViewsResults: [],
    autoSuggestionResults: {
        results: [],
        duration: -1
    },
    quickSearchResults: [],
    recentSearchResults: [],
    resultCount: {
        peopleAndTeams: 0,
        autoSuggestion: 0,
        quickSearch: 0,
        recentSearch: 0,
        recentViews: 0
    },
    selectedInputFilters: []
};
const $3a2567ac224fb8e0$var$actions = {
    setShowDropdown: (showDropdown)=>({ setState: setState })=>{
            setState({
                showDropdown: showDropdown
            });
        },
    setDropdownLoading: (dropdownLoading)=>({ setState: setState })=>{
            setState({
                dropdownLoading: dropdownLoading
            });
        },
    setPeopleAndTeamsResults: (peopleAndTeamsResults)=>({ setState: setState })=>{
            setState({
                peopleAndTeamsResults: peopleAndTeamsResults
            });
        },
    setRecentViewsResults: (recentViewsResults)=>({ setState: setState })=>{
            setState({
                recentViewsResults: recentViewsResults
            });
        },
    setAutoSuggestionResults: (autoSuggestionResults)=>({ setState: setState })=>{
            setState({
                autoSuggestionResults: autoSuggestionResults
            });
        },
    setRecentSearchResults: (recentSearchResults)=>({ setState: setState })=>{
            setState({
                recentSearchResults: recentSearchResults
            });
        },
    setQuickSearchResults: (quickSearchResults)=>({ setState: setState })=>{
            setState({
                quickSearchResults: quickSearchResults
            });
        },
    setResultCount: (resultCount)=>({ setState: setState })=>{
            setState({
                resultCount: resultCount
            });
        },
    setPrefetchedRecentViewsResults: (prefetchedRecentViewsResults)=>({ setState: setState })=>{
            setState({
                prefetchedRecentViewsResults: prefetchedRecentViewsResults
            });
        },
    setPrefetchedRecentSearchResults: (prefetchedRecentSearchResults)=>({ setState: setState })=>{
            setState({
                prefetchedRecentSearchResults: prefetchedRecentSearchResults
            });
        },
    setSelectedInputFilters: (selectedInputFilters)=>({ setState: setState })=>{
            setState({
                selectedInputFilters: selectedInputFilters
            });
        }
};
const $3a2567ac224fb8e0$export$1d29bcde96a75168 = (0, $j8on0.createContainer)();
// Keep store private and use hooks to access state and actions
const $3a2567ac224fb8e0$var$Store = (0, $8s9DV.createStore)({
    containedBy: $3a2567ac224fb8e0$export$1d29bcde96a75168,
    initialState: $3a2567ac224fb8e0$export$d4c72bab9d6cc13a,
    actions: $3a2567ac224fb8e0$var$actions,
    name: 'dynamic-cards-dropdown'
});
const $3a2567ac224fb8e0$export$4e8b5ffe8cfc8886 = (0, $kBr4q.createActionsHook)($3a2567ac224fb8e0$var$Store);
const $3a2567ac224fb8e0$export$8c32fdb3462273b4 = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.showDropdown
});
const $3a2567ac224fb8e0$export$41ba39ed718e7414 = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.dropdownLoading
});
const $3a2567ac224fb8e0$export$c30c238644aa02ee = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.peopleAndTeamsResults
});
const $3a2567ac224fb8e0$export$f53e0f96bec5ea4d = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.recentViewsResults
});
const $3a2567ac224fb8e0$export$30ecbc19a2297251 = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.autoSuggestionResults
});
const $3a2567ac224fb8e0$export$970bfa0ee111b06 = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.recentSearchResults
});
const $3a2567ac224fb8e0$export$369bf1e7413c2c02 = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.quickSearchResults
});
const $3a2567ac224fb8e0$export$22da568447791223 = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.resultCount
});
const $3a2567ac224fb8e0$export$a7f7068aa342db89 = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.prefetchedRecentViewsResults
});
const $3a2567ac224fb8e0$export$8fdf7942b5f23117 = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.prefetchedRecentSearchResults
});
const $3a2567ac224fb8e0$export$5a795cafef59146c = (0, $kBr4q.createHook)($3a2567ac224fb8e0$var$Store, {
    selector: (state)=>state.selectedInputFilters
});






const $7467e526334959ee$export$ec4722d39a5031c0 = 'atlassian.unified-search.recent-searches';
const $7467e526334959ee$export$c1b7badf23670c19 = 50;
const $7467e526334959ee$export$74e99d9695eabee6 = (value, userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $7467e526334959ee$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId]) recentSearches[userId] = {};
    let userSearches = recentSearches[userId];
    if (!userSearches[product]) userSearches[product] = [];
    let productSearches = userSearches[product];
    const trimmedValue = value.trim();
    // Pop the last value of the array if it is too long
    if (productSearches.length === $7467e526334959ee$export$c1b7badf23670c19) productSearches.pop();
    // If the given value is a duplicate, remove it from the array
    if (productSearches.includes(trimmedValue)) productSearches = productSearches.filter((v)=>v !== trimmedValue);
    productSearches.unshift(trimmedValue);
    recentSearches[userId][product] = productSearches;
    $7467e526334959ee$var$setLocalStorageItem(recentSearchKey, JSON.stringify(recentSearches));
};
const $7467e526334959ee$export$1216255791599668 = (userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $7467e526334959ee$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    const userSearches = recentSearches[userId] || {};
    return userSearches[product] || [];
};
const $7467e526334959ee$export$6adb2cc1366d1e30 = (value, userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $7467e526334959ee$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId] || !recentSearches[userId][product]) return [];
    recentSearches[userId][product] = recentSearches[userId][product].filter((v)=>v !== value);
    $7467e526334959ee$var$setLocalStorageItem(recentSearchKey, JSON.stringify(recentSearches));
    return recentSearches[userId][product];
};
const $7467e526334959ee$var$setLocalStorageItem = (key, value)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    window.localStorage.setItem(key, value);
};
const $7467e526334959ee$var$getLocalStorageItem = (key)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    return window.localStorage.getItem(key);
};


// Modified from platform/packages/search/product-search-dialog/src/extensible/product-router/product/result-provider/faster-search-helpers.ts
/**
 * Breakdown of the filtering & ordering logic :
 *
 * 0th pass: if the string has any highlight tags, remove them and continue
 * An alternate could be to exit early, but then we don't have the scoring information from the later passes
 *
 * 1st Pass - Complete match of query broken by words - This checks that all the words of the query must occur somewhere in the Title.
 *    - This is case insensitive.
 *    - This is unordered.
 *    For eg -
 *    Query - "mad max" will NOT let "Nomad" or "Climax" pass through,
 *    but  "Nomad Climax", "Madmax", "max Mad" will pass through
 *
 * 2nd Pass Scoring - Score calculation based on the kind of matches.
 *    There are 3 types - Exact match, StartsWith match & Partial match
 *    For eg -
 *    Exact Match (Score = 100) - Query: "Mad" will score "mad", "mad max" with 100.
 *            Note: Special characters stripped -  "Mad" will score "mad-max", "max-mad" with 100.
 *    StartsWith Match (Score = 10) - Query: "ark" will score "ARKK" and "Arkose Meeting" as 10
 *    Partial Match (Score = 1) - Query: "mad max" will score "Nomad Climax" as 2
 *
 *    Mix of multiple matching scenarios is possible.
 *    For example - "mad max" query will score "Mad Climax" as 100 (Exact) + 1 (Partial) = 101
 *
 * 3rd Pass - Sorting & Highlighting
 *    Sorting happens in the descending order of the score.
 *    Highlighting will match the entered query and inject necessary tags.
 *    Note: if both StartsWith and Partial matching exists in the same word then only StartsWith is highlighted
 *
 *    Two new properties are populated:
 *    1. highlightedText - highlights the query
 *    2. negatedHighlightedText - highights everything except the part that matches the query
 */ const $d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $d1c1d51b23ca3f0a$var$SPECIAL_CHARACTER_REGEX = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
const $d1c1d51b23ca3f0a$var$CONSECUTIVE_START_REGEX = new RegExp(`${$d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG}${$d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG}`, 'g');
const $d1c1d51b23ca3f0a$var$CONSECUTIVE_END_REGEX = new RegExp(`${$d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG}${$d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG}`, 'g');
const $d1c1d51b23ca3f0a$var$CONSECUTIVE_START_END_REGEX = new RegExp(`${$d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG}${$d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG}`, 'g');
const $d1c1d51b23ca3f0a$var$ESCAPE_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;
const $d1c1d51b23ca3f0a$var$cleanStartRegex = new RegExp($d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG, 'g');
const $d1c1d51b23ca3f0a$var$cleanEndRegex = new RegExp($d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG, 'g');
const $d1c1d51b23ca3f0a$export$9f4c92a576b56d82 = (source, matchWords)=>{
    // Remove any previous highlighting and regenerate
    // Supports the use case where we perform this on the frontend, and later the backend starts doing it for us first
    const cleanedSource = source.replace($d1c1d51b23ca3f0a$var$cleanStartRegex, '').replace($d1c1d51b23ca3f0a$var$cleanEndRegex, '');
    const lowerCaseMatchWords = matchWords.filter((word)=>word !== '').map((word)=>word.toLowerCase());
    const wordsDetails = cleanedSource.split(' ').map((word)=>{
        const lowerCaseWord = word.toLowerCase();
        const alphabetOnlyWord = lowerCaseWord.replace($d1c1d51b23ca3f0a$var$SPECIAL_CHARACTER_REGEX, ' ').split(' ');
        let partialCount = 0;
        let startsWithCount = 0;
        let exactMatchCount = 0;
        let exactMatch = '';
        let partialMatch = '';
        let startsWithMatch = '';
        for(let i = 0; i < lowerCaseMatchWords.length; ++i){
            if (lowerCaseWord === lowerCaseMatchWords[i] || alphabetOnlyWord.includes(lowerCaseMatchWords[i])) {
                exactMatchCount++;
                exactMatch = lowerCaseMatchWords[i];
                break;
            }
            if (lowerCaseWord.startsWith(lowerCaseMatchWords[i])) {
                startsWithCount++;
                startsWithMatch = lowerCaseMatchWords[i];
                continue;
            }
            if (lowerCaseWord.includes(lowerCaseMatchWords[i])) {
                partialCount++;
                partialMatch = lowerCaseMatchWords[i];
            }
        }
        const score = 100 * exactMatchCount + 10 * startsWithCount + partialCount;
        if (exactMatchCount > 0 || startsWithCount > 0 || partialCount > 0) {
            const pattern = exactMatchCount > 0 ? exactMatch : startsWithCount > 0 ? startsWithMatch : partialMatch;
            const regExp = new RegExp(`(${pattern.replace($d1c1d51b23ca3f0a$var$ESCAPE_SPECIAL_CHARACTERS, '\\$&')})`, 'ig');
            const openingClosingRegExp = new RegExp(`(${$d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG}|${$d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG})`, 'ig');
            const highlighted = word.replace(regExp, `${$d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG}$1${$d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG}`).replace($d1c1d51b23ca3f0a$var$CONSECUTIVE_START_END_REGEX, ``);
            const mirror = {
                [`${$d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG}`]: `${$d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG}`,
                [`${$d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG}`]: `${$d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG}`
            };
            const mirroredHighlighted = highlighted.replace(openingClosingRegExp, (ch)=>mirror[ch]);
            const negatedHighlight = `${$d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG}${mirroredHighlighted}${$d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG}`.replace($d1c1d51b23ca3f0a$var$CONSECUTIVE_START_REGEX, `${$d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG}`).replace($d1c1d51b23ca3f0a$var$CONSECUTIVE_END_REGEX, `${$d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG}`).replace($d1c1d51b23ca3f0a$var$CONSECUTIVE_START_END_REGEX, '');
            return {
                highlighted: highlighted,
                negatedHighlight: negatedHighlight,
                score: score
            };
        }
        // no match scenario
        return {
            negatedHighlight: `${$d1c1d51b23ca3f0a$var$HIGHLIGHT_START_TAG}${word}${$d1c1d51b23ca3f0a$var$HIGHLIGHT_END_TAG}`,
            highlighted: word,
            score: score
        };
    });
    const highlightedTitle = wordsDetails.map((wordObj)=>wordObj.highlighted).join(' ');
    const negatedHighlightedTitle = wordsDetails.map((wordObj)=>wordObj.negatedHighlight).join(' ');
    const finalScore = wordsDetails.reduce((acc, word)=>acc + word.score, 0);
    if (highlightedTitle !== '' && highlightedTitle !== cleanedSource) return {
        highlightedTitle: highlightedTitle,
        negatedHighlightedTitle: negatedHighlightedTitle,
        score: finalScore
    };
    return {};
};


function $0e68c99e68a0931d$export$18f3758fc3685a84(searchResults, query, numberOfResultItems = 3, negateTitleHighlight) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result,
                    highlightedTitle: negateTitleHighlight ? negatedHighlightedTitle : highlightedTitle
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0).slice(0, numberOfResultItems);
    return filteredResults;
}


const $546b537d8b10f575$export$7a283d45f414521b = (primaryProduct, userId)=>{
    if (userId && primaryProduct) {
        const recentSearches = (0, $7467e526334959ee$export$1216255791599668)(userId, primaryProduct, (0, $7467e526334959ee$export$ec4722d39a5031c0)).map((searchTitle)=>({
                title: searchTitle,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
                onClick: ()=>null
            }));
        return recentSearches;
    }
    return [];
};
const $546b537d8b10f575$export$9770ca05e8d4f1fe = (recentSearches, inputQuery)=>{
    if (inputQuery.length === 0) return recentSearches;
    return (0, $0e68c99e68a0931d$export$18f3758fc3685a84)(recentSearches, inputQuery, inputQuery.length < 3 ? 3 : 2, true);
};



var $jR2a0 = parcelRequire("jR2a0");

const $f79bfdfe882aad1c$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    title
    pageStatus: status
    subtype
    ancestors {
      __typename
      id
      title
    }
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $f79bfdfe882aad1c$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    title
    blogStatus: status
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $f79bfdfe882aad1c$var$ConfluenceWhiteboardFragment = `
  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $f79bfdfe882aad1c$var$AtlasProjectFragment = `
  fragment AtlasProjectFragment on TownsquareProject {
    __typename
    key
    name
    url
    iconData
  }
`;
const $f79bfdfe882aad1c$var$AtlasGoalFragment = `
  fragment AtlasGoalFragment on TownsquareGoal {
    __typename
    key
    name
    url
    iconData
  }
`;
const $f79bfdfe882aad1c$var$JiraSingleIssueLineTextFieldFragment = `
  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {
    text
  }
`;
const $f79bfdfe882aad1c$var$JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    key
    webUrl
    fieldsById(ids: ["summary"]) {
      edges {
        node {
          __typename
          ...JiraSingleIssueLineTextFieldFragment
        }
      }
    }
  }
  ${$f79bfdfe882aad1c$var$JiraSingleIssueLineTextFieldFragment}
`;
const $f79bfdfe882aad1c$export$5db520940cf00715 = 'QuickFindActivitiesQuery';
const $f79bfdfe882aad1c$export$8a781e50bcd90a75 = `
  query ${$f79bfdfe882aad1c$export$5db520940cf00715}(
    $filteredProducts: [String!]
    $filteredObjectTypes: [String!]
    $itemsLimit: Int!
    $filteredRootContainerIds: [ID!]
  ) {
    activity {
      myActivity {
        all(
          filter: {
            arguments: {
              products: $filteredProducts
              objectTypes: $filteredObjectTypes
            }
            rootContainerIds: $filteredRootContainerIds
          }
          first: $itemsLimit
        ) {
          __typename
          edges {
            __typename
            node {
              __typename
              object {
                __typename
                id
                type
                product
                data {
                  __typename
                  ...ConfluencePageFragment
                  ...ConfluenceBlogPostFragment
                  ...ConfluenceWhiteboardFragment
                  ...AtlasProjectFragment
                  ...AtlasGoalFragment
                  ...JiraIssueFragment
                }
              }
              event {
                __typename
                eventType
                timestamp
              }
            }
          }
        }
      }
    }
  }
  ${$f79bfdfe882aad1c$var$ConfluencePageFragment}
  ${$f79bfdfe882aad1c$var$ConfluenceBlogPostFragment}
  ${$f79bfdfe882aad1c$var$ConfluenceWhiteboardFragment}
  ${$f79bfdfe882aad1c$var$AtlasProjectFragment}
  ${$f79bfdfe882aad1c$var$AtlasGoalFragment}
  ${$f79bfdfe882aad1c$var$JiraIssueFragment}
`;


const $ea680f69fb68aad1$export$ba6bff93c920ff4a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return (0, $jR2a0.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $f79bfdfe882aad1c$export$8a781e50bcd90a75),
        operationName: $f79bfdfe882aad1c$export$5db520940cf00715
    });
};







var $6LZT4 = parcelRequire("6LZT4");


var $2hwbE = parcelRequire("2hwbE");











var $mr7nI = parcelRequire("mr7nI");


var $zxlpF = parcelRequire("zxlpF");


var $P1m33 = parcelRequire("P1m33");





var $iC0LJ = parcelRequire("iC0LJ");

var $2NJB3 = parcelRequire("2NJB3");

var $bdce1f0e6d9e5cc4$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    return VIEWED_EVENT;
}({});
var $bdce1f0e6d9e5cc4$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
function $bdce1f0e6d9e5cc4$export$e873c799b137eec4(date) {
    return (0, $mr7nI.default)(new Date(date), $bdce1f0e6d9e5cc4$var$startOfOneWeekAgo());
}
function $bdce1f0e6d9e5cc4$var$startOfOneWeekAgo() {
    return (0, $zxlpF.default)((0, $P1m33.default)(new Date(), 1));
}
const $bdce1f0e6d9e5cc4$export$9e4fb3fb50a3c754 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { eventType: eventType, timestamp: timestamp } = t0;
    let t1;
    if ($[0] !== timestamp) {
        t1 = $bdce1f0e6d9e5cc4$export$e873c799b137eec4(timestamp);
        $[0] = timestamp;
        $[1] = t1;
    } else t1 = $[1];
    const isAbsolute = t1;
    let t2;
    if ($[2] !== isAbsolute) {
        t2 = {
            isMyActivityData: true,
            isAbsolute: isAbsolute
        };
        $[2] = isAbsolute;
        $[3] = t2;
    } else t2 = $[3];
    const message = (0, $2NJB3.useEventTypeMessage)(eventType, t2);
    let t3;
    if ($[4] !== timestamp) {
        t3 = (0, $iC0LJ.selectUnit)(new Date(timestamp).getTime(), new Date(), {
            day: 7
        });
        $[4] = timestamp;
        $[5] = t3;
    } else t3 = $[5];
    const { value: value, unit: unit } = t3;
    let t4;
    if ($[6] !== isAbsolute || $[7] !== timestamp || $[8] !== unit || $[9] !== value) {
        t4 = isAbsolute ? {
            absoluteTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
                value: timestamp,
                month: "short",
                day: "2-digit",
                year: "numeric"
            })
        } : {
            relativeTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
                value: value,
                unit: unit
            })
        };
        $[6] = isAbsolute;
        $[7] = timestamp;
        $[8] = unit;
        $[9] = value;
        $[10] = t4;
    } else t4 = $[10];
    const values = t4;
    let t5;
    if ($[11] !== message || $[12] !== values) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: values
        });
        $[11] = message;
        $[12] = values;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ eventType: eventType, timestamp: timestamp })=>{
    const isAbsolute = $bdce1f0e6d9e5cc4$export$e873c799b137eec4(timestamp);
    const message = (0, $2NJB3.useEventTypeMessage)(eventType, {
        isMyActivityData: true,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $iC0LJ.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...message,
        values: values
    });
};












var $hekY6 = parcelRequire("hekY6");


var $6cA3O = parcelRequire("6cA3O");

var $33jh4 = parcelRequire("33jh4");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e8102bfd9c3388fd$var$ConfluenceResultMetaWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5v1qpb _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5v1qpb _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $e8102bfd9c3388fd$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0Of8r2FQfX _4EypqQ7NXe _4zFhSBdnbC _3tmrBpdnbC _11fIckdnbC _0xwIsudnbC _0BtHt6N91d _12NH9BYbGa _38sxj6DIqT _1wjO8X7NXe _17nkIGdnbC _22M99OdnbC _1ist0GdnbC _0a2ilYdnbC _3FGkVhYbGa _4iNZBZDIqT _2Yu8lgN91d _2pEBGw1Y8M _1Ps52U1Y8M _3AFf5bUNDJ _3x4VyyLRg7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0Of8r2FQfX _4EypqQ7NXe _4zFhSBdnbC _3tmrBpdnbC _11fIckdnbC _0xwIsudnbC _0BtHt6N91d _12NH9BYbGa _38sxj6DIqT _1wjO8X7NXe _17nkIGdnbC _22M99OdnbC _1ist0GdnbC _0a2ilYdnbC _3FGkVhYbGa _4iNZBZDIqT _2Yu8lgN91d _2pEBGw1Y8M _1Ps52U1Y8M _3AFf5bUNDJ _3x4VyyLRg7",
            __cmplp.className
        ])
    });
});
const $e8102bfd9c3388fd$var$ConfluenceTypeWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1UtDYzZpcK _41LZZBMRGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1UtDYzZpcK _41LZZBMRGa",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e8102bfd9c3388fd$var$ConfluenceMetaSpacerWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1UtDYzZpcK _313842dnbC _0adFHs1Y8M _1DCdHidnbC _2XsHFM1Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1UtDYzZpcK _313842dnbC _0adFHs1Y8M _1DCdHidnbC _2XsHFM1Y8M",
            __cmplp.className
        ])
    });
});
const $e8102bfd9c3388fd$export$9138e703d4b4585b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { resultContentType: resultContentType, resultAncestors: resultAncestors, resultSpace: resultSpace } = t0;
    let t1;
    if ($[0] !== resultAncestors || $[1] !== resultContentType || $[2] !== resultSpace) {
        const breadcrumbs = $e8102bfd9c3388fd$export$ed9f69ac7e699c53(resultAncestors, resultSpace);
        let t2;
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$ConfluenceTypeWrapper, null, "Confluence");
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$ConfluenceMetaSpacerWrapper, null, "\u2022");
            $[4] = t2;
            $[5] = t3;
        } else {
            t2 = $[4];
            t3 = $[5];
        }
        let t4;
        if ($[6] !== resultContentType) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$ConfluenceTypeWrapper, null, resultContentType);
            $[6] = resultContentType;
            $[7] = t4;
        } else t4 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$ConfluenceResultMetaWrapper, null, t2, t3, t4, breadcrumbs?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$ConfluenceMetaSpacerWrapper, null, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33jh4.default), {
            maxItems: 2,
            isExpanded: false,
            onExpand: $e8102bfd9c3388fd$var$_temp
        }, breadcrumbs.map((t5, itemIndex)=>{
            const { id: id, title: title } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cA3O.default), {
                key: id,
                text: title || "",
                truncationWidth: itemIndex === breadcrumbs.length - 1 || itemIndex === 0 ? 130 : 50
            });
        })))));
        $[0] = resultAncestors;
        $[1] = resultContentType;
        $[2] = resultSpace;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ resultContentType: resultContentType, resultAncestors: resultAncestors, resultSpace: resultSpace })=>{
    const breadcrumbs = $e8102bfd9c3388fd$export$ed9f69ac7e699c53(resultAncestors, resultSpace);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$ConfluenceResultMetaWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$ConfluenceTypeWrapper, null, "Confluence"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$ConfluenceMetaSpacerWrapper, null, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$ConfluenceTypeWrapper, null, resultContentType), breadcrumbs?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$ConfluenceMetaSpacerWrapper, null, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8102bfd9c3388fd$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33jh4.default), {
        maxItems: 2,
        isExpanded: false,
        onExpand: (e)=>e.preventDefault()
    }, breadcrumbs.map(({ id: id, title: title }, itemIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cA3O.default), {
            key: id,
            text: title || '',
            truncationWidth: itemIndex === breadcrumbs.length - 1 || itemIndex === 0 ? 130 : 50
        }))))));
};
const $e8102bfd9c3388fd$export$ed9f69ac7e699c53 = (ancestors, space)=>{
    let breadcrumbs = [];
    if (space) {
        const spaceBreadcrumb = {
            id: space?.id,
            title: space?.name
        };
        if (!ancestors || ancestors.length === 0) breadcrumbs = [
            spaceBreadcrumb
        ];
        else if (ancestors.length >= 1) breadcrumbs = [
            spaceBreadcrumb,
            ...ancestors.slice(1)
        ];
    }
    return breadcrumbs;
};
function $e8102bfd9c3388fd$var$_temp(e) {
    return e.preventDefault();
}


const $b26fbd822321ad08$var$CONTEXT_PATH = '/wiki/spaces';
const $b26fbd822321ad08$export$7192bcb9a5864aaa = (edge)=>{
    const item = edge.node;
    const iconLabel = `${item.object.product} ${item.object.type}`;
    switch(item.object.product){
        case 'jira':
            return {
                title: `${item.object.data?.key}: ${(item.object.data?.fieldsById?.edges || [
                    {}
                ])[0].node?.text}` || '',
                description: `Jira ${item.object.type}`,
                subheading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdce1f0e6d9e5cc4$export$9e4fb3fb50a3c754), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2hwbE.default), {
                    size: "small",
                    label: iconLabel
                }),
                onClick: ()=>{},
                navigationUrl: item.object.data?.webUrl || ''
            };
        case 'confluence':
            return {
                title: item.object.data?.title || '',
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8102bfd9c3388fd$export$9138e703d4b4585b), {
                    resultContentType: item.object.type,
                    resultAncestors: item.object.data?.ancestors,
                    resultSpace: item.object.data?.space
                }),
                subheading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdce1f0e6d9e5cc4$export$9e4fb3fb50a3c754), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6LZT4.default), {
                    size: "small",
                    label: iconLabel
                }),
                onClick: ()=>{},
                navigationUrl: `${item.object.data?.links?.base || $b26fbd822321ad08$var$CONTEXT_PATH}${item.object.data?.links?.webUi || ''}`
            };
        case 'townsquare':
            return {
                title: `${item.object.data?.key}: ${item.object.data?.name}` || '',
                description: `Atlas ${item.object.type}`,
                subheading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdce1f0e6d9e5cc4$export$9e4fb3fb50a3c754), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                    width: 24,
                    height: 24,
                    src: item.object.data?.iconData || '',
                    alt: `${item.object.product} ${item.object.type}`
                }),
                onClick: ()=>{},
                navigationUrl: item.object.data?.url || '',
                meta: `Atlas ${item.object.type}`
            };
        default:
            return {
                title: '',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
                onClick: ()=>{
                    return;
                }
            };
    }
};


const $5922fe5bff57c0db$export$ba7d28c6aa777ec8 = async (cloudId, onError)=>{
    const fetchData = async (filteredProducts, filteredObjectTypes, filteredRootContainerIds, itemsLimit)=>{
        const response = await (0, $ea680f69fb68aad1$export$ba6bff93c920ff4a)({
            variables: {
                filteredProducts: filteredProducts,
                filteredObjectTypes: filteredObjectTypes,
                filteredRootContainerIds: filteredRootContainerIds,
                itemsLimit: itemsLimit
            }
        }).catch((error)=>{
            onError(error);
        });
        const data = response && response.data;
        const edges = data?.activity?.myActivity?.all?.edges || [];
        return edges?.map((edge)=>(0, $b26fbd822321ad08$export$7192bcb9a5864aaa)(edge));
    };
    return await fetchData([
        'confluence',
        'jira',
        'townsquare'
    ], [
        'page',
        'issue',
        'project'
    ], [
        `ari:cloud:platform::site/${cloudId}`,
        `ari:cloud:townsquare::site/${cloudId}`
    ], 200);
};
const $5922fe5bff57c0db$export$c8394dd336252c18 = (recentViews, inputQuery)=>{
    if (inputQuery.length === 0) return recentViews;
    return recentViews && (0, $0e68c99e68a0931d$export$18f3758fc3685a84)(recentViews, inputQuery);
};


const $4a8b01ab53e0218b$export$11133d09694420f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(20);
    const [t0] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { user: user, primaryProduct: primaryProduct, cloudId: cloudId } = t0;
    const { setPrefetchedRecentSearchResults: setPrefetchedRecentSearchResults, setPrefetchedRecentViewsResults: setPrefetchedRecentViewsResults } = (0, $3a2567ac224fb8e0$export$4e8b5ffe8cfc8886)();
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    const logException = (0, $298b6709c80d740f$export$67ff3bc9583d7c16)();
    let t1;
    if ($[0] !== cloudId || $[1] !== features?.recentViews?.enabled || $[2] !== logException || $[3] !== setPrefetchedRecentViewsResults) {
        t1 = ()=>{
            const fetchRecentViewsResults = async function fetchRecentViewsResults() {
                if (!cloudId) return;
                const recentViewsResults = await (0, $5922fe5bff57c0db$export$ba7d28c6aa777ec8)(cloudId, logException);
                setPrefetchedRecentViewsResults(recentViewsResults);
            };
            if (features?.recentViews?.enabled) fetchRecentViewsResults();
            else setPrefetchedRecentViewsResults([]);
        };
        $[0] = cloudId;
        $[1] = features?.recentViews?.enabled;
        $[2] = logException;
        $[3] = setPrefetchedRecentViewsResults;
        $[4] = t1;
    } else t1 = $[4];
    const t2 = features?.recentViews?.enabled;
    let t3;
    if ($[5] !== cloudId || $[6] !== logException || $[7] !== setPrefetchedRecentViewsResults || $[8] !== t2) {
        t3 = [
            setPrefetchedRecentViewsResults,
            cloudId,
            logException,
            t2
        ];
        $[5] = cloudId;
        $[6] = logException;
        $[7] = setPrefetchedRecentViewsResults;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    (0, $cozmU.useEffect)(t1, t3);
    let t4;
    if ($[10] !== features?.recentSearches?.enabled || $[11] !== primaryProduct || $[12] !== setPrefetchedRecentSearchResults || $[13] !== user?.id) {
        t4 = ()=>{
            if (features?.recentSearches?.enabled) setPrefetchedRecentSearchResults((0, $546b537d8b10f575$export$7a283d45f414521b)(primaryProduct, user?.id));
            else setPrefetchedRecentSearchResults([]);
        };
        $[10] = features?.recentSearches?.enabled;
        $[11] = primaryProduct;
        $[12] = setPrefetchedRecentSearchResults;
        $[13] = user?.id;
        $[14] = t4;
    } else t4 = $[14];
    const t5 = features?.recentSearches?.enabled;
    let t6;
    if ($[15] !== primaryProduct || $[16] !== setPrefetchedRecentSearchResults || $[17] !== t5 || $[18] !== user) {
        t6 = [
            primaryProduct,
            user,
            setPrefetchedRecentSearchResults,
            t5
        ];
        $[15] = primaryProduct;
        $[16] = setPrefetchedRecentSearchResults;
        $[17] = t5;
        $[18] = user;
        $[19] = t6;
    } else t6 = $[19];
    (0, $cozmU.useEffect)(t4, t6);
} : ()=>{
    const [{ user: user, primaryProduct: primaryProduct, cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { setPrefetchedRecentSearchResults: setPrefetchedRecentSearchResults, setPrefetchedRecentViewsResults: setPrefetchedRecentViewsResults } = (0, $3a2567ac224fb8e0$export$4e8b5ffe8cfc8886)();
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    const logException = (0, $298b6709c80d740f$export$67ff3bc9583d7c16)();
    (0, $cozmU.useEffect)(()=>{
        async function fetchRecentViewsResults() {
            if (!cloudId) return;
            const recentViewsResults = await (0, $5922fe5bff57c0db$export$ba7d28c6aa777ec8)(cloudId, logException);
            setPrefetchedRecentViewsResults(recentViewsResults);
        }
        if (features?.recentViews?.enabled) fetchRecentViewsResults();
        else setPrefetchedRecentViewsResults([]);
    }, [
        setPrefetchedRecentViewsResults,
        cloudId,
        logException,
        features?.recentViews?.enabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (features?.recentSearches?.enabled) setPrefetchedRecentSearchResults((0, $546b537d8b10f575$export$7a283d45f414521b)(primaryProduct, user?.id));
        else setPrefetchedRecentSearchResults([]);
    }, [
        primaryProduct,
        user,
        setPrefetchedRecentSearchResults,
        features?.recentSearches?.enabled
    ]);
};































var $l8Rhq = parcelRequire("l8Rhq");

// This function is used to override the values of an object with the values of another object.
// Unless the value is null or undefined, the value from the source object will be used.
function $90b7144a3d69bad9$export$8b58be045bf06082(target, source) {
    const result = {
        ...target
    };
    for(const key in source)if (source[key] !== null && source[key] !== undefined) result[key] = source[key];
    return result;
}


function $386ccd9a45899fff$export$f654b28f82155665(url) {
    return url ? new URL(url).origin : window.location.origin;
}
function $386ccd9a45899fff$export$3c0cdf0037f37eca(queryParams) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
    });
    url.search = searchParams.toString();
    return url.href;
}
function $386ccd9a45899fff$export$bd386de500a3324b(url) {
    window.location.href = url;
}


const $d848581de35407c0$export$554c849e7e3a0f1 = {
    linkComponent: (0, $l8Rhq.Anchor),
    mapUserIdToProfileUrl: ()=>null,
    generateSearchUrl: (0, $386ccd9a45899fff$export$3c0cdf0037f37eca),
    queryParams: {},
    onNavigate: (0, $386ccd9a45899fff$export$bd386de500a3324b)
};
/**
 * Provides information about the host application that can't be stored in a state store,
 * e.g. a function.
 */ const $d848581de35407c0$var$AppContext = /*#__PURE__*/ (0, $cozmU.createContext)($d848581de35407c0$export$554c849e7e3a0f1);
const $d848581de35407c0$export$fdc397e486fa83e7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($d848581de35407c0$var$AppContext);
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($d848581de35407c0$var$AppContext);
const $d848581de35407c0$export$20d2b7652facc723 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let T0;
    let children;
    let t1;
    if ($[0] !== t0) {
        const { children: t2, ...props } = t0;
        children = t2;
        T0 = $d848581de35407c0$var$AppContext.Provider;
        t1 = (0, $90b7144a3d69bad9$export$8b58be045bf06082)($d848581de35407c0$export$554c849e7e3a0f1, props);
        $[0] = t0;
        $[1] = T0;
        $[2] = children;
        $[3] = t1;
    } else {
        T0 = $[1];
        children = $[2];
        t1 = $[3];
    }
    let t2;
    if ($[4] !== T0 || $[5] !== children || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            value: t1
        }, children);
        $[4] = T0;
        $[5] = children;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d848581de35407c0$var$AppContext.Provider, {
        value: (0, $90b7144a3d69bad9$export$8b58be045bf06082)($d848581de35407c0$export$554c849e7e3a0f1, props)
    }, children);

























const $76cfb571302d9094$var$searchLinkWithDescriptionStyles = (0, $buxP3.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateAreas: `
    "icon title"
    "icon description"
  `,
    alignItems: 'center',
    height: '50px',
    borderRadius: 'radius.large'
});
const $76cfb571302d9094$var$iconSkeleton = (0, $buxP3.xcss)({
    gridArea: 'icon',
    backgroundColor: 'color.background.neutral',
    width: '24px',
    height: '24px',
    borderRadius: 'radius.xsmall'
});
const $76cfb571302d9094$var$titleSkeleton = (0, $buxP3.xcss)({
    gridArea: 'title',
    backgroundColor: 'color.background.neutral',
    width: '260px',
    height: '14px',
    borderRadius: 'radius.xsmall'
});
const $76cfb571302d9094$var$descriptionSkeleton = (0, $buxP3.xcss)({
    gridArea: 'description',
    backgroundColor: 'color.background.neutral',
    width: '150px',
    height: '10px',
    borderRadius: 'radius.xsmall'
});
const $76cfb571302d9094$export$f2db87eaff19de11 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $76cfb571302d9094$var$searchLinkWithDescriptionStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $76cfb571302d9094$var$iconSkeleton
        }), /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $76cfb571302d9094$var$titleSkeleton
        }), /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $76cfb571302d9094$var$descriptionSkeleton
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $76cfb571302d9094$var$searchLinkWithDescriptionStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $76cfb571302d9094$var$iconSkeleton
    }), /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $76cfb571302d9094$var$titleSkeleton
    }), /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $76cfb571302d9094$var$descriptionSkeleton
    }));
};


const $a7094d498c2eb578$export$772547de01833b56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76cfb571302d9094$export$f2db87eaff19de11), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76cfb571302d9094$export$f2db87eaff19de11), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76cfb571302d9094$export$f2db87eaff19de11), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76cfb571302d9094$export$f2db87eaff19de11), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76cfb571302d9094$export$f2db87eaff19de11), null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76cfb571302d9094$export$f2db87eaff19de11), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76cfb571302d9094$export$f2db87eaff19de11), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76cfb571302d9094$export$f2db87eaff19de11), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76cfb571302d9094$export$f2db87eaff19de11), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76cfb571302d9094$export$f2db87eaff19de11), null));
};





class $398a80973ab06e53$export$d7f5e52d091a66db extends Error {
    constructor(...args){
        super(...args);
        this.isCancelled = true;
    }
}
const $398a80973ab06e53$var$CANCEL_ERROR = new $398a80973ab06e53$export$d7f5e52d091a66db('Promise is cancelled');
class $398a80973ab06e53$export$5782acf08706f13d {
    static from(promise) {
        return new $398a80973ab06e53$export$5782acf08706f13d(promise);
    }
    constructor(promise){
        this.cancellablePromiseInternal = void 0;
        this.cancelInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.promise = ()=>this.cancellablePromiseInternal;
        this.cancel = ()=>this.cancelInternal();
        this.cancellablePromiseInternal = Promise.race([
            promise,
            new Promise((_, reject)=>{
                this.cancelInternal = ()=>reject($398a80973ab06e53$var$CANCEL_ERROR);
            })
        ]);
    }
}

























































var $gbbjP = parcelRequire("gbbjP");




const $3add93f8c7972f84$export$d8428ac7d93fb69a = Object.freeze({
    [(0, $bkXhB.filter).id]: (0, $bkXhB.filter),
    [(0, $bPX0r.filter).id]: (0, $bPX0r.filter),
    [(0, $lBu63.filter).id]: (0, $lBu63.filter),
    [(0, $5EzaL.filter).id]: (0, $5EzaL.filter),
    [(0, $ko90a.filter).id]: (0, $ko90a.filter),
    [(0, $10JkG.filter).id]: (0, $10JkG.filter),
    [(0, $lCzjG.universalTypeFilterId)]: (0, $gbbjP.filter),
    [(0, $hYdYN.filter).id]: (0, $hYdYN.filter),
    [(0, $cqf3V.filter).id]: (0, $cqf3V.filter),
    [(0, $7ayyq.filter).id]: (0, $7ayyq.filter),
    [(0, $h4cPw.filter).id]: (0, $h4cPw.filter)
});





const $979870397bacea10$var$getSelectFilterValue = (filter)=>{
    return (0, $iueFH.isSelectFilter)(filter?.type) ? filter.value : [];
};
const $979870397bacea10$var$getSelectFilterCustomOptionValue = (filter)=>{
    return (0, $iueFH.isSelectFilter)(filter?.type) ? filter.customValue : {};
};
const $979870397bacea10$var$getBooleanFilterValue = (filter)=>{
    return filter?.type === 'boolean' ? filter.value : false;
};
const $979870397bacea10$var$getSelectedDateRange = (filter)=>{
    const selectedDateOption = $979870397bacea10$var$getSelectFilterValue(filter).at(0);
    if (selectedDateOption && selectedDateOption !== (0, $lCzjG.CUSTOM_OPTION_VALUE)) return (0, $hz3c4.convertLastUpdatedToDateRange)(selectedDateOption);
    else if (selectedDateOption === (0, $lCzjG.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $979870397bacea10$var$getSelectFilterCustomOptionValue(filter);
        if (customDateRange?.from || customDateRange?.to) return (0, $hz3c4.convertCustomDateToRange)(customDateRange.from, customDateRange.to);
    }
    return;
};
const $979870397bacea10$var$getFilterDateRange = (filter)=>{
    const selectedDateOption = $979870397bacea10$var$getSelectFilterValue(filter).at(0);
    if (selectedDateOption && selectedDateOption !== (0, $lCzjG.CUSTOM_OPTION_VALUE)) return [
        (0, $hz3c4.getConfluenceDateOptionValues)(selectedDateOption)
    ];
    else if (selectedDateOption === (0, $lCzjG.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $979870397bacea10$var$getSelectFilterCustomOptionValue(filter);
        if (customDateRange?.from && customDateRange?.to) return [
            (0, $hz3c4.getConfluenceDateOptionFromCustomDates)(customDateRange.from, customDateRange.to)
        ];
    }
    return [];
};
const $979870397bacea10$export$eee2fc39be8ffb4a = (selectedProduct)=>{
    switch(selectedProduct){
        case (0, $37AYo.ProductKeys).Jira:
            return [
                'software',
                'business'
            ];
        case (0, $37AYo.ProductKeys).JiraProductDiscovery:
            return [
                'product_discovery'
            ];
        case (0, $37AYo.ProductKeys).JiraServiceManagement:
            return [
                'service_desk'
            ];
    }
    return [
        'software',
        'business',
        'service_desk',
        'product_discovery'
    ];
};
const $979870397bacea10$export$e90e90fddddd8154 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(73);
    const { outboundAuthConfigs: outboundAuthConfigs } = t0;
    const filters = (0, $2Va9o.useFilters)();
    const { selectedProduct: selectedProduct, filteredProducts: filteredProducts, availableProducts: availableProducts } = (0, $2Va9o.useProducts)();
    let t1;
    if ($[0] !== outboundAuthConfigs) {
        t1 = {
            outboundAuthConfigs: outboundAuthConfigs
        };
        $[0] = outboundAuthConfigs;
        $[1] = t1;
    } else t1 = $[1];
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $2Va9o.useTypeEntities)(t1);
    const t2 = filters[(0, $cqf3V.filter).id];
    let t3;
    if ($[2] !== t2) {
        t3 = $979870397bacea10$var$getBooleanFilterValue(t2);
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const titleMatchValue = t3;
    const t4 = filters[(0, $bkXhB.filter).id];
    let t5;
    if ($[4] !== t4) {
        t5 = $979870397bacea10$var$getSelectedDateRange(t4);
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const selectedDateRange = t5;
    const t6 = filters[(0, $bkXhB.filter).id];
    let t7;
    if ($[6] !== t6) {
        t7 = $979870397bacea10$var$getFilterDateRange(t6);
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    const filterDateRange = t7;
    let t8;
    if ($[8] !== filters) {
        t8 = undefined;
        $[8] = filters;
        $[9] = t8;
    } else t8 = $[9];
    const commonContributors = t8;
    let t9;
    if ($[10] !== selectedDateRange) {
        t9 = {
            lastModified: selectedDateRange
        };
        $[10] = selectedDateRange;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== commonContributors || $[13] !== t9) {
        t10 = {
            range: t9,
            contributorsFilter: commonContributors
        };
        $[12] = commonContributors;
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    const t11 = filters[(0, $10JkG.filter).id];
    let t12;
    if ($[15] !== t11) {
        t12 = $979870397bacea10$var$getSelectFilterValue(t11);
        $[15] = t11;
        $[16] = t12;
    } else t12 = $[16];
    const t13 = filters[(0, $ko90a.filter).id];
    let t14;
    if ($[17] !== t13) {
        t14 = $979870397bacea10$var$getSelectFilterValue(t13);
        $[17] = t13;
        $[18] = t14;
    } else t14 = $[18];
    let t15;
    if ($[19] !== t12 || $[20] !== t14) {
        t15 = {
            projectARIs: t12,
            assigneeARIs: t14
        };
        $[19] = t12;
        $[20] = t14;
        $[21] = t15;
    } else t15 = $[21];
    let t16;
    if ($[22] !== selectedProduct) {
        t16 = undefined;
        $[22] = selectedProduct;
        $[23] = t16;
    } else t16 = $[23];
    let t17;
    if ($[24] !== t16) {
        t17 = {
            projectTypes: t16
        };
        $[24] = t16;
        $[25] = t17;
    } else t17 = $[25];
    let t18;
    if ($[26] !== t15 || $[27] !== t17) {
        t18 = {
            issueFilter: t15,
            projectFilter: t17
        };
        $[26] = t15;
        $[27] = t17;
        $[28] = t18;
    } else t18 = $[28];
    const t19 = filters[(0, $lBu63.filter).id];
    let t20;
    if ($[29] !== t19) {
        t20 = $979870397bacea10$var$getSelectFilterValue(t19);
        $[29] = t19;
        $[30] = t20;
    } else t20 = $[30];
    let t21;
    if ($[31] !== filters) {
        t21 = $979870397bacea10$var$getBooleanFilterValue(filters[(0, $5EzaL.filter).id]) || undefined;
        $[31] = filters;
        $[32] = t21;
    } else t21 = $[32];
    const t22 = filters[(0, $bPX0r.filter).id];
    let t23;
    if ($[33] !== t22) {
        t23 = $979870397bacea10$var$getSelectFilterValue(t22);
        $[33] = t22;
        $[34] = t23;
    } else t23 = $[34];
    const t24 = filters[(0, $hYdYN.filter).id];
    let t25;
    if ($[35] !== t24) {
        t25 = $979870397bacea10$var$getSelectFilterValue(t24);
        $[35] = t24;
        $[36] = t25;
    } else t25 = $[36];
    const t26 = filters[(0, $7ayyq.filter).id];
    let t27;
    if ($[37] !== t26) {
        t27 = $979870397bacea10$var$getSelectFilterValue(t26);
        $[37] = t26;
        $[38] = t27;
    } else t27 = $[38];
    const t28 = filters[(0, $h4cPw.filter).id];
    let t29;
    if ($[39] !== t28) {
        t29 = $979870397bacea10$var$getSelectFilterValue(t28);
        $[39] = t28;
        $[40] = t29;
    } else t29 = $[40];
    let t30;
    if ($[41] !== filterDateRange || $[42] !== t20 || $[43] !== t21 || $[44] !== t23 || $[45] !== t25 || $[46] !== t27 || $[47] !== t29) {
        t30 = {
            spacesFilter: t20,
            isVerified: t21,
            contributorsFilter: t23,
            ancestorIdsFilter: t25,
            range: filterDateRange,
            owners: t27,
            labelsFilter: t29
        };
        $[41] = filterDateRange;
        $[42] = t20;
        $[43] = t21;
        $[44] = t23;
        $[45] = t25;
        $[46] = t27;
        $[47] = t29;
        $[48] = t30;
    } else t30 = $[48];
    const t31 = selectedEntities;
    let t32;
    if ($[49] !== filterDateRange || $[50] !== filteredProducts || $[51] !== outboundAuthConfigs || $[52] !== t31 || $[53] !== titleMatchValue) {
        t32 = (0, $hz3c4.getThirdPartyFilters)(filteredProducts, titleMatchValue, t31, outboundAuthConfigs, (0, $hz3c4.baseIntegrationARIs), filterDateRange);
        $[49] = filterDateRange;
        $[50] = filteredProducts;
        $[51] = outboundAuthConfigs;
        $[52] = t31;
        $[53] = titleMatchValue;
        $[54] = t32;
    } else t32 = $[54];
    let t33;
    if ($[55] !== t10 || $[56] !== t18 || $[57] !== t30 || $[58] !== t32) {
        t33 = {
            commonFilters: t10,
            jiraFilters: t18,
            confluenceFilters: t30,
            thirdPartyFilters: t32
        };
        $[55] = t10;
        $[56] = t18;
        $[57] = t30;
        $[58] = t32;
        $[59] = t33;
    } else t33 = $[59];
    const selectedFilters = t33;
    const t34 = selectedEntities;
    let t35;
    if ($[60] !== availableProducts || $[61] !== filterDateRange || $[62] !== outboundAuthConfigs || $[63] !== t34 || $[64] !== titleMatchValue) {
        t35 = (0, $hz3c4.getThirdPartyFilters)(availableProducts, titleMatchValue, t34, outboundAuthConfigs, (0, $hz3c4.baseIntegrationARIs), filterDateRange);
        $[60] = availableProducts;
        $[61] = filterDateRange;
        $[62] = outboundAuthConfigs;
        $[63] = t34;
        $[64] = titleMatchValue;
        $[65] = t35;
    } else t35 = $[65];
    const unselectedProductsThirdPartyFilters = t35;
    const { commonFilters: commonFilters, jiraFilters: jiraFilters, confluenceFilters: confluenceFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters;
    const isEmpty = !commonFilters.range.lastModified && selectedEntities.length === 0 && confluenceFilters.spacesFilter.length === 0 && !confluenceFilters.isVerified && confluenceFilters.contributorsFilter.length === 0 && confluenceFilters.ancestorIdsFilter.length === 0 && confluenceFilters.range.length === 0 && confluenceFilters.owners.length === 0 && confluenceFilters.labelsFilter.length === 0 && jiraFilters.issueFilter.assigneeARIs.length === 0 && jiraFilters.issueFilter.projectARIs.length === 0 && (!thirdPartyFilters.range || thirdPartyFilters?.range?.length === 0) && !thirdPartyFilters.titleMatchOnly && thirdPartyFilters.subtypes.length === 0;
    const t36 = !isEmpty;
    let t37;
    if ($[66] !== entitiesForQuery || $[67] !== entitiesForResultsCountQuery || $[68] !== selectedEntities || $[69] !== selectedFilters || $[70] !== t36 || $[71] !== unselectedProductsThirdPartyFilters) {
        t37 = {
            selectedFilters: selectedFilters,
            unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters,
            selectedEntities: selectedEntities,
            entitiesForResultsCountQuery: entitiesForResultsCountQuery,
            entities: entitiesForQuery,
            hasFiltersSelected: t36
        };
        $[66] = entitiesForQuery;
        $[67] = entitiesForResultsCountQuery;
        $[68] = selectedEntities;
        $[69] = selectedFilters;
        $[70] = t36;
        $[71] = unselectedProductsThirdPartyFilters;
        $[72] = t37;
    } else t37 = $[72];
    return t37;
} : ({ outboundAuthConfigs: outboundAuthConfigs })=>{
    const filters = (0, $2Va9o.useFilters)();
    const { selectedProduct: selectedProduct, filteredProducts: filteredProducts, availableProducts: availableProducts } = (0, $2Va9o.useProducts)();
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $2Va9o.useTypeEntities)({
        outboundAuthConfigs: outboundAuthConfigs
    });
    const titleMatchValue = $979870397bacea10$var$getBooleanFilterValue(filters[(0, $cqf3V.filter).id]);
    const selectedDateRange = $979870397bacea10$var$getSelectedDateRange(filters[(0, $bkXhB.filter).id]);
    const filterDateRange = $979870397bacea10$var$getFilterDateRange(filters[(0, $bkXhB.filter).id]);
    // fg('universal-contributor-filter') => false
    const commonContributors = undefined;
    const selectedFilters = (0, $cozmU.useMemo)(()=>({
            commonFilters: {
                range: {
                    lastModified: selectedDateRange
                },
                contributorsFilter: commonContributors
            },
            jiraFilters: {
                issueFilter: {
                    projectARIs: $979870397bacea10$var$getSelectFilterValue(filters[(0, $10JkG.filter).id]),
                    assigneeARIs: $979870397bacea10$var$getSelectFilterValue(filters[(0, $ko90a.filter).id])
                },
                projectFilter: {
                    // fg('enable_1p_search_jpd_jsm') => false
                    projectTypes: undefined
                }
            },
            confluenceFilters: {
                spacesFilter: $979870397bacea10$var$getSelectFilterValue(filters[(0, $lBu63.filter).id]),
                isVerified: $979870397bacea10$var$getBooleanFilterValue(filters[(0, $5EzaL.filter).id]) || undefined,
                contributorsFilter: $979870397bacea10$var$getSelectFilterValue(filters[(0, $bPX0r.filter).id]),
                ancestorIdsFilter: $979870397bacea10$var$getSelectFilterValue(filters[(0, $hYdYN.filter).id]),
                range: filterDateRange,
                owners: $979870397bacea10$var$getSelectFilterValue(filters[(0, $7ayyq.filter).id]),
                labelsFilter: $979870397bacea10$var$getSelectFilterValue(filters[(0, $h4cPw.filter).id])
            },
            thirdPartyFilters: (0, $hz3c4.getThirdPartyFilters)(filteredProducts, titleMatchValue, selectedEntities, outboundAuthConfigs, (0, $hz3c4.baseIntegrationARIs), filterDateRange)
        }), [
        filterDateRange,
        filteredProducts,
        filters,
        outboundAuthConfigs,
        selectedDateRange,
        selectedEntities,
        selectedProduct,
        titleMatchValue,
        commonContributors
    ]);
    const unselectedProductsThirdPartyFilters = (0, $cozmU.useMemo)(()=>(0, $hz3c4.getThirdPartyFilters)(availableProducts, titleMatchValue, selectedEntities, outboundAuthConfigs, (0, $hz3c4.baseIntegrationARIs), filterDateRange), [
        availableProducts,
        titleMatchValue,
        selectedEntities,
        outboundAuthConfigs,
        filterDateRange
    ]);
    const { commonFilters: commonFilters, jiraFilters: jiraFilters, confluenceFilters: confluenceFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters;
    const isEmpty = !commonFilters.range.lastModified && selectedEntities.length === 0 && confluenceFilters.spacesFilter.length === 0 && !confluenceFilters.isVerified && confluenceFilters.contributorsFilter.length === 0 && confluenceFilters.ancestorIdsFilter.length === 0 && confluenceFilters.range.length === 0 && confluenceFilters.owners.length === 0 && confluenceFilters.labelsFilter.length === 0 && jiraFilters.issueFilter.assigneeARIs.length === 0 && jiraFilters.issueFilter.projectARIs.length === 0 && (!thirdPartyFilters.range || thirdPartyFilters?.range?.length === 0) && !thirdPartyFilters.titleMatchOnly && thirdPartyFilters.subtypes.length === 0;
    return {
        selectedFilters: selectedFilters,
        unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters,
        selectedEntities: selectedEntities,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        entities: entitiesForQuery,
        hasFiltersSelected: !isEmpty
    };
};







const $8c5830022d72122a$export$e292df53a75b4e9b = (inputQuery, count)=>{
    let { peopleAndTeams: peopleAndTeams, autoSuggestion: autoSuggestion, recentSearch: recentSearch, recentViews: recentViews, quickSearch: quickSearch } = count;
    // case 1: prequery
    let maxDisplayed = {
        peopleAndTeams: 0,
        autoSuggestion: 0,
        recentSearch: 3,
        recentViews: 5,
        quickSearch: 5
    };
    // case 2: 1-2 characters in query
    if (inputQuery.length === 1 || inputQuery.length === 2) {
        // with recent search match (same as prequery)
        if (recentSearch > 0) ;
        else if (autoSuggestion > 0) maxDisplayed = {
            peopleAndTeams: 0,
            autoSuggestion: 8 - Math.min(5, recentViews),
            recentSearch: 0,
            recentViews: 5,
            quickSearch: 5
        };
        else maxDisplayed = {
            peopleAndTeams: 0,
            autoSuggestion: 0,
            recentSearch: 0,
            recentViews: 7,
            quickSearch: 5
        };
    }
    // case 3: 3+ characters in query
    if (inputQuery.length >= 3) {
        // with no person match
        if (peopleAndTeams === 0) {
            // with no person match, with recent search
            if (recentSearch) maxDisplayed = {
                peopleAndTeams: 0,
                autoSuggestion: 3,
                recentSearch: 2,
                recentViews: 3,
                quickSearch: 5
            };
            else maxDisplayed = {
                peopleAndTeams: 0,
                autoSuggestion: 4,
                recentSearch: 0,
                recentViews: 4,
                quickSearch: 5
            };
        } else maxDisplayed = {
            peopleAndTeams: 2,
            autoSuggestion: recentSearch > 0 ? 1 : 3,
            // surface more auto suggestion if no recent search
            recentSearch: 3,
            recentViews: 3,
            quickSearch: 5
        };
    }
    return {
        peopleAndTeams: Math.min(maxDisplayed.peopleAndTeams, peopleAndTeams),
        autoSuggestion: Math.min(maxDisplayed.autoSuggestion, autoSuggestion),
        recentSearch: Math.min(maxDisplayed.recentSearch, recentSearch),
        recentViews: Math.min(maxDisplayed.recentViews, recentViews),
        quickSearch: Math.min(maxDisplayed.quickSearch, quickSearch)
    };
};



var $cXtTj = parcelRequire("cXtTj");




const $03ee1c363dae2ea9$var$operationName = 'AutoSuggestionQuery';
const $03ee1c363dae2ea9$var$AutoSuggestionQuery = `
query ${$03ee1c363dae2ea9$var$operationName}($query: String, $limit: Int!, $filters: QuerySuggestionFilterInput!) {
  suggest {
    suggest(query: $query, limit: $limit, filters: $filters) {
      nodes {
        title
        type
      }
      totalCount
    }
  }
}
`;
const $03ee1c363dae2ea9$export$aa1032c480f72e0d = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>(0, $jR2a0.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $03ee1c363dae2ea9$var$AutoSuggestionQuery,
        operationName: $03ee1c363dae2ea9$var$operationName
    });


const $411379b9efa09b69$export$2d543e88c46c0c38 = (query, bootstrap, onError)=>{
    const autoSuggestionFilters = {
        entities: [
            'query-suggestion.query-suggestion-item'
        ],
        locations: [
            `ari:cloud:confluence::site/${bootstrap.cloudId}`
        ]
    };
    const primaryProduct = bootstrap.primaryProduct;
    const fetchData = async (query)=>{
        // Confluence killswitch
        // FeatureGates.checkGate('search-plex_auto-suggestion') => false
        if (primaryProduct === 'confluence' && true) return {
            results: [],
            duration: 0
        };
        // Atlas killswitch
        if (primaryProduct === 'townsquare' && !(0, $cXtTj.default).checkGate('atlas_enable_query_suggestion_dropdown')) return {
            results: [],
            duration: 0
        };
        performance.mark('fetchAutoSuggestionResultsStart');
        const response = await (0, $03ee1c363dae2ea9$export$aa1032c480f72e0d)({
            variables: {
                limit: 10,
                filters: autoSuggestionFilters,
                query: query
            }
        }).catch((error)=>{
            onError(error);
        });
        performance.mark('fetchAutoSuggestionResultsEnd');
        const { duration: duration } = performance.measure('fetchAutoSuggestionResultsDuration', 'fetchAutoSuggestionResultsStart', 'fetchAutoSuggestionResultsEnd');
        return {
            results: response?.data?.suggest?.suggest?.nodes || [],
            duration: duration
        };
    };
    return fetchData(query);
};



var $7AGG2 = parcelRequire("7AGG2");

var $aNJkw = parcelRequire("aNJkw");

const $6c4d217b7a8a091c$export$290039782fc4e47 = (query, bootstrap, onError)=>{
    const fetchData = async (query)=>{
        performance.mark('fetchPeopleAndTeamsResultsStart');
        // Map townsquare scope as URS does not support townsquare as a primary product
        const productKey = bootstrap.primaryProduct === 'townsquare' ? 'people' : bootstrap.primaryProduct;
        const recommendations = await (0, $7AGG2.default)({
            query: query,
            context: {
                contextType: 'full_page_search',
                siteId: bootstrap.cloudId || '',
                productKey: productKey || '',
                principalId: bootstrap.user?.id || '',
                organizationId: bootstrap.orgId || ''
            },
            includeUsers: true,
            includeTeams: true,
            includeGroups: false,
            maxNumberOfResults: 3,
            performSearchQueryOnly: false,
            searchQuery: {
                filter: 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)',
                teamSearchFields: [
                    (0, $aNJkw.TeamSearchField).NAME
                ]
            }
        }).catch((error)=>{
            onError(error);
            return [];
        });
        performance.mark('fetchPeopleAndTeamsResultsEnd');
        const { duration: duration } = performance.measure('fetchPeopleAndTeamsResultsDuration', 'fetchPeopleAndTeamsResultsStart', 'fetchPeopleAndTeamsResultsEnd');
        return {
            results: recommendations,
            duration: duration
        };
    };
    return fetchData(query);
};



var $8N7MV = parcelRequire("8N7MV");



const $031fedb6b348fb8a$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject @include(if: $includeAtlasProjects) {
  project {
    __typename
    key
  }
}
`;
const $031fedb6b348fb8a$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal @include(if: $includeAtlasGoals) {
  goal {
    __typename
    key
  }
}
`;
const $031fedb6b348fb8a$var$SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
  __typename
  lastModified
  iconCssClass
  space {
    __typename
    id
    name
  }
  confluenceEntity @include(if: $includeAncestors) {
    ... on ConfluencePage {
      __typename
      ancestors {
        __typename
        id
        title
      }
    }
  }
}`;
const $031fedb6b348fb8a$export$5db520940cf00715 = 'QuickFindSearchQuery';
const $031fedb6b348fb8a$export$5dd443f88002bca3 = `
  query ${$031fedb6b348fb8a$export$5db520940cf00715}(
    $query: String!
    $cloudIdARI: String!
    $resultsLimit: Int!
    $spaceLimit: Int!
    $contentEntities: [String!]!
    $confluenceFilters: SearchConfluenceFilter
    $queryVersion: Int
    $searchSessionId: String
    $includeSpaces: Boolean!
    $includeAncestors: Boolean!
		$includeAtlasProjects: Boolean = true
    $includeAtlasGoals: Boolean = true
    $experimentId: String
    $shadowExperimentId: String
    $experimentLayers: [SearchExperimentLayer]
		$experience: String = "quick-find"
		$spacesExperience: String = "searchDialog"
  ) {
    search {
      results: search(
        experience: $experience
        query: $query
        first: $resultsLimit
        filters: {
          entities: $contentEntities
          locations: [$cloudIdARI]
          confluenceFilters: $confluenceFilters
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
        experimentContext: {
          experimentId: $experimentId
          shadowExperimentId: $shadowExperimentId
          experimentLayers: $experimentLayers
        }
      ) {
        __typename
        edges {
          __typename
          node {
            id
            title
            url
            type
            iconUrl
            __typename
            ${$031fedb6b348fb8a$var$SearchConfluencePageBlogAttachment}
						${$031fedb6b348fb8a$var$SearchResultAtlasProject}
						${$031fedb6b348fb8a$var$SearchResultAtlasGoal}
          }
        }
        abTest {
          __typename
          abTestId
          controlId
          experimentId
        }
        totalCount
      }
      spaces: search(
				experience: $spacesExperience
        query: $query
        first: $spaceLimit
        filters: {
          entities: ["ati:cloud:confluence:space"]
          locations: [$cloudIdARI]
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
      ) @include(if: $includeSpaces) {
        __typename
        edges {
          __typename
          node {
            ... on SearchConfluenceSpace {
              __typename
              id
              key
              title
              type
              url
              iconPath
            }
          }
        }
      }
    }
  }
`;


const $eda6b0aabf359d24$export$ac350a1cbaa2773a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return (0, $jR2a0.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $031fedb6b348fb8a$export$5dd443f88002bca3),
        operationName: $031fedb6b348fb8a$export$5db520940cf00715
    });
};













const $8f47020abac40f8c$export$be39b22d05f99edf = (inputQuery)=>({ node: node })=>{
        return {
            title: node?.title || '',
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8102bfd9c3388fd$export$9138e703d4b4585b), {
                resultContentType: node?.type ?? 'page',
                resultAncestors: node?.confluenceEntity?.ancestors,
                resultSpace: node?.space
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6LZT4.default), {
                size: "small",
                label: ""
            }),
            onClick: ()=>{},
            navigationUrl: node?.url,
            highlightedTitle: (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(node?.title ?? '', inputQuery.split(' ')).highlightedTitle
        };
    };


const $e7a1288af0e47770$export$f3ac47fc15573feb = ({ experience: experience, query: query, bootstrap: bootstrap, onError: onError, selectedFilters: selectedFilters, selectedEntities: selectedEntities })=>{
    const { confluenceFilters: confluenceFiltersAll, commonFilters: commonFilters } = selectedFilters || (0, $hz3c4.getEmptySelectedFilters)();
    // In this filter set, "range" is defined as an array but the QuickFindSearchQuery expects an object.
    const { range: range, ...restOfconfluenceFilters } = confluenceFiltersAll;
    const confluenceFilters = {
        ...restOfconfluenceFilters,
        range: Array.isArray(range) && range.length > 0 ? range[0] : undefined
    };
    const fetchData = async (query)=>{
        const contentQueryResults = await (0, $eda6b0aabf359d24$export$ac350a1cbaa2773a)({
            variables: {
                query: query,
                experience: experience,
                cloudIdARI: `${(0, $8N7MV.CONFLUENCE_ARI_PREFIX)}${bootstrap.cloudId}`,
                resultsLimit: 5,
                spaceLimit: 3,
                contentEntities: selectedEntities,
                confluenceFilters: confluenceFilters,
                commonFilters: commonFilters,
                includeAncestors: true,
                includeSpaces: false,
                includeAtlasGoals: false,
                includeAtlasProjects: false,
                searchSessionId: bootstrap.searchSessionId,
                queryVersion: 1
            },
            aggAbsoluteUrl: bootstrap.aggAbsoluteUrl
        });
        const contentResponse = contentQueryResults.data?.search.results?.edges || [];
        const contentResults = contentResponse.map((0, $8f47020abac40f8c$export$be39b22d05f99edf)(query));
        return {
            results: contentResults,
            duration: null
        };
    };
    return fetchData(query).catch((error)=>{
        onError(error);
        return {
            results: [],
            duration: null
        };
    });
};




const $35d27cf6b5f8ffc6$var$fetchAll = async ({ query: query, bootstrap: bootstrap, onError: onError, features: features, selectedFilters: selectedFilters, selectedEntities: selectedEntities })=>{
    const resolveEmpty = ()=>Promise.resolve({
            results: [],
            duration: 0
        });
    return Promise.all([
        features?.peopleAndTeamsSearch?.enabled ? (0, $6c4d217b7a8a091c$export$290039782fc4e47)(query, bootstrap, onError) : resolveEmpty(),
        features?.autoSuggestion?.enabled ? (0, $411379b9efa09b69$export$2d543e88c46c0c38)(query, bootstrap, onError) : resolveEmpty(),
        features?.quickSearch?.enabled ? (0, $e7a1288af0e47770$export$f3ac47fc15573feb)({
            query: query,
            experience: 'company-hub-search',
            bootstrap: bootstrap,
            onError: onError,
            selectedFilters: selectedFilters,
            selectedEntities: selectedEntities
        }) : resolveEmpty()
    ]);
};
const $35d27cf6b5f8ffc6$export$4e2bef15a5b74b17 = ()=>{
    const [inputQuery] = (0, $2Va9o.useInputQuery)();
    const [bootstrap] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const [dropdownLoading] = (0, $3a2567ac224fb8e0$export$41ba39ed718e7414)();
    const requestRef = (0, $cozmU.useRef)();
    const [currentInputQuery, setCurrentInputQuery] = (0, $cozmU.useState)(inputQuery);
    const [recentSearchResults] = (0, $3a2567ac224fb8e0$export$8fdf7942b5f23117)();
    const [recentViewsResults] = (0, $3a2567ac224fb8e0$export$a7f7068aa342db89)();
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    const logException = (0, $298b6709c80d740f$export$67ff3bc9583d7c16)();
    const { setPeopleAndTeamsResults: setPeopleAndTeamsResults, setRecentViewsResults: setRecentViewsResults, setAutoSuggestionResults: setAutoSuggestionResults, setRecentSearchResults: setRecentSearchResults, setQuickSearchResults: setQuickSearchResults, setDropdownLoading: setDropdownLoading, setResultCount: setResultCount } = (0, $3a2567ac224fb8e0$export$4e8b5ffe8cfc8886)();
    const { selectedFilters: selectedFilters, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $979870397bacea10$export$e90e90fddddd8154)({
        outboundAuthConfigs: bootstrap.outboundAuthConfigs
    });
    const debounceTimeout = (0, $cozmU.useRef)(null);
    const fetchData = (0, $cozmU.useCallback)(async (query, bootstrap_0)=>{
        setCurrentInputQuery(inputQuery);
        if (requestRef.current) // If there is an existing fetchAll promise, cancel it
        requestRef.current.cancel();
        setDropdownLoading(true);
        // Set the fetchAll promise
        requestRef.current = new (0, $398a80973ab06e53$export$5782acf08706f13d)($35d27cf6b5f8ffc6$var$fetchAll({
            query: query,
            bootstrap: bootstrap_0,
            onError: logException,
            features: features,
            selectedFilters: selectedFilters,
            selectedEntities: entitiesForResultsCountQuery
        }));
        try {
            const [peopleAndTeamsResults, autoSuggestionResults, quickSearchResults] = await requestRef.current.promise();
            // update store
            setPeopleAndTeamsResults(peopleAndTeamsResults);
            setAutoSuggestionResults(autoSuggestionResults);
            const filteredRecentSearchResults = (0, $546b537d8b10f575$export$9770ca05e8d4f1fe)(recentSearchResults, query);
            setRecentSearchResults(filteredRecentSearchResults);
            setQuickSearchResults(quickSearchResults.results);
            const filteredRecentViewsResults = (0, $5922fe5bff57c0db$export$c8394dd336252c18)(recentViewsResults ?? [], query);
            setRecentViewsResults(filteredRecentViewsResults);
            const resultCounts = (0, $8c5830022d72122a$export$e292df53a75b4e9b)(query, {
                peopleAndTeams: peopleAndTeamsResults.results.length,
                autoSuggestion: autoSuggestionResults.results.length,
                quickSearch: quickSearchResults.results.length,
                recentSearch: filteredRecentSearchResults.length,
                recentViews: filteredRecentViewsResults.length
            });
            setResultCount(resultCounts);
            // stop loading
            setDropdownLoading(false);
        } catch (error) {
            if (!(error instanceof (0, $398a80973ab06e53$export$d7f5e52d091a66db))) {
                // stop loading
                setDropdownLoading(false);
                // log error
                logException(error);
            }
        }
    }, [
        inputQuery,
        logException,
        recentSearchResults,
        recentViewsResults,
        setAutoSuggestionResults,
        setDropdownLoading,
        setPeopleAndTeamsResults,
        setRecentSearchResults,
        setRecentViewsResults,
        setResultCount,
        setQuickSearchResults,
        features,
        selectedFilters,
        entitiesForResultsCountQuery
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((inputQuery !== currentInputQuery || dropdownLoading && !requestRef.current) && recentViewsResults !== undefined) {
            if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
            debounceTimeout.current = setTimeout(()=>{
                fetchData(inputQuery, bootstrap);
            }, 300);
        }
    }, [
        inputQuery,
        bootstrap,
        currentInputQuery,
        dropdownLoading,
        recentViewsResults,
        fetchData
    ]);
};




















var $hAgam = parcelRequire("hAgam");





























const $e2d205701d0a5b5d$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $e2d205701d0a5b5d$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $e2d205701d0a5b5d$var$highlightRE = new RegExp(`${$e2d205701d0a5b5d$var$HIGHLIGHT_START_TAG}(.*?)${$e2d205701d0a5b5d$var$HIGHLIGHT_END_TAG}.*`);
const $e2d205701d0a5b5d$var$openingTagRE = new RegExp(`(.*?)${$e2d205701d0a5b5d$var$HIGHLIGHT_START_TAG}`);
const $e2d205701d0a5b5d$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($e2d205701d0a5b5d$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        key: title + counter
    }, title);
    while(title){
        const [preMatch, preText] = title.match($e2d205701d0a5b5d$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: preText + counter
        }, preText));
        const [boldMatch, highlightText] = title.match($e2d205701d0a5b5d$var$highlightRE) || [];
        title = title.replace(`${$e2d205701d0a5b5d$var$HIGHLIGHT_START_TAG}${highlightText}${$e2d205701d0a5b5d$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("strong", {
            key: highlightText + counter
        }, highlightText));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                key: title + counter
            }, title));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};







const $c3851bfbbb39ba91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    searchLinkLabel: {
        id: "dynamic-cards-search-page.search-link.label",
        defaultMessage: "Search Link"
    }
});


const $fe3202d1a2ffd60f$var$searchLinkStyles = (0, $buxP3.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr auto',
    gridTemplateAreas: `
    "icon title subheading"
  `,
    alignItems: 'center',
    height: '40px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    borderRadius: 'radius.large',
    cursor: 'pointer'
});
const $fe3202d1a2ffd60f$var$searchLinkWithDescriptionStyles = (0, $buxP3.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateAreas: `
    "icon title subheading"
    "icon description subheading"
  `,
    alignItems: 'center',
    height: '50px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    borderRadius: 'radius.large',
    cursor: 'pointer'
});
const $fe3202d1a2ffd60f$var$iconStyles = (0, $buxP3.xcss)({
    gridArea: 'icon'
});
const $fe3202d1a2ffd60f$var$titleStyles = (0, $buxP3.xcss)({
    gridArea: 'title',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: 'font.body'
});
const $fe3202d1a2ffd60f$var$descriptionStyles = (0, $buxP3.xcss)({
    gridArea: 'description',
    display: 'flex',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body.small',
    color: 'color.text.subtle',
    paddingTop: 'space.075'
});
const $fe3202d1a2ffd60f$var$subheadingStyles = (0, $buxP3.xcss)({
    gridArea: 'subheading',
    display: 'flex',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body.small',
    color: 'color.text.subtle',
    alignItems: 'center',
    gap: 'space.050'
});
const $fe3202d1a2ffd60f$var$DropdownResultContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { title: title, description: description, subheading: subheading, icon: icon, onClick: onClick, highlightedTitle: highlightedTitle, rightPanel: rightPanel, asBox: t1, isKeyboardHighlighted: t2 } = t0;
    const asBox = t1 === undefined ? false : t1;
    const isKeyboardHighlighted = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isMouseHighlighted, setIsMouseHighlighted] = (0, $cozmU.useState)(false);
    if (asBox) {
        const t3 = description ? $fe3202d1a2ffd60f$var$searchLinkWithDescriptionStyles : $fe3202d1a2ffd60f$var$searchLinkStyles;
        let t4;
        if ($[0] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $fe3202d1a2ffd60f$var$iconStyles
            }, icon);
            $[0] = icon;
            $[1] = t4;
        } else t4 = $[1];
        let t5;
        if ($[2] !== highlightedTitle || $[3] !== title) {
            t5 = highlightedTitle ? (0, $e2d205701d0a5b5d$export$c43ff622b37ceaa9)(highlightedTitle) : title;
            $[2] = highlightedTitle;
            $[3] = title;
            $[4] = t5;
        } else t5 = $[4];
        let t6;
        if ($[5] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $fe3202d1a2ffd60f$var$titleStyles
            }, t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== subheading) {
            t7 = subheading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $fe3202d1a2ffd60f$var$subheadingStyles
            }, subheading);
            $[7] = subheading;
            $[8] = t7;
        } else t7 = $[8];
        let t8;
        if ($[9] !== description) {
            t8 = description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $fe3202d1a2ffd60f$var$descriptionStyles
            }, description);
            $[9] = description;
            $[10] = t8;
        } else t8 = $[10];
        const t9 = (isKeyboardHighlighted || isMouseHighlighted) && rightPanel;
        let t10;
        if ($[11] !== t3 || $[12] !== t4 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: t3,
                testId: "search-page-dropdown-result"
            }, t4, t6, t7, t8, t9);
            $[11] = t3;
            $[12] = t4;
            $[13] = t6;
            $[14] = t7;
            $[15] = t8;
            $[16] = t9;
            $[17] = t10;
        } else t10 = $[17];
        return t10;
    }
    const t3 = description ? $fe3202d1a2ffd60f$var$searchLinkWithDescriptionStyles : $fe3202d1a2ffd60f$var$searchLinkStyles;
    const t4 = isKeyboardHighlighted ? "color.background.neutral.subtle.hovered" : "color.background.neutral.subtle";
    let t5;
    if ($[18] !== formatMessage) {
        t5 = formatMessage((0, $c3851bfbbb39ba91$export$defe85febe8b728c).searchLinkLabel);
        $[18] = formatMessage;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    let t7;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setIsMouseHighlighted(true);
        t7 = ()=>setIsMouseHighlighted(false);
        $[20] = t6;
        $[21] = t7;
    } else {
        t6 = $[20];
        t7 = $[21];
    }
    let t8;
    if ($[22] !== icon) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $fe3202d1a2ffd60f$var$iconStyles
        }, icon);
        $[22] = icon;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== highlightedTitle || $[25] !== title) {
        t9 = highlightedTitle ? (0, $e2d205701d0a5b5d$export$c43ff622b37ceaa9)(highlightedTitle) : title;
        $[24] = highlightedTitle;
        $[25] = title;
        $[26] = t9;
    } else t9 = $[26];
    let t10;
    if ($[27] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $fe3202d1a2ffd60f$var$titleStyles
        }, t9);
        $[27] = t9;
        $[28] = t10;
    } else t10 = $[28];
    let t11;
    if ($[29] !== subheading) {
        t11 = subheading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $fe3202d1a2ffd60f$var$subheadingStyles
        }, subheading);
        $[29] = subheading;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== description) {
        t12 = description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $fe3202d1a2ffd60f$var$descriptionStyles
        }, description);
        $[31] = description;
        $[32] = t12;
    } else t12 = $[32];
    const t13 = (isKeyboardHighlighted || isMouseHighlighted) && rightPanel;
    let t14;
    if ($[33] !== onClick || $[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t13 || $[38] !== t3 || $[39] !== t4 || $[40] !== t5 || $[41] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            xcss: t3,
            backgroundColor: t4,
            onClick: onClick,
            onMouseDown: $fe3202d1a2ffd60f$var$_temp,
            "aria-label": t5,
            onMouseOver: t6,
            onMouseLeave: t7,
            testId: "search-page-dropdown-result"
        }, t8, t10, t11, t12, t13);
        $[33] = onClick;
        $[34] = t10;
        $[35] = t11;
        $[36] = t12;
        $[37] = t13;
        $[38] = t3;
        $[39] = t4;
        $[40] = t5;
        $[41] = t8;
        $[42] = t14;
    } else t14 = $[42];
    return t14;
} : ({ title: title, description: description, subheading: subheading, icon: icon, onClick: onClick, highlightedTitle: highlightedTitle, rightPanel: rightPanel, asBox: asBox = false, isKeyboardHighlighted: isKeyboardHighlighted = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isMouseHighlighted, setIsMouseHighlighted] = (0, $cozmU.useState)(false);
    if (asBox) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: description ? $fe3202d1a2ffd60f$var$searchLinkWithDescriptionStyles : $fe3202d1a2ffd60f$var$searchLinkStyles,
        testId: "search-page-dropdown-result"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $fe3202d1a2ffd60f$var$iconStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $fe3202d1a2ffd60f$var$titleStyles
    }, highlightedTitle ? (0, $e2d205701d0a5b5d$export$c43ff622b37ceaa9)(highlightedTitle) : title), subheading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $fe3202d1a2ffd60f$var$subheadingStyles
    }, subheading), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $fe3202d1a2ffd60f$var$descriptionStyles
    }, description), (isKeyboardHighlighted || isMouseHighlighted) && rightPanel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        xcss: description ? $fe3202d1a2ffd60f$var$searchLinkWithDescriptionStyles : $fe3202d1a2ffd60f$var$searchLinkStyles,
        backgroundColor: isKeyboardHighlighted ? 'color.background.neutral.subtle.hovered' : 'color.background.neutral.subtle',
        onClick: onClick,
        onMouseDown: (e)=>e.preventDefault(),
        "aria-label": formatMessage((0, $c3851bfbbb39ba91$export$defe85febe8b728c).searchLinkLabel),
        onMouseOver: ()=>setIsMouseHighlighted(true),
        onMouseLeave: ()=>setIsMouseHighlighted(false),
        testId: "search-page-dropdown-result"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $fe3202d1a2ffd60f$var$iconStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $fe3202d1a2ffd60f$var$titleStyles
    }, highlightedTitle ? (0, $e2d205701d0a5b5d$export$c43ff622b37ceaa9)(highlightedTitle) : title), subheading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $fe3202d1a2ffd60f$var$subheadingStyles
    }, subheading), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $fe3202d1a2ffd60f$var$descriptionStyles
    }, description), (isKeyboardHighlighted || isMouseHighlighted) && rightPanel);
};
const $fe3202d1a2ffd60f$export$5b6118e2ff142a50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const { linkComponent: Link } = (0, $d848581de35407c0$export$fdc397e486fa83e7)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            textDecoration: "none",
            color: "inherit"
        };
        $[0] = t0;
    } else t0 = $[0];
    const t1 = props.navigationUrl || "";
    let t2;
    if ($[1] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe3202d1a2ffd60f$var$DropdownResultContent, {
            ...props,
            asBox: true
        });
        $[1] = props;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== Link || $[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Link, {
            style: t0,
            backgroundColor: "color.background.neutral.subtle",
            href: t1
        }, t2);
        $[3] = Link;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : (props)=>{
    const { linkComponent: Link } = (0, $d848581de35407c0$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Link // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: {
            textDecoration: 'none',
            color: 'inherit'
        },
        backgroundColor: "color.background.neutral.subtle",
        href: props.navigationUrl || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe3202d1a2ffd60f$var$DropdownResultContent, {
        ...props,
        asBox: true
    }));
};
const $fe3202d1a2ffd60f$export$f12258e0b62ed378 = (props)=>{
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (!features?.chromeExtension?.enabled) return;
        const { onInputDropdownResultSelect: onInputDropdownResultSelect } = features.chromeExtension;
        onInputDropdownResultSelect({
            title: props.title,
            url: props.navigationUrl
        });
    }, [
        features?.chromeExtension,
        props.title,
        props.navigationUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe3202d1a2ffd60f$var$DropdownResultContent, {
        ...props,
        onClick: onClick
    });
};
const $fe3202d1a2ffd60f$export$bbedf2c4ad87789c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    if (features?.chromeExtension?.enabled) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe3202d1a2ffd60f$export$f12258e0b62ed378, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    } else if (props.navigationUrl) {
        let t0;
        if ($[2] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe3202d1a2ffd60f$export$5b6118e2ff142a50, props);
            $[2] = props;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    } else {
        let t0;
        if ($[4] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe3202d1a2ffd60f$var$DropdownResultContent, props);
            $[4] = props;
            $[5] = t0;
        } else t0 = $[5];
        return t0;
    }
} : (props)=>{
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    if (features?.chromeExtension?.enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe3202d1a2ffd60f$export$f12258e0b62ed378, props);
    else if (props.navigationUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe3202d1a2ffd60f$export$5b6118e2ff142a50, props);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe3202d1a2ffd60f$var$DropdownResultContent, props);
};
function $fe3202d1a2ffd60f$var$_temp(e) {
    return e.preventDefault();
}









const $7ac91a73f02bf5a2$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    searchIconLabel: {
        id: "dynamic-cards-search-page.dropdown_search_icon_label",
        defaultMessage: "Search"
    }
});


const $0331d4dc38b3a1f7$var$iconStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $0331d4dc38b3a1f7$export$14bd3dc13236b3f1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(16);
    const [inputQuery, t0] = (0, $2Va9o.useInputQuery)();
    const { setSearchQuery: setSearchQuery } = t0;
    const [, t1] = (0, $3a2567ac224fb8e0$export$8c32fdb3462273b4)();
    const { setShowDropdown: setShowDropdown } = t1;
    const intl = (0, $kSwu1.useIntl)();
    const [recentSearchResults] = (0, $3a2567ac224fb8e0$export$970bfa0ee111b06)();
    const [autoSuggestionResults] = (0, $3a2567ac224fb8e0$export$30ecbc19a2297251)();
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    let t2;
    if ($[0] !== autoSuggestionResults.results || $[1] !== inputQuery || $[2] !== intl || $[3] !== recentSearchResults || $[4] !== resultCount.autoSuggestion || $[5] !== resultCount.recentSearch || $[6] !== setSearchQuery || $[7] !== setShowDropdown) {
        const recentSearchTitles = recentSearchResults.slice(0, resultCount.recentSearch).map($0331d4dc38b3a1f7$var$_temp);
        const filteredAutoSuggestions = autoSuggestionResults.results.filter((suggestion)=>!recentSearchTitles.includes(suggestion.title.toLowerCase()) && suggestion.title !== inputQuery.toLowerCase()).slice(0, resultCount.autoSuggestion);
        let t3;
        if ($[9] !== inputQuery || $[10] !== intl || $[11] !== setSearchQuery || $[12] !== setShowDropdown) {
            t3 = (suggestion_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
                    title: suggestion_0.title || "",
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                        xcss: $0331d4dc38b3a1f7$var$iconStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                        color: "currentColor",
                        label: intl.formatMessage((0, $7ac91a73f02bf5a2$export$defe85febe8b728c).searchIconLabel)
                    })),
                    onClick: ()=>{
                        setSearchQuery(suggestion_0.title || "");
                        setShowDropdown(false);
                    },
                    highlightedTitle: (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(suggestion_0.title, inputQuery.split(" ")).negatedHighlightedTitle,
                    key: `${index}-${suggestion_0.title}`
                });
            $[9] = inputQuery;
            $[10] = intl;
            $[11] = setSearchQuery;
            $[12] = setShowDropdown;
            $[13] = t3;
        } else t3 = $[13];
        t2 = filteredAutoSuggestions.map(t3);
        $[0] = autoSuggestionResults.results;
        $[1] = inputQuery;
        $[2] = intl;
        $[3] = recentSearchResults;
        $[4] = resultCount.autoSuggestion;
        $[5] = resultCount.recentSearch;
        $[6] = setSearchQuery;
        $[7] = setShowDropdown;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[14] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2);
        $[14] = t2;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
} : ()=>{
    const [inputQuery, { setSearchQuery: setSearchQuery }] = (0, $2Va9o.useInputQuery)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $3a2567ac224fb8e0$export$8c32fdb3462273b4)();
    const intl = (0, $kSwu1.useIntl)();
    const [recentSearchResults] = (0, $3a2567ac224fb8e0$export$970bfa0ee111b06)();
    const [autoSuggestionResults] = (0, $3a2567ac224fb8e0$export$30ecbc19a2297251)();
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    const recentSearchTitles = recentSearchResults.slice(0, resultCount.recentSearch).map((search)=>search.title.toLowerCase());
    const filteredAutoSuggestions = autoSuggestionResults.results.filter((suggestion)=>{
        return !recentSearchTitles.includes(suggestion.title.toLowerCase()) && suggestion.title !== inputQuery.toLowerCase();
    }).slice(0, resultCount.autoSuggestion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, filteredAutoSuggestions.map((suggestion_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
            title: suggestion_0.title || '',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $0331d4dc38b3a1f7$var$iconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                color: "currentColor",
                label: intl.formatMessage((0, $7ac91a73f02bf5a2$export$defe85febe8b728c).searchIconLabel)
            })),
            onClick: ()=>{
                setSearchQuery(suggestion_0.title || '');
                setShowDropdown(false);
            },
            highlightedTitle: (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(suggestion_0.title, inputQuery.split(' ')).negatedHighlightedTitle,
            key: `${index}-${suggestion_0.title}`
        })));
};
function $0331d4dc38b3a1f7$var$_temp(search) {
    return search.title.toLowerCase();
}





const $ecbff6b625e51b62$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    searchSuggestionsDropdownLabel: {
        id: "dynamic-cards-search-page.dropdown.search-suggestions-label",
        defaultMessage: "Search Suggestions Dropdown"
    }
});































const $206945ce43168a9e$export$4501fc029b186da8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "20",
            rx: "3",
            fill: "var(--ds-background-neutral, #0515240F)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "nonzero",
            d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
            fill: "var(--ds-icon-subtle, #505258)"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "20",
        rx: "3",
        fill: "var(--ds-background-neutral, #0515240F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "nonzero",
        d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
        fill: "var(--ds-icon-subtle, #505258)"
    }));










const $3a42d866794d2267$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    search: {
        id: "dynamic-cards-search-page.dropdown_search",
        defaultMessage: "Search"
    },
    searchIconLabel: {
        id: "dynamic-cards-search-page.dropdown_search_icon_label",
        defaultMessage: "Search"
    }
});


const $e6d9ac5c94f26f67$var$iconStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $e6d9ac5c94f26f67$var$subheadingTextWrapper = (0, $buxP3.xcss)({
    marginRight: 'space.100'
});
const $e6d9ac5c94f26f67$export$4a7d659f3bdb9018 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const intl = (0, $kSwu1.useIntl)();
    const [inputQuery] = (0, $2Va9o.useInputQuery)();
    const { triggerSearch: triggerSearch } = (0, $2Va9o.useSearchActions)();
    const { setShowDropdown: setShowDropdown } = (0, $3a2567ac224fb8e0$export$4e8b5ffe8cfc8886)();
    let t0;
    if ($[0] !== inputQuery || $[1] !== intl || $[2] !== setShowDropdown || $[3] !== triggerSearch) {
        t0 = inputQuery.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
            title: inputQuery,
            subheading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $e6d9ac5c94f26f67$var$subheadingTextWrapper
            }, intl.formatMessage((0, $3a42d866794d2267$export$defe85febe8b728c).search)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $206945ce43168a9e$export$4501fc029b186da8), null)),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $e6d9ac5c94f26f67$var$iconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                color: "currentColor",
                label: intl.formatMessage((0, $3a42d866794d2267$export$defe85febe8b728c).searchIconLabel)
            })),
            onClick: ()=>{
                setShowDropdown(false);
                triggerSearch();
            }
        });
        $[0] = inputQuery;
        $[1] = intl;
        $[2] = setShowDropdown;
        $[3] = triggerSearch;
        $[4] = t0;
    } else t0 = $[4];
    let t1;
    if ($[5] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0);
        $[5] = t0;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const [inputQuery] = (0, $2Va9o.useInputQuery)();
    const { triggerSearch: triggerSearch } = (0, $2Va9o.useSearchActions)();
    const { setShowDropdown: setShowDropdown } = (0, $3a2567ac224fb8e0$export$4e8b5ffe8cfc8886)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, inputQuery.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
        title: inputQuery,
        subheading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $e6d9ac5c94f26f67$var$subheadingTextWrapper
        }, intl.formatMessage((0, $3a42d866794d2267$export$defe85febe8b728c).search)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $206945ce43168a9e$export$4501fc029b186da8), null)),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $e6d9ac5c94f26f67$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            color: "currentColor",
            label: intl.formatMessage((0, $3a42d866794d2267$export$defe85febe8b728c).searchIconLabel)
        })),
        onClick: ()=>{
            setShowDropdown(false);
            triggerSearch();
        }
    }));
};
























var $cJ0FD = parcelRequire("cJ0FD");








const $315d557f08ee9463$var$resultStateContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: 'space.400',
    marginBottom: 'space.100'
});
const $315d557f08ee9463$var$imageContainerStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.150'
});
const $315d557f08ee9463$var$primaryTextContainerStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.150',
    font: 'font.heading.medium',
    fontWeight: 'font.weight.medium'
});
const $315d557f08ee9463$var$secondaryTextContainerStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.200'
});
const $315d557f08ee9463$export$d9172702747fb4bc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { imageSrcLight: imageSrcLight, imageSrcDark: imageSrcDark, imageWidth: imageWidth, imageHeight: imageHeight, primaryText: primaryText, secondaryText: secondaryText, callToAction: callToAction, testId: testId } = t0;
    const t1 = imageWidth || "124px";
    const t2 = imageHeight || "124px";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            width: t1,
            height: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== imageSrcDark || $[4] !== imageSrcLight) {
        t4 = imageSrcLight && imageSrcDark && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: imageSrcLight,
            srcDark: imageSrcDark,
            alt: ""
        });
        $[3] = imageSrcDark;
        $[4] = imageSrcLight;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $315d557f08ee9463$var$imageContainerStyles,
            style: t3
        }, t4);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== primaryText) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $315d557f08ee9463$var$primaryTextContainerStyles
        }, primaryText);
        $[9] = primaryText;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== secondaryText) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $315d557f08ee9463$var$secondaryTextContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), null, secondaryText));
        $[11] = secondaryText;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== callToAction) {
        t8 = callToAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, callToAction);
        $[13] = callToAction;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 || $[19] !== testId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $315d557f08ee9463$var$resultStateContainerStyles,
            testId: testId
        }, t5, t6, t7, t8);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
        $[19] = testId;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
} : ({ imageSrcLight: imageSrcLight, imageSrcDark: imageSrcDark, imageWidth: imageWidth, imageHeight: imageHeight, primaryText: primaryText, secondaryText: secondaryText, callToAction: callToAction, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $315d557f08ee9463$var$resultStateContainerStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $315d557f08ee9463$var$imageContainerStyles,
        style: {
            width: imageWidth || '124px',
            height: imageHeight || '124px'
        }
    }, imageSrcLight && imageSrcDark && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: imageSrcLight,
        srcDark: imageSrcDark,
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $315d557f08ee9463$var$primaryTextContainerStyles
    }, primaryText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $315d557f08ee9463$var$secondaryTextContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), null, secondaryText)), callToAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, callToAction));
};


var $21e02e87bb5671d3$exports = {};
$21e02e87bb5671d3$exports = new URL("no-results-dark.a00ae47b.svg", import.meta.url).toString();


var $cbcd8977aff38c31$exports = {};
$cbcd8977aff38c31$exports = new URL("no-results-light.5ca83755.svg", import.meta.url).toString();





const $20072af14e90025d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noResultsPrimary: {
        id: "dynamic-cards-search-page.no_results_primary",
        defaultMessage: "We couldn't find anything matching your search"
    }
});


const $5b536d286c5e1134$export$73c06a78041d5456 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $315d557f08ee9463$export$d9172702747fb4bc), {
            imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($cbcd8977aff38c31$exports))),
            imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($21e02e87bb5671d3$exports))),
            primaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $20072af14e90025d$export$defe85febe8b728c).noResultsPrimary),
            secondaryText: ""
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $315d557f08ee9463$export$d9172702747fb4bc), {
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($cbcd8977aff38c31$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($21e02e87bb5671d3$exports))),
        primaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $20072af14e90025d$export$defe85febe8b728c).noResultsPrimary),
        secondaryText: ""
    });
};


























var $5rA68 = parcelRequire("5rA68");

const $e96c73d010d50533$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
// copied over from @confluence/hash
const $e96c73d010d50533$var$hash = (algorithm, data, asBytes = false)=>{
    const hashObj = (0, (/*@__PURE__*/$parcel$interopDefault($5rA68))).createHash(algorithm);
    hashObj.update(data);
    if (asBytes) return Array.from(hashObj.digest());
    return hashObj.digest('hex');
};
const $e96c73d010d50533$export$5fdf8c875acfc1b3 = (data)=>{
    return $e96c73d010d50533$var$hash('sha256', data, true);
};
const $e96c73d010d50533$export$7904c6256691057a = (data)=>{
    return $e96c73d010d50533$var$hash('sha256', data);
};
const $e96c73d010d50533$export$451f7a1e7c934f54 = (userId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return `/wiki/people/${userId}`;
    else if (primaryProduct === 'townsquare') return `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
};
const $e96c73d010d50533$export$9456a8e088bfede1 = (teamId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return `/wiki/people/team/${teamId}`;
    else if (primaryProduct === 'townsquare') return `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
};










const $1e00d04be204e064$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    teamLabel: {
        id: "dynamic-cards-search-page.team",
        defaultMessage: "Team"
    }
});


const $84612d176bf52d0c$export$9d052a57a86e166 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(20);
    const intl = (0, $kSwu1.useIntl)();
    const [cloudId] = (0, $122441d1a555945e$export$9da0f7c65f28ed16)();
    const [orgId] = (0, $122441d1a555945e$export$52a03a3207af3687)();
    const [inputQuery] = (0, $2Va9o.useInputQuery)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [, t0] = (0, $3a2567ac224fb8e0$export$8c32fdb3462273b4)();
    const { setShowDropdown: setShowDropdown } = t0;
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    const [peopleAndTeamsResults] = (0, $3a2567ac224fb8e0$export$c30c238644aa02ee)();
    let t1;
    if ($[0] !== setShowDropdown) {
        t1 = ()=>{
            setShowDropdown(false);
        };
        $[0] = setShowDropdown;
        $[1] = t1;
    } else t1 = $[1];
    const onClick = t1;
    let t2;
    if ($[2] !== cloudId || $[3] !== inputQuery || $[4] !== intl || $[5] !== onClick || $[6] !== orgId || $[7] !== peopleAndTeamsResults.results || $[8] !== primaryProduct || $[9] !== resultCount.peopleAndTeams) {
        let t3;
        if ($[11] !== cloudId || $[12] !== inputQuery || $[13] !== intl || $[14] !== onClick || $[15] !== orgId || $[16] !== primaryProduct) {
            t3 = (result, index)=>{
                if (result.entityType === (0, $aNJkw.EntityType).USER && result.name) {
                    const navigationUrl = primaryProduct && cloudId && orgId && (0, $e96c73d010d50533$export$451f7a1e7c934f54)(result.id, primaryProduct, orgId, cloudId);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($84612d176bf52d0c$var$PeopleAndTeamsLink, {
                        title: result.name,
                        description: result.title,
                        avatarUrl: result.avatarUrl,
                        onClick: onClick,
                        inputQuery: inputQuery,
                        key: `${index}-${result.name}`,
                        navigationUrl: navigationUrl || ""
                    });
                } else if (result.entityType === (0, $aNJkw.EntityType).TEAM && result.displayName) {
                    const navigationUrl_0 = primaryProduct && cloudId && orgId && (0, $e96c73d010d50533$export$9456a8e088bfede1)(result.id, primaryProduct, orgId, cloudId);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($84612d176bf52d0c$var$PeopleAndTeamsLink, {
                        title: result.displayName,
                        description: intl.formatMessage((0, $1e00d04be204e064$export$defe85febe8b728c).teamLabel),
                        avatarUrl: result?.smallAvatarImageUrl,
                        onClick: onClick,
                        inputQuery: inputQuery,
                        key: `${index}-${result.name}`,
                        navigationUrl: navigationUrl_0 || ""
                    });
                }
            };
            $[11] = cloudId;
            $[12] = inputQuery;
            $[13] = intl;
            $[14] = onClick;
            $[15] = orgId;
            $[16] = primaryProduct;
            $[17] = t3;
        } else t3 = $[17];
        t2 = peopleAndTeamsResults.results.slice(0, resultCount.peopleAndTeams).map(t3);
        $[2] = cloudId;
        $[3] = inputQuery;
        $[4] = intl;
        $[5] = onClick;
        $[6] = orgId;
        $[7] = peopleAndTeamsResults.results;
        $[8] = primaryProduct;
        $[9] = resultCount.peopleAndTeams;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[18] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2);
        $[18] = t2;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const [cloudId] = (0, $122441d1a555945e$export$9da0f7c65f28ed16)();
    const [orgId] = (0, $122441d1a555945e$export$52a03a3207af3687)();
    const [inputQuery] = (0, $2Va9o.useInputQuery)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $3a2567ac224fb8e0$export$8c32fdb3462273b4)();
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    const [peopleAndTeamsResults] = (0, $3a2567ac224fb8e0$export$c30c238644aa02ee)();
    const onClick = ()=>{
        setShowDropdown(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, peopleAndTeamsResults.results.slice(0, resultCount.peopleAndTeams).map((result, index)=>{
        if (result.entityType === (0, $aNJkw.EntityType).USER && result.name) {
            const navigationUrl = primaryProduct && cloudId && orgId && (0, $e96c73d010d50533$export$451f7a1e7c934f54)(result.id, primaryProduct, orgId, cloudId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($84612d176bf52d0c$var$PeopleAndTeamsLink, {
                title: result.name,
                description: result.title,
                avatarUrl: result.avatarUrl,
                onClick: onClick,
                inputQuery: inputQuery,
                key: `${index}-${result.name}`,
                navigationUrl: navigationUrl || ''
            });
        } else if (result.entityType === (0, $aNJkw.EntityType).TEAM && result.displayName) {
            const navigationUrl_0 = primaryProduct && cloudId && orgId && (0, $e96c73d010d50533$export$9456a8e088bfede1)(result.id, primaryProduct, orgId, cloudId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($84612d176bf52d0c$var$PeopleAndTeamsLink, {
                title: result.displayName,
                description: intl.formatMessage((0, $1e00d04be204e064$export$defe85febe8b728c).teamLabel),
                avatarUrl: result?.smallAvatarImageUrl,
                onClick: onClick,
                inputQuery: inputQuery,
                key: `${index}-${result.name}`,
                navigationUrl: navigationUrl_0 || ''
            });
        }
    }));
};
const $84612d176bf52d0c$var$iconStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.full',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $84612d176bf52d0c$var$PeopleAndTeamsLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { title: title, description: t1, avatarUrl: t2, inputQuery: inputQuery, onClick: onClick, navigationUrl: navigationUrl } = t0;
    const description = t1 === undefined ? "" : t1;
    const avatarUrl = t2 === undefined ? "" : t2;
    let t3;
    if ($[0] !== avatarUrl) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84612d176bf52d0c$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarUrl,
            size: "small"
        }));
        $[0] = avatarUrl;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== inputQuery || $[3] !== title) {
        t4 = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(title, inputQuery.split(" "));
        $[2] = inputQuery;
        $[3] = title;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== description || $[6] !== navigationUrl || $[7] !== onClick || $[8] !== t3 || $[9] !== t4.highlightedTitle || $[10] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
            title: title,
            description: description,
            icon: t3,
            onClick: onClick,
            highlightedTitle: t4.highlightedTitle,
            navigationUrl: navigationUrl
        });
        $[5] = description;
        $[6] = navigationUrl;
        $[7] = onClick;
        $[8] = t3;
        $[9] = t4.highlightedTitle;
        $[10] = title;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ title: title, description: description = '', avatarUrl: avatarUrl = '', inputQuery: inputQuery, onClick: onClick, navigationUrl: navigationUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
        title: title,
        description: description,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84612d176bf52d0c$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarUrl,
            size: "small"
        })),
        onClick: onClick,
        highlightedTitle: (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(title, inputQuery.split(' ')).highlightedTitle,
        navigationUrl: navigationUrl
    });



















const $61de23962fda5bbf$var$iconStyles = (0, $buxP3.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $61de23962fda5bbf$export$8def3ebb7c3d38c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    const [, t0] = (0, $3a2567ac224fb8e0$export$8c32fdb3462273b4)();
    const { setShowDropdown: setShowDropdown } = t0;
    let t1;
    if ($[0] !== setShowDropdown) {
        t1 = ()=>{
            setShowDropdown(false);
        };
        $[0] = setShowDropdown;
        $[1] = t1;
    } else t1 = $[1];
    const onClick = t1;
    const [quickSearchResults] = (0, $3a2567ac224fb8e0$export$369bf1e7413c2c02)();
    let t2;
    if ($[2] !== onClick || $[3] !== quickSearchResults || $[4] !== resultCount.quickSearch) {
        let t3;
        if ($[6] !== onClick) {
            t3 = (result, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
                    title: result.title,
                    description: result.description,
                    subheading: result.subheading,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                        xcss: $61de23962fda5bbf$var$iconStyles
                    }, result.icon),
                    onClick: onClick,
                    highlightedTitle: result.highlightedTitle,
                    key: `${index}-${result.title}`,
                    navigationUrl: result.navigationUrl
                });
            $[6] = onClick;
            $[7] = t3;
        } else t3 = $[7];
        t2 = quickSearchResults.slice(0, resultCount.quickSearch).map(t3);
        $[2] = onClick;
        $[3] = quickSearchResults;
        $[4] = resultCount.quickSearch;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2);
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ()=>{
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $3a2567ac224fb8e0$export$8c32fdb3462273b4)();
    const onClick = ()=>{
        setShowDropdown(false);
    };
    const [quickSearchResults] = (0, $3a2567ac224fb8e0$export$369bf1e7413c2c02)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, quickSearchResults.slice(0, resultCount.quickSearch).map((result, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
            title: result.title,
            description: result.description,
            subheading: result.subheading,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $61de23962fda5bbf$var$iconStyles
            }, result.icon),
            onClick: onClick,
            highlightedTitle: result.highlightedTitle,
            key: `${index}-${result.title}`,
            navigationUrl: result.navigationUrl
        })));
};















var $1sCHt = parcelRequire("1sCHt");


var $5ZtfK = parcelRequire("5ZtfK");


var $l3wuH = parcelRequire("l3wuH");















const $d201141df91505ae$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    recentSearchIconLabel: {
        id: "dynamic-cards-search-page.dropdown_recent_icon_label",
        defaultMessage: "Recent"
    },
    removeRecentSearchIcon: {
        id: "dynamic-cards-search-page.search-result.remove-recent-search",
        defaultMessage: "Remove recent search icon"
    },
    removeRecentSearchSubheading: {
        id: "dynamic-cards-search-page.search-result.remove-recent-search-result-subheading",
        defaultMessage: "Recent search"
    }
});


const $4e8967551d768a88$var$iconStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $4e8967551d768a88$export$e4bc6828df5bf4e8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const { setSearchQuery: setSearchQuery } = (0, $2Va9o.useSearchActions)();
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    const [, t0] = (0, $3a2567ac224fb8e0$export$8c32fdb3462273b4)();
    const { setShowDropdown: setShowDropdown } = t0;
    let t1;
    if ($[0] !== setSearchQuery || $[1] !== setShowDropdown) {
        t1 = (query)=>{
            setShowDropdown(false);
            setSearchQuery(query);
        };
        $[0] = setSearchQuery;
        $[1] = setShowDropdown;
        $[2] = t1;
    } else t1 = $[2];
    const onClick = t1;
    const [recentSearches] = (0, $3a2567ac224fb8e0$export$970bfa0ee111b06)();
    let t2;
    if ($[3] !== onClick || $[4] !== recentSearches || $[5] !== resultCount.recentSearch) {
        let t3;
        if ($[7] !== onClick) {
            t3 = (result, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
                    title: result.title,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e8967551d768a88$export$aa64f88f83123fb7, null),
                    onClick: ()=>onClick(result.title),
                    key: `${index}-${result.title}`,
                    rightPanel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e8967551d768a88$export$ea04c1e9e2b7cc14, {
                        title: result.title
                    })
                });
            $[7] = onClick;
            $[8] = t3;
        } else t3 = $[8];
        t2 = recentSearches.slice(0, resultCount.recentSearch).map(t3);
        $[3] = onClick;
        $[4] = recentSearches;
        $[5] = resultCount.recentSearch;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2);
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ()=>{
    const { setSearchQuery: setSearchQuery } = (0, $2Va9o.useSearchActions)();
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $3a2567ac224fb8e0$export$8c32fdb3462273b4)();
    const onClick = (query)=>{
        setShowDropdown(false);
        setSearchQuery(query);
    };
    const [recentSearches] = (0, $3a2567ac224fb8e0$export$970bfa0ee111b06)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, recentSearches.slice(0, resultCount.recentSearch).map((result, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
            title: result.title,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e8967551d768a88$export$aa64f88f83123fb7, null),
            onClick: ()=>onClick(result.title),
            key: `${index}-${result.title}`,
            rightPanel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e8967551d768a88$export$ea04c1e9e2b7cc14, {
                title: result.title
            })
        })));
};
const $4e8967551d768a88$export$aa64f88f83123fb7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $d201141df91505ae$export$defe85febe8b728c).recentSearchIconLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $4e8967551d768a88$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            color: "currentColor",
            label: t0,
            spacing: "spacious"
        }));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $4e8967551d768a88$var$iconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
        color: "currentColor",
        label: intl.formatMessage((0, $d201141df91505ae$export$defe85febe8b728c).recentSearchIconLabel),
        spacing: "spacious"
    }));
};
const $4e8967551d768a88$var$recentSearchRightPanelStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    font: 'font.body.small'
});
const $4e8967551d768a88$var$subheadingStyles = (0, $buxP3.xcss)({
    marginRight: 'space.150'
});
const $4e8967551d768a88$export$ea04c1e9e2b7cc14 = ({ title: title })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [{ user: user, primaryProduct: primaryProduct }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { setRecentSearchResults: setRecentSearchResults } = (0, $3a2567ac224fb8e0$export$4e8b5ffe8cfc8886)();
    const onClick = (0, $cozmU.useCallback)((event)=>{
        event.stopPropagation();
        if (user?.id && primaryProduct) {
            const newRecentSearches = (0, $7467e526334959ee$export$6adb2cc1366d1e30)(title, user.id, primaryProduct, (0, $7467e526334959ee$export$ec4722d39a5031c0)).map((searchTitle)=>({
                    // Todo: cleanup this so that we only need to pass the search title.
                    title: searchTitle,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
                    onClick: ()=>null
                }));
            setRecentSearchResults(newRecentSearches);
        }
    }, [
        primaryProduct,
        title,
        setRecentSearchResults,
        user?.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $4e8967551d768a88$var$recentSearchRightPanelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        as: "span",
        xcss: $4e8967551d768a88$var$subheadingStyles
    }, intl.formatMessage((0, $d201141df91505ae$export$defe85febe8b728c).removeRecentSearchSubheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                label: intl.formatMessage((0, $d201141df91505ae$export$defe85febe8b728c).removeRecentSearchIcon),
                color: "currentColor"
            }),
        spacing: 'compact',
        onClick: onClick,
        label: intl.formatMessage((0, $d201141df91505ae$export$defe85febe8b728c).removeRecentSearchIcon),
        appearance: 'subtle'
    }));
};


















const $caaee91fb514e9cf$var$iconStyles = (0, $buxP3.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $caaee91fb514e9cf$export$c68af787f8f88afe = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [recentViewsResults] = (0, $3a2567ac224fb8e0$export$f53e0f96bec5ea4d)();
    const { setShowDropdown: setShowDropdown } = (0, $3a2567ac224fb8e0$export$4e8b5ffe8cfc8886)();
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    let t0;
    if ($[0] !== setShowDropdown) {
        t0 = ()=>{
            setShowDropdown(false);
        };
        $[0] = setShowDropdown;
        $[1] = t0;
    } else t0 = $[1];
    const onClick = t0;
    let t1;
    if ($[2] !== onClick || $[3] !== recentViewsResults || $[4] !== resultCount) {
        t1 = recentViewsResults?.slice(0, resultCount.recentViews).map((result, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
                title: result.title,
                description: result.description,
                subheading: result.subheading,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    xcss: $caaee91fb514e9cf$var$iconStyles
                }, result.icon),
                onClick: onClick,
                highlightedTitle: result.highlightedTitle,
                key: `${index}-${result.title}`,
                navigationUrl: result.navigationUrl
            }));
        $[2] = onClick;
        $[3] = recentViewsResults;
        $[4] = resultCount;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const [recentViewsResults] = (0, $3a2567ac224fb8e0$export$f53e0f96bec5ea4d)();
    const { setShowDropdown: setShowDropdown } = (0, $3a2567ac224fb8e0$export$4e8b5ffe8cfc8886)();
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    const onClick = ()=>{
        setShowDropdown(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, recentViewsResults?.slice(0, resultCount.recentViews).map((result, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3202d1a2ffd60f$export$bbedf2c4ad87789c), {
            title: result.title,
            description: result.description,
            subheading: result.subheading,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $caaee91fb514e9cf$var$iconStyles
            }, result.icon),
            onClick: onClick,
            highlightedTitle: result.highlightedTitle,
            key: `${index}-${result.title}`,
            navigationUrl: result.navigationUrl
        });
    }));
};


const $765219d4c0e21bfb$var$searchDropdownStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    gap: 'space.025',
    boxShadow: 'elevation.shadow.overlay',
    borderWidth: '0',
    boxSizing: 'border-box'
});
const $765219d4c0e21bfb$export$e33d60b8f4099ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { inputWidth: inputWidth } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $35d27cf6b5f8ffc6$export$4e2bef15a5b74b17)();
    const [dropdownLoading] = (0, $3a2567ac224fb8e0$export$41ba39ed718e7414)();
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    const [components] = (0, $122441d1a555945e$export$7c355de7fd01eb66)();
    const [query] = (0, $2Va9o.useInputQuery)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $d848581de35407c0$export$fdc397e486fa83e7)();
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    let t1;
    if ($[0] !== resultCount) {
        t1 = Object.values(resultCount).reduce($765219d4c0e21bfb$var$_temp, 0);
        $[0] = resultCount;
        $[1] = t1;
    } else t1 = $[1];
    const totalResultCount = t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let footerComponent = null;
    if (components?.footer !== undefined) {
        if (typeof components.footer === "function") {
            let t2;
            if ($[2] !== components || $[3] !== generateSearchUrl || $[4] !== query || $[5] !== queryParams) {
                t2 = components.footer(generateSearchUrl({
                    ...queryParams,
                    text: query
                }));
                $[2] = components;
                $[3] = generateSearchUrl;
                $[4] = query;
                $[5] = queryParams;
                $[6] = t2;
            } else t2 = $[6];
            footerComponent = t2;
        } else if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(components.footer)) footerComponent = components.footer;
    }
    const t2 = `${inputWidth}px`;
    let t3;
    if ($[7] !== t2) {
        t3 = {
            width: t2
        };
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== formatMessage) {
        t4 = formatMessage((0, $ecbff6b625e51b62$export$defe85febe8b728c).searchSuggestionsDropdownLabel);
        $[9] = formatMessage;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== dropdownLoading || $[12] !== features?.inlineSearch?.enabled) {
        t5 = dropdownLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, Boolean(features?.inlineSearch?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6d9ac5c94f26f67$export$4a7d659f3bdb9018), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a7094d498c2eb578$export$772547de01833b56), null));
        $[11] = dropdownLoading;
        $[12] = features?.inlineSearch?.enabled;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== dropdownLoading || $[15] !== totalResultCount) {
        t6 = !dropdownLoading && totalResultCount === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b536d286c5e1134$export$73c06a78041d5456), null);
        $[14] = dropdownLoading;
        $[15] = totalResultCount;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== dropdownLoading || $[18] !== features?.autoSuggestion?.enabled || $[19] !== features?.inlineSearch?.enabled || $[20] !== features?.peopleAndTeamsSearch?.enabled || $[21] !== features?.quickSearch?.enabled || $[22] !== features?.recentSearches?.enabled || $[23] !== features?.recentViews?.enabled || $[24] !== footerComponent || $[25] !== totalResultCount) {
        t7 = !dropdownLoading && totalResultCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, Boolean(features?.inlineSearch?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6d9ac5c94f26f67$export$4a7d659f3bdb9018), null), Boolean(features?.autoSuggestion?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0331d4dc38b3a1f7$export$14bd3dc13236b3f1), null), Boolean(features?.recentSearches?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e8967551d768a88$export$e4bc6828df5bf4e8), null), Boolean(features?.peopleAndTeamsSearch?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $84612d176bf52d0c$export$9d052a57a86e166), null), Boolean(features?.recentViews?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $caaee91fb514e9cf$export$c68af787f8f88afe), null), Boolean(features?.quickSearch?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61de23962fda5bbf$export$8def3ebb7c3d38c), null), footerComponent);
        $[17] = dropdownLoading;
        $[18] = features?.autoSuggestion?.enabled;
        $[19] = features?.inlineSearch?.enabled;
        $[20] = features?.peopleAndTeamsSearch?.enabled;
        $[21] = features?.quickSearch?.enabled;
        $[22] = features?.recentSearches?.enabled;
        $[23] = features?.recentViews?.enabled;
        $[24] = footerComponent;
        $[25] = totalResultCount;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] !== t3 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $765219d4c0e21bfb$var$searchDropdownStyles,
            style: t3,
            "aria-label": t4,
            testId: "search-suggestions-dropdown",
            ref: containerRef
        }, t5, t6, t7);
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
        $[30] = t6;
        $[31] = t7;
        $[32] = t8;
    } else t8 = $[32];
    return t8;
} : ({ inputWidth: inputWidth })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $35d27cf6b5f8ffc6$export$4e2bef15a5b74b17)();
    const [dropdownLoading] = (0, $3a2567ac224fb8e0$export$41ba39ed718e7414)();
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    const [components] = (0, $122441d1a555945e$export$7c355de7fd01eb66)();
    const [query] = (0, $2Va9o.useInputQuery)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $d848581de35407c0$export$fdc397e486fa83e7)();
    const [resultCount] = (0, $3a2567ac224fb8e0$export$22da568447791223)();
    const totalResultCount = Object.values(resultCount).reduce((sum, count)=>sum + count, 0);
    const containerRef = (0, $cozmU.useRef)(null);
    let footerComponent = null;
    if (components?.footer !== undefined) {
        if (typeof components.footer === 'function') footerComponent = components.footer(generateSearchUrl({
            ...queryParams,
            text: query
        }));
        else if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(components.footer)) footerComponent = components.footer;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $765219d4c0e21bfb$var$searchDropdownStyles,
        style: {
            width: `${inputWidth}px`
        },
        "aria-label": formatMessage((0, $ecbff6b625e51b62$export$defe85febe8b728c).searchSuggestionsDropdownLabel),
        testId: 'search-suggestions-dropdown',
        ref: containerRef
    }, dropdownLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, Boolean(features?.inlineSearch?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6d9ac5c94f26f67$export$4a7d659f3bdb9018), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a7094d498c2eb578$export$772547de01833b56), null)), !dropdownLoading && totalResultCount === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b536d286c5e1134$export$73c06a78041d5456), null), !dropdownLoading && totalResultCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, Boolean(features?.inlineSearch?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6d9ac5c94f26f67$export$4a7d659f3bdb9018), null), Boolean(features?.autoSuggestion?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0331d4dc38b3a1f7$export$14bd3dc13236b3f1), null), Boolean(features?.recentSearches?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e8967551d768a88$export$e4bc6828df5bf4e8), null), Boolean(features?.peopleAndTeamsSearch?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $84612d176bf52d0c$export$9d052a57a86e166), null), Boolean(features?.recentViews?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $caaee91fb514e9cf$export$c68af787f8f88afe), null), Boolean(features?.quickSearch?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61de23962fda5bbf$export$8def3ebb7c3d38c), null), footerComponent));
};
function $765219d4c0e21bfb$var$_temp(sum, count) {
    return sum + count;
}


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 





var $9aYkv = parcelRequire("9aYkv");



















var $lfoFx = parcelRequire("lfoFx");


var $4yg9g = parcelRequire("4yg9g");










const $0922fb65a417b9c9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    searchIconLabel: {
        id: "dynamic-cards-search-page.input_search_icon_label",
        defaultMessage: "Search"
    },
    clearIconLabel: {
        id: "dynamic-cards-search-page.input_clear_icon_label",
        defaultMessage: "Clear"
    },
    inputPlaceholder: {
        id: "dynamic-cards-search-page.input_placeholder",
        defaultMessage: "Search or ask anything"
    },
    inputPlaceholderSearchOnly: {
        id: "dynamic-cards-search-page.input_placeholder_search_only",
        defaultMessage: "Search anything"
    }
});


const $0e7ab459a082b03b$var$textFieldBoxStyles = (0, $buxP3.xcss)({
    height: 'space.500',
    flexGrow: 1
});
const $0e7ab459a082b03b$var$cssOverrideWrapperStyles = null;
const $0e7ab459a082b03b$var$searchIconWrapperStyles = (0, $buxP3.xcss)({
    minWidth: 'size.200',
    minHeight: 'size.200',
    marginLeft: 'space.100',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $0e7ab459a082b03b$var$clearIconStyles = (0, $buxP3.xcss)({
    marginRight: 'space.100'
});
const $0e7ab459a082b03b$export$1d3bcc092e622e3d = 'ch-search-text-query-input';
const $0e7ab459a082b03b$export$fb8d8fbc0c4c1705 = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { onSubmit: onSubmit } = props;
    let hasReceivedFocus = props.hasReceivedFocus ? props.hasReceivedFocus : ()=>{};
    const [isLoading] = (0, $2Va9o.useIsLoading)();
    const intl = (0, $kSwu1.useIntl)();
    const [query, { setInputQuery: setInputQuery, triggerSearch: triggerSearch }] = (0, $2Va9o.useSearchQuery)();
    const [localQuery, setLocalQuery] = (0, $cozmU.useState)(query);
    const [{ primaryProduct: primaryProduct, user: user }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const [userWithStatus] = (0, $122441d1a555945e$export$23bbbc4533528f03)();
    const [showDropdown, { setShowDropdown: setShowDropdown }] = (0, $3a2567ac224fb8e0$export$8c32fdb3462273b4)();
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    const isUserAuthenticated = userWithStatus.status === (0, $aaa3fcc9c0025f59$export$a82073022ded66e8).Authenticated; // Sync local query with input query
    (0, $cozmU.useEffect)(()=>{
        setInputQuery(localQuery);
    }, [
        setInputQuery,
        localQuery
    ]); // Sync search query with local query
    // on search query change, determine intent / get smart answer route
    (0, $cozmU.useEffect)(()=>{
        setLocalQuery(query);
    }, [
        query,
        setLocalQuery
    ]);
    const [inputQuery] = (0, $2Va9o.useInputQuery)();
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams } = (0, $d848581de35407c0$export$fdc397e486fa83e7)();
    const handleOnSubmit = ()=>{
        // Store search in recent searches
        if (localQuery.trim() !== '' && user && user.id && primaryProduct) (0, $7467e526334959ee$export$74e99d9695eabee6)(localQuery, user.id, primaryProduct, (0, $7467e526334959ee$export$ec4722d39a5031c0));
         // Handles the delegated UI events like closing the dropdown
        if (onSubmit) onSubmit();
        if (features?.chromeExtension?.enabled) {
            features.chromeExtension.onInputSubmit({
                query: localQuery
            });
            return;
        } // If quick search is enabled, we don't want to trigger whole page search
        if (features?.quickSearch?.enabled) {
            onNavigate(generateSearchUrl({
                ...queryParams,
                text: inputQuery
            }), 'push');
            return;
        }
        triggerSearch();
    };
    const onChange = (e)=>{
        setLocalQuery(e.currentTarget.value);
        hasReceivedFocus();
        if (e.currentTarget.value === '' && !isUserAuthenticated) setShowDropdown(false);
        else if (e.currentTarget.value !== '') setShowDropdown(true);
    };
    const onClick = ()=>{
        hasReceivedFocus();
        if (localQuery === '' && !isUserAuthenticated) setShowDropdown(false);
    };
    const onKeyPress = (event)=>{
        if (event.key === 'Enter') {
            handleOnSubmit();
            event.currentTarget.blur();
        }
    };
    const onKeyDown = (event_0)=>{
        if (event_0.key === 'ArrowDown') hasReceivedFocus();
        if (showDropdown && event_0.key === 'Tab') {
            if (onSubmit) onSubmit();
        }
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $0e7ab459a082b03b$var$textFieldBoxStyles,
        ref: ref
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2kvw12KTcp _4ax6G7NvrM _1kNrnzUF4f",
            props.styleOverrides?.borderRadius && "_0TaA34bdUk",
            props.styleOverrides?.textColor && "_1Su2HTkaja _3nYAgEkaja",
            props.styleOverrides?.backgroundColor && "_0rts8oCRcw _1RwOt4CRcw _1nWO32CRcw"
        ]),
        style: {
            "--_ek0kxz": (0, $9aYkv.default)(props.styleOverrides?.borderRadius),
            "--_1tv6lz7": (0, $9aYkv.default)(props.styleOverrides?.textColor),
            "--_1pi6qsr": (0, $9aYkv.default)(props.styleOverrides?.backgroundColor)
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default), {
        ref: props.keyboardRef,
        id: $0e7ab459a082b03b$export$1d3bcc092e622e3d,
        testId: $0e7ab459a082b03b$export$1d3bcc092e622e3d,
        value: localQuery,
        onKeyPress: (event_1)=>onKeyPress(event_1),
        onKeyDown: (event_2)=>onKeyDown(event_2),
        onChange: onChange,
        onClick: onClick,
        autoComplete: "off",
        isReadOnly: props.isReadOnly,
        placeholder: props.styleOverrides?.placeholder ?? intl.formatMessage((0, $0922fb65a417b9c9$export$defe85febe8b728c).inputPlaceholderSearchOnly),
        elemBeforeInput: /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $0e7ab459a082b03b$var$searchIconWrapperStyles
        }, isLoading ? /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: "search-page-input-spinner",
            size: "small",
            appearance: "inherit"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            color: props.styleOverrides?.textColor ? props.styleOverrides?.textColor : 'currentColor',
            spacing: "spacious",
            label: intl.formatMessage((0, $0922fb65a417b9c9$export$defe85febe8b728c).searchIconLabel)
        })),
        elemAfterInput: localQuery && /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $0e7ab459a082b03b$var$clearIconStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                    ...iconProps,
                    color: props.styleOverrides?.textColor ? props.styleOverrides?.textColor : 'currentColor',
                    label: intl.formatMessage((0, $0922fb65a417b9c9$export$defe85febe8b728c).clearIconLabel)
                }),
            spacing: 'compact',
            onClick: ()=>setLocalQuery(''),
            label: intl.formatMessage((0, $0922fb65a417b9c9$export$defe85febe8b728c).clearIconLabel),
            appearance: 'subtle'
        }))
    })));
});


const $cbdd30a2675003a4$var$textFieldBoxStyles = (0, $buxP3.xcss)({
    height: 'space.500',
    flexGrow: 1
});
const $cbdd30a2675003a4$export$f5b8910cec6cf069 = ()=>{
    const [showDropdown, { setShowDropdown: setShowDropdown }] = (0, $3a2567ac224fb8e0$export$8c32fdb3462273b4)();
    const inputBoxRef = (0, $cozmU.useRef)(null);
    const inputRef = (0, $cozmU.useRef)(null);
    const [styleOverrides] = (0, $122441d1a555945e$export$4f9dad8ddb27a630)();
    (0, $4a8b01ab53e0218b$export$11133d09694420f7)();
    const [_, setInputWidth] = (0, $cozmU.useState)(inputBoxRef.current?.offsetWidth);
    (0, $cozmU.useEffect)(()=>{
        const listener = ()=>setInputWidth(inputBoxRef.current?.offsetWidth);
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = (0, $cozmU.useCallback)(()=>{
        if (showDropdown) setShowDropdown(false);
    }, [
        showDropdown,
        setShowDropdown
    ]);
    const trigger = (0, $cozmU.useCallback)((triggerProps)=>{
        // When the SearchTextField receives a submit/enter
        const hasSubmitted = ()=>{
            closeDropdown();
        }; // When the SearchTextField receives focus - simple API for multiple events that cause this
        const inputHasReceivedFocus = ()=>{
            if (!showDropdown) setShowDropdown(true);
        };
        return /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $cbdd30a2675003a4$var$textFieldBoxStyles,
            ref: inputBoxRef
        }, /*#__PURE__*/ $cozmU.createElement((0, $0e7ab459a082b03b$export$fb8d8fbc0c4c1705), {
            keyboardRef: inputRef,
            ...triggerProps,
            ref: triggerProps.ref,
            onSubmit: hasSubmitted,
            hasReceivedFocus: inputHasReceivedFocus,
            styleOverrides: styleOverrides?.textfield
        }));
    }, [
        closeDropdown,
        showDropdown,
        setShowDropdown,
        styleOverrides?.textfield
    ]);
    const content = /*#__PURE__*/ $cozmU.createElement((0, $765219d4c0e21bfb$export$e33d60b8f4099ae), {
        inputWidth: inputBoxRef.current?.offsetWidth || 0
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.Popup), {
        shouldReturnFocus: false,
        content: ()=>content,
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};
const $cbdd30a2675003a4$var$InputWithErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
            fallback: /*#__PURE__*/ $cozmU.createElement((0, $0e7ab459a082b03b$export$fb8d8fbc0c4c1705), null)
        }, /*#__PURE__*/ $cozmU.createElement($cbdd30a2675003a4$export$f5b8910cec6cf069, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $0e7ab459a082b03b$export$fb8d8fbc0c4c1705), null)
    }, /*#__PURE__*/ $cozmU.createElement($cbdd30a2675003a4$export$f5b8910cec6cf069, null));
};
var $cbdd30a2675003a4$export$2e2bcd8739ae039 = $cbdd30a2675003a4$var$InputWithErrorBoundary;












var $iMnC5 = parcelRequire("iMnC5");














var $9iaFM = parcelRequire("9iaFM");



















const $de509023e97a6742$var$contentContainerStyles = (0, $buxP3.xcss)({
    margin: 'auto',
    maxWidth: '70rem',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    boxSizing: 'content-box'
});
const $de509023e97a6742$export$9d2b4227a95687cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $de509023e97a6742$var$contentContainerStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $de509023e97a6742$var$contentContainerStyles
    }, children);
};



const $c3be8e2be2185467$var$RightPanelContainerStyles = (0, $buxP3.xcss)({
    width: '100%',
    display: 'inline'
});
const $c3be8e2be2185467$var$bodyStackStyles = (0, $buxP3.xcss)({
    // By default, elements with display: flex will have a width of auto, which
    // means they will not shrink below the width of their content. By setting
    // this to 0, it ensures that this stack will not grow beyond its width.
    minWidth: '0'
});
const $c3be8e2be2185467$var$gridStyles = (0, $buxP3.xcss)({
    grid: '1fr / 100fr',
    gridTemplateColumns: 'auto'
});
const $c3be8e2be2185467$var$gridStylesSmall = (0, $buxP3.xcss)({
    grid: '1fr / 70fr 30fr',
    gridTemplateColumns: 'auto'
});
const $c3be8e2be2185467$var$gridStylesMedium = (0, $buxP3.xcss)({
    grid: '1fr / 100fr 320px',
    gridTemplateColumns: 'auto'
});
// Prevent the smart answers dialog from z-indexing above the dialog, filters etc
const $c3be8e2be2185467$var$smartAnswersWrapperStyles = {
    zIndex: 0
};
const $c3be8e2be2185467$export$36cf6d64005c1ddf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { components: components } = t0;
    const { smartAnswers: smartAnswers, results: resultsComponent, autoCorrection: autoCorrection } = components;
    let t1;
    if ($[0] !== resultsComponent || $[1] !== smartAnswers) {
        t1 = [
            smartAnswers,
            resultsComponent
        ];
        $[0] = resultsComponent;
        $[1] = smartAnswers;
        $[2] = t1;
    } else t1 = $[2];
    (0, $cozmU.useEffect)($c3be8e2be2185467$var$_temp, t1);
    let t2;
    if ($[3] !== autoCorrection || $[4] !== resultsComponent || $[5] !== smartAnswers) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: $c3be8e2be2185467$var$smartAnswersWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            space: "space.200",
            xcss: $c3be8e2be2185467$var$bodyStackStyles
        }, autoCorrection, smartAnswers, resultsComponent));
        $[3] = autoCorrection;
        $[4] = resultsComponent;
        $[5] = smartAnswers;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ components: components })=>{
    const { smartAnswers: smartAnswers, results: resultsComponent, autoCorrection: autoCorrection } = components;
    (0, $cozmU.useEffect)(()=>{
        // The scroll is on the window level so we have to scroll window to 0,0 to reset the scroller
        window.scrollTo(0, 0);
    }, [
        smartAnswers,
        resultsComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: $c3be8e2be2185467$var$smartAnswersWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.200",
        xcss: $c3be8e2be2185467$var$bodyStackStyles
    }, autoCorrection, smartAnswers, resultsComponent));
};
const $c3be8e2be2185467$export$4b2c32e08f77ff18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { components: components } = t0;
    const { rightPanel: rightPanel } = components;
    const width = (0, $e0f6b39825d0c965$export$1217913212f99c7)("layout");
    if (!rightPanel) {
        let t1;
        if ($[0] !== components) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de509023e97a6742$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
                gap: "space.400",
                templateColumns: "100fr"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3be8e2be2185467$export$36cf6d64005c1ddf, {
                components: components
            })));
            $[0] = components;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    } else if (width > 0) {
        const isAboveMedium = (0, $e0f6b39825d0c965$export$c44b7f69e7aa026)({
            width: width,
            above: "md"
        });
        let t1;
        if ($[2] !== width) {
            t1 = (0, $e0f6b39825d0c965$export$c44b7f69e7aa026)({
                width: width,
                above: "sm"
            });
            $[2] = width;
            $[3] = t1;
        } else t1 = $[3];
        const isAboveSmall = t1;
        let className = $c3be8e2be2185467$var$gridStyles;
        if (isAboveMedium) className = $c3be8e2be2185467$var$gridStylesMedium;
        else if (isAboveSmall) className = $c3be8e2be2185467$var$gridStylesSmall;
        let t2;
        if ($[4] !== components) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3be8e2be2185467$export$36cf6d64005c1ddf, {
                components: components
            });
            $[4] = components;
            $[5] = t2;
        } else t2 = $[5];
        let t3;
        if ($[6] !== isAboveSmall || $[7] !== rightPanel) {
            t3 = isAboveSmall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $c3be8e2be2185467$var$RightPanelContainerStyles
            }, rightPanel);
            $[6] = isAboveSmall;
            $[7] = rightPanel;
            $[8] = t3;
        } else t3 = $[8];
        let t4;
        if ($[9] !== className || $[10] !== t2 || $[11] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de509023e97a6742$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
                gap: "space.400",
                xcss: className
            }, t2, t3));
            $[9] = className;
            $[10] = t2;
            $[11] = t3;
            $[12] = t4;
        } else t4 = $[12];
        return t4;
    }
    return null;
} : ({ components: components })=>{
    const { rightPanel: rightPanel } = components;
    const width = (0, $e0f6b39825d0c965$export$1217913212f99c7)('layout');
    // Primary use case for this is side-by-side which does not set a rightPanel
    if (!rightPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de509023e97a6742$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
        gap: "space.400",
        templateColumns: '100fr'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3be8e2be2185467$export$36cf6d64005c1ddf, {
        components: components
    })));
    else if (width > 0) {
        const isAboveMedium = (0, $e0f6b39825d0c965$export$c44b7f69e7aa026)({
            width: width,
            above: 'md'
        });
        const isAboveSmall = (0, $e0f6b39825d0c965$export$c44b7f69e7aa026)({
            width: width,
            above: 'sm'
        });
        let className = $c3be8e2be2185467$var$gridStyles;
        if (isAboveMedium) className = $c3be8e2be2185467$var$gridStylesMedium;
        else if (isAboveSmall) className = $c3be8e2be2185467$var$gridStylesSmall;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de509023e97a6742$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
            gap: "space.400",
            xcss: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3be8e2be2185467$export$36cf6d64005c1ddf, {
            components: components
        }), isAboveSmall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $c3be8e2be2185467$var$RightPanelContainerStyles
        }, rightPanel)));
    }
    return null;
};
function $c3be8e2be2185467$var$_temp() {
    window.scrollTo(0, 0);
}




















const $81fdfd0c459a6f45$var$baseHeaderStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    width: '100%'
});
const $81fdfd0c459a6f45$var$headerGridStyles = (0, $buxP3.xcss)({
    paddingBottom: 'space.200',
    marginBottom: 'space.250',
    borderBottom: `solid ${"var(--ds-border-width, 1px)"} ${"var(--ds-border, #0B120E24)"}`
});
const $81fdfd0c459a6f45$var$filtersGridAreaStyles = (0, $buxP3.xcss)({
    gridArea: 'filters'
});
const $81fdfd0c459a6f45$var$Header = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { components: components, disableHeaderGridStyles: disableHeaderGridStyles } = t0;
    const { filters: filters } = components;
    const [stickyHeaderStyles, setStickyHeaderStyles] = (0, $cozmU.useState)();
    const referenceRef = (0, $cozmU.useRef)(null);
    const headerRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if (!referenceRef.current) return;
            referenceRef.current.getBoundingClientRect();
            const scrollY = window.scrollY;
            const top = 0 + scrollY;
            setStickyHeaderStyles((0, $buxP3.xcss)({
                position: "sticky",
                top: `${top}px`,
                backgroundClip: "padding-box"
            }));
        };
        t2 = [
            setStickyHeaderStyles
        ];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            ref: referenceRef,
            testId: "search-page-header-reference"
        });
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== stickyHeaderStyles) {
        t4 = [
            $81fdfd0c459a6f45$var$baseHeaderStyles,
            stickyHeaderStyles
        ];
        $[3] = stickyHeaderStyles;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            zIndex: 1
        };
        $[5] = t5;
    } else t5 = $[5];
    const t6 = disableHeaderGridStyles ? undefined : $81fdfd0c459a6f45$var$headerGridStyles;
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = [
            "input feedback",
            "filters filters"
        ];
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== filters) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $81fdfd0c459a6f45$var$filtersGridAreaStyles
        }, filters);
        $[7] = filters;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t6 || $[10] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de509023e97a6742$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
            ref: headerRef,
            xcss: t6,
            columnGap: "space.250",
            rowGap: "space.200",
            templateAreas: t7,
            templateColumns: "65fr 35fr"
        }, t8));
        $[9] = t6;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== t4 || $[13] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t4,
            testId: "search-page-header",
            style: t5
        }, t9));
        $[12] = t4;
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    return t10;
} : ({ components: components, disableHeaderGridStyles: disableHeaderGridStyles })=>{
    const { filters: filters } = components;
    const [stickyHeaderStyles, setStickyHeaderStyles] = (0, $cozmU.useState)();
    const referenceRef = (0, $cozmU.useRef)(null);
    const headerRef = (0, $cozmU.useRef)(null);
    // Use the reference element's position to set the sticky styles on the
    // header. This allows `top` to always be correct.
    (0, $cozmU.useEffect)(()=>{
        if (!referenceRef.current) return;
        // QS-5148
        // referenceY is a measure of how far the top of search-page is from the top of the scrolling context. This works in old nav, because the scroll matches the viewport
        // In Nav 4, the scroll is the content region and the nav is outside of it
        // This is a temporary fix to unblock Nav4 dogfooding
        let referenceY = referenceRef.current.getBoundingClientRect().top;
        referenceY = 0;
        const scrollY = window.scrollY;
        const top = referenceY + scrollY;
        setStickyHeaderStyles((0, $buxP3.xcss)({
            position: 'sticky',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundClip: 'padding-box'
        }));
    }, [
        setStickyHeaderStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        ref: referenceRef,
        testId: "search-page-header-reference"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $81fdfd0c459a6f45$var$baseHeaderStyles,
            stickyHeaderStyles
        ],
        testId: "search-page-header",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            zIndex: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de509023e97a6742$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
        ref: headerRef,
        xcss: disableHeaderGridStyles ? undefined : $81fdfd0c459a6f45$var$headerGridStyles,
        columnGap: "space.250",
        rowGap: "space.200",
        templateAreas: [
            'input feedback',
            'filters filters'
        ],
        templateColumns: "65fr 35fr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $81fdfd0c459a6f45$var$filtersGridAreaStyles
    }, filters)))));
};
const $81fdfd0c459a6f45$var$HeaderWithErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    const t0 = props.disableHeaderGridStyles ? undefined : $81fdfd0c459a6f45$var$headerGridStyles;
    let t1;
    if ($[0] !== props.components.input) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de509023e97a6742$export$9d2b4227a95687cc), null, props.components.input);
        $[0] = props.components.input;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t0
        }, t1);
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== props) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($81fdfd0c459a6f45$var$Header, props);
        $[5] = props;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
            fallback: t2
        }, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: props.disableHeaderGridStyles ? undefined : $81fdfd0c459a6f45$var$headerGridStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de509023e97a6742$export$9d2b4227a95687cc), null, props.components.input))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($81fdfd0c459a6f45$var$Header, props));
};
var $81fdfd0c459a6f45$export$2e2bcd8739ae039 = $81fdfd0c459a6f45$var$HeaderWithErrorBoundary;

















const $8b18364564afbcd7$var$baseHeaderStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface',
    width: '100%'
});
const $8b18364564afbcd7$var$headerGridStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.400',
    paddingBottom: 'space.200'
});
const $8b18364564afbcd7$var$HeaderSideBySide = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { components: components } = t0;
    const { filters: filters } = components;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            $8b18364564afbcd7$var$baseHeaderStyles
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            zIndex: 10
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== filters) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t1,
            testId: "search-page-header",
            style: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de509023e97a6742$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $8b18364564afbcd7$var$headerGridStyles
        }, filters))));
        $[2] = filters;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ components: components })=>{
    const { filters: filters } = components;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $8b18364564afbcd7$var$baseHeaderStyles
        ],
        testId: "search-page-header",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            zIndex: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de509023e97a6742$export$9d2b4227a95687cc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $8b18364564afbcd7$var$headerGridStyles
    }, filters))));
};
var $8b18364564afbcd7$export$2e2bcd8739ae039 = $8b18364564afbcd7$var$HeaderSideBySide;


const $a1fcc08c0b2907b8$export$c84671f46d6a1ca = ({ components: { filters: filters, results: results = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null), input: input = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null), feedback: feedback = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null), smartAnswers: smartAnswers = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null), oauthContainer: oauthContainer = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null), rightPanel: rightPanel = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null), autoCorrection: autoCorrection = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null) }, disableHeaderGridStyles: disableHeaderGridStyles })=>/*#__PURE__*/ $cozmU.createElement((0, $e0f6b39825d0c965$export$f8586f54f6b8f867), {
        id: "layout"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "search-page-layout"
    }, /*#__PURE__*/ $cozmU.createElement((0, $81fdfd0c459a6f45$export$2e2bcd8739ae039), {
        components: {
            input: input,
            feedback: feedback,
            filters: filters
        },
        disableHeaderGridStyles: disableHeaderGridStyles
    }), /*#__PURE__*/ $cozmU.createElement((0, $c3be8e2be2185467$export$4b2c32e08f77ff18), {
        components: {
            results: results,
            smartAnswers: smartAnswers,
            rightPanel: rightPanel,
            oauthContainer: oauthContainer,
            autoCorrection: autoCorrection
        }
    })));
const $a1fcc08c0b2907b8$export$8ac1fb3f3f89d5bf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { components: t1 } = t0;
    const { filters: filters, results: results, smartAnswers: smartAnswers, oauthContainer: oauthContainer, autoCorrection: autoCorrection } = t1;
    let t2;
    if ($[0] !== filters) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $8b18364564afbcd7$export$2e2bcd8739ae039), {
            components: {
                filters: filters
            }
        });
        $[0] = filters;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== autoCorrection || $[3] !== oauthContainer || $[4] !== results || $[5] !== smartAnswers) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $c3be8e2be2185467$export$4b2c32e08f77ff18), {
            components: {
                results: results,
                smartAnswers: smartAnswers,
                oauthContainer: oauthContainer,
                autoCorrection: autoCorrection
            }
        });
        $[2] = autoCorrection;
        $[3] = oauthContainer;
        $[4] = results;
        $[5] = smartAnswers;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            testId: "search-page-layout"
        }, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ components: { filters: filters, results: results, smartAnswers: smartAnswers, oauthContainer: oauthContainer, autoCorrection: autoCorrection } })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "search-page-layout"
    }, /*#__PURE__*/ $cozmU.createElement((0, $8b18364564afbcd7$export$2e2bcd8739ae039), {
        components: {
            filters: filters
        }
    }), /*#__PURE__*/ $cozmU.createElement((0, $c3be8e2be2185467$export$4b2c32e08f77ff18), {
        components: {
            results: results,
            smartAnswers: smartAnswers,
            oauthContainer: oauthContainer,
            autoCorrection: autoCorrection
        }
    }));




















var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");

const $a69b1b004ef5dd7f$var$COMPONENT = 'search-page';
const $a69b1b004ef5dd7f$export$a98443e214d7b1fd = new (0, $34VCg.UFOExperience)('load', {
    type: (0, $gZFfs.ExperienceTypes).Load,
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
    platform: {
        component: $a69b1b004ef5dd7f$var$COMPONENT
    }
});
const $a69b1b004ef5dd7f$export$e882a2ec68d19be8 = new (0, $34VCg.UFOExperience)('search-results-load', {
    type: (0, $gZFfs.ExperienceTypes).Experience,
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $a69b1b004ef5dd7f$var$COMPONENT
    },
    timings: [
        {
            key: 'request',
            startMark: 'request_start',
            endMark: 'request_end'
        },
        {
            key: 'render',
            startMark: 'render_start',
            endMark: 'render_end'
        }
    ]
});





const $a4ade32e9dcacfed$export$44fea6589b7ddc92 = (type)=>{
    switch(type){
        case 'jira':
            return 'Jira';
        case 'confluence':
            return 'Confluence';
        case 'townsquare':
            return 'Atlas';
        case 'drive':
            return 'Google Drive';
        case 'microsoft':
        case 'sharepoint':
            return 'Microsoft SharePoint';
        case 'github':
            return 'GitHub';
        case 'compass':
            return 'Compass';
        case 'trello':
            return 'Trello';
    }
    return '';
};
const $a4ade32e9dcacfed$export$b0f4af9a0173cbfd = (product)=>{
    return (0, $37AYo.products)[product].is3P;
};






var $79a9ae6415bd9660$var$ce = Object.defineProperty;
var $79a9ae6415bd9660$var$v = Object.getOwnPropertySymbols;
var $79a9ae6415bd9660$var$X = Object.prototype.hasOwnProperty, $79a9ae6415bd9660$var$Y = Object.prototype.propertyIsEnumerable;
var $79a9ae6415bd9660$var$Q = (e, o, a)=>o in e ? $79a9ae6415bd9660$var$ce(e, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: a
    }) : e[o] = a, $79a9ae6415bd9660$var$m = (e, o)=>{
    for(var a in o || (o = {}))$79a9ae6415bd9660$var$X.call(o, a) && $79a9ae6415bd9660$var$Q(e, a, o[a]);
    if ($79a9ae6415bd9660$var$v) for (var a of $79a9ae6415bd9660$var$v(o))$79a9ae6415bd9660$var$Y.call(o, a) && $79a9ae6415bd9660$var$Q(e, a, o[a]);
    return e;
};
var $79a9ae6415bd9660$var$Z = (e, o)=>{
    var a = {};
    for(var c in e)$79a9ae6415bd9660$var$X.call(e, c) && o.indexOf(c) < 0 && (a[c] = e[c]);
    if (e != null && $79a9ae6415bd9660$var$v) for (var c of $79a9ae6415bd9660$var$v(e))o.indexOf(c) < 0 && $79a9ae6415bd9660$var$Y.call(e, c) && (a[c] = e[c]);
    return a;
};
var $79a9ae6415bd9660$var$w = (e, o)=>{
    let a = "[react-use-intercom]";
    switch(e){
        case "info":
            console.log(`${a} ${o}`);
            break;
        case "warn":
            console.warn(`${a} ${o}`);
            break;
        case "error":
            console.error(`${a} ${o}`);
            break;
        default:
            console.log(`${a} ${o}`);
    }
};
var $79a9ae6415bd9660$var$h = typeof window == "undefined", $79a9ae6415bd9660$var$A = (e)=>(Object.keys(e).forEach((o)=>{
        e[o] && typeof e[o] == "object" ? $79a9ae6415bd9660$var$A(e[o]) : e[o] === void 0 && delete e[o];
    }), e);
var $79a9ae6415bd9660$var$ie = (e, ...o)=>{
    if (!$79a9ae6415bd9660$var$h && window.Intercom) return window.Intercom.apply(null, [
        e,
        ...o
    ]);
    $79a9ae6415bd9660$var$w("error", `${e} Intercom instance is not initalized yet`);
}, $79a9ae6415bd9660$var$s = $79a9ae6415bd9660$var$ie;
var $79a9ae6415bd9660$var$me = $cozmU.createContext(void 0), $79a9ae6415bd9660$var$b = $79a9ae6415bd9660$var$me;
var $79a9ae6415bd9660$var$le = (e, o = 0)=>{
    var a = window, c = a.Intercom;
    if (typeof c == "function") c("reattach_activator"), c("update", a.intercomSettings);
    else {
        var f = document, l = function() {
            l.c(arguments);
        };
        l.q = [], l.c = function(u) {
            l.q.push(u);
        }, a.Intercom = l;
        var p = function() {
            setTimeout(function() {
                var u = f.createElement("script");
                u.type = "text/javascript", u.async = !0, u.src = "https://widget.intercom.io/widget/" + e;
                var d = f.getElementsByTagName("script")[0];
                d.parentNode.insertBefore(u, d);
            }, o);
        };
        document.readyState === "complete" ? p() : a.attachEvent ? a.attachEvent("onload", p) : a.addEventListener("load", p, !1);
    }
}, $79a9ae6415bd9660$var$oe = $79a9ae6415bd9660$var$le;
var $79a9ae6415bd9660$var$ue = (e)=>({
        custom_launcher_selector: e.customLauncherSelector,
        alignment: e.alignment,
        vertical_padding: e.verticalPadding,
        horizontal_padding: e.horizontalPadding,
        hide_default_launcher: e.hideDefaultLauncher,
        session_duration: e.sessionDuration,
        action_color: e.actionColor,
        background_color: e.backgroundColor
    }), $79a9ae6415bd9660$var$re = (e)=>$79a9ae6415bd9660$var$m({
        company_id: e.companyId,
        name: e.name,
        created_at: e.createdAt,
        plan: e.plan,
        monthly_spend: e.monthlySpend,
        user_count: e.userCount,
        size: e.size,
        website: e.website,
        industry: e.industry
    }, e.customAttributes), $79a9ae6415bd9660$var$de = (e)=>({
        type: e.type,
        image_url: e.imageUrl
    }), $79a9ae6415bd9660$var$pe = (e)=>{
    var o;
    return $79a9ae6415bd9660$var$m({
        email: e.email,
        user_id: e.userId,
        created_at: e.createdAt,
        name: e.name,
        phone: e.phone,
        last_request_at: e.lastRequestAt,
        unsubscribed_from_emails: e.unsubscribedFromEmails,
        language_override: e.languageOverride,
        utm_campaign: e.utmCampaign,
        utm_content: e.utmContent,
        utm_medium: e.utmMedium,
        utm_source: e.utmSource,
        utm_term: e.utmTerm,
        avatar: e.avatar && $79a9ae6415bd9660$var$de(e.avatar),
        user_hash: e.userHash,
        company: e.company && $79a9ae6415bd9660$var$re(e.company),
        companies: (o = e.companies) == null ? void 0 : o.map($79a9ae6415bd9660$var$re)
    }, e.customAttributes);
}, $79a9ae6415bd9660$var$k = (e)=>$79a9ae6415bd9660$var$A($79a9ae6415bd9660$var$m($79a9ae6415bd9660$var$m({}, $79a9ae6415bd9660$var$ue(e)), $79a9ae6415bd9660$var$pe(e)));
var $79a9ae6415bd9660$export$5091c5023e5c7eba = (ge)=>{
    var _ = ge, { appId: e, autoBoot: o = !1, autoBootProps: a, children: c, onHide: f, onShow: l, onUnreadCountChange: p, onUserEmailSupplied: u, shouldInitialize: d = !$79a9ae6415bd9660$var$h, apiBase: C, initializeDelay: P } = _, ae = $79a9ae6415bd9660$var$Z(_, [
        "appId",
        "autoBoot",
        "autoBootProps",
        "children",
        "onHide",
        "onShow",
        "onUnreadCountChange",
        "onUserEmailSupplied",
        "shouldInitialize",
        "apiBase",
        "initializeDelay"
    ]);
    let g = $cozmU.useRef(!1), y = $cozmU.useRef(!1), [x, R] = $cozmU.useState(!1), S = Object.keys(ae).filter((r)=>!r.startsWith("data-"));
    S.length > 0 && $79a9ae6415bd9660$var$w("warn", [
        "some invalid props were passed to IntercomProvider. ",
        `Please check following props: ${S.join(", ")}.`
    ].join(""));
    let D = $cozmU.useCallback(()=>{
        R(!1), f && f();
    }, [
        f,
        R
    ]), M = $cozmU.useCallback(()=>{
        R(!0), l && l();
    }, [
        l,
        R
    ]), I = $cozmU.useCallback((r)=>{
        if (!window.Intercom && !d) {
            $79a9ae6415bd9660$var$w("warn", "Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");
            return;
        }
        $79a9ae6415bd9660$var$s("onHide", D), $79a9ae6415bd9660$var$s("onShow", M), $79a9ae6415bd9660$var$s("onUserEmailSupplied", u), p && $79a9ae6415bd9660$var$s("onUnreadCountChange", p);
        let i = $79a9ae6415bd9660$var$m($79a9ae6415bd9660$var$m({
            app_id: e
        }, C && {
            api_base: C
        }), r && $79a9ae6415bd9660$var$k(r));
        window.intercomSettings = i, $79a9ae6415bd9660$var$s("boot", i), g.current = !0;
    }, [
        C,
        e,
        D,
        M,
        p,
        u,
        d
    ]);
    $cozmU.useEffect(()=>{
        !$79a9ae6415bd9660$var$h && d && !y.current && ($79a9ae6415bd9660$var$oe(e, P), o && I(a), y.current = !0);
    }, [
        e,
        o,
        a,
        I,
        P,
        d
    ]);
    let n = $cozmU.useCallback((r, i)=>{
        if (!window.Intercom && !d) {
            $79a9ae6415bd9660$var$w("warn", "Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");
            return;
        }
        if (!g.current) {
            $79a9ae6415bd9660$var$w("warn", [
                `"${r}" was called but Intercom has not booted yet. `,
                `Please call 'boot' before calling '${r}' or `,
                "set 'autoBoot' to true in the IntercomProvider."
            ].join(""));
            return;
        }
        return i();
    }, [
        d
    ]), T = $cozmU.useCallback(()=>{
        g.current && ($79a9ae6415bd9660$var$s("shutdown"), delete window.intercomSettings, g.current = !1);
    }, []), E = $cozmU.useCallback(()=>{
        g.current && ($79a9ae6415bd9660$var$s("shutdown"), delete window.Intercom, delete window.intercomSettings, g.current = !1);
    }, []), $ = $cozmU.useCallback(()=>{
        n("update", ()=>{
            let r = Math.floor(new Date().getTime() / 1e3);
            $79a9ae6415bd9660$var$s("update", {
                last_request_at: r
            });
        });
    }, [
        n
    ]), N = $cozmU.useCallback((r)=>{
        n("update", ()=>{
            if (!r) {
                $();
                return;
            }
            let i = $79a9ae6415bd9660$var$k(r);
            window.intercomSettings = $79a9ae6415bd9660$var$m($79a9ae6415bd9660$var$m({}, window.intercomSettings), i), $79a9ae6415bd9660$var$s("update", i);
        });
    }, [
        n,
        $
    ]), V = $cozmU.useCallback(()=>{
        n("hide", ()=>{
            $79a9ae6415bd9660$var$s("hide");
        });
    }, [
        n
    ]), L = $cozmU.useCallback(()=>{
        n("show", ()=>$79a9ae6415bd9660$var$s("show"));
    }, [
        n
    ]), z = $cozmU.useCallback(()=>{
        n("showMessages", ()=>{
            $79a9ae6415bd9660$var$s("showMessages");
        });
    }, [
        n
    ]), q = $cozmU.useCallback((r)=>{
        n("showNewMessage", ()=>{
            r ? $79a9ae6415bd9660$var$s("showNewMessage", r) : $79a9ae6415bd9660$var$s("showNewMessage");
        });
    }, [
        n
    ]), O = $cozmU.useCallback(()=>n("getVisitorId", ()=>$79a9ae6415bd9660$var$s("getVisitorId")), [
        n
    ]), W = $cozmU.useCallback((r)=>{
        n("startTour", ()=>{
            $79a9ae6415bd9660$var$s("startTour", r);
        });
    }, [
        n
    ]), j = $cozmU.useCallback((r)=>{
        n("startChecklist", ()=>{
            $79a9ae6415bd9660$var$s("startChecklist", r);
        });
    }, [
        n
    ]), B = $cozmU.useCallback((r, i)=>{
        n("trackEvent", ()=>{
            i ? $79a9ae6415bd9660$var$s("trackEvent", r, i) : $79a9ae6415bd9660$var$s("trackEvent", r);
        });
    }, [
        n
    ]), F = $cozmU.useCallback((r)=>n("showArticle", ()=>{
            $79a9ae6415bd9660$var$s("showArticle", r);
        }), [
        n
    ]), U = $cozmU.useCallback((r)=>n("showSpace", ()=>{
            $79a9ae6415bd9660$var$s("showSpace", r);
        }), [
        n
    ]), H = $cozmU.useCallback((r)=>{
        n("startSurvey", ()=>{
            $79a9ae6415bd9660$var$s("startSurvey", r);
        });
    }, [
        n
    ]), K = $cozmU.useCallback((r)=>n("showNews", ()=>{
            $79a9ae6415bd9660$var$s("showNews", r);
        }), [
        n
    ]), G = $cozmU.useCallback((r)=>n("showTicket", ()=>{
            $79a9ae6415bd9660$var$s("showTicket", r);
        }), [
        n
    ]), J = $cozmU.useCallback((r)=>n("showConversation", ()=>{
            $79a9ae6415bd9660$var$s("showConversation", r);
        }), [
        n
    ]), se = $cozmU.useMemo(()=>({
            boot: I,
            shutdown: T,
            hardShutdown: E,
            update: N,
            hide: V,
            show: L,
            isOpen: x,
            showMessages: z,
            showNewMessage: q,
            getVisitorId: O,
            startTour: W,
            startChecklist: j,
            trackEvent: B,
            showArticle: F,
            startSurvey: H,
            showSpace: U,
            showNews: K,
            showTicket: G,
            showConversation: J
        }), [
        I,
        T,
        E,
        N,
        V,
        L,
        x,
        z,
        q,
        O,
        W,
        j,
        B,
        F,
        H,
        U,
        K,
        G,
        J
    ]);
    return $cozmU.createElement($79a9ae6415bd9660$var$b.Provider, {
        value: se
    }, c);
}, $79a9ae6415bd9660$var$ne = ()=>{
    let e = $cozmU.useContext($79a9ae6415bd9660$var$b);
    if (e === void 0) throw new Error('"useIntercom" must be used within `IntercomProvider`.');
    return e;
};
var $79a9ae6415bd9660$export$624db904a0be2d69 = ()=>$79a9ae6415bd9660$var$ne();
 //# sourceMappingURL=out.js.map
 //# sourceMappingURL=index.mjs.map


const $ecf47e97be76a1bd$export$f0fed4b0765d7314 = ()=>{
    try {
        return (0, $79a9ae6415bd9660$export$624db904a0be2d69)();
    } catch (err) {
        return;
    }
};



var $5A1wD = parcelRequire("5A1wD");

var $hOJLU = parcelRequire("hOJLU");




class $d374566d2028db50$export$94cd2e6f39615373 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResultsFetchError';
    }
}
class $d374566d2028db50$export$8ba86dff7c04c14c extends $d374566d2028db50$export$94cd2e6f39615373 {
    constructor(){
        super('No entities provided to fetch results');
        this.name = 'EmptyEntitiesError';
    }
}
const $d374566d2028db50$export$46f82b8a3ce2a183 = async ({ query: query, originalQuery: originalQuery, entities: entities, selectedFilters: selectedFilters, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, searchSessionId: searchSessionId, sort: sort, sourceProduct: sourceProduct, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, after: after, limit: limit })=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters || (0, $hz3c4.getEmptySelectedFilters)();
    const sortVariables = [
        sort
    ];
    // If the original query param is present, we want to disable query replacement
    const disableQueryReplacement = !!originalQuery;
    const variables = {
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: limit,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        searchSessionId: searchSessionId,
        sort: sortVariables,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId
            })),
        // eslint-disable-next-line no-constant-condition
        after: undefined,
        disableQueryReplacement: disableQueryReplacement
    };
    if (entities.length === 0) throw new $d374566d2028db50$export$8ba86dff7c04c14c();
    const response = (0, $hOJLU.searchPageQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery
    });
    // If the original query param is not present, we want to cache the response with the replacement query
    // fg('rovo-search-spelling-correction') => false
    // eslint-disable-next-line no-constant-condition
    originalQuery;
    return response;
};
const $d374566d2028db50$export$6405a4ba66d50345 = async ({ issueKeys: issueKeys, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const variables = {
        issueKeys: issueKeys,
        cloudId: cloudId
    };
    const response = (0, $5A1wD.fetchJiraFieldsQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    return response;
};


















var $7ZB0A = parcelRequire("7ZB0A");


var $1c46a046326b4458$exports = {};
$1c46a046326b4458$exports = new URL("error-dark.43e0a164.svg", import.meta.url).toString();


var $2cecd614edc3a3c9$exports = {};
$2cecd614edc3a3c9$exports = new URL("error-light.02ef2e6f.svg", import.meta.url).toString();


const $4ca6254f4124508a$export$add61e2630a21f9 = 'cachedImageErrorLight';
const $4ca6254f4124508a$export$4be43fd067fd9d7f = 'cachedImageErrorDark';
const $4ca6254f4124508a$export$7f23364af4709df5 = async (url, key)=>{
    const response = await fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();
    const base64data = await new Promise((resolve, reject)=>{
        reader.onloadend = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, base64data);
};
const $4ca6254f4124508a$export$5e3e5ca9e3ba891b = async (isOnline, imageLight, lightImageKey, imageDark, darkImageKey)=>{
    if (isOnline) {
        await $4ca6254f4124508a$export$7f23364af4709df5(imageLight, lightImageKey);
        await $4ca6254f4124508a$export$7f23364af4709df5(imageDark, darkImageKey);
    }
};
const $4ca6254f4124508a$export$ce969d199fe2c04e = (key)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    return localStorage.getItem(key);
};





const $16e90fad0f69b086$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorPrimary: {
        id: "dynamic-cards-search-page.error_primary",
        defaultMessage: "We're having trouble searching"
    },
    errorSecondary: {
        id: "dynamic-cards-search-page.error_secondary",
        defaultMessage: "It might just be a hiccup. The best thing to do is to <btn>try again</btn>."
    }
});


const $e2cdf20372367534$export$edf27be85e5f6da0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { fetchResults: fetchResults } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $4ca6254f4124508a$export$ce969d199fe2c04e)("cachedImageErrorLight") || (0, (/*@__PURE__*/$parcel$interopDefault($2cecd614edc3a3c9$exports)));
        $[0] = t1;
    } else t1 = $[0];
    const ImageErrorLight = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $4ca6254f4124508a$export$ce969d199fe2c04e)("cachedImageErrorDark") || (0, (/*@__PURE__*/$parcel$interopDefault($1c46a046326b4458$exports)));
        $[1] = t2;
    } else t2 = $[1];
    const ImageErrorDark = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $16e90fad0f69b086$export$defe85febe8b728c).errorPrimary);
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== fetchResults) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $315d557f08ee9463$export$d9172702747fb4bc), {
            imageSrcLight: ImageErrorLight,
            imageSrcDark: ImageErrorDark,
            primaryText: t3,
            secondaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $16e90fad0f69b086$export$defe85febe8b728c).errorSecondary,
                values: {
                    btn: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                            appearance: "link",
                            spacing: "none",
                            onClick: fetchResults
                        }, chunks)
                }
            }),
            testId: "search-page-error"
        }));
        $[3] = fetchResults;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : ({ fetchResults: fetchResults })=>{
    const ImageErrorLight = (0, $4ca6254f4124508a$export$ce969d199fe2c04e)('cachedImageErrorLight') || (0, (/*@__PURE__*/$parcel$interopDefault($2cecd614edc3a3c9$exports)));
    const ImageErrorDark = (0, $4ca6254f4124508a$export$ce969d199fe2c04e)('cachedImageErrorDark') || (0, (/*@__PURE__*/$parcel$interopDefault($1c46a046326b4458$exports)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $315d557f08ee9463$export$d9172702747fb4bc), {
        imageSrcLight: ImageErrorLight,
        imageSrcDark: ImageErrorDark,
        primaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $16e90fad0f69b086$export$defe85febe8b728c).errorPrimary),
        secondaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $16e90fad0f69b086$export$defe85febe8b728c).errorSecondary,
            values: {
                btn: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                        appearance: "link",
                        spacing: "none",
                        onClick: fetchResults
                    }, chunks)
            }
        }),
        testId: "search-page-error"
    }));
};


















var $8f9ab673709e26ae$exports = {};
$8f9ab673709e26ae$exports = new URL("dynamic-cards-landing.82c00804.svg", import.meta.url).toString();





const $b5c51fe1682c7572$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    landingPrimary: {
        id: "dynamic-cards-search-page.landing_primary",
        defaultMessage: "Get started with filters for dynamic cards"
    },
    landingSecondary: {
        id: "dynamic-cards-search-page.landing_secondary",
        defaultMessage: "Define your rules to automatically build cards"
    }
});


const $150ee3d75f054d54$export$12449a31c6671d53 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $315d557f08ee9463$export$d9172702747fb4bc), {
            imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($8f9ab673709e26ae$exports))),
            imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($8f9ab673709e26ae$exports))),
            imageWidth: "400px",
            imageHeight: "300px",
            primaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b5c51fe1682c7572$export$defe85febe8b728c).landingPrimary),
            secondaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b5c51fe1682c7572$export$defe85febe8b728c).landingSecondary),
            testId: "search-page-landing"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $315d557f08ee9463$export$d9172702747fb4bc), {
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($8f9ab673709e26ae$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($8f9ab673709e26ae$exports))),
        imageWidth: '400px',
        imageHeight: '300px',
        primaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b5c51fe1682c7572$export$defe85febe8b728c).landingPrimary),
        secondaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b5c51fe1682c7572$export$defe85febe8b728c).landingSecondary),
        testId: "search-page-landing"
    });
};

















































const $2278d028db531411$var$SEARCH_PAGE_VISITED_KEY = 'atlassian.search-page.visited';
const $2278d028db531411$var$setLocalStorageItem = (key, value)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    window.localStorage.setItem(key, value);
};
const $2278d028db531411$var$getLocalStorageItem = (key)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    return window.localStorage.getItem(key);
};
const $2278d028db531411$export$5d8cdaf303406828 = (value)=>{
    $2278d028db531411$var$setLocalStorageItem($2278d028db531411$var$SEARCH_PAGE_VISITED_KEY, JSON.stringify([
        ...$2278d028db531411$export$ea4ff4efe040153f(),
        value
    ]));
};
const $2278d028db531411$export$ea4ff4efe040153f = ()=>{
    const visitedLinksRaw = $2278d028db531411$var$getLocalStorageItem($2278d028db531411$var$SEARCH_PAGE_VISITED_KEY);
    return new Set(visitedLinksRaw ? JSON.parse(visitedLinksRaw) : []);
};
const $2278d028db531411$export$df30b8dffa0e57a6 = (visitedLinks, id)=>{
    return visitedLinks.has(id);
};


const $88d5f08d75a5e53f$var$containerStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    borderRadius: 'radius.small'
});
const $88d5f08d75a5e53f$var$iconAreaStyles = (0, $buxP3.xcss)({
    gridArea: 'icon',
    width: 'size.200',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right'
});
const $88d5f08d75a5e53f$var$headingAreaStyles = (0, $buxP3.xcss)({
    gridArea: 'heading',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body.large'
});
const $88d5f08d75a5e53f$var$subheadingStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtle',
    marginTop: 'space.025',
    font: 'font.body',
    overflow: 'clip',
    overflowClipMargin: '5px' // space for focus outlines
});
const $88d5f08d75a5e53f$var$subheadingLeftAreaStyles = (0, $buxP3.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $88d5f08d75a5e53f$var$bodyAreaStyles = (0, $buxP3.xcss)({
    gridArea: 'body',
    marginTop: 'space.075',
    overflowWrap: 'break-word'
});
const $88d5f08d75a5e53f$var$footerAreaStyles = (0, $buxP3.xcss)({
    gridArea: 'footer'
});
const $88d5f08d75a5e53f$var$visitedLinkStyles = (0, $buxP3.xcss)({
    textDecoration: 'none',
    ':visited:active': {
        color: 'color.link.visited.pressed'
    },
    ':visited': {
        color: 'color.link.visited'
    }
});
const $88d5f08d75a5e53f$var$visitedLinkPatchStyles = (0, $buxP3.xcss)({
    color: 'color.link.visited',
    ':active': {
        color: 'color.link.visited.pressed'
    }
});
const $88d5f08d75a5e53f$export$a2def421b23768aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { id: id, description: description, footer: footer, icon: icon, headerMetadata: t1, title: title, url: url, isThirdParty: t2, showAISummary: t3, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu } = t0;
    let t4;
    if ($[0] !== t1) {
        t4 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t4;
    } else t4 = $[1];
    const headerMetadata = t4;
    const isThirdParty = t2 === undefined ? false : t2;
    t3 === undefined || t3;
    const { setIsHovered: setIsHovered, setIsFocused: setIsFocused } = $88d5f08d75a5e53f$var$useVisibilityState();
    let t5;
    if ($[2] !== id) {
        const visitedLinks = (0, $2278d028db531411$export$ea4ff4efe040153f)();
        t5 = id ? (0, $2278d028db531411$export$df30b8dffa0e57a6)(visitedLinks, id) : false;
        $[2] = id;
        $[3] = t5;
    } else t5 = $[3];
    const isVisitedLink = t5;
    const { linkComponent: Link } = (0, $d848581de35407c0$export$fdc397e486fa83e7)();
    let t6;
    let t7;
    if ($[4] !== setIsHovered) {
        t6 = ()=>setIsHovered(true);
        t7 = ()=>setIsHovered(false);
        $[4] = setIsHovered;
        $[5] = t6;
        $[6] = t7;
    } else {
        t6 = $[5];
        t7 = $[6];
    }
    let t8;
    let t9;
    if ($[7] !== setIsFocused) {
        t8 = ()=>setIsFocused(true);
        t9 = ()=>setIsFocused(false);
        $[7] = setIsFocused;
        $[8] = t8;
        $[9] = t9;
    } else {
        t8 = $[8];
        t9 = $[9];
    }
    let t10;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [
            "icon heading header-right",
            "icon subheading-left header-right",
            ". body body",
            ". footer footer"
        ];
        $[10] = t10;
    } else t10 = $[10];
    let t11;
    if ($[11] !== icon) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $88d5f08d75a5e53f$var$iconAreaStyles
        }, icon);
        $[11] = icon;
        $[12] = t11;
    } else t11 = $[12];
    let t12;
    if ($[13] !== Link || $[14] !== id || $[15] !== isThirdParty || $[16] !== isVisitedLink || $[17] !== onResultClicked || $[18] !== onResultContextMenu || $[19] !== title || $[20] !== url) {
        t12 = id && url ? /*#__PURE__*/ $cozmU.createElement(Link, {
            xcss: [
                $88d5f08d75a5e53f$var$headingAreaStyles,
                $88d5f08d75a5e53f$var$visitedLinkStyles,
                isVisitedLink && $88d5f08d75a5e53f$var$visitedLinkPatchStyles
            ],
            rel: isThirdParty ? "noreferrer" : "",
            target: isThirdParty ? "_blank" : undefined,
            href: url,
            testId: "search-page-result-link",
            onClick: ()=>{
                (0, $2278d028db531411$export$5d8cdaf303406828)(id);
                onResultClicked?.();
            },
            onContextMenu: onResultContextMenu
        }, title) : onResultClicked ? /*#__PURE__*/ $cozmU.createElement((0, $kh0hi.Pressable), {
            xcss: $88d5f08d75a5e53f$var$headingAreaStyles,
            onClick: onResultClicked,
            onContextMenu: onResultContextMenu
        }, title) : /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $88d5f08d75a5e53f$var$headingAreaStyles
        }, title);
        $[13] = Link;
        $[14] = id;
        $[15] = isThirdParty;
        $[16] = isVisitedLink;
        $[17] = onResultClicked;
        $[18] = onResultContextMenu;
        $[19] = title;
        $[20] = url;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== headerMetadata) {
        t13 = headerMetadata && /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: [
                $88d5f08d75a5e53f$var$subheadingLeftAreaStyles,
                $88d5f08d75a5e53f$var$subheadingStyles
            ],
            testId: "search-page-result-metadata"
        }, headerMetadata);
        $[22] = headerMetadata;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== description) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $88d5f08d75a5e53f$var$bodyAreaStyles
        }, description);
        $[24] = description;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== footer) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $88d5f08d75a5e53f$var$footerAreaStyles
        }, footer);
        $[26] = footer;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== t11 || $[29] !== t12 || $[30] !== t13 || $[31] !== t14 || $[32] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $9iaFM.Grid), {
            columnGap: "space.150",
            templateAreas: t10,
            templateColumns: "auto 1fr auto"
        }, t11, t12, t13, t14, t15);
        $[28] = t11;
        $[29] = t12;
        $[30] = t13;
        $[31] = t14;
        $[32] = t15;
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== t16 || $[35] !== t6 || $[36] !== t7 || $[37] !== t8 || $[38] !== t9) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            role: "listitem",
            xcss: $88d5f08d75a5e53f$var$containerStyles,
            onMouseEnter: t6,
            onMouseLeave: t7,
            onFocusCapture: t8,
            onBlurCapture: t9,
            testId: "search-page-result"
        }, t16);
        $[34] = t16;
        $[35] = t6;
        $[36] = t7;
        $[37] = t8;
        $[38] = t9;
        $[39] = t17;
    } else t17 = $[39];
    return t17;
} : ({ id: id, primaryProduct: _primaryProduct, description: description, footer: footer, icon: icon, headerMetadata: headerMetadata = [], title: title, url: url, isThirdParty: isThirdParty = false, showAISummary: _showAISummary = false, cloudId: _cloudId, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu })=>{
    const { setIsHovered: setIsHovered, setIsFocused: setIsFocused } = $88d5f08d75a5e53f$var$useVisibilityState(); /**
                             * A dynamic search_id query param and queryHash is appended to the document URL for 1P search results.
                             * As result we are unable to use the browser's visited links history to determine if a link has been visited.
                             * This is workaround until we have a better solution.
                             */ 
    const visitedLinks = (0, $2278d028db531411$export$ea4ff4efe040153f)();
    const isVisitedLink = id ? (0, $2278d028db531411$export$df30b8dffa0e57a6)(visitedLinks, id) : false;
    const { linkComponent: Link } = (0, $d848581de35407c0$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        role: "listitem",
        xcss: $88d5f08d75a5e53f$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: "search-page-result"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9iaFM.Grid), {
        columnGap: "space.150",
        templateAreas: [
            'icon heading header-right',
            'icon subheading-left header-right',
            '. body body',
            '. footer footer'
        ],
        templateColumns: "auto 1fr auto"
    }, /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $88d5f08d75a5e53f$var$iconAreaStyles
    }, icon), id && url ? /*#__PURE__*/ $cozmU.createElement(Link, {
        xcss: [
            $88d5f08d75a5e53f$var$headingAreaStyles,
            $88d5f08d75a5e53f$var$visitedLinkStyles,
            isVisitedLink && $88d5f08d75a5e53f$var$visitedLinkPatchStyles
        ],
        rel: isThirdParty ? 'noreferrer' : '',
        target: isThirdParty ? '_blank' : undefined,
        href: url,
        testId: "search-page-result-link",
        onClick: ()=>{
            (0, $2278d028db531411$export$5d8cdaf303406828)(id);
            onResultClicked?.();
        },
        onContextMenu: onResultContextMenu
    }, title) : onResultClicked ? /*#__PURE__*/ $cozmU.createElement((0, $kh0hi.Pressable), {
        xcss: $88d5f08d75a5e53f$var$headingAreaStyles,
        onClick: onResultClicked,
        onContextMenu: onResultContextMenu
    }, title) : /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $88d5f08d75a5e53f$var$headingAreaStyles
    }, title), headerMetadata && /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: [
            $88d5f08d75a5e53f$var$subheadingLeftAreaStyles,
            $88d5f08d75a5e53f$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, headerMetadata), /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $88d5f08d75a5e53f$var$bodyAreaStyles
    }, description), /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $88d5f08d75a5e53f$var$footerAreaStyles
    }, footer)));
};
const $88d5f08d75a5e53f$var$useVisibilityState = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const [isContextMenuOpen, setIsContextMenuOpen] = (0, $cozmU.useState)(false);
    const t0 = isHovered || isFocused || isContextMenuOpen;
    let t1;
    if ($[0] !== isContextMenuOpen || $[1] !== t0) {
        t1 = {
            isContextMenuVisible: t0,
            isContextMenuOpen: isContextMenuOpen,
            setIsHovered: setIsHovered,
            setIsFocused: setIsFocused,
            setIsContextMenuOpen: setIsContextMenuOpen
        };
        $[0] = isContextMenuOpen;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const [isContextMenuOpen, setIsContextMenuOpen] = (0, $cozmU.useState)(false);
    return {
        isContextMenuVisible: isHovered || isFocused || isContextMenuOpen,
        isContextMenuOpen: isContextMenuOpen,
        setIsHovered: setIsHovered,
        setIsFocused: setIsFocused,
        setIsContextMenuOpen: setIsContextMenuOpen
    };
};


const $21f984d0478a8ef9$var$commonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small'
});
const $21f984d0478a8ef9$var$skeletonTextStyles = (0, $buxP3.xcss)({
    height: '14px',
    marginTop: 'space.025',
    marginBottom: 'space.025'
});
const $21f984d0478a8ef9$var$titleStyles = (0, $buxP3.xcss)({
    width: '280px'
});
const $21f984d0478a8ef9$var$iconStyles = (0, $buxP3.xcss)({
    width: 'size.200',
    height: 'size.200'
});
const $21f984d0478a8ef9$var$containerStyles = (0, $buxP3.xcss)({
    pointerEvents: 'none'
});
const $21f984d0478a8ef9$var$descriptionContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $21f984d0478a8ef9$var$descriptionStyles = (0, $buxP3.xcss)({
    width: '100%'
});
const $21f984d0478a8ef9$var$metadataStyles = (0, $buxP3.xcss)({
    width: '200px'
});
const $21f984d0478a8ef9$var$subMetaDataStyles = (0, $buxP3.xcss)({
    width: '50px'
});
const $21f984d0478a8ef9$export$9ecbe061c4358be9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$skeletonTextStyles,
                $21f984d0478a8ef9$var$subMetaDataStyles
            ]
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $21f984d0478a8ef9$var$commonStyles,
            $21f984d0478a8ef9$var$skeletonTextStyles,
            $21f984d0478a8ef9$var$subMetaDataStyles
        ]
    });
};
const $21f984d0478a8ef9$var$metaDataWideStyles = (0, $buxP3.xcss)({
    width: '100px'
});
const $21f984d0478a8ef9$export$a72c2188d2b05fba = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$skeletonTextStyles,
                $21f984d0478a8ef9$var$metaDataWideStyles
            ]
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $21f984d0478a8ef9$var$commonStyles,
            $21f984d0478a8ef9$var$skeletonTextStyles,
            $21f984d0478a8ef9$var$metaDataWideStyles
        ]
    });
};
const $21f984d0478a8ef9$export$dd3282b157ef6f7a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            $21f984d0478a8ef9$var$descriptionContainerStyles
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$skeletonTextStyles,
                $21f984d0478a8ef9$var$descriptionStyles
            ]
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t0
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$skeletonTextStyles,
                $21f984d0478a8ef9$var$descriptionStyles
            ]
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$iconStyles
            ]
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$skeletonTextStyles,
                $21f984d0478a8ef9$var$titleStyles
            ]
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $21f984d0478a8ef9$var$containerStyles,
            role: "list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            description: t2,
            icon: t3,
            title: t4,
            headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: [
                    $21f984d0478a8ef9$var$commonStyles,
                    $21f984d0478a8ef9$var$skeletonTextStyles,
                    $21f984d0478a8ef9$var$metadataStyles
                ]
            })
        }));
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $21f984d0478a8ef9$var$containerStyles,
        role: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$descriptionContainerStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$skeletonTextStyles,
                $21f984d0478a8ef9$var$descriptionStyles
            ]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$skeletonTextStyles,
                $21f984d0478a8ef9$var$descriptionStyles
            ]
        })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$iconStyles
            ]
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$skeletonTextStyles,
                $21f984d0478a8ef9$var$titleStyles
            ]
        }),
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $21f984d0478a8ef9$var$commonStyles,
                $21f984d0478a8ef9$var$skeletonTextStyles,
                $21f984d0478a8ef9$var$metadataStyles
            ]
        })
    }));
};


const $04940efdfc96d832$var$resultsListGridAreaStyles = (0, $buxP3.xcss)({
    gridArea: 'results-list',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200'
});
const $04940efdfc96d832$export$669f6ea7d267feaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $04940efdfc96d832$var$resultsListGridAreaStyles,
            testId: "search-page-results-list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$dd3282b157ef6f7a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$dd3282b157ef6f7a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$dd3282b157ef6f7a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$dd3282b157ef6f7a), null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $04940efdfc96d832$var$resultsListGridAreaStyles,
        testId: "search-page-results-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$dd3282b157ef6f7a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$dd3282b157ef6f7a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$dd3282b157ef6f7a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$dd3282b157ef6f7a), null));
};















var $17147815169b9e8a$exports = {};
$17147815169b9e8a$exports = new URL("no-results-dark.a00ae47b.svg", import.meta.url).toString();


var $8d9046b5177a182e$exports = {};
$8d9046b5177a182e$exports = new URL("no-results-light.5ca83755.svg", import.meta.url).toString();





const $64742f113cdc0c4e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noResultsPrimary: {
        id: "dynamic-cards-search-page.no_results_primary",
        defaultMessage: "We couldn't find anything matching your search"
    },
    noResultsSecondaryFilters: {
        id: "dynamic-cards-search-page.no_results_secondary_some_filters_applied",
        defaultMessage: "Looks like you have some filters applied. You could try clearing them."
    }
});


const $5c57c587d13eb9d3$export$ef6006467f04ee41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $315d557f08ee9463$export$d9172702747fb4bc), {
            imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($8d9046b5177a182e$exports))),
            imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($17147815169b9e8a$exports))),
            primaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $64742f113cdc0c4e$export$defe85febe8b728c).noResultsPrimary),
            secondaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $64742f113cdc0c4e$export$defe85febe8b728c).noResultsSecondaryFilters)
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $315d557f08ee9463$export$d9172702747fb4bc), {
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($8d9046b5177a182e$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($17147815169b9e8a$exports))),
        primaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $64742f113cdc0c4e$export$defe85febe8b728c).noResultsPrimary),
        secondaryText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $64742f113cdc0c4e$export$defe85febe8b728c).noResultsSecondaryFilters)
    });
};






















var $4ut97 = parcelRequire("4ut97");

var $9Ppk1 = parcelRequire("9Ppk1");

var $lqSug = parcelRequire("lqSug");

var $bzYTC = parcelRequire("bzYTC");

var $ah5yI = parcelRequire("ah5yI");

var $e7vVr = parcelRequire("e7vVr");

var $hJYQM = parcelRequire("hJYQM");
















var $7akNQ = parcelRequire("7akNQ");




















var $4MnFz = parcelRequire("4MnFz");


var $eh6Ml = parcelRequire("eh6Ml");





var $kMzDv = parcelRequire("kMzDv");


var $gABt9 = parcelRequire("gABt9");


var $7tsC5 = parcelRequire("7tsC5");


var $d5jV9 = parcelRequire("d5jV9");

const $ca36fbb7f8007876$export$5aa524d86254b4f = (key, value)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    window.localStorage.setItem(key, value);
};
const $ca36fbb7f8007876$export$93d719890ad66653 = (key)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    return window.localStorage.getItem(key);
};


const $a12fa58d8ce4dae3$export$3849829f439d9262 = (args)=>{
    const { name: name } = args;
    const cacheInstance = (0, $d5jV9.getInstance)(args);
    const persistedState = (0, $ca36fbb7f8007876$export$93d719890ad66653)(name);
    if (persistedState) cacheInstance.deserialize(persistedState);
    const get = (key, returnExpired)=>cacheInstance.get(key, returnExpired ?? true); // fetch expired result by default.
    const set = async (key, result)=>{
        cacheInstance.set(key, result);
        await result;
        const serialized = await cacheInstance.serialize();
        (0, $ca36fbb7f8007876$export$5aa524d86254b4f)(name, serialized);
    };
    const refreshOnAccessDecorator = (key, supplier, returnExpired)=>{
        // cache hit
        const results = get(key, returnExpired);
        // cache refresh
        const apiPromise = supplier();
        // set the promise in the cache
        set(key, apiPromise);
        if (results) // return the expired result
        return results;
        else // return the latest result
        return apiPromise;
    };
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator
    };
};


const $7b01b6676ae1e761$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $7b01b6676ae1e761$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const { refreshOnAccessDecorator: $7b01b6676ae1e761$var$refreshOnAccessDecoratorSearch } = (0, $a12fa58d8ce4dae3$export$3849829f439d9262)({
    name: 'search-config'
});
const $7b01b6676ae1e761$export$cf95148f36a28b96 = 'search-3p-config';
const { refreshOnAccessDecorator: $7b01b6676ae1e761$var$refreshOnAccessDecorator3pSearch } = (0, $a12fa58d8ce4dae3$export$3849829f439d9262)({
    name: $7b01b6676ae1e761$export$cf95148f36a28b96,
    expiration: 300000
});
const $7b01b6676ae1e761$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
const $7b01b6676ae1e761$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId })=>{
    const url = absoluteUrl || `${hostName || ''}${$7b01b6676ae1e761$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $7tsC5.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $7b01b6676ae1e761$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $7b01b6676ae1e761$var$refreshOnAccessDecoratorSearch(key.toString(), supplier);
};
const $7b01b6676ae1e761$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId })=>{
    const baseUrl = absoluteUrl || $7b01b6676ae1e761$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = $7b01b6676ae1e761$export$f80795c7fd0ce9fc(userId || '', cloudId || '');
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options);
    return $7b01b6676ae1e761$var$refreshOnAccessDecorator3pSearch(key.toString(), supplier, false);
};
const $7b01b6676ae1e761$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $7tsC5.generateHash)(`3p|${userId}|${cloudId}`);



const $5bc3952a31f94bbf$export$e5c324cf2a7795e0 = ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId })=>{
    const relativeSlackUrl = `/gateway/api/third-party-user-auth/slack/user-authed`;
    const baseUrl = absoluteUrl || relativeSlackUrl;
    const url = `${baseUrl}/${cloudId}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};








const $fc269b4f3807010d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    authorizationFail: {
        id: "dynamic-cards-search-page.oauth-banner.authorization-fail",
        defaultMessage: "Authorization for {product} failed."
    },
    authorizationSuccess: {
        id: "dynamic-cards-search-page.oauth-banner.authorization-success",
        defaultMessage: "Authorization for {product} successful."
    }
});


















var $I7hWB = parcelRequire("I7hWB");























const $55ba47c437332f2e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    connectThirdPartyProductTitle: {
        id: "dynamic-cards-search-page.connect_third_party_product_title",
        defaultMessage: "Your admin has added {product}!"
    },
    connectThirdPartyProductTitleAlternate: {
        id: "dynamic-cards-search-page.connect_third_party_product_title_alternate",
        defaultMessage: "{product} is now available!"
    },
    connectThirdPartyProductDescription: {
        id: "dynamic-cards-search-page.connect_third_party_product_description",
        defaultMessage: "Connect your account to see missing results"
    },
    dismiss: {
        id: "dynamic-cards-search-page.oauth-message-dismiss",
        defaultMessage: "Dismiss"
    },
    connect: {
        id: "dynamic-cards-search-page.oauth-message-connect",
        defaultMessage: "Connect"
    }
});


const $f8eaccd15b6a34d7$var$containerStyles = (0, $buxP3.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $f8eaccd15b6a34d7$var$connectPressableStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    paddingInline: 'space.150',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    color: 'color.link',
    ':hover': {
        textDecoration: 'underline',
        color: 'color.link.pressed'
    },
    ':active': {
        textDecoration: 'underline',
        color: 'color.link.pressed'
    },
    whiteSpace: 'nowrap' // so that "Connect" doesn't get broken up needlessly
});
const $f8eaccd15b6a34d7$var$actionsContainer = (0, $buxP3.xcss)({
    flexBasis: 'fit-content'
});
const $f8eaccd15b6a34d7$export$1b25a7895791d4fc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(26);
    const { product: product, onAuthorize: onAuthorize, onDismiss: onDismiss, testId: testId } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const productString = product === "sharepoint" ? "SharePoint" : (0, $37AYo.products)[product].displayName;
    const Icon = (0, $37AYo.products)[product].Icon;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "icon text cta"
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== Icon) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            appearance: "brand"
        });
        $[1] = Icon;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== product || $[4] !== productString) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, product === "figma" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $55ba47c437332f2e$export$defe85febe8b728c).connectThirdPartyProductTitleAlternate,
            values: {
                product: productString
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $55ba47c437332f2e$export$defe85febe8b728c).connectThirdPartyProductTitle,
            values: {
                product: productString
            }
        }));
        $[3] = product;
        $[4] = productString;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            size: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $55ba47c437332f2e$export$defe85febe8b728c).connectThirdPartyProductDescription));
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            space: "space.050",
            alignBlock: "center",
            shouldWrap: true
        }, t2, t3);
        $[7] = t2;
        $[8] = t4;
    } else t4 = $[8];
    const t5 = testId && `${testId}--actions`;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            weight: "medium",
            size: "medium",
            color: "color.link"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $55ba47c437332f2e$export$defe85febe8b728c).connect));
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== onAuthorize) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            onClick: onAuthorize,
            backgroundColor: "color.background.neutral.subtle",
            xcss: $f8eaccd15b6a34d7$var$connectPressableStyles
        }, t6);
        $[10] = onAuthorize;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== formatMessage) {
        t8 = formatMessage((0, $55ba47c437332f2e$export$defe85febe8b728c).dismiss);
        $[12] = formatMessage;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== onDismiss || $[15] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $f8eaccd15b6a34d7$var$_temp,
            onClick: onDismiss,
            label: t8,
            appearance: "subtle",
            spacing: "compact"
        });
        $[14] = onDismiss;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t5 || $[18] !== t7 || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            testId: t5,
            space: "space.150",
            rowSpace: "space.0",
            alignBlock: "center",
            xcss: $f8eaccd15b6a34d7$var$actionsContainer
        }, t7, t9);
        $[17] = t5;
        $[18] = t7;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t1 || $[22] !== t10 || $[23] !== t4 || $[24] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
            alignItems: "center",
            templateAreas: t0,
            templateColumns: "min-content 1fr auto",
            columnGap: "space.150",
            testId: testId,
            xcss: $f8eaccd15b6a34d7$var$containerStyles
        }, t1, t4, t10);
        $[21] = t1;
        $[22] = t10;
        $[23] = t4;
        $[24] = testId;
        $[25] = t11;
    } else t11 = $[25];
    return t11;
} : (props)=>{
    const { product: product, onAuthorize: onAuthorize, onDismiss: onDismiss, testId: testId } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const productString = product === 'sharepoint' ? 'SharePoint' : (0, $37AYo.products)[product].displayName;
    const Icon = (0, $37AYo.products)[product].Icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
        alignItems: "center",
        templateAreas: [
            'icon text cta'
        ],
        templateColumns: "min-content 1fr auto",
        columnGap: "space.150",
        testId: testId,
        xcss: $f8eaccd15b6a34d7$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        appearance: "brand"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        space: "space.050",
        alignBlock: "center",
        shouldWrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, product === 'figma' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $55ba47c437332f2e$export$defe85febe8b728c).connectThirdPartyProductTitleAlternate,
        values: {
            product: productString
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $55ba47c437332f2e$export$defe85febe8b728c).connectThirdPartyProductTitle,
        values: {
            product: productString
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $55ba47c437332f2e$export$defe85febe8b728c).connectThirdPartyProductDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        testId: testId && `${testId}--actions`,
        space: "space.150",
        rowSpace: "space.0",
        alignBlock: "center",
        xcss: $f8eaccd15b6a34d7$var$actionsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        onClick: onAuthorize,
        backgroundColor: "color.background.neutral.subtle",
        xcss: $f8eaccd15b6a34d7$var$connectPressableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        weight: "medium",
        size: "medium",
        color: "color.link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $55ba47c437332f2e$export$defe85febe8b728c).connect))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                label: "",
                color: "currentColor"
            }),
        onClick: onDismiss,
        label: formatMessage((0, $55ba47c437332f2e$export$defe85febe8b728c).dismiss),
        appearance: 'subtle',
        spacing: 'compact'
    })));
};
function $f8eaccd15b6a34d7$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps,
        label: "",
        color: "currentColor"
    });
}


const $4a6f4035a5325ddd$var$LOCAL_STORAGE_BANNER_DISMISS_KEY = 'atlassian.unified-search.oauth-banner-dismiss-counts';
const $4a6f4035a5325ddd$export$afe8c16e492e553f = (product, isHello)=>{
    const dismissCounts = $4a6f4035a5325ddd$var$getLocalStorageData();
    const hasUserDismissedThisProductBefore = (dismissCounts[product] ?? 0) > 0;
    if (isHello) return !(hasUserDismissedThisProductBefore || $4a6f4035a5325ddd$export$67e3eb5caec4ff4c(dismissCounts));
    return !hasUserDismissedThisProductBefore;
};
/**
 * The max number of times the user dismisses **across products**
 */ const $4a6f4035a5325ddd$var$MAX_DISMISSALS = 3;
const $4a6f4035a5325ddd$export$67e3eb5caec4ff4c = (dismissCounts)=>{
    const totalDismissalsAcrossProducts = Object.values(dismissCounts).reduce((prev, curr)=>prev + curr, 0);
    return totalDismissalsAcrossProducts >= $4a6f4035a5325ddd$var$MAX_DISMISSALS;
};
const $4a6f4035a5325ddd$export$94f957a0ee1d39c8 = (product)=>{
    const dismissCounts = $4a6f4035a5325ddd$var$getLocalStorageData();
    dismissCounts[product] = (dismissCounts[product] ?? 0) + 1;
    $4a6f4035a5325ddd$var$saveToLocalStorage(dismissCounts);
};
/**
 * @returns the local storage object that stores products and their dismiss counts
 */ const $4a6f4035a5325ddd$var$getLocalStorageData = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const serializedDismissCounts = localStorage.getItem($4a6f4035a5325ddd$var$LOCAL_STORAGE_BANNER_DISMISS_KEY);
    if (!serializedDismissCounts) return {};
    let localStorageObject;
    try {
        localStorageObject = JSON.parse(serializedDismissCounts);
    } catch (_) {
        return {};
    }
    return localStorageObject;
};
/**
 * Saves the local storage object that stores products and their dismiss counts
 */ const $4a6f4035a5325ddd$var$saveToLocalStorage = (localStorageObject)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem($4a6f4035a5325ddd$var$LOCAL_STORAGE_BANNER_DISMISS_KEY, JSON.stringify(localStorageObject));
};


const $e93b937d369640bb$export$4177cdcc6454d6f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { product: product, outboundAuthUrl: outboundAuthUrl } = t0;
    const [t1, t2] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId, user: user, outboundAuthConfigs: outboundAuthConfigs } = t1;
    const { setState: setState } = t2;
    const userId = user?.id;
    const { retrySearch: retrySearch } = (0, $2Va9o.useSearchActions)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isDismissed, setIsDismissed] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    let t3;
    if ($[0] !== product) {
        t3 = product.charAt(0).toUpperCase();
        $[0] = product;
        $[1] = t3;
    } else t3 = $[1];
    const productCapitalized = t3 + product.slice(1);
    let t4;
    if ($[2] !== cloudId || $[3] !== formatMessage || $[4] !== outboundAuthConfigs || $[5] !== product || $[6] !== productCapitalized || $[7] !== retrySearch || $[8] !== setState || $[9] !== showFlag || $[10] !== userId) {
        t4 = ()=>{
            if (product === "slack") (0, $5bc3952a31f94bbf$export$e5c324cf2a7795e0)({
                cloudId: cloudId
            });
            setIsDismissed(true);
            showFlag({
                title: formatMessage((0, $fc269b4f3807010d$export$defe85febe8b728c).authorizationSuccess, {
                    product: productCapitalized
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon-success, #6A9A23)"
                }),
                isAutoDismiss: true
            });
            const newOutboundAuthConfigs = $e93b937d369640bb$var$refreshOAuthCache(product, userId || "", cloudId || "", outboundAuthConfigs);
            setState({
                outboundAuthConfigs: newOutboundAuthConfigs
            });
            (0, $hOJLU.cache).clear();
            retrySearch();
        };
        $[2] = cloudId;
        $[3] = formatMessage;
        $[4] = outboundAuthConfigs;
        $[5] = product;
        $[6] = productCapitalized;
        $[7] = retrySearch;
        $[8] = setState;
        $[9] = showFlag;
        $[10] = userId;
        $[11] = t4;
    } else t4 = $[11];
    const onSuccess = t4;
    let t5;
    if ($[12] !== formatMessage || $[13] !== productCapitalized || $[14] !== showFlag) {
        t5 = ()=>{
            showFlag({
                title: formatMessage((0, $fc269b4f3807010d$export$defe85febe8b728c).authorizationFail, {
                    product: productCapitalized
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                isAutoDismiss: true
            });
        };
        $[12] = formatMessage;
        $[13] = productCapitalized;
        $[14] = showFlag;
        $[15] = t5;
    } else t5 = $[15];
    const onFail = t5;
    let t6;
    if ($[16] !== onFail || $[17] !== onSuccess || $[18] !== outboundAuthUrl) {
        t6 = ()=>{
            (0, $kMzDv.auth)(outboundAuthUrl).then(onSuccess).catch(onFail);
        };
        $[16] = onFail;
        $[17] = onSuccess;
        $[18] = outboundAuthUrl;
        $[19] = t6;
    } else t6 = $[19];
    const onAuthorize = t6;
    let t7;
    if ($[20] !== product) {
        t7 = ()=>{
            setIsDismissed(true);
            (0, $4a6f4035a5325ddd$export$94f957a0ee1d39c8)(product);
        };
        $[20] = product;
        $[21] = t7;
    } else t7 = $[21];
    const onDismiss = t7;
    if (isDismissed) return null;
    let t8;
    if ($[22] !== onAuthorize || $[23] !== onDismiss || $[24] !== product) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8eaccd15b6a34d7$export$1b25a7895791d4fc), {
            product: product,
            onAuthorize: onAuthorize,
            onDismiss: onDismiss
        });
        $[22] = onAuthorize;
        $[23] = onDismiss;
        $[24] = product;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : ({ product: product, outboundAuthUrl: outboundAuthUrl })=>{
    const [{ cloudId: cloudId, user: user, outboundAuthConfigs: outboundAuthConfigs }, { setState: setState }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const userId = user?.id;
    const { retrySearch: retrySearch } = (0, $2Va9o.useSearchActions)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isDismissed, setIsDismissed] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const productCapitalized = product.charAt(0).toUpperCase() + product.slice(1);
    const onSuccess = ()=>{
        if (product === 'slack') (0, $5bc3952a31f94bbf$export$e5c324cf2a7795e0)({
            cloudId: cloudId
        });
        setIsDismissed(true);
        showFlag({
            title: formatMessage((0, $fc269b4f3807010d$export$defe85febe8b728c).authorizationSuccess, {
                product: productCapitalized
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            }),
            isAutoDismiss: true
        });
        const newOutboundAuthConfigs = $e93b937d369640bb$var$refreshOAuthCache(product, userId || '', cloudId || '', outboundAuthConfigs);
        setState({
            outboundAuthConfigs: newOutboundAuthConfigs
        });
        (0, $hOJLU.cache).clear();
        retrySearch();
    };
    const onFail = ()=>{
        showFlag({
            title: formatMessage((0, $fc269b4f3807010d$export$defe85febe8b728c).authorizationFail, {
                product: productCapitalized
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            isAutoDismiss: true
        });
    };
    const onAuthorize = ()=>{
        (0, $kMzDv.auth)(outboundAuthUrl).then(onSuccess).catch(onFail);
    };
    const onDismiss = ()=>{
        setIsDismissed(true);
        (0, $4a6f4035a5325ddd$export$94f957a0ee1d39c8)(product);
    };
    if (isDismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8eaccd15b6a34d7$export$1b25a7895791d4fc), {
        product: product,
        onAuthorize: onAuthorize,
        onDismiss: onDismiss
    });
};
const $e93b937d369640bb$var$refreshOAuthCache = (product, userId, cloudId, outboundAuthConfigs)=>{
    const key = (0, $7b01b6676ae1e761$export$f80795c7fd0ce9fc)(userId, cloudId);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const item = localStorage.getItem((0, $7b01b6676ae1e761$export$cf95148f36a28b96));
    if (!item) return;
    let object;
    try {
        object = JSON.parse(item);
    } catch (_) {
        return;
    }
    const oauthConfig = object?.[key]?.result?.find((config)=>config.type.includes(product));
    if (!oauthConfig) return;
    oauthConfig.isUserOAuthed = true;
    const newOutboundAuthConfigs = {
        ...outboundAuthConfigs
    };
    const updatedConfig = outboundAuthConfigs[product];
    if (updatedConfig) updatedConfig.userNeedsOAuth = false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem((0, $7b01b6676ae1e761$export$cf95148f36a28b96), JSON.stringify(object));
    return newOutboundAuthConfigs;
};



const $80f58e8b5617f295$var$OAuthContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [t0] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { outboundAuthConfigs: outboundAuthConfigs, products: availableProducts } = t0;
    const [isHello] = (0, $122441d1a555945e$export$1a0be923fb1117e4)();
    let productOrder;
    let displayedProduct;
    if ($[0] !== availableProducts || $[1] !== isHello || $[2] !== outboundAuthConfigs) {
        productOrder = [
            (0, $37AYo.ProductKeys3P).GoogleDrive,
            (0, $37AYo.ProductKeys3P).Sharepoint,
            (0, $37AYo.ProductKeys3P).OneDrive,
            (0, $37AYo.ProductKeys3P).Slack,
            (0, $37AYo.ProductKeys3P).Teams,
            (0, $37AYo.ProductKeys3P).Github,
            (0, $37AYo.ProductKeys3P).Figma
        ];
        const productsToBeDisplayed = productOrder.filter((product_0)=>availableProducts.includes(product_0));
        for (const product_1 of productsToBeDisplayed){
            const config = outboundAuthConfigs[product_1];
            if (config && config.userNeedsOAuth && (0, $4a6f4035a5325ddd$export$afe8c16e492e553f)(product_1, isHello)) {
                displayedProduct = product_1;
                break;
            }
        }
        $[0] = availableProducts;
        $[1] = isHello;
        $[2] = outboundAuthConfigs;
        $[3] = displayedProduct;
        $[4] = productOrder;
    } else {
        displayedProduct = $[3];
        productOrder = $[4];
    }
    const outboundAuthUrl = displayedProduct && outboundAuthConfigs[displayedProduct]?.url;
    let t1;
    if ($[5] !== displayedProduct || $[6] !== outboundAuthUrl) {
        t1 = displayedProduct && outboundAuthUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e93b937d369640bb$export$4177cdcc6454d6f2), {
            product: displayedProduct,
            outboundAuthUrl: outboundAuthUrl
        })) : null;
        $[5] = displayedProduct;
        $[6] = outboundAuthUrl;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : ()=>{
    const [{ outboundAuthConfigs: outboundAuthConfigs, products: availableProducts }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const [isHello] = (0, $122441d1a555945e$export$1a0be923fb1117e4)();
    let productOrder = [];
    productOrder = [
        (0, $37AYo.ProductKeys3P).GoogleDrive,
        (0, $37AYo.ProductKeys3P).Sharepoint,
        (0, $37AYo.ProductKeys3P).OneDrive,
        (0, $37AYo.ProductKeys3P).Slack,
        (0, $37AYo.ProductKeys3P).Teams,
        (0, $37AYo.ProductKeys3P).Github,
        (0, $37AYo.ProductKeys3P).Figma
    ];
    const productsToBeDisplayed = productOrder.filter((product_0)=>availableProducts.includes(product_0));
    let displayedProduct;
    for (const product_1 of productsToBeDisplayed){
        const config = outboundAuthConfigs[product_1];
        if (config && config.userNeedsOAuth && (0, $4a6f4035a5325ddd$export$afe8c16e492e553f)(product_1, isHello)) {
            displayedProduct = product_1;
            break;
        }
    }
    const outboundAuthUrl = displayedProduct && outboundAuthConfigs[displayedProduct]?.url;
    return displayedProduct && outboundAuthUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e93b937d369640bb$export$4177cdcc6454d6f2), {
        product: displayedProduct,
        outboundAuthUrl: outboundAuthUrl
    })) : null;
};
const $80f58e8b5617f295$var$OAuthContainerWithErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($80f58e8b5617f295$var$OAuthContainer, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($80f58e8b5617f295$var$OAuthContainer, null));
};
var $80f58e8b5617f295$export$2e2bcd8739ae039 = $80f58e8b5617f295$var$OAuthContainerWithErrorBoundary;















var $9KSWX = parcelRequire("9KSWX");























var $jmUhx = parcelRequire("jmUhx");










const $14b49a5417cb0d73$export$134cbcd70c6693b8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GoalIcon() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            fill: "none",
            viewBox: "0 0 24 24"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm2 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
            fill: "currentColor"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function GoalIcon() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm2 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
        fill: "currentColor"
    }));
};










const $86f750f375fc64ee$export$219c8b8c393795b3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProjectIcon() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.8284 6C14.5632 6 14.3088 6.10536 14.1213 6.29289L10.4591 9.95515L6.30769 10.4164C6.08201 10.4415 5.87158 10.5426 5.71101 10.7032L5.4142 11L6.53032 12.1161C7.01847 12.6043 7.01847 13.3957 6.53032 13.8839L5.20709 15.2071C4.81657 15.5976 4.1834 15.5976 3.79288 15.2071C3.40235 14.8166 3.40235 14.1834 3.79288 13.7929L4.58577 13L3.64643 12.0607C3.06064 11.4749 3.06065 10.5251 3.64643 9.93934L4.2968 9.28897C4.77849 8.80728 5.40978 8.50387 6.08683 8.42864L9.54092 8.04485L12.7071 4.87868C13.2697 4.31607 14.0328 4 14.8284 4H18C19.1046 4 20 4.89543 20 6V9.17157C20 9.96722 19.6839 10.7303 19.1213 11.2929L15.9551 14.4591L15.5713 17.9132C15.4961 18.5902 15.1927 19.2215 14.711 19.7032L14.0606 20.3536C13.4749 20.9393 12.5251 20.9393 11.9393 20.3536L11 19.4142L10.2071 20.2071C9.81657 20.5976 9.1834 20.5976 8.79288 20.2071C8.40235 19.8166 8.40235 19.1834 8.79288 18.7929L10.1161 17.4697C10.6043 16.9815 11.3957 16.9815 11.8839 17.4697L13 18.5858L13.2968 18.289C13.4574 18.1284 13.5585 17.918 13.5836 17.6923L14.0448 13.5409L17.7071 9.87868C17.8946 9.69114 18 9.43679 18 9.17157V6H14.8284ZM8.70711 15.2929C9.09763 15.6834 9.09763 16.3166 8.70711 16.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L7.29289 15.2929C7.68342 14.9024 8.31658 14.9024 8.70711 15.2929ZM15 10C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9C14 9.55228 14.4477 10 15 10Z",
            fill: "currentColor"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function ProjectIcon() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.8284 6C14.5632 6 14.3088 6.10536 14.1213 6.29289L10.4591 9.95515L6.30769 10.4164C6.08201 10.4415 5.87158 10.5426 5.71101 10.7032L5.4142 11L6.53032 12.1161C7.01847 12.6043 7.01847 13.3957 6.53032 13.8839L5.20709 15.2071C4.81657 15.5976 4.1834 15.5976 3.79288 15.2071C3.40235 14.8166 3.40235 14.1834 3.79288 13.7929L4.58577 13L3.64643 12.0607C3.06064 11.4749 3.06065 10.5251 3.64643 9.93934L4.2968 9.28897C4.77849 8.80728 5.40978 8.50387 6.08683 8.42864L9.54092 8.04485L12.7071 4.87868C13.2697 4.31607 14.0328 4 14.8284 4H18C19.1046 4 20 4.89543 20 6V9.17157C20 9.96722 19.6839 10.7303 19.1213 11.2929L15.9551 14.4591L15.5713 17.9132C15.4961 18.5902 15.1927 19.2215 14.711 19.7032L14.0606 20.3536C13.4749 20.9393 12.5251 20.9393 11.9393 20.3536L11 19.4142L10.2071 20.2071C9.81657 20.5976 9.1834 20.5976 8.79288 20.2071C8.40235 19.8166 8.40235 19.1834 8.79288 18.7929L10.1161 17.4697C10.6043 16.9815 11.3957 16.9815 11.8839 17.4697L13 18.5858L13.2968 18.289C13.4574 18.1284 13.5585 17.918 13.5836 17.6923L14.0448 13.5409L17.7071 9.87868C17.8946 9.69114 18 9.43679 18 9.17157V6H14.8284ZM8.70711 15.2929C9.09763 15.6834 9.09763 16.3166 8.70711 16.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L7.29289 15.2929C7.68342 14.9024 8.31658 14.9024 8.70711 15.2929ZM15 10C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9C14 9.55228 14.4477 10 15 10Z",
        fill: "currentColor"
    }));
};










const $9d4bf3d617a21e93$export$80beb1cb95701424 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TagIcon() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            fill: "none",
            viewBox: "0 0 24 24"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.99 5.141a1 1 0 0 0-1.98-.282L8.561 8H6a1 1 0 0 0 0 2h2.276l-.572 4H5a1 1 0 1 0 0 2h2.418l-.408 2.859a1 1 0 0 0 1.98.282L9.439 16h3.98l-.409 2.859a1 1 0 0 0 1.98.282L15.439 16H18a1 1 0 1 0 0-2h-2.276l.572-4H19a1 1 0 1 0 0-2h-2.418l.408-2.859a1 1 0 1 0-1.98-.282L14.561 8h-3.98l.409-2.859ZM13.704 14l.572-4h-3.98l-.572 4h3.98Z",
            fill: "currentColor"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function TagIcon() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.99 5.141a1 1 0 0 0-1.98-.282L8.561 8H6a1 1 0 0 0 0 2h2.276l-.572 4H5a1 1 0 1 0 0 2h2.418l-.408 2.859a1 1 0 0 0 1.98.282L9.439 16h3.98l-.409 2.859a1 1 0 0 0 1.98.282L15.439 16H18a1 1 0 1 0 0-2h-2.276l.572-4H19a1 1 0 1 0 0-2h-2.418l.408-2.859a1 1 0 1 0-1.98-.282L14.561 8h-3.98l.409-2.859ZM13.704 14l.572-4h-3.98l-.572 4h3.98Z",
        fill: "currentColor"
    }));
};



var $4aQS7 = parcelRequire("4aQS7");


var $kUPAS = parcelRequire("kUPAS");

const $9c2e54be46e3373a$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    tag: 'tag',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $9c2e54be46e3373a$export$5cb7c19fcb84c9cd = {
    [$9c2e54be46e3373a$export$a93cddd79e3ea530.project]: {
        displayName: (0, $kUPAS.messages).project,
        displayNamePlural: (0, $kUPAS.messages).projects,
        Icon: (0, $86f750f375fc64ee$export$219c8b8c393795b3)
    },
    [$9c2e54be46e3373a$export$a93cddd79e3ea530.goal]: {
        displayName: (0, $kUPAS.messages).goal,
        displayNamePlural: (0, $kUPAS.messages).goals,
        Icon: (0, $14b49a5417cb0d73$export$134cbcd70c6693b8)
    },
    [$9c2e54be46e3373a$export$a93cddd79e3ea530.tag]: {
        displayName: (0, $kUPAS.messages).tag,
        displayNamePlural: (0, $kUPAS.messages).tags,
        Icon: (0, $9d4bf3d617a21e93$export$80beb1cb95701424)
    },
    [$9c2e54be46e3373a$export$a93cddd79e3ea530.AtlassianWebCrawler]: {
        displayName: (0, $kUPAS.messages).webPage,
        displayNamePlural: (0, $kUPAS.messages).webPages,
        Icon: (0, $4aQS7.WebDomainIcon)
    }
};
const $9c2e54be46e3373a$export$341b1567666c2663 = [
    $9c2e54be46e3373a$export$a93cddd79e3ea530.project,
    $9c2e54be46e3373a$export$a93cddd79e3ea530.goal,
    $9c2e54be46e3373a$export$a93cddd79e3ea530.tag,
    $9c2e54be46e3373a$export$a93cddd79e3ea530.AtlassianWebCrawler
];





const $5b6e60425766dcf3$export$1a199e029d5e93d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let product;
    let props;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ product: product, size: t1, isSelected: t2, ...props } = t0);
        $[0] = t0;
        $[1] = product;
        $[2] = props;
        $[3] = t1;
        $[4] = t2;
    } else {
        product = $[1];
        props = $[2];
        t1 = $[3];
        t2 = $[4];
    }
    const size = t1 === undefined ? "medium" : t1;
    const isSelected = t2 === undefined ? false : t2;
    let Icon;
    if (product) {
        Icon = (0, $37AYo.products)[product].Icon;
        let t3;
        if ($[5] !== Icon || $[6] !== props || $[7] !== size) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                ...props,
                size: size,
                appearance: "brand"
            });
            $[5] = Icon;
            $[6] = props;
            $[7] = size;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    } else {
        const t3 = isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
        let t4;
        if ($[9] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
                label: "",
                spacing: "spacious",
                color: t3
            });
            $[9] = t3;
            $[10] = t4;
        } else t4 = $[10];
        return t4;
    }
} : ({ product: product, size: size = 'medium', isSelected: isSelected = false, ...props })=>{
    let Icon;
    if (product) {
        Icon = (0, $37AYo.products)[product].Icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            ...props,
            size: size,
            appearance: "brand"
        });
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        spacing: "spacious",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
};
const $5b6e60425766dcf3$export$fe03eddc92730a5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let productOrNounKey;
    let props;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ productOrNounKey: productOrNounKey, size: t1, isSelected: t2, ...props } = t0);
        $[0] = t0;
        $[1] = productOrNounKey;
        $[2] = props;
        $[3] = t1;
        $[4] = t2;
    } else {
        productOrNounKey = $[1];
        props = $[2];
        t1 = $[3];
        t2 = $[4];
    }
    const size = t1 === undefined ? "medium" : t1;
    const isSelected = t2 === undefined ? false : t2;
    let Icon;
    if (productOrNounKey) {
        Icon = (0, $37AYo.products)[productOrNounKey]?.Icon || (0, $9c2e54be46e3373a$export$5cb7c19fcb84c9cd)[productOrNounKey]?.Icon;
        let t3;
        if ($[5] !== Icon || $[6] !== props || $[7] !== size) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                ...props,
                size: size,
                appearance: "brand"
            });
            $[5] = Icon;
            $[6] = props;
            $[7] = size;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    } else {
        const t3 = isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
        let t4;
        if ($[9] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
                label: "",
                spacing: "spacious",
                color: t3
            });
            $[9] = t3;
            $[10] = t4;
        } else t4 = $[10];
        return t4;
    }
} : ({ productOrNounKey: productOrNounKey, size: size = 'medium', isSelected: isSelected = false, ...props })=>{
    let Icon;
    if (productOrNounKey) {
        Icon = (0, $37AYo.products)[productOrNounKey]?.Icon || (0, $9c2e54be46e3373a$export$5cb7c19fcb84c9cd)[productOrNounKey]?.Icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            ...props,
            size: size,
            appearance: "brand"
        });
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        spacing: "spacious",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
};


















const $2e466e8b178d272a$var$metadataSpacerStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.075',
    marginRight: 'space.075'
});
const $2e466e8b178d272a$var$Spacer = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            as: "span",
            xcss: $2e466e8b178d272a$var$metadataSpacerStyles
        }, "\u2022");
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        as: "span",
        xcss: $2e466e8b178d272a$var$metadataSpacerStyles
    }, "\u2022");
const $2e466e8b178d272a$var$renderParts = (part, spacer)=>{
    const [key, value] = Array.isArray(part) ? part : [
        part,
        part
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
        key: key
    }, value, spacer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e466e8b178d272a$var$Spacer, null));
};
const $2e466e8b178d272a$var$filterPart = (part)=>{
    if (Array.isArray(part)) return !!part[1];
    return !!part;
};
const $2e466e8b178d272a$export$8e7fb1f8fe599124 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { product: product, productSelected: productSelected, parts: t1 } = t0;
    let t2;
    let t3;
    if ($[0] !== product || $[1] !== productSelected || $[2] !== t1) {
        const defaultParts = t1 === undefined ? [] : t1;
        let t4;
        if ($[5] !== product || $[6] !== productSelected) {
            t4 = productSelected ? "" : (0, $a4ade32e9dcacfed$export$44fea6589b7ddc92)(product);
            $[5] = product;
            $[6] = productSelected;
            $[7] = t4;
        } else t4 = $[7];
        const productDisplayName = t4;
        const parts = defaultParts.filter($2e466e8b178d272a$var$filterPart);
        if ($[8] !== productDisplayName) {
            t3 = productDisplayName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0f6b39825d0c965$export$f6a3d19be20f5819), {
                target: "layout",
                above: "sm"
            }, productDisplayName, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e466e8b178d272a$var$Spacer, null));
            $[8] = productDisplayName;
            $[9] = t3;
        } else t3 = $[9];
        t2 = parts?.map((m, i)=>$2e466e8b178d272a$var$renderParts(m, i < parts.length - 1));
        $[0] = product;
        $[1] = productSelected;
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    let t4;
    if ($[10] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2);
        $[10] = t2;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4);
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ product: product, productSelected: productSelected, parts: defaultParts = [] })=>{
    const productDisplayName = productSelected ? '' : (0, $a4ade32e9dcacfed$export$44fea6589b7ddc92)(product);
    const parts = defaultParts.filter($2e466e8b178d272a$var$filterPart);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, productDisplayName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0f6b39825d0c965$export$f6a3d19be20f5819), {
        target: "layout",
        above: "sm"
    }, productDisplayName, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e466e8b178d272a$var$Spacer, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, parts?.map((m, i)=>$2e466e8b178d272a$var$renderParts(m, i < parts.length - 1))));
};
















const $6319f15e3b45f1e8$var$anchorStyles = (0, $buxP3.xcss)({
    display: 'inline-block',
    overflow: 'hidden',
    font: 'font.body',
    color: 'color.text.subtle',
    textDecoration: 'none',
    ':hover': {
        color: 'color.text.subtle'
    },
    ':visited': {
        color: 'color.text.subtle'
    },
    ':focus': {
        color: 'color.text.subtle'
    },
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $6319f15e3b45f1e8$var$SearchMetadataLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { label: label, href: href } = t0;
    let t1;
    if ($[0] !== href || $[1] !== label) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
            href: href,
            xcss: $6319f15e3b45f1e8$var$anchorStyles
        }, label);
        $[0] = href;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ label: label, href: href })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
        href: href,
        xcss: $6319f15e3b45f1e8$var$anchorStyles
    }, label);
};
var $6319f15e3b45f1e8$export$2e2bcd8739ae039 = $6319f15e3b45f1e8$var$SearchMetadataLink;


















const $846bfa7a23817997$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    page: {
        id: "dynamic-cards-search-page.search_result_type_page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "dynamic-cards-search-page.search_result_type_blogpost",
        defaultMessage: "Blog Post"
    },
    whiteboard: {
        id: "dynamic-cards-search-page.search_result_type_whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "dynamic-cards-search-page.search_result_type_database",
        defaultMessage: "Database"
    },
    space: {
        id: "dynamic-cards-search-page.search_result_type_space",
        defaultMessage: "Space"
    },
    attachment: {
        id: "dynamic-cards-search-page.search_result_type_attachment",
        defaultMessage: "Attachment"
    },
    comment: {
        id: "dynamic-cards-search-page.search_result_type_comment",
        defaultMessage: "Comment"
    },
    folder: {
        id: "dynamic-cards-search-page.search_result_type_folder",
        defaultMessage: "Folder"
    },
    calendar: {
        id: "dynamic-cards-search-page.search_result_type_calendar",
        defaultMessage: "Calendar"
    },
    space_calendar: {
        // snake_case returned by the API
        id: "dynamic-cards-search-page.search_result_type_space_calendar",
        defaultMessage: "Space calendar"
    },
    question: {
        id: "dynamic-cards-search-page.search_result_type_question",
        defaultMessage: "Question"
    },
    answer: {
        id: "dynamic-cards-search-page.search_result_type_answer",
        defaultMessage: "Answer"
    },
    embed: {
        id: "dynamic-cards-search-page.search_result_type_embed",
        defaultMessage: "Smart Link"
    },
    board: {
        id: "dynamic-cards-search-page.search_result_type_board",
        defaultMessage: "Board"
    },
    dashboard: {
        id: "dynamic-cards-search-page.search_result_type_dashboard",
        defaultMessage: "Dashboard"
    },
    filter: {
        id: "dynamic-cards-search-page.search_result_type_filter",
        defaultMessage: "Filter"
    },
    issue: {
        id: "dynamic-cards-search-page.search_result_type_issue",
        defaultMessage: "Issue"
    },
    plan: {
        id: "dynamic-cards-search-page.search_result_type_plan",
        defaultMessage: "Plan"
    },
    project: {
        id: "dynamic-cards-search-page.search_result_type_project",
        defaultMessage: "Project"
    },
    goal: {
        id: "dynamic-cards-search-page.search_result_type_goal",
        defaultMessage: "Goal"
    },
    tag: {
        id: "dynamic-cards-search-page.search_result_type_tag",
        defaultMessage: "Tag"
    },
    learning: {
        id: "dynamic-cards-search-page.search_result_type_learning",
        defaultMessage: "Learning"
    },
    unrecognised: {
        id: "dynamic-cards-search-page.search_result_type_unrecognised",
        defaultMessage: "Unrecognised"
    },
    document: {
        id: "dynamic-cards-search-page.search_result_type_document",
        defaultMessage: "Document"
    },
    spreadsheet: {
        id: "dynamic-cards-search-page.search_result_type_spreadsheet",
        defaultMessage: "Spreadsheet"
    },
    presentation: {
        id: "dynamic-cards-search-page.search_result_type_presentation",
        defaultMessage: "Presentation"
    },
    'sharepoint-document': {
        id: "dynamic-cards-search-page.search_result_type_sharepoint_document",
        defaultMessage: "Sharepoint Document"
    },
    message: {
        id: "dynamic-cards-search-page.search_result_type_message",
        defaultMessage: "Message"
    },
    repository: {
        id: "dynamic-cards-search-page.search_result_type_repository",
        defaultMessage: "Repository"
    },
    'pull-request': {
        id: "dynamic-cards-search-page.search_result_type_pull_request",
        defaultMessage: "Pull Request"
    },
    commit: {
        id: "dynamic-cards-search-page.search_result_type_commit",
        defaultMessage: "Commit"
    },
    branch: {
        id: "dynamic-cards-search-page.search_result_type_branch",
        defaultMessage: "Branch"
    },
    channel: {
        id: "dynamic-cards-search-page.search_result_type_channel",
        defaultMessage: "Channel"
    },
    component: {
        id: "dynamic-cards-search-page.search_result_type_component",
        defaultMessage: "Component"
    },
    'work-item': {
        id: "dynamic-cards-search-page.search_result_type_work_item",
        defaultMessage: "Work Item"
    },
    card: {
        id: "dynamic-cards-search-page.search_result_type_card",
        defaultMessage: "Card"
    }
});


const $20651b41f8c81b92$export$95cacd63dfd98bee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { type: type } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = (0, $846bfa7a23817997$export$defe85febe8b728c)[type];
    if (!message) return null;
    let t1;
    if ($[0] !== formatMessage || $[1] !== message) {
        t1 = formatMessage(message);
        $[0] = formatMessage;
        $[1] = message;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = (0, $846bfa7a23817997$export$defe85febe8b728c)[type];
    if (!message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage(message));
};


/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 












var $4UwFu = parcelRequire("4UwFu");



















var $iITVA = parcelRequire("iITVA");









const $12c57466b7657e64$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    personAvatarLabel: {
        id: "personAvatar.label",
        defaultMessage: "Person Avatar"
    },
    initialsAvatarLabel: {
        id: "initialsAvatar.label",
        defaultMessage: "Initials Avatar"
    }
});


const $5c900a01b74c1545$var$initialsAvatarColor = "var(--ds-background-neutral, #0515240F)";
const $5c900a01b74c1545$var$personAvatarColor = "var(--ds-icon, #292A2E)";
const $5c900a01b74c1545$var$textColor = "var(--ds-text, #292A2E)";
const $5c900a01b74c1545$var$defaultAvatarCSS = (0, $buxP3.xcss)({
    padding: 'space.025',
    alignItems: 'center',
    display: 'flex'
});
const $5c900a01b74c1545$var$initialsAvatarCSS = (0, $buxP3.xcss)({
    alignItems: 'center',
    display: 'flex'
});
function $5c900a01b74c1545$var$getInitials(name) {
    const names = name.split(' ');
    const lastName = names.length > 1 ? names[names.length - 1] : '';
    const firstInitial = names[0][0].toUpperCase();
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return firstInitial + lastInitial;
}
const $5c900a01b74c1545$export$e2255cf6045e8d47 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { name: name } = t0;
    const useInitialsAvatar = false;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== name || $[2] !== useInitialsAvatar) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, useInitialsAvatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            testId: "3p-message-avatar",
            xcss: $5c900a01b74c1545$var$initialsAvatarCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            "aria-label": formatMessage((0, $12c57466b7657e64$export$defe85febe8b728c).initialsAvatarLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
            cx: "10",
            cy: "10",
            r: "10",
            fill: $5c900a01b74c1545$var$initialsAvatarColor
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("text", {
            x: "50%",
            y: "55%",
            fontFamily: "SF Pro Text, sans-serif",
            dominantBaseline: "middle",
            textAnchor: "middle",
            fontSize: "11",
            fontWeight: "400",
            fill: $5c900a01b74c1545$var$textColor
        }, $5c900a01b74c1545$var$getInitials(name)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $5c900a01b74c1545$var$defaultAvatarCSS,
            testId: "3p-message-avatar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iITVA))), {
            label: formatMessage((0, $12c57466b7657e64$export$defe85febe8b728c).personAvatarLabel),
            color: $5c900a01b74c1545$var$personAvatarColor
        })));
        $[0] = formatMessage;
        $[1] = name;
        $[2] = useInitialsAvatar;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ name: name })=>{
    // fg('use_initials_avatar_icon_3pmessages') => false
    const useInitialsAvatar = false;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, useInitialsAvatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        testId: "3p-message-avatar",
        xcss: $5c900a01b74c1545$var$initialsAvatarCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        "aria-label": formatMessage((0, $12c57466b7657e64$export$defe85febe8b728c).initialsAvatarLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: $5c900a01b74c1545$var$initialsAvatarColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("text", {
        x: "50%",
        y: "55%",
        fontFamily: "SF Pro Text, sans-serif",
        dominantBaseline: "middle",
        textAnchor: "middle",
        fontSize: "11",
        fontWeight: "400",
        fill: $5c900a01b74c1545$var$textColor
    }, $5c900a01b74c1545$var$getInitials(name)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $5c900a01b74c1545$var$defaultAvatarCSS,
        testId: "3p-message-avatar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iITVA))), {
        label: formatMessage((0, $12c57466b7657e64$export$defe85febe8b728c).personAvatarLabel),
        color: $5c900a01b74c1545$var$personAvatarColor
    })));
};





const $7493884928001162$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    lastActive: {
        id: "search-page.results.product-results.third-party.last-active",
        defaultMessage: "Last active {relativeDate}"
    },
    threadTypeLabel: {
        id: "search-page.results.product-results.third-party.thread-type-label",
        defaultMessage: "Thread"
    },
    messageTypeLabel: {
        id: "search-page.results.product-results.third-party.message-type-label",
        defaultMessage: "Message"
    },
    channelTypeLabel: {
        id: "search-page.results.product-results.third-party.channel-type-label",
        defaultMessage: "Channel"
    },
    channelMemberCount: {
        id: "search-page.results.product-results.third-party.channel-member-count",
        defaultMessage: "{memberCount, plural, one {# member} other {# members}}"
    },
    privateConversationText: {
        id: "search-page.results.product-results.third-party.private-conversation-text",
        defaultMessage: "{users} in a private conversation"
    },
    noContributorsText: {
        id: "search-page.results.product-results.third-party.no-contributors-label",
        defaultMessage: "External people in #{channelName}"
    },
    externalPeopleText: {
        id: "search-page.results.product-results.third-party.external-people-label",
        defaultMessage: "External people"
    },
    externalPersonText: {
        id: "search-page.results.product-results.third-party.external-person-label",
        defaultMessage: "External person"
    },
    titleWithRemainingContributors: {
        id: "search-page.results.product-results.third-party.title-with-remaining-contributors",
        defaultMessage: "{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}"
    },
    titleAndChannelName: {
        id: "search-page.results.product-results.third-party.title-and-channel-name",
        defaultMessage: "{title} in #{channelName}"
    }
});


const $8a1a5c2af543b4cc$var$threadItemCSS = (0, $buxP3.xcss)({
    paddingBottom: 'space.050',
    paddingTop: 'space.050'
});
const $8a1a5c2af543b4cc$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $8a1a5c2af543b4cc$var$MAX_EXCERPT_LENGTH = 80;
const $8a1a5c2af543b4cc$var$USER_DISPLAY_LIMIT = 3;
const $8a1a5c2af543b4cc$export$2f5ba0d1129fe71 = (inputStr)=>{
    const htmlEntities = {
        '&nbsp;': ' ',
        '&lt;': '<',
        '&amp;': '&',
        '&quot;': '"',
        '&gt;': '>'
    };
    return Object.keys(htmlEntities).reduce((str, entity)=>{
        return str.replace(new RegExp(entity, 'g'), htmlEntities[entity]);
    }, inputStr);
};
const $8a1a5c2af543b4cc$export$16c2ab98757b54d6 = (excerpt, noLeadingEllipsis, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: "empty"
        })
    ];
    excerpt = $8a1a5c2af543b4cc$export$2f5ba0d1129fe71(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($8a1a5c2af543b4cc$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipsis prefix if beginning of excerpt isn't a URL and excerpt length is greater than 80
    if (!noLeadingEllipsis && !beginsWithUrl && excerpt.length > $8a1a5c2af543b4cc$var$MAX_EXCERPT_LENGTH) excerpt = '...'.concat(excerpt);
    // Add ellipsis suffix if excerpt doesn't end with ending punctuation and if length is greater than 80
    if (excerpt.length > $8a1a5c2af543b4cc$var$MAX_EXCERPT_LENGTH && !excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with separators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $8a1a5c2af543b4cc$export$b847312d69858d61(excerpt, prefix);
};
const $8a1a5c2af543b4cc$export$b847312d69858d61 = (excerpt, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: "empty"
        })
    ];
    excerpt = $8a1a5c2af543b4cc$export$2f5ba0d1129fe71(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: "empty"
        })
    ];
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: `pre-${i}`
        }, pre));
        if (textMatch) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("strong", {
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return(// NOTE: wrapping these in <div> previously broke focus rings
    // in search results
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, prefix, res));
};
function $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b(permissionLevel) {
    return permissionLevel === 'restricted' || permissionLevel === 'private';
}
const $8a1a5c2af543b4cc$export$85fedc4ba4240156 = (input, maxLength)=>{
    if (input.length <= maxLength) return input;
    return input.substring(0, maxLength) + '...';
};
const $8a1a5c2af543b4cc$export$c32a8291d21fb086 = (thumbnailUrl)=>{
    // Parse the URL
    const urlObj = new URL(thumbnailUrl);
    const params = urlObj.searchParams;
    // Extract the required parameters
    const amzExpires = params.get('X-Amz-Expires');
    const amzDate = params.get('X-Amz-Date');
    // if we lose the format, we should not attempt to render the thumbnail
    if (!amzExpires || !amzDate) return true;
    // Convert X-Amz-Date to a Date object
    const amzDateObj = new Date(parseInt(amzDate.substring(0, 4)), // Year
    parseInt(amzDate.substring(4, 6)) - 1, // Month (0-based index)
    parseInt(amzDate.substring(6, 8)), // Day
    parseInt(amzDate.substring(9, 11)), // Hour
    parseInt(amzDate.substring(11, 13)), // Minute
    parseInt(amzDate.substring(13, 15)) // Second
    );
    // Calculate the expiration time in milliseconds
    const expirationTime = amzDateObj.getTime() + parseInt(amzExpires) * 1000;
    // Get the current time in milliseconds
    const currentTime = Date.now();
    // Determine if the current time is greater than the expiration time
    return currentTime > expirationTime;
};
const $8a1a5c2af543b4cc$export$a688e0cd0fe53c61 = (inputString, mentions = [])=>{
    if (!inputString) return '';
    // Replace Slack aliases - @here, @channel, @everyone
    // More information on these can be found here: https://api.slack.com/reference/surfaces/formatting#special-mentions
    let processedString = inputString.replace(/<!(here|channel|everyone)>/g, '@$1');
    // Replace mentions with slack user names
    const slackNamePattern = /<@[^>]+>/g;
    processedString = processedString.replace(slackNamePattern, (externalId)=>{
        // Find the mention with the matching externalId
        const validMentions = mentions.filter((m)=>m !== null && m !== undefined);
        const mention = validMentions.find((m)=>`<@${m.externalId}>` === externalId);
        return mention ? `@${mention.name}` : ''; // Replace with name if found, otherwise remove the string
    });
    return processedString;
};
const $8a1a5c2af543b4cc$export$4675aadf6b343fe5 = (allContributors, channelName, intl)=>{
    const { formatMessage: formatMessage } = intl;
    if (!allContributors) return formatMessage((0, $7493884928001162$export$defe85febe8b728c).noContributorsText, {
        channelName: channelName
    });
    const firstNamesString = $8a1a5c2af543b4cc$export$71c19251e893ab21(allContributors, intl);
    let title = '';
    // if there are less than 3 contributors, show all
    if (allContributors.length <= $8a1a5c2af543b4cc$var$USER_DISPLAY_LIMIT) title = firstNamesString;
    else // if there are more than 3 contributors, show the first 3
    title = formatMessage((0, $7493884928001162$export$defe85febe8b728c).titleWithRemainingContributors, {
        title: firstNamesString,
        remainingContributorsCount: allContributors.length - $8a1a5c2af543b4cc$var$USER_DISPLAY_LIMIT
    });
    return formatMessage((0, $7493884928001162$export$defe85febe8b728c).titleAndChannelName, {
        title: title,
        channelName: channelName
    });
};
const $8a1a5c2af543b4cc$export$71c19251e893ab21 = (contributors, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const firstNames = contributors.map((contributor)=>contributor?.name?.split(' ')?.[0] || formatMessage((0, $7493884928001162$export$defe85febe8b728c).externalPersonText));
    // if all contributors are external, show external people label
    if (firstNames.every((name)=>name === formatMessage((0, $7493884928001162$export$defe85febe8b728c).externalPersonText))) return formatMessage((0, $7493884928001162$export$defe85febe8b728c).externalPeopleText);
    return firstNames.slice(0, $8a1a5c2af543b4cc$var$USER_DISPLAY_LIMIT).join(', ');
};
const $8a1a5c2af543b4cc$export$3cf018c7cb5c2c7d = (partial, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const { description: description } = partial;
    let matchedMessage = null;
    let threadMessages = null;
    if ((0, $hJYQM.isSlackMessage)(partial)) {
        const { initialContributors: initialContributors, linkedEntities: linkedEntities = [] } = partial;
        const ownerName = initialContributors?.[0]?.name || formatMessage((0, $7493884928001162$export$defe85febe8b728c).externalPersonText);
        matchedMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $8a1a5c2af543b4cc$var$threadItemCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            key: "initial",
            space: "space.025",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c900a01b74c1545$export$e2255cf6045e8d47), {
            name: ownerName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            maxLines: 1
        }, ownerName, ": ", $8a1a5c2af543b4cc$export$b847312d69858d61($8a1a5c2af543b4cc$export$a688e0cd0fe53c61(description)))));
        threadMessages = linkedEntities.slice(0, 2).map((entity)=>{
            const currentMessageOwnerName = entity.initialContributors?.[0]?.name;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $8a1a5c2af543b4cc$var$threadItemCSS
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
                key: entity.id,
                space: "space.025",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c900a01b74c1545$export$e2255cf6045e8d47), {
                name: currentMessageOwnerName
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                maxLines: 1
            }, currentMessageOwnerName ? ` ${currentMessageOwnerName}: ` : '', ' ', $8a1a5c2af543b4cc$export$b847312d69858d61($8a1a5c2af543b4cc$export$a688e0cd0fe53c61(entity.description)))));
        });
    } else if ((0, $ah5yI.isMessageEntity)(partial)) {
        const { initialContributors: initialContributors, linkedEntities: linkedEntities = [] } = partial;
        const ownerName = initialContributors?.[0]?.name;
        matchedMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $8a1a5c2af543b4cc$var$threadItemCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            key: "initial",
            space: "space.025",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c900a01b74c1545$export$e2255cf6045e8d47), {
            name: ownerName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            maxLines: 1
        }, ownerName, ": ", $8a1a5c2af543b4cc$export$b847312d69858d61(description))));
        threadMessages = linkedEntities.slice(0, 2).map((entity)=>{
            const currentMessageOwnerName = entity.initialContributors?.[0]?.name || formatMessage((0, $7493884928001162$export$defe85febe8b728c).externalPersonText);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $8a1a5c2af543b4cc$var$threadItemCSS
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
                key: entity.id,
                space: "space.025",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c900a01b74c1545$export$e2255cf6045e8d47), {
                name: currentMessageOwnerName
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                maxLines: 1
            }, currentMessageOwnerName, ":", $8a1a5c2af543b4cc$export$b847312d69858d61(entity.description))));
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, matchedMessage, threadMessages?.map((message)=>message));
};
const $8a1a5c2af543b4cc$export$995e2d4c52603c12 = (linkedEntities)=>{
    const contributors = (linkedEntities || []).flatMap((entity)=>entity.initialContributors || []).reduce((acc, curr)=>{
        acc[curr?.externalId] = curr;
        return acc;
    }, {});
    return Object.values(contributors);
};
const $8a1a5c2af543b4cc$export$fdcae512e9fdc5ad = (timestamp)=>{
    return $8a1a5c2af543b4cc$export$96e2a37e068d7fac($8a1a5c2af543b4cc$export$7e0fd00186ff29c6(timestamp));
};
const $8a1a5c2af543b4cc$export$158516eb8829fc93 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const now = new Date();
    return (now.getTime() - new Date(timestamp).getTime()) / 1000;
};
const $8a1a5c2af543b4cc$export$7e0fd00186ff29c6 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const secondsPast = $8a1a5c2af543b4cc$export$158516eb8829fc93(timestamp);
    const timeUnits = {
        seconds: secondsPast,
        minutes: secondsPast / 60,
        hours: secondsPast / 3600,
        days: secondsPast / 86400,
        months: secondsPast / 2592000,
        years: secondsPast / 31536000
    };
    return {
        seconds: Math.floor(timeUnits.seconds),
        minutes: Math.floor(timeUnits.minutes),
        hours: Math.floor(timeUnits.hours),
        days: Math.floor(timeUnits.days),
        months: Math.floor(timeUnits.months),
        years: Math.floor(timeUnits.years)
    };
};
const $8a1a5c2af543b4cc$export$96e2a37e068d7fac = ({ seconds: seconds, minutes: minutes, hours: hours, days: days, months: months, years: years })=>{
    return $8a1a5c2af543b4cc$export$3e6e07f5a5b9cd48(seconds, minutes, hours, days, months, years);
};
const $8a1a5c2af543b4cc$export$3e6e07f5a5b9cd48 = (seconds, minutes, hours, days, months, years)=>{
    if (years > 0) return {
        unit: 'year',
        value: years
    };
    else if (months > 0) return {
        unit: 'month',
        value: months
    };
    else if (days > 0) return {
        unit: 'day',
        value: days
    };
    else if (hours > 0) return {
        unit: 'hour',
        value: hours
    };
    else if (minutes > 0) return {
        unit: 'minute',
        value: minutes
    };
    else return {
        unit: 'second',
        value: seconds
    };
};
const $8a1a5c2af543b4cc$export$fb63ba58603395b8 = (integrationId)=>{
    return integrationId ? (0, $4UwFu.PlatformIntegrationAri).parse(integrationId).integrationKey : undefined;
};


const $49e72282c8d5e924$export$94df0e59ebebf4a7 = (url, key, unencodedValue)=>{
    return $49e72282c8d5e924$export$cbc5b385481fb319(url, {
        [key]: unencodedValue
    });
};
const $49e72282c8d5e924$export$cbc5b385481fb319 = (url, params)=>{
    if (!url) return url;
    const sanitisedUrl = url.endsWith('?') || url.endsWith('&') ? url.slice(0, url.length - 1) : url;
    const paramsString = Object.entries(params).reduce((rest, [key, unencodedValue])=>{
        if (!key) return rest;
        const nextPart = `${encodeURIComponent(key)}=${encodeURIComponent(unencodedValue)}`;
        if (rest) return `${rest}&${nextPart}`;
        return nextPart;
    }, '');
    if (!paramsString) return url;
    // If it has a query string already
    if (sanitisedUrl.includes('?')) return `${sanitisedUrl}&${paramsString}`;
    return `${sanitisedUrl}?${paramsString}`;
};








const $ceba75cd17cd92d5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    for: {
        id: "dynamic-cards-search-page.atlas.for",
        defaultMessage: "for"
    },
    'townsquare.api.goal-state.archived': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.archived",
        defaultMessage: "Archived"
    },
    'townsquare.api.goal-state.off-track': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.off-track",
        defaultMessage: "Off track"
    },
    'townsquare.api.goal-state.at-risk': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.at-risk",
        defaultMessage: "At risk"
    },
    'townsquare.api.goal-state.on-track': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.on-track",
        defaultMessage: "On track"
    },
    'townsquare.api.goal-state.pending': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.pending",
        defaultMessage: "Pending"
    },
    'townsquare.api.goal-state.paused': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.paused",
        defaultMessage: "Paused"
    },
    'townsquare.api.goal-state.completed': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.completed",
        defaultMessage: "Completed"
    },
    'townsquare.api.goal-state.cancelled': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.cancelled",
        defaultMessage: "Cancelled"
    }
});


const $15dffd31214416dd$var$getKey = (partial)=>{
    if ((0, $4ut97.isSearchResultAtlasProjectPartial)(partial)) return partial.project?.key;
    else if ((0, $4ut97.isSearchResultAtlasGoalPartial)(partial)) return partial.goal?.key;
    else return null;
};
const $15dffd31214416dd$var$statusAndDateContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $15dffd31214416dd$var$statusDateStyles = (0, $buxP3.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtle'
});
const $15dffd31214416dd$var$getStatusAndDate = (partial)=>{
    let statusLabel = null;
    let statusValue;
    let date = null;
    if ((0, $4ut97.isSearchResultAtlasProjectPartial)(partial)) {
        statusLabel = partial.project?.state.label;
        statusValue = partial.project?.state.value;
        date = partial.project?.dueDate.label;
    } else if ((0, $4ut97.isSearchResultAtlasGoalPartial)(partial)) {
        const messageKey = partial.goal?.status.localizedLabel.messageId;
        statusLabel = (0, $ceba75cd17cd92d5$export$defe85febe8b728c)[messageKey] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ceba75cd17cd92d5$export$defe85febe8b728c)[messageKey]) : null;
        date = partial.goal?.targetDate.label;
    }
    if (!statusLabel || !statusValue) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $15dffd31214416dd$var$statusAndDateContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        style: $15dffd31214416dd$export$e9a2c2b0ecc25ba5(statusValue)
    }, statusLabel), date && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $15dffd31214416dd$var$statusDateStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ceba75cd17cd92d5$export$defe85febe8b728c).for)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        style: $15dffd31214416dd$var$defaultStatusLozengeStyle
    }, date)));
};
const $15dffd31214416dd$var$onTrackStatusLozengeStyle = {
    backgroundColor: `${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`,
    color: `${"var(--ds-text-accent-green, #216E4E)"}`
};
const $15dffd31214416dd$var$atRiskStatusLozengeStyle = {
    backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"}`,
    color: `${"var(--ds-text-accent-orange, #9E4C00)"}`
};
const $15dffd31214416dd$var$offTrackStatusLozengeStyle = {
    backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
    color: `${"var(--ds-text-accent-red, #AE2E24)"}`
};
const $15dffd31214416dd$var$defaultStatusLozengeStyle = {
    backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`,
    color: `${"var(--ds-text-accent-gray, #505258)"}`
};
const $15dffd31214416dd$export$e9a2c2b0ecc25ba5 = (statusType)=>{
    switch(statusType){
        case 'on_track':
            return $15dffd31214416dd$var$onTrackStatusLozengeStyle;
        case 'at_risk':
            return $15dffd31214416dd$var$atRiskStatusLozengeStyle;
        case 'off_track':
            return $15dffd31214416dd$var$offTrackStatusLozengeStyle;
        default:
            return $15dffd31214416dd$var$defaultStatusLozengeStyle;
    }
};
const $15dffd31214416dd$var$descriptionContainerStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    maxHeight: '60px'
});
const $15dffd31214416dd$var$getDescription = (partial)=>{
    let description = '';
    if ((0, $4ut97.isSearchResultAtlasGoalPartial)(partial) && partial.goal?.description) {
        const parsedDescrption = JSON.parse(partial.goal.description);
        // Recursive function to build the description. Traversal occurs in DFS
        // order. The base case is when the node is a text node, in which case
        // the text is appended to the description.
        const buildDescription = (goalDescription)=>{
            if (goalDescription.content) goalDescription.content.forEach(buildDescription);
            else if (goalDescription.type === 'text') description += goalDescription.text;
        };
        if (parsedDescrption.content) buildDescription(parsedDescrption);
    }
    return description;
};
const $15dffd31214416dd$export$a97c0c8e95f01322 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { partial: partial, position: position } = t0;
    const [searchSessionId] = (0, $122441d1a555945e$export$e1e7a4797df1a656)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    let t1;
    if ($[0] !== partial.title || $[1] !== searchQuery) {
        bb0: {
            const { highlightedTitle: highlightedTitle } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(partial.title, searchQuery.split(" "));
            if (!highlightedTitle) {
                t1 = partial.title;
                break bb0;
            }
            t1 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(highlightedTitle);
        }
        $[0] = partial.title;
        $[1] = searchQuery;
        $[2] = t1;
    } else t1 = $[2];
    const enrichedTitle = t1;
    let t2;
    if ($[3] !== partial) {
        t2 = $15dffd31214416dd$var$getDescription(partial);
        $[3] = partial;
        $[4] = t2;
    } else t2 = $[4];
    const description = t2;
    let t3;
    if ($[5] !== description || $[6] !== searchQuery) {
        bb1: {
            const { highlightedTitle: highlightedTitle_0 } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(description, searchQuery.split(" "));
            if (!highlightedTitle_0) {
                t3 = description;
                break bb1;
            }
            t3 = (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(highlightedTitle_0);
        }
        $[5] = description;
        $[6] = searchQuery;
        $[7] = t3;
    } else t3 = $[7];
    const enrichedDescription = t3;
    let t4;
    if ($[8] !== partial.url || $[9] !== searchSessionId) {
        t4 = (0, $49e72282c8d5e924$export$94df0e59ebebf4a7)(partial.url, "search_id", searchSessionId);
        $[8] = partial.url;
        $[9] = searchSessionId;
        $[10] = t4;
    } else t4 = $[10];
    const url = t4;
    let t5;
    bb2: {
        let t6;
        if ($[11] !== partial) {
            t6 = $15dffd31214416dd$var$getKey(partial);
            $[11] = partial;
            $[12] = t6;
        } else t6 = $[12];
        const value = t6;
        if (!value || !url) {
            t5 = null;
            break bb2;
        }
        let t7;
        if ($[13] !== url || $[14] !== value) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6319f15e3b45f1e8$export$2e2bcd8739ae039), {
                label: value,
                href: url
            });
            $[13] = url;
            $[14] = value;
            $[15] = t7;
        } else t7 = $[15];
        t5 = t7;
    }
    const keyLink = t5;
    let t6;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
            product: (0, $37AYo.ProductKeys).Atlas,
            label: "Atlas"
        });
        $[16] = t6;
    } else t6 = $[16];
    const t7 = !!selectedProduct;
    let t8;
    if ($[17] !== partial.type) {
        t8 = [
            "type",
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20651b41f8c81b92$export$95cacd63dfd98bee), {
                type: partial.type
            })
        ];
        $[17] = partial.type;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== keyLink) {
        t9 = [
            "key",
            keyLink
        ];
        $[19] = keyLink;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== partial) {
        t10 = $15dffd31214416dd$var$getStatusAndDate(partial);
        $[21] = partial;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== t10) {
        t11 = [
            "status",
            t10
        ];
        $[23] = t10;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t11 || $[26] !== t8 || $[27] !== t9) {
        t12 = [
            t8,
            t9,
            t11
        ];
        $[25] = t11;
        $[26] = t8;
        $[27] = t9;
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== t12 || $[30] !== t7) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: "townsquare",
            productSelected: t7,
            parts: t12
        });
        $[29] = t12;
        $[30] = t7;
        $[31] = t13;
    } else t13 = $[31];
    let t14;
    if ($[32] !== enrichedDescription) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $15dffd31214416dd$var$descriptionContainerStyles,
            testId: "search-page-atlas-result-description"
        }, enrichedDescription);
        $[32] = enrichedDescription;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== enrichedTitle || $[35] !== partial || $[36] !== position || $[37] !== primaryProduct || $[38] !== t13 || $[39] !== t14 || $[40] !== url) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            ...partial,
            primaryProduct: primaryProduct,
            url: url,
            icon: t6,
            headerMetadata: t13,
            title: enrichedTitle,
            description: t14,
            position: position,
            partial: partial
        });
        $[34] = enrichedTitle;
        $[35] = partial;
        $[36] = position;
        $[37] = primaryProduct;
        $[38] = t13;
        $[39] = t14;
        $[40] = url;
        $[41] = t15;
    } else t15 = $[41];
    return t15;
} : ({ partial: partial, position: position })=>{
    const [searchSessionId] = (0, $122441d1a555945e$export$e1e7a4797df1a656)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const enrichedTitle = (0, $cozmU.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(partial.title, searchQuery.split(' '));
        if (!highlightedTitle) return partial.title;
        return (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(highlightedTitle);
    }, [
        partial.title,
        searchQuery
    ]);
    const description = $15dffd31214416dd$var$getDescription(partial);
    const enrichedDescription = (0, $cozmU.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle_0 } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(description, searchQuery.split(' '));
        if (!highlightedTitle_0) return description;
        return (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(highlightedTitle_0);
    }, [
        description,
        searchQuery
    ]);
    const url = (0, $cozmU.useMemo)(()=>{
        return (0, $49e72282c8d5e924$export$94df0e59ebebf4a7)(partial.url, 'search_id', searchSessionId);
    }, [
        partial,
        searchSessionId
    ]);
    const keyLink = (0, $cozmU.useMemo)(()=>{
        const value = $15dffd31214416dd$var$getKey(partial);
        if (!value || !url) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6319f15e3b45f1e8$export$2e2bcd8739ae039), {
            label: value,
            href: url
        });
    }, [
        partial,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        ...partial,
        primaryProduct: primaryProduct,
        url: url,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
            product: (0, $37AYo.ProductKeys).Atlas,
            label: "Atlas"
        }),
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: "townsquare",
            productSelected: !!selectedProduct,
            parts: [
                [
                    'type',
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20651b41f8c81b92$export$95cacd63dfd98bee), {
                        type: partial.type
                    })
                ],
                [
                    'key',
                    keyLink
                ],
                [
                    'status',
                    $15dffd31214416dd$var$getStatusAndDate(partial)
                ]
            ]
        }),
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $15dffd31214416dd$var$descriptionContainerStyles,
            testId: "search-page-atlas-result-description"
        }, enrichedDescription),
        position: position,
        partial: partial
    });
};












































var $lpNn5 = parcelRequire("lpNn5");





const $4b8e6d922b2f5fa6$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    lastModified: {
        id: "dynamic-cards-search-page.search-result.last-modified",
        defaultMessage: "Updated {formattedDate}"
    }
});


const $898b3cab58426bd8$export$e6747eee8f26f8c0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { lastModified: lastModified, message: t1 } = t0;
    const message = t1 === undefined ? (0, $4b8e6d922b2f5fa6$export$defe85febe8b728c).lastModified : t1;
    if (!lastModified) return null;
    let t2;
    if ($[0] !== lastModified) {
        const lastModifiedDate = new Date(lastModified);
        t2 = (0, $8a1a5c2af543b4cc$export$fdcae512e9fdc5ad)(lastModifiedDate);
        $[0] = lastModified;
        $[1] = t2;
    } else t2 = $[1];
    const { value: value, unit: unit } = t2;
    let t3;
    if ($[2] !== lastModified) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
            value: lastModified,
            month: "short",
            day: "numeric",
            year: "numeric"
        });
        $[2] = lastModified;
        $[3] = t3;
    } else t3 = $[3];
    const absoluteDate = t3;
    let t4;
    if ($[4] !== message || $[5] !== unit || $[6] !== value) {
        t4 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...message,
                values: {
                    formattedDate: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
                        value: -value,
                        unit: unit
                    })
                }
            }));
        $[4] = message;
        $[5] = unit;
        $[6] = value;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== absoluteDate || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: absoluteDate
        }, t4);
        $[8] = absoluteDate;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ lastModified: lastModified, message: message = (0, $4b8e6d922b2f5fa6$export$defe85febe8b728c).lastModified })=>{
    if (!lastModified) return null;
    const lastModifiedDate = new Date(lastModified);
    const { value: value, unit: unit } = (0, $8a1a5c2af543b4cc$export$fdcae512e9fdc5ad)(lastModifiedDate);
    const absoluteDate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
        value: lastModified,
        month: "short",
        day: "numeric",
        year: "numeric"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: absoluteDate
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: {
                formattedDate: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
                    value: -value,
                    unit: unit
                })
            }
        })));
};








const $e348b946f9be0b4c$var$MAX_WORDS = 20;
const $e348b946f9be0b4c$export$6e2b3cea5902982b = 250;
const $e348b946f9be0b4c$export$91c2cc655c44ef69 = (text, query)=>{
    if (!text) return '';
    const lowerCaseQuery = query.toLowerCase();
    const words = text.split(' ');
    const indexOfQuery = words.findIndex((value)=>lowerCaseQuery === value.toLowerCase());
    if (indexOfQuery > $e348b946f9be0b4c$var$MAX_WORDS) return [
        '...'
    ].concat(words.slice(indexOfQuery - $e348b946f9be0b4c$var$MAX_WORDS, indexOfQuery + $e348b946f9be0b4c$var$MAX_WORDS)).concat('...').join(' ');
    return words.slice(0, 2 * $e348b946f9be0b4c$var$MAX_WORDS).join(' ').substring(0, $e348b946f9be0b4c$export$6e2b3cea5902982b) + (text.length > $e348b946f9be0b4c$export$6e2b3cea5902982b ? '...' : '');
};











const $af9fb2b5a0a8dcbd$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    tier: {
        id: "dynamic-cards-search-page.compass.tier",
        defaultMessage: "Tier {tier}"
    },
    state: {
        id: "dynamic-cards-search-page.compass.state",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{state}"
    },
    ownerName: {
        id: "dynamic-cards-search-page.compass.owner-name",
        defaultMessage: "Owned by {ownerName}"
    }
});


const $fc13cccc13153192$var$dotStyles = (0, $buxP3.xcss)({
    width: '4px',
    height: '4px',
    borderRadius: 'radius.xsmall',
    marginLeft: 'space.050'
});
const $fc13cccc13153192$var$pendingStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtle'
});
const $fc13cccc13153192$var$activeStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.accent.green.subtle'
});
const $fc13cccc13153192$var$archivedStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.accent.gray.subtle'
});
const $fc13cccc13153192$var$getComponentStateIcon = (state)=>{
    switch(state){
        case 'PENDING':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: [
                    $fc13cccc13153192$var$dotStyles,
                    $fc13cccc13153192$var$pendingStyles
                ]
            });
        case 'ACTIVE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: [
                    $fc13cccc13153192$var$dotStyles,
                    $fc13cccc13153192$var$activeStyles
                ]
            });
        case 'ARCHIVED':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: [
                    $fc13cccc13153192$var$dotStyles,
                    $fc13cccc13153192$var$archivedStyles
                ]
            });
    }
};
const $fc13cccc13153192$var$owningTeamStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px'
});
const $fc13cccc13153192$export$cc23f5d092bb479f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { partial: partial, position: position } = t0;
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCompassTeamsLoading = (0, $2Va9o.useIsCompassTeamsLoading)();
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const { title: title, url: url, tier: tier, component: component, lastModifiedDate: lastModifiedDate, type: type, ownerName: ownerName } = partial;
    let t2;
    if ($[0] !== component) {
        t2 = component || {};
        $[0] = component;
        $[1] = t2;
    } else t2 = $[1];
    const { state: state, description: description } = t2;
    let t3;
    bb0: {
        if (!lastModifiedDate) {
            t3 = null;
            break bb0;
        }
        let t4;
        if ($[2] !== lastModifiedDate) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
                lastModified: lastModifiedDate
            });
            $[2] = lastModifiedDate;
            $[3] = t4;
        } else t4 = $[3];
        t3 = t4;
    }
    const getLastModified = t3;
    let t4;
    bb1: {
        if (!state) {
            t4 = null;
            break bb1;
        }
        let t5;
        if ($[4] !== state) {
            t5 = $fc13cccc13153192$var$getComponentStateIcon(state);
            $[4] = state;
            $[5] = t5;
        } else t5 = $[5];
        let t6;
        if ($[6] !== formatMessage || $[7] !== state) {
            t6 = formatMessage((0, $af9fb2b5a0a8dcbd$export$defe85febe8b728c).state, {
                state: state
            });
            $[6] = formatMessage;
            $[7] = state;
            $[8] = t6;
        } else t6 = $[8];
        let t7;
        if ($[9] !== t5 || $[10] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                appearance: "default"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
                alignBlock: "center",
                space: "space.075"
            }, t5, t6));
            $[9] = t5;
            $[10] = t6;
            $[11] = t7;
        } else t7 = $[11];
        t4 = t7;
    }
    const getComponentState = t4;
    let t5;
    bb2: {
        if (!tier) {
            t5 = null;
            break bb2;
        }
        let t6;
        if ($[12] !== formatMessage || $[13] !== tier) {
            t6 = formatMessage((0, $af9fb2b5a0a8dcbd$export$defe85febe8b728c).tier, {
                tier: tier
            });
            $[12] = formatMessage;
            $[13] = tier;
            $[14] = t6;
        } else t6 = $[14];
        let t7;
        if ($[15] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                appearance: "default"
            }, t6);
            $[15] = t6;
            $[16] = t7;
        } else t7 = $[16];
        t5 = t7;
    }
    const getTier = t5;
    let t6;
    bb3: {
        if (ownerName) {
            let t7;
            if ($[17] !== formatMessage || $[18] !== ownerName) {
                t7 = formatMessage((0, $af9fb2b5a0a8dcbd$export$defe85febe8b728c).ownerName, {
                    ownerName: ownerName
                });
                $[17] = formatMessage;
                $[18] = ownerName;
                $[19] = t7;
            } else t7 = $[19];
            let t8;
            if ($[20] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    xcss: $fc13cccc13153192$var$owningTeamStyles
                }, t7);
                $[20] = t7;
                $[21] = t8;
            } else t8 = $[21];
            t6 = t8;
            break bb3;
        }
        if (isCompassTeamsLoading) {
            let t7;
            if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$a72c2188d2b05fba), null);
                $[22] = t7;
            } else t7 = $[22];
            t6 = t7;
            break bb3;
        }
        t6 = undefined;
    }
    const getOwnerName = t6;
    let t7;
    if ($[23] !== searchQuery || $[24] !== title) {
        bb4: {
            const { highlightedTitle: highlightedTitle } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(title, searchQuery.split(" "));
            if (!highlightedTitle) {
                t7 = title;
                break bb4;
            }
            t7 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(highlightedTitle);
        }
        $[23] = searchQuery;
        $[24] = title;
        $[25] = t7;
    } else t7 = $[25];
    const enrichedTitle = t7;
    let t8;
    if ($[26] !== description || $[27] !== searchQuery) {
        bb5: {
            const reducedDescription = (0, $e348b946f9be0b4c$export$91c2cc655c44ef69)(description, searchQuery);
            const { highlightedTitle: highlightedTitle_0 } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(reducedDescription, searchQuery.split(" "));
            if (!highlightedTitle_0) {
                t8 = reducedDescription;
                break bb5;
            }
            t8 = (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(highlightedTitle_0);
        }
        $[26] = description;
        $[27] = searchQuery;
        $[28] = t8;
    } else t8 = $[28];
    const enrichedDescription = t8;
    let t9;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
            product: (0, $37AYo.ProductKeys).Compass
        });
        $[29] = t9;
    } else t9 = $[29];
    const t10 = !!selectedProduct;
    let t11;
    if ($[30] !== type) {
        t11 = [
            "type",
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20651b41f8c81b92$export$95cacd63dfd98bee), {
                type: type
            })
        ];
        $[30] = type;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== getOwnerName) {
        t12 = [
            "ownerName",
            getOwnerName
        ];
        $[32] = getOwnerName;
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== getLastModified) {
        t13 = [
            "lastModified",
            getLastModified
        ];
        $[34] = getLastModified;
        $[35] = t13;
    } else t13 = $[35];
    let t14;
    if ($[36] !== getComponentState) {
        t14 = [
            "componentState",
            getComponentState
        ];
        $[36] = getComponentState;
        $[37] = t14;
    } else t14 = $[37];
    let t15;
    if ($[38] !== getTier) {
        t15 = [
            "tier",
            getTier
        ];
        $[38] = getTier;
        $[39] = t15;
    } else t15 = $[39];
    let t16;
    if ($[40] !== t11 || $[41] !== t12 || $[42] !== t13 || $[43] !== t14 || $[44] !== t15) {
        t16 = [
            t11,
            t12,
            t13,
            t14,
            t15
        ];
        $[40] = t11;
        $[41] = t12;
        $[42] = t13;
        $[43] = t14;
        $[44] = t15;
        $[45] = t16;
    } else t16 = $[45];
    let t17;
    if ($[46] !== t10 || $[47] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: "compass",
            productSelected: t10,
            parts: t16
        });
        $[46] = t10;
        $[47] = t16;
        $[48] = t17;
    } else t17 = $[48];
    let t18;
    if ($[49] !== cloudId || $[50] !== enrichedDescription || $[51] !== enrichedTitle || $[52] !== partial || $[53] !== position || $[54] !== primaryProduct || $[55] !== t17 || $[56] !== url) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            ...partial,
            primaryProduct: primaryProduct,
            url: url,
            icon: t9,
            title: enrichedTitle,
            headerMetadata: t17,
            description: enrichedDescription,
            cloudId: cloudId,
            position: position
        });
        $[49] = cloudId;
        $[50] = enrichedDescription;
        $[51] = enrichedTitle;
        $[52] = partial;
        $[53] = position;
        $[54] = primaryProduct;
        $[55] = t17;
        $[56] = url;
        $[57] = t18;
    } else t18 = $[57];
    return t18;
} : ({ partial: partial, position: position })=>{
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCompassTeamsLoading = (0, $2Va9o.useIsCompassTeamsLoading)();
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const { title: title, url: url, tier: tier, component: component, lastModifiedDate: lastModifiedDate, type: type, ownerName: ownerName } = partial;
    const { state: state, description: description } = component || {};
    const getLastModified = (0, $cozmU.useMemo)(()=>{
        if (!lastModifiedDate) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        });
    }, [
        lastModifiedDate
    ]);
    const getComponentState = (0, $cozmU.useMemo)(()=>{
        if (!state) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: 'default'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, $fc13cccc13153192$var$getComponentStateIcon(state), formatMessage((0, $af9fb2b5a0a8dcbd$export$defe85febe8b728c).state, {
            state: state
        })));
    }, [
        state,
        formatMessage
    ]);
    const getTier = (0, $cozmU.useMemo)(()=>{
        if (!tier) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: 'default'
        }, formatMessage((0, $af9fb2b5a0a8dcbd$export$defe85febe8b728c).tier, {
            tier: tier
        }));
    }, [
        tier,
        formatMessage
    ]);
    const getOwnerName = (0, $cozmU.useMemo)(()=>{
        if (ownerName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $fc13cccc13153192$var$owningTeamStyles
        }, formatMessage((0, $af9fb2b5a0a8dcbd$export$defe85febe8b728c).ownerName, {
            ownerName: ownerName
        }));
        if (isCompassTeamsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$a72c2188d2b05fba), null);
    }, [
        ownerName,
        formatMessage,
        isCompassTeamsLoading
    ]);
    const enrichedTitle = (0, $cozmU.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(title, searchQuery.split(' '));
        if (!highlightedTitle) return title;
        return (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(highlightedTitle);
    }, [
        title,
        searchQuery
    ]);
    const enrichedDescription = (0, $cozmU.useMemo)(()=>{
        const reducedDescription = (0, $e348b946f9be0b4c$export$91c2cc655c44ef69)(description, searchQuery);
        const { highlightedTitle: highlightedTitle_0 } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle_0) return reducedDescription;
        return (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(highlightedTitle_0);
    }, [
        description,
        searchQuery
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        ...partial,
        primaryProduct: primaryProduct,
        url: url,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
            product: (0, $37AYo.ProductKeys).Compass
        }),
        title: enrichedTitle,
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: "compass",
            productSelected: !!selectedProduct,
            parts: [
                [
                    'type',
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20651b41f8c81b92$export$95cacd63dfd98bee), {
                        type: type
                    })
                ],
                [
                    'ownerName',
                    getOwnerName
                ],
                [
                    'lastModified',
                    getLastModified
                ],
                [
                    'componentState',
                    getComponentState
                ],
                [
                    'tier',
                    getTier
                ]
            ]
        }),
        description: enrichedDescription,
        cloudId: cloudId,
        position: position
    });
};




















































var $eKMV3 = parcelRequire("eKMV3");


var $eDtFr = parcelRequire("eDtFr");


var $gC2EJ = parcelRequire("gC2EJ");


var $ldb9Z = parcelRequire("ldb9Z");


var $dmZMN = parcelRequire("dmZMN");











const $6bedf712d3622b41$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card.view-profile",
        defaultMessage: "View profile"
    },
    emailButtonLabel: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card.email-button-label",
        defaultMessage: "Copy email address"
    }
});
const $6bedf712d3622b41$export$6bab030fe17f656d = (0, $kSwu1.defineMessages)({
    share: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card.shared-time-unit-ago-by",
        defaultMessage: "Shared {relativeDate} by"
    },
    comment: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card.commented-time-unit-ago-by",
        defaultMessage: "Commented {relativeDate} by"
    },
    edit: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card.edited-time-unit-ago-by",
        defaultMessage: "Edited {relativeDate} by"
    }
});


const $81572168273698ea$var$cardXcss = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.raised',
    borderRadius: "var(--ds-radius-large, 8px)",
    padding: 'space.200',
    minWidth: '214px',
    width: 'fit-content'
});
const $81572168273698ea$var$headerXcss = (0, $buxP3.xcss)({
    font: 'font.body.small',
    fontWeight: 'font.weight.semibold'
});
const $81572168273698ea$var$userNameXcss = (0, $buxP3.xcss)({
    font: 'font.body.large',
    fontWeight: 'font.weight.semibold',
    textAlign: 'center',
    maxWidth: '214px',
    overflowWrap: 'break-word'
});
const $81572168273698ea$var$userSubheadingXcss = (0, $buxP3.xcss)({
    font: 'font.body',
    textAlign: 'center',
    maxWidth: '214px',
    overflowWrap: 'break-word'
});
const $81572168273698ea$export$4c094c8f61edecb4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { signalDate: signalDate, signalType: signalType, user: user, onCopyEmail: onCopyEmail } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== signalDate || $[1] !== signalType) {
        t1 = signalDate && signalType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            xcss: $81572168273698ea$var$headerXcss,
            alignItems: "center",
            gap: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($81572168273698ea$export$4a6f3cfec60dc525, {
            signalDate: signalDate,
            signalType: signalType
        }));
        $[0] = signalDate;
        $[1] = signalType;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== user.profilePicUrl) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: user.profilePicUrl,
            size: "xlarge"
        }));
        $[3] = user.profilePicUrl;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== user.name) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $81572168273698ea$var$userNameXcss
        }, user.name);
        $[5] = user.name;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== user.jobTitle) {
        t4 = user.jobTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $81572168273698ea$var$userSubheadingXcss
        }, user.jobTitle);
        $[7] = user.jobTitle;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            direction: "column",
            alignItems: "center",
            gap: "space.100"
        }, t3, t4);
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== formatMessage || $[13] !== onCopyEmail) {
        t6 = onCopyEmail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))),
            label: formatMessage((0, $6bedf712d3622b41$export$defe85febe8b728c).emailButtonLabel),
            isTooltipDisabled: false,
            onClick: onCopyEmail
        });
        $[12] = formatMessage;
        $[13] = onCopyEmail;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== user.profileUrl) {
        t7 = user.profileUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            href: user.profileUrl,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6bedf712d3622b41$export$defe85febe8b728c).viewProfile));
        $[15] = user.profileUrl;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== t6 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            gap: "space.050"
        }, t6, t7);
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== t1 || $[21] !== t2 || $[22] !== t5 || $[23] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            direction: "column",
            alignItems: "center",
            gap: "space.200",
            xcss: $81572168273698ea$var$cardXcss
        }, t1, t2, t5, t8);
        $[20] = t1;
        $[21] = t2;
        $[22] = t5;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ signalDate: signalDate, signalType: signalType, user: user, onCopyEmail: onCopyEmail })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        xcss: $81572168273698ea$var$cardXcss
    }, signalDate && signalType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
        xcss: $81572168273698ea$var$headerXcss,
        alignItems: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($81572168273698ea$export$4a6f3cfec60dc525, {
        signalDate: signalDate,
        signalType: signalType
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: user.profilePicUrl,
        size: "xlarge"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
        direction: "column",
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $81572168273698ea$var$userNameXcss
    }, user.name), user.jobTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $81572168273698ea$var$userSubheadingXcss
    }, user.jobTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
        gap: "space.050"
    }, onCopyEmail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))),
        label: formatMessage((0, $6bedf712d3622b41$export$defe85febe8b728c).emailButtonLabel),
        isTooltipDisabled: false,
        onClick: onCopyEmail
    }), user.profileUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: user.profileUrl,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6bedf712d3622b41$export$defe85febe8b728c).viewProfile))));
};
const $81572168273698ea$var$SECONDS_IN_A_DAY = 86400;
const $81572168273698ea$var$SECONDS_IN_AN_HOUR = 3600;
function $81572168273698ea$export$e603bc8e48e0cfbb(signalDate) {
    const secondsSinceUpdate = (Date.now() - signalDate.getTime()) / 1000;
    const daysSinceUpdate = Math.floor(secondsSinceUpdate / $81572168273698ea$var$SECONDS_IN_A_DAY);
    /** Seconds that don't fit into a whole day */ const remainingSecondsInAnHour = secondsSinceUpdate % $81572168273698ea$var$SECONDS_IN_A_DAY;
    const leftoverHoursSinceUpdate = Math.floor(remainingSecondsInAnHour / $81572168273698ea$var$SECONDS_IN_AN_HOUR);
    const minutesSinceUpdate = Math.floor(secondsSinceUpdate / 60);
    return {
        daysSinceUpdate: daysSinceUpdate,
        leftoverHoursSinceUpdate: leftoverHoursSinceUpdate,
        minutesSinceUpdate: minutesSinceUpdate
    };
}
const $81572168273698ea$var$SOCIAL_SIGNAL_ICONS = {
    comment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
        label: "",
        color: "currentColor"
    }),
    edit: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        label: "",
        color: "currentColor"
    }),
    share: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmZMN))), {
        label: "",
        color: "currentColor"
    })
};
const $81572168273698ea$export$4a6f3cfec60dc525 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { signalDate: signalDate, signalType: signalType } = t0;
    const icon = $81572168273698ea$var$SOCIAL_SIGNAL_ICONS[signalType];
    const timeUnitAgoMessage = (0, $6bedf712d3622b41$export$6bab030fe17f656d)[signalType];
    let t1;
    if ($[0] !== signalDate) {
        const { daysSinceUpdate: daysSinceUpdate, leftoverHoursSinceUpdate: leftoverHoursSinceUpdate, minutesSinceUpdate: minutesSinceUpdate } = $81572168273698ea$export$e603bc8e48e0cfbb(signalDate);
        t1 = $81572168273698ea$var$getTimeValues(daysSinceUpdate, leftoverHoursSinceUpdate, minutesSinceUpdate);
        $[0] = signalDate;
        $[1] = t1;
    } else t1 = $[1];
    const { unit: unit, value: value } = t1;
    const t2 = -value;
    let t3;
    if ($[2] !== timeUnitAgoMessage) {
        t3 = (formattedTime)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...timeUnitAgoMessage,
                values: {
                    relativeDate: formattedTime
                }
            });
        $[2] = timeUnitAgoMessage;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== unit) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
            value: t2,
            style: "long",
            unit: unit,
            numeric: "auto"
        }, t3);
        $[4] = t2;
        $[5] = t3;
        $[6] = unit;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== icon || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, icon, t4);
        $[8] = icon;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ signalDate: signalDate, signalType: signalType })=>{
    const icon = $81572168273698ea$var$SOCIAL_SIGNAL_ICONS[signalType];
    const timeUnitAgoMessage = (0, $6bedf712d3622b41$export$6bab030fe17f656d)[signalType];
    const { unit: unit, value: value } = (0, $cozmU.useMemo)(()=>{
        const { daysSinceUpdate: daysSinceUpdate, leftoverHoursSinceUpdate: leftoverHoursSinceUpdate, minutesSinceUpdate: minutesSinceUpdate } = $81572168273698ea$export$e603bc8e48e0cfbb(signalDate);
        return $81572168273698ea$var$getTimeValues(daysSinceUpdate, leftoverHoursSinceUpdate, minutesSinceUpdate);
    }, [
        signalDate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
        value: -value,
        style: "long",
        unit: unit,
        numeric: "auto"
    }, (formattedTime)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...timeUnitAgoMessage,
            values: {
                relativeDate: formattedTime
            }
        })));
};
const $81572168273698ea$var$getTimeValues = (daysSinceUpdate, leftoverHoursSinceUpdate, minutesSinceUpdate)=>{
    if (daysSinceUpdate === 0) {
        if (leftoverHoursSinceUpdate < 1) return {
            unit: 'minute',
            value: minutesSinceUpdate
        };
        return {
            unit: 'hour',
            value: leftoverHoursSinceUpdate
        };
    }
    return {
        unit: 'day',
        value: daysSinceUpdate
    };
};




























const $7470aa6f261cd222$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    share: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card-trigger.shared",
        defaultMessage: "{name} shared"
    },
    edit: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card-trigger.edited",
        defaultMessage: "{name} edited"
    },
    comment: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card-trigger.commented",
        defaultMessage: "{name} commented"
    }
});


const $120716506582f985$var$signalTextXcss = (0, $buxP3.xcss)({
    color: 'color.text.subtle',
    ':hover': {
        textDecoration: 'underline'
    },
    ':focus-visible': {
        textDecoration: 'underline'
    },
    background: 'none',
    padding: '0'
});
const $120716506582f985$export$b3c2c65aed2f6e98 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(18);
    const { avatarUrl: avatarUrl, userName: userName, onClick: onClick, socialSignalType: socialSignalType, testId: testId, componentName: componentName } = t0;
    let t1;
    if ($[0] !== userName) {
        t1 = userName.split(" ");
        $[0] = userName;
        $[1] = t1;
    } else t1 = $[1];
    const firstName = t1[0];
    const message = (0, $7470aa6f261cd222$export$defe85febe8b728c)[socialSignalType];
    if (!message) return null;
    let t2;
    if ($[2] !== avatarUrl) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarUrl,
            size: "xxsmall"
        });
        $[2] = avatarUrl;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== firstName) {
        t3 = {
            name: firstName
        };
        $[4] = firstName;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== message || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: t3
        }));
        $[6] = message;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t2 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            gap: "space.075",
            alignItems: "center"
        }, t2, t4);
        $[9] = t2;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== componentName || $[13] !== onClick || $[14] !== ref || $[15] !== t5 || $[16] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            ref: ref,
            onClick: onClick,
            xcss: $120716506582f985$var$signalTextXcss,
            testId: testId,
            componentName: componentName
        }, t5);
        $[12] = componentName;
        $[13] = onClick;
        $[14] = ref;
        $[15] = t5;
        $[16] = testId;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ avatarUrl: avatarUrl, userName: userName, onClick: onClick, socialSignalType: socialSignalType, testId: testId, componentName: componentName }, ref)=>{
    const firstName = (0, $cozmU.useMemo)(()=>userName.split(' ')[0], [
        userName
    ]);
    const message = (0, $7470aa6f261cd222$export$defe85febe8b728c)[socialSignalType];
    if (!message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        ref: ref,
        onClick: onClick,
        xcss: $120716506582f985$var$signalTextXcss,
        testId: testId,
        componentName: componentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
        gap: "space.075",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarUrl,
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        size: "small",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...message,
        values: {
            name: firstName
        }
    }))));
});










const $82d9866c8855687f$export$b2199c37e85de4a7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (text)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== text) {
        t0 = ()=>{
            navigator.clipboard.writeText(text);
        };
        $[0] = text;
        $[1] = t0;
    } else t0 = $[1];
    const callback = t0;
    return callback;
} : (text)=>{
    const callback = (0, $cozmU.useCallback)(()=>{
        navigator.clipboard.writeText(text);
    }, [
        text
    ]);
    return callback;
};



var $db9XH = parcelRequire("db9XH");


const $4760164d6f170a64$export$2530a1964f2c1c12 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { partial: partial } = t0;
    const copyEmailToClipboard = (0, $82d9866c8855687f$export$b2199c37e85de4a7)(partial.socialSignal?.user?.email ?? "");
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { mapUserIdToProfileUrl: mapUserIdToProfileUrl } = (0, $d848581de35407c0$export$fdc397e486fa83e7)();
    const { socialSignal: socialSignal } = partial;
    if (!socialSignal || !socialSignal.user || !socialSignal.signal || !$4760164d6f170a64$var$isSupportedSocialSignal(socialSignal.signal)) return null;
    const { signal: signal, timestamp: timestamp, user: user } = socialSignal;
    let t1;
    if ($[0] !== mapUserIdToProfileUrl || $[1] !== user.accountId) {
        t1 = mapUserIdToProfileUrl(user.accountId);
        $[0] = mapUserIdToProfileUrl;
        $[1] = user.accountId;
        $[2] = t1;
    } else t1 = $[2];
    const userProfileUrl = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsOpen(false);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== signal || $[5] !== user.name || $[6] !== user.picture) {
        t3 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $120716506582f985$export$b3c2c65aed2f6e98), {
                ...triggerProps,
                userName: user.name,
                socialSignalType: signal,
                avatarUrl: user.picture,
                onClick: ()=>{
                    setIsOpen($4760164d6f170a64$var$_temp);
                },
                testId: "search-page-social-signal",
                componentName: `${(0, $db9XH.ACTION_SUBJECT_PREFIX)}SocialSignal`
            });
        $[4] = signal;
        $[5] = user.name;
        $[6] = user.picture;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== copyEmailToClipboard || $[9] !== signal || $[10] !== timestamp || $[11] !== user.extendedProfile?.jobTitle || $[12] !== user.name || $[13] !== user.picture || $[14] !== userProfileUrl) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81572168273698ea$export$4c094c8f61edecb4), {
                user: {
                    name: user.name,
                    profilePicUrl: user.picture,
                    jobTitle: user.extendedProfile?.jobTitle,
                    profileUrl: userProfileUrl
                },
                onCopyEmail: copyEmailToClipboard,
                signalDate: timestamp ? new Date(timestamp) : undefined,
                signalType: signal
            });
        $[8] = copyEmailToClipboard;
        $[9] = signal;
        $[10] = timestamp;
        $[11] = user.extendedProfile?.jobTitle;
        $[12] = user.name;
        $[13] = user.picture;
        $[14] = userProfileUrl;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== isOpen || $[17] !== t3 || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: t2,
            trigger: t3,
            content: t4,
            shouldRenderToParent: true
        });
        $[16] = isOpen;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
} : ({ partial: partial })=>{
    const copyEmailToClipboard = (0, $82d9866c8855687f$export$b2199c37e85de4a7)(partial.socialSignal?.user?.email ?? '');
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { mapUserIdToProfileUrl: mapUserIdToProfileUrl } = (0, $d848581de35407c0$export$fdc397e486fa83e7)();
    const { socialSignal: socialSignal } = partial;
    if (!socialSignal || !socialSignal.user || !socialSignal.signal || !$4760164d6f170a64$var$isSupportedSocialSignal(socialSignal.signal)) return null;
    const { signal: signal, timestamp: timestamp, user: user } = socialSignal;
    const userProfileUrl = mapUserIdToProfileUrl(user.accountId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $120716506582f985$export$b3c2c65aed2f6e98), {
                ...triggerProps,
                userName: user.name,
                socialSignalType: signal,
                avatarUrl: user.picture,
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: "search-page-social-signal",
                componentName: `${(0, $db9XH.ACTION_SUBJECT_PREFIX)}SocialSignal`
            }),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81572168273698ea$export$4c094c8f61edecb4), {
                user: {
                    name: user.name,
                    profilePicUrl: user.picture,
                    jobTitle: user.extendedProfile?.jobTitle,
                    profileUrl: userProfileUrl
                },
                onCopyEmail: copyEmailToClipboard,
                signalDate: timestamp ? new Date(timestamp) : undefined,
                signalType: signal
            }),
        shouldRenderToParent: true
    });
};
const $4760164d6f170a64$var$supportedSignals = [
    'edit',
    'share',
    'comment'
];
function $4760164d6f170a64$var$isSupportedSocialSignal(signalFromApi) {
    return $4760164d6f170a64$var$supportedSignals.includes(signalFromApi);
}
function $4760164d6f170a64$var$_temp(open) {
    return !open;
}



































const $3c54bcb0d0a4c856$var$styles = (0, $buxP3.xcss)({
    display: 'inline-block',
    font: 'font.body',
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $3c54bcb0d0a4c856$var$SearchMetadataGeneric = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { label: label } = t0;
    let t1;
    if ($[0] !== label) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $3c54bcb0d0a4c856$var$styles
        }, label);
        $[0] = label;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $3c54bcb0d0a4c856$var$styles
    }, label);
};
var $3c54bcb0d0a4c856$export$2e2bcd8739ae039 = $3c54bcb0d0a4c856$var$SearchMetadataGeneric;




const $02cb136c4c643249$var$breadcrumbsContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.100',
    maxWidth: '246px' // Specified in the design
});
const $02cb136c4c643249$export$9138e703d4b4585b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { partial: t1 } = t0;
    const { space: space, url: url } = t1;
    if (!space || !space.name) return null;
    let t2;
    if ($[0] !== url) {
        t2 = url && (0, $386ccd9a45899fff$export$f654b28f82155665)(url);
        $[0] = url;
        $[1] = t2;
    } else t2 = $[1];
    const baseUrl = t2;
    const href = `${baseUrl}/wiki${space.webUiLink}`;
    let t3;
    if ($[2] !== href || $[3] !== space.name) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            xcss: $02cb136c4c643249$var$breadcrumbsContainerStyles
        }, href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6319f15e3b45f1e8$export$2e2bcd8739ae039), {
            label: space.name,
            href: href
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3c54bcb0d0a4c856$export$2e2bcd8739ae039), {
            label: space.name
        }));
        $[2] = href;
        $[3] = space.name;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ partial: { space: space, url: url } })=>{
    if (!space || !space.name) return null;
    const baseUrl = url && (0, $386ccd9a45899fff$export$f654b28f82155665)(url);
    const href = `${baseUrl}/wiki${space.webUiLink}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: $02cb136c4c643249$var$breadcrumbsContainerStyles
    }, href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6319f15e3b45f1e8$export$2e2bcd8739ae039), {
        label: space.name,
        href: href
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3c54bcb0d0a4c856$export$2e2bcd8739ae039), {
        label: space.name
    }));
};














var $4aRua = parcelRequire("4aRua");
















const $8e05c654e122d42f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    commentIconLabel: {
        id: "dynamic-cards-search-page.comment-icon.label",
        defaultMessage: "Number of comments"
    }
});


// TODO: Replace this custom svg with `import CommentIcon from '@atlaskit/icon/core/comment';` once the icon is the same as this one
const $873c4bdebd93852d$var$CommentIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $8e05c654e122d42f$export$defe85febe8b728c).commentIconLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.77126 13.0019C3.43856 13.2168 3 12.9779 3 12.5819V5C3 3.89543 3.89543 3 5 3H11C12.1046 3 13 3.89543 13 5V8.91667C13 10.0212 12.1046 10.9167 11 10.9167H7L3.77126 13.0019ZM6.55773 9.41667H11C11.2761 9.41667 11.5 9.19281 11.5 8.91667V5C11.5 4.72386 11.2761 4.5 11 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V10.7456L6.55773 9.41667Z",
            fill: "var(--ds-icon, #292A2E)"
        });
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t0) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            "aria-label": t0,
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            color: "var(--ds-icon, #292A2E)"
        }, t1);
        $[3] = t0;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "aria-label": formatMessage((0, $8e05c654e122d42f$export$defe85febe8b728c).commentIconLabel),
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: "var(--ds-icon, #292A2E)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.77126 13.0019C3.43856 13.2168 3 12.9779 3 12.5819V5C3 3.89543 3.89543 3 5 3H11C12.1046 3 13 3.89543 13 5V8.91667C13 10.0212 12.1046 10.9167 11 10.9167H7L3.77126 13.0019ZM6.55773 9.41667H11C11.2761 9.41667 11.5 9.19281 11.5 8.91667V5C11.5 4.72386 11.2761 4.5 11 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V10.7456L6.55773 9.41667Z",
        fill: "var(--ds-icon, #292A2E)"
    }));
};
var $873c4bdebd93852d$export$2e2bcd8739ae039 = $873c4bdebd93852d$var$CommentIcon;


const $d4245b71c5549026$export$f4c1466e6fdd07b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { numberOfComments: numberOfComments } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $873c4bdebd93852d$export$2e2bcd8739ae039), null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== numberOfComments) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, numberOfComments));
        $[1] = numberOfComments;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ numberOfComments: numberOfComments })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $873c4bdebd93852d$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, numberOfComments));
};
















const $0b2a417f853e9d89$export$1bd444ba34dbd512 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { numberOfLikes: numberOfLikes } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            size: "small"
        }, "\uD83D\uDC4D");
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== numberOfLikes) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, numberOfLikes));
        $[1] = numberOfLikes;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ numberOfLikes: numberOfLikes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        size: "small"
    }, "\uD83D\uDC4D"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, numberOfLikes));
};


























const $f93dfb2758c7d793$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    verifiedIconLabel: {
        id: "search-page.verified-icon-label",
        defaultMessage: "Verified"
    },
    verifiedIconTooltipMessage: {
        id: "search-page.verified-icon-tooltip-message",
        defaultMessage: "This page has been verified by an owner or admin."
    }
});


const $2fe17273e4befd62$var$TooltipTagStyles = {
    wrapper: "_3iDTPbQ4SZ"
}; // A custom tag element to prevent a bug where an additional 1-pixel whitespace is rendered after the target element
const $2fe17273e4befd62$export$48d215ae75c54231 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    const t0 = ref;
    let t1;
    if ($[0] !== props || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "div",
            xcss: $2fe17273e4befd62$var$TooltipTagStyles.wrapper,
            ref: t0,
            ...props
        });
        $[0] = props;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "div",
        xcss: $2fe17273e4befd62$var$TooltipTagStyles.wrapper,
        ref: ref,
        ...props
    }));
const $2fe17273e4befd62$export$eb413699769dd9b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $f93dfb2758c7d793$export$a7357cdd1f0b0168).verifiedIconTooltipMessage);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== formatMessage) {
        t1 = formatMessage((0, $f93dfb2758c7d793$export$a7357cdd1f0b0168).verifiedIconLabel);
        $[2] = formatMessage;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            label: t1,
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t0 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t0,
            tag: $2fe17273e4befd62$export$48d215ae75c54231
        }, t2);
        $[6] = t0;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $f93dfb2758c7d793$export$a7357cdd1f0b0168).verifiedIconTooltipMessage),
        tag: $2fe17273e4befd62$export$48d215ae75c54231
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        label: formatMessage((0, $f93dfb2758c7d793$export$a7357cdd1f0b0168).verifiedIconLabel),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }));
};


const $da289b704d3b2901$var$getTitle = (partial)=>{
    return (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(partial.title);
};
const $da289b704d3b2901$var$getLastModified = (partial)=>{
    if (partial.lastModified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
        lastModified: partial.lastModified
    });
    return null;
};
const $da289b704d3b2901$var$getBreadcrumbs = (partial)=>{
    if (!(0, $lqSug.isSearchConfluencePageBlogAttachment)(partial)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02cb136c4c643249$export$9138e703d4b4585b), {
        partial: partial
    });
};
const $da289b704d3b2901$var$getVerifiedIcon = (partial)=>{
    if ((0, $lqSug.isSearchConfluencePageBlogAttachment)(partial) && partial.isVerified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2fe17273e4befd62$export$eb413699769dd9b1), null);
    return null;
};
const $da289b704d3b2901$var$getCommentCount = (partial)=>{
    if (!(0, $lqSug.isSearchConfluencePageBlogAttachment)(partial)) return null;
    const numberOfComments = partial.confluenceEntity?.commentCountSummary?.total ?? 0;
    if (numberOfComments === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d4245b71c5549026$export$f4c1466e6fdd07b), {
        numberOfComments: numberOfComments
    });
};
const $da289b704d3b2901$var$getLikeCount = (partial)=>{
    if (!(0, $lqSug.isSearchConfluencePageBlogAttachment)(partial)) return null;
    const numberOfLikes = partial.confluenceEntity?.likesSummary?.count ?? 0;
    if (numberOfLikes === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b2a417f853e9d89$export$1bd444ba34dbd512), {
        numberOfLikes: numberOfLikes
    });
};
const $da289b704d3b2901$var$getDescription = (partial)=>{
    return (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(partial.description);
};
const $da289b704d3b2901$export$30adeb861c31a5ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(60);
    const { partial: partial, position: position } = t0;
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled } = t1;
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [searchSessionId] = (0, $122441d1a555945e$export$e1e7a4797df1a656)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
            product: (0, $37AYo.ProductKeys).Confluence
        });
        $[0] = t2;
    } else t2 = $[0];
    const icon = t2;
    let t3;
    if ($[1] !== partial.type) {
        t3 = [
            "type",
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20651b41f8c81b92$export$95cacd63dfd98bee), {
                type: partial.type
            })
        ];
        $[1] = partial.type;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== partial) {
        t4 = $da289b704d3b2901$var$getBreadcrumbs(partial);
        $[3] = partial;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t4) {
        t5 = [
            "breadcrumbs",
            t4
        ];
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== partial) {
        t6 = $da289b704d3b2901$var$getLastModified(partial);
        $[7] = partial;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t6) {
        t7 = [
            "last-modified",
            t6
        ];
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== partial) {
        t8 = $da289b704d3b2901$var$getVerifiedIcon(partial);
        $[11] = partial;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== t8) {
        t9 = [
            "verified",
            t8
        ];
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== partial) {
        t10 = $da289b704d3b2901$var$getCommentCount(partial);
        $[15] = partial;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== t10) {
        t11 = [
            "comment-count",
            t10
        ];
        $[17] = t10;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== partial) {
        t12 = $da289b704d3b2901$var$getLikeCount(partial);
        $[19] = partial;
        $[20] = t12;
    } else t12 = $[20];
    let t13;
    if ($[21] !== t12) {
        t13 = [
            "like-count",
            t12
        ];
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let metadataParts;
    if ($[23] !== partial || $[24] !== t11 || $[25] !== t13 || $[26] !== t3 || $[27] !== t5 || $[28] !== t7 || $[29] !== t9) {
        metadataParts = [
            t3,
            t5,
            t7,
            t9,
            t11,
            t13
        ];
        if (partial.socialSignal) {
            let t14;
            if ($[31] !== partial) {
                t14 = [
                    "social-signal",
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4760164d6f170a64$export$2530a1964f2c1c12), {
                        partial: partial
                    })
                ];
                $[31] = partial;
                $[32] = t14;
            } else t14 = $[32];
            metadataParts.push(t14);
        }
        $[23] = partial;
        $[24] = t11;
        $[25] = t13;
        $[26] = t3;
        $[27] = t5;
        $[28] = t7;
        $[29] = t9;
        $[30] = metadataParts;
    } else metadataParts = $[30];
    let t14;
    if ($[33] !== partial.url || $[34] !== searchSessionId) {
        t14 = (t15)=>{
            const href = (0, $49e72282c8d5e924$export$94df0e59ebebf4a7)(partial.url, "search_id", searchSessionId);
            return href;
        };
        $[33] = partial.url;
        $[34] = searchSessionId;
        $[35] = t14;
    } else t14 = $[35];
    const appendAdditionalQueryParams = t14;
    let t15;
    if ($[36] !== appendAdditionalQueryParams || $[37] !== partial.id || $[38] !== partial.url) {
        t15 = appendAdditionalQueryParams({
            url: partial.url,
            resultId: partial.id
        });
        $[36] = appendAdditionalQueryParams;
        $[37] = partial.id;
        $[38] = partial.url;
        $[39] = t15;
    } else t15 = $[39];
    let t16;
    if ($[40] !== partial) {
        t16 = $da289b704d3b2901$var$getTitle(partial);
        $[40] = partial;
        $[41] = t16;
    } else t16 = $[41];
    const t17 = !!selectedProduct;
    let t18;
    if ($[42] !== metadataParts || $[43] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: "confluence",
            productSelected: t17,
            parts: metadataParts
        });
        $[42] = metadataParts;
        $[43] = t17;
        $[44] = t18;
    } else t18 = $[44];
    let t19;
    if ($[45] !== partial) {
        t19 = $da289b704d3b2901$var$getDescription(partial);
        $[45] = partial;
        $[46] = t19;
    } else t19 = $[46];
    let t20;
    if ($[47] !== isAdminHubAIEnabled || $[48] !== partial.type) {
        t20 = [
            "page",
            "blogpost"
        ].includes(partial.type) && isAdminHubAIEnabled;
        $[47] = isAdminHubAIEnabled;
        $[48] = partial.type;
        $[49] = t20;
    } else t20 = $[49];
    let t21;
    if ($[50] !== cloudId || $[51] !== partial || $[52] !== position || $[53] !== primaryProduct || $[54] !== t15 || $[55] !== t16 || $[56] !== t18 || $[57] !== t19 || $[58] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            ...partial,
            primaryProduct: primaryProduct,
            url: t15,
            title: t16,
            icon: icon,
            headerMetadata: t18,
            description: t19,
            showAISummary: t20,
            cloudId: cloudId,
            position: position,
            partial: partial
        });
        $[50] = cloudId;
        $[51] = partial;
        $[52] = position;
        $[53] = primaryProduct;
        $[54] = t15;
        $[55] = t16;
        $[56] = t18;
        $[57] = t19;
        $[58] = t20;
        $[59] = t21;
    } else t21 = $[59];
    return t21;
} : ({ partial: partial, position: position })=>{
    const [{ cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [searchSessionId] = (0, $122441d1a555945e$export$e1e7a4797df1a656)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
        product: (0, $37AYo.ProductKeys).Confluence
    });
    const metadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20651b41f8c81b92$export$95cacd63dfd98bee), {
                type: partial.type
            })
        ],
        [
            'breadcrumbs',
            $da289b704d3b2901$var$getBreadcrumbs(partial)
        ],
        [
            'last-modified',
            $da289b704d3b2901$var$getLastModified(partial)
        ],
        [
            'verified',
            $da289b704d3b2901$var$getVerifiedIcon(partial)
        ],
        [
            'comment-count',
            $da289b704d3b2901$var$getCommentCount(partial)
        ],
        [
            'like-count',
            $da289b704d3b2901$var$getLikeCount(partial)
        ]
    ];
    if (partial.socialSignal) metadataParts.push([
        'social-signal',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4760164d6f170a64$export$2530a1964f2c1c12), {
            partial: partial
        })
    ]);
    const appendAdditionalQueryParams = ({ url: url, resultId: resultId })=>{
        const href = (0, $49e72282c8d5e924$export$94df0e59ebebf4a7)(partial.url, 'search_id', searchSessionId);
        return href;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        ...partial,
        primaryProduct: primaryProduct,
        url: appendAdditionalQueryParams({
            url: partial.url,
            resultId: partial.id
        }),
        title: $da289b704d3b2901$var$getTitle(partial),
        icon: icon,
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: "confluence",
            productSelected: !!selectedProduct,
            parts: metadataParts
        }),
        description: $da289b704d3b2901$var$getDescription(partial),
        showAISummary: [
            'page',
            'blogpost'
        ].includes(partial.type) && isAdminHubAIEnabled,
        cloudId: cloudId,
        position: position,
        partial: partial
    });
};















































const $f9b2deff8a406002$var$jiraProjectProductMap = {
    software: (0, $37AYo.ProductKeys).Jira,
    business: (0, $37AYo.ProductKeys).Jira,
    service_desk: (0, $37AYo.ProductKeys).JiraServiceManagement,
    product_discovery: (0, $37AYo.ProductKeys).JiraProductDiscovery
};
const $f9b2deff8a406002$var$jiraIssueProductMap = {
    SOFTWARE: (0, $37AYo.ProductKeys).Jira,
    BUSINESS: (0, $37AYo.ProductKeys).Jira,
    SERVICE_DESK: (0, $37AYo.ProductKeys).JiraServiceManagement,
    PRODUCT_DISCOVERY: (0, $37AYo.ProductKeys).JiraProductDiscovery
};
const $f9b2deff8a406002$var$jiraBoardProductMap = {
    SOFTWARE: (0, $37AYo.ProductKeys).Jira,
    BUSINESS: (0, $37AYo.ProductKeys).Jira
};
const $f9b2deff8a406002$export$212b3dd204f7717b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { partial: partial } = t0;
    let product = (0, $37AYo.ProductKeys).Jira;
    if ((0, $bzYTC.isSearchResultJiraProject)(partial)) product = $f9b2deff8a406002$var$jiraProjectProductMap[partial.projectType];
    else {
        if ((0, $bzYTC.isSearchResultJiraIssue)(partial)) {
            const projectType = partial?.issue?.fieldsById.edges[0]?.node.project.projectType;
            product = projectType ? $f9b2deff8a406002$var$jiraIssueProductMap[projectType] : product;
        } else if ((0, $bzYTC.isSearchResultJiraBoard)(partial)) product = $f9b2deff8a406002$var$jiraBoardProductMap[partial.product];
        else {
            if ((0, $bzYTC.isSearchResultJiraFilter)(partial)) ;
            else (0, $bzYTC.isSearchResultJiraDashboard)(partial);
        }
    }
    let t1;
    if ($[0] !== product) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
            product: product
        });
        $[0] = product;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ partial: partial })=>{
    let product = (0, $37AYo.ProductKeys).Jira;
    if ((0, $bzYTC.isSearchResultJiraProject)(partial)) product = $f9b2deff8a406002$var$jiraProjectProductMap[partial.projectType];
    else if ((0, $bzYTC.isSearchResultJiraIssue)(partial)) {
        const projectType = partial?.issue?.fieldsById.edges[0]?.node.project.projectType;
        product = projectType ? $f9b2deff8a406002$var$jiraIssueProductMap[projectType] : product;
    } else if ((0, $bzYTC.isSearchResultJiraBoard)(partial)) product = $f9b2deff8a406002$var$jiraBoardProductMap[partial.product];
    else if ((0, $bzYTC.isSearchResultJiraFilter)(partial)) ;
    else (0, $bzYTC.isSearchResultJiraDashboard)(partial);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
        product: product
    });
};



















const $1c8c9d05f653c760$var$containerStyles = (0, $buxP3.xcss)({
    display: 'inline-block',
    maxWidth: '215px',
    // from Figma design
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $1c8c9d05f653c760$export$47d2cbdccded0b18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { project: project } = t0;
    let t1;
    if ($[0] !== project) {
        t1 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $1c8c9d05f653c760$var$containerStyles,
                testId: "project-metadata",
                ...tooltipProps
            }, project);
        $[0] = project;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== project || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: project
        }, t1);
        $[2] = project;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ project: project })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: project
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $1c8c9d05f653c760$var$containerStyles,
            testId: "project-metadata",
            ...tooltipProps
        }, project));
};


const $d965d04720d0d4aa$var$findProject = (partial)=>{
    if (!partial.issue) return;
    for (const field of partial.issue.fieldsById.edges){
        if ((0, $bzYTC.isJiraProjectField)(field.node)) return field.node;
    }
};
const $d965d04720d0d4aa$var$getIssueOrProjectKey = (partial)=>{
    if ((0, $bzYTC.isSearchResultJiraIssue)(partial)) return partial.issue?.key;
    if ((0, $bzYTC.isSearchResultJiraProject)(partial)) return partial.projectKey;
    return null;
};
const $d965d04720d0d4aa$var$addJiraQueryParams = (url, partial, searchSessionId)=>{
    return (0, $49e72282c8d5e924$export$cbc5b385481fb319)(url, {
        searchObjectId: partial.id.split('/').pop(),
        searchContentType: partial.type,
        searchSessionId: searchSessionId
    });
};
const $d965d04720d0d4aa$var$STATUS_REGEX = /[\s-]+/g;
/**
 * This logic would need to be updated to use the color passed from the BE and not the string.
 * https://product-fabric.atlassian.net/browse/QS-3655
 */ const $d965d04720d0d4aa$var$getAppearance = (name)=>{
    name = name.replace($d965d04720d0d4aa$var$STATUS_REGEX, '').toLowerCase();
    switch(true){
        case [
            'todo',
            'unavailable',
            'minor',
            'notstarted'
        ].includes(name):
            return 'neutral';
        case [
            'available',
            'completed',
            'done',
            'approved',
            'resolved',
            'added',
            'closed'
        ].includes(name):
            return 'success';
        case [
            'error',
            'declined',
            'deleted',
            'failed',
            'rejected'
        ].includes(name):
            return 'danger';
        case [
            'inprogress',
            'open',
            'modified'
        ].includes(name):
            return 'information';
    }
    return 'neutral';
};
const $d965d04720d0d4aa$var$getStatus = (name, isLoading)=>{
    if (name) {
        const appearance = $d965d04720d0d4aa$var$getAppearance(name);
        if (appearance) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: appearance
        }, name);
    }
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$9ecbe061c4358be9), null);
    return null;
};
const $d965d04720d0d4aa$var$getContentString = (adf, level = 0)=>{
    let aggregatedString = '';
    if (adf.content) adf.content.forEach((node)=>{
        if (node.type === 'text') aggregatedString += node.text;
        else if (node.content && level < 15) aggregatedString += ' ' + $d965d04720d0d4aa$var$getContentString(node, ++level);
    });
    return aggregatedString;
};
const $d965d04720d0d4aa$var$getDescription = (description, query)=>{
    /**
   * This description can be either a complicated JSON which is actually an ADF (Atlassian Document Format) schema of the entire content of the jira issue.
   * or it could be a simple excerpt. This uncertainity is due to the progressive development of the BE feature and rolling it out.
   */ try {
        const adf = JSON.parse(description);
        const text = $d965d04720d0d4aa$var$getContentString(adf);
        return (0, $e348b946f9be0b4c$export$91c2cc655c44ef69)(text, query);
    } catch (e) {
        return description.length > (0, $e348b946f9be0b4c$export$6e2b3cea5902982b) ? description.substring(0, (0, $e348b946f9be0b4c$export$6e2b3cea5902982b)) + '...' : description.substring(0, (0, $e348b946f9be0b4c$export$6e2b3cea5902982b));
    }
};
const $d965d04720d0d4aa$export$3c36ba6ceaed3437 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(60);
    const { partial: partial, position: position } = t0;
    const [searchSessionId] = (0, $122441d1a555945e$export$e1e7a4797df1a656)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled } = t1;
    const isHydrationLoading = (0, $2Va9o.useIsJiraHydrationLoading)();
    const { description: description } = partial;
    let project = "";
    let Status = null;
    let url;
    if ($[0] !== isHydrationLoading || $[1] !== partial) {
        url = partial.url;
        if ((0, $bzYTC.isSearchResultJiraIssue)(partial)) {
            const projectField = $d965d04720d0d4aa$var$findProject(partial);
            project = projectField?.project.name || "";
            const projectId = projectField?.project.id || "";
            url = (0, $49e72282c8d5e924$export$cbc5b385481fb319)(partial.url, {
                searchContainerId: projectId.split("/").pop()
            });
            const t2 = partial.status?.name;
            let t3;
            if ($[5] !== isHydrationLoading || $[6] !== t2) {
                t3 = $d965d04720d0d4aa$var$getStatus(t2, isHydrationLoading);
                $[5] = isHydrationLoading;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            Status = t3;
        }
        $[0] = isHydrationLoading;
        $[1] = partial;
        $[2] = url;
        $[3] = project;
        $[4] = Status;
    } else {
        url = $[2];
        project = $[3];
        Status = $[4];
    }
    let t2;
    if ($[8] !== partial.title || $[9] !== searchQuery) {
        bb0: {
            const { highlightedTitle: highlightedTitle } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(partial.title, searchQuery.split(" "));
            if (!highlightedTitle) {
                t2 = partial.title;
                break bb0;
            }
            t2 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(highlightedTitle);
        }
        $[8] = partial.title;
        $[9] = searchQuery;
        $[10] = t2;
    } else t2 = $[10];
    const enrichedTitle = t2;
    let t3;
    if ($[11] !== description || $[12] !== searchQuery) {
        bb1: {
            const reducedDescription = $d965d04720d0d4aa$var$getDescription(description, searchQuery);
            const { highlightedTitle: highlightedTitle_0 } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(reducedDescription, searchQuery.split(" "));
            if (!highlightedTitle_0) {
                t3 = reducedDescription;
                break bb1;
            }
            t3 = (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(highlightedTitle_0);
        }
        $[11] = description;
        $[12] = searchQuery;
        $[13] = t3;
    } else t3 = $[13];
    const enrichedDescription = t3;
    url;
    let t4;
    if ($[14] !== partial || $[15] !== searchSessionId || $[16] !== url) {
        t4 = $d965d04720d0d4aa$var$addJiraQueryParams(url, partial, searchSessionId);
        $[14] = partial;
        $[15] = searchSessionId;
        $[16] = url;
        $[17] = t4;
    } else t4 = $[17];
    const getUrl = t4;
    let t5;
    bb2: {
        let t6;
        if ($[18] !== partial) {
            t6 = $d965d04720d0d4aa$var$getIssueOrProjectKey(partial);
            $[18] = partial;
            $[19] = t6;
        } else t6 = $[19];
        const value = t6;
        if (!value || !getUrl) {
            t5 = null;
            break bb2;
        }
        let t7;
        if ($[20] !== getUrl || $[21] !== value) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6319f15e3b45f1e8$export$2e2bcd8739ae039), {
                label: value,
                href: getUrl
            });
            $[20] = getUrl;
            $[21] = value;
            $[22] = t7;
        } else t7 = $[22];
        t5 = t7;
    }
    const getKey = t5;
    let t6;
    bb3: {
        if (!((0, $bzYTC.isSearchResultJiraIssue)(partial) || (0, $bzYTC.isSearchResultJiraProject)(partial))) {
            t6 = null;
            break bb3;
        }
        if (partial.lastModifiedDate) {
            let t7;
            if ($[23] !== partial.lastModifiedDate) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
                    lastModified: partial.lastModifiedDate
                });
                $[23] = partial.lastModifiedDate;
                $[24] = t7;
            } else t7 = $[24];
            t6 = t7;
            break bb3;
        }
        t6 = null;
    }
    const getLastModified = t6;
    let t7;
    if ($[25] !== partial.type) {
        t7 = [
            "type",
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20651b41f8c81b92$export$95cacd63dfd98bee), {
                type: partial.type
            })
        ];
        $[25] = partial.type;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] !== getKey) {
        t8 = [
            "key",
            getKey
        ];
        $[27] = getKey;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== project) {
        t9 = project ? [
            "project",
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c8c9d05f653c760$export$47d2cbdccded0b18), {
                project: project
            })
        ] : null;
        $[29] = project;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== getLastModified) {
        t10 = [
            "lastModified",
            getLastModified
        ];
        $[31] = getLastModified;
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] !== Status) {
        t11 = [
            "status",
            Status
        ];
        $[33] = Status;
        $[34] = t11;
    } else t11 = $[34];
    let metadataParts;
    if ($[35] !== partial || $[36] !== t10 || $[37] !== t11 || $[38] !== t7 || $[39] !== t8 || $[40] !== t9) {
        metadataParts = [
            t7,
            t8,
            t9,
            t10,
            t11
        ].filter(Boolean);
        (0, $bzYTC.isSearchResultJiraIssue)(partial) && partial.socialSignal;
        $[35] = partial;
        $[36] = t10;
        $[37] = t11;
        $[38] = t7;
        $[39] = t8;
        $[40] = t9;
        $[41] = metadataParts;
    } else metadataParts = $[41];
    let t12;
    if ($[44] !== partial) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9b2deff8a406002$export$212b3dd204f7717b), {
            partial: partial
        });
        $[44] = partial;
        $[45] = t12;
    } else t12 = $[45];
    const t13 = !!selectedProduct;
    let t14;
    if ($[46] !== metadataParts || $[47] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: "jira",
            productSelected: t13,
            parts: metadataParts
        });
        $[46] = metadataParts;
        $[47] = t13;
        $[48] = t14;
    } else t14 = $[48];
    const t15 = partial.type === "issue" && isAdminHubAIEnabled;
    let t16;
    if ($[49] !== cloudId || $[50] !== enrichedDescription || $[51] !== enrichedTitle || $[52] !== getUrl || $[53] !== partial || $[54] !== position || $[55] !== primaryProduct || $[56] !== t12 || $[57] !== t14 || $[58] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            ...partial,
            primaryProduct: primaryProduct,
            url: getUrl,
            icon: t12,
            title: enrichedTitle,
            headerMetadata: t14,
            description: enrichedDescription,
            showAISummary: t15,
            cloudId: cloudId,
            position: position,
            partial: partial
        });
        $[49] = cloudId;
        $[50] = enrichedDescription;
        $[51] = enrichedTitle;
        $[52] = getUrl;
        $[53] = partial;
        $[54] = position;
        $[55] = primaryProduct;
        $[56] = t12;
        $[57] = t14;
        $[58] = t15;
        $[59] = t16;
    } else t16 = $[59];
    return t16;
} : ({ partial: partial, position: position })=>{
    const [searchSessionId] = (0, $122441d1a555945e$export$e1e7a4797df1a656)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const isHydrationLoading = (0, $2Va9o.useIsJiraHydrationLoading)();
    const { description: description } = partial;
    let project = '';
    let Status = null;
    let url = partial.url;
    if ((0, $bzYTC.isSearchResultJiraIssue)(partial)) {
        const projectField = $d965d04720d0d4aa$var$findProject(partial);
        project = projectField?.project.name || '';
        const projectId = projectField?.project.id || '';
        url = (0, $49e72282c8d5e924$export$cbc5b385481fb319)(partial.url, {
            searchContainerId: projectId.split('/').pop()
        });
        Status = $d965d04720d0d4aa$var$getStatus(partial.status?.name, isHydrationLoading);
    }
    const enrichedTitle = (0, $cozmU.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(partial.title, searchQuery.split(' '));
        if (!highlightedTitle) return partial.title;
        return (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(highlightedTitle);
    }, [
        partial.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $cozmU.useMemo)(()=>{
        const reducedDescription = $d965d04720d0d4aa$var$getDescription(description, searchQuery);
        const { highlightedTitle: highlightedTitle_0 } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle_0) return reducedDescription;
        return (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(highlightedTitle_0);
    }, [
        description,
        searchQuery
    ]);
    const getUrl = (0, $cozmU.useMemo)(()=>{
        return $d965d04720d0d4aa$var$addJiraQueryParams(url, partial, searchSessionId);
    }, [
        url,
        partial,
        searchSessionId
    ]);
    const getKey = (0, $cozmU.useMemo)(()=>{
        const value = $d965d04720d0d4aa$var$getIssueOrProjectKey(partial);
        if (!value || !getUrl) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6319f15e3b45f1e8$export$2e2bcd8739ae039), {
            label: value,
            href: getUrl
        });
    }, [
        partial,
        getUrl
    ]);
    const getLastModified = (0, $cozmU.useMemo)(()=>{
        if (!((0, $bzYTC.isSearchResultJiraIssue)(partial) || (0, $bzYTC.isSearchResultJiraProject)(partial))) return null;
        if (partial.lastModifiedDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: partial.lastModifiedDate
        });
        return null;
    }, [
        partial
    ]);
    const metadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20651b41f8c81b92$export$95cacd63dfd98bee), {
                type: partial.type
            })
        ],
        [
            'key',
            getKey
        ],
        project ? [
            'project',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c8c9d05f653c760$export$47d2cbdccded0b18), {
                project: project
            })
        ] : null,
        [
            'lastModified',
            getLastModified
        ],
        [
            'status',
            Status
        ]
    ].filter(Boolean);
    // fg('search-plex-jira-social-signal') => false
    (0, $bzYTC.isSearchResultJiraIssue)(partial) && partial.socialSignal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        ...partial,
        primaryProduct: primaryProduct,
        url: getUrl,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9b2deff8a406002$export$212b3dd204f7717b), {
            partial: partial
        }),
        title: enrichedTitle,
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: "jira",
            productSelected: !!selectedProduct,
            parts: metadataParts
        }),
        description: enrichedDescription,
        showAISummary: partial.type === 'issue' && isAdminHubAIEnabled,
        cloudId: cloudId,
        position: position,
        partial: partial
    });
};












var $kTb7m = parcelRequire("kTb7m");


var $7avaU = parcelRequire("7avaU");



































var $4efpo = parcelRequire("4efpo");










const $677d5ada4b14cab4$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    restrictedTooltip: {
        id: "search-page.results.restricted-result-tooltip",
        defaultMessage: "Only visible to specific people"
    },
    privateTooltip: {
        id: "search-page.results.private-result-tooltip",
        defaultMessage: "Only visible to you"
    }
});


const $81ab49e84b84cfe5$var$iconColor = "var(--ds-icon, #292A2E)";
const $81ab49e84b84cfe5$export$3aad690c5eb10b93 = 'restricted-lozenge';
const $81ab49e84b84cfe5$export$fb0d481c8f77ba99 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { permissionLevel: permissionLevel } = t0;
    const tooltipText = permissionLevel === "private" ? (0, $677d5ada4b14cab4$export$defe85febe8b728c).privateTooltip : (0, $677d5ada4b14cab4$export$defe85febe8b728c).restrictedTooltip;
    let t1;
    if ($[0] !== tooltipText) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipText);
        $[0] = tooltipText;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: $81ab49e84b84cfe5$export$3aad690c5eb10b93
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
            label: "",
            color: $81ab49e84b84cfe5$var$iconColor,
            size: "small"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1
        }, t2);
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ permissionLevel: permissionLevel })=>{
    const tooltipText = permissionLevel === 'private' ? (0, $677d5ada4b14cab4$export$defe85febe8b728c).privateTooltip : (0, $677d5ada4b14cab4$export$defe85febe8b728c).restrictedTooltip;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: $81ab49e84b84cfe5$export$3aad690c5eb10b93
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        label: "",
        color: $81ab49e84b84cfe5$var$iconColor,
        size: "small"
    })));
};









const $784095eebd525145$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    resultLabel: {
        id: "dynamic-cards-search-page.github-branch-result.label",
        defaultMessage: "Branch"
    }
});


const $fb628f3bbf293e2d$export$5620ef5d10869020 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { partial: partial, position: position, icon: icon } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity } = partial;
    let t2;
    if ($[0] !== entity) {
        t2 = entity || {};
        $[0] = entity;
        $[1] = t2;
    } else t2 = $[1];
    const { name: branchName, container: container } = t2;
    let t3;
    if ($[2] !== formatMessage) {
        t3 = formatMessage((0, $784095eebd525145$export$defe85febe8b728c).resultLabel);
        $[2] = formatMessage;
        $[3] = t3;
    } else t3 = $[3];
    const label = t3;
    let t4;
    if ($[4] !== partial.integrationId) {
        t4 = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
        $[4] = partial.integrationId;
        $[5] = t4;
    } else t4 = $[5];
    const integrationKey = t4;
    let t5;
    if ($[6] !== lastModifiedDate) {
        t5 = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        }) : null;
        $[6] = lastModifiedDate;
        $[7] = t5;
    } else t5 = $[7];
    const lastModifiedComponent = t5;
    let t6;
    if ($[8] !== permissionLevel) {
        t6 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
            permissionLevel: permissionLevel
        }) : null;
        $[8] = permissionLevel;
        $[9] = t6;
    } else t6 = $[9];
    const padlockIcon = t6;
    const t7 = container?.name ?? null;
    let t8;
    if ($[10] !== t7) {
        t8 = [
            "repository-name",
            t7
        ];
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== padlockIcon) {
        t9 = [
            "padlock",
            padlockIcon
        ];
        $[12] = padlockIcon;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== lastModifiedComponent) {
        t10 = [
            "last-modified",
            lastModifiedComponent
        ];
        $[14] = lastModifiedComponent;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== label || $[17] !== t10 || $[18] !== t8 || $[19] !== t9) {
        t11 = [
            label,
            t8,
            t9,
            t10
        ];
        $[16] = label;
        $[17] = t10;
        $[18] = t8;
        $[19] = t9;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== integrationKey || $[22] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: t11
        });
        $[21] = integrationKey;
        $[22] = t11;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== branchName || $[25] !== cloudId || $[26] !== icon || $[27] !== partial || $[28] !== position || $[29] !== primaryProduct || $[30] !== t12 || $[31] !== url) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: partial.id,
            icon: icon,
            description: "",
            headerMetadata: t12,
            title: branchName,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[24] = branchName;
        $[25] = cloudId;
        $[26] = icon;
        $[27] = partial;
        $[28] = position;
        $[29] = primaryProduct;
        $[30] = t12;
        $[31] = url;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity } = partial;
    const { name: branchName, container: container } = entity || {};
    const label = formatMessage((0, $784095eebd525145$export$defe85febe8b728c).resultLabel);
    const integrationKey = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: '',
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: [
                label,
                [
                    'repository-name',
                    container?.name ?? null
                ],
                [
                    'padlock',
                    padlockIcon
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ]
            ]
        }),
        title: branchName,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};


























var $aDSIl = parcelRequire("aDSIl");


var $60Yxm = parcelRequire("60Yxm");


























const $75f65e77ad9e9a87$export$10f53ee736dae147 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { date: date } = t0;
    if (!date) return null;
    let t1;
    if ($[0] !== date) {
        t1 = new Date(date);
        $[0] = date;
        $[1] = t1;
    } else t1 = $[1];
    const event = t1;
    let t2;
    if ($[2] !== event) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
            value: event,
            month: "short",
            day: "numeric",
            year: "numeric"
        });
        $[2] = event;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ date: date })=>{
    if (!date) return null;
    const event = new Date(date);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
        value: event,
        month: "short",
        day: "numeric",
        year: "numeric"
    });
};





/**
 * Returns a date and time range based on two date strings
 * @example 10-11 AM
 */ const $f90e8d06356a2e70$export$abc17c795ac8b09b = ({ from: from, to: to })=>{
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric'
    });
    const fromDateParts = dateTimeFormat.format(fromDate);
    const toDateParts = dateTimeFormat.format(toDate);
    return `${fromDateParts} - ${toDateParts}`;
};









const $1d73628619f23db3$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    eventLabel: {
        id: "dynamic-cards-search-page.calendar-event-search-result.calendar-label",
        defaultMessage: "Calendar"
    },
    meetingLink: {
        id: "dynamic-cards-search-page.calendar-event-search-result.meeting-link",
        defaultMessage: "Meeting link"
    },
    joinMeetingLink: {
        id: "dynamic-cards-search-page.calendar-event-search-result.join-meeting-link",
        defaultMessage: "Join meeting"
    },
    meetingLinkIcon: {
        id: "dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon",
        defaultMessage: "Join meeting"
    },
    recurringEventIcon: {
        id: "dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon",
        defaultMessage: "Recurring event"
    },
    recurringMetadataLabel: {
        id: "dynamic-cards-search-page.calendar-event-search-result.recurring-event-label",
        defaultMessage: "Recurring"
    },
    upcomingEventsButton: {
        id: "dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button",
        defaultMessage: "Upcoming events"
    },
    pastEventsButton: {
        id: "dynamic-cards-search-page.calendar-event-search-result.past-events-button",
        defaultMessage: "Past events"
    }
});


const $364e1a9ab72bb427$var$RELATED_EVENTS_STATE = {
    UPCOMING: 'upcoming',
    PAST: 'past',
    CLOSED: 'closed'
};
const $364e1a9ab72bb427$export$137e3167f558cbc3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { fromDate: fromDate, toDate: toDate, meetingLink: meetingLink } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!fromDate || !meetingLink || !toDate) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Date();
        $[0] = t1;
    } else t1 = $[0];
    const currentDate = t1;
    let startDate;
    if ($[1] !== fromDate) {
        startDate = new Date(fromDate);
        startDate.setHours(startDate.getHours() - 2);
        $[1] = fromDate;
        $[2] = startDate;
    } else startDate = $[2];
    let t2;
    if ($[3] !== toDate) {
        t2 = new Date(toDate);
        $[3] = toDate;
        $[4] = t2;
    } else t2 = $[4];
    const endDate = t2;
    const eventIsWithin2hoursOrIsOngoing = startDate < currentDate && currentDate < endDate;
    let t3;
    if ($[5] !== eventIsWithin2hoursOrIsOngoing || $[6] !== formatMessage) {
        t3 = eventIsWithin2hoursOrIsOngoing ? formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).joinMeetingLink) : formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).meetingLink);
        $[5] = eventIsWithin2hoursOrIsOngoing;
        $[6] = formatMessage;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== meetingLink || $[9] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $eKMV3.default), {
            iconBefore: $364e1a9ab72bb427$var$_temp,
            href: meetingLink
        }, t3);
        $[8] = meetingLink;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ fromDate: fromDate, toDate: toDate, meetingLink: meetingLink })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!fromDate || !meetingLink || !toDate) return null;
    const currentDate = new Date();
    const startDate = new Date(fromDate);
    startDate.setHours(startDate.getHours() - 2); // Checks if the event is within 2 hours
    const endDate = new Date(toDate);
    const eventIsWithin2hoursOrIsOngoing = startDate < currentDate && currentDate < endDate;
    return /*#__PURE__*/ $cozmU.createElement((0, $eKMV3.default), {
        iconBefore: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
                color: "var(--ds-icon-subtle)",
                label: ''
            }),
        href: meetingLink
    }, eventIsWithin2hoursOrIsOngoing ? formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).joinMeetingLink) : formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).meetingLink));
};
const $364e1a9ab72bb427$var$calendarEventLinkStyles = (0, $buxP3.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    },
    display: 'flex'
});
const $364e1a9ab72bb427$var$relatedCalendarEventMetadataStyles = (0, $buxP3.xcss)({
    gridColumn: 2,
    alignItems: 'center'
});
const $364e1a9ab72bb427$var$RelatedCalendarEvents = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { calendarEvents: calendarEvents } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== calendarEvents || $[1] !== formatMessage) {
        let t2;
        if ($[3] !== formatMessage) {
            t2 = (calendarEvent)=>{
                const { entity: entity, title: title, url: url } = calendarEvent;
                const labelMessageComponent = /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
                    size: "small"
                }, formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).eventLabel));
                const eventDateComponent = /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
                    size: "small"
                }, /*#__PURE__*/ $cozmU.createElement((0, $75f65e77ad9e9a87$export$10f53ee736dae147), {
                    date: entity.eventStartTime
                }));
                const eventTimeComponent = entity.eventStartTime && entity.eventEndTime ? /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
                    size: "small"
                }, (0, $f90e8d06356a2e70$export$abc17c795ac8b09b)({
                    from: entity.eventStartTime,
                    to: entity.eventEndTime
                })) : null;
                const meetingLink = entity.videoMeetingURL ? /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
                    size: "small"
                }, /*#__PURE__*/ $cozmU.createElement((0, $l8Rhq.Anchor), {
                    xcss: $364e1a9ab72bb427$var$calendarEventLinkStyles,
                    href: entity.videoMeetingURL
                }, formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).meetingLink))) : null;
                return /*#__PURE__*/ $cozmU.createElement((0, $9iaFM.Grid), {
                    templateColumns: "min-content 1fr",
                    alignItems: "center",
                    columnGap: "space.100"
                }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                    label: formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).recurringEventIcon),
                    size: "medium",
                    color: "var(--ds-icon-accent-blue, #357DE8)"
                }), /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
                    size: "small",
                    weight: "semibold"
                }, /*#__PURE__*/ $cozmU.createElement((0, $l8Rhq.Anchor), {
                    xcss: $364e1a9ab72bb427$var$calendarEventLinkStyles,
                    href: url
                }, title)), /*#__PURE__*/ $cozmU.createElement((0, $kA6Zo.Flex), {
                    xcss: $364e1a9ab72bb427$var$relatedCalendarEventMetadataStyles
                }, /*#__PURE__*/ $cozmU.createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
                    parts: [
                        [
                            "calendar-label",
                            labelMessageComponent
                        ],
                        [
                            "event-date",
                            eventDateComponent
                        ],
                        [
                            "event-time",
                            eventTimeComponent
                        ],
                        [
                            "meeting-link",
                            meetingLink
                        ]
                    ]
                })));
            };
            $[3] = formatMessage;
            $[4] = t2;
        } else t2 = $[4];
        t1 = calendarEvents.map(t2);
        $[0] = calendarEvents;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $9iaFM.Grid), {
            gap: "space.200"
        }, t1);
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ calendarEvents: calendarEvents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $9iaFM.Grid), {
        gap: "space.200"
    }, calendarEvents.map((calendarEvent)=>{
        const { entity: entity, title: title, url: url } = calendarEvent;
        const labelMessageComponent = /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
            size: "small"
        }, formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).eventLabel));
        const eventDateComponent = /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
            size: "small"
        }, /*#__PURE__*/ $cozmU.createElement((0, $75f65e77ad9e9a87$export$10f53ee736dae147), {
            date: entity.eventStartTime
        }));
        const eventTimeComponent = entity.eventStartTime && entity.eventEndTime ? /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
            size: "small"
        }, (0, $f90e8d06356a2e70$export$abc17c795ac8b09b)({
            from: entity.eventStartTime,
            to: entity.eventEndTime
        })) : null;
        const meetingLink = entity.videoMeetingURL ? /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
            size: "small"
        }, /*#__PURE__*/ $cozmU.createElement((0, $l8Rhq.Anchor), {
            xcss: $364e1a9ab72bb427$var$calendarEventLinkStyles,
            href: entity.videoMeetingURL
        }, formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).meetingLink))) : null;
        return /*#__PURE__*/ $cozmU.createElement((0, $9iaFM.Grid), {
            templateColumns: "min-content 1fr",
            alignItems: "center",
            columnGap: "space.100"
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
            label: formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).recurringEventIcon),
            size: "medium",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.Text), {
            size: "small",
            weight: "semibold"
        }, /*#__PURE__*/ $cozmU.createElement((0, $l8Rhq.Anchor), {
            xcss: $364e1a9ab72bb427$var$calendarEventLinkStyles,
            href: url
        }, title)), /*#__PURE__*/ $cozmU.createElement((0, $kA6Zo.Flex), {
            xcss: $364e1a9ab72bb427$var$relatedCalendarEventMetadataStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            parts: [
                [
                    'calendar-label',
                    labelMessageComponent
                ],
                [
                    'event-date',
                    eventDateComponent
                ],
                [
                    'event-time',
                    eventTimeComponent
                ],
                [
                    'meeting-link',
                    meetingLink
                ]
            ]
        })));
    }));
};
const $364e1a9ab72bb427$var$calendarEventActionStyles = (0, $buxP3.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $364e1a9ab72bb427$var$CalendarEventActions = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { fromDate: fromDate, toDate: toDate, meetingLink: meetingLink, linkedEntities: linkedEntities } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [relatedEventsState, setEventsToDisplay] = (0, $cozmU.useState)($364e1a9ab72bb427$var$RELATED_EVENTS_STATE.CLOSED);
    const isUpcomingEventsSelected = relatedEventsState === $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.UPCOMING;
    const isPastEventsSelected = relatedEventsState === $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.PAST;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Date();
        $[0] = t1;
    } else t1 = $[0];
    const currentDate = t1;
    let t2;
    if ($[1] !== linkedEntities) {
        const linkedCalendarEvents = linkedEntities.flatMap($364e1a9ab72bb427$var$_temp2);
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (events, currentEvent)=>{
                const isPastEvent = new Date(currentEvent.entity.eventStartTime) < currentDate;
                if (isPastEvent) return [
                    events[0].concat(currentEvent),
                    events[1]
                ];
                return [
                    events[0],
                    events[1].concat(currentEvent)
                ];
            };
            $[3] = t3;
        } else t3 = $[3];
        t2 = linkedCalendarEvents.reduce(t3, [
            [],
            []
        ]);
        $[1] = linkedEntities;
        $[2] = t2;
    } else t2 = $[2];
    const [pastEvents, upcomingEvents] = t2;
    let t3;
    if ($[4] !== pastEvents || $[5] !== upcomingEvents) {
        t3 = {
            pastEvents: pastEvents,
            upcomingEvents: upcomingEvents
        };
        $[4] = pastEvents;
        $[5] = upcomingEvents;
        $[6] = t3;
    } else t3 = $[6];
    const data = t3;
    let t4;
    if ($[7] !== fromDate || $[8] !== meetingLink || $[9] !== toDate) {
        t4 = /*#__PURE__*/ $cozmU.createElement($364e1a9ab72bb427$export$137e3167f558cbc3, {
            fromDate: fromDate,
            toDate: toDate,
            meetingLink: meetingLink
        });
        $[7] = fromDate;
        $[8] = meetingLink;
        $[9] = toDate;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== data.upcomingEvents.length || $[12] !== formatMessage || $[13] !== isUpcomingEventsSelected) {
        t5 = !!data.upcomingEvents.length && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            iconAfter: (iconProps)=>isUpcomingEventsSelected ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: ()=>setEventsToDisplay(isUpcomingEventsSelected ? $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.CLOSED : $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.UPCOMING),
            isSelected: isUpcomingEventsSelected
        }, formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).upcomingEventsButton));
        $[11] = data.upcomingEvents.length;
        $[12] = formatMessage;
        $[13] = isUpcomingEventsSelected;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== data.pastEvents.length || $[16] !== formatMessage || $[17] !== isPastEventsSelected) {
        t6 = !!data.pastEvents.length && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            iconAfter: (iconProps_0)=>isPastEventsSelected ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps_0,
                    size: "small"
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    ...iconProps_0,
                    size: "small"
                }),
            onClick: ()=>setEventsToDisplay(isPastEventsSelected ? $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.CLOSED : $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.PAST),
            isSelected: isPastEventsSelected
        }, formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).pastEventsButton));
        $[15] = data.pastEvents.length;
        $[16] = formatMessage;
        $[17] = isPastEventsSelected;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $364e1a9ab72bb427$var$calendarEventActionStyles
        }, t4, t5, t6);
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== data.upcomingEvents || $[24] !== relatedEventsState) {
        t8 = relatedEventsState === $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.UPCOMING && /*#__PURE__*/ $cozmU.createElement($364e1a9ab72bb427$var$RelatedCalendarEvents, {
            calendarEvents: data.upcomingEvents
        });
        $[23] = data.upcomingEvents;
        $[24] = relatedEventsState;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] !== data.pastEvents || $[27] !== relatedEventsState) {
        t9 = relatedEventsState === $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.PAST && /*#__PURE__*/ $cozmU.createElement($364e1a9ab72bb427$var$RelatedCalendarEvents, {
            calendarEvents: data.pastEvents
        });
        $[26] = data.pastEvents;
        $[27] = relatedEventsState;
        $[28] = t9;
    } else t9 = $[28];
    let t10;
    if ($[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $9iaFM.Grid), {
            gap: "space.200"
        }, t7, t8, t9);
        $[29] = t7;
        $[30] = t8;
        $[31] = t9;
        $[32] = t10;
    } else t10 = $[32];
    return t10;
} : ({ fromDate: fromDate, toDate: toDate, meetingLink: meetingLink, linkedEntities: linkedEntities })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [relatedEventsState, setEventsToDisplay] = (0, $cozmU.useState)($364e1a9ab72bb427$var$RELATED_EVENTS_STATE.CLOSED);
    const isUpcomingEventsSelected = relatedEventsState === $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.UPCOMING;
    const isPastEventsSelected = relatedEventsState === $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.PAST;
    const data = (0, $cozmU.useMemo)(()=>{
        const currentDate = new Date();
        const linkedCalendarEvents = linkedEntities.flatMap((linkedEntity)=>linkedEntity.entity ? [
                {
                    title: linkedEntity.title,
                    url: linkedEntity.url,
                    entity: linkedEntity.entity
                }
            ] : []);
        const [pastEvents, upcomingEvents] = linkedCalendarEvents.reduce((events, currentEvent)=>{
            const isPastEvent = new Date(currentEvent.entity.eventStartTime) < currentDate;
            if (isPastEvent) return [
                events[0].concat(currentEvent),
                events[1]
            ];
            return [
                events[0],
                events[1].concat(currentEvent)
            ];
        }, [
            [],
            []
        ]);
        return {
            pastEvents: pastEvents,
            upcomingEvents: upcomingEvents
        };
    }, [
        linkedEntities
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $9iaFM.Grid), {
        gap: "space.200"
    }, /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $364e1a9ab72bb427$var$calendarEventActionStyles
    }, /*#__PURE__*/ $cozmU.createElement($364e1a9ab72bb427$export$137e3167f558cbc3, {
        fromDate: fromDate,
        toDate: toDate,
        meetingLink: meetingLink
    }), !!data.upcomingEvents.length && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        iconAfter: (iconProps)=>isUpcomingEventsSelected ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        onClick: ()=>setEventsToDisplay(isUpcomingEventsSelected ? $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.CLOSED : $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.UPCOMING),
        isSelected: isUpcomingEventsSelected
    }, formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).upcomingEventsButton)), !!data.pastEvents.length && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        iconAfter: (iconProps_0)=>isPastEventsSelected ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps_0,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps_0,
                size: "small"
            }),
        onClick: ()=>setEventsToDisplay(isPastEventsSelected ? $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.CLOSED : $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.PAST),
        isSelected: isPastEventsSelected
    }, formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).pastEventsButton))), relatedEventsState === $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.UPCOMING && /*#__PURE__*/ $cozmU.createElement($364e1a9ab72bb427$var$RelatedCalendarEvents, {
        calendarEvents: data.upcomingEvents
    }), relatedEventsState === $364e1a9ab72bb427$var$RELATED_EVENTS_STATE.PAST && /*#__PURE__*/ $cozmU.createElement($364e1a9ab72bb427$var$RelatedCalendarEvents, {
        calendarEvents: data.pastEvents
    }));
};
const $364e1a9ab72bb427$export$2d6c717667f5157c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { partial: partial, position: position, icon: icon, product: product } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const { url: url, permissionLevel: permissionLevel, entity: entity, title: title, linkedEntities: linkedEntities } = partial;
    let t2;
    if ($[0] !== entity?.eventEndTime || $[1] !== entity?.eventStartTime) {
        t2 = entity?.eventStartTime && entity?.eventEndTime ? (0, $f90e8d06356a2e70$export$abc17c795ac8b09b)({
            from: entity?.eventStartTime,
            to: entity?.eventEndTime
        }) : null;
        $[0] = entity?.eventEndTime;
        $[1] = entity?.eventStartTime;
        $[2] = t2;
    } else t2 = $[2];
    const eventTime = t2;
    let t3;
    if ($[3] !== entity?.recurringEventID || $[4] !== formatMessage) {
        t3 = entity?.recurringEventID ? formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).recurringMetadataLabel) : null;
        $[3] = entity?.recurringEventID;
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    const recurringEvent = t3;
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).eventLabel);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = entity?.parentCalendar.name ?? null;
    let t6;
    if ($[8] !== eventTime || $[9] !== recurringEvent || $[10] !== t4 || $[11] !== t5) {
        t6 = {
            labelMessage: t4,
            calendarName: t5,
            eventTime: eventTime,
            recurringEvent: recurringEvent
        };
        $[8] = eventTime;
        $[9] = recurringEvent;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const calendarEvent = t6;
    const t7 = entity?.eventStartTime;
    let t8;
    if ($[13] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $75f65e77ad9e9a87$export$10f53ee736dae147), {
            date: t7
        });
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    const eventDateComponent = t8;
    let t9;
    if ($[15] !== partial.description) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            paddingBlockEnd: "space.100"
        }, partial.description);
        $[15] = partial.description;
        $[16] = t9;
    } else t9 = $[16];
    const body = t9;
    let t10;
    if ($[17] !== permissionLevel) {
        t10 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ $cozmU.createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
            permissionLevel: permissionLevel
        }) : null;
        $[17] = permissionLevel;
        $[18] = t10;
    } else t10 = $[18];
    const padlockIcon = t10;
    const t11 = partial.id;
    const t12 = !!selectedProduct;
    let t13;
    if ($[19] !== eventDateComponent) {
        t13 = [
            "event-date",
            eventDateComponent
        ];
        $[19] = eventDateComponent;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== calendarEvent.eventTime) {
        t14 = [
            "event-time",
            calendarEvent.eventTime
        ];
        $[21] = calendarEvent.eventTime;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== padlockIcon) {
        t15 = [
            "padlock",
            padlockIcon
        ];
        $[23] = padlockIcon;
        $[24] = t15;
    } else t15 = $[24];
    let t16;
    if ($[25] !== calendarEvent.calendarName || $[26] !== calendarEvent.labelMessage || $[27] !== calendarEvent.recurringEvent || $[28] !== t13 || $[29] !== t14 || $[30] !== t15) {
        t16 = [
            calendarEvent.labelMessage,
            calendarEvent.calendarName,
            t13,
            t14,
            calendarEvent.recurringEvent,
            t15
        ];
        $[25] = calendarEvent.calendarName;
        $[26] = calendarEvent.labelMessage;
        $[27] = calendarEvent.recurringEvent;
        $[28] = t13;
        $[29] = t14;
        $[30] = t15;
        $[31] = t16;
    } else t16 = $[31];
    let t17;
    if ($[32] !== product || $[33] !== t12 || $[34] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: t12,
            parts: t16
        });
        $[32] = product;
        $[33] = t12;
        $[34] = t16;
        $[35] = t17;
    } else t17 = $[35];
    let t18;
    if ($[36] !== title) {
        t18 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title);
        $[36] = title;
        $[37] = t18;
    } else t18 = $[37];
    const t19 = entity?.videoMeetingURL;
    const t20 = entity?.eventStartTime;
    const t21 = entity?.eventEndTime;
    let t22;
    if ($[38] !== linkedEntities) {
        t22 = linkedEntities ?? [];
        $[38] = linkedEntities;
        $[39] = t22;
    } else t22 = $[39];
    let t23;
    if ($[40] !== t19 || $[41] !== t20 || $[42] !== t21 || $[43] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement($364e1a9ab72bb427$var$CalendarEventActions, {
            meetingLink: t19,
            fromDate: t20,
            toDate: t21,
            linkedEntities: t22
        });
        $[40] = t19;
        $[41] = t20;
        $[42] = t21;
        $[43] = t22;
        $[44] = t23;
    } else t23 = $[44];
    let t24;
    if ($[45] !== body || $[46] !== cloudId || $[47] !== icon || $[48] !== partial || $[49] !== position || $[50] !== primaryProduct || $[51] !== t17 || $[52] !== t18 || $[53] !== t23 || $[54] !== url) {
        t24 = /*#__PURE__*/ $cozmU.createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: t11,
            icon: icon,
            description: body,
            headerMetadata: t17,
            title: t18,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial,
            footer: t23
        });
        $[45] = body;
        $[46] = cloudId;
        $[47] = icon;
        $[48] = partial;
        $[49] = position;
        $[50] = primaryProduct;
        $[51] = t17;
        $[52] = t18;
        $[53] = t23;
        $[54] = url;
        $[55] = t24;
    } else t24 = $[55];
    return t24;
} : ({ partial: partial, position: position, icon: icon, product: product })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { url: url, permissionLevel: permissionLevel, entity: entity, title: title, linkedEntities: linkedEntities } = partial;
    const calendarEvent = (0, $cozmU.useMemo)(()=>{
        const eventTime = entity?.eventStartTime && entity?.eventEndTime ? (0, $f90e8d06356a2e70$export$abc17c795ac8b09b)({
            from: entity?.eventStartTime,
            to: entity?.eventEndTime
        }) : null;
        const recurringEvent = entity?.recurringEventID ? formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).recurringMetadataLabel) : null;
        return {
            labelMessage: formatMessage((0, $1d73628619f23db3$export$defe85febe8b728c).eventLabel),
            calendarName: entity?.parentCalendar.name ?? null,
            eventTime: eventTime,
            recurringEvent: recurringEvent
        };
    }, [
        entity,
        formatMessage
    ]);
    const eventDateComponent = /*#__PURE__*/ $cozmU.createElement((0, $75f65e77ad9e9a87$export$10f53ee736dae147), {
        date: entity?.eventStartTime
    });
    const body = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        paddingBlockEnd: "space.100"
    }, partial.description);
    const padlockIcon = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ $cozmU.createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    return /*#__PURE__*/ $cozmU.createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: body,
        headerMetadata: /*#__PURE__*/ $cozmU.createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: !!selectedProduct,
            parts: [
                calendarEvent.labelMessage,
                calendarEvent.calendarName,
                [
                    'event-date',
                    eventDateComponent
                ],
                [
                    'event-time',
                    calendarEvent.eventTime
                ],
                calendarEvent.recurringEvent,
                [
                    'padlock',
                    padlockIcon
                ]
            ]
        }),
        title: (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        footer: /*#__PURE__*/ $cozmU.createElement($364e1a9ab72bb427$var$CalendarEventActions, {
            meetingLink: entity?.videoMeetingURL,
            fromDate: entity?.eventStartTime,
            toDate: entity?.eventEndTime,
            linkedEntities: linkedEntities ?? []
        })
    });
};
function $364e1a9ab72bb427$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
        color: "var(--ds-icon-subtle)",
        label: ""
    });
}
function $364e1a9ab72bb427$var$_temp2(linkedEntity) {
    return linkedEntity.entity ? [
        {
            title: linkedEntity.title,
            url: linkedEntity.url,
            entity: linkedEntity.entity
        }
    ] : [];
}





























const $b445df02919fcc5f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    resultLabel: {
        id: "dynamic-cards-search-page.github-commit-result.label",
        defaultMessage: "Commit"
    }
});


const $cceb87146273e5fe$export$35c708bc36dbd879 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(50);
    const { partial: partial, position: position, icon: icon } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, entity: entity } = partial;
    let t2;
    if ($[0] !== entity) {
        t2 = entity || {};
        $[0] = entity;
        $[1] = t2;
    } else t2 = $[1];
    const { author: author, container: container } = t2;
    let t3;
    if ($[2] !== formatMessage) {
        t3 = formatMessage((0, $b445df02919fcc5f$export$defe85febe8b728c).resultLabel);
        $[2] = formatMessage;
        $[3] = t3;
    } else t3 = $[3];
    const label = t3;
    let t4;
    if ($[4] !== partial.integrationId) {
        t4 = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
        $[4] = partial.integrationId;
        $[5] = t4;
    } else t4 = $[5];
    const integrationKey = t4;
    let t5;
    if ($[6] !== lastModifiedDate) {
        t5 = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        }) : null;
        $[6] = lastModifiedDate;
        $[7] = t5;
    } else t5 = $[7];
    const lastModifiedComponent = t5;
    let t6;
    if ($[8] !== permissionLevel) {
        t6 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
            permissionLevel: permissionLevel
        }) : null;
        $[8] = permissionLevel;
        $[9] = t6;
    } else t6 = $[9];
    const padlockIcon = t6;
    let messageDescription;
    if (author?.user) {
        let t7;
        if ($[10] !== author.user.name) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c900a01b74c1545$export$e2255cf6045e8d47), {
                name: author.user.name
            });
            $[10] = author.user.name;
            $[11] = t7;
        } else t7 = $[11];
        const t8 = `${author.user.name}: `;
        let t9;
        if ($[12] !== excerpt || $[13] !== t8) {
            t9 = (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerpt, true, t8);
            $[12] = excerpt;
            $[13] = t8;
            $[14] = t9;
        } else t9 = $[14];
        let t10;
        if ($[15] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, t9);
            $[15] = t9;
            $[16] = t10;
        } else t10 = $[16];
        let t11;
        if ($[17] !== t10 || $[18] !== t7) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.025",
                alignBlock: "start"
            }, t7, t10);
            $[17] = t10;
            $[18] = t7;
            $[19] = t11;
        } else t11 = $[19];
        messageDescription = t11;
    } else {
        let t7;
        if ($[20] !== excerpt) {
            t7 = (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerpt, true);
            $[20] = excerpt;
            $[21] = t7;
        } else t7 = $[21];
        let t8;
        if ($[22] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, t7);
            $[22] = t7;
            $[23] = t8;
        } else t8 = $[23];
        messageDescription = t8;
    }
    const t7 = partial.id;
    const t8 = messageDescription;
    const t9 = container?.name ?? null;
    let t10;
    if ($[24] !== t9) {
        t10 = [
            "repository-name",
            t9
        ];
        $[24] = t9;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== padlockIcon) {
        t11 = [
            "padlock",
            padlockIcon
        ];
        $[26] = padlockIcon;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== lastModifiedComponent) {
        t12 = [
            "last-modified",
            lastModifiedComponent
        ];
        $[28] = lastModifiedComponent;
        $[29] = t12;
    } else t12 = $[29];
    let t13;
    if ($[30] !== label || $[31] !== t10 || $[32] !== t11 || $[33] !== t12) {
        t13 = [
            label,
            t10,
            t11,
            t12
        ];
        $[30] = label;
        $[31] = t10;
        $[32] = t11;
        $[33] = t12;
        $[34] = t13;
    } else t13 = $[34];
    let t14;
    if ($[35] !== integrationKey || $[36] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: t13
        });
        $[35] = integrationKey;
        $[36] = t13;
        $[37] = t14;
    } else t14 = $[37];
    let t15;
    if ($[38] !== title) {
        t15 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title);
        $[38] = title;
        $[39] = t15;
    } else t15 = $[39];
    let t16;
    if ($[40] !== cloudId || $[41] !== icon || $[42] !== messageDescription || $[43] !== partial || $[44] !== position || $[45] !== primaryProduct || $[46] !== t14 || $[47] !== t15 || $[48] !== url) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: t7,
            icon: icon,
            description: t8,
            headerMetadata: t14,
            title: t15,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[40] = cloudId;
        $[41] = icon;
        $[42] = messageDescription;
        $[43] = partial;
        $[44] = position;
        $[45] = primaryProduct;
        $[46] = t14;
        $[47] = t15;
        $[48] = url;
        $[49] = t16;
    } else t16 = $[49];
    return t16;
} : ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, entity: entity } = partial;
    const { author: author, container: container } = entity || {};
    const label = formatMessage((0, $b445df02919fcc5f$export$defe85febe8b728c).resultLabel);
    const integrationKey = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    let messageDescription;
    if (author?.user) messageDescription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.025",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c900a01b74c1545$export$e2255cf6045e8d47), {
        name: author.user.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerpt, true, `${author.user.name}: `)));
    else messageDescription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerpt, true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: messageDescription,
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: [
                label,
                [
                    'repository-name',
                    container?.name ?? null
                ],
                [
                    'padlock',
                    padlockIcon
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ]
            ]
        }),
        title: (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};
























var $303LV = parcelRequire("303LV");




function $6aca57325ae7c660$export$7e4bcd4afb389edb(markdown) {
    if (!markdown) return ''; // Handle the case where markdown is null or undefined
    // Convert headers to plain text
    markdown = markdown.replace(/^#+\s*(.+?)\s*$/gm, '$1');
    // Convert bold and italic text to plain text
    markdown = markdown.replace(/\*\*(.+?)\*\*/g, '$1');
    markdown = markdown.replace(/__(.+?)__/g, '$1');
    markdown = markdown.replace(/\*(.+?)\*/g, '$1');
    markdown = markdown.replace(/_(.+?)_/g, '$1');
    // Convert strikethrough text to plain text
    markdown = markdown.replace(/~~(.+?)~~/g, '$1');
    // Convert inline code to plain text
    markdown = markdown.replace(/`(.+?)`/g, '$1');
    // Remove code blocks
    markdown = markdown.replace(/```[\s\S]*?/g, '');
    // Convert links to plain text by keeping only the link text
    markdown = markdown.replace(/\[(.+?)\]\((.+?)\)/g, '$1');
    // Convert autolinks to plain text
    markdown = markdown.replace(/<(?![@#]|!.*>)([^>|\s]+)>/g, '$1');
    // Handle autolinks with display text, like <http://example.com|example.com>
    markdown = markdown.replace(/<([^|>]+)\|([^>]+)>/g, '$2');
    // Fix broken autolinks
    markdown = markdown.replace(/<(?![@#]|!.*>)([^>|\s]+)>?/g, '$1');
    // Remove images, keeping only the alt text
    markdown = markdown.replace(/!\[(.+?)\]\((.+?)\)/g, '$1');
    // Remove blockquotes, preserving the quoted text
    markdown = markdown.replace(/^\s*>\s+(.+?)\s*$/gm, '$1');
    // Preserve list items as plain text, removing the list markers
    markdown = markdown.replace(/^\s*[\*\+-]\s+(.+?)\s*$/gm, '$1');
    markdown = markdown.replace(/^\s*\d+\.\s+(.+?)\s*$/gm, '$1');
    // Remove horizontal lines
    markdown = markdown.replace(/^\s*[-*_]{3,}\s*$/gm, '');
    // Replace multiple newlines with a single newline
    markdown = markdown.replace(/\n\s*\n/g, '\n');
    return markdown.trim();
}














const $a8033ec9c58f5562$var$SPACE = ' ';
const $a8033ec9c58f5562$var$channelStyle = null;
const $a8033ec9c58f5562$export$cfdacaa37f9b4dd7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, associations: associations } = t0;
    const channelId = children?.[0];
    let t1;
    if ($[0] !== associations || $[1] !== channelId) {
        t1 = associations?.filter($a8033ec9c58f5562$var$_temp).find((edge_0)=>Boolean(channelId) && channelId === edge_0.node.entity.channelId);
        $[0] = associations;
        $[1] = channelId;
        $[2] = t1;
    } else t1 = $[2];
    const channelAssociation = t1;
    if (!channelAssociation) return null;
    const entity = channelAssociation?.node?.entity;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_1ANEUSLRg7"
        ]);
        $[3] = t2;
    } else t2 = $[3];
    const t3 = entity?.displayName || channelAssociation?.node?.title;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t2
        }, $a8033ec9c58f5562$var$SPACE, "#", t3);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ children: children, associations: associations })=>{
    const channelId = children?.[0];
    const channelAssociation = associations?.filter((edge)=>edge?.node?.entity?.__typename === 'ExternalConversation').find((edge_0)=>Boolean(channelId) && channelId === edge_0.node.entity.channelId);
    if (!channelAssociation) return null;
    const entity = channelAssociation?.node?.entity;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1ANEUSLRg7"
        ])
    }, $a8033ec9c58f5562$var$SPACE, "#", entity?.displayName || channelAssociation?.node?.title);
};
function $a8033ec9c58f5562$var$_temp(edge) {
    return edge?.node?.entity?.__typename === "ExternalConversation";
}

















const $50831a03fb944502$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    externalPersonLabel: {
        id: "search-result.user-mention.external-person",
        defaultMessage: "External person"
    }
});


const $93b40b80bb25b258$var$SPACE = ' ';
const $93b40b80bb25b258$export$e891316fea657d90 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ $cozmU.createElement("span", null, $93b40b80bb25b258$var$SPACE, "@", children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", null, $93b40b80bb25b258$var$SPACE, "@", children);
};
const $93b40b80bb25b258$export$85d6e42a90e882cb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, associations: associations } = t0;
    const channelId = children?.[0];
    let t1;
    if ($[0] !== associations || $[1] !== channelId) {
        t1 = associations?.find((edge)=>Boolean(channelId) && channelId === edge?.node?.entity?.externalId);
        $[0] = associations;
        $[1] = channelId;
        $[2] = t1;
    } else t1 = $[2];
    const userAssociation = t1;
    let t2;
    if ($[3] !== userAssociation?.node?.entity?.name) {
        t2 = userAssociation?.node?.entity?.name || /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $50831a03fb944502$export$defe85febe8b728c).externalPersonLabel);
        $[3] = userAssociation?.node?.entity?.name;
        $[4] = t2;
    } else t2 = $[4];
    const name = t2;
    if (!name) return null;
    let t3;
    if ($[5] !== name) {
        t3 = /*#__PURE__*/ $cozmU.createElement($93b40b80bb25b258$export$e891316fea657d90, null, name);
        $[5] = name;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, associations: associations })=>{
    const channelId = children?.[0];
    const userAssociation = associations?.find((edge)=>Boolean(channelId) && channelId === edge?.node?.entity?.externalId);
    const name = userAssociation?.node?.entity?.name || /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $50831a03fb944502$export$defe85febe8b728c).externalPersonLabel);
    if (!name) return null;
    return /*#__PURE__*/ $cozmU.createElement($93b40b80bb25b258$export$e891316fea657d90, null, name);
};


const $5a8e4d80f88463b7$var$SPACE = ' ';
const $5a8e4d80f88463b7$export$95e34c5d2bf14b09 = (inputString)=>{
    if (!inputString) return '';
    return (0, $6aca57325ae7c660$export$7e4bcd4afb389edb)(inputString) //Slack User
    .replace(/<@(\w+)>/g, '<Mention>$1</Mention>') //Teams User
    .replace(/<@([a-zA-Z0-9-]+)>/g, '<Mention>$1</Mention>') //Slack Channel
    .replace(/<#(\w+)\|?>/g, '<Channel>$1</Channel>') //Teams Channel variation 1
    .replace(/<#teamId\/[a-f0-9-]+\/channelId\/teamId\/([a-f0-9-]+)\/channelId\/([0-9a-zA-Z:@._-]+)>/g, '<Channel>teamId/$1/channelId/$2</Channel>') // Teams Channel variation 2
    .replace(/<[@#]teamId\/([a-f0-9-]+)\/channelId\/([0-9a-zA-Z:@._-]+)>/g, '<Channel>teamId/$1/channelId/$2</Channel>').replace(/<\!subteam\^(\w+)>/g, '<Subteam>$1</Subteam>').replace(/<\!(\w+)>/g, '<Alias>$1</Alias>') // emojis, works for those that have repeating pattern as well. eg: :word-word-word:
    .replace(/:((@@@hl@@@.+?@@@endhl@@@)(-@@@hl@@@.+?@@@endhl@@@)*):/g, (match)=>{
        const words = match.match(/@@@hl@@@(.+?)@@@endhl@@@/g)?.map((m)=>m.replace(/@@@hl@@@|@@@endhl@@@/g, '')) || [];
        return `<Highlight>:${words.join('-')}:</Highlight>`;
    }).replace(/@@@hl@@@(.+?)@@@endhl@@@/g, '<Highlight>$1</Highlight>').replace(/<@<Highlight>(.+?)<\/Highlight>>/g, '<Highlight><Mention>$1</Mention></Highlight>').replace(/<#<Highlight>(.+?)<\/Highlight>\|>/g, '<Highlight><Channel>$1</Channel></Highlight>');
// .replace(/\:(\w+)\:/g, '<Emoji>$1</Emoji>') Support for emojis coming soon
};
const $5a8e4d80f88463b7$var$PlainText = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, children);
const $5a8e4d80f88463b7$var$Highlight = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "strong"
        }, $5a8e4d80f88463b7$var$SPACE, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "strong"
    }, $5a8e4d80f88463b7$var$SPACE, children); // It is assumed that description is the full message and excerpt is a potentially truncated version
const $5a8e4d80f88463b7$export$bf780c85e04b8810 = (excerpt, description)=>{
    if (excerpt.length === 0 || description.length === 0 || excerpt === description) return excerpt;
    var modifiedExcerpt = excerpt; // regex which has the starting tag of a mention, but not the end
    const startTagRegex = /<[@#][^> ]*$/g;
    const startTagMatch = modifiedExcerpt.match(startTagRegex);
    if (startTagMatch) {
        // theoretically, there should only be one match at max
        const partialMention = startTagMatch[startTagMatch.length - 1]; // the partialMention can appear several times in the string. We need to find the correct one
        const partialMentionInExcerptCount = excerpt.split(partialMention).length - 1;
        const splitDescription = description.split(partialMention); // check if partial mention is found in description
        if (splitDescription.length >= 2) {
            const splitByClosingTag = splitDescription[partialMentionInExcerptCount].split('>'); // check if closing tag is found
            if (splitByClosingTag.length >= 2) {
                const restOfString = splitByClosingTag[0];
                modifiedExcerpt = modifiedExcerpt + restOfString + '>';
            }
        }
    } // const endTagRegex = /^[^< ]*\.tacv2>/g; This works on channel mentions that I have observed
    // weaker regex which tries to capture the ending tag of a mention (assuming it always ends with >), but not the start
    const weakEndTagRegex = /^[^< ]*>/g;
    const weakEndTagMatch = modifiedExcerpt.match(weakEndTagRegex);
    if (weakEndTagMatch) {
        // theoretically, there should only be one match at max
        const partialMention = weakEndTagMatch[0];
        const splitDescription = description.split(partialMention); // partialMention not found in description
        if (splitDescription.length >= 2) {
            const splitByOpeningTag = splitDescription[0].split('<'); // opening tag found
            if (splitByOpeningTag.length >= 2) {
                const restOfString = splitByOpeningTag[splitByOpeningTag.length - 1];
                modifiedExcerpt = '<' + restOfString + modifiedExcerpt;
            }
        }
    }
    return modifiedExcerpt;
};
const $5a8e4d80f88463b7$export$36e783c4ff07cd7c = ({ partial: partial })=>{
    // in ConversationSearchResult, partial.excerpt is used as the body
    if (partial.excerpt) partial.excerpt = $5a8e4d80f88463b7$export$bf780c85e04b8810(partial.excerpt, partial?.entity?.description ?? '');
    const body = partial.excerpt || partial?.entity?.description || ''; /**
                                                                       * Event hough we remove markdown from the body, we still use this component
                                                                       * to render mentions and highlighted text */ 
    return /*#__PURE__*/ $cozmU.createElement((0, $303LV.default), {
        options: {
            forceInline: true,
            overrides: {
                a: $5a8e4d80f88463b7$var$PlainText,
                Highlight: $5a8e4d80f88463b7$var$Highlight,
                Alias: (0, $93b40b80bb25b258$export$e891316fea657d90),
                Mention: {
                    component: (0, $93b40b80bb25b258$export$85d6e42a90e882cb),
                    props: {
                        associations: partial?.entity?.associatedWith?.edges
                    }
                },
                Channel: {
                    component: (0, $a8033ec9c58f5562$export$cfdacaa37f9b4dd7),
                    props: {
                        associations: partial?.entity?.associatedWith?.edges
                    }
                }
            }
        }
    }, $5a8e4d80f88463b7$export$95e34c5d2bf14b09(body));
};








const $44b8679eb5c4147e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    label: {
        id: "search-page.results.product-results.third-party.conversation-search-result.label",
        defaultMessage: "Channel"
    },
    memberCount: {
        id: "search-page.results.product-results.third-party.conversation-search-result.member-count",
        defaultMessage: "{count, plural, one {# member} other {# members}}"
    },
    lastActive: {
        id: "search-page.results.product-results.third-party.conversation-search-result.time-since-label",
        defaultMessage: "Last active {formattedDate}"
    },
    unknownChannel: {
        id: "search-page.results.product-results.third-party.conversation-search-result.unknown-channel",
        defaultMessage: "unknown-channel"
    }
});


const $88e604f7a5fc15eb$export$4534f971846d5b0b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { partial: partial, icon: icon, position: position, integrationKey: integrationKey, cloudId: cloudId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { entity: entity, url: url } = partial;
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const memberCount = entity?.memberCount || entity?.members?.length;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "label",
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $44b8679eb5c4147e$export$a7357cdd1f0b0168).label)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== memberCount) {
        t2 = memberCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $44b8679eb5c4147e$export$a7357cdd1f0b0168).memberCount,
            values: {
                count: memberCount
            }
        });
        $[1] = memberCount;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = [
            t1,
            [
                "memberCount",
                t2
            ]
        ];
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const parts = t3;
    let t4;
    if ($[5] !== partial) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a8e4d80f88463b7$export$36e783c4ff07cd7c), {
            partial: partial
        });
        $[5] = partial;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== integrationKey || $[8] !== parts) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: parts
        });
        $[7] = integrationKey;
        $[8] = parts;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== entity?.displayName || $[11] !== formatMessage) {
        t6 = entity?.displayName || formatMessage((0, $44b8679eb5c4147e$export$a7357cdd1f0b0168).unknownChannel);
        $[10] = entity?.displayName;
        $[11] = formatMessage;
        $[12] = t6;
    } else t6 = $[12];
    const t7 = `#${t6}`;
    let t8;
    if ($[13] !== cloudId || $[14] !== icon || $[15] !== partial || $[16] !== position || $[17] !== primaryProduct || $[18] !== t4 || $[19] !== t5 || $[20] !== t7 || $[21] !== url) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: partial.id,
            description: t4,
            icon: icon,
            headerMetadata: t5,
            title: t7,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[13] = cloudId;
        $[14] = icon;
        $[15] = partial;
        $[16] = position;
        $[17] = primaryProduct;
        $[18] = t4;
        $[19] = t5;
        $[20] = t7;
        $[21] = url;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ partial: partial, icon: icon, position: position, integrationKey: integrationKey, cloudId: cloudId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { entity: entity, url: url } = partial;
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const memberCount = entity?.memberCount || entity?.members?.length;
    const parts = [
        [
            'label',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $44b8679eb5c4147e$export$a7357cdd1f0b0168).label)
        ],
        [
            'memberCount',
            memberCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $44b8679eb5c4147e$export$a7357cdd1f0b0168).memberCount,
                values: {
                    count: memberCount
                }
            })
        ]
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a8e4d80f88463b7$export$36e783c4ff07cd7c), {
            partial: partial
        }),
        icon: icon,
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: parts
        }),
        title: `#${entity?.displayName || formatMessage((0, $44b8679eb5c4147e$export$a7357cdd1f0b0168).unknownChannel)}`,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};




































var $iDrrr = parcelRequire("iDrrr");














const $f4f82836100bc8ab$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    restrictedLabel: {
        id: "search-page.results.restricted-result-label",
        defaultMessage: "Restricted"
    },
    restrictedTooltip: {
        id: "search-page.results.restricted-result-tooltip",
        defaultMessage: "Only visible to specific people"
    },
    privateLabel: {
        id: "search-page.results.private-result-label",
        defaultMessage: "Private"
    },
    privateTooltip: {
        id: "search-page.results.private-result-tooltip",
        defaultMessage: "Only visible to you"
    }
});


const $a550cfb7414ffd45$var$container = (0, $buxP3.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'space.050',
    backgroundColor: 'color.background.neutral',
    paddingLeft: 'space.100',
    paddingRight: 'space.150',
    // different to paddingLeft for visual balance
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    borderRadius: 'radius.small',
    cursor: 'default' // so that it doesn't change to the text-selecting looking one
});
const $a550cfb7414ffd45$var$iconColor = "var(--ds-icon, #292A2E)";
const $a550cfb7414ffd45$export$3aad690c5eb10b93 = 'restricted-lozenge';
const $a550cfb7414ffd45$export$3eac322cb0b365da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { restriction: restriction } = t0;
    const label = restriction === "private" ? (0, $f4f82836100bc8ab$export$defe85febe8b728c).privateLabel : (0, $f4f82836100bc8ab$export$defe85febe8b728c).restrictedLabel;
    const tooltipText = restriction === "private" ? (0, $f4f82836100bc8ab$export$defe85febe8b728c).privateTooltip : (0, $f4f82836100bc8ab$export$defe85febe8b728c).restrictedTooltip;
    if ((0, $iDrrr.fg)("confluence_fronend_labels_categorization_migration")) {
        let t1;
        if ($[0] !== tooltipText) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipText);
            $[0] = tooltipText;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== label) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                appearance: "neutral",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4efpo))),
                testId: $a550cfb7414ffd45$export$3aad690c5eb10b93
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label));
            $[2] = label;
            $[3] = t2;
        } else t2 = $[3];
        let t3;
        if ($[4] !== t1 || $[5] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: t1
            }, t2);
            $[4] = t1;
            $[5] = t2;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    let t1;
    if ($[7] !== tooltipText) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipText);
        $[7] = tooltipText;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
            label: "",
            color: $a550cfb7414ffd45$var$iconColor,
            size: "small"
        });
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== label) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $a550cfb7414ffd45$var$container,
            testId: $a550cfb7414ffd45$export$3aad690c5eb10b93
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)));
        $[10] = label;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== t1 || $[13] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1
        }, t3);
        $[12] = t1;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ restriction: restriction })=>{
    const label = restriction === 'private' ? (0, $f4f82836100bc8ab$export$defe85febe8b728c).privateLabel : (0, $f4f82836100bc8ab$export$defe85febe8b728c).restrictedLabel;
    const tooltipText = restriction === 'private' ? (0, $f4f82836100bc8ab$export$defe85febe8b728c).privateTooltip : (0, $f4f82836100bc8ab$export$defe85febe8b728c).restrictedTooltip;
    if ((0, $iDrrr.fg)('confluence_fronend_labels_categorization_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "neutral",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4efpo))),
        testId: $a550cfb7414ffd45$export$3aad690c5eb10b93
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $a550cfb7414ffd45$var$container,
        testId: $a550cfb7414ffd45$export$3aad690c5eb10b93
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        label: "",
        color: $a550cfb7414ffd45$var$iconColor,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label))));
};






const $ad3393f69a26b05b$var$footerContainer = (0, $buxP3.xcss)({
    paddingTop: 'space.100'
});
const $ad3393f69a26b05b$var$typeLabelContainer = (0, $buxP3.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $ad3393f69a26b05b$var$getLabel = (entityNoun)=>entityNoun.replace(/-/g, ' ');
const $ad3393f69a26b05b$export$2917a391c04f0e93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { icon: icon, partial: partial, position: position, resultAri: resultAri, integrationKey: integrationKey } = t0;
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = partial;
    let t2;
    if ($[0] !== lastModifiedDate) {
        t2 = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        }) : null;
        $[0] = lastModifiedDate;
        $[1] = t2;
    } else t2 = $[1];
    const lastModifiedComponent = t2;
    let t3;
    if ($[2] !== resultAri.resourceType) {
        t3 = $ad3393f69a26b05b$var$getLabel(resultAri.resourceType);
        $[2] = resultAri.resourceType;
        $[3] = t3;
    } else t3 = $[3];
    const label = t3;
    let t4;
    if ($[4] !== permissionLevel) {
        t4 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel);
        $[4] = permissionLevel;
        $[5] = t4;
    } else t4 = $[5];
    const isNotPublic = t4;
    const t5 = partial.id;
    let t6;
    if ($[6] !== excerpt) {
        t6 = (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerpt);
        $[6] = excerpt;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== label) {
        t7 = [
            "label",
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $ad3393f69a26b05b$var$typeLabelContainer
            }, label)
        ];
        $[8] = label;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== lastModifiedComponent) {
        t8 = [
            "last-modified",
            lastModifiedComponent
        ];
        $[10] = lastModifiedComponent;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== t7 || $[13] !== t8) {
        t9 = [
            t7,
            t8
        ];
        $[12] = t7;
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== integrationKey || $[16] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            productSelected: true,
            product: integrationKey,
            parts: t9
        });
        $[15] = integrationKey;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== isNotPublic || $[19] !== permissionLevel) {
        t11 = isNotPublic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $ad3393f69a26b05b$var$footerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a550cfb7414ffd45$export$3eac322cb0b365da), {
            restriction: permissionLevel
        }));
        $[18] = isNotPublic;
        $[19] = permissionLevel;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== title) {
        t12 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title);
        $[21] = title;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== cloudId || $[24] !== icon || $[25] !== partial || $[26] !== position || $[27] !== primaryProduct || $[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t6 || $[32] !== url) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: t5,
            description: t6,
            icon: icon,
            headerMetadata: t10,
            footer: t11,
            title: t12,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[23] = cloudId;
        $[24] = icon;
        $[25] = partial;
        $[26] = position;
        $[27] = primaryProduct;
        $[28] = t10;
        $[29] = t11;
        $[30] = t12;
        $[31] = t6;
        $[32] = url;
        $[33] = t13;
    } else t13 = $[33];
    return t13;
} : ({ icon: icon, partial: partial, position: position, resultAri: resultAri, integrationKey: integrationKey })=>{
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = partial;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = $ad3393f69a26b05b$var$getLabel(resultAri.resourceType);
    const isNotPublic = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        description: (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerpt),
        icon: icon,
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            productSelected: true,
            product: integrationKey,
            parts: [
                [
                    'label',
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                        xcss: $ad3393f69a26b05b$var$typeLabelContainer
                    }, label)
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ]
            ]
        }),
        footer: isNotPublic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $ad3393f69a26b05b$var$footerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a550cfb7414ffd45$export$3eac322cb0b365da), {
            restriction: permissionLevel
        })),
        title: (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};



































const $ea6fdf0fd2edb51a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    designLabel: {
        id: "dynamic-cards-search-page.design-search-result.label",
        defaultMessage: "Design"
    }
});


const $6ae16e5f1b27f4f3$var$thumbnailContainerStyles = (0, $buxP3.xcss)({
    gridArea: 'body'
});
const $6ae16e5f1b27f4f3$var$thumbnailImageStyles = null;
const $6ae16e5f1b27f4f3$var$descriptionLinkStyles = (0, $buxP3.xcss)({
    display: 'inline-block'
});
const $6ae16e5f1b27f4f3$export$f6a73210de3b9a3b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { partial: partial, position: position, icon: icon } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    let t2;
    if ($[0] !== partial.integrationId) {
        t2 = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
        $[0] = partial.integrationId;
        $[1] = t2;
    } else t2 = $[1];
    const integrationKey = t2;
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, title: title } = partial;
    const thumbnailUrl = entity?.thumbnail?.externalUrl;
    let t3;
    if ($[2] !== lastModifiedDate) {
        t3 = lastModifiedDate ? /*#__PURE__*/ $cozmU.createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        }) : null;
        $[2] = lastModifiedDate;
        $[3] = t3;
    } else t3 = $[3];
    const lastModifiedComponent = t3;
    let t4;
    if ($[4] !== formatMessage) {
        t4 = formatMessage((0, $ea6fdf0fd2edb51a$export$defe85febe8b728c).designLabel);
        $[4] = formatMessage;
        $[5] = t4;
    } else t4 = $[5];
    const label = t4;
    let t5;
    if ($[6] !== thumbnailUrl || $[7] !== url) {
        t5 = !thumbnailUrl || (0, $8a1a5c2af543b4cc$export$c32a8291d21fb086)(thumbnailUrl) ? null : /*#__PURE__*/ $cozmU.createElement((0, $l8Rhq.Anchor), {
            xcss: [
                $6ae16e5f1b27f4f3$var$descriptionLinkStyles
            ],
            rel: "noreferrer",
            target: "_blank",
            href: url
        }, /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            testId: "thumbnail-container",
            xcss: $6ae16e5f1b27f4f3$var$thumbnailContainerStyles
        }, /*#__PURE__*/ $cozmU.createElement("img", {
            src: thumbnailUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_0bjKvDKTcp _2V7sgO2M4S _3hxITi6wH8 _3vBAKHot27 _00EA0eiObl _0jFU0VUzl5 _39xV02GNMc"
            ])
        })));
        $[6] = thumbnailUrl;
        $[7] = url;
        $[8] = t5;
    } else t5 = $[8];
    const body = t5;
    let t6;
    if ($[9] !== permissionLevel) {
        t6 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ $cozmU.createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
            permissionLevel: permissionLevel
        }) : null;
        $[9] = permissionLevel;
        $[10] = t6;
    } else t6 = $[10];
    const padlockIcon = t6;
    const t7 = partial.id;
    const t8 = !!selectedProduct;
    let t9;
    if ($[11] !== lastModifiedComponent) {
        t9 = [
            "last-modified",
            lastModifiedComponent
        ];
        $[11] = lastModifiedComponent;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== padlockIcon) {
        t10 = [
            "padlock",
            padlockIcon
        ];
        $[13] = padlockIcon;
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== label || $[16] !== t10 || $[17] !== t9) {
        t11 = [
            label,
            t9,
            t10
        ];
        $[15] = label;
        $[16] = t10;
        $[17] = t9;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== integrationKey || $[20] !== t11 || $[21] !== t8) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: t8,
            parts: t11
        });
        $[19] = integrationKey;
        $[20] = t11;
        $[21] = t8;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== title) {
        t13 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title);
        $[23] = title;
        $[24] = t13;
    } else t13 = $[24];
    let t14;
    if ($[25] !== body || $[26] !== cloudId || $[27] !== icon || $[28] !== partial || $[29] !== position || $[30] !== primaryProduct || $[31] !== t12 || $[32] !== t13 || $[33] !== url) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: t7,
            icon: icon,
            description: body,
            headerMetadata: t12,
            title: t13,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[25] = body;
        $[26] = cloudId;
        $[27] = icon;
        $[28] = partial;
        $[29] = position;
        $[30] = primaryProduct;
        $[31] = t12;
        $[32] = t13;
        $[33] = url;
        $[34] = t14;
    } else t14 = $[34];
    return t14;
} : ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const integrationKey = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, title: title } = partial;
    const thumbnailUrl = entity?.thumbnail?.externalUrl;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ $cozmU.createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = formatMessage((0, $ea6fdf0fd2edb51a$export$defe85febe8b728c).designLabel);
    const body = !thumbnailUrl || (0, $8a1a5c2af543b4cc$export$c32a8291d21fb086)(thumbnailUrl) ? null : /*#__PURE__*/ $cozmU.createElement((0, $l8Rhq.Anchor), {
        xcss: [
            $6ae16e5f1b27f4f3$var$descriptionLinkStyles
        ],
        rel: 'noreferrer',
        target: '_blank',
        href: url
    }, /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        testId: "thumbnail-container",
        xcss: $6ae16e5f1b27f4f3$var$thumbnailContainerStyles
    }, /*#__PURE__*/ $cozmU.createElement("img", {
        src: thumbnailUrl,
        alt: "",
        className: (0, $hekY6.default)([
            "_0bjKvDKTcp _2V7sgO2M4S _3hxITi6wH8 _3vBAKHot27 _00EA0eiObl _0jFU0VUzl5 _39xV02GNMc"
        ])
    })));
    const padlockIcon = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ $cozmU.createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    return /*#__PURE__*/ $cozmU.createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: body,
        headerMetadata: /*#__PURE__*/ $cozmU.createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: !!selectedProduct,
            parts: [
                label,
                [
                    'last-modified',
                    lastModifiedComponent
                ],
                [
                    'padlock',
                    padlockIcon
                ]
            ]
        }),
        title: (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};






































const $a37fab90c8280e67$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    googleDocsLabel: {
        id: "dynamic-cards-search-page.document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "dynamic-cards-search-page.document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "dynamic-cards-search-page.document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "dynamic-cards-search-page.document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "dynamic-cards-search-page.document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "dynamic-cards-search-page.document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    }
});


const $328556d5016888fe$var$footerContainer = (0, $buxP3.xcss)({
    paddingTop: 'space.100'
});
const $328556d5016888fe$var$contentIconStyles = null;
const $328556d5016888fe$var$outerContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.100',
    maxWidth: '246px' // Specified in the design
});
const $328556d5016888fe$var$parentNameStyles = (0, $buxP3.xcss)({
    display: 'inline-block',
    overflow: 'hidden',
    font: 'font.body',
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $328556d5016888fe$var$typeLabelContainer = (0, $buxP3.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $328556d5016888fe$var$GOOGLE_INTEGRATION_KEY = 'google';
const $328556d5016888fe$var$MICROSOFT_INTEGRATION_KEY = 'microsoft';
const $328556d5016888fe$var$SUBTYPE_DOCUMENT = 'document';
const $328556d5016888fe$var$SUBTYPE_PRESENTATION = 'presentation';
const $328556d5016888fe$var$SUBTYPE_SPREADSHEET = 'spreadsheet';
const $328556d5016888fe$var$GOOGLE_LABELS = {
    [$328556d5016888fe$var$SUBTYPE_DOCUMENT]: (0, $a37fab90c8280e67$export$defe85febe8b728c).googleDocsLabel,
    [$328556d5016888fe$var$SUBTYPE_PRESENTATION]: (0, $a37fab90c8280e67$export$defe85febe8b728c).googleSlidesLabel,
    [$328556d5016888fe$var$SUBTYPE_SPREADSHEET]: (0, $a37fab90c8280e67$export$defe85febe8b728c).googleSheetsLabel
};
const $328556d5016888fe$var$MICROSOFT_LABELS = {
    [$328556d5016888fe$var$SUBTYPE_DOCUMENT]: (0, $a37fab90c8280e67$export$defe85febe8b728c).msWordLabel,
    [$328556d5016888fe$var$SUBTYPE_PRESENTATION]: (0, $a37fab90c8280e67$export$defe85febe8b728c).msPowerpointLabel,
    [$328556d5016888fe$var$SUBTYPE_SPREADSHEET]: (0, $a37fab90c8280e67$export$defe85febe8b728c).msExcelLabel
};
const $328556d5016888fe$var$getDocumentSubtypeLabel = ({ integrationKey: integrationKey, subtype: subtype })=>{
    if (!subtype) return;
    let label;
    if (integrationKey === $328556d5016888fe$var$GOOGLE_INTEGRATION_KEY) label = $328556d5016888fe$var$GOOGLE_LABELS[subtype];
    if (integrationKey === $328556d5016888fe$var$MICROSOFT_INTEGRATION_KEY) label = $328556d5016888fe$var$MICROSOFT_LABELS[subtype];
    return label;
};
const $328556d5016888fe$var$getParentName = (partial)=>{
    const parentName = partial.entity?.parent?.displayName;
    if (!parentName) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $kz1Yj.Inline), {
        xcss: $328556d5016888fe$var$outerContainerStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $kz1Yj.Inline), {
        xcss: $328556d5016888fe$var$parentNameStyles
    }, parentName));
};
const $328556d5016888fe$export$43fa1bdcdc4d31ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { icon: icon, partial: partial, position: position, integrationKey: integrationKey } = t0;
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled } = t1;
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, subtype: subtype, entity: entity } = partial;
    let t2;
    if ($[0] !== entity || $[1] !== icon) {
        t2 = entity?.type?.iconUrl ? /*#__PURE__*/ $cozmU.createElement("img", {
            src: entity.type.iconUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV02Va5s _0jFU0VVa5s _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX _24h04i2Njc _00EA0egIor"
            ])
        }) : icon;
        $[0] = entity;
        $[1] = icon;
        $[2] = t2;
    } else t2 = $[2];
    const contentIcon = t2;
    const product = integrationKey;
    let t3;
    if ($[3] !== integrationKey || $[4] !== subtype) {
        t3 = $328556d5016888fe$var$getDocumentSubtypeLabel({
            integrationKey: integrationKey,
            subtype: subtype
        });
        $[3] = integrationKey;
        $[4] = subtype;
        $[5] = t3;
    } else t3 = $[5];
    const label = t3;
    let t4;
    if ($[6] !== permissionLevel) {
        t4 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel);
        $[6] = permissionLevel;
        $[7] = t4;
    } else t4 = $[7];
    const isNotPublic = t4;
    const shouldShowLastModified = lastModifiedDate && integrationKey !== "atlassian-web-crawler";
    let t5;
    if ($[8] !== label || $[9] !== subtype) {
        t5 = label ? /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $328556d5016888fe$var$typeLabelContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), label)) : subtype ? /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $328556d5016888fe$var$typeLabelContainer
        }, subtype?.replace(/-/g, " ")) : null;
        $[8] = label;
        $[9] = subtype;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t5) {
        t6 = [
            "label",
            t5
        ];
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== partial) {
        t7 = $328556d5016888fe$var$getParentName(partial);
        $[13] = partial;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== t7) {
        t8 = [
            "parentName",
            t7
        ];
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== lastModifiedDate || $[18] !== shouldShowLastModified) {
        t9 = shouldShowLastModified && /*#__PURE__*/ $cozmU.createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        });
        $[17] = lastModifiedDate;
        $[18] = shouldShowLastModified;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== t9) {
        t10 = [
            "lastModified",
            t9
        ];
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t6 || $[24] !== t8) {
        t11 = [
            t6,
            t8,
            t10
        ];
        $[22] = t10;
        $[23] = t6;
        $[24] = t8;
        $[25] = t11;
    } else t11 = $[25];
    const metadataParts = t11;
    const t12 = partial.id;
    let t13;
    if ($[26] !== excerpt) {
        t13 = (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerpt);
        $[26] = excerpt;
        $[27] = t13;
    } else t13 = $[27];
    const t14 = !!selectedProduct;
    let t15;
    if ($[28] !== metadataParts || $[29] !== product || $[30] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: t14,
            parts: metadataParts
        });
        $[28] = metadataParts;
        $[29] = product;
        $[30] = t14;
        $[31] = t15;
    } else t15 = $[31];
    let t16;
    if ($[32] !== isNotPublic || $[33] !== permissionLevel) {
        t16 = isNotPublic && /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $328556d5016888fe$var$footerContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $a550cfb7414ffd45$export$3eac322cb0b365da), {
            restriction: permissionLevel
        }));
        $[32] = isNotPublic;
        $[33] = permissionLevel;
        $[34] = t16;
    } else t16 = $[34];
    let t17;
    if ($[35] !== title) {
        t17 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title);
        $[35] = title;
        $[36] = t17;
    } else t17 = $[36];
    let t18;
    if ($[37] !== isAdminHubAIEnabled || $[38] !== partial) {
        t18 = (0, $hJYQM.isGoogleDocument)(partial) && isAdminHubAIEnabled;
        $[37] = isAdminHubAIEnabled;
        $[38] = partial;
        $[39] = t18;
    } else t18 = $[39];
    let t19;
    if ($[40] !== cloudId || $[41] !== contentIcon || $[42] !== partial || $[43] !== position || $[44] !== primaryProduct || $[45] !== t13 || $[46] !== t15 || $[47] !== t16 || $[48] !== t17 || $[49] !== t18 || $[50] !== url) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: t12,
            description: t13,
            icon: contentIcon,
            headerMetadata: t15,
            footer: t16,
            title: t17,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial,
            showAISummary: t18
        });
        $[40] = cloudId;
        $[41] = contentIcon;
        $[42] = partial;
        $[43] = position;
        $[44] = primaryProduct;
        $[45] = t13;
        $[46] = t15;
        $[47] = t16;
        $[48] = t17;
        $[49] = t18;
        $[50] = url;
        $[51] = t19;
    } else t19 = $[51];
    return t19;
} : ({ icon: icon, partial: partial, position: position, resultAri: resultAri, integrationKey: integrationKey })=>{
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [{ cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, subtype: subtype, entity: entity } = partial;
    const contentIcon = entity?.type?.iconUrl ? /*#__PURE__*/ $cozmU.createElement("img", {
        src: entity.type.iconUrl,
        alt: "",
        className: (0, $hekY6.default)([
            "_39xV02Va5s _0jFU0VVa5s _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX _24h04i2Njc _00EA0egIor"
        ])
    }) : icon;
    const product = integrationKey;
    const label = $328556d5016888fe$var$getDocumentSubtypeLabel({
        integrationKey: integrationKey,
        subtype: subtype
    });
    const isNotPublic = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel);
    const shouldShowLastModified = lastModifiedDate && integrationKey !== 'atlassian-web-crawler';
    const metadataParts = [
        [
            'label',
            label ? /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
                xcss: $328556d5016888fe$var$typeLabelContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), label)) : subtype ? /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
                xcss: $328556d5016888fe$var$typeLabelContainer
            }, subtype?.replace(/-/g, ' ')) : null
        ],
        [
            'parentName',
            $328556d5016888fe$var$getParentName(partial)
        ],
        [
            'lastModified',
            shouldShowLastModified && /*#__PURE__*/ $cozmU.createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
                lastModified: lastModifiedDate
            })
        ]
    ];
    return /*#__PURE__*/ $cozmU.createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        description: (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerpt),
        icon: contentIcon,
        headerMetadata: /*#__PURE__*/ $cozmU.createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: !!selectedProduct,
            parts: metadataParts
        }),
        footer: isNotPublic && /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $328556d5016888fe$var$footerContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $a550cfb7414ffd45$export$3eac322cb0b365da), {
            restriction: permissionLevel
        })),
        title: (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        showAISummary: (0, $hJYQM.isGoogleDocument)(partial) && isAdminHubAIEnabled
    });
};






































var $gxI48 = parcelRequire("gxI48");


var $kmvdJ = parcelRequire("kmvdJ");








var $6NvYG = parcelRequire("6NvYG");



























const $ed1d3c4f664e94fa$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    attachedDateLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.attached-date.label",
        defaultMessage: "Attached {formattedDate}"
    },
    expandLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.expand.label",
        defaultMessage: "Expand"
    },
    attachmentLabel: {
        id: "dynamic-cards-search-page.search-result.attachment-label",
        defaultMessage: "Attachment"
    },
    pdfLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.pdf-label",
        defaultMessage: "PDF"
    },
    videoLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.video-label",
        defaultMessage: "Video"
    },
    imageLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.image-label",
        defaultMessage: "Image"
    },
    audioLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.audio-label",
        defaultMessage: "Audio"
    }
});


const $bfab777519380dff$var$footerContainer = (0, $buxP3.xcss)({
    paddingTop: 'space.100',
    position: 'relative'
});
const $bfab777519380dff$var$dropdownItemStyles = (0, $buxP3.xcss)({
    display: 'flex',
    columnGap: 'space.100',
    paddingBlock: 'space.050',
    marginTop: 'space.100'
});
const $bfab777519380dff$var$attachmentStyles = (0, $buxP3.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $bfab777519380dff$var$mimeTypeToIcon = (mimeType)=>{
    if (!mimeType) return 0, (/*@__PURE__*/$parcel$interopDefault($gxI48));
    const [type, specificType] = mimeType.split('/');
    if (specificType === 'pdf') return 0, (/*@__PURE__*/$parcel$interopDefault($hMaHH));
    switch(type){
        case 'video':
            return 0, (/*@__PURE__*/$parcel$interopDefault($60Yxm));
        case 'image':
            return 0, (/*@__PURE__*/$parcel$interopDefault($6NvYG));
        case 'audio':
            return 0, (/*@__PURE__*/$parcel$interopDefault($kmvdJ));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($gxI48));
    }
};
const $bfab777519380dff$var$mimeTypeToLabel = (mimeType)=>{
    if (!mimeType) return (0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).attachmentLabel;
    const [type, specificType] = mimeType.split('/');
    if (specificType === 'pdf') return (0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).pdfLabel;
    switch(type){
        case 'video':
            return (0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).videoLabel;
        case 'image':
            return (0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).imageLabel;
        case 'audio':
            return (0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).audioLabel;
        default:
            return (0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).attachmentLabel;
    }
};
const $bfab777519380dff$var$DropdownItems = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { attachments: attachments, message: message } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== attachments || $[1] !== formatMessage || $[2] !== message) {
        let t2;
        if ($[4] !== formatMessage || $[5] !== message) {
            t2 = (t3)=>{
                const { title: title, mimeType: mimeType, thumbnailUrl: thumbnailUrl } = t3;
                const Icon = $bfab777519380dff$var$mimeTypeToIcon(mimeType);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
                    xcss: $bfab777519380dff$var$dropdownItemStyles,
                    space: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
                    alignBlock: "center",
                    space: "space.100"
                }, (0, $iDrrr.fg)("confluence_frontend_tile_object_system_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    label: "icon",
                    color: "var(--ds-icon-accent-blue, #357DE8)"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    label: "icon",
                    color: "var(--ds-icon-accent-blue, #357DE8)"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                    size: "medium",
                    color: "color.link",
                    weight: "medium"
                }, thumbnailUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
                    xcss: $bfab777519380dff$var$attachmentStyles,
                    href: thumbnailUrl,
                    rel: "noreferrer",
                    target: "_blank"
                }, title) : title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
                    separator: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                        size: "small"
                    }, "\u2022"),
                    space: "space.075",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                    size: "small"
                }, formatMessage($bfab777519380dff$var$mimeTypeToLabel(mimeType))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                    size: "small",
                    color: "color.text.subtle"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
                    lastModified: message.lastModifiedDate,
                    message: (0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).attachedDateLabel
                }))));
            };
            $[4] = formatMessage;
            $[5] = message;
            $[6] = t2;
        } else t2 = $[6];
        t1 = attachments.map(t2);
        $[0] = attachments;
        $[1] = formatMessage;
        $[2] = message;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, t1);
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ attachments: attachments, message: message })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, attachments.map(({ title: title, mimeType: mimeType, thumbnailUrl: thumbnailUrl })=>{
        const Icon = $bfab777519380dff$var$mimeTypeToIcon(mimeType);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            xcss: $bfab777519380dff$var$dropdownItemStyles,
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, (0, $iDrrr.fg)('confluence_frontend_tile_object_system_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "icon",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "icon",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            size: "medium",
            color: "color.link",
            weight: "medium"
        }, thumbnailUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
            xcss: $bfab777519380dff$var$attachmentStyles,
            href: thumbnailUrl,
            rel: 'noreferrer',
            target: "_blank"
        }, title) : title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            separator: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                size: "small"
            }, "\u2022"),
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            size: "small"
        }, formatMessage($bfab777519380dff$var$mimeTypeToLabel(mimeType))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: message.lastModifiedDate,
            message: (0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).attachedDateLabel
        }))));
    }));
};
const $bfab777519380dff$var$DropdownMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { attachments: attachments, message: message } = t0;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const attachmentWord = `attachment${attachments.length > 1 ? "s" : ""}`;
    const dropdownMessage = `${attachments.length} ${attachmentWord}`;
    let t1;
    if ($[0] !== formatMessage || $[1] !== isExpanded) {
        t1 = isExpanded ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                label: formatMessage((0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).expandLabel),
                size: "small"
            }) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                color: "currentColor",
                label: formatMessage((0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).expandLabel),
                size: "small"
            });
        $[0] = formatMessage;
        $[1] = isExpanded;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== isExpanded) {
        t2 = ()=>setIsExpanded(!isExpanded);
        $[3] = isExpanded;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== dropdownMessage || $[6] !== isExpanded || $[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            iconAfter: t1,
            onClick: t2,
            isSelected: isExpanded
        }, dropdownMessage);
        $[5] = dropdownMessage;
        $[6] = isExpanded;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== attachments || $[11] !== isExpanded || $[12] !== message) {
        t4 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfab777519380dff$var$DropdownItems, {
            attachments: attachments,
            message: message
        });
        $[10] = attachments;
        $[11] = isExpanded;
        $[12] = message;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, t3, t4);
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ attachments: attachments, message: message })=>{
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const attachmentWord = `attachment${attachments.length > 1 ? 's' : ''}`;
    const dropdownMessage = `${attachments.length} ${attachmentWord}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconAfter: isExpanded ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                label: formatMessage((0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).expandLabel),
                size: "small"
            }) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                color: "currentColor",
                label: formatMessage((0, $ed1d3c4f664e94fa$export$a7357cdd1f0b0168).expandLabel),
                size: "small"
            }),
        onClick: ()=>setIsExpanded(!isExpanded),
        isSelected: isExpanded
    }, dropdownMessage), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfab777519380dff$var$DropdownItems, {
        attachments: attachments,
        message: message
    }));
};
const $bfab777519380dff$export$c129802f229d9594 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { attachments: attachments, message: message } = t0;
    if (!attachments || attachments.length === 0) return null;
    let t1;
    if ($[0] !== attachments || $[1] !== message) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $bfab777519380dff$var$footerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfab777519380dff$var$DropdownMenu, {
            attachments: attachments,
            message: message
        }));
        $[0] = attachments;
        $[1] = message;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ attachments: attachments, message: message })=>{
    if (!attachments || attachments.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $bfab777519380dff$var$footerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfab777519380dff$var$DropdownMenu, {
        attachments: attachments,
        message: message
    }));
};





const $f170b0bde2723337$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    threadTypeLabel: {
        id: "dynamic-cards-search-page.search-result.thread-type-label",
        defaultMessage: "Thread"
    },
    messageTypeLabel: {
        id: "dynamic-cards-search-page.search-result.message-type-label",
        defaultMessage: "Message"
    },
    lastActive: {
        id: "dynamic-cards-search-page.search-result.message-last-active",
        defaultMessage: "Last active {formattedDate}"
    },
    attachedDateLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.attached-date.label",
        defaultMessage: "Attached {formattedDate}"
    },
    privateChannelLabel: {
        id: "dynamic-cards-search-page.search-result.private-channel-label",
        defaultMessage: "Private Channel"
    }
});



























const $8ab02b458de6b8d1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    externalPersonLabel: {
        id: "dynamic-cards-search-page.externalPersonLabel",
        defaultMessage: "External person"
    }
});


const $6fbc8cf7696bece3$var$threadItemCSS = (0, $buxP3.xcss)({
    paddingBottom: 'space.050',
    paddingTop: 'space.050'
});
const $6fbc8cf7696bece3$var$nameContainer = (0, $buxP3.xcss)({
    whiteSpace: 'nowrap'
});
const $6fbc8cf7696bece3$export$39a3a4657e687b88 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { partial: partial, components: components } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== partial?.linkedEntities) {
        t1 = partial?.linkedEntities || [];
        $[0] = partial?.linkedEntities;
        $[1] = t1;
    } else t1 = $[1];
    const linkedEntities = t1;
    const { Body: Body } = components;
    let t2;
    if ($[2] !== linkedEntities || $[3] !== partial) {
        t2 = [
            partial,
            ...linkedEntities
        ].slice(0, 3);
        $[2] = linkedEntities;
        $[3] = partial;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== Body || $[6] !== formatMessage || $[7] !== t2) {
        const threadMessages = t2.map((linkedMessage)=>{
            const currentMessageOwnerName = linkedMessage?.entity?.createdBy?.thirdPartyUser?.name || formatMessage((0, $8ab02b458de6b8d1$export$a7357cdd1f0b0168).externalPersonLabel);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $6fbc8cf7696bece3$var$threadItemCSS
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
                key: linkedMessage.id,
                space: "space.025",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c900a01b74c1545$export$e2255cf6045e8d47), {
                name: currentMessageOwnerName
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $6fbc8cf7696bece3$var$nameContainer
            }, currentMessageOwnerName, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                maxLines: 1
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Body, {
                partial: linkedMessage
            }))));
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, threadMessages);
        $[5] = Body;
        $[6] = formatMessage;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ partial: partial, components: components })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const linkedEntities = partial?.linkedEntities || [];
    const { Body: Body } = components;
    const threadMessages = [
        partial,
        ...linkedEntities
    ].slice(0, 3).map((linkedMessage)=>{
        const currentMessageOwnerName = linkedMessage?.entity?.createdBy?.thirdPartyUser?.name || formatMessage((0, $8ab02b458de6b8d1$export$a7357cdd1f0b0168).externalPersonLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $6fbc8cf7696bece3$var$threadItemCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            key: linkedMessage.id,
            space: "space.025",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c900a01b74c1545$export$e2255cf6045e8d47), {
            name: currentMessageOwnerName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $6fbc8cf7696bece3$var$nameContainer
        }, currentMessageOwnerName, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            maxLines: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Body, {
            partial: linkedMessage
        }))));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, threadMessages);
};

















const $9e6aae9f49232115$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    threadTitleWithOthers: {
        id: "dynamic-cards-search-page.search-result.thread-title-wth-others",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules, @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: "\n\t\t\t{contributorCount, plural,\n\t\t\t\t=0 {}\n\t\t\t\t=1 {{name1} in }\n\t\t\t\t=2 {{name1} and {name2} in }\n\t\t\t\t=3 {{name1}, {name2}, and {name3} in }\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in }\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others in }\n\t\t\t}#{channelName}\n\t\t\t"
    },
    groupChatTitle: {
        id: "dynamic-cards-search-page.search-result.thread-title-wth-others",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules, @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: "\n\t\t\t{contributorCount, plural,\n\t\t\t\t=0 {Group message with external users}\n\t\t\t\t=1 {{name1}}\n\t\t\t\t=2 {{name1} and {name2}}\n\t\t\t\t=3 {{name1}, {name2}, and {name3}}\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other}\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others}\n\t\t\t}\n\t\t\t"
    },
    externalPeopleLabel: {
        id: "dynamic-cards-search-page.externalPeopleLabel",
        defaultMessage: "External people #{channelName}"
    },
    externalPersonLabel: {
        id: "dynamic-cards-search-page.externalPersonLabel",
        defaultMessage: "External person"
    },
    unknownChannel: {
        id: "dynamic-cards-search-page.search-result.unknown-channel-in-thread",
        defaultMessage: "unknown-channel"
    }
});


const $796be31b418aa35d$var$USER_DISPLAY_LIMIT = 3;
const $796be31b418aa35d$var$dedupUsers = (userMap, user, index)=>{
    if (!userMap[user.id]) userMap[user.id] = {
        thirdPartyUser: user,
        index: index
    };
    return userMap;
};
const $796be31b418aa35d$var$getTitleMessageValues = (users = [], intl)=>{
    const { formatMessage: formatMessage } = intl;
    const uniqueUsers = users?.filter((thirdPartyUser)=>Boolean(thirdPartyUser?.name))?.reduce($796be31b418aa35d$var$dedupUsers, {});
    const validContributors = Object.values(uniqueUsers).sort((a, b)=>a.index - b.index).map((entry)=>entry?.thirdPartyUser?.name || formatMessage((0, $9e6aae9f49232115$export$a7357cdd1f0b0168).externalPersonLabel)).map((name)=>name?.split(' ')[0]);
    const externalPersonLabel = formatMessage((0, $9e6aae9f49232115$export$a7357cdd1f0b0168).externalPersonLabel);
    const externalPersonCount = validContributors.filter((name)=>name === externalPersonLabel).length;
    let adjustedContributors = validContributors;
    if (externalPersonCount > 1) {
        adjustedContributors = validContributors.filter((name)=>name !== externalPersonLabel);
        adjustedContributors.unshift(formatMessage((0, $9e6aae9f49232115$export$a7357cdd1f0b0168).externalPeopleLabel));
    }
    const contributorCount = adjustedContributors.length;
    const namedContributors = adjustedContributors.slice(0, $796be31b418aa35d$var$USER_DISPLAY_LIMIT);
    const overflowContributorCount = adjustedContributors.slice($796be31b418aa35d$var$USER_DISPLAY_LIMIT).length;
    return {
        contributorCount: contributorCount,
        namedContributors: namedContributors,
        overflowContributorCount: overflowContributorCount
    };
};
const $796be31b418aa35d$export$18638a7ae5c7368a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { partial: partial } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    let values;
    let titleMessage;
    if (partial?.entity?.container?.type === "DIRECT_MESSAGE" || partial?.entity?.container?.type === "GROUP_DIRECT_MESSAGE") {
        let t1;
        if ($[0] !== intl || $[1] !== partial?.entity.container?.members) {
            const groupChatParticipants = partial?.entity.container?.members?.map($796be31b418aa35d$var$_temp);
            t1 = $796be31b418aa35d$var$getTitleMessageValues(groupChatParticipants, intl);
            $[0] = intl;
            $[1] = partial?.entity.container?.members;
            $[2] = t1;
        } else t1 = $[2];
        const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = t1;
        const [name1, name2, name3] = namedContributors;
        let t2;
        if ($[3] !== contributorCount || $[4] !== name1 || $[5] !== name2 || $[6] !== name3 || $[7] !== overflowContributorCount) {
            t2 = {
                contributorCount: contributorCount,
                name1: name1,
                name2: name2,
                name3: name3,
                overflowContributorCount: overflowContributorCount
            };
            $[3] = contributorCount;
            $[4] = name1;
            $[5] = name2;
            $[6] = name3;
            $[7] = overflowContributorCount;
            $[8] = t2;
        } else t2 = $[8];
        values = t2;
        titleMessage = (0, $9e6aae9f49232115$export$a7357cdd1f0b0168).groupChatTitle;
    } else {
        let t1;
        if ($[9] !== intl || $[10] !== partial) {
            const linkedEntities = partial.linkedEntities || [];
            const threadUsers = [
                partial,
                ...linkedEntities
            ].map($796be31b418aa35d$var$_temp2);
            t1 = $796be31b418aa35d$var$getTitleMessageValues(threadUsers, intl);
            $[9] = intl;
            $[10] = partial;
            $[11] = t1;
        } else t1 = $[11];
        const { contributorCount: contributorCount_0, namedContributors: namedContributors_0, overflowContributorCount: overflowContributorCount_0 } = t1;
        const [name1_0, name2_0, name3_0] = namedContributors_0;
        let t2;
        if ($[12] !== formatMessage || $[13] !== partial.entity?.container?.displayName) {
            t2 = partial?.entity?.container?.displayName || formatMessage((0, $9e6aae9f49232115$export$a7357cdd1f0b0168).unknownChannel);
            $[12] = formatMessage;
            $[13] = partial.entity?.container?.displayName;
            $[14] = t2;
        } else t2 = $[14];
        const channelName = t2;
        let t3;
        if ($[15] !== channelName || $[16] !== contributorCount_0 || $[17] !== name1_0 || $[18] !== name2_0 || $[19] !== name3_0 || $[20] !== overflowContributorCount_0) {
            t3 = {
                contributorCount: contributorCount_0,
                name1: name1_0,
                name2: name2_0,
                name3: name3_0,
                overflowContributorCount: overflowContributorCount_0,
                channelName: channelName
            };
            $[15] = channelName;
            $[16] = contributorCount_0;
            $[17] = name1_0;
            $[18] = name2_0;
            $[19] = name3_0;
            $[20] = overflowContributorCount_0;
            $[21] = t3;
        } else t3 = $[21];
        values = t3;
        titleMessage = (0, $9e6aae9f49232115$export$a7357cdd1f0b0168).threadTitleWithOthers;
    }
    let t1;
    if ($[22] !== titleMessage || $[23] !== values) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...titleMessage,
            values: values
        });
        $[22] = titleMessage;
        $[23] = values;
        $[24] = t1;
    } else t1 = $[24];
    return t1;
} : ({ partial: partial })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    let values = {};
    let titleMessage = (0, $9e6aae9f49232115$export$a7357cdd1f0b0168).groupChatTitle;
    if (partial?.entity?.container?.type === 'DIRECT_MESSAGE' || partial?.entity?.container?.type === 'GROUP_DIRECT_MESSAGE') {
        const groupChatParticipants = partial?.entity.container?.members?.map((member)=>member?.thirdPartyUser);
        const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = $796be31b418aa35d$var$getTitleMessageValues(groupChatParticipants, intl);
        const [name1, name2, name3] = namedContributors;
        values = {
            contributorCount: contributorCount,
            name1: name1,
            name2: name2,
            name3: name3,
            overflowContributorCount: overflowContributorCount
        };
        titleMessage = (0, $9e6aae9f49232115$export$a7357cdd1f0b0168).groupChatTitle;
    } else {
        const linkedEntities = partial.linkedEntities || [];
        const threadUsers = [
            partial,
            ...linkedEntities
        ].map((linkedMessage)=>linkedMessage?.entity?.createdBy?.thirdPartyUser);
        const { contributorCount: contributorCount_0, namedContributors: namedContributors_0, overflowContributorCount: overflowContributorCount_0 } = $796be31b418aa35d$var$getTitleMessageValues(threadUsers, intl);
        const [name1_0, name2_0, name3_0] = namedContributors_0;
        const channelName = partial?.entity?.container?.displayName || formatMessage((0, $9e6aae9f49232115$export$a7357cdd1f0b0168).unknownChannel);
        values = {
            contributorCount: contributorCount_0,
            name1: name1_0,
            name2: name2_0,
            name3: name3_0,
            overflowContributorCount: overflowContributorCount_0,
            channelName: channelName
        };
        titleMessage = (0, $9e6aae9f49232115$export$a7357cdd1f0b0168).threadTitleWithOthers;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...titleMessage,
        values: values
    });
};
function $796be31b418aa35d$var$_temp(member) {
    return member?.thirdPartyUser;
}
function $796be31b418aa35d$var$_temp2(linkedMessage) {
    return linkedMessage?.entity?.createdBy?.thirdPartyUser;
}


const $c9baa6c1d486b4cf$export$423dfe6469a8e0dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { partial: partial, position: position, icon: icon } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const { url: url, linkedEntities: linkedEntities } = partial;
    let t2;
    if ($[0] !== partial.integrationId) {
        t2 = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
        $[0] = partial.integrationId;
        $[1] = t2;
    } else t2 = $[1];
    const integrationKey = t2;
    const labelMessage = linkedEntities?.length ? (0, $f170b0bde2723337$export$a7357cdd1f0b0168).threadTypeLabel : (0, $f170b0bde2723337$export$a7357cdd1f0b0168).messageTypeLabel;
    let t3;
    if ($[2] !== partial) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $796be31b418aa35d$export$18638a7ae5c7368a), {
            partial: partial
        });
        $[2] = partial;
        $[3] = t3;
    } else t3 = $[3];
    const title = t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Body: (0, $5a8e4d80f88463b7$export$36e783c4ff07cd7c)
        };
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== partial) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6fbc8cf7696bece3$export$39a3a4657e687b88), {
            partial: partial,
            components: t4
        });
        $[5] = partial;
        $[6] = t5;
    } else t5 = $[6];
    const body = t5;
    let t6;
    if ($[7] !== labelMessage) {
        t6 = [
            "label",
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), labelMessage)
        ];
        $[7] = labelMessage;
        $[8] = t6;
    } else t6 = $[8];
    let parts;
    if ($[9] !== formatMessage || $[10] !== partial.entity?.container?.membershipType || $[11] !== t6) {
        parts = [
            t6
        ];
        if (partial?.entity?.container?.membershipType === "PRIVATE") {
            let t7;
            if ($[13] !== formatMessage) {
                t7 = formatMessage((0, $f170b0bde2723337$export$a7357cdd1f0b0168).privateChannelLabel);
                $[13] = formatMessage;
                $[14] = t7;
            } else t7 = $[14];
            let t8;
            if ($[15] !== t7) {
                t8 = [
                    "private",
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
                        label: t7,
                        color: "var(--ds-icon)",
                        size: "small"
                    })
                ];
                $[15] = t7;
                $[16] = t8;
            } else t8 = $[16];
            parts.push(t8);
        }
        $[9] = formatMessage;
        $[10] = partial.entity?.container?.membershipType;
        $[11] = t6;
        $[12] = parts;
    } else parts = $[12];
    let t7;
    if ($[17] !== integrationKey || $[18] !== parts) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: parts
        });
        $[17] = integrationKey;
        $[18] = parts;
        $[19] = t7;
    } else t7 = $[19];
    const t8 = partial.entity?.attachments;
    let t9;
    if ($[20] !== partial || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bfab777519380dff$export$c129802f229d9594), {
            attachments: t8,
            message: partial
        });
        $[20] = partial;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== body || $[24] !== cloudId || $[25] !== icon || $[26] !== partial || $[27] !== position || $[28] !== primaryProduct || $[29] !== t7 || $[30] !== t9 || $[31] !== title || $[32] !== url) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: partial.id,
            icon: icon,
            description: body,
            headerMetadata: t7,
            footer: t9,
            title: title,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[23] = body;
        $[24] = cloudId;
        $[25] = icon;
        $[26] = partial;
        $[27] = position;
        $[28] = primaryProduct;
        $[29] = t7;
        $[30] = t9;
        $[31] = title;
        $[32] = url;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
} : ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { url: url, linkedEntities: linkedEntities } = partial;
    const integrationKey = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
    const labelMessage = linkedEntities?.length ? (0, $f170b0bde2723337$export$a7357cdd1f0b0168).threadTypeLabel : (0, $f170b0bde2723337$export$a7357cdd1f0b0168).messageTypeLabel;
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $796be31b418aa35d$export$18638a7ae5c7368a), {
        partial: partial
    });
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6fbc8cf7696bece3$export$39a3a4657e687b88), {
        partial: partial,
        components: {
            Body: (0, $5a8e4d80f88463b7$export$36e783c4ff07cd7c)
        }
    });
    const parts = [
        [
            'label',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), labelMessage)
        ]
    ];
    if (partial?.entity?.container?.membershipType === 'PRIVATE') parts.push([
        'private',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
            label: formatMessage((0, $f170b0bde2723337$export$a7357cdd1f0b0168).privateChannelLabel),
            color: "var(--ds-icon)",
            size: "small"
        })
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: body,
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: parts
        }),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bfab777519380dff$export$c129802f229d9594), {
            attachments: partial.entity?.attachments,
            message: partial
        }),
        title: title,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};
























const $62465dde1d9dc735$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    resultLabel: {
        id: "dynamic-cards-search-page.github-pull-request-result.label",
        defaultMessage: "Pull request"
    }
});


const $b7af05f962af8542$export$fcb233d1869c46a3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(41);
    const { partial: partial, position: position, icon: icon } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const { url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt } = partial;
    let t2;
    if ($[0] !== entity) {
        t2 = entity || {};
        $[0] = entity;
        $[1] = t2;
    } else t2 = $[1];
    const { title: title, lastUpdate: lastUpdate, container: container, pullRequestId: pullRequestId } = t2;
    let t3;
    if ($[2] !== formatMessage) {
        t3 = formatMessage((0, $62465dde1d9dc735$export$defe85febe8b728c).resultLabel);
        $[2] = formatMessage;
        $[3] = t3;
    } else t3 = $[3];
    const label = t3;
    let t4;
    if ($[4] !== lastUpdate) {
        t4 = lastUpdate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastUpdate
        }) : null;
        $[4] = lastUpdate;
        $[5] = t4;
    } else t4 = $[5];
    const lastModifiedComponent = t4;
    let t5;
    if ($[6] !== partial.integrationId) {
        t5 = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
        $[6] = partial.integrationId;
        $[7] = t5;
    } else t5 = $[7];
    const integrationKey = t5;
    let t6;
    if ($[8] !== permissionLevel) {
        t6 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
            permissionLevel: permissionLevel
        }) : null;
        $[8] = permissionLevel;
        $[9] = t6;
    } else t6 = $[9];
    const padlockIcon = t6;
    const getDescription = $b7af05f962af8542$var$_temp;
    const t7 = partial.id;
    let t8;
    if ($[10] !== excerpt) {
        t8 = getDescription(excerpt);
        $[10] = excerpt;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = `#${pullRequestId}`;
    let t10;
    if ($[12] !== t9) {
        t10 = [
            "pull-request-id",
            t9
        ];
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    const t11 = container?.name ?? null;
    let t12;
    if ($[14] !== t11) {
        t12 = [
            "repository-name",
            t11
        ];
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== padlockIcon) {
        t13 = [
            "padlock",
            padlockIcon
        ];
        $[16] = padlockIcon;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== lastModifiedComponent) {
        t14 = [
            "last-modified",
            lastModifiedComponent
        ];
        $[18] = lastModifiedComponent;
        $[19] = t14;
    } else t14 = $[19];
    let t15;
    if ($[20] !== label || $[21] !== t10 || $[22] !== t12 || $[23] !== t13 || $[24] !== t14) {
        t15 = [
            label,
            t10,
            t12,
            t13,
            t14
        ];
        $[20] = label;
        $[21] = t10;
        $[22] = t12;
        $[23] = t13;
        $[24] = t14;
        $[25] = t15;
    } else t15 = $[25];
    let t16;
    if ($[26] !== integrationKey || $[27] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: t15
        });
        $[26] = integrationKey;
        $[27] = t15;
        $[28] = t16;
    } else t16 = $[28];
    let t17;
    if ($[29] !== title) {
        t17 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title);
        $[29] = title;
        $[30] = t17;
    } else t17 = $[30];
    let t18;
    if ($[31] !== cloudId || $[32] !== icon || $[33] !== partial || $[34] !== position || $[35] !== primaryProduct || $[36] !== t16 || $[37] !== t17 || $[38] !== t8 || $[39] !== url) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: t7,
            icon: icon,
            description: t8,
            headerMetadata: t16,
            title: t17,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[31] = cloudId;
        $[32] = icon;
        $[33] = partial;
        $[34] = position;
        $[35] = primaryProduct;
        $[36] = t16;
        $[37] = t17;
        $[38] = t8;
        $[39] = url;
        $[40] = t18;
    } else t18 = $[40];
    return t18;
} : ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt } = partial;
    const { title: title, lastUpdate: lastUpdate, container: container, pullRequestId: pullRequestId } = entity || {};
    const label = formatMessage((0, $62465dde1d9dc735$export$defe85febe8b728c).resultLabel);
    const lastModifiedComponent = lastUpdate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
        lastModified: lastUpdate
    }) : null;
    const integrationKey = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
    const padlockIcon = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getDescription = (excerpt_0)=>{
        const markdownRemoved = (0, $6aca57325ae7c660$export$7e4bcd4afb389edb)(excerpt_0);
        return (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(markdownRemoved, true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: getDescription(excerpt),
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: [
                label,
                [
                    'pull-request-id',
                    `#${pullRequestId}`
                ],
                [
                    'repository-name',
                    container?.name ?? null
                ],
                [
                    'padlock',
                    padlockIcon
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ]
            ]
        }),
        title: (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};
function $b7af05f962af8542$var$_temp(excerpt_0) {
    const markdownRemoved = (0, $6aca57325ae7c660$export$7e4bcd4afb389edb)(excerpt_0);
    return (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(markdownRemoved, true);
}
























const $932cd2c49cfd4219$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    repositoryLabel: {
        id: "dynamic-cards-search-page.search-result.repository-label",
        defaultMessage: "Repository"
    }
});


const $e0adf0fe6c572ea8$var$GITHUB_INTEGRATION_KEY = 'github';
const $e0adf0fe6c572ea8$export$334ba9b7628e002a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { partial: partial, position: position, icon: icon } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = partial;
    let t2;
    if ($[0] !== partial.integrationId) {
        t2 = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
        $[0] = partial.integrationId;
        $[1] = t2;
    } else t2 = $[1];
    const integrationKey = t2;
    let t3;
    if ($[2] !== formatMessage) {
        t3 = formatMessage((0, $932cd2c49cfd4219$export$defe85febe8b728c).repositoryLabel);
        $[2] = formatMessage;
        $[3] = t3;
    } else t3 = $[3];
    const label = t3;
    let t4;
    if ($[4] !== permissionLevel) {
        t4 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ $cozmU.createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
            permissionLevel: permissionLevel
        }) : null;
        $[4] = permissionLevel;
        $[5] = t4;
    } else t4 = $[5];
    const padlockIcon = t4;
    const getDescription = $e0adf0fe6c572ea8$var$_temp;
    let t5;
    if ($[6] !== integrationKey || $[7] !== lastModifiedDate) {
        t5 = lastModifiedDate && integrationKey !== $e0adf0fe6c572ea8$var$GITHUB_INTEGRATION_KEY ? /*#__PURE__*/ $cozmU.createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        }) : null;
        $[6] = integrationKey;
        $[7] = lastModifiedDate;
        $[8] = t5;
    } else t5 = $[8];
    const lastModifiedComponent = t5;
    const t6 = partial.id;
    let t7;
    if ($[9] !== excerpt) {
        t7 = getDescription(excerpt);
        $[9] = excerpt;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== padlockIcon) {
        t8 = [
            "padlock",
            padlockIcon
        ];
        $[11] = padlockIcon;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== lastModifiedComponent) {
        t9 = [
            "last-modified",
            lastModifiedComponent
        ];
        $[13] = lastModifiedComponent;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== label || $[16] !== t8 || $[17] !== t9) {
        t10 = [
            label,
            t8,
            t9
        ];
        $[15] = label;
        $[16] = t8;
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== integrationKey || $[20] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: t10
        });
        $[19] = integrationKey;
        $[20] = t10;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== title) {
        t12 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title);
        $[22] = title;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== cloudId || $[25] !== icon || $[26] !== partial || $[27] !== position || $[28] !== primaryProduct || $[29] !== t11 || $[30] !== t12 || $[31] !== t7 || $[32] !== url) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: t6,
            icon: icon,
            description: t7,
            headerMetadata: t11,
            title: t12,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[24] = cloudId;
        $[25] = icon;
        $[26] = partial;
        $[27] = position;
        $[28] = primaryProduct;
        $[29] = t11;
        $[30] = t12;
        $[31] = t7;
        $[32] = url;
        $[33] = t13;
    } else t13 = $[33];
    return t13;
} : ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = partial;
    const integrationKey = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
    const label = formatMessage((0, $932cd2c49cfd4219$export$defe85febe8b728c).repositoryLabel);
    const padlockIcon = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ $cozmU.createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getDescription = (excerpt_0)=>{
        const markdownRemoved = (0, $6aca57325ae7c660$export$7e4bcd4afb389edb)(excerpt_0);
        return (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(markdownRemoved, true);
    };
    const lastModifiedComponent = lastModifiedDate && integrationKey !== $e0adf0fe6c572ea8$var$GITHUB_INTEGRATION_KEY ? /*#__PURE__*/ $cozmU.createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    return /*#__PURE__*/ $cozmU.createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: getDescription(excerpt),
        headerMetadata: /*#__PURE__*/ $cozmU.createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: [
                label,
                [
                    'padlock',
                    padlockIcon
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ]
            ]
        }),
        title: (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};
function $e0adf0fe6c572ea8$var$_temp(excerpt_0) {
    const markdownRemoved = (0, $6aca57325ae7c660$export$7e4bcd4afb389edb)(excerpt_0);
    return (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(markdownRemoved, true);
}






























var $7vK9E = parcelRequire("7vK9E");


















const $0a1ff150b603e352$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    videoThumbnailAltText: {
        id: "dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text",
        defaultMessage: "Video thumbnail"
    },
    videoIconLabel: {
        id: "dynamic-cards-search-page.video-search-result.video-icon-label",
        defaultMessage: "video icon"
    },
    dropdownMessage: {
        id: "dynamic-cards-search-page.video-search-result.dropdown-message",
        defaultMessage: "{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}"
    },
    seeAllLabel: {
        id: "dynamic-cards-search-page.video-search-result.see-all-label",
        defaultMessage: "See all"
    }
});



var $d2hGj = parcelRequire("d2hGj");


var $f6RxU = parcelRequire("f6RxU");


var $e9nC3 = parcelRequire("e9nC3");

var $382a7f655ad1c40a$require$Buffer = $e9nC3.Buffer;
const $382a7f655ad1c40a$export$b0d5f79a828d791e = (durationInSeconds, options)=>{
    if (durationInSeconds === undefined) return null;
    const date = (0, $d2hGj.default)(new Date(0), durationInSeconds);
    const ONE_HOUR = 3600;
    const ONE_MINUTE = 60;
    const hours = Math.floor(durationInSeconds / ONE_HOUR);
    const minutes = Math.floor(durationInSeconds % ONE_HOUR / ONE_MINUTE);
    const seconds = durationInSeconds % ONE_MINUTE;
    if (options?.readable) {
        if (durationInSeconds < ONE_MINUTE) return `${seconds} sec`;
        else if (durationInSeconds < 3600) return `${minutes} min`;
        else return `${hours} hour ${minutes} min`;
    }
    if (durationInSeconds < ONE_HOUR) return (0, $f6RxU.default)(date, 'mm:ss');
    return (0, $f6RxU.default)(date, 'HH:mm:ss');
};
const $382a7f655ad1c40a$export$edf82fe058be01d = (url)=>{
    const urlParams = new URLSearchParams(new URL(url).search);
    const base64Policy = urlParams.get('Policy');
    if (!base64Policy) return true;
    const decodedPolicy = $382a7f655ad1c40a$require$Buffer.from(base64Policy, 'base64').toString('utf-8');
    const i = decodedPolicy.lastIndexOf('}');
    const sanitizedPolicy = decodedPolicy.substring(0, i + 1);
    let policy;
    try {
        policy = JSON.parse(sanitizedPolicy);
    } catch (_) {
        return true;
    }
    if (policy.Statement && policy.Statement.length > 0) {
        const statement = policy.Statement[0];
        if (statement.Condition && statement.Condition.DateLessThan) {
            const epochTime = statement.Condition.DateLessThan['AWS:EpochTime'];
            const currentTime = Math.floor(Date.now() / 1000);
            return currentTime > epochTime;
        }
    }
    //fallthrough treat as expired
    return true;
};
const $382a7f655ad1c40a$export$121bfeb3f6fb7f94 = (baseUrl, durationInSeconds)=>{
    return `${baseUrl}?t=${durationInSeconds}`;
};


const $601d3403b9925a73$var$styles = {
    thumbnailContainer: "_1xC2CJQOCm _1mT5xdRAKS",
    bodyArea: "_3iDTPbQ4SZ _17lj8p8HPE",
    footerContainer: "_0Of8r22ADO _1mT5xdRAKS",
    dropdownItem: "_4c065U1Y8M _3iDTPbQ4SZ _17lj8p2ADO _3138422ADO",
    seeAll: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2sNsIg7NXe _3138428HPE",
    thumbnailImageStyles: "_0bjKvDKxmn _0NUa3r1Ddq _39xV02IZbP",
    chapterLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzM7Tp _2nTuUYWfPD _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMM7Tp _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _4scvAwWyeI"
};
const $601d3403b9925a73$var$VideoThumbnail = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { thumbnailUrl: thumbnailUrl, url: url } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isErrored, setIsErrored] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== formatMessage || $[1] !== isErrored || $[2] !== thumbnailUrl || $[3] !== url) {
        t1 = !thumbnailUrl || (0, $382a7f655ad1c40a$export$edf82fe058be01d)(thumbnailUrl) || isErrored ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            testId: "thumbnail-container",
            xcss: $601d3403b9925a73$var$styles.thumbnailContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: url,
            rel: "noreferrer",
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: thumbnailUrl,
            alt: formatMessage((0, $0a1ff150b603e352$export$defe85febe8b728c).videoThumbnailAltText),
            onError: ()=>setIsErrored(true),
            className: (0, $hekY6.default)([
                $601d3403b9925a73$var$styles.thumbnailImageStyles
            ])
        })));
        $[0] = formatMessage;
        $[1] = isErrored;
        $[2] = thumbnailUrl;
        $[3] = url;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ thumbnailUrl: thumbnailUrl, url: url })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isErrored, setIsErrored] = (0, $cozmU.useState)(false);
    return !thumbnailUrl || (0, $382a7f655ad1c40a$export$edf82fe058be01d)(thumbnailUrl) || isErrored ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        testId: "thumbnail-container",
        xcss: $601d3403b9925a73$var$styles.thumbnailContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: url,
        rel: 'noreferrer',
        target: '_blank'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: thumbnailUrl,
        alt: formatMessage((0, $0a1ff150b603e352$export$defe85febe8b728c).videoThumbnailAltText),
        onError: ()=>setIsErrored(true),
        className: (0, $hekY6.default)([
            $601d3403b9925a73$var$styles.thumbnailImageStyles
        ])
    })));
};
const $601d3403b9925a73$var$VideoChapters = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { chapters: chapters, url: url } = t0;
    if (!chapters || chapters.length === 0) return null;
    let t1;
    if ($[0] !== chapters || $[1] !== url) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $601d3403b9925a73$var$styles.footerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($601d3403b9925a73$var$DropdownMenu, {
            chapters: chapters,
            url: url
        }));
        $[0] = chapters;
        $[1] = url;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ chapters: chapters, url: url })=>{
    if (!chapters || chapters.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $601d3403b9925a73$var$styles.footerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($601d3403b9925a73$var$DropdownMenu, {
        chapters: chapters,
        url: url
    }));
};
const $601d3403b9925a73$var$DropdownMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { chapters: chapters, url: url } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== chapters.length || $[1] !== formatMessage) {
        t1 = formatMessage((0, $0a1ff150b603e352$export$defe85febe8b728c).dropdownMessage, {
            chapterCount: chapters.length
        });
        $[0] = chapters.length;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    const dropdownMessage = t1;
    let t2;
    let t3;
    if ($[3] !== isExpanded) {
        t2 = (iconProps)=>isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            });
        t3 = ()=>setIsExpanded(!isExpanded);
        $[3] = isExpanded;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    let t4;
    if ($[6] !== dropdownMessage || $[7] !== isExpanded || $[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            iconAfter: t2,
            onClick: t3,
            isSelected: isExpanded
        }, dropdownMessage);
        $[6] = dropdownMessage;
        $[7] = isExpanded;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== chapters || $[12] !== isExpanded || $[13] !== url) {
        t5 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($601d3403b9925a73$var$DropdownItems, {
            chapters: chapters,
            url: url
        });
        $[11] = chapters;
        $[12] = isExpanded;
        $[13] = url;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== t4 || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, t4, t5);
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ chapters: chapters, url: url })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const dropdownMessage = formatMessage((0, $0a1ff150b603e352$export$defe85febe8b728c).dropdownMessage, {
        chapterCount: chapters.length
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconAfter: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        onClick: ()=>setIsExpanded(!isExpanded),
        isSelected: isExpanded
    }, dropdownMessage), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($601d3403b9925a73$var$DropdownItems, {
        chapters: chapters,
        url: url
    }));
};
const $601d3403b9925a73$var$DropdownItems = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { chapters: chapters, url: url } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== chapters || $[1] !== formatMessage || $[2] !== url) {
        let t2;
        if ($[4] !== formatMessage || $[5] !== url) {
            t2 = (t3)=>{
                const { title: title, startTimeInSeconds: startTimeInSeconds } = t3;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $601d3403b9925a73$var$styles.dropdownItem
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
                    label: formatMessage((0, $0a1ff150b603e352$export$defe85febe8b728c).videoIconLabel),
                    size: "medium",
                    color: "var(--ds-icon-accent-blue, #357DE8)"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    space: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    size: "small",
                    weight: "medium"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                    xcss: $601d3403b9925a73$var$styles.chapterLink,
                    href: (0, $382a7f655ad1c40a$export$121bfeb3f6fb7f94)(url, startTimeInSeconds),
                    rel: "noreferrer",
                    target: "_blank"
                }, (0, $382a7f655ad1c40a$export$b0d5f79a828d791e)(startTimeInSeconds))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    size: "small"
                }, title)));
            };
            $[4] = formatMessage;
            $[5] = url;
            $[6] = t2;
        } else t2 = $[6];
        t1 = chapters.map(t2);
        $[0] = chapters;
        $[1] = formatMessage;
        $[2] = url;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[7] !== chapters.length || $[8] !== formatMessage || $[9] !== url) {
        t2 = chapters.length > 10 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $601d3403b9925a73$var$styles.seeAll
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: url,
            target: "_blank",
            xcss: $601d3403b9925a73$var$styles.seeAll
        }, formatMessage((0, $0a1ff150b603e352$export$defe85febe8b728c).seeAllLabel)));
        $[7] = chapters.length;
        $[8] = formatMessage;
        $[9] = url;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] !== t1 || $[12] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, t1, t2);
        $[11] = t1;
        $[12] = t2;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ chapters: chapters, url: url })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, chapters.map(({ title: title, startTimeInSeconds: startTimeInSeconds })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $601d3403b9925a73$var$styles.dropdownItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            label: formatMessage((0, $0a1ff150b603e352$export$defe85febe8b728c).videoIconLabel),
            size: "medium",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: 'space.050'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            xcss: $601d3403b9925a73$var$styles.chapterLink,
            href: (0, $382a7f655ad1c40a$export$121bfeb3f6fb7f94)(url, startTimeInSeconds),
            rel: 'noreferrer',
            target: "_blank"
        }, (0, $382a7f655ad1c40a$export$b0d5f79a828d791e)(startTimeInSeconds))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, title)));
    }), chapters.length > 10 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $601d3403b9925a73$var$styles.seeAll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: url,
        target: "_blank",
        xcss: $601d3403b9925a73$var$styles.seeAll
    }, formatMessage((0, $0a1ff150b603e352$export$defe85febe8b728c).seeAllLabel))));
};
const $601d3403b9925a73$export$d343a98cb833c8b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(67);
    const { partial: partial, position: position, icon: icon } = t0;
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity } = partial;
    let T0;
    let T1;
    let chapters;
    let creatorName;
    let integrationKey;
    let lastModifiedComponent;
    let t2;
    let t3;
    let t4;
    let t5;
    let title;
    let videoDuration;
    if ($[0] !== entity || $[1] !== lastModifiedDate || $[2] !== partial || $[3] !== url) {
        const { durationInSeconds: durationInSeconds, chapters: t6, createdBy: createdBy, thumbnailUrl: thumbnailUrl } = entity || {};
        chapters = t6;
        creatorName = createdBy?.user?.name || createdBy?.thirdPartyUser?.name || null;
        const { title: t7, excerpt: excerpt } = partial;
        title = t7;
        const excerptToDisplay = (0, $8a1a5c2af543b4cc$export$85fedc4ba4240156)(excerpt || "", 300);
        let t8;
        if ($[16] !== partial.integrationId) {
            t8 = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
            $[16] = partial.integrationId;
            $[17] = t8;
        } else t8 = $[17];
        integrationKey = t8;
        videoDuration = (0, $382a7f655ad1c40a$export$b0d5f79a828d791e)(durationInSeconds, {
            readable: true
        });
        let t9;
        if ($[18] !== lastModifiedDate) {
            t9 = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
                lastModified: lastModifiedDate
            }) : null;
            $[18] = lastModifiedDate;
            $[19] = t9;
        } else t9 = $[19];
        lastModifiedComponent = t9;
        T1 = (0, $iMnC5.Box);
        t3 = "thumbnail-container";
        t4 = $601d3403b9925a73$var$styles.bodyArea;
        if ($[20] !== thumbnailUrl || $[21] !== url) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($601d3403b9925a73$var$VideoThumbnail, {
                thumbnailUrl: thumbnailUrl,
                url: url
            });
            $[20] = thumbnailUrl;
            $[21] = url;
            $[22] = t5;
        } else t5 = $[22];
        T0 = (0, $iMnC5.Box);
        t2 = (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerptToDisplay, true);
        $[0] = entity;
        $[1] = lastModifiedDate;
        $[2] = partial;
        $[3] = url;
        $[4] = T0;
        $[5] = T1;
        $[6] = chapters;
        $[7] = creatorName;
        $[8] = integrationKey;
        $[9] = lastModifiedComponent;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = title;
        $[15] = videoDuration;
    } else {
        T0 = $[4];
        T1 = $[5];
        chapters = $[6];
        creatorName = $[7];
        integrationKey = $[8];
        lastModifiedComponent = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        t5 = $[13];
        title = $[14];
        videoDuration = $[15];
    }
    let t6;
    if ($[23] !== T0 || $[24] !== t2) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, null, t2);
        $[23] = T0;
        $[24] = t2;
        $[25] = t6;
    } else t6 = $[25];
    let t7;
    if ($[26] !== T1 || $[27] !== t3 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            testId: t3,
            xcss: t4
        }, t5, t6);
        $[26] = T1;
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
        $[30] = t6;
        $[31] = t7;
    } else t7 = $[31];
    const body = t7;
    let t8;
    if ($[32] !== permissionLevel) {
        t8 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
            permissionLevel: permissionLevel
        }) : null;
        $[32] = permissionLevel;
        $[33] = t8;
    } else t8 = $[33];
    const padlockIcon = t8;
    const t9 = partial.id;
    const t10 = !!selectedProduct;
    let t11;
    if ($[34] !== creatorName) {
        t11 = [
            "creator-name",
            creatorName
        ];
        $[34] = creatorName;
        $[35] = t11;
    } else t11 = $[35];
    let t12;
    if ($[36] !== lastModifiedComponent) {
        t12 = [
            "last-modified",
            lastModifiedComponent
        ];
        $[36] = lastModifiedComponent;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== videoDuration) {
        t13 = [
            "video-duration",
            videoDuration
        ];
        $[38] = videoDuration;
        $[39] = t13;
    } else t13 = $[39];
    let t14;
    if ($[40] !== padlockIcon) {
        t14 = [
            "padlock",
            padlockIcon
        ];
        $[40] = padlockIcon;
        $[41] = t14;
    } else t14 = $[41];
    let t15;
    if ($[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== t14) {
        t15 = [
            "Video",
            t11,
            t12,
            t13,
            t14
        ];
        $[42] = t11;
        $[43] = t12;
        $[44] = t13;
        $[45] = t14;
        $[46] = t15;
    } else t15 = $[46];
    let t16;
    if ($[47] !== integrationKey || $[48] !== t10 || $[49] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: t10,
            parts: t15
        });
        $[47] = integrationKey;
        $[48] = t10;
        $[49] = t15;
        $[50] = t16;
    } else t16 = $[50];
    let t17;
    if ($[51] !== chapters || $[52] !== url) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($601d3403b9925a73$var$VideoChapters, {
            chapters: chapters,
            url: url
        });
        $[51] = chapters;
        $[52] = url;
        $[53] = t17;
    } else t17 = $[53];
    let t18;
    if ($[54] !== title) {
        t18 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title);
        $[54] = title;
        $[55] = t18;
    } else t18 = $[55];
    let t19;
    if ($[56] !== body || $[57] !== cloudId || $[58] !== icon || $[59] !== partial || $[60] !== position || $[61] !== primaryProduct || $[62] !== t16 || $[63] !== t17 || $[64] !== t18 || $[65] !== url) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: t9,
            description: body,
            icon: icon,
            headerMetadata: t16,
            footer: t17,
            title: t18,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[56] = body;
        $[57] = cloudId;
        $[58] = icon;
        $[59] = partial;
        $[60] = position;
        $[61] = primaryProduct;
        $[62] = t16;
        $[63] = t17;
        $[64] = t18;
        $[65] = url;
        $[66] = t19;
    } else t19 = $[66];
    return t19;
} : ({ partial: partial, position: position, icon: icon })=>{
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity } = partial;
    const { durationInSeconds: durationInSeconds, chapters: chapters, createdBy: createdBy, thumbnailUrl: thumbnailUrl } = entity || {};
    const creatorName = createdBy?.user?.name || createdBy?.thirdPartyUser?.name || null;
    let { title: title, excerpt: excerpt } = partial;
    const excerptToDisplay = (0, $8a1a5c2af543b4cc$export$85fedc4ba4240156)(excerpt || '', 300);
    const integrationKey = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
    const videoDuration = (0, $382a7f655ad1c40a$export$b0d5f79a828d791e)(durationInSeconds, {
        readable: true
    });
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "thumbnail-container",
        xcss: $601d3403b9925a73$var$styles.bodyArea
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($601d3403b9925a73$var$VideoThumbnail, {
        thumbnailUrl: thumbnailUrl,
        url: url
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerptToDisplay, true)));
    const padlockIcon = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        description: body,
        icon: icon,
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: !!selectedProduct,
            parts: [
                'Video',
                [
                    'creator-name',
                    creatorName
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ],
                [
                    'video-duration',
                    videoDuration
                ],
                [
                    'padlock',
                    padlockIcon
                ]
            ]
        }),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($601d3403b9925a73$var$VideoChapters, {
            chapters: chapters,
            url: url
        }),
        title: (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};




































const $149a12367c3172cb$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    workItem: {
        id: "dynamic-cards-search-page.work-item.label",
        defaultMessage: "Work item"
    },
    taskLabel: {
        id: "dynamic-cards-search-page.work-item-task.label",
        defaultMessage: "Task"
    },
    projectLabel: {
        id: "dynamic-cards-search-page.work-item-project.label",
        defaultMessage: "Project"
    },
    ticketLabel: {
        id: "dynamic-cards-search-page.work-item-ticket.label",
        defaultMessage: "Ticket"
    },
    for: {
        id: "dynamic-cards-search-page.work-item-status.for",
        defaultMessage: "for"
    },
    isAssigned: {
        id: "dynamic-cards-search-page.work-item-assignee.assigned",
        defaultMessage: "is assigned"
    },
    created: {
        id: "dynamic-cards-search-page.work-item-creator.created",
        defaultMessage: "created"
    },
    externalPersonLabel: {
        id: "dynamic-cards-search-page.externalPersonLabel",
        defaultMessage: "External person"
    }
});


const $4c2056d5893e6f6d$var$nameContainer = (0, $buxP3.xcss)({
    whiteSpace: 'nowrap'
});
const $4c2056d5893e6f6d$var$statusAndDateContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $4c2056d5893e6f6d$var$STATUS_REGEX = /[\s-]+/g;
const $4c2056d5893e6f6d$var$getStatusLozenge = (name)=>{
    name = name.replace($4c2056d5893e6f6d$var$STATUS_REGEX, '').toLowerCase();
    switch(true){
        case [
            'onhold'
        ].includes(name):
            return 'neutral';
        case [
            'solved',
            'complete',
            'completed',
            'open'
        ].includes(name):
            return 'success';
        case [
            'offtrack',
            'untriaged'
        ].includes(name):
            return 'danger';
        case [
            'atrisk'
        ].includes(name):
            return 'warning';
        case [
            'todo',
            'new',
            'pending',
            'created'
        ].includes(name):
            return 'discovery';
        case [
            'inprogress',
            'ontrack'
        ].includes(name):
            return 'information';
    }
    return 'information'; // for custom status labels
};
const $4c2056d5893e6f6d$export$35f8af203ce4264d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { partial: partial, position: position, icon: icon, product: product } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, title: title, subtype: subtype } = partial;
    let t2;
    if ($[0] !== entity) {
        t2 = entity || {};
        $[0] = entity;
        $[1] = t2;
    } else t2 = $[1];
    const { assignee: assignee, createdBy: createdBy, dueDate: dueDate, id: id, projectName: projectName, status: status } = t2;
    let t3;
    if ($[2] !== lastModifiedDate) {
        t3 = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        }) : null;
        $[2] = lastModifiedDate;
        $[3] = t3;
    } else t3 = $[3];
    const lastModifiedComponent = t3;
    let t4;
    if ($[4] !== permissionLevel) {
        t4 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
            permissionLevel: permissionLevel
        }) : null;
        $[4] = permissionLevel;
        $[5] = t4;
    } else t4 = $[5];
    const padlockIcon = t4;
    let t5;
    if ($[6] !== dueDate || $[7] !== status) {
        t5 = ()=>{
            if (!status) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $4c2056d5893e6f6d$var$statusAndDateContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                appearance: $4c2056d5893e6f6d$var$getStatusLozenge(status)
            }, status), dueDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $149a12367c3172cb$export$defe85febe8b728c).for), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
                value: dueDate,
                month: "short",
                day: "numeric"
            }))));
        };
        $[6] = dueDate;
        $[7] = status;
        $[8] = t5;
    } else t5 = $[8];
    const getStatusAndDate = t5;
    let t6;
    if ($[9] !== assignee?.thirdPartyUser?.name || $[10] !== createdBy?.thirdPartyUser?.name || $[11] !== formatMessage) {
        t6 = ()=>{
            let fullName;
            let firstName;
            let verbMessage;
            if (assignee?.thirdPartyUser?.name) {
                fullName = assignee?.thirdPartyUser?.name || "";
                verbMessage = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).isAssigned);
            } else {
                fullName = createdBy?.thirdPartyUser?.name || "";
                verbMessage = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).created);
            }
            firstName = fullName?.split(" ")?.[0] || formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).externalPersonLabel);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
                space: "space.025",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c900a01b74c1545$export$e2255cf6045e8d47), {
                name: fullName
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $4c2056d5893e6f6d$var$nameContainer
            }, firstName, " ", verbMessage));
        };
        $[9] = assignee?.thirdPartyUser?.name;
        $[10] = createdBy?.thirdPartyUser?.name;
        $[11] = formatMessage;
        $[12] = t6;
    } else t6 = $[12];
    const getAssigneeOrCreator = t6;
    let t7;
    if ($[13] !== formatMessage) {
        t7 = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).workItem);
        $[13] = formatMessage;
        $[14] = t7;
    } else t7 = $[14];
    let label = t7;
    if (subtype === "task") {
        let t8;
        if ($[15] !== formatMessage) {
            t8 = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).taskLabel);
            $[15] = formatMessage;
            $[16] = t8;
        } else t8 = $[16];
        label = t8;
    } else {
        if (subtype === "project") {
            let t8;
            if ($[17] !== formatMessage) {
                t8 = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).projectLabel);
                $[17] = formatMessage;
                $[18] = t8;
            } else t8 = $[18];
            label = t8;
        } else if (subtype === "ticket") {
            let t8;
            if ($[19] !== formatMessage) {
                t8 = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).ticketLabel);
                $[19] = formatMessage;
                $[20] = t8;
            } else t8 = $[20];
            label = t8;
        }
    }
    const t8 = partial.id;
    let t9;
    if ($[21] !== excerpt) {
        t9 = (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerpt, true);
        $[21] = excerpt;
        $[22] = t9;
    } else t9 = $[22];
    const t10 = !!selectedProduct;
    const t11 = label;
    const t12 = subtype === "ticket" && id ? `#${id}` : projectName;
    let t13;
    if ($[23] !== t12) {
        t13 = [
            "identifier",
            t12
        ];
        $[23] = t12;
        $[24] = t13;
    } else t13 = $[24];
    let t14;
    if ($[25] !== lastModifiedComponent) {
        t14 = [
            "last-modified",
            lastModifiedComponent
        ];
        $[25] = lastModifiedComponent;
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== padlockIcon) {
        t15 = [
            "padlock",
            padlockIcon
        ];
        $[27] = padlockIcon;
        $[28] = t15;
    } else t15 = $[28];
    let t16;
    if ($[29] !== getStatusAndDate) {
        t16 = getStatusAndDate();
        $[29] = getStatusAndDate;
        $[30] = t16;
    } else t16 = $[30];
    let t17;
    if ($[31] !== t16) {
        t17 = [
            "status",
            t16
        ];
        $[31] = t16;
        $[32] = t17;
    } else t17 = $[32];
    let t18;
    if ($[33] !== getAssigneeOrCreator) {
        t18 = [
            "person",
            getAssigneeOrCreator()
        ];
        $[33] = getAssigneeOrCreator;
        $[34] = t18;
    } else t18 = $[34];
    let t19;
    if ($[35] !== label || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== t17 || $[40] !== t18) {
        t19 = [
            t11,
            t13,
            t14,
            t15,
            t17,
            t18
        ];
        $[35] = label;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = t17;
        $[40] = t18;
        $[41] = t19;
    } else t19 = $[41];
    let t20;
    if ($[42] !== product || $[43] !== t10 || $[44] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: t10,
            parts: t19
        });
        $[42] = product;
        $[43] = t10;
        $[44] = t19;
        $[45] = t20;
    } else t20 = $[45];
    let t21;
    if ($[46] !== title) {
        t21 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title);
        $[46] = title;
        $[47] = t21;
    } else t21 = $[47];
    let t22;
    if ($[48] !== cloudId || $[49] !== icon || $[50] !== partial || $[51] !== position || $[52] !== primaryProduct || $[53] !== t20 || $[54] !== t21 || $[55] !== t9 || $[56] !== url) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            id: t8,
            icon: icon,
            description: t9,
            headerMetadata: t20,
            title: t21,
            url: url,
            isThirdParty: true,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[48] = cloudId;
        $[49] = icon;
        $[50] = partial;
        $[51] = position;
        $[52] = primaryProduct;
        $[53] = t20;
        $[54] = t21;
        $[55] = t9;
        $[56] = url;
        $[57] = t22;
    } else t22 = $[57];
    return t22;
} : ({ partial: partial, position: position, icon: icon, product: product })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, title: title, subtype: subtype } = partial;
    const { assignee: assignee, createdBy: createdBy, dueDate: dueDate, id: id, projectName: projectName, status: status } = entity || {};
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $81ab49e84b84cfe5$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getStatusAndDate = ()=>{
        if (!status) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $4c2056d5893e6f6d$var$statusAndDateContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: $4c2056d5893e6f6d$var$getStatusLozenge(status)
        }, status), dueDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $149a12367c3172cb$export$defe85febe8b728c).for), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
            value: dueDate,
            month: "short",
            day: "numeric"
        }))));
    };
    const getAssigneeOrCreator = ()=>{
        let fullName, firstName, verbMessage;
        if (assignee?.thirdPartyUser?.name) {
            fullName = assignee?.thirdPartyUser?.name || '';
            verbMessage = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).isAssigned);
        } else {
            fullName = createdBy?.thirdPartyUser?.name || '';
            verbMessage = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).created);
        }
        firstName = fullName?.split(' ')?.[0] || formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).externalPersonLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            space: "space.025",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c900a01b74c1545$export$e2255cf6045e8d47), {
            name: fullName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $4c2056d5893e6f6d$var$nameContainer
        }, firstName, " ", verbMessage));
    };
    let label = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).workItem);
    if (subtype === 'task') label = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).taskLabel);
    else if (subtype === 'project') label = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).projectLabel);
    else if (subtype === 'ticket') label = formatMessage((0, $149a12367c3172cb$export$defe85febe8b728c).ticketLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(excerpt, true),
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: !!selectedProduct,
            parts: [
                label,
                [
                    'identifier',
                    subtype === 'ticket' && id ? `#${id}` : projectName
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ],
                [
                    'padlock',
                    padlockIcon
                ],
                [
                    'status',
                    getStatusAndDate()
                ],
                [
                    'person',
                    getAssigneeOrCreator()
                ]
            ]
        }),
        title: (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};


const $9329fb93eda7f9aa$var$MICROSOFT_INTEGRATION_KEY = 'microsoft';
const $9329fb93eda7f9aa$var$SHAREPOINT_SUPPORTED_RESOURCE_TYPES = [
    'document'
];
const $9329fb93eda7f9aa$var$TEAMS_SUPPORTED_RESOURCE_TYPES = [
    'message',
    'conversation'
];
const $9329fb93eda7f9aa$var$getIcon = ({ integrationKey: integrationKey, resourceType: resourceType })=>{
    if (!integrationKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
    let productKey = integrationKey === 'google' ? (0, $37AYo.ProductKeys).GoogleDrive : integrationKey;
    /**
   * Temporary fix for Microsoft integrationKey
   */ if (integrationKey === $9329fb93eda7f9aa$var$MICROSOFT_INTEGRATION_KEY && $9329fb93eda7f9aa$var$SHAREPOINT_SUPPORTED_RESOURCE_TYPES.includes(resourceType)) productKey = (0, $37AYo.ProductKeys).Sharepoint;
    else if (integrationKey === $9329fb93eda7f9aa$var$MICROSOFT_INTEGRATION_KEY && $9329fb93eda7f9aa$var$TEAMS_SUPPORTED_RESOURCE_TYPES.includes(resourceType)) productKey = (0, $37AYo.ProductKeys).Teams;
    let IconComponent = (0, $37AYo.products)[productKey]?.SearchResultIcon || (0, $37AYo.products)[productKey]?.Icon;
    return IconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
        appearance: "brand",
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
};
const $9329fb93eda7f9aa$export$b86b424e0d4929fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(62);
    const { partial: partial, position: position } = t0;
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    let integrationKey;
    let resultAri;
    let t2;
    if ($[0] !== partial.id || $[1] !== partial.integrationId) {
        resultAri = (0, $7avaU.AnyAri).parse(partial.id);
        integrationKey = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
        t2 = $9329fb93eda7f9aa$var$getIcon({
            integrationKey: integrationKey,
            resourceType: resultAri.resourceType
        });
        $[0] = partial.id;
        $[1] = partial.integrationId;
        $[2] = integrationKey;
        $[3] = resultAri;
        $[4] = t2;
    } else {
        integrationKey = $[2];
        resultAri = $[3];
        t2 = $[4];
    }
    const icon = t2;
    if ((0, $ah5yI.isConversationEntity)(partial)) {
        let t3;
        if ($[5] !== cloudId || $[6] !== icon || $[7] !== integrationKey || $[8] !== partial || $[9] !== position || $[10] !== resultAri) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88e604f7a5fc15eb$export$4534f971846d5b0b), {
                partial: partial,
                position: position,
                icon: icon,
                integrationKey: integrationKey,
                resultAri: resultAri,
                cloudId: cloudId
            });
            $[5] = cloudId;
            $[6] = icon;
            $[7] = integrationKey;
            $[8] = partial;
            $[9] = position;
            $[10] = resultAri;
            $[11] = t3;
        } else t3 = $[11];
        return t3;
    }
    if ((0, $ah5yI.isDesignEntity)(partial)) {
        let t3;
        if ($[12] !== icon || $[13] !== partial || $[14] !== position) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ae16e5f1b27f4f3$export$f6a73210de3b9a3b), {
                partial: partial,
                position: position,
                icon: icon
            });
            $[12] = icon;
            $[13] = partial;
            $[14] = position;
            $[15] = t3;
        } else t3 = $[15];
        return t3;
    }
    if ((0, $ah5yI.isBranchEntity)(partial)) {
        let t3;
        if ($[16] !== icon || $[17] !== partial || $[18] !== position) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb628f3bbf293e2d$export$5620ef5d10869020), {
                partial: partial,
                position: position,
                icon: icon
            });
            $[16] = icon;
            $[17] = partial;
            $[18] = position;
            $[19] = t3;
        } else t3 = $[19];
        return t3;
    }
    if ((0, $ah5yI.isCommitEntity)(partial)) {
        let t3;
        if ($[20] !== icon || $[21] !== partial || $[22] !== position) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cceb87146273e5fe$export$35c708bc36dbd879), {
                partial: partial,
                position: position,
                icon: icon
            });
            $[20] = icon;
            $[21] = partial;
            $[22] = position;
            $[23] = t3;
        } else t3 = $[23];
        return t3;
    }
    if ((0, $ah5yI.isPullRequestEntity)(partial)) {
        let t3;
        if ($[24] !== icon || $[25] !== partial || $[26] !== position) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7af05f962af8542$export$fcb233d1869c46a3), {
                partial: partial,
                position: position,
                icon: icon
            });
            $[24] = icon;
            $[25] = partial;
            $[26] = position;
            $[27] = t3;
        } else t3 = $[27];
        return t3;
    }
    if ((0, $ah5yI.isRepositoryEntity)(partial)) {
        let t3;
        if ($[28] !== icon || $[29] !== partial || $[30] !== position) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0adf0fe6c572ea8$export$334ba9b7628e002a), {
                partial: partial,
                position: position,
                icon: icon
            });
            $[28] = icon;
            $[29] = partial;
            $[30] = position;
            $[31] = t3;
        } else t3 = $[31];
        return t3;
    }
    if ((0, $ah5yI.isVideoEntity)(partial)) {
        let t3;
        if ($[32] !== icon || $[33] !== partial || $[34] !== position) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $601d3403b9925a73$export$d343a98cb833c8b), {
                partial: partial,
                position: position,
                icon: icon
            });
            $[32] = icon;
            $[33] = partial;
            $[34] = position;
            $[35] = t3;
        } else t3 = $[35];
        return t3;
    }
    if ((0, $ah5yI.isMessageEntity)(partial)) {
        let t3;
        if ($[36] !== icon || $[37] !== partial || $[38] !== position) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9baa6c1d486b4cf$export$423dfe6469a8e0dd), {
                partial: partial,
                position: position,
                icon: icon
            });
            $[36] = icon;
            $[37] = partial;
            $[38] = position;
            $[39] = t3;
        } else t3 = $[39];
        return t3;
    }
    if ((0, $ah5yI.isDocumentEntity)(partial)) {
        let t3;
        if ($[40] !== icon || $[41] !== integrationKey || $[42] !== partial || $[43] !== position || $[44] !== resultAri) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $328556d5016888fe$export$43fa1bdcdc4d31ed), {
                partial: partial,
                position: position,
                resultAri: resultAri,
                icon: icon,
                integrationKey: integrationKey
            });
            $[40] = icon;
            $[41] = integrationKey;
            $[42] = partial;
            $[43] = position;
            $[44] = resultAri;
            $[45] = t3;
        } else t3 = $[45];
        return t3;
    }
    if ((0, $ah5yI.isCalendarEventEntity)(partial)) {
        let t3;
        if ($[46] !== icon || $[47] !== integrationKey || $[48] !== partial || $[49] !== position) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $364e1a9ab72bb427$export$2d6c717667f5157c), {
                partial: partial,
                position: position,
                icon: icon,
                product: integrationKey
            });
            $[46] = icon;
            $[47] = integrationKey;
            $[48] = partial;
            $[49] = position;
            $[50] = t3;
        } else t3 = $[50];
        return t3;
    }
    if ((0, $ah5yI.isWorkItemEntity)(partial)) {
        let t3;
        if ($[51] !== icon || $[52] !== integrationKey || $[53] !== partial || $[54] !== position) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4c2056d5893e6f6d$export$35f8af203ce4264d), {
                partial: partial,
                position: position,
                icon: icon,
                product: integrationKey
            });
            $[51] = icon;
            $[52] = integrationKey;
            $[53] = partial;
            $[54] = position;
            $[55] = t3;
        } else t3 = $[55];
        return t3;
    }
    const t3 = partial;
    let t4;
    if ($[56] !== icon || $[57] !== integrationKey || $[58] !== position || $[59] !== resultAri || $[60] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad3393f69a26b05b$export$2917a391c04f0e93), {
            partial: t3,
            position: position,
            resultAri: resultAri,
            icon: icon,
            integrationKey: integrationKey
        });
        $[56] = icon;
        $[57] = integrationKey;
        $[58] = position;
        $[59] = resultAri;
        $[60] = t3;
        $[61] = t4;
    } else t4 = $[61];
    return t4;
} : ({ partial: partial, position: position })=>{
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const resultAri = (0, $7avaU.AnyAri).parse(partial.id);
    const integrationKey = (0, $8a1a5c2af543b4cc$export$fb63ba58603395b8)(partial.integrationId);
    const icon = $9329fb93eda7f9aa$var$getIcon({
        integrationKey: integrationKey,
        resourceType: resultAri.resourceType
    });
    if ((0, $ah5yI.isConversationEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88e604f7a5fc15eb$export$4534f971846d5b0b), {
        partial: partial,
        position: position,
        icon: icon,
        integrationKey: integrationKey,
        resultAri: resultAri,
        cloudId: cloudId
    });
    if ((0, $ah5yI.isDesignEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ae16e5f1b27f4f3$export$f6a73210de3b9a3b), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $ah5yI.isBranchEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb628f3bbf293e2d$export$5620ef5d10869020), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $ah5yI.isCommitEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cceb87146273e5fe$export$35c708bc36dbd879), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $ah5yI.isPullRequestEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7af05f962af8542$export$fcb233d1869c46a3), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $ah5yI.isRepositoryEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0adf0fe6c572ea8$export$334ba9b7628e002a), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $ah5yI.isVideoEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $601d3403b9925a73$export$d343a98cb833c8b), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $ah5yI.isMessageEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9baa6c1d486b4cf$export$423dfe6469a8e0dd), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $ah5yI.isDocumentEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $328556d5016888fe$export$43fa1bdcdc4d31ed), {
        partial: partial,
        position: position,
        resultAri: resultAri,
        icon: icon,
        integrationKey: integrationKey
    });
    if ((0, $ah5yI.isCalendarEventEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $364e1a9ab72bb427$export$2d6c717667f5157c), {
        partial: partial,
        position: position,
        icon: icon,
        product: integrationKey
    });
    if ((0, $ah5yI.isWorkItemEntity)(partial)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4c2056d5893e6f6d$export$35f8af203ce4264d), {
        partial: partial,
        position: position,
        icon: icon,
        product: integrationKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad3393f69a26b05b$export$2917a391c04f0e93), {
        partial: partial,
        position: position,
        resultAri: resultAri,
        icon: icon,
        integrationKey: integrationKey
    });
};



























/* product-result-utils.tsx generated by @compiled/babel-plugin v2.0.0 */ 

















const $ed562f534adea649$export$15f5952b52a8f495 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M20.5938 24H8.40625C7.63281 24 7 23.3864 7 22.6364V5.36364C7 4.61364 7.63281 4 8.40625 4H16.8438L22 9V22.6364C22 23.3864 21.3672 24 20.5938 24Z",
            fill: "#3086F6"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.8438 4L22 9H16.8438V4Z",
            fill: "#0C67D6"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M18.7188 12.8634H10.2812V11.7271H18.7188V12.8634ZM18.7188 14.4543H10.2812V15.5907H18.7188V14.4543ZM16.375 17.1816H10.2812V18.318H16.375V17.1816Z",
            fill: "#FDFFFF"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M20.5938 24H8.40625C7.63281 24 7 23.3864 7 22.6364V5.36364C7 4.61364 7.63281 4 8.40625 4H16.8438L22 9V22.6364C22 23.3864 21.3672 24 20.5938 24Z",
        fill: "#3086F6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.8438 4L22 9H16.8438V4Z",
        fill: "#0C67D6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M18.7188 12.8634H10.2812V11.7271H18.7188V12.8634ZM18.7188 14.4543H10.2812V15.5907H18.7188V14.4543ZM16.375 17.1816H10.2812V18.318H16.375V17.1816Z",
        fill: "#FDFFFF"
    }));











const $0e3070a2599cd8a2$export$4fa264492a686961 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(19);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask0_271_181646",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask0_271_181646)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L18.7188 7.18182L16.375 4Z",
            fill: "#F4B400"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask1_271_181646",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask1_271_181646)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M17.5469 13.0908H11.4531C11.0664 13.0908 10.75 13.3976 10.75 13.7726V19.6817C10.75 20.0567 11.0664 20.3635 11.4531 20.3635H17.5469C17.9336 20.3635 18.25 20.0567 18.25 19.6817V13.7726C18.25 13.3976 17.9336 13.0908 17.5469 13.0908ZM17.3125 18.3181H11.6875V15.1363H17.3125V18.3181Z",
            fill: "#F1F1F1"
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask2_271_181646",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask2_271_181646)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.7866 9.05518L22.0003 14.1097V9.45404L16.7866 9.05518Z",
            fill: "url(#paint0_linear_271_181646)"
        }));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask3_271_181646",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask3_271_181646)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4V8.09091C16.375 8.84432 17.0043 9.45454 17.7813 9.45454H22L16.375 4Z",
            fill: "#FADA80"
        }));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask4_271_181646",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask4_271_181646)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4V4.11364L21.8828 9.45454H22L16.375 4Z",
            fill: "white",
            fillOpacity: "0.1"
        }));
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask5_271_181646",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[10] = t10;
    } else t10 = $[10];
    let t11;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask5_271_181646)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M8.40625 4C7.63281 4 7 4.61364 7 5.36364V5.47727C7 4.72727 7.63281 4.11364 8.40625 4.11364H16.375V4H8.40625Z",
            fill: "white",
            fillOpacity: "0.2"
        }));
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask6_271_181646",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[12] = t12;
    } else t12 = $[12];
    let t13;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask6_271_181646)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M20.5937 23.8866H8.40625C7.63281 23.8866 7 23.2729 7 22.5229V22.6366C7 23.3866 7.63281 24.0002 8.40625 24.0002H20.5937C21.3672 24.0002 22 23.3866 22 22.6366V22.5229C22 23.2729 21.3672 23.8866 20.5937 23.8866Z",
            fill: "#BF360C",
            fillOpacity: "0.2"
        }));
        $[13] = t13;
    } else t13 = $[13];
    let t14;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask7_271_181646",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[14] = t14;
    } else t14 = $[14];
    let t15;
    let t16;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask7_271_181646)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M17.7812 9.45494C17.0043 9.45494 16.375 8.84472 16.375 8.09131V8.20495C16.375 8.95835 17.0043 9.56858 17.7812 9.56858H22V9.45494H17.7812Z",
            fill: "#BF360C",
            fillOpacity: "0.1"
        }));
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "url(#paint1_radial_271_181646)"
        });
        $[15] = t15;
        $[16] = t16;
    } else {
        t15 = $[15];
        t16 = $[16];
    }
    let t17;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint0_linear_271_181646",
            x1: "277.498",
            y1: "52.454",
            x2: "277.498",
            y2: "514.58",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#BF360C",
            stopOpacity: "0.2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#BF360C",
            stopOpacity: "0.02"
        }));
        $[17] = t17;
    } else t17 = $[17];
    let t18;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t17, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint1_radial_271_181646",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(54.5207 43.5288) scale(2418.73 2345.43)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "white",
            stopOpacity: "0.1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "white",
            stopOpacity: "0"
        }))));
        $[18] = t18;
    } else t18 = $[18];
    return t18;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask0_271_181646",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask0_271_181646)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L18.7188 7.18182L16.375 4Z",
        fill: "#F4B400"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask1_271_181646",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask1_271_181646)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M17.5469 13.0908H11.4531C11.0664 13.0908 10.75 13.3976 10.75 13.7726V19.6817C10.75 20.0567 11.0664 20.3635 11.4531 20.3635H17.5469C17.9336 20.3635 18.25 20.0567 18.25 19.6817V13.7726C18.25 13.3976 17.9336 13.0908 17.5469 13.0908ZM17.3125 18.3181H11.6875V15.1363H17.3125V18.3181Z",
        fill: "#F1F1F1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask2_271_181646",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask2_271_181646)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.7866 9.05518L22.0003 14.1097V9.45404L16.7866 9.05518Z",
        fill: "url(#paint0_linear_271_181646)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask3_271_181646",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask3_271_181646)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4V8.09091C16.375 8.84432 17.0043 9.45454 17.7813 9.45454H22L16.375 4Z",
        fill: "#FADA80"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask4_271_181646",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask4_271_181646)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4V4.11364L21.8828 9.45454H22L16.375 4Z",
        fill: "white",
        fillOpacity: "0.1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask5_271_181646",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask5_271_181646)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.40625 4C7.63281 4 7 4.61364 7 5.36364V5.47727C7 4.72727 7.63281 4.11364 8.40625 4.11364H16.375V4H8.40625Z",
        fill: "white",
        fillOpacity: "0.2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask6_271_181646",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask6_271_181646)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M20.5937 23.8866H8.40625C7.63281 23.8866 7 23.2729 7 22.5229V22.6366C7 23.3866 7.63281 24.0002 8.40625 24.0002H20.5937C21.3672 24.0002 22 23.3866 22 22.6366V22.5229C22 23.2729 21.3672 23.8866 20.5937 23.8866Z",
        fill: "#BF360C",
        fillOpacity: "0.2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask7_271_181646",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask7_271_181646)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M17.7812 9.45494C17.0043 9.45494 16.375 8.84472 16.375 8.09131V8.20495C16.375 8.95835 17.0043 9.56858 17.7812 9.56858H22V9.45494H17.7812Z",
        fill: "#BF360C",
        fillOpacity: "0.1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "url(#paint1_radial_271_181646)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_271_181646",
        x1: "277.498",
        y1: "52.454",
        x2: "277.498",
        y2: "514.58",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#BF360C",
        stopOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#BF360C",
        stopOpacity: "0.02"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
        id: "paint1_radial_271_181646",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(54.5207 43.5288) scale(2418.73 2345.43)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "white",
        stopOpacity: "0.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "white",
        stopOpacity: "0"
    }))));











const $aa85bb6060b32d72$export$26bbd899e059afb8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(17);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask0_271_181645",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask0_271_181645)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L18.7188 7.18182L16.375 4Z",
            fill: "#0F9D58"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask1_271_181645",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask1_271_181645)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M10.75 13.7734V20.3643H18.25V13.7734H10.75ZM14.0313 19.4553H11.6875V18.3189H14.0313V19.4553ZM14.0313 17.6371H11.6875V16.5007H14.0313V17.6371ZM14.0313 15.8189H11.6875V14.6825H14.0313V15.8189ZM17.3125 19.4553H14.9688V18.3189H17.3125V19.4553ZM17.3125 17.6371H14.9688V16.5007H17.3125V17.6371ZM17.3125 15.8189H14.9688V14.6825H17.3125V15.8189Z",
            fill: "#F1F1F1"
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask2_271_181645",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask2_271_181645)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.7866 9.05518L22.0003 14.1097V9.45404L16.7866 9.05518Z",
            fill: "url(#paint0_linear_271_181645)"
        }));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask3_271_181645",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask3_271_181645)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4V8.09091C16.375 8.84432 17.0043 9.45454 17.7813 9.45454H22L16.375 4Z",
            fill: "#87CEAC"
        }));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask4_271_181645",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask4_271_181645)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M8.40625 4C7.63281 4 7 4.61364 7 5.36364V5.47727C7 4.72727 7.63281 4.11364 8.40625 4.11364H16.375V4H8.40625Z",
            fill: "white",
            fillOpacity: "0.2"
        }));
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask5_271_181645",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[10] = t10;
    } else t10 = $[10];
    let t11;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask5_271_181645)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M20.5937 23.8866H8.40625C7.63281 23.8866 7 23.2729 7 22.5229V22.6366C7 23.3866 7.63281 24.0002 8.40625 24.0002H20.5937C21.3672 24.0002 22 23.3866 22 22.6366V22.5229C22 23.2729 21.3672 23.8866 20.5937 23.8866Z",
            fill: "#263238",
            fillOpacity: "0.2"
        }));
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask6_271_181645",
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "4",
            width: "15",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "white"
        }));
        $[12] = t12;
    } else t12 = $[12];
    let t13;
    let t14;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask6_271_181645)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M17.7812 9.45494C17.0043 9.45494 16.375 8.84472 16.375 8.09131V8.20495C16.375 8.95835 17.0043 9.56858 17.7812 9.56858H22V9.45494H17.7812Z",
            fill: "#263238",
            fillOpacity: "0.1"
        }));
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
            fill: "url(#paint1_radial_271_181645)"
        });
        $[13] = t13;
        $[14] = t14;
    } else {
        t13 = $[13];
        t14 = $[14];
    }
    let t15;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint0_linear_271_181645",
            x1: "277.498",
            y1: "52.454",
            x2: "277.498",
            y2: "514.58",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "#263238",
            stopOpacity: "0.2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "#263238",
            stopOpacity: "0.02"
        }));
        $[15] = t15;
    } else t15 = $[15];
    let t16;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t15, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
            id: "paint1_radial_271_181645",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(54.5207 43.5288) scale(2418.73 2345.43)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: "white",
            stopOpacity: "0.1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: "white",
            stopOpacity: "0"
        }))));
        $[16] = t16;
    } else t16 = $[16];
    return t16;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask0_271_181645",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask0_271_181645)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L18.7188 7.18182L16.375 4Z",
        fill: "#0F9D58"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask1_271_181645",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask1_271_181645)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M10.75 13.7734V20.3643H18.25V13.7734H10.75ZM14.0313 19.4553H11.6875V18.3189H14.0313V19.4553ZM14.0313 17.6371H11.6875V16.5007H14.0313V17.6371ZM14.0313 15.8189H11.6875V14.6825H14.0313V15.8189ZM17.3125 19.4553H14.9688V18.3189H17.3125V19.4553ZM17.3125 17.6371H14.9688V16.5007H17.3125V17.6371ZM17.3125 15.8189H14.9688V14.6825H17.3125V15.8189Z",
        fill: "#F1F1F1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask2_271_181645",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask2_271_181645)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.7866 9.05518L22.0003 14.1097V9.45404L16.7866 9.05518Z",
        fill: "url(#paint0_linear_271_181645)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask3_271_181645",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask3_271_181645)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4V8.09091C16.375 8.84432 17.0043 9.45454 17.7813 9.45454H22L16.375 4Z",
        fill: "#87CEAC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask4_271_181645",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask4_271_181645)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.40625 4C7.63281 4 7 4.61364 7 5.36364V5.47727C7 4.72727 7.63281 4.11364 8.40625 4.11364H16.375V4H8.40625Z",
        fill: "white",
        fillOpacity: "0.2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask5_271_181645",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask5_271_181645)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M20.5937 23.8866H8.40625C7.63281 23.8866 7 23.2729 7 22.5229V22.6366C7 23.3866 7.63281 24.0002 8.40625 24.0002H20.5937C21.3672 24.0002 22 23.3866 22 22.6366V22.5229C22 23.2729 21.3672 23.8866 20.5937 23.8866Z",
        fill: "#263238",
        fillOpacity: "0.2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask6_271_181645",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "4",
        width: "15",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask6_271_181645)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M17.7812 9.45494C17.0043 9.45494 16.375 8.84472 16.375 8.09131V8.20495C16.375 8.95835 17.0043 9.56858 17.7812 9.56858H22V9.45494H17.7812Z",
        fill: "#263238",
        fillOpacity: "0.1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
        fill: "url(#paint1_radial_271_181645)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_271_181645",
        x1: "277.498",
        y1: "52.454",
        x2: "277.498",
        y2: "514.58",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#263238",
        stopOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#263238",
        stopOpacity: "0.02"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
        id: "paint1_radial_271_181645",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(54.5207 43.5288) scale(2418.73 2345.43)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "white",
        stopOpacity: "0.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "white",
        stopOpacity: "0"
    }))));











const $11402bf95f875780$export$543eca71a8a23d8c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_271_181625)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.1472 3H7.50344C7.03258 3 6.65088 3.37303 6.65088 3.83318V7.54545L14.5579 9.81818L21.9997 7.54545V3.83318C21.9997 3.37303 21.618 3 21.1472 3Z",
            fill: "#41A5EE"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.9997 7.54541H6.65088V12.0909L14.5579 13.4545L21.9997 12.0909V7.54541Z",
            fill: "#2B7CD3"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M6.65088 12.0908V16.6363L14.0927 17.5454L21.9997 16.6363V12.0908H6.65088Z",
            fill: "#185ABD"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M7.50344 21.1819H21.1472C21.618 21.1819 21.9997 20.8089 21.9997 20.3487V16.6365H6.65088V20.3487C6.65088 20.8089 7.03258 21.1819 7.50344 21.1819Z",
            fill: "#103F91"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M12.3099 6.63647H6.65088V18.0001H12.3099C12.7802 17.9986 13.161 17.6265 13.1625 17.1669V7.46966C13.161 7.01013 12.7802 6.63797 12.3099 6.63647Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.8448 7.09082H6.65088V18.4545H11.8448C12.315 18.453 12.6959 18.0808 12.6974 17.6213V7.924C12.6959 7.46447 12.315 7.09232 11.8448 7.09082Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.8448 7.09082H6.65088V17.5454H11.8448C12.315 17.5439 12.6959 17.1717 12.6974 16.7122V7.924C12.6959 7.46447 12.315 7.09232 11.8448 7.09082Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.3797 7.09082H6.65088V17.5454H11.3797C11.8499 17.5439 12.2307 17.1717 12.2323 16.7122V7.924C12.2307 7.46447 11.8499 7.09232 11.3797 7.09082Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M2.85256 7.09082H11.38C11.8509 7.09082 12.2326 7.46385 12.2326 7.924V16.2576C12.2326 16.7178 11.8509 17.0908 11.38 17.0908H2.85256C2.3817 17.0908 2 16.7178 2 16.2576V7.924C2 7.46385 2.3817 7.09082 2.85256 7.09082Z",
            fill: "#1a5bb8"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M5.49864 13.4809C5.51538 13.6095 5.52654 13.7213 5.53166 13.8172H5.55119C5.55863 13.7263 5.57413 13.6168 5.5977 13.4886C5.62127 13.3604 5.64251 13.2521 5.66142 13.1636L6.55817 9.38268H7.7177L8.64793 13.1068C8.70198 13.3383 8.74067 13.5731 8.76375 13.8095H8.7791C8.79644 13.5804 8.82876 13.3527 8.87585 13.1277L9.61771 9.38086H10.6731L9.3698 14.799H8.13677L7.25305 11.2109C7.22748 11.1077 7.19818 10.9727 7.16608 10.8068C7.13398 10.6408 7.11399 10.5195 7.10608 10.4431H7.09073C7.0805 10.5313 7.06049 10.6622 7.03072 10.8359C7.00096 11.0095 6.97708 11.138 6.95909 11.2213L6.12839 14.7981H4.87443L3.56421 9.38267H4.63862L5.44653 13.1713C5.46468 13.249 5.48189 13.3527 5.49864 13.4809Z",
            fill: "white"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_271_181625"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "18.1818",
            fill: "white",
            transform: "translate(2 3)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_271_181625)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.1472 3H7.50344C7.03258 3 6.65088 3.37303 6.65088 3.83318V7.54545L14.5579 9.81818L21.9997 7.54545V3.83318C21.9997 3.37303 21.618 3 21.1472 3Z",
        fill: "#41A5EE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.9997 7.54541H6.65088V12.0909L14.5579 13.4545L21.9997 12.0909V7.54541Z",
        fill: "#2B7CD3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M6.65088 12.0908V16.6363L14.0927 17.5454L21.9997 16.6363V12.0908H6.65088Z",
        fill: "#185ABD"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.50344 21.1819H21.1472C21.618 21.1819 21.9997 20.8089 21.9997 20.3487V16.6365H6.65088V20.3487C6.65088 20.8089 7.03258 21.1819 7.50344 21.1819Z",
        fill: "#103F91"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M12.3099 6.63647H6.65088V18.0001H12.3099C12.7802 17.9986 13.161 17.6265 13.1625 17.1669V7.46966C13.161 7.01013 12.7802 6.63797 12.3099 6.63647Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.8448 7.09082H6.65088V18.4545H11.8448C12.315 18.453 12.6959 18.0808 12.6974 17.6213V7.924C12.6959 7.46447 12.315 7.09232 11.8448 7.09082Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.8448 7.09082H6.65088V17.5454H11.8448C12.315 17.5439 12.6959 17.1717 12.6974 16.7122V7.924C12.6959 7.46447 12.315 7.09232 11.8448 7.09082Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.3797 7.09082H6.65088V17.5454H11.3797C11.8499 17.5439 12.2307 17.1717 12.2323 16.7122V7.924C12.2307 7.46447 11.8499 7.09232 11.3797 7.09082Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M2.85256 7.09082H11.38C11.8509 7.09082 12.2326 7.46385 12.2326 7.924V16.2576C12.2326 16.7178 11.8509 17.0908 11.38 17.0908H2.85256C2.3817 17.0908 2 16.7178 2 16.2576V7.924C2 7.46385 2.3817 7.09082 2.85256 7.09082Z",
        fill: "#1a5bb8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5.49864 13.4809C5.51538 13.6095 5.52654 13.7213 5.53166 13.8172H5.55119C5.55863 13.7263 5.57413 13.6168 5.5977 13.4886C5.62127 13.3604 5.64251 13.2521 5.66142 13.1636L6.55817 9.38268H7.7177L8.64793 13.1068C8.70198 13.3383 8.74067 13.5731 8.76375 13.8095H8.7791C8.79644 13.5804 8.82876 13.3527 8.87585 13.1277L9.61771 9.38086H10.6731L9.3698 14.799H8.13677L7.25305 11.2109C7.22748 11.1077 7.19818 10.9727 7.16608 10.8068C7.13398 10.6408 7.11399 10.5195 7.10608 10.4431H7.09073C7.0805 10.5313 7.06049 10.6622 7.03072 10.8359C7.00096 11.0095 6.97708 11.138 6.95909 11.2213L6.12839 14.7981H4.87443L3.56421 9.38267H4.63862L5.44653 13.1713C5.46468 13.249 5.48189 13.3527 5.49864 13.4809Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_271_181625"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "18.1818",
        fill: "white",
        transform: "translate(2 3)"
    }))));











const $0a0a5a0a11733173$export$ad243ee11ac5af03 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_271_181627)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.0927 12.5417L12.6973 2H12.5932C7.51931 2.01526 3.40983 6.24888 3.39502 11.476V11.5833L14.0927 12.5417Z",
            fill: "#ED6C47"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12.8015 2H12.6973V11.5833L17.3484 13.5L21.9996 11.5833V11.476C21.9848 6.24888 17.8753 2.01526 12.8015 2Z",
            fill: "#FF8F6B"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.9997 11.5833V11.6887C21.9851 16.917 17.8746 21.1516 12.7997 21.1666H12.595C7.52004 21.1516 3.40958 16.917 3.39502 11.6887V11.5833H21.9997Z",
            fill: "#D35230"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M13.1625 6.71013V16.9355C13.1602 17.2909 12.9512 17.6101 12.6322 17.7453C12.5307 17.7896 12.4216 17.8124 12.3113 17.8124H5.59038C5.46015 17.6591 5.33457 17.4962 5.21829 17.3333C4.03331 15.7047 3.39349 13.724 3.39503 11.6887V11.4778C3.39231 9.64206 3.9131 7.8459 4.8927 6.31242C4.99503 6.1495 5.102 5.98659 5.21829 5.83325H12.3113C12.7799 5.83691 13.1589 6.22737 13.1625 6.71013Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M12.6974 7.18938V17.4148C12.6973 17.5284 12.6752 17.6408 12.6322 17.7454C12.5009 18.074 12.1911 18.2893 11.8462 18.2917H6.01364C5.86648 18.1378 5.72528 17.9779 5.59038 17.8125C5.46015 17.6592 5.33457 17.4962 5.21829 17.3333C4.03331 15.7048 3.39349 13.724 3.39503 11.6887V11.4779C3.39231 9.64214 3.9131 7.84598 4.8927 6.3125H11.8462C12.3148 6.31615 12.6938 6.70661 12.6974 7.18938Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M12.6974 7.18937V16.4565C12.6938 16.9392 12.3148 17.3297 11.8462 17.3333H5.21829C4.03331 15.7048 3.39349 13.724 3.39503 11.6887V11.4779C3.39231 9.64214 3.9131 7.84598 4.8927 6.3125H11.8462C12.3148 6.31614 12.6938 6.7066 12.6974 7.18937Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M12.2322 7.18937V16.4565C12.2287 16.9392 11.8497 17.3297 11.3811 17.3333H5.21829C4.03331 15.7048 3.39349 13.724 3.39503 11.6887V11.4779C3.39231 9.64214 3.9131 7.84598 4.8927 6.3125H11.3811C11.8497 6.31614 12.2287 6.7066 12.2322 7.18937Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M2.85231 6.3125H11.3798C11.8506 6.3125 12.2323 6.70574 12.2323 7.19081V15.9758C12.2323 16.4609 11.8506 16.8542 11.3798 16.8542H2.85231C2.38146 16.8542 1.99976 16.4609 1.99976 15.9759V7.19081C1.99976 6.70574 2.38146 6.3125 2.85231 6.3125Z",
            fill: "#c54220"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M7.20915 8.65514C7.76426 8.61655 8.31459 8.78266 8.76171 9.12377C9.13464 9.46676 9.3339 9.96726 9.30217 10.4812C9.30827 10.8385 9.21585 11.1903 9.03567 11.4956C8.85325 11.7957 8.59043 12.035 8.27892 12.1847C7.9228 12.3553 7.53344 12.4396 7.14077 12.431H6.06217V14.4962H4.95752V8.65514H7.20915ZM6.06125 11.5388H7.01195C7.31334 11.5616 7.61239 11.4697 7.85242 11.2805C8.05094 11.0843 8.155 10.8076 8.1366 10.5249C8.1366 9.88117 7.7735 9.55933 7.0473 9.55933H6.06126V11.5388H6.06125Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_271_181627"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "19.1667",
            fill: "white",
            transform: "translate(2 2)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_271_181627)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.0927 12.5417L12.6973 2H12.5932C7.51931 2.01526 3.40983 6.24888 3.39502 11.476V11.5833L14.0927 12.5417Z",
        fill: "#ED6C47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.8015 2H12.6973V11.5833L17.3484 13.5L21.9996 11.5833V11.476C21.9848 6.24888 17.8753 2.01526 12.8015 2Z",
        fill: "#FF8F6B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.9997 11.5833V11.6887C21.9851 16.917 17.8746 21.1516 12.7997 21.1666H12.595C7.52004 21.1516 3.40958 16.917 3.39502 11.6887V11.5833H21.9997Z",
        fill: "#D35230"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M13.1625 6.71013V16.9355C13.1602 17.2909 12.9512 17.6101 12.6322 17.7453C12.5307 17.7896 12.4216 17.8124 12.3113 17.8124H5.59038C5.46015 17.6591 5.33457 17.4962 5.21829 17.3333C4.03331 15.7047 3.39349 13.724 3.39503 11.6887V11.4778C3.39231 9.64206 3.9131 7.8459 4.8927 6.31242C4.99503 6.1495 5.102 5.98659 5.21829 5.83325H12.3113C12.7799 5.83691 13.1589 6.22737 13.1625 6.71013Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.6974 7.18938V17.4148C12.6973 17.5284 12.6752 17.6408 12.6322 17.7454C12.5009 18.074 12.1911 18.2893 11.8462 18.2917H6.01364C5.86648 18.1378 5.72528 17.9779 5.59038 17.8125C5.46015 17.6592 5.33457 17.4962 5.21829 17.3333C4.03331 15.7048 3.39349 13.724 3.39503 11.6887V11.4779C3.39231 9.64214 3.9131 7.84598 4.8927 6.3125H11.8462C12.3148 6.31615 12.6938 6.70661 12.6974 7.18938Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.6974 7.18937V16.4565C12.6938 16.9392 12.3148 17.3297 11.8462 17.3333H5.21829C4.03331 15.7048 3.39349 13.724 3.39503 11.6887V11.4779C3.39231 9.64214 3.9131 7.84598 4.8927 6.3125H11.8462C12.3148 6.31614 12.6938 6.7066 12.6974 7.18937Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.2322 7.18937V16.4565C12.2287 16.9392 11.8497 17.3297 11.3811 17.3333H5.21829C4.03331 15.7048 3.39349 13.724 3.39503 11.6887V11.4779C3.39231 9.64214 3.9131 7.84598 4.8927 6.3125H11.3811C11.8497 6.31614 12.2287 6.7066 12.2322 7.18937Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M2.85231 6.3125H11.3798C11.8506 6.3125 12.2323 6.70574 12.2323 7.19081V15.9758C12.2323 16.4609 11.8506 16.8542 11.3798 16.8542H2.85231C2.38146 16.8542 1.99976 16.4609 1.99976 15.9759V7.19081C1.99976 6.70574 2.38146 6.3125 2.85231 6.3125Z",
        fill: "#c54220"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.20915 8.65514C7.76426 8.61655 8.31459 8.78266 8.76171 9.12377C9.13464 9.46676 9.3339 9.96726 9.30217 10.4812C9.30827 10.8385 9.21585 11.1903 9.03567 11.4956C8.85325 11.7957 8.59043 12.035 8.27892 12.1847C7.9228 12.3553 7.53344 12.4396 7.14077 12.431H6.06217V14.4962H4.95752V8.65514H7.20915ZM6.06125 11.5388H7.01195C7.31334 11.5616 7.61239 11.4697 7.85242 11.2805C8.05094 11.0843 8.155 10.8076 8.1366 10.5249C8.1366 9.88117 7.7735 9.55933 7.0473 9.55933H6.06126V11.5388H6.06125Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_271_181627"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "19.1667",
        fill: "white",
        transform: "translate(2 2)"
    }))));











const $b6125520c1b2fab5$export$44eea01b1a1915e7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_271_181626)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.5583 11.7083L6.65137 10.3333V20.4931C6.65137 20.9571 7.03307 21.3333 7.50392 21.3333H21.1476C21.6185 21.3333 22.0002 20.9571 22.0002 20.4931V16.7499L14.5583 11.7083Z",
            fill: "#185C37"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.5583 3H7.50392C7.03307 3 6.65137 3.37613 6.65137 3.84012V7.58333L14.5583 12.1667L18.7444 13.5417L22.0002 12.1667V7.58333L14.5583 3Z",
            fill: "#21A366"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M6.65137 7.58325H14.5583V12.1666H6.65137V7.58325Z",
            fill: "#107C41"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M12.3104 6.66675H6.65137V18.1251H12.3104C12.7807 18.1236 13.1615 17.7483 13.163 17.285V7.50687C13.1615 7.04351 12.7807 6.66825 12.3104 6.66675Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.8453 7.125H6.65137V18.5833H11.8453C12.3155 18.5818 12.6964 18.2066 12.6979 17.7432V7.96512C12.6964 7.50176 12.3155 7.12651 11.8453 7.125Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.8453 7.125H6.65137V17.6667H11.8453C12.3155 17.6652 12.6964 17.2899 12.6979 16.8265V7.96512C12.6964 7.50176 12.3155 7.12651 11.8453 7.125Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.3802 7.125H6.65137V17.6667H11.3802C11.8504 17.6652 12.2312 17.2899 12.2328 16.8265V7.96512C12.2312 7.50176 11.8504 7.12651 11.3802 7.125Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M2.85256 7.125H11.38C11.8508 7.125 12.2325 7.50113 12.2325 7.96512V16.3682C12.2325 16.8322 11.8508 17.2083 11.38 17.2083H2.85256C2.3817 17.2083 2 16.8322 2 16.3682V7.96512C2 7.50113 2.3817 7.125 2.85256 7.125Z",
            fill: "#117d42"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M4.64038 14.8975L6.43387 12.159L4.79062 9.43555H6.11247L7.00922 11.1772C7.09201 11.3427 7.14875 11.4655 7.17945 11.5466H7.19108C7.24999 11.4146 7.31201 11.2864 7.37713 11.1621L8.33573 9.43647H9.54921L7.8641 12.1438L9.59201 14.8975H8.30085L7.26503 12.9858C7.21624 12.9045 7.17484 12.819 7.14132 12.7305H7.12597C7.09563 12.8172 7.05537 12.9003 7.00597 12.978L5.93946 14.8975H4.64038Z",
            fill: "white"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.1474 3H14.5581V7.58333H22V3.84012C22 3.37613 21.6183 3 21.1474 3Z",
            fill: "#33C481"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.5581 12.1667H22V16.7501H14.5581V12.1667Z",
            fill: "#107C41"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_271_181626"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "18.3333",
            fill: "white",
            transform: "translate(2 3)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_271_181626)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5583 11.7083L6.65137 10.3333V20.4931C6.65137 20.9571 7.03307 21.3333 7.50392 21.3333H21.1476C21.6185 21.3333 22.0002 20.9571 22.0002 20.4931V16.7499L14.5583 11.7083Z",
        fill: "#185C37"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5583 3H7.50392C7.03307 3 6.65137 3.37613 6.65137 3.84012V7.58333L14.5583 12.1667L18.7444 13.5417L22.0002 12.1667V7.58333L14.5583 3Z",
        fill: "#21A366"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M6.65137 7.58325H14.5583V12.1666H6.65137V7.58325Z",
        fill: "#107C41"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M12.3104 6.66675H6.65137V18.1251H12.3104C12.7807 18.1236 13.1615 17.7483 13.163 17.285V7.50687C13.1615 7.04351 12.7807 6.66825 12.3104 6.66675Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.8453 7.125H6.65137V18.5833H11.8453C12.3155 18.5818 12.6964 18.2066 12.6979 17.7432V7.96512C12.6964 7.50176 12.3155 7.12651 11.8453 7.125Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.8453 7.125H6.65137V17.6667H11.8453C12.3155 17.6652 12.6964 17.2899 12.6979 16.8265V7.96512C12.6964 7.50176 12.3155 7.12651 11.8453 7.125Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.3802 7.125H6.65137V17.6667H11.3802C11.8504 17.6652 12.2312 17.2899 12.2328 16.8265V7.96512C12.2312 7.50176 11.8504 7.12651 11.3802 7.125Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M2.85256 7.125H11.38C11.8508 7.125 12.2325 7.50113 12.2325 7.96512V16.3682C12.2325 16.8322 11.8508 17.2083 11.38 17.2083H2.85256C2.3817 17.2083 2 16.8322 2 16.3682V7.96512C2 7.50113 2.3817 7.125 2.85256 7.125Z",
        fill: "#117d42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M4.64038 14.8975L6.43387 12.159L4.79062 9.43555H6.11247L7.00922 11.1772C7.09201 11.3427 7.14875 11.4655 7.17945 11.5466H7.19108C7.24999 11.4146 7.31201 11.2864 7.37713 11.1621L8.33573 9.43647H9.54921L7.8641 12.1438L9.59201 14.8975H8.30085L7.26503 12.9858C7.21624 12.9045 7.17484 12.819 7.14132 12.7305H7.12597C7.09563 12.8172 7.05537 12.9003 7.00597 12.978L5.93946 14.8975H4.64038Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.1474 3H14.5581V7.58333H22V3.84012C22 3.37613 21.6183 3 21.1474 3Z",
        fill: "#33C481"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5581 12.1667H22V16.7501H14.5581V12.1667Z",
        fill: "#107C41"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_271_181626"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "18.3333",
        fill: "white",
        transform: "translate(2 3)"
    }))));



var $eIKlJ = parcelRequire("eIKlJ");





const $eb10e775ed47edcd$export$16b26cd5e98d9100 = (partial, selectedProduct, label = '')=>{
    const getGoogleIconGlyph = ()=>{
        if ((0, $hJYQM.isGoogleDocument)(partial)) return 0, $ed562f534adea649$export$15f5952b52a8f495;
        if ((0, $hJYQM.isGooglePresentation)(partial)) return 0, $0e3070a2599cd8a2$export$4fa264492a686961;
        if ((0, $hJYQM.isGoogleSpreadsheet)(partial)) return 0, $aa85bb6060b32d72$export$26bbd899e059afb8;
    };
    const getSharepointIconGlyph = ()=>{
        if ((0, $hJYQM.isSharepointDocument)(partial)) return 0, $11402bf95f875780$export$543eca71a8a23d8c;
        if ((0, $hJYQM.isSharepointPresentation)(partial)) return 0, $0a0a5a0a11733173$export$ad243ee11ac5af03;
        if ((0, $hJYQM.isSharepointSpreadsheet)(partial)) return 0, $b6125520c1b2fab5$export$44eea01b1a1915e7;
    };
    if ((0, $hJYQM.isGoogleResult)(partial)) return selectedProduct ? getGoogleIconGlyph()?.({
        'aria-label': label
    }) : /*#__PURE__*/ $cozmU.createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
        product: (0, $37AYo.ProductKeys).GoogleDrive
    });
    if ((0, $hJYQM.isSlackMessage)(partial)) return selectedProduct ? /*#__PURE__*/ $cozmU.createElement((0, $eIKlJ.SlackIcon), {
        "aria-label": label
    }) : /*#__PURE__*/ $cozmU.createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
        product: (0, $37AYo.ProductKeys).Slack
    });
    if ((0, $hJYQM.isSharepointResult)(partial)) return selectedProduct ? getSharepointIconGlyph()?.({
        'aria-label': label
    }) : /*#__PURE__*/ $cozmU.createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
        product: (0, $37AYo.ProductKeys).Sharepoint
    });
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
};
const $eb10e775ed47edcd$export$236350842f3cd9bc = (partial)=>{
    if ((0, $hJYQM.isSlackMessage)(partial)) return 'Slack';
    if ((0, $hJYQM.isGoogleDocument)(partial)) return 'Docs';
    if ((0, $hJYQM.isGooglePresentation)(partial)) return 'Slides';
    if ((0, $hJYQM.isGoogleSpreadsheet)(partial)) return 'Sheets';
    if ((0, $hJYQM.isSharepointDocument)(partial)) return 'Word';
    if ((0, $hJYQM.isSharepointPresentation)(partial)) return 'PowerPoint';
    if ((0, $hJYQM.isSharepointSpreadsheet)(partial)) return 'Excel';
    return '';
};






const $90a30405e08b2b1e$var$footerContainer = (0, $buxP3.xcss)({
    paddingTop: 'space.100'
});
const $90a30405e08b2b1e$export$de6215ca63d8bb61 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(78);
    const { partial: partial, position: position } = t0;
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled } = t1;
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, mentions: mentions, type: type, subtype: subtype, linkedEntities: linkedEntities, lastActive: lastActive, allContributors: allContributors } = partial;
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] !== allContributors || $[1] !== formatMessage || $[2] !== intl || $[3] !== lastActive || $[4] !== lastModifiedDate || $[5] !== linkedEntities || $[6] !== mentions || $[7] !== partial || $[8] !== permissionLevel || $[9] !== selectedProduct || $[10] !== subtype || $[11] !== type) {
        let { description: description, title: title } = partial;
        const label = (0, $eb10e775ed47edcd$export$236350842f3cd9bc)(partial);
        lastModifiedDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        });
        const [contributor] = (0, $hJYQM.isGraphDocument)(partial) && partial.initialContributors || [];
        contributor?.name;
        let parts;
        let messageDescription;
        const latestModifiedDate = linkedEntities ? linkedEntities[linkedEntities.length - 1]?.lastModifiedDate : lastModifiedDate;
        let t8;
        if ($[19] !== lastActive || $[20] !== lastModifiedDate || $[21] !== latestModifiedDate) {
            const timeValues = (0, $8a1a5c2af543b4cc$export$7e0fd00186ff29c6)(lastActive || latestModifiedDate || lastModifiedDate);
            t8 = (0, $8a1a5c2af543b4cc$export$3e6e07f5a5b9cd48)(timeValues.seconds, timeValues.minutes, timeValues.hours, timeValues.days, timeValues.months, timeValues.years);
            $[19] = lastActive;
            $[20] = lastModifiedDate;
            $[21] = latestModifiedDate;
            $[22] = t8;
        } else t8 = $[22];
        const { unit: unit, value: value } = t8;
        const t9 = -value;
        let t10;
        if ($[23] !== t9 || $[24] !== unit) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
                value: t9,
                style: "long",
                unit: unit,
                numeric: "auto"
            }, $90a30405e08b2b1e$var$_temp);
            $[23] = t9;
            $[24] = unit;
            $[25] = t10;
        } else t10 = $[25];
        const relativeTime = t10;
        const contributors = allContributors || [
            ...(0, $8a1a5c2af543b4cc$export$995e2d4c52603c12)([
                partial,
                ...linkedEntities
            ])
        ];
        if (type === "channel") {
            title = `#${title}`;
            messageDescription = "";
            parts = [
                formatMessage((0, $7493884928001162$export$defe85febe8b728c).channelTypeLabel),
                formatMessage((0, $7493884928001162$export$defe85febe8b728c).channelMemberCount, {
                    memberCount: contributors.length
                }),
                [
                    "last-active",
                    relativeTime
                ]
            ];
        } else {
            if (subtype === "direct_message") {
                title = (0, $8a1a5c2af543b4cc$export$4675aadf6b343fe5)(contributors, formatMessage((0, $7493884928001162$export$defe85febe8b728c).privateConversationText, {
                    users: (0, $8a1a5c2af543b4cc$export$71c19251e893ab21)(contributors, intl)
                }), intl);
                let t11;
                if ($[26] !== formatMessage) {
                    t11 = formatMessage((0, $7493884928001162$export$defe85febe8b728c).messageTypeLabel);
                    $[26] = formatMessage;
                    $[27] = t11;
                } else t11 = $[27];
                let t12;
                if ($[28] !== relativeTime) {
                    t12 = [
                        "last-active",
                        relativeTime
                    ];
                    $[28] = relativeTime;
                    $[29] = t12;
                } else t12 = $[29];
                let t13;
                if ($[30] !== t11 || $[31] !== t12) {
                    t13 = [
                        t11,
                        t12
                    ];
                    $[30] = t11;
                    $[31] = t12;
                    $[32] = t13;
                } else t13 = $[32];
                parts = t13;
                let t14;
                if ($[33] !== description || $[34] !== mentions) {
                    t14 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)((0, $8a1a5c2af543b4cc$export$a688e0cd0fe53c61)(description, mentions));
                    $[33] = description;
                    $[34] = mentions;
                    $[35] = t14;
                } else t14 = $[35];
                messageDescription = t14;
            } else if (linkedEntities?.length > 0) {
                title = (0, $8a1a5c2af543b4cc$export$4675aadf6b343fe5)(contributors, `#${title}`, intl);
                let t11;
                if ($[36] !== formatMessage) {
                    t11 = formatMessage((0, $7493884928001162$export$defe85febe8b728c).threadTypeLabel);
                    $[36] = formatMessage;
                    $[37] = t11;
                } else t11 = $[37];
                let t12;
                if ($[38] !== relativeTime) {
                    t12 = [
                        "last-active",
                        relativeTime
                    ];
                    $[38] = relativeTime;
                    $[39] = t12;
                } else t12 = $[39];
                let t13;
                if ($[40] !== t11 || $[41] !== t12) {
                    t13 = [
                        t11,
                        t12
                    ];
                    $[40] = t11;
                    $[41] = t12;
                    $[42] = t13;
                } else t13 = $[42];
                parts = t13;
                let t14;
                if ($[43] !== intl || $[44] !== partial) {
                    t14 = (0, $8a1a5c2af543b4cc$export$3cf018c7cb5c2c7d)(partial, intl);
                    $[43] = intl;
                    $[44] = partial;
                    $[45] = t14;
                } else t14 = $[45];
                messageDescription = t14;
            } else {
                title = (0, $8a1a5c2af543b4cc$export$4675aadf6b343fe5)(contributors, `#${title}`, intl);
                let t11;
                if ($[46] !== formatMessage) {
                    t11 = formatMessage((0, $7493884928001162$export$defe85febe8b728c).messageTypeLabel);
                    $[46] = formatMessage;
                    $[47] = t11;
                } else t11 = $[47];
                let t12;
                if ($[48] !== relativeTime) {
                    t12 = [
                        "last-active",
                        relativeTime
                    ];
                    $[48] = relativeTime;
                    $[49] = t12;
                } else t12 = $[49];
                let t13;
                if ($[50] !== t11 || $[51] !== t12) {
                    t13 = [
                        t11,
                        t12
                    ];
                    $[50] = t11;
                    $[51] = t12;
                    $[52] = t13;
                } else t13 = $[52];
                parts = t13;
                let t14;
                if ($[53] !== intl || $[54] !== partial) {
                    t14 = (0, $8a1a5c2af543b4cc$export$3cf018c7cb5c2c7d)(partial, intl);
                    $[53] = intl;
                    $[54] = partial;
                    $[55] = t14;
                } else t14 = $[55];
                messageDescription = t14;
            }
        }
        const icon = (0, $eb10e775ed47edcd$export$16b26cd5e98d9100)(partial, selectedProduct, label);
        let t11;
        if ($[56] !== permissionLevel) {
            t11 = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel);
            $[56] = permissionLevel;
            $[57] = t11;
        } else t11 = $[57];
        const isNotPublic = t11;
        T0 = (0, $88d5f08d75a5e53f$export$a2def421b23768aa);
        t2 = partial.id;
        t3 = messageDescription;
        t4 = icon;
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: "slack",
            productSelected: true,
            parts: parts
        });
        if ($[58] !== isNotPublic || $[59] !== permissionLevel) {
            t6 = isNotPublic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $90a30405e08b2b1e$var$footerContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a550cfb7414ffd45$export$3eac322cb0b365da), {
                restriction: permissionLevel
            }));
            $[58] = isNotPublic;
            $[59] = permissionLevel;
            $[60] = t6;
        } else t6 = $[60];
        t7 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title);
        $[0] = allContributors;
        $[1] = formatMessage;
        $[2] = intl;
        $[3] = lastActive;
        $[4] = lastModifiedDate;
        $[5] = linkedEntities;
        $[6] = mentions;
        $[7] = partial;
        $[8] = permissionLevel;
        $[9] = selectedProduct;
        $[10] = subtype;
        $[11] = type;
        $[12] = T0;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else {
        T0 = $[12];
        t2 = $[13];
        t3 = $[14];
        t4 = $[15];
        t5 = $[16];
        t6 = $[17];
        t7 = $[18];
    }
    let t8;
    if ($[61] !== isAdminHubAIEnabled || $[62] !== partial) {
        t8 = (0, $hJYQM.isGoogleDocument)(partial) && isAdminHubAIEnabled;
        $[61] = isAdminHubAIEnabled;
        $[62] = partial;
        $[63] = t8;
    } else t8 = $[63];
    let t9;
    if ($[64] !== T0 || $[65] !== cloudId || $[66] !== partial || $[67] !== position || $[68] !== primaryProduct || $[69] !== t2 || $[70] !== t3 || $[71] !== t4 || $[72] !== t5 || $[73] !== t6 || $[74] !== t7 || $[75] !== t8 || $[76] !== url) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            id: t2,
            description: t3,
            icon: t4,
            headerMetadata: t5,
            footer: t6,
            title: t7,
            url: url,
            isThirdParty: true,
            showAISummary: t8,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            position: position,
            partial: partial
        });
        $[64] = T0;
        $[65] = cloudId;
        $[66] = partial;
        $[67] = position;
        $[68] = primaryProduct;
        $[69] = t2;
        $[70] = t3;
        $[71] = t4;
        $[72] = t5;
        $[73] = t6;
        $[74] = t7;
        $[75] = t8;
        $[76] = url;
        $[77] = t9;
    } else t9 = $[77];
    return t9;
} : ({ partial: partial, position: position })=>{
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const product = 'slack';
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, mentions: mentions, type: type, subtype: subtype, linkedEntities: linkedEntities, lastActive: lastActive, allContributors: allContributors } = partial;
    let { description: description, title: title } = partial;
    let label = (0, $eb10e775ed47edcd$export$236350842f3cd9bc)(partial);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const [contributor] = (0, $hJYQM.isGraphDocument)(partial) && partial.initialContributors || [];
    let parts = [
        label,
        [
            'last-modified',
            lastModifiedComponent
        ],
        contributor?.name
    ];
    let messageDescription;
    const latestModifiedDate = linkedEntities ? linkedEntities[linkedEntities.length - 1]?.lastModifiedDate : lastModifiedDate;
    const timeValues = (0, $8a1a5c2af543b4cc$export$7e0fd00186ff29c6)(lastActive || latestModifiedDate || lastModifiedDate);
    const { unit: unit, value: value } = (0, $8a1a5c2af543b4cc$export$3e6e07f5a5b9cd48)(timeValues.seconds, timeValues.minutes, timeValues.hours, timeValues.days, timeValues.months, timeValues.years);
    const relativeTime = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
        value: -value,
        style: "long",
        unit: unit,
        numeric: "auto"
    }, (formattedTime)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $7493884928001162$export$defe85febe8b728c)['lastActive'],
            values: {
                relativeDate: formattedTime
            }
        }));
    const contributors = allContributors || [
        ...(0, $8a1a5c2af543b4cc$export$995e2d4c52603c12)([
            partial,
            ...linkedEntities
        ])
    ];
    if (type === 'channel') {
        title = `#${title}`;
        messageDescription = '';
        // need to set these to empty strings to avoid showing any description in the search result
        description = '';
        parts = [
            formatMessage((0, $7493884928001162$export$defe85febe8b728c).channelTypeLabel),
            formatMessage((0, $7493884928001162$export$defe85febe8b728c).channelMemberCount, {
                memberCount: contributors.length
            }),
            [
                'last-active',
                relativeTime
            ]
        ];
    } else {
        if (subtype === 'direct_message') {
            title = (0, $8a1a5c2af543b4cc$export$4675aadf6b343fe5)(contributors, formatMessage((0, $7493884928001162$export$defe85febe8b728c).privateConversationText, {
                users: (0, $8a1a5c2af543b4cc$export$71c19251e893ab21)(contributors, intl)
            }), intl);
            parts = [
                formatMessage((0, $7493884928001162$export$defe85febe8b728c).messageTypeLabel),
                [
                    'last-active',
                    relativeTime
                ]
            ];
            messageDescription = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)((0, $8a1a5c2af543b4cc$export$a688e0cd0fe53c61)(description, mentions));
        } else // if it's a thread, build the title and description
        // otherwise if it's a message, just process the description
        if (linkedEntities?.length > 0) {
            title = (0, $8a1a5c2af543b4cc$export$4675aadf6b343fe5)(contributors, `#${title}`, intl);
            parts = [
                formatMessage((0, $7493884928001162$export$defe85febe8b728c).threadTypeLabel),
                [
                    'last-active',
                    relativeTime
                ]
            ];
            messageDescription = (0, $8a1a5c2af543b4cc$export$3cf018c7cb5c2c7d)(partial, intl);
        } else {
            title = (0, $8a1a5c2af543b4cc$export$4675aadf6b343fe5)(contributors, `#${title}`, intl);
            parts = [
                formatMessage((0, $7493884928001162$export$defe85febe8b728c).messageTypeLabel),
                [
                    'last-active',
                    relativeTime
                ]
            ];
            messageDescription = (0, $8a1a5c2af543b4cc$export$3cf018c7cb5c2c7d)(partial, intl);
        }
    }
    const icon = (0, $eb10e775ed47edcd$export$16b26cd5e98d9100)(partial, selectedProduct, label);
    const isNotPublic = (0, $8a1a5c2af543b4cc$export$f2f9c8e083d34d6b)(permissionLevel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        id: partial.id,
        description: messageDescription,
        icon: icon,
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: true,
            parts: parts
        }),
        footer: isNotPublic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $90a30405e08b2b1e$var$footerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a550cfb7414ffd45$export$3eac322cb0b365da), {
            restriction: permissionLevel
        })),
        title: (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        // AI Summaries are only supported for Google Drive now
        showAISummary: (0, $hJYQM.isGoogleDocument)(partial) && isAdminHubAIEnabled,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};
function $90a30405e08b2b1e$var$_temp(formattedTime) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $7493884928001162$export$defe85febe8b728c).lastActive,
        values: {
            relativeDate: formattedTime
        }
    });
}












var $9cGsb = parcelRequire("9cGsb");

const $bfad958d51fa208b$export$d8a746fe35b1c95d = (ari)=>{
    const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $bfad958d51fa208b$export$fccbae65febb6fd4(ari) ? $bfad958d51fa208b$export$2f432ca99e30467e(ari) : (0, $9cGsb.parse)(ari);
    return [
        resourceOwner,
        cloudId,
        resourceType,
        resourceId
    ];
};
const $bfad958d51fa208b$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $bfad958d51fa208b$export$2f432ca99e30467e = (ari)=>{
    const result = $bfad958d51fa208b$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$bfad958d51fa208b$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner, resourceType, resourceId] = result;
    return {
        resourceId: resourceId,
        resourceOwner: resourceOwner,
        resourceType: resourceType,
        cloudId: resourceId
    };
};
const $bfad958d51fa208b$export$fccbae65febb6fd4 = (ari)=>$bfad958d51fa208b$var$thirdPartyRegex.test(ari);



















const $92807d054f54e21f$export$37a54a397a692113 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { partial: partial, position: position } = t0;
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [t1] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: cloudId } = t1;
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const { id: id, title: title, url: url, type: type, description: description, lastModifiedDate: lastModifiedDate } = partial;
    let t2;
    if ($[0] !== id) {
        t2 = (0, $bfad958d51fa208b$export$d8a746fe35b1c95d)(id);
        $[0] = id;
        $[1] = t2;
    } else t2 = $[1];
    const [product] = t2;
    const t3 = type === "issue" ? "card" : type;
    let t4;
    if ($[2] !== product || $[3] !== t3) {
        t4 = {
            entityType: t3,
            product: product
        };
        $[2] = product;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const metadata = t4;
    let t5;
    bb0: {
        if (!lastModifiedDate) {
            t5 = null;
            break bb0;
        }
        let t6;
        if ($[5] !== lastModifiedDate) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
                lastModified: lastModifiedDate
            });
            $[5] = lastModifiedDate;
            $[6] = t6;
        } else t6 = $[6];
        t5 = t6;
    }
    const getLastModified = t5;
    let t6;
    if ($[7] !== searchQuery || $[8] !== title) {
        bb1: {
            const { highlightedTitle: highlightedTitle } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(title, searchQuery.split(" "));
            if (!highlightedTitle) {
                t6 = title;
                break bb1;
            }
            t6 = (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(highlightedTitle);
        }
        $[7] = searchQuery;
        $[8] = title;
        $[9] = t6;
    } else t6 = $[9];
    const enrichedTitle = t6;
    let t7;
    if ($[10] !== description || $[11] !== searchQuery) {
        bb2: {
            const reducedDescription = (0, $e348b946f9be0b4c$export$91c2cc655c44ef69)(description, searchQuery);
            const { highlightedTitle: highlightedTitle_0 } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(reducedDescription, searchQuery.split(" "));
            if (!highlightedTitle_0) {
                t7 = reducedDescription;
                break bb2;
            }
            t7 = (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(highlightedTitle_0);
        }
        $[10] = description;
        $[11] = searchQuery;
        $[12] = t7;
    } else t7 = $[12];
    const enrichedDescription = t7;
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
            product: (0, $37AYo.ProductKeys).Trello
        });
        $[13] = t8;
    } else t8 = $[13];
    const t9 = !!selectedProduct;
    let t10;
    if ($[14] !== metadata.entityType) {
        t10 = [
            "type",
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20651b41f8c81b92$export$95cacd63dfd98bee), {
                type: metadata.entityType
            })
        ];
        $[14] = metadata.entityType;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== getLastModified) {
        t11 = [
            "lastModified",
            getLastModified
        ];
        $[16] = getLastModified;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== t10 || $[19] !== t11) {
        t12 = [
            t10,
            t11
        ];
        $[18] = t10;
        $[19] = t11;
        $[20] = t12;
    } else t12 = $[20];
    let t13;
    if ($[21] !== metadata.product || $[22] !== t12 || $[23] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: metadata.product,
            productSelected: t9,
            parts: t12
        });
        $[21] = metadata.product;
        $[22] = t12;
        $[23] = t9;
        $[24] = t13;
    } else t13 = $[24];
    let t14;
    if ($[25] !== cloudId || $[26] !== enrichedDescription || $[27] !== enrichedTitle || $[28] !== partial || $[29] !== position || $[30] !== primaryProduct || $[31] !== t13 || $[32] !== url) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
            ...partial,
            primaryProduct: primaryProduct,
            url: url,
            icon: t8,
            title: enrichedTitle,
            headerMetadata: t13,
            description: enrichedDescription,
            cloudId: cloudId,
            position: position
        });
        $[25] = cloudId;
        $[26] = enrichedDescription;
        $[27] = enrichedTitle;
        $[28] = partial;
        $[29] = position;
        $[30] = primaryProduct;
        $[31] = t13;
        $[32] = url;
        $[33] = t14;
    } else t14 = $[33];
    return t14;
} : ({ partial: partial, position: position })=>{
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const [primaryProduct] = (0, $122441d1a555945e$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const { id: id, title: title, url: url, type: type, description: description, lastModifiedDate: lastModifiedDate } = partial;
    const metadata = (0, $cozmU.useMemo)(()=>{
        const [product] = (0, $bfad958d51fa208b$export$d8a746fe35b1c95d)(id);
        return {
            entityType: type === 'issue' ? 'card' : type,
            product: product
        };
    }, [
        id,
        type
    ]);
    const getLastModified = (0, $cozmU.useMemo)(()=>{
        if (!lastModifiedDate) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $898b3cab58426bd8$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        });
    }, [
        lastModifiedDate
    ]);
    const enrichedTitle = (0, $cozmU.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(title, searchQuery.split(' '));
        if (!highlightedTitle) return title;
        return (0, $8a1a5c2af543b4cc$export$b847312d69858d61)(highlightedTitle);
    }, [
        title,
        searchQuery
    ]);
    const enrichedDescription = (0, $cozmU.useMemo)(()=>{
        const reducedDescription = (0, $e348b946f9be0b4c$export$91c2cc655c44ef69)(description, searchQuery);
        const { highlightedTitle: highlightedTitle_0 } = (0, $d1c1d51b23ca3f0a$export$9f4c92a576b56d82)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle_0) return reducedDescription;
        return (0, $8a1a5c2af543b4cc$export$16c2ab98757b54d6)(highlightedTitle_0);
    }, [
        description,
        searchQuery
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88d5f08d75a5e53f$export$a2def421b23768aa), {
        ...partial,
        primaryProduct: primaryProduct,
        url: url,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b6e60425766dcf3$export$1a199e029d5e93d6), {
            product: (0, $37AYo.ProductKeys).Trello
        }),
        title: enrichedTitle,
        headerMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e466e8b178d272a$export$8e7fb1f8fe599124), {
            product: metadata.product,
            productSelected: !!selectedProduct,
            parts: [
                [
                    'type',
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20651b41f8c81b92$export$95cacd63dfd98bee), {
                        type: metadata.entityType
                    })
                ],
                [
                    'lastModified',
                    getLastModified
                ]
            ]
        }),
        description: enrichedDescription,
        cloudId: cloudId,
        position: position
    });
};


const $999d7e32103ae785$var$resultsListGridAreaStyles = (0, $buxP3.xcss)({
    gridArea: 'results-list',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200'
});
const $999d7e32103ae785$var$noMoreResultsStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.400'
});
// How many search results to show before the OAuth banner
const $999d7e32103ae785$var$OAUTH_BANNER_CUTOFF = 4;
const $999d7e32103ae785$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    resultsCount: {
        id: "search-result.result.count",
        defaultMessage: "{count, plural, one {Showing {count} result} other {Showing {count} results}}"
    }
});
// TODO: we should monitor for unsupported result types, right now we're failing silently and fall back to null
const $999d7e32103ae785$var$ResultRecord = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { node: node, index: index } = t0;
    let t1;
    if ($[0] !== index || $[1] !== node) {
        t1 = (0, $lqSug.isSearchConfluencePartial)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da289b704d3b2901$export$30adeb861c31a5ed), {
            partial: node,
            position: index
        }) : (0, $bzYTC.isSearchResultJiraIssue)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d965d04720d0d4aa$export$3c36ba6ceaed3437), {
            partial: (0, $bzYTC.mapJiraIssuePartial)(node),
            position: index
        }) : (0, $bzYTC.isSearchResultJiraProject)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d965d04720d0d4aa$export$3c36ba6ceaed3437), {
            partial: (0, $bzYTC.mapJiraProjectPartial)(node),
            position: index
        }) : (0, $bzYTC.isSearchJiraPartial)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d965d04720d0d4aa$export$3c36ba6ceaed3437), {
            partial: node,
            position: index
        }) : (0, $4ut97.isSearchAtlasPartial)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $15dffd31214416dd$export$a97c0c8e95f01322), {
            partial: node,
            position: index
        }) : (0, $9Ppk1.isSearchCompassPartial)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fc13cccc13153192$export$cc23f5d092bb479f), {
            partial: node,
            position: index
        }) : (0, $e7vVr.isSearchTrelloPartial)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92807d054f54e21f$export$37a54a397a692113), {
            partial: node,
            position: index
        }) : (0, $hJYQM.isSlackMessage)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90a30405e08b2b1e$export$de6215ca63d8bb61), {
            partial: node,
            position: index
        }) : (0, $ah5yI.isSearchResultGraphEntity)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9329fb93eda7f9aa$export$b86b424e0d4929fb), {
            partial: node,
            position: index
        }) : null;
        $[0] = index;
        $[1] = node;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== node.id || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
            key: node.id,
            fallback: null
        }, t1);
        $[3] = node.id;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ node: node, index: index })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
        key: node.id,
        fallback: null
    }, (0, $lqSug.isSearchConfluencePartial)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da289b704d3b2901$export$30adeb861c31a5ed), {
        partial: node,
        position: index
    }) : (0, $bzYTC.isSearchResultJiraIssue)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d965d04720d0d4aa$export$3c36ba6ceaed3437), {
        partial: (0, $bzYTC.mapJiraIssuePartial)(node),
        position: index
    }) : (0, $bzYTC.isSearchResultJiraProject)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d965d04720d0d4aa$export$3c36ba6ceaed3437), {
        partial: (0, $bzYTC.mapJiraProjectPartial)(node),
        position: index
    }) : (0, $bzYTC.isSearchJiraPartial)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d965d04720d0d4aa$export$3c36ba6ceaed3437), {
        partial: node,
        position: index
    }) : (0, $4ut97.isSearchAtlasPartial)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $15dffd31214416dd$export$a97c0c8e95f01322), {
        partial: node,
        position: index
    }) : (0, $9Ppk1.isSearchCompassPartial)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fc13cccc13153192$export$cc23f5d092bb479f), {
        partial: node,
        position: index
    }) : (0, $e7vVr.isSearchTrelloPartial)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92807d054f54e21f$export$37a54a397a692113), {
        partial: node,
        position: index
    }) : (0, $hJYQM.isSlackMessage)(node) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90a30405e08b2b1e$export$de6215ca63d8bb61), {
        partial: node,
        position: index
    }) : (0, $ah5yI.isSearchResultGraphEntity)(node) ? // Leave this one last
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9329fb93eda7f9aa$export$b86b424e0d4929fb), {
        partial: node,
        position: index
    }) : null);
};
const $999d7e32103ae785$export$4a34de49b46a2bfa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(35);
    const [results] = (0, $2Va9o.useResults)();
    const { setFetchFromCursor: setFetchFromCursor } = (0, $2Va9o.useSearchActions)();
    const currentCursor = (0, $2Va9o.useFetchFromCursor)();
    const nextFetchCursor = (0, $2Va9o.usePageEndCursor)();
    const isLoadingMore = (0, $2Va9o.useIsLoadingMore)();
    const hasNextPage = nextFetchCursor && currentCursor !== nextFetchCursor;
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const lastResultRef = (0, $cozmU.useRef)(null);
    let t0;
    if ($[0] !== currentCursor || $[1] !== nextFetchCursor || $[2] !== results || $[3] !== setFetchFromCursor) {
        t0 = [
            currentCursor,
            nextFetchCursor,
            false,
            results,
            setFetchFromCursor
        ];
        $[0] = currentCursor;
        $[1] = nextFetchCursor;
        $[2] = results;
        $[3] = setFetchFromCursor;
        $[4] = t0;
    } else t0 = $[4];
    (0, $cozmU.useEffect)($999d7e32103ae785$var$_temp, t0);
    if (!results) {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
            $[5] = t1;
        } else t1 = $[5];
        return t1;
    }
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[6] !== results.edges || $[7] !== results.totalCount || $[8] !== selectedProduct) {
        const initialResults = results.edges.slice(0, $999d7e32103ae785$var$OAUTH_BANNER_CUTOFF);
        const remainingResults = results.edges.slice($999d7e32103ae785$var$OAUTH_BANNER_CUTOFF);
        const resultsCount = (0, results.edges.length);
        T0 = (0, $3izAL.Box);
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = [
                $999d7e32103ae785$var$resultsListGridAreaStyles,
                $999d7e32103ae785$var$noMoreResultsStyles
            ];
            $[17] = t1;
        } else t1 = $[17];
        t2 = "list";
        t3 = "search-page-results-list";
        if ($[18] !== resultsCount) {
            t4 = resultsCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
                color: "color.text.subtle"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$999d7e32103ae785$export$a7357cdd1f0b0168.resultsCount,
                values: {
                    count: resultsCount
                }
            }));
            $[18] = resultsCount;
            $[19] = t4;
        } else t4 = $[19];
        t5 = initialResults.map($999d7e32103ae785$var$_temp2);
        if ($[20] !== selectedProduct) {
            t6 = !selectedProduct && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80f58e8b5617f295$export$2e2bcd8739ae039), null);
            $[20] = selectedProduct;
            $[21] = t6;
        } else t6 = $[21];
        t7 = remainingResults.length > 0 && remainingResults.map($999d7e32103ae785$var$_temp3);
        $[6] = results.edges;
        $[7] = results.totalCount;
        $[8] = selectedProduct;
        $[9] = T0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else {
        T0 = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        t4 = $[13];
        t5 = $[14];
        t6 = $[15];
        t7 = $[16];
    }
    let t8;
    if ($[22] !== hasNextPage || $[23] !== isLoadingMore) {
        t8 = false;
        $[22] = hasNextPage;
        $[23] = isLoadingMore;
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] !== T0 || $[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t1,
            role: t2,
            testId: t3
        }, t4, t5, t6, t7, t8);
        $[25] = T0;
        $[26] = t1;
        $[27] = t2;
        $[28] = t3;
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
        $[34] = t9;
    } else t9 = $[34];
    return t9;
} : ()=>{
    const [results] = (0, $2Va9o.useResults)();
    const { setFetchFromCursor: setFetchFromCursor } = (0, $2Va9o.useSearchActions)();
    const currentCursor = (0, $2Va9o.useFetchFromCursor)();
    const nextFetchCursor = (0, $2Va9o.usePageEndCursor)();
    const isLoadingMore = (0, $2Va9o.useIsLoadingMore)();
    const hasNextPage = nextFetchCursor && currentCursor !== nextFetchCursor;
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const lastResultRef = (0, $cozmU.useRef)(null);
    const paginationEnabled = false;
    (0, $cozmU.useEffect)(()=>{
        if (!paginationEnabled) return;
        const nextPageObserver = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) {
                if (nextFetchCursor && nextFetchCursor !== currentCursor) setFetchFromCursor(nextFetchCursor);
            }
        }, {});
        if (lastResultRef.current) nextPageObserver.observe(lastResultRef.current);
    }, [
        currentCursor,
        nextFetchCursor,
        paginationEnabled,
        results,
        setFetchFromCursor
    ]);
    if (!results) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    const initialResults = results.edges.slice(0, $999d7e32103ae785$var$OAUTH_BANNER_CUTOFF);
    const remainingResults = results.edges.slice($999d7e32103ae785$var$OAUTH_BANNER_CUTOFF);
    const resultsCount = paginationEnabled ? results.totalCount : results.edges.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $999d7e32103ae785$var$resultsListGridAreaStyles,
            $999d7e32103ae785$var$noMoreResultsStyles
        ],
        role: "list",
        testId: "search-page-results-list"
    }, resultsCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$999d7e32103ae785$export$a7357cdd1f0b0168.resultsCount,
        values: {
            count: resultsCount
        }
    })), initialResults.map(({ node: node }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($999d7e32103ae785$var$ResultRecord, {
            node: node,
            index: index
        })), !selectedProduct && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80f58e8b5617f295$export$2e2bcd8739ae039), null), remainingResults.length > 0 && remainingResults.map(({ node: node_0 }, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($999d7e32103ae785$var$ResultRecord, {
            node: node_0,
            index: index_0 + $999d7e32103ae785$var$OAUTH_BANNER_CUTOFF
        })), paginationEnabled && (hasNextPage || isLoadingMore) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        ref: lastResultRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21f984d0478a8ef9$export$dd3282b157ef6f7a), null)));
};
function $999d7e32103ae785$var$_temp() {}
function $999d7e32103ae785$var$_temp2(t0, index) {
    const { node: node } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($999d7e32103ae785$var$ResultRecord, {
        node: node,
        index: index
    });
}
function $999d7e32103ae785$var$_temp3(t0, index_0) {
    const { node: node_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($999d7e32103ae785$var$ResultRecord, {
        node: node_0,
        index: index_0 + $999d7e32103ae785$var$OAUTH_BANNER_CUTOFF
    });
}


const $698b45f6b1b2c33e$var$resultCountAndSortContainer = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 'space.050'
});
const $698b45f6b1b2c33e$var$ResultsState = {
    NO_RESULTS: 'noResults',
    INITIAL: 'initial',
    RESULTS: 'results',
    ERROR: 'error',
    IS_LOADING: 'isLoading',
    EMPTY: 'empty'
};
const $698b45f6b1b2c33e$export$1e51d2073b60bd88 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const [t0] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { outboundAuthConfigs: outboundAuthConfigs } = t0;
    let t1;
    if ($[0] !== outboundAuthConfigs) {
        t1 = {
            outboundAuthConfigs: outboundAuthConfigs
        };
        $[0] = outboundAuthConfigs;
        $[1] = t1;
    } else t1 = $[1];
    const { hasFiltersSelected: hasFiltersSelected } = (0, $979870397bacea10$export$e90e90fddddd8154)(t1);
    const [isLoading] = (0, $2Va9o.useIsLoading)();
    const [error] = (0, $2Va9o.useResultsError)();
    const [results] = (0, $2Va9o.useResults)();
    let t2;
    bb0: {
        if (results === undefined && error === undefined) {
            if (hasFiltersSelected) {
                let t3;
                if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = {
                        state: $698b45f6b1b2c33e$var$ResultsState.IS_LOADING
                    };
                    $[2] = t3;
                } else t3 = $[2];
                t2 = t3;
                break bb0;
            }
            let t3;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = {
                    state: $698b45f6b1b2c33e$var$ResultsState.EMPTY
                };
                $[3] = t3;
            } else t3 = $[3];
            t2 = t3;
            break bb0;
        }
        if (!hasFiltersSelected) {
            let t3;
            if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = {
                    state: $698b45f6b1b2c33e$var$ResultsState.INITIAL
                };
                $[4] = t3;
            } else t3 = $[4];
            t2 = t3;
            break bb0;
        }
        if (isLoading) {
            let t3;
            if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = {
                    state: $698b45f6b1b2c33e$var$ResultsState.IS_LOADING
                };
                $[5] = t3;
            } else t3 = $[5];
            t2 = t3;
            break bb0;
        }
        if (results && results.edges.length > 0) {
            let t3;
            if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = {
                    state: $698b45f6b1b2c33e$var$ResultsState.RESULTS
                };
                $[6] = t3;
            } else t3 = $[6];
            t2 = t3;
            break bb0;
        }
        if (error instanceof (0, $d374566d2028db50$export$8ba86dff7c04c14c) || results && results.edges.length === 0) {
            let t3;
            if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = {
                    state: $698b45f6b1b2c33e$var$ResultsState.NO_RESULTS
                };
                $[7] = t3;
            } else t3 = $[7];
            t2 = t3;
            break bb0;
        }
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                state: $698b45f6b1b2c33e$var$ResultsState.ERROR
            };
            $[8] = t3;
        } else t3 = $[8];
        t2 = t3;
    }
    return t2;
} : ()=>{
    // TODO: this hook should be moved to the Store, so it can be used by other components.
    const [{ outboundAuthConfigs: outboundAuthConfigs }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { hasFiltersSelected: hasFiltersSelected } = (0, $979870397bacea10$export$e90e90fddddd8154)({
        outboundAuthConfigs: outboundAuthConfigs
    });
    const [isLoading] = (0, $2Va9o.useIsLoading)();
    const [error] = (0, $2Va9o.useResultsError)();
    const [results] = (0, $2Va9o.useResults)();
    return (0, $cozmU.useMemo)(()=>{
        // This narrows the result down to either loading or nothing
        if (results === undefined && error === undefined) {
            // In this case, we know user has selected filters, so we can show loading state
            if (hasFiltersSelected) return {
                state: $698b45f6b1b2c33e$var$ResultsState.IS_LOADING
            };
            /*
      	In some cases, isLoading returns true before hasFiltersSelected returns true
      	In these cases, we do not know if:
      	- the user has selected filters (we should show loading state)
      	- the user has not selected filters (we should not show loading state)
      		For this reason, we display nothing until we know filter state for certain
       */ return {
                state: $698b45f6b1b2c33e$var$ResultsState.EMPTY
            };
        }
        // In this case, we know user has not selected filters, so we can show initial state
        if (!hasFiltersSelected) return {
            state: $698b45f6b1b2c33e$var$ResultsState.INITIAL
        };
        // This covers loading case where a second query was made
        if (isLoading) return {
            state: $698b45f6b1b2c33e$var$ResultsState.IS_LOADING
        };
        if (results && results.edges.length > 0) return {
            state: $698b45f6b1b2c33e$var$ResultsState.RESULTS
        };
        // If there are no entities for a query, an error will throw
        // when no entities for query is equivalent to no results
        if (error instanceof (0, $d374566d2028db50$export$8ba86dff7c04c14c) || results && results.edges.length === 0) return {
            state: $698b45f6b1b2c33e$var$ResultsState.NO_RESULTS
        };
        return {
            state: $698b45f6b1b2c33e$var$ResultsState.ERROR
        };
    }, [
        hasFiltersSelected,
        isLoading,
        error,
        results
    ]);
};
const $698b45f6b1b2c33e$export$b4ce9e0c6695ed08 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(20);
    const [results] = (0, $2Va9o.useResults)();
    const [requestId] = (0, $2Va9o.useResultsRequestId)();
    const [error] = (0, $2Va9o.useResultsError)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const { retrySearch: retrySearch } = (0, $2Va9o.useSearchActions)();
    const intercom = (0, $ecf47e97be76a1bd$export$f0fed4b0765d7314)();
    const { state: state } = $698b45f6b1b2c33e$export$1e51d2073b60bd88();
    const [isOnline] = (0, $cozmU.useState)(navigator.onLine);
    let t0;
    let t1;
    if ($[0] !== error || $[1] !== intercom || $[2] !== requestId || $[3] !== results || $[4] !== selectedProduct) {
        t0 = ()=>{
            if (results && results.edges.length >= 0) {
                (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).mark("render_end");
                (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).success({
                    metadata: {
                        productFilter: selectedProduct,
                        requestId: requestId
                    }
                });
                if (results.edges.length > 0) {
                    if (selectedProduct && (0, $a4ade32e9dcacfed$export$b0f4af9a0173cbfd)(selectedProduct)) intercom?.trackEvent("search_results_shown_3p", {
                        product_filter: selectedProduct
                    });
                    else intercom?.trackEvent("search_results_shown", {
                        product_filter: selectedProduct
                    });
                }
            } else if (error && !results) (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).failure({
                metadata: {
                    productFilter: selectedProduct
                }
            });
        };
        t1 = [
            results,
            selectedProduct,
            error,
            intercom,
            requestId
        ];
        $[0] = error;
        $[1] = intercom;
        $[2] = requestId;
        $[3] = results;
        $[4] = selectedProduct;
        $[5] = t0;
        $[6] = t1;
    } else {
        t0 = $[5];
        t1 = $[6];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    let t3;
    if ($[7] !== isOnline) {
        t2 = ()=>{
            (0, $4ca6254f4124508a$export$5e3e5ca9e3ba891b)(isOnline, (0, (/*@__PURE__*/$parcel$interopDefault($2cecd614edc3a3c9$exports))), (0, $4ca6254f4124508a$export$add61e2630a21f9), (0, (/*@__PURE__*/$parcel$interopDefault($1c46a046326b4458$exports))), (0, $4ca6254f4124508a$export$4be43fd067fd9d7f));
        };
        t3 = [
            isOnline
        ];
        $[7] = isOnline;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const showResultCountAndSort = selectedProduct === (0, $37AYo.ProductKeys).Confluence;
    if (state === $698b45f6b1b2c33e$var$ResultsState.IS_LOADING) {
        let t4;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04940efdfc96d832$export$669f6ea7d267feaf), null);
            $[10] = t4;
        } else t4 = $[10];
        return t4;
    }
    if (state === $698b45f6b1b2c33e$var$ResultsState.INITIAL) {
        let t4;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $150ee3d75f054d54$export$12449a31c6671d53), null);
            $[11] = t4;
        } else t4 = $[11];
        return t4;
    }
    if (state === $698b45f6b1b2c33e$var$ResultsState.RESULTS) {
        let t4;
        if ($[12] !== showResultCountAndSort) {
            t4 = showResultCountAndSort && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $698b45f6b1b2c33e$var$resultCountAndSortContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null));
            $[12] = showResultCountAndSort;
            $[13] = t4;
        } else t4 = $[13];
        let t5;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $999d7e32103ae785$export$4a34de49b46a2bfa), null);
            $[14] = t5;
        } else t5 = $[14];
        let t6;
        if ($[15] !== t4) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, t4, t5);
            $[15] = t4;
            $[16] = t6;
        } else t6 = $[16];
        return t6;
    }
    if (state === $698b45f6b1b2c33e$var$ResultsState.NO_RESULTS) {
        let t4;
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c57c587d13eb9d3$export$ef6006467f04ee41), null));
            $[17] = t4;
        } else t4 = $[17];
        return t4;
    }
    if (state === $698b45f6b1b2c33e$var$ResultsState.EMPTY) return null;
    let t4;
    if ($[18] !== retrySearch) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2cdf20372367534$export$edf27be85e5f6da0), {
            fetchResults: retrySearch
        });
        $[18] = retrySearch;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : ()=>{
    const [results] = (0, $2Va9o.useResults)();
    const [requestId] = (0, $2Va9o.useResultsRequestId)();
    const [error] = (0, $2Va9o.useResultsError)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const { retrySearch: retrySearch } = (0, $2Va9o.useSearchActions)();
    const intercom = (0, $ecf47e97be76a1bd$export$f0fed4b0765d7314)();
    const { state: state } = $698b45f6b1b2c33e$export$1e51d2073b60bd88();
    const [isOnline, _] = (0, $cozmU.useState)(navigator.onLine);
    (0, $cozmU.useEffect)(()=>{
        if (results && results.edges.length >= 0) {
            (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).mark('render_end');
            (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).success({
                metadata: {
                    productFilter: selectedProduct,
                    requestId: requestId
                }
            });
            // Only fire intercom results shown events when there are actually results
            // as we don't know when the user has connected their 3P provider or not
            if (results.edges.length > 0) {
                if (selectedProduct && (0, $a4ade32e9dcacfed$export$b0f4af9a0173cbfd)(selectedProduct)) intercom?.trackEvent('search_results_shown_3p', {
                    product_filter: selectedProduct
                });
                else intercom?.trackEvent('search_results_shown', {
                    product_filter: selectedProduct
                });
            }
        } else if (error && !results) (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).failure({
            metadata: {
                productFilter: selectedProduct
            }
        });
    }, [
        results,
        selectedProduct,
        error,
        intercom,
        requestId
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $4ca6254f4124508a$export$5e3e5ca9e3ba891b)(isOnline, (0, (/*@__PURE__*/$parcel$interopDefault($2cecd614edc3a3c9$exports))), (0, $4ca6254f4124508a$export$add61e2630a21f9), (0, (/*@__PURE__*/$parcel$interopDefault($1c46a046326b4458$exports))), (0, $4ca6254f4124508a$export$4be43fd067fd9d7f));
    }, [
        isOnline
    ]);
    const showResultCountAndSort = (0, $cozmU.useMemo)(()=>selectedProduct === (0, $37AYo.ProductKeys).Confluence, [
        selectedProduct
    ]);
    if (state === $698b45f6b1b2c33e$var$ResultsState.IS_LOADING) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04940efdfc96d832$export$669f6ea7d267feaf), null);
    if (state === $698b45f6b1b2c33e$var$ResultsState.INITIAL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $150ee3d75f054d54$export$12449a31c6671d53), null);
    if (state === $698b45f6b1b2c33e$var$ResultsState.RESULTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, showResultCountAndSort && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $698b45f6b1b2c33e$var$resultCountAndSortContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $999d7e32103ae785$export$4a34de49b46a2bfa), null));
    if (state === $698b45f6b1b2c33e$var$ResultsState.NO_RESULTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c57c587d13eb9d3$export$ef6006467f04ee41), null));
    if (state === $698b45f6b1b2c33e$var$ResultsState.EMPTY) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2cdf20372367534$export$edf27be85e5f6da0), {
        fetchResults: retrySearch
    });
};



















var $87Lnp = parcelRequire("87Lnp");


var $3Q5mv = parcelRequire("3Q5mv");

const $d925f29f24bf891f$var$outboundAuthConfigSchema = (0, $87Lnp.z).object({
    url: (0, $87Lnp.z).string(),
    userNeedsOAuth: (0, $87Lnp.z).boolean()
});
const $d925f29f24bf891f$export$550db1eccbaa1ef8 = (0, $87Lnp.z).record((0, $3Q5mv.productKeySchema), $d925f29f24bf891f$var$outboundAuthConfigSchema).or((0, $87Lnp.z).record((0, $87Lnp.z).never())); // Allow for empty objects = {}
















const $324a448bb6e67fd9$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $324a448bb6e67fd9$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $324a448bb6e67fd9$var$getFirstCloudId = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($324a448bb6e67fd9$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $324a448bb6e67fd9$var$isNounsAvailable = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isNounsAvailable;
};
const $324a448bb6e67fd9$export$2b0ac18f7cd43e19 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, primaryProduct: primaryProduct } = t0;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [accessibleProducts, setAccessibleProducts] = (0, $cozmU.useState)();
    const logException = (0, $298b6709c80d740f$export$67ff3bc9583d7c16)();
    let t1;
    bb0: {
        if (!cloudIdProp && firstPartyResponse) {
            let t2;
            if ($[0] !== firstPartyResponse) {
                t2 = $324a448bb6e67fd9$var$getFirstCloudId(firstPartyResponse);
                $[0] = firstPartyResponse;
                $[1] = t2;
            } else t2 = $[1];
            t1 = t2;
            break bb0;
        }
        t1 = "";
    }
    const firstCloudId = t1;
    const t2 = cloudIdProp || firstCloudId || "";
    let t3;
    if ($[2] !== t2 || $[3] !== thirdPartyAbsoluteUrl || $[4] !== userId) {
        t3 = {
            cloudId: t2,
            userId: userId,
            absoluteUrl: thirdPartyAbsoluteUrl
        };
        $[2] = t2;
        $[3] = thirdPartyAbsoluteUrl;
        $[4] = userId;
        $[5] = t3;
    } else t3 = $[5];
    const { productKeys: thirdPartyProductKeys, outboundAuthConfigs: outboundAuthConfigs } = $324a448bb6e67fd9$export$4fc2f66fb6e9d067(t3);
    let t4;
    let t5;
    if ($[6] !== aggregatorHostName || $[7] !== cloudIdProp || $[8] !== configFetchAbsoluteUrl || $[9] !== firstPartyResponse || $[10] !== logException || $[11] !== userId) {
        t4 = ()=>{
            if (!firstPartyResponse) (0, $7b01b6676ae1e761$export$2e9655e8b4177582)({
                cloudId: cloudIdProp,
                absoluteUrl: configFetchAbsoluteUrl,
                hostName: aggregatorHostName,
                userId: userId
            }).then((response)=>setFirstPartyResponse(response)).catch((error)=>{
                logException(error);
                setFirstPartyResponse({
                    resources: [],
                    intercomHmac: "",
                    siteMetadata: []
                });
            });
        };
        t5 = [
            firstPartyResponse,
            setFirstPartyResponse,
            cloudIdProp,
            configFetchAbsoluteUrl,
            aggregatorHostName,
            userId,
            logException
        ];
        $[6] = aggregatorHostName;
        $[7] = cloudIdProp;
        $[8] = configFetchAbsoluteUrl;
        $[9] = firstPartyResponse;
        $[10] = logException;
        $[11] = userId;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[14] !== accessibleProducts || $[15] !== firstPartyResponse || $[16] !== primaryProduct || $[17] !== thirdPartyProductKeys) {
        t6 = ()=>{
            if (thirdPartyProductKeys && firstPartyResponse && !accessibleProducts) {
                let allAccessibleProducts = [];
                const firstPartyProducts = firstPartyResponse.resources.flatMap($324a448bb6e67fd9$var$_temp);
                if (firstPartyProducts.length === 0 && primaryProduct) allAccessibleProducts.push(primaryProduct);
                else allAccessibleProducts.push(...firstPartyProducts);
                if (allAccessibleProducts.includes("bitbucket") && !allAccessibleProducts.includes("jira")) allAccessibleProducts = allAccessibleProducts.filter($324a448bb6e67fd9$var$_temp2);
                const allProducts = allAccessibleProducts.concat(thirdPartyProductKeys);
                setAccessibleProducts(allProducts);
            }
        };
        $[14] = accessibleProducts;
        $[15] = firstPartyResponse;
        $[16] = primaryProduct;
        $[17] = thirdPartyProductKeys;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== accessibleProducts || $[20] !== firstPartyResponse || $[21] !== logException || $[22] !== primaryProduct || $[23] !== thirdPartyProductKeys) {
        t7 = [
            thirdPartyProductKeys,
            firstPartyResponse,
            setAccessibleProducts,
            primaryProduct,
            accessibleProducts,
            logException
        ];
        $[19] = accessibleProducts;
        $[20] = firstPartyResponse;
        $[21] = logException;
        $[22] = primaryProduct;
        $[23] = thirdPartyProductKeys;
        $[24] = t7;
    } else t7 = $[24];
    (0, $cozmU.useEffect)(t6, t7);
    const t8 = firstPartyResponse?.intercomHmac;
    let t9;
    if ($[25] !== cloudIdProp || $[26] !== firstPartyResponse) {
        t9 = $324a448bb6e67fd9$var$isNounsAvailable(firstPartyResponse, cloudIdProp);
        $[25] = cloudIdProp;
        $[26] = firstPartyResponse;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== accessibleProducts || $[29] !== firstCloudId || $[30] !== outboundAuthConfigs || $[31] !== t8 || $[32] !== t9) {
        t10 = {
            accessibleProducts: accessibleProducts,
            outboundAuthConfigs: outboundAuthConfigs,
            firstCloudId: firstCloudId,
            intercomHmac: t8,
            isNounsAvailable: t9
        };
        $[28] = accessibleProducts;
        $[29] = firstCloudId;
        $[30] = outboundAuthConfigs;
        $[31] = t8;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
} : ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, primaryProduct: primaryProduct })=>{
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [accessibleProducts, setAccessibleProducts] = (0, $cozmU.useState)();
    const logException = (0, $298b6709c80d740f$export$67ff3bc9583d7c16)();
    const firstCloudId = (0, $cozmU.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return $324a448bb6e67fd9$var$getFirstCloudId(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const { productKeys: thirdPartyProductKeys, outboundAuthConfigs: outboundAuthConfigs } = $324a448bb6e67fd9$export$4fc2f66fb6e9d067({
        cloudId: cloudIdProp || firstCloudId || '',
        userId: userId,
        absoluteUrl: thirdPartyAbsoluteUrl
    });
    (0, $cozmU.useEffect)(()=>{
        if (!firstPartyResponse) (0, $7b01b6676ae1e761$export$2e9655e8b4177582)({
            cloudId: cloudIdProp,
            absoluteUrl: configFetchAbsoluteUrl,
            hostName: aggregatorHostName,
            userId: userId
        }).then((response)=>setFirstPartyResponse(response)).catch((error)=>{
            logException(error);
            setFirstPartyResponse({
                resources: [],
                intercomHmac: '',
                siteMetadata: []
            });
        });
    }, [
        firstPartyResponse,
        setFirstPartyResponse,
        cloudIdProp,
        configFetchAbsoluteUrl,
        aggregatorHostName,
        userId,
        logException
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (thirdPartyProductKeys && firstPartyResponse && !accessibleProducts) {
            let allAccessibleProducts = [];
            const firstPartyProducts = firstPartyResponse.resources.flatMap((resource)=>{
                const { id: id } = resource;
                const match = id.match($324a448bb6e67fd9$var$EXTRACT_PRODUCT);
                if (match && match.length >= 2) return [
                    match[1]
                ];
                return [];
            });
            if (firstPartyProducts.length === 0 && primaryProduct) // Use the primary product if the 1P Search Config request fails
            allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            // Remove Bitbucket from the list of resources if Jira is not available.
            // This is because Bitbucket results only come from workspaces that are connected to a corresponding Jira site
            // See https://hello.atlassian.net/wiki/x/1hI6CQE for details
            if (allAccessibleProducts.includes('bitbucket') && !allAccessibleProducts.includes('jira')) allAccessibleProducts = allAccessibleProducts.filter((product)=>product !== 'bitbucket');
            const allProducts = allAccessibleProducts.concat(thirdPartyProductKeys);
            setAccessibleProducts(allProducts);
        }
    }, [
        thirdPartyProductKeys,
        firstPartyResponse,
        setAccessibleProducts,
        primaryProduct,
        accessibleProducts,
        logException
    ]);
    return {
        accessibleProducts: accessibleProducts,
        outboundAuthConfigs: outboundAuthConfigs,
        firstCloudId: firstCloudId,
        intercomHmac: firstPartyResponse?.intercomHmac,
        isNounsAvailable: $324a448bb6e67fd9$var$isNounsAvailable(firstPartyResponse, cloudIdProp)
    };
};
const $324a448bb6e67fd9$var$THIRD_PARTY_TYPES = {
    'ai-3p-connector:google-workspace': `drive`,
    'ai-3p-connector:sharepoint-domain': `sharepoint`,
    'ai-3p-connector:slack-workspace': 'slack',
    //platform connector types use a different naming convention
    'sharepoint-connector': `sharepoint`,
    'webcrawler-connector': 'atlassian-web-crawler',
    'microsoft-teams-connector': 'teams',
    'github-connector': 'github',
    'figma-connector': 'figma',
    'onedrive-connector': 'onedrive',
    'dropbox-connector': 'dropbox',
    'google-calendar-connector': 'google-calendar',
    'gmail-conenctor': 'gmail',
    'airtable-connector': 'airtable',
    'notion-connector': 'notion',
    'miro-connector': 'miro'
};
const $324a448bb6e67fd9$var$get3pProductKeys = async ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId })=>{
    const resources = await (0, $7b01b6676ae1e761$export$6916ea7f169882e0)({
        cloudId: cloudId,
        absoluteUrl: absoluteUrl,
        userId: userId
    });
    let productKeys = [];
    let outboundAuthConfigs = {};
    resources.forEach((resource)=>{
        const productKey = $324a448bb6e67fd9$var$THIRD_PARTY_TYPES[resource.type] || '';
        if (productKey) {
            productKeys.push(productKey);
            outboundAuthConfigs[productKey] = {
                url: resource.outboundAuthUrl,
                userNeedsOAuth: !resource.isUserOAuthed
            };
        }
    });
    productKeys = productKeys.filter((productKey)=>(0, $37AYo.products)[productKey]);
    return {
        productKeys: productKeys,
        outboundAuthConfigs: outboundAuthConfigs
    };
};
const $324a448bb6e67fd9$var$EMPTY_RESPONSE = [];
const $324a448bb6e67fd9$export$4fc2f66fb6e9d067 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId } = t1;
    const [productKeys, setProductKeys] = (0, $cozmU.useState)(undefined);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {};
        $[2] = t2;
    } else t2 = $[2];
    const [outboundAuthConfigs, setOutboundAutConfigs] = (0, $cozmU.useState)(t2);
    const logException = (0, $298b6709c80d740f$export$67ff3bc9583d7c16)();
    let t3;
    let t4;
    if ($[3] !== absoluteUrl || $[4] !== cloudId || $[5] !== logException || $[6] !== productKeys || $[7] !== userId) {
        t3 = ()=>{
            if (!productKeys) {
                if (cloudId) $324a448bb6e67fd9$var$get3pProductKeys({
                    cloudId: cloudId,
                    absoluteUrl: absoluteUrl,
                    userId: userId
                }).then((data)=>{
                    setProductKeys(data.productKeys);
                    if (data.outboundAuthConfigs) setOutboundAutConfigs(data.outboundAuthConfigs);
                }).catch((error)=>{
                    setProductKeys($324a448bb6e67fd9$var$EMPTY_RESPONSE);
                    logException(error);
                });
                else setProductKeys($324a448bb6e67fd9$var$EMPTY_RESPONSE);
            }
        };
        t4 = [
            cloudId,
            absoluteUrl,
            userId,
            productKeys,
            logException
        ];
        $[3] = absoluteUrl;
        $[4] = cloudId;
        $[5] = logException;
        $[6] = productKeys;
        $[7] = userId;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[10] !== outboundAuthConfigs || $[11] !== productKeys) {
        t5 = {
            productKeys: productKeys,
            outboundAuthConfigs: outboundAuthConfigs
        };
        $[10] = outboundAuthConfigs;
        $[11] = productKeys;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId } = {})=>{
    const [productKeys, setProductKeys] = (0, $cozmU.useState)(undefined);
    const [outboundAuthConfigs, setOutboundAutConfigs] = (0, $cozmU.useState)({});
    const logException = (0, $298b6709c80d740f$export$67ff3bc9583d7c16)();
    (0, $cozmU.useEffect)(()=>{
        if (!productKeys) {
            if (cloudId) $324a448bb6e67fd9$var$get3pProductKeys({
                cloudId: cloudId,
                absoluteUrl: absoluteUrl,
                userId: userId
            }).then((data)=>{
                setProductKeys(data.productKeys);
                if (data.outboundAuthConfigs) setOutboundAutConfigs(data.outboundAuthConfigs);
            }).catch((error)=>{
                setProductKeys($324a448bb6e67fd9$var$EMPTY_RESPONSE);
                logException(error);
            });
            else setProductKeys($324a448bb6e67fd9$var$EMPTY_RESPONSE);
        }
    }, [
        cloudId,
        absoluteUrl,
        userId,
        productKeys,
        logException
    ]);
    return {
        productKeys: productKeys,
        outboundAuthConfigs: outboundAuthConfigs
    };
};
function $324a448bb6e67fd9$var$_temp(resource) {
    const { id: id } = resource;
    const match = id.match($324a448bb6e67fd9$var$EXTRACT_PRODUCT);
    if (match && match.length >= 2) return [
        match[1]
    ];
    return [];
}
function $324a448bb6e67fd9$var$_temp2(product) {
    return product !== "bitbucket";
}



const $990a27ebecec3695$export$8a525a626086c807 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const { cloudId: cloudId, configFetchAbsoluteUrl: configFetchAbsoluteUrl, user: user, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, SAINHostName: SAINHostName, aggregatorHostName: aggregatorHostName, orgId: orgId, analyticsAttributes: analyticsAttributes, queryParams: queryParams, features: features, searchSessionId: searchSessionId, isAdminHubAIEnabled: isAdminHubAIEnabled, callbacks: callbacks, styleOverrides: styleOverrides, components: components } = props;
    const t1 = user?.id;
    let t2;
    if ($[3] !== aggregatorHostName || $[4] !== cloudId || $[5] !== configFetchAbsoluteUrl || $[6] !== primaryProduct || $[7] !== t1 || $[8] !== thirdPartyAbsoluteUrl) {
        t2 = {
            cloudId: cloudId,
            configFetchAbsoluteUrl: configFetchAbsoluteUrl,
            aggregatorHostName: aggregatorHostName,
            userId: t1,
            thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl,
            primaryProduct: primaryProduct
        };
        $[3] = aggregatorHostName;
        $[4] = cloudId;
        $[5] = configFetchAbsoluteUrl;
        $[6] = primaryProduct;
        $[7] = t1;
        $[8] = thirdPartyAbsoluteUrl;
        $[9] = t2;
    } else t2 = $[9];
    const { accessibleProducts: accessibleProducts, outboundAuthConfigs: outboundAuthConfigs, firstCloudId: firstCloudId, intercomHmac: intercomHmac, isNounsAvailable: isNounsAvailable } = (0, $324a448bb6e67fd9$export$2b0ac18f7cd43e19)(t2);
    let t3;
    if ($[10] !== SAINHostName || $[11] !== accessibleProducts || $[12] !== aggAbsoluteUrl || $[13] !== aggregatorHostName || $[14] !== analyticsAttributes || $[15] !== cloudId || $[16] !== components || $[17] !== features || $[18] !== firstCloudId || $[19] !== intercomHmac || $[20] !== isAdminHubAIEnabled || $[21] !== isNounsAvailable || $[22] !== orgId || $[23] !== outboundAuthConfigs || $[24] !== primaryProduct || $[25] !== searchSessionId || $[26] !== styleOverrides || $[27] !== user) {
        t3 = ()=>{
            const storeContainerInitialProps = {
                cloudId: cloudId ?? firstCloudId,
                aggAbsoluteUrl: aggAbsoluteUrl,
                SAINHostName: SAINHostName,
                aggregatorHostName: aggregatorHostName,
                user: user,
                primaryProduct: primaryProduct,
                orgId: orgId,
                analyticsAttributes: analyticsAttributes,
                features: features,
                intercomHmac: intercomHmac,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                isNounsAvailable: isNounsAvailable,
                products: [
                    (0, $37AYo.ProductKeys).Confluence
                ],
                allFilterExcludedProducts: [
                    (0, $37AYo.ProductKeys).Trello
                ],
                styleOverrides: styleOverrides,
                components: components
            };
            if (searchSessionId) storeContainerInitialProps.searchSessionId = searchSessionId;
            if (accessibleProducts) {
                const parsedOutboundAuth = (0, $d925f29f24bf891f$export$550db1eccbaa1ef8).safeParse(outboundAuthConfigs);
                if (parsedOutboundAuth.success) storeContainerInitialProps.outboundAuthConfigs = outboundAuthConfigs;
            }
            return storeContainerInitialProps;
        };
        $[10] = SAINHostName;
        $[11] = accessibleProducts;
        $[12] = aggAbsoluteUrl;
        $[13] = aggregatorHostName;
        $[14] = analyticsAttributes;
        $[15] = cloudId;
        $[16] = components;
        $[17] = features;
        $[18] = firstCloudId;
        $[19] = intercomHmac;
        $[20] = isAdminHubAIEnabled;
        $[21] = isNounsAvailable;
        $[22] = orgId;
        $[23] = outboundAuthConfigs;
        $[24] = primaryProduct;
        $[25] = searchSessionId;
        $[26] = styleOverrides;
        $[27] = user;
        $[28] = t3;
    } else t3 = $[28];
    const getInitialProps = t3;
    let t4;
    if ($[29] !== getInitialProps) {
        t4 = getInitialProps();
        $[29] = getInitialProps;
        $[30] = t4;
    } else t4 = $[30];
    const t5 = callbacks?.updateQueryParameters;
    const t6 = callbacks?.getSpaceIdsFromSpaceKeys;
    let t7;
    if ($[31] !== children || $[32] !== queryParams || $[33] !== t4 || $[34] !== t5 || $[35] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $122441d1a555945e$export$557bf45c8d0f5bd), {
            initialProps: t4,
            queryParams: queryParams,
            queryParamsCallback: t5,
            getSpaceIdsFromSpaceKeys: t6
        }, children);
        $[31] = children;
        $[32] = queryParams;
        $[33] = t4;
        $[34] = t5;
        $[35] = t6;
        $[36] = t7;
    } else t7 = $[36];
    return t7;
} : ({ children: children, ...props })=>{
    const { cloudId: cloudId, configFetchAbsoluteUrl: configFetchAbsoluteUrl, user: user, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, SAINHostName: SAINHostName, aggregatorHostName: aggregatorHostName, orgId: orgId, analyticsAttributes: analyticsAttributes, queryParams: queryParams, features: features, searchSessionId: searchSessionId, isAdminHubAIEnabled: isAdminHubAIEnabled, callbacks: callbacks, styleOverrides: styleOverrides, components: components } = props;
    const { accessibleProducts: accessibleProducts, outboundAuthConfigs: outboundAuthConfigs, firstCloudId: firstCloudId, intercomHmac: intercomHmac, isNounsAvailable: isNounsAvailable } = (0, $324a448bb6e67fd9$export$2b0ac18f7cd43e19)({
        cloudId: cloudId,
        configFetchAbsoluteUrl: configFetchAbsoluteUrl,
        aggregatorHostName: aggregatorHostName,
        userId: user?.id,
        thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl,
        primaryProduct: primaryProduct
    });
    const getInitialProps = (0, $cozmU.useCallback)(()=>{
        let storeContainerInitialProps = {
            cloudId: cloudId ?? firstCloudId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            SAINHostName: SAINHostName,
            aggregatorHostName: aggregatorHostName,
            user: user,
            primaryProduct: primaryProduct,
            orgId: orgId,
            analyticsAttributes: analyticsAttributes,
            features: features,
            intercomHmac: intercomHmac,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            isNounsAvailable: isNounsAvailable,
            products: [
                (0, $37AYo.ProductKeys).Confluence
            ],
            allFilterExcludedProducts: [
                (0, $37AYo.ProductKeys).Trello
            ],
            styleOverrides: styleOverrides,
            components: components
        };
        if (searchSessionId) storeContainerInitialProps.searchSessionId = searchSessionId;
        if (accessibleProducts) {
            const parsedOutboundAuth = (0, $d925f29f24bf891f$export$550db1eccbaa1ef8).safeParse(outboundAuthConfigs);
            if (parsedOutboundAuth.success) storeContainerInitialProps.outboundAuthConfigs = outboundAuthConfigs;
        }
        return storeContainerInitialProps;
    }, [
        cloudId,
        firstCloudId,
        aggAbsoluteUrl,
        SAINHostName,
        aggregatorHostName,
        user,
        primaryProduct,
        orgId,
        analyticsAttributes,
        features,
        intercomHmac,
        isAdminHubAIEnabled,
        isNounsAvailable,
        searchSessionId,
        accessibleProducts,
        outboundAuthConfigs,
        styleOverrides,
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $122441d1a555945e$export$557bf45c8d0f5bd), {
        initialProps: getInitialProps(),
        queryParams: queryParams,
        queryParamsCallback: callbacks?.updateQueryParameters,
        getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys
    }, children);
};




















const $22e5a9be9488a0e8$export$3776ece9f99ed2df = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { children: children } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const [t1, t2] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { queryParams: queryParams, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, initialSpaceARIs: initialSpaceARIs, user: user, products: products, allFilterExcludedProducts: allFilterExcludedProducts } = t1;
    const { setQueryParams: setQueryParams } = t2;
    const t3 = user?.id || "";
    let t4;
    if ($[0] !== aggAbsoluteUrl || $[1] !== cloudId || $[2] !== initialSpaceARIs || $[3] !== intl || $[4] !== t3) {
        t4 = {
            intl: intl,
            ari: "",
            cloudId: cloudId,
            userId: t3,
            initialSpaceARIs: initialSpaceARIs,
            aggAbsoluteUrl: aggAbsoluteUrl
        };
        $[0] = aggAbsoluteUrl;
        $[1] = cloudId;
        $[2] = initialSpaceARIs;
        $[3] = intl;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const config = t4;
    let queryParamsInUse;
    if ($[6] !== queryParams) {
        const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt, ...t5 } = queryParams;
        queryParamsInUse = t5;
        $[6] = queryParams;
        $[7] = queryParamsInUse;
    } else queryParamsInUse = $[7];
    let t5;
    if ($[8] !== allFilterExcludedProducts || $[9] !== children || $[10] !== config || $[11] !== products || $[12] !== queryParamsInUse || $[13] !== setQueryParams) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Va9o.SearchStoreContainer), {
            queryParams: queryParamsInUse,
            allFilters: (0, $3add93f8c7972f84$export$d8428ac7d93fb69a),
            config: config,
            setQueryParams: setQueryParams,
            availableProducts: products,
            allFilterExcludedProducts: allFilterExcludedProducts
        }, children);
        $[8] = allFilterExcludedProducts;
        $[9] = children;
        $[10] = config;
        $[11] = products;
        $[12] = queryParamsInUse;
        $[13] = setQueryParams;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ children: children })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [{ queryParams: queryParams, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, initialSpaceARIs: initialSpaceARIs, user: user, products: products, allFilterExcludedProducts: allFilterExcludedProducts }, { setQueryParams: setQueryParams }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const config = {
        intl: intl,
        ari: '',
        cloudId: cloudId,
        userId: user?.id || '',
        initialSpaceARIs: initialSpaceARIs,
        aggAbsoluteUrl: aggAbsoluteUrl
    };
    const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt, ...queryParamsInUse } = queryParams;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Va9o.SearchStoreContainer), {
        queryParams: queryParamsInUse,
        allFilters: (0, $3add93f8c7972f84$export$d8428ac7d93fb69a),
        config: config,
        setQueryParams: setQueryParams,
        availableProducts: products,
        allFilterExcludedProducts: allFilterExcludedProducts
    }, children);
};












var $aHr8q = parcelRequire("aHr8q");


var $ljSu0 = parcelRequire("ljSu0");


const $1b8d152ae38d18a3$export$7eaa56945d1970dc = 'kkvkd7ql';






const $458383e8c578a95c$var$generateSearchPageVisitedString = ()=>{
    const currentDate = new Date();
    const year = (0, $ljSu0.default)(currentDate);
    const week = (0, $aHr8q.default)(currentDate);
    return `search_page_visited_${year}_week_${week}`;
};
const $458383e8c578a95c$export$2a1369f17c026393 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { children: children } = t0;
    const { boot: boot, shutdown: shutdown, trackEvent: trackEvent } = (0, $79a9ae6415bd9660$export$624db904a0be2d69)();
    const [intercomHmac] = (0, $122441d1a555945e$export$8ab143228c6f49a2)();
    const [userWithStatus] = (0, $122441d1a555945e$export$23bbbc4533528f03)();
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    const [availableProducts] = (0, $122441d1a555945e$export$5afbfe6edea8e998)();
    const isUserUnauthenticated = userWithStatus.status === (0, $aaa3fcc9c0025f59$export$a82073022ded66e8).Unauthenticated;
    let t1;
    if ($[0] !== availableProducts || $[1] !== boot || $[2] !== features?.sideBySide?.enabled || $[3] !== intercomHmac || $[4] !== isUserUnauthenticated || $[5] !== shutdown || $[6] !== trackEvent || $[7] !== userWithStatus.email || $[8] !== userWithStatus.id || $[9] !== userWithStatus.name) {
        t1 = ()=>{
            if (features?.sideBySide?.enabled) return;
            if (isUserUnauthenticated || !userWithStatus.name || !userWithStatus.email || !intercomHmac) return;
            if (availableProducts.length === 0) return;
            const thirdPartyProducts = availableProducts.filter($458383e8c578a95c$var$_temp);
            boot({
                userId: userWithStatus.id ?? undefined,
                name: userWithStatus.name,
                email: userWithStatus.email,
                userHash: intercomHmac,
                customAttributes: {
                    atlassian_account_email: userWithStatus.email,
                    connected_third_parties: thirdPartyProducts.join(",")
                }
            });
            const eventString = $458383e8c578a95c$var$generateSearchPageVisitedString();
            trackEvent(eventString);
            trackEvent("search_page_visited");
            return ()=>{
                shutdown();
            };
        };
        $[0] = availableProducts;
        $[1] = boot;
        $[2] = features?.sideBySide?.enabled;
        $[3] = intercomHmac;
        $[4] = isUserUnauthenticated;
        $[5] = shutdown;
        $[6] = trackEvent;
        $[7] = userWithStatus.email;
        $[8] = userWithStatus.id;
        $[9] = userWithStatus.name;
        $[10] = t1;
    } else t1 = $[10];
    const t2 = features?.sideBySide?.enabled;
    let t3;
    if ($[11] !== availableProducts || $[12] !== boot || $[13] !== intercomHmac || $[14] !== isUserUnauthenticated || $[15] !== shutdown || $[16] !== t2 || $[17] !== trackEvent || $[18] !== userWithStatus.email || $[19] !== userWithStatus.id || $[20] !== userWithStatus.name) {
        t3 = [
            availableProducts,
            boot,
            t2,
            intercomHmac,
            shutdown,
            isUserUnauthenticated,
            userWithStatus.id,
            userWithStatus.name,
            userWithStatus.email,
            trackEvent
        ];
        $[11] = availableProducts;
        $[12] = boot;
        $[13] = intercomHmac;
        $[14] = isUserUnauthenticated;
        $[15] = shutdown;
        $[16] = t2;
        $[17] = trackEvent;
        $[18] = userWithStatus.email;
        $[19] = userWithStatus.id;
        $[20] = userWithStatus.name;
        $[21] = t3;
    } else t3 = $[21];
    (0, $cozmU.useEffect)(t1, t3);
    let t4;
    if ($[22] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[22] = children;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ({ children: children })=>{
    const { boot: boot, shutdown: shutdown, trackEvent: trackEvent } = (0, $79a9ae6415bd9660$export$624db904a0be2d69)();
    const [intercomHmac] = (0, $122441d1a555945e$export$8ab143228c6f49a2)();
    const [userWithStatus] = (0, $122441d1a555945e$export$23bbbc4533528f03)();
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    const [availableProducts] = (0, $122441d1a555945e$export$5afbfe6edea8e998)();
    const isUserUnauthenticated = userWithStatus.status === (0, $aaa3fcc9c0025f59$export$a82073022ded66e8).Unauthenticated;
    (0, $cozmU.useEffect)(()=>{
        // Do not boot if sideBySide feature is enabled
        if (features?.sideBySide?.enabled) return;
        // Do not boot if user details are not available
        if (isUserUnauthenticated || !userWithStatus.name || !userWithStatus.email || !intercomHmac) return;
        // Do not boot if there are no products available
        if (availableProducts.length === 0) return;
        const thirdPartyProducts = availableProducts.filter((product)=>(0, $a4ade32e9dcacfed$export$b0f4af9a0173cbfd)(product));
        boot({
            userId: userWithStatus.id ?? undefined,
            name: userWithStatus.name,
            email: userWithStatus.email,
            userHash: intercomHmac,
            customAttributes: {
                // Some intercom users were registered without an email and succeeding
                // bootstrap calls did not update their email.
                // This change is temporary to ensure all users have an attribute that
                // actually stores the email for them :fried_angry_lol_cry:
                atlassian_account_email: userWithStatus.email,
                connected_third_parties: thirdPartyProducts.join(',')
            }
        });
        // A new intercom event will be created each week of the year.
        // Example: search_page_visited_2024_week_29
        // Events: https://app.intercom.com/a/apps/kkvkd7ql/settings/data/people?tab=events
        const eventString = $458383e8c578a95c$var$generateSearchPageVisitedString();
        trackEvent(eventString);
        trackEvent('search_page_visited');
        return ()=>{
            shutdown();
        };
    }, [
        availableProducts,
        boot,
        features?.sideBySide?.enabled,
        intercomHmac,
        shutdown,
        isUserUnauthenticated,
        userWithStatus.id,
        userWithStatus.name,
        userWithStatus.email,
        trackEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};

const $458383e8c578a95c$var$Intercom = ({ children: children })=>{
    const [intercomAllowed, setIntercomAllowed] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const loadCheckThirdParty = async ()=>{
            // lazy loaded because this package breaks VR tests and local storybook when upgrading to react-18
            // https://atlassian.slack.com/archives/C05U6KCDNQJ/p1729037211204509?thread_ts=1725415385.613669&cid=C05U6KCDNQJ
            const { checkThirdParty: checkThirdParty } = await (parcelRequire("hsKod"));
            checkThirdParty('intercom', async ()=>setIntercomAllowed(true), async ()=>setIntercomAllowed(false));
        };
        loadCheckThirdParty();
    }, []);
    if (!intercomAllowed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79a9ae6415bd9660$export$5091c5023e5c7eba), {
        appId: (0, $1b8d152ae38d18a3$export$7eaa56945d1970dc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($458383e8c578a95c$export$2a1369f17c026393, null, children));
};
const $458383e8c578a95c$var$IntercomWithErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($458383e8c578a95c$var$Intercom, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
            fallback: children
        }, t1);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $298b6709c80d740f$export$e926676385687eaf), {
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($458383e8c578a95c$var$Intercom, null, children));
};
var $458383e8c578a95c$export$2e2bcd8739ae039 = $458383e8c578a95c$var$IntercomWithErrorBoundary;
function $458383e8c578a95c$var$_temp(product) {
    return (0, $a4ade32e9dcacfed$export$b0f4af9a0173cbfd)(product);
}





















var $6Tme9 = parcelRequire("6Tme9");




var $7Mvs5 = parcelRequire("7Mvs5");

const $741d7470c5c604dc$var$TEAMS_BULK_REST_API_URL = '/gateway/api/v4/teams/withMembers/bulk';
const $741d7470c5c604dc$var$cache = (0, $7Mvs5.inMemoryCache)();
const $741d7470c5c604dc$export$a4f9b7f788f9e71f = (request)=>{
    const keyObj = {
        teamIds: request.teamIds.sort()
    };
    return (0, $7tsC5.generateHashFromVariables)(keyObj);
};
const $741d7470c5c604dc$export$eb16261a2bb165d4 = async (request)=>{
    return $741d7470c5c604dc$var$cache.inMemoryDecorator($741d7470c5c604dc$export$a4f9b7f788f9e71f(request), ()=>fetch($741d7470c5c604dc$var$TEAMS_BULK_REST_API_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(request)
        }).then((response)=>{
            if (response.ok) return response.json();
            return Promise.reject({
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: `Unable to fetch ${$741d7470c5c604dc$var$TEAMS_BULK_REST_API_URL} ${response.statusText}`,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            });
        }).catch((e)=>{
            return {
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: e.message,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            };
        }));
};









var $jViGU = parcelRequire("jViGU");




var $4mebe = parcelRequire("4mebe");











const $59f3156662ef05ae$export$60bd4eb259acb432 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const [t0] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const { cloudId: t1, aggregatorHostName: aggregatorHostName } = t0;
    const cloudId = t1 === undefined ? "" : t1;
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const [, t2] = (0, $2Va9o.useAutoCorrection)();
    const { setAutoCorrection: setAutoCorrection } = t2;
    let t3;
    let t4;
    if ($[0] !== aggregatorHostName || $[1] !== cloudId || $[2] !== searchQuery || $[3] !== setAutoCorrection) {
        t3 = ()=>{
            const searchClient = (0, $6Tme9.createClient)({
                cloudId: cloudId,
                aggregatorHostName: aggregatorHostName
            });
            const containsSearchQuery = searchQuery !== "";
            const shouldGetAutoCorrection = containsSearchQuery;
            if (!shouldGetAutoCorrection) return;
            searchClient.getAutoCorrection({
                query: searchQuery
            }).then((autoCorrection)=>{
                setAutoCorrection(autoCorrection);
            });
        };
        t4 = [
            searchQuery,
            cloudId,
            setAutoCorrection,
            aggregatorHostName
        ];
        $[0] = aggregatorHostName;
        $[1] = cloudId;
        $[2] = searchQuery;
        $[3] = setAutoCorrection;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
} : ()=>{
    const [{ cloudId: cloudId = '', aggregatorHostName: aggregatorHostName }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const [, { setAutoCorrection: setAutoCorrection }] = (0, $2Va9o.useAutoCorrection)();
    (0, $cozmU.useEffect)(()=>{
        const searchClient = (0, $6Tme9.createClient)({
            cloudId: cloudId,
            aggregatorHostName: aggregatorHostName
        });
        const containsSearchQuery = searchQuery !== '';
        const shouldGetAutoCorrection = containsSearchQuery;
        if (!shouldGetAutoCorrection) return;
        searchClient.getAutoCorrection({
            query: searchQuery
        }).then((autoCorrection)=>{
            setAutoCorrection(autoCorrection);
        });
    }, [
        searchQuery,
        cloudId,
        setAutoCorrection,
        aggregatorHostName
    ]);
};
const $59f3156662ef05ae$export$c199ac7e412a5a11 = ()=>{
    const [{ cloudId: cloudId = '', aggAbsoluteUrl: aggAbsoluteUrl, primaryProduct: primaryProduct, outboundAuthConfigs: outboundAuthConfigs }] = (0, $122441d1a555945e$export$9ba1f1f28043c5bf)();
    const isSearchReady = (0, $2Va9o.useIsSearchReady)();
    const [searchSessionId] = (0, $122441d1a555945e$export$e1e7a4797df1a656)();
    const [{ order: order, field: field }] = (0, $2Va9o.useResultsSort)();
    const [selectedProduct] = (0, $2Va9o.useSelectedProduct)();
    const fetchFromCursor = (0, $2Va9o.useFetchFromCursor)();
    const { selectedFilters: selectedFilters, unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters, selectedEntities: selectedEntities, entities: entities, hasFiltersSelected: hasFiltersSelected, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $979870397bacea10$export$e90e90fddddd8154)({
        outboundAuthConfigs: outboundAuthConfigs
    });
    const [searchQuery] = (0, $2Va9o.useSearchQuery)();
    const [originalQuery] = (0, $2Va9o.useOriginalQuery)();
    const { setJiraIssueDetails: setJiraIssueDetails, setJiraIssueFieldsLoading: setJiraIssueFieldsLoading, setCompassTeamsLoading: setCompassTeamsLoading, setCompassTeams: setCompassTeams, setIsLoading: setIsLoading, setResults: setResults, setQueryUpdatedTime: setQueryUpdatedTime, resetResults: resetResults, setProductResultCount: setProductResultCount, setIsLoadingMore: setIsLoadingMore, appendMoreResults: appendMoreResults } = (0, $2Va9o.useSearchActions)();
    const [retryCount] = (0, $2Va9o.useRetryCount)();
    const requestRef = (0, $cozmU.useRef)();
    const [backendExperiment] = (0, $122441d1a555945e$export$9e89c81d9ff2c758)();
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const intercom = (0, $ecf47e97be76a1bd$export$f0fed4b0765d7314)();
    const [frontendExperiments] = (0, $122441d1a555945e$export$d2c28b106f1bf70b)();
    const logException = (0, $298b6709c80d740f$export$67ff3bc9583d7c16)();
    const trackIntercomEvents = (0, $cozmU.useCallback)(()=>{
        if (selectedProduct && (0, $a4ade32e9dcacfed$export$b0f4af9a0173cbfd)(selectedProduct)) intercom?.trackEvent('search_requested_3p', {
            product_filter: selectedProduct
        });
        else intercom?.trackEvent('search_requested');
    }, [
        selectedProduct,
        intercom
    ]);
    // We compare these via deep value equality, as currently the objects are regenerated
    // The bug this fixes is that when adding a filter from a dropdown, we shouldn't cause a search to run or load
    // TODO refactor this so we can go back to Object.is dependency equality on these objects
    const selectedFiltersValueEquality = JSON.stringify(selectedFilters);
    const selectedEntitiesValueEquality = JSON.stringify(selectedEntities);
    const entitiesValueEquality = JSON.stringify(entities);
    const frontendExperimentsValueEquality = JSON.stringify(frontendExperiments);
    const experimentLayersValueEquality = JSON.stringify(experimentLayers);
    (0, $cozmU.useEffect)(()=>{
        if (!isSearchReady) return;
        // Reset results when...
        // 1. There is no search query
        // 2. There is no selected product or the selected product is not Confluence
        // 3. There are no selected child filters
        const containsSearchQuery = searchQuery !== '';
        const confluenceIsSelected = selectedProduct === 'confluence';
        const shouldTriggerSearch = containsSearchQuery || containsSearchQuery && hasFiltersSelected || confluenceIsSelected;
        // Reset results and cancel inflight requests if we are not searching
        if (!shouldTriggerSearch) {
            if (requestRef.current) requestRef.current.cancel();
            resetResults();
            return;
        }
        // Cancel the inflight request if there is one
        if (requestRef.current) requestRef.current.cancel();
        setProductResultCount();
        const restartUFOExperience = async ()=>{
            if (requestRef.current) await (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).abort();
            await (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).start();
            (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).mark('request_start');
        };
        restartUFOExperience();
        if (fetchFromCursor && fetchFromCursor !== '') setIsLoadingMore(true);
        else setIsLoading(true);
        setQueryUpdatedTime();
        requestRef.current = new (0, $398a80973ab06e53$export$5782acf08706f13d)((0, $d374566d2028db50$export$46f82b8a3ce2a183)({
            query: searchQuery,
            originalQuery: originalQuery,
            entities: entities,
            selectedFilters: selectedFilters,
            aggAbsoluteUrl: aggAbsoluteUrl,
            cloudId: cloudId,
            searchSessionId: searchSessionId,
            sort: {
                order: order,
                field: field
            },
            sourceProduct: primaryProduct,
            experimentId: experimentId,
            shadowExperimentId: shadowExperimentId,
            experimentLayers: experimentLayers,
            after: fetchFromCursor,
            limit: entities.length === (0, $jViGU.DEFAULT_ENTITY_ATI).length ? (0, $jViGU.RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS) : (0, $jViGU.RESULT_LIMIT_FOR_SINGLE_PRODUCT)
        }));
        requestRef.current.promise().then((aggResults)=>{
            const { data: data, extensions: extensions, errors: errors } = aggResults;
            const errorMessage = errors?.[0]?.message;
            const resultsFetchError = errorMessage ? new (0, $d374566d2028db50$export$94cd2e6f39615373)(errorMessage) : undefined;
            if (fetchFromCursor && fetchFromCursor !== '') appendMoreResults(data?.search.results);
            else setResults(data?.search.results, resultsFetchError, extensions?.gateway?.request_id || undefined);
            setProductResultCount(data?.search.results.totalCounts || []);
            trackIntercomEvents();
            (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).mark('request_end');
            (0, $a69b1b004ef5dd7f$export$e882a2ec68d19be8).mark('render_start');
            resultsFetchError && logException(resultsFetchError);
            const edges = data?.search.results.edges;
            // Fetch extra fields for Issues
            const issuesToFetch = [];
            // Fetch team names associated with the teamIds in Compass results
            const teamsIdsToFetch = [];
            if (edges && edges.length > 0) edges.forEach((edge)=>{
                if ((0, $bzYTC.isSearchResultJiraIssue)(edge.node)) {
                    const issueKey = edge.node.issue?.webUrl?.split('/').at(-1) || edge.node.url.split('/').at(-1);
                    if (!!issueKey) issuesToFetch.push(issueKey);
                } else if ((0, $9Ppk1.isSearchCompassPartial)(edge.node)) {
                    const teamId = (0, $4mebe.getTeamId)(edge.node.ownerId);
                    if (teamId && !teamsIdsToFetch.includes(teamId)) teamsIdsToFetch.push(teamId);
                }
            });
            if (issuesToFetch.length > 0) {
                setJiraIssueFieldsLoading(true);
                (0, $d374566d2028db50$export$6405a4ba66d50345)({
                    issueKeys: issuesToFetch,
                    cloudId: cloudId,
                    aggAbsoluteUrl: aggAbsoluteUrl
                }).then((jiraHydrationResults)=>{
                    const issues = jiraHydrationResults.data?.jira.issuesByKey;
                    setJiraIssueDetails(issues || []);
                }).finally(()=>{
                    setJiraIssueFieldsLoading(false);
                });
            }
            if (teamsIdsToFetch.length > 0) {
                setCompassTeamsLoading(true);
                (0, $741d7470c5c604dc$export$eb16261a2bb165d4)({
                    siteId: cloudId,
                    teamIds: teamsIdsToFetch
                }).then((data)=>{
                    setCompassTeams(data.teams);
                }).finally(()=>{
                    setCompassTeamsLoading(false);
                });
            }
        }).catch((e)=>{
            if (e instanceof (0, $d374566d2028db50$export$8ba86dff7c04c14c)) setResults(undefined, e);
            else if (!(e instanceof (0, $398a80973ab06e53$export$d7f5e52d091a66db))) {
                setResults(undefined, new (0, $d374566d2028db50$export$94cd2e6f39615373)(e.message));
                setProductResultCount([]);
                trackIntercomEvents();
            }
        });
        const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters } = selectedFilters;
        const resultsCountVariables = {
            query: searchQuery,
            queryVersion: 1,
            cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
            limit: 0,
            commonFilters: commonFilters,
            confluenceFilters: confluenceFilters,
            jiraFilters: jiraFilters,
            thirdPartyFilters: unselectedProductsThirdPartyFilters,
            entities: entitiesForResultsCountQuery,
            searchSessionId: searchSessionId,
            sort: [],
            sourceProduct: primaryProduct
        };
        const showResultCounts = false;
        if (showResultCounts) (0, $hOJLU.resultsCountQuery)({
            variables: resultsCountVariables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            originalQuery: originalQuery
        }).then((resultsCountData)=>{
            setProductResultCount(resultsCountData?.data?.search.results.totalCounts || []);
        }).catch(()=>{
            setProductResultCount([]);
        });
    // Note! Please ensure all dependencies are actually here, we're just trying to ignore the xValueEquality ones
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSearchReady,
        resetResults,
        searchQuery,
        originalQuery,
        selectedFiltersValueEquality,
        // selectedFilters,
        selectedEntitiesValueEquality,
        // selectedEntities,
        entitiesValueEquality,
        // entities,
        selectedProduct,
        hasFiltersSelected,
        setIsLoading,
        setResults,
        setQueryUpdatedTime,
        setProductResultCount,
        searchSessionId,
        aggAbsoluteUrl,
        cloudId,
        retryCount,
        // will cause a new request when it increments. Is reset to 0 when query changes.
        field,
        order,
        primaryProduct,
        experimentId,
        experimentLayersValueEquality,
        shadowExperimentId,
        trackIntercomEvents,
        frontendExperimentsValueEquality,
        fetchFromCursor
    ]);
};



const $10ce509e7050e57c$var$FetchResults = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    (0, $59f3156662ef05ae$export$c199ac7e412a5a11)();
    return null;
} : ()=>{
    (0, $59f3156662ef05ae$export$c199ac7e412a5a11)();
    return null;
};
const $10ce509e7050e57c$export$da0f89c65081f644 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    let t1;
    if ($[0] !== features?.fetchInitialResults?.enabled) {
        t1 = Boolean(features?.fetchInitialResults?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($10ce509e7050e57c$var$FetchResults, null);
        $[0] = features?.fetchInitialResults?.enabled;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children })=>{
    const [features] = (0, $122441d1a555945e$export$4a39035bacc4ed76)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, Boolean(features?.fetchInitialResults?.enabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($10ce509e7050e57c$var$FetchResults, null), children);
};


const $6b36a4549efacc39$export$794614fa392eb573 = ({ children: children, ...props })=>{
    const { mapUserIdToProfileUrl: mapUserIdToProfileUrl, linkComponent: linkComponent, generateSearchUrl: generateSearchUrl, queryParams: queryParams, onNavigate: onNavigate } = props;
    // Ensure callback is stable by using the initial value only
    const mapUserIdToProfileUrlRef = (0, $cozmU.useRef)(mapUserIdToProfileUrl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3a2567ac224fb8e0$export$1d29bcde96a75168), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $990a27ebecec3695$export$8a525a626086c807), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22e5a9be9488a0e8$export$3776ece9f99ed2df), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $458383e8c578a95c$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d848581de35407c0$export$20d2b7652facc723), {
        linkComponent: linkComponent,
        mapUserIdToProfileUrl: mapUserIdToProfileUrlRef.current,
        generateSearchUrl: generateSearchUrl,
        queryParams: queryParams,
        onNavigate: onNavigate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $10ce509e7050e57c$export$da0f89c65081f644), null, children))))));
};


const $232672d4bc1cf7f5$export$a54ec244c8863715 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, linkComponent: linkComponent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0f6b39825d0c965$export$75f7910544138d14), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1fcc08c0b2907b8$export$c84671f46d6a1ca), {
            components: {
                filters: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d98235a0e8ddb8b$export$2e2bcd8739ae039), null),
                results: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $698b45f6b1b2c33e$export$b4ce9e0c6695ed08), null)
            }
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== callbacks || $[2] !== linkComponent || $[3] !== mapUserIdToProfileUrl || $[4] !== shell) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b36a4549efacc39$export$794614fa392eb573), {
            ...shell,
            callbacks: callbacks,
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            linkComponent: linkComponent
        }, t1);
        $[1] = callbacks;
        $[2] = linkComponent;
        $[3] = mapUserIdToProfileUrl;
        $[4] = shell;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, linkComponent: linkComponent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b36a4549efacc39$export$794614fa392eb573), {
        ...shell,
        callbacks: callbacks,
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        linkComponent: linkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0f6b39825d0c965$export$75f7910544138d14), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1fcc08c0b2907b8$export$c84671f46d6a1ca), {
        components: {
            filters: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d98235a0e8ddb8b$export$2e2bcd8739ae039), null),
            results: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $698b45f6b1b2c33e$export$b4ce9e0c6695ed08), null)
        }
    })));
const $232672d4bc1cf7f5$export$9303e6cdcc95142a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, linkComponent: linkComponent, filtersToHide: filtersToHide } = t0;
    let t1;
    if ($[0] !== filtersToHide) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0f6b39825d0c965$export$75f7910544138d14), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1fcc08c0b2907b8$export$c84671f46d6a1ca), {
            components: {
                filters: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d98235a0e8ddb8b$export$4f7c5f9bd9ac3227), {
                    filtersToHide: filtersToHide
                })
            },
            disableHeaderGridStyles: true
        }));
        $[0] = filtersToHide;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== callbacks || $[3] !== linkComponent || $[4] !== mapUserIdToProfileUrl || $[5] !== shell || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b36a4549efacc39$export$794614fa392eb573), {
            ...shell,
            callbacks: callbacks,
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            linkComponent: linkComponent
        }, t1);
        $[2] = callbacks;
        $[3] = linkComponent;
        $[4] = mapUserIdToProfileUrl;
        $[5] = shell;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, linkComponent: linkComponent, filtersToHide: filtersToHide })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b36a4549efacc39$export$794614fa392eb573), {
        ...shell,
        callbacks: callbacks,
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        linkComponent: linkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0f6b39825d0c965$export$75f7910544138d14), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1fcc08c0b2907b8$export$c84671f46d6a1ca), {
        components: {
            filters: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d98235a0e8ddb8b$export$4f7c5f9bd9ac3227), {
                filtersToHide: filtersToHide
            })
        },
        disableHeaderGridStyles: true
    })));
const $232672d4bc1cf7f5$export$55d7609a8f1eccd2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, generateSearchUrl: generateSearchUrl, linkComponent: linkComponent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0f6b39825d0c965$export$75f7910544138d14), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cbdd30a2675003a4$export$2e2bcd8739ae039), null));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== callbacks || $[2] !== generateSearchUrl || $[3] !== linkComponent || $[4] !== mapUserIdToProfileUrl || $[5] !== shell) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b36a4549efacc39$export$794614fa392eb573), {
            ...shell,
            callbacks: callbacks,
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            generateSearchUrl: generateSearchUrl,
            linkComponent: linkComponent
        }, t1);
        $[1] = callbacks;
        $[2] = generateSearchUrl;
        $[3] = linkComponent;
        $[4] = mapUserIdToProfileUrl;
        $[5] = shell;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, generateSearchUrl: generateSearchUrl, linkComponent: linkComponent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b36a4549efacc39$export$794614fa392eb573), {
        ...shell,
        callbacks: callbacks,
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        generateSearchUrl: generateSearchUrl,
        linkComponent: linkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0f6b39825d0c965$export$75f7910544138d14), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cbdd30a2675003a4$export$2e2bcd8739ae039), null)));
module.exports["SearchPage"] = $232672d4bc1cf7f5$export$a54ec244c8863715;
module.exports["CustomSearchMacroConfigFilters"] = $232672d4bc1cf7f5$export$9303e6cdcc95142a;
module.exports["SearchInput"] = $232672d4bc1cf7f5$export$55d7609a8f1eccd2;

});

parcelRegister("hsKod", function(module, exports) {

let $cb69092ceb55987d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb69092ceb55987d$var$load("aTi5X").then(()=>parcelRequire('dMmFn'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("gExfk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $5dDC4 = parcelRequire("5dDC4");

var $a96iv = parcelRequire("a96iv");

var $hjUDQ = parcelRequire("hjUDQ");

var $4cGll = parcelRequire("4cGll");

var $cfM7x = parcelRequire("cfM7x");


var $KDPGa = parcelRequire("KDPGa");










const $42592e50ee014fa8$var$updateNodeParameters = (editorActions, updatedParameters)=>{
    const selectedNodeJSON = editorActions.getSelectedNode()?.toJSON();
    const updatedNodeSelection = {
        ...selectedNodeJSON,
        attrs: {
            ...selectedNodeJSON?.attrs,
            parameters: {
                ...updatedParameters
            }
        }
    };
    editorActions.replaceSelection(updatedNodeSelection, true);
};
const $42592e50ee014fa8$var$fetchLocalIdMacroParameters = (editorActions, localId)=>{
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    return params;
};
const $42592e50ee014fa8$var$removeProperties = (extensionsPropertiesToRemove, extensionParameters)=>{
    const mutatedParameters = {
        ...extensionParameters
    };
    extensionsPropertiesToRemove.forEach((field)=>{
        if (field in mutatedParameters) delete mutatedParameters[field];
    });
    return mutatedParameters;
};
const $42592e50ee014fa8$export$d78d7700cec50018 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { localId: localId, editorActions: editorActions } = t0;
    let t1;
    if ($[0] !== editorActions || $[1] !== localId) {
        t1 = $42592e50ee014fa8$var$fetchLocalIdMacroParameters(editorActions, localId);
        $[0] = editorActions;
        $[1] = localId;
        $[2] = t1;
    } else t1 = $[2];
    const [extensionParameters, setExtensionParameters] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[3] !== editorActions || $[4] !== localId) {
        t2 = ()=>{
            const extensionNodeParams = $42592e50ee014fa8$var$fetchLocalIdMacroParameters(editorActions, localId);
            setExtensionParameters(extensionNodeParams);
        };
        t3 = [
            editorActions,
            localId
        ];
        $[3] = editorActions;
        $[4] = localId;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] !== editorActions) {
        t4 = (newExtensionParameters, t5)=>{
            const options = t5 === undefined ? {} : t5;
            setExtensionParameters((prevParams)=>{
                let mutatedFields = {
                    ...prevParams
                };
                const fieldsToRemove = [
                    ...options?.fieldsToRemove || []
                ];
                if (fieldsToRemove.length > 0) mutatedFields = $42592e50ee014fa8$var$removeProperties(fieldsToRemove, prevParams);
                const updatedParams = {
                    ...mutatedFields,
                    ...newExtensionParameters
                };
                $42592e50ee014fa8$var$updateNodeParameters(editorActions, updatedParams);
                return updatedParams;
            });
        };
        $[7] = editorActions;
        $[8] = t4;
    } else t4 = $[8];
    const updateExtensionParams = t4;
    let t5;
    if ($[9] !== updateExtensionParams) {
        t5 = (updatedFields, t6)=>{
            const options_0 = t6 === undefined ? {} : t6;
            return updateExtensionParams(updatedFields, options_0);
        };
        $[9] = updateExtensionParams;
        $[10] = t5;
    } else t5 = $[10];
    const updateMainFormField = t5;
    let t6;
    if ($[11] !== updateMainFormField) {
        t6 = {
            updateMainFormField: updateMainFormField
        };
        $[11] = updateMainFormField;
        $[12] = t6;
    } else t6 = $[12];
    const extensionActions = t6;
    let t7;
    if ($[13] !== extensionActions || $[14] !== extensionParameters) {
        t7 = {
            extensionParameters: extensionParameters,
            extensionActions: extensionActions
        };
        $[13] = extensionActions;
        $[14] = extensionParameters;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
} : ({ localId: localId, editorActions: editorActions })=>{
    const [extensionParameters, setExtensionParameters] = (0, $cozmU.useState)($42592e50ee014fa8$var$fetchLocalIdMacroParameters(editorActions, localId));
    (0, $cozmU.useEffect)(()=>{
        const extensionNodeParams = $42592e50ee014fa8$var$fetchLocalIdMacroParameters(editorActions, localId);
        setExtensionParameters(extensionNodeParams);
    }, [
        editorActions,
        localId
    ]);
    const updateExtensionParams = (0, $cozmU.useCallback)((newExtensionParameters, options = {})=>{
        setExtensionParameters((prevParams)=>{
            let mutatedFields = {
                ...prevParams
            };
            const fieldsToRemove = [
                ...options?.fieldsToRemove || []
            ];
            if (fieldsToRemove.length > 0) mutatedFields = $42592e50ee014fa8$var$removeProperties(fieldsToRemove, prevParams);
            const updatedParams = {
                ...mutatedFields,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            $42592e50ee014fa8$var$updateNodeParameters(editorActions, updatedParams);
            return updatedParams;
        });
    }, [
        editorActions
    ]);
    const updateMainFormField = (0, $cozmU.useCallback)((updatedFields, options_0 = {})=>updateExtensionParams(updatedFields, options_0), [
        updateExtensionParams
    ]);
    const extensionActions = (0, $cozmU.useMemo)(()=>({
            updateMainFormField: updateMainFormField
        }), [
        updateMainFormField
    ]);
    return {
        extensionParameters: extensionParameters,
        extensionActions: extensionActions
    };
};















var $I7hWB = parcelRequire("I7hWB");


var $iDrrr = parcelRequire("iDrrr");




var $dinVW = parcelRequire("dinVW");


var $3yqh5 = parcelRequire("3yqh5");


var $ik71g = parcelRequire("ik71g");




const $672d0229c2938375$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    filtersTitle: {
        id: "company-hub.search-extension.custom-search-config-panel.filters-title",
        defaultMessage: "Filters"
    }
});


const $e25e772a0a129a73$var$cssStyles = {
    container: "_46hvQm5zaO _22sfPnNvrM _3zygPU9r67 _2IVJ4M6wH8 _0xmtko5zaO _3hhsrrNvrM _3XVgLM9r67 _3BoeID6wH8 _0rIjyk5zaO",
    header: "_2Y7lL42ADO"
};
const $e25e772a0a129a73$export$41dc5c54b6ccd429 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { filters: filters, setFilters: setFilters, cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, isAdminHubAIEnabled: isAdminHubAIEnabled } = t0;
    const getSpaceIdsFromSpaceKeys = (0, $3yqh5.useGetSpaceIdsFromSpaceKeys)();
    let t1;
    if ($[0] !== setFilters) {
        t1 = (newFilters)=>{
            setFilters({
                ...newFilters,
                product: "confluence"
            });
        };
        $[0] = setFilters;
        $[1] = t1;
    } else t1 = $[1];
    const setFiltersInternal = t1;
    let t2;
    if ($[2] !== displayName || $[3] !== userId) {
        t2 = {
            id: userId,
            name: displayName
        };
        $[2] = displayName;
        $[3] = userId;
        $[4] = t2;
    } else t2 = $[4];
    const userDetails = t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        const isUnifiedSearchEnabled = (0, $iDrrr.fg)("unified_search_in_confluence");
        t3 = isUnifiedSearchEnabled ? [
            "universalTypeFilter"
        ] : [
            "universalTypeFilter",
            "owner"
        ];
        $[5] = t3;
    } else t3 = $[5];
    const filtersToHide = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e25e772a0a129a73$var$cssStyles.header
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $672d0229c2938375$export$defe85febe8b728c).filtersTitle)));
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== cloudId || $[8] !== filters || $[9] !== isAdminHubAIEnabled || $[10] !== orgId || $[11] !== userDetails) {
        t5 = {
            cloudId: cloudId,
            orgId: orgId,
            user: userDetails,
            primaryProduct: "confluence",
            queryParams: filters,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        };
        $[7] = cloudId;
        $[8] = filters;
        $[9] = isAdminHubAIEnabled;
        $[10] = orgId;
        $[11] = userDetails;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== getSpaceIdsFromSpaceKeys || $[14] !== setFiltersInternal) {
        t6 = {
            updateQueryParameters: setFiltersInternal,
            getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
        };
        $[13] = getSpaceIdsFromSpaceKeys;
        $[14] = setFiltersInternal;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t5 || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            xcss: $e25e772a0a129a73$var$cssStyles.container
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ik71g.CustomSearchMacroConfigFilters), {
            shell: t5,
            callbacks: t6,
            filtersToHide: filtersToHide
        }));
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : ({ filters: filters, setFilters: setFilters, cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, isAdminHubAIEnabled: isAdminHubAIEnabled })=>{
    const getSpaceIdsFromSpaceKeys = (0, $3yqh5.useGetSpaceIdsFromSpaceKeys)();
    const setFiltersInternal = (0, $cozmU.useCallback)((newFilters)=>{
        setFilters({
            ...newFilters,
            product: 'confluence'
        });
    }, [
        setFilters
    ]);
    const userDetails = (0, $cozmU.useMemo)(()=>{
        return {
            id: userId,
            name: displayName
        };
    }, [
        userId,
        displayName
    ]);
    const filtersToHide = (0, $cozmU.useMemo)(()=>{
        // Only enable unified search if:
        // - User is in unified search beta and
        const isUnifiedSearchEnabled = (0, $iDrrr.fg)('unified_search_in_confluence'); // The "Type" filter is hidden because the current available options are a subset of
        // those on the full search page. This misalignment creats a poor user experience.
        //
        // The "Owner" filter is hidden when unified search is disabled because it is not supported by the
        // non-unified full search page.
        return isUnifiedSearchEnabled ? [
            'universalTypeFilter'
        ] : [
            'universalTypeFilter',
            'owner'
        ];
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $e25e772a0a129a73$var$cssStyles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e25e772a0a129a73$var$cssStyles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $672d0229c2938375$export$defe85febe8b728c).filtersTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ik71g.CustomSearchMacroConfigFilters), {
        shell: {
            cloudId: cloudId,
            orgId: orgId,
            user: userDetails,
            primaryProduct: 'confluence',
            queryParams: filters,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        },
        callbacks: {
            updateQueryParameters: setFiltersInternal,
            getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
        },
        filtersToHide: filtersToHide
    }));
};





const $18ec6a25a22da173$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "company-hub.search-extension.custom-search-config-panel.title",
        defaultMessage: "Custom search"
    },
    preamble: {
        id: "company-hub.search-extension.custom-search-config-panel.preamble",
        defaultMessage: "Add a filtered search bar"
    }
});















var $w6R6I = parcelRequire("w6R6I");





var $fodiz = parcelRequire("fodiz");




var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");






var $4yg9g = parcelRequire("4yg9g");


var $lpNn5 = parcelRequire("lpNn5");


var $cXCJB = parcelRequire("cXCJB");

var $4yUlE = parcelRequire("4yUlE");

var $4sYZY = parcelRequire("4sYZY");


var $9l2Y4 = parcelRequire("9l2Y4");

var $2TDGa = parcelRequire("2TDGa");






const $b4f02574d299870b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    stylesTitle: {
        id: "company-hub.search-extension.custom-search-config-panel.styles-title",
        defaultMessage: "Styles"
    },
    fillColorLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.styles-fill-color-label",
        defaultMessage: "Fill color"
    },
    textColorLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.styles-text-color-label",
        defaultMessage: "Text color"
    },
    cornerStyleLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.corner-style-label",
        defaultMessage: "Corners"
    },
    placeholderTextLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.placeholder-text-label",
        defaultMessage: "Placeholder text"
    },
    placeholderTooltipLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label",
        defaultMessage: "Customize the prompt your readers will see"
    },
    roundCornerStyleLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.round-corner-style-label",
        defaultMessage: "Round"
    },
    sharpCornerStyleLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label",
        defaultMessage: "Square"
    },
    defaultPlaceholderText: {
        id: "company-hub.search-extension.custom-search-config-panel.default-placeholder-text",
        defaultMessage: "Search for verified announcements, resources, and policies"
    }
});


const $20cfeb719c7722b8$var$cssStyles = {
    container: "_2Y7lL42ADO _0xmtko2ADO",
    borderOptionContainer: "_4c065UFQfX _2Y7lL41Y8M _0KLXrumhAQ _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VoWWg _39xV02oWWg",
    border: "_0bjKvDKxmn _2V7sgONvrM _3vBAKH9r67 _3hxITi6wH8",
    selected: "_3vBAKHQvmT _0KLXru7Cj1",
    informationIcon: "_0LQT5E1Y8M _46hvQmFQfX"
};
const $20cfeb719c7722b8$export$97c42e26adc98d54 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(60);
    const { styles: styles, setStyles: setStyles, isSSRProductInDarkMode: isSSRProductInDarkMode } = t0;
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== branding) {
        t1 = branding ?? {};
        $[0] = branding;
        $[1] = t1;
    } else t1 = $[1];
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = t1;
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const fillColor = styles?.backgroundColor || "";
    const textColor = styles?.textColor || "";
    const cornerStyle = styles?.borderRadius || "";
    let t2;
    if ($[2] !== textColor) {
        t2 = (color)=>(0, $4yUlE.isReadable)(color, textColor);
        $[2] = textColor;
        $[3] = t2;
    } else t2 = $[3];
    const isReadableFillColor = t2;
    let t3;
    if ($[4] !== fillColor) {
        t3 = (color_0)=>(0, $4yUlE.isReadable)(color_0, fillColor);
        $[4] = fillColor;
        $[5] = t3;
    } else t3 = $[5];
    const isReadableTextColor = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b4f02574d299870b$export$defe85febe8b728c).stylesTitle));
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b4f02574d299870b$export$defe85febe8b728c).fillColorLabel));
        $[7] = t5;
    } else t5 = $[7];
    const t6 = hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap;
    let t7;
    if ($[8] !== fillColor || $[9] !== setStyles || $[10] !== styles) {
        t7 = (newFillColor)=>setStyles({
                ...styles,
                backgroundColor: newFillColor || fillColor
            });
        $[8] = fillColor;
        $[9] = setStyles;
        $[10] = styles;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== fillColor || $[13] !== isReadableFillColor || $[14] !== t6 || $[15] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            testId: "fill-color-wrapper"
        }, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            builtInColorMap: t6,
            onChange: t7,
            value: fillColor,
            pickerTitle: (0, $b4f02574d299870b$export$defe85febe8b728c).fillColorLabel,
            showCustomPalette: true,
            isReadableColor: isReadableFillColor
        }));
        $[12] = fillColor;
        $[13] = isReadableFillColor;
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b4f02574d299870b$export$defe85febe8b728c).textColorLabel));
        $[17] = t9;
    } else t9 = $[17];
    const t10 = hideDefaultColorPalette ? emptyColorMap : textColorMap;
    let t11;
    if ($[18] !== setStyles || $[19] !== styles || $[20] !== textColor) {
        t11 = (newTextColor)=>setStyles({
                ...styles,
                textColor: newTextColor || textColor
            });
        $[18] = setStyles;
        $[19] = styles;
        $[20] = textColor;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== isReadableTextColor || $[23] !== t10 || $[24] !== t11 || $[25] !== textColor) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            testId: "text-color-wrapper"
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            builtInColorMap: t10,
            onChange: t11,
            value: textColor,
            pickerTitle: (0, $b4f02574d299870b$export$defe85febe8b728c).textColorLabel,
            showCustomPalette: true,
            showTextIcon: true,
            isReadableColor: isReadableTextColor
        }));
        $[22] = isReadableTextColor;
        $[23] = t10;
        $[24] = t11;
        $[25] = textColor;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b4f02574d299870b$export$defe85febe8b728c).cornerStyleLabel));
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = [
            {
                cornerOption: "var(--ds-radius-large, 8px)",
                IconComponent: (0, $9l2Y4.RoundCornerIcon),
                label: (0, $b4f02574d299870b$export$defe85febe8b728c).roundCornerStyleLabel,
                textIdPrefix: "round"
            },
            {
                cornerOption: "0px",
                IconComponent: (0, $2TDGa.SharpCornerIcon),
                label: (0, $b4f02574d299870b$export$defe85febe8b728c).sharpCornerStyleLabel,
                textIdPrefix: "sharp"
            }
        ];
        $[28] = t14;
    } else t14 = $[28];
    let t15;
    if ($[29] !== cornerStyle || $[30] !== formatMessage || $[31] !== setStyles || $[32] !== styles) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            testId: "corner-style-wrapper"
        }, t13, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075"
        }, t14.map((t16)=>{
            const { cornerOption: cornerOption, IconComponent: IconComponent, label: label, textIdPrefix: textIdPrefix } = t16;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label),
                hideTooltipOnMouseDown: true,
                key: cornerOption
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                xcss: (0, $w6R6I.cx)($20cfeb719c7722b8$var$cssStyles.borderOptionContainer, $20cfeb719c7722b8$var$cssStyles.border, cornerStyle === cornerOption && $20cfeb719c7722b8$var$cssStyles.selected),
                onClick: ()=>setStyles({
                        ...styles,
                        borderRadius: cornerOption
                    }),
                testId: `${textIdPrefix}${cornerStyle === cornerOption ? "--selected" : ""}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                color: cornerStyle === cornerOption ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
                label: formatMessage(label)
            })));
        })));
        $[29] = cornerStyle;
        $[30] = formatMessage;
        $[31] = setStyles;
        $[32] = styles;
        $[33] = t15;
    } else t15 = $[33];
    let t16;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b4f02574d299870b$export$defe85febe8b728c).placeholderTextLabel));
        $[34] = t16;
    } else t16 = $[34];
    let t17;
    if ($[35] !== formatMessage) {
        t17 = formatMessage((0, $b4f02574d299870b$export$defe85febe8b728c).placeholderTooltipLabel);
        $[35] = formatMessage;
        $[36] = t17;
    } else t17 = $[36];
    let t18;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $20cfeb719c7722b8$var$cssStyles.informationIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            label: ""
        }));
        $[37] = t18;
    } else t18 = $[37];
    let t19;
    if ($[38] !== t17) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, t16, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t17
        }, t18));
        $[38] = t17;
        $[39] = t19;
    } else t19 = $[39];
    let t20;
    if ($[40] !== formatMessage) {
        t20 = formatMessage((0, $b4f02574d299870b$export$defe85febe8b728c).placeholderTextLabel);
        $[40] = formatMessage;
        $[41] = t20;
    } else t20 = $[41];
    let t21;
    if ($[42] !== setStyles || $[43] !== styles) {
        t21 = (e)=>setStyles({
                ...styles,
                placeholder: e.currentTarget.value || ""
            });
        $[42] = setStyles;
        $[43] = styles;
        $[44] = t21;
    } else t21 = $[44];
    let t22;
    if ($[45] !== formatMessage || $[46] !== styles?.placeholder) {
        t22 = styles?.placeholder || formatMessage((0, $b4f02574d299870b$export$defe85febe8b728c).defaultPlaceholderText);
        $[45] = formatMessage;
        $[46] = styles?.placeholder;
        $[47] = t22;
    } else t22 = $[47];
    let t23;
    if ($[48] !== t20 || $[49] !== t21 || $[50] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            "aria-label": t20,
            onChange: t21,
            value: t22
        });
        $[48] = t20;
        $[49] = t21;
        $[50] = t22;
        $[51] = t23;
    } else t23 = $[51];
    let t24;
    if ($[52] !== t19 || $[53] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            testId: "placeholder-text-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            grow: "fill"
        }, t19, t23));
        $[52] = t19;
        $[53] = t23;
        $[54] = t24;
    } else t24 = $[54];
    let t25;
    if ($[55] !== t12 || $[56] !== t15 || $[57] !== t24 || $[58] !== t8) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.300",
            xcss: $20cfeb719c7722b8$var$cssStyles.container
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t8, t12, t15, t24));
        $[55] = t12;
        $[56] = t15;
        $[57] = t24;
        $[58] = t8;
        $[59] = t25;
    } else t25 = $[59];
    return t25;
} : ({ styles: styles, setStyles: setStyles, isSSRProductInDarkMode: isSSRProductInDarkMode })=>{
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const fillColor = styles?.backgroundColor || '';
    const textColor = styles?.textColor || '';
    const cornerStyle = styles?.borderRadius || '';
    const isReadableFillColor = (color)=>(0, $4yUlE.isReadable)(color, textColor);
    const isReadableTextColor = (color_0)=>(0, $4yUlE.isReadable)(color_0, fillColor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300",
        xcss: $20cfeb719c7722b8$var$cssStyles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b4f02574d299870b$export$defe85febe8b728c).stylesTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        testId: "fill-color-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b4f02574d299870b$export$defe85febe8b728c).fillColorLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
        onChange: (newFillColor)=>setStyles({
                ...styles,
                backgroundColor: newFillColor || fillColor
            }),
        value: fillColor,
        pickerTitle: (0, $b4f02574d299870b$export$defe85febe8b728c).fillColorLabel,
        showCustomPalette: true,
        isReadableColor: isReadableFillColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        testId: "text-color-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b4f02574d299870b$export$defe85febe8b728c).textColorLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        builtInColorMap: hideDefaultColorPalette ? emptyColorMap : textColorMap,
        onChange: (newTextColor)=>setStyles({
                ...styles,
                textColor: newTextColor || textColor
            }),
        value: textColor,
        pickerTitle: (0, $b4f02574d299870b$export$defe85febe8b728c).textColorLabel,
        showCustomPalette: true,
        showTextIcon: true,
        isReadableColor: isReadableTextColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        testId: "corner-style-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b4f02574d299870b$export$defe85febe8b728c).cornerStyleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075"
    }, [
        {
            cornerOption: "var(--ds-radius-large, 8px)",
            IconComponent: (0, $9l2Y4.RoundCornerIcon),
            label: (0, $b4f02574d299870b$export$defe85febe8b728c).roundCornerStyleLabel,
            textIdPrefix: 'round'
        },
        {
            cornerOption: '0px',
            IconComponent: (0, $2TDGa.SharpCornerIcon),
            label: (0, $b4f02574d299870b$export$defe85febe8b728c).sharpCornerStyleLabel,
            textIdPrefix: 'sharp'
        }
    ].map(({ cornerOption: cornerOption, IconComponent: IconComponent, label: label, textIdPrefix: textIdPrefix })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label),
            hideTooltipOnMouseDown: true,
            key: cornerOption
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $w6R6I.cx)($20cfeb719c7722b8$var$cssStyles.borderOptionContainer, $20cfeb719c7722b8$var$cssStyles.border, cornerStyle === cornerOption && $20cfeb719c7722b8$var$cssStyles.selected),
            onClick: ()=>setStyles({
                    ...styles,
                    borderRadius: cornerOption
                }),
            testId: `${textIdPrefix}${cornerStyle === cornerOption ? '--selected' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
            color: cornerStyle === cornerOption ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
            label: formatMessage(label)
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        testId: "placeholder-text-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b4f02574d299870b$export$defe85febe8b728c).placeholderTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $b4f02574d299870b$export$defe85febe8b728c).placeholderTooltipLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $20cfeb719c7722b8$var$cssStyles.informationIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: ""
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        "aria-label": formatMessage((0, $b4f02574d299870b$export$defe85febe8b728c).placeholderTextLabel),
        onChange: (e)=>setStyles({
                ...styles,
                placeholder: e.currentTarget.value || ''
            }),
        value: styles?.placeholder || formatMessage((0, $b4f02574d299870b$export$defe85febe8b728c).defaultPlaceholderText)
    })))));
};


const $f07a9de1f32d8d44$var$styles = {
    title: "_2Y7lL42ADO",
    preamble: "_2Y7lL42ADO",
    stickyFooter: "_4c065U1Y8M _42Yu6B7dHp _1mT5xdHE3j _0Bm75GPgdg _0KLXrulfZc",
    footerContentWrapper: "_2mHwu82ADO _4c065U2ADO _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $f07a9de1f32d8d44$var$SearchConfigPanelFeedbackCollector = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f07a9de1f32d8d44$var$styles.stickyFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f07a9de1f32d8d44$var$styles.footerContentWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
            source: (0, $KDPGa.CUSTOM_SEARCH_EXTENSION_ANALYTIC_SOURCE),
            type: (0, $hjUDQ.FeedbackType).CUSTOM_SEARCH
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f07a9de1f32d8d44$var$styles.stickyFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f07a9de1f32d8d44$var$styles.footerContentWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
        source: (0, $KDPGa.CUSTOM_SEARCH_EXTENSION_ANALYTIC_SOURCE),
        type: (0, $hjUDQ.FeedbackType).CUSTOM_SEARCH
    })));
};
const $f07a9de1f32d8d44$export$d4705ab11bd150a7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions } = t0;
    let t1;
    if ($[0] !== editorActions || $[1] !== localId) {
        t1 = {
            localId: localId,
            editorActions: editorActions,
            extensionType: (0, $KDPGa.SEARCH_EXTENSION_TYPE)
        };
        $[0] = editorActions;
        $[1] = localId;
        $[2] = t1;
    } else t1 = $[2];
    const { extensionActions: extensionActions, extensionParameters: extensionParameters } = (0, $42592e50ee014fa8$export$d78d7700cec50018)(t1);
    const { updateMainFormField: updateMainFormField } = extensionActions;
    const { cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, isAdminHubAIEnabled: isAdminHubAIEnabled, isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const filters = extensionParameters.filters;
    let t2;
    if ($[3] !== extensionParameters || $[4] !== updateMainFormField) {
        t2 = (newFilters)=>{
            updateMainFormField({
                ...extensionParameters,
                filters: {
                    ...newFilters,
                    product: "confluence"
                }
            });
        };
        $[3] = extensionParameters;
        $[4] = updateMainFormField;
        $[5] = t2;
    } else t2 = $[5];
    const setFilters = t2;
    let t3;
    if ($[6] !== extensionParameters.styles) {
        t3 = extensionParameters?.styles || {};
        $[6] = extensionParameters.styles;
        $[7] = t3;
    } else t3 = $[7];
    const extensionStyles = t3;
    let t4;
    if ($[8] !== extensionParameters || $[9] !== updateMainFormField) {
        t4 = (newStyles)=>{
            updateMainFormField({
                ...extensionParameters,
                styles: newStyles
            });
        };
        $[8] = extensionParameters;
        $[9] = updateMainFormField;
        $[10] = t4;
    } else t4 = $[10];
    const setStyles = t4;
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f07a9de1f32d8d44$var$styles.title
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $18ec6a25a22da173$export$defe85febe8b728c).title));
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f07a9de1f32d8d44$var$styles.preamble
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $18ec6a25a22da173$export$defe85febe8b728c).preamble)));
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== extensionStyles || $[14] !== isSSRProductInDarkMode || $[15] !== setStyles) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20cfeb719c7722b8$export$97c42e26adc98d54), {
            styles: extensionStyles,
            setStyles: setStyles,
            isSSRProductInDarkMode: isSSRProductInDarkMode
        });
        $[13] = extensionStyles;
        $[14] = isSSRProductInDarkMode;
        $[15] = setStyles;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = userId ?? null;
    const t9 = displayName ?? null;
    const t10 = isAdminHubAIEnabled ?? false;
    let t11;
    if ($[17] !== cloudId || $[18] !== filters || $[19] !== orgId || $[20] !== setFilters || $[21] !== t10 || $[22] !== t8 || $[23] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e25e772a0a129a73$export$41dc5c54b6ccd429), {
            filters: filters,
            setFilters: setFilters,
            cloudId: cloudId,
            userId: t8,
            displayName: t9,
            orgId: orgId,
            isAdminHubAIEnabled: t10
        });
        $[17] = cloudId;
        $[18] = filters;
        $[19] = orgId;
        $[20] = setFilters;
        $[21] = t10;
        $[22] = t8;
        $[23] = t9;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t11 || $[26] !== t7) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cGll.PremiumGateForExtensionConfigPanel), {
            feature: "premiumSearchConfig"
        }, t7, t11);
        $[25] = t11;
        $[26] = t7;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== closeConfigPanel || $[29] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
            title: t5,
            footerComponent: $f07a9de1f32d8d44$var$SearchConfigPanelFeedbackCollector,
            closeConfigPanel: closeConfigPanel
        }, t6, t12);
        $[28] = closeConfigPanel;
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    return t13;
} : ({ closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions })=>{
    const { extensionActions: extensionActions, extensionParameters: extensionParameters } = (0, $42592e50ee014fa8$export$d78d7700cec50018)({
        localId: localId,
        editorActions: editorActions,
        extensionType: (0, $KDPGa.SEARCH_EXTENSION_TYPE)
    });
    const { updateMainFormField: updateMainFormField } = extensionActions;
    const { cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, isAdminHubAIEnabled: isAdminHubAIEnabled, isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const filters = extensionParameters.filters;
    const setFilters = (0, $cozmU.useCallback)((newFilters)=>{
        updateMainFormField({
            ...extensionParameters,
            filters: {
                ...newFilters,
                product: 'confluence'
            }
        });
    }, [
        extensionParameters,
        updateMainFormField
    ]);
    const extensionStyles = extensionParameters?.styles || {};
    const setStyles = (0, $cozmU.useCallback)((newStyles)=>{
        updateMainFormField({
            ...extensionParameters,
            styles: newStyles
        });
    }, [
        extensionParameters,
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f07a9de1f32d8d44$var$styles.title
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $18ec6a25a22da173$export$defe85febe8b728c).title)),
        footerComponent: $f07a9de1f32d8d44$var$SearchConfigPanelFeedbackCollector,
        closeConfigPanel: closeConfigPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f07a9de1f32d8d44$var$styles.preamble
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $18ec6a25a22da173$export$defe85febe8b728c).preamble))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cGll.PremiumGateForExtensionConfigPanel), {
        feature: "premiumSearchConfig"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20cfeb719c7722b8$export$97c42e26adc98d54), {
        styles: extensionStyles,
        setStyles: setStyles,
        isSSRProductInDarkMode: isSSRProductInDarkMode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e25e772a0a129a73$export$41dc5c54b6ccd429), {
        filters: filters,
        setFilters: setFilters,
        cloudId: cloudId,
        userId: userId ?? null,
        displayName: displayName ?? null,
        orgId: orgId,
        isAdminHubAIEnabled: isAdminHubAIEnabled ?? false
    })));
};
module.exports["SearchConfigPanelContent"] = $f07a9de1f32d8d44$export$d4705ab11bd150a7;

});

parcelRegister("5A1wD", function(module, exports) {

var $jR2a0 = parcelRequire("jR2a0");


var $7tsC5 = parcelRequire("7tsC5");


var $7Mvs5 = parcelRequire("7Mvs5");

const $c97d3ae93aa68485$export$42679f7213a051c = ()=>{
    return `
	query SearchPageJiraFieldHydration (
		$issueKeys: [String!]!
		$cloudId: ID!
	) {
		jira {
			issuesByKey(cloudId: $cloudId, keys: $issueKeys) {
			  statusField {
				status {
				  name
				}
			  }
			  id
			}
		  }

	}
	`;
};


const $f457b45cb9aab62d$var$cache = (0, $7Mvs5.inMemoryCache)();
const $f457b45cb9aab62d$export$801183f161baaa36 = (variables)=>{
    const keyObj = {
        issueKeys: variables.issueKeys
    };
    return (0, $7tsC5.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or results are empty
const $f457b45cb9aab62d$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.jira.issuesByKey.length === 0;
};
const $f457b45cb9aab62d$export$16b4bc84d4d9549f = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const graphQuery = (0, $c97d3ae93aa68485$export$42679f7213a051c)();
    return $f457b45cb9aab62d$var$cache.inMemoryDecorator($f457b45cb9aab62d$export$801183f161baaa36(variables), ()=>(0, $jR2a0.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: 'SearchPageJiraFieldHydration'
        }), $f457b45cb9aab62d$var$expireWhen);
};
module.exports["fetchJiraFieldsQuery"] = $f457b45cb9aab62d$export$16b4bc84d4d9549f;

});

parcelRegister("lCzjG", function(module, exports) {

var $jViGU = parcelRequire("jViGU");

const $9551465545585458$export$5ef321009a5b450c = 'custom';
const $9551465545585458$export$62fed45313a13eff = 'universalTypeFilter';
const $9551465545585458$export$64f2f70bb9f8e772 = [
    'lastUpdated',
    $9551465545585458$export$62fed45313a13eff,
    'contributor',
    'owner',
    'space',
    'assignee',
    'project',
    'content',
    'onlyTitleMatch',
    'verified',
    'label'
];
const $9551465545585458$export$1fd3303b0f1dd4fb = ()=>{
    return $9551465545585458$export$64f2f70bb9f8e772.filter(()=>{
        return true;
    });
};
const $9551465545585458$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Component: 'component',
    Board: 'board',
    Card: 'card',
    Project: 'project',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item'
};
const $9551465545585458$export$e01073b80ff953d5 = Object.values($9551465545585458$export$49f6cbb853d30562);
const $9551465545585458$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page'
};
const $9551465545585458$export$a62d9b6a2b7f9510 = new Map([
    [
        $9551465545585458$export$49f6cbb853d30562.Document,
        {
            entities3P: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                $9551465545585458$export$1f2db89e0caa00c9.Document
            ]
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.Spreadsheet,
        {
            entities3P: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                $9551465545585458$export$1f2db89e0caa00c9.Spreadsheet
            ]
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.Presentation,
        {
            entities3P: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                $9551465545585458$export$1f2db89e0caa00c9.Presentation
            ]
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.Repository,
        {
            entities3P: [
                'ati:cloud:graph:repository'
            ],
            subTypes3P: []
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.PullRequest,
        {
            entities3P: [
                'ati:cloud:graph:pull-request'
            ],
            subTypes3P: []
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.Branch,
        {
            entities3P: [
                'ati:cloud:graph:branch'
            ],
            subTypes3P: []
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.Commit,
        {
            entities3P: [
                'ati:cloud:graph:commit'
            ],
            subTypes3P: []
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.WebPage,
        {
            entities3P: [
                'ati:cloud:graph:document'
            ],
            subTypes3P: [
                $9551465545585458$export$1f2db89e0caa00c9.WebPage
            ]
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.Conversation,
        {
            entities3P: (0, $jViGU.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
            subTypes3P: []
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.Message,
        {
            entities3P: (0, $jViGU.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
            subTypes3P: []
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.Video,
        {
            entities3P: (0, $jViGU.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
            subTypes3P: []
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.Design,
        {
            entities3P: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
            subTypes3P: [
                $9551465545585458$export$1f2db89e0caa00c9.File
            ]
        }
    ],
    [
        $9551465545585458$export$49f6cbb853d30562.WorkItem,
        {
            entities3P: (0, $jViGU.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: []
        }
    ]
]);
module.exports["CUSTOM_OPTION_VALUE"] = $9551465545585458$export$5ef321009a5b450c;
module.exports["universalTypeFilterId"] = $9551465545585458$export$62fed45313a13eff;
module.exports["getFilterIdOrdering"] = $9551465545585458$export$1fd3303b0f1dd4fb;
module.exports["TypeFilterValueKey"] = $9551465545585458$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $9551465545585458$export$e01073b80ff953d5;
module.exports["TypeFilterTWGNounMapping"] = $9551465545585458$export$a62d9b6a2b7f9510;

});

parcelRegister("htTgH", function(module, exports) {

var $irdYS = parcelRequire("irdYS");


var $7Mllk = parcelRequire("7Mllk");


var $klGKb = parcelRequire("klGKb");


var $abZJs = parcelRequire("abZJs");


var $1xLLa = parcelRequire("1xLLa");


var $dJiO9 = parcelRequire("dJiO9");


var $1Kmth = parcelRequire("1Kmth");


var $53xPo = parcelRequire("53xPo");


var $gcDyO = parcelRequire("gcDyO");


var $hwu7Y = parcelRequire("hwu7Y");


var $9t53P = parcelRequire("9t53P");


var $gM79P = parcelRequire("gM79P");


var $5qT5Z = parcelRequire("5qT5Z");


var $1zrs2 = parcelRequire("1zrs2");


var $jpmtj = parcelRequire("jpmtj");


var $bbj14 = parcelRequire("bbj14");


var $2wdaB = parcelRequire("2wdaB");


var $f8VKw = parcelRequire("f8VKw");

// New 3P? Add it here
const $a22b15fd9d1be316$var$ProductKeys3P = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    Gmail: 'gmail',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Notion: 'notion',
    Miro: 'miro'
};
const $a22b15fd9d1be316$export$f7937c5f282f2571 = new Map([
    [
        $a22b15fd9d1be316$var$ProductKeys3P.AtlassianWebCrawler,
        (0, $klGKb.atlassianWebCrawlerConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Figma,
        (0, $1xLLa.figmaConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Github,
        (0, $dJiO9.githubConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.GoogleDrive,
        (0, $53xPo.googleDriveConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Sharepoint,
        (0, $jpmtj.sharepointConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Loom,
        (0, $hwu7Y.loomConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.OneDrive,
        (0, $5qT5Z.oneDriveConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Dropbox,
        (0, $abZJs.dropboxConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Slack,
        (0, $bbj14.slackConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Teams,
        (0, $2wdaB.teamsConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.GoogleCalendar,
        (0, $gcDyO.googleCalendarConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Gmail,
        (0, $1Kmth.gmailConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.OutlookCalendar,
        (0, $1zrs2.outlookCalendarConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Asana,
        (0, $7Mllk.asanaConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Zendesk,
        (0, $f8VKw.zendeskConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Airtable,
        (0, $irdYS.airtableConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Notion,
        (0, $gM79P.notionConfig)
    ],
    [
        $a22b15fd9d1be316$var$ProductKeys3P.Miro,
        (0, $9t53P.miroConfig)
    ]
]);
const $a22b15fd9d1be316$var$ProductsOrder3P = [
    // // Loom is actually a 1P so goes to the top
    $a22b15fd9d1be316$var$ProductKeys3P.Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    $a22b15fd9d1be316$var$ProductKeys3P.GoogleDrive,
    $a22b15fd9d1be316$var$ProductKeys3P.Sharepoint,
    $a22b15fd9d1be316$var$ProductKeys3P.OneDrive,
    $a22b15fd9d1be316$var$ProductKeys3P.Dropbox,
    $a22b15fd9d1be316$var$ProductKeys3P.Slack,
    $a22b15fd9d1be316$var$ProductKeys3P.Teams,
    $a22b15fd9d1be316$var$ProductKeys3P.Github,
    $a22b15fd9d1be316$var$ProductKeys3P.Figma,
    $a22b15fd9d1be316$var$ProductKeys3P.GoogleCalendar,
    $a22b15fd9d1be316$var$ProductKeys3P.Gmail,
    $a22b15fd9d1be316$var$ProductKeys3P.OutlookCalendar,
    $a22b15fd9d1be316$var$ProductKeys3P.Airtable,
    $a22b15fd9d1be316$var$ProductKeys3P.Asana,
    $a22b15fd9d1be316$var$ProductKeys3P.Zendesk,
    $a22b15fd9d1be316$var$ProductKeys3P.Miro,
    // New 3P? Add it here
    // Always last
    $a22b15fd9d1be316$var$ProductKeys3P.AtlassianWebCrawler
];
const $a22b15fd9d1be316$export$1242fc8c436d51cf = $a22b15fd9d1be316$var$ProductKeys3P;
const $a22b15fd9d1be316$export$9d22c431a2a02e31 = $a22b15fd9d1be316$var$ProductsOrder3P;
module.exports["ThirdPartyConfigs"] = $a22b15fd9d1be316$export$f7937c5f282f2571;
module.exports["DO_NOT_IMPORT_ProductKeys3P"] = $a22b15fd9d1be316$export$1242fc8c436d51cf;
module.exports["DO_NOT_IMPORT_ProductsOrder3P"] = $a22b15fd9d1be316$export$9d22c431a2a02e31;

});

parcelRegister("kEOJV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $7f2354ce5685add0$export$88b64eee273831fd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.7168 6.25334L5.76892 9.95584C5.27133 10.1618 5.27649 10.8685 5.7772 11.067L14.7625 14.6302C15.552 14.9433 16.4312 14.9433 17.2206 14.6302L26.206 11.067C26.7066 10.8685 26.7119 10.1618 26.2141 9.95584L17.2664 6.25334C16.45 5.91555 15.533 5.91555 14.7168 6.25334Z",
            fill: "#FFBF00"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.7887 16.576V25.4773C16.7887 25.9007 17.2156 26.1906 17.6092 26.0346L27.6215 22.1482C27.8501 22.0576 28 21.8368 28 21.591V12.6897C28 12.2663 27.5731 11.9764 27.1795 12.1324L17.1672 16.0187C16.9387 16.1093 16.7887 16.3302 16.7887 16.576Z",
            fill: "#26B5F8"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.4508 17.0352L11.4793 18.47L11.1776 18.6158L4.90511 21.6213C4.50749 21.8131 4 21.5233 4 21.0816V12.727C4 12.5672 4.08194 12.4293 4.19182 12.3253C4.23767 12.2794 4.28963 12.2415 4.34362 12.2115C4.49352 12.1216 4.70732 12.0976 4.8891 12.1695L14.4009 15.9382C14.8843 16.13 14.9223 16.8075 14.4508 17.0352Z",
            fill: "#ED3049"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.4507 17.0352L11.4793 18.47L4.19177 12.3253C4.23762 12.2794 4.28958 12.2415 4.34357 12.2115C4.49347 12.1216 4.70727 12.0976 4.88905 12.1695L14.4008 15.9382C14.8843 16.13 14.9223 16.8075 14.4507 17.0352Z",
            fill: "black",
            fillOpacity: "0.25"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.7168 6.25334L5.76892 9.95584C5.27133 10.1618 5.27649 10.8685 5.7772 11.067L14.7625 14.6302C15.552 14.9433 16.4312 14.9433 17.2206 14.6302L26.206 11.067C26.7066 10.8685 26.7119 10.1618 26.2141 9.95584L17.2664 6.25334C16.45 5.91555 15.533 5.91555 14.7168 6.25334Z",
        fill: "#FFBF00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.7887 16.576V25.4773C16.7887 25.9007 17.2156 26.1906 17.6092 26.0346L27.6215 22.1482C27.8501 22.0576 28 21.8368 28 21.591V12.6897C28 12.2663 27.5731 11.9764 27.1795 12.1324L17.1672 16.0187C16.9387 16.1093 16.7887 16.3302 16.7887 16.576Z",
        fill: "#26B5F8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.4508 17.0352L11.4793 18.47L11.1776 18.6158L4.90511 21.6213C4.50749 21.8131 4 21.5233 4 21.0816V12.727C4 12.5672 4.08194 12.4293 4.19182 12.3253C4.23767 12.2794 4.28963 12.2415 4.34362 12.2115C4.49352 12.1216 4.70732 12.0976 4.8891 12.1695L14.4009 15.9382C14.8843 16.13 14.9223 16.8075 14.4508 17.0352Z",
        fill: "#ED3049"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.4507 17.0352L11.4793 18.47L4.19177 12.3253C4.23762 12.2794 4.28958 12.2415 4.34357 12.2115C4.49347 12.1216 4.70727 12.0976 4.88905 12.1695L14.4008 15.9382C14.8843 16.13 14.9223 16.8075 14.4507 17.0352Z",
        fill: "black",
        fillOpacity: "0.25"
    }));
module.exports["AirtableIcon"] = $7f2354ce5685add0$export$88b64eee273831fd;

});

parcelRegister("2JxTe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $28bb8a947e2780b1$export$f6d383c62156550f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.2515 6.14778L6.03189 8.30757C5.74163 8.4277 5.74464 8.83998 6.03672 8.95576L11.2781 11.0343C11.7387 11.2169 12.2515 11.2169 12.712 11.0343L17.9535 8.95576C18.2455 8.83998 18.2486 8.4277 17.9583 8.30757L12.7388 6.14778C12.2625 5.95074 11.7276 5.95074 11.2515 6.14778Z",
            fill: "#FFBF00"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12.4601 12.1693V17.3617C12.4601 17.6087 12.7091 17.7778 12.9387 17.6868L18.7792 15.4198C18.9126 15.3669 19 15.2381 19 15.0947V9.90228C19 9.65531 18.751 9.4862 18.5214 9.5772L12.6809 11.8442C12.5476 11.8971 12.4601 12.0259 12.4601 12.1693Z",
            fill: "#26B5F8"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.0963 12.4372L9.36295 13.2741L9.18695 13.3592L5.52798 15.1124C5.29604 15.2243 5 15.0552 5 14.7976V9.92405C5 9.83083 5.0478 9.75035 5.11189 9.68974C5.13864 9.66291 5.16895 9.64083 5.20045 9.62334C5.28789 9.57088 5.4126 9.55687 5.51864 9.59881L11.0672 11.7972C11.3492 11.9091 11.3714 12.3043 11.0963 12.4372Z",
            fill: "#ED3049"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.0963 12.4372L9.36293 13.2741L5.11188 9.68974C5.13862 9.66291 5.16893 9.64083 5.20043 9.62334C5.28787 9.57088 5.41258 9.55687 5.51862 9.59881L11.0671 11.7972C11.3492 11.9091 11.3713 12.3043 11.0963 12.4372Z",
            fill: "black",
            fillOpacity: "0.25"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.2515 6.14778L6.03189 8.30757C5.74163 8.4277 5.74464 8.83998 6.03672 8.95576L11.2781 11.0343C11.7387 11.2169 12.2515 11.2169 12.712 11.0343L17.9535 8.95576C18.2455 8.83998 18.2486 8.4277 17.9583 8.30757L12.7388 6.14778C12.2625 5.95074 11.7276 5.95074 11.2515 6.14778Z",
        fill: "#FFBF00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.4601 12.1693V17.3617C12.4601 17.6087 12.7091 17.7778 12.9387 17.6868L18.7792 15.4198C18.9126 15.3669 19 15.2381 19 15.0947V9.90228C19 9.65531 18.751 9.4862 18.5214 9.5772L12.6809 11.8442C12.5476 11.8971 12.4601 12.0259 12.4601 12.1693Z",
        fill: "#26B5F8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.0963 12.4372L9.36295 13.2741L9.18695 13.3592L5.52798 15.1124C5.29604 15.2243 5 15.0552 5 14.7976V9.92405C5 9.83083 5.0478 9.75035 5.11189 9.68974C5.13864 9.66291 5.16895 9.64083 5.20045 9.62334C5.28789 9.57088 5.4126 9.55687 5.51864 9.59881L11.0672 11.7972C11.3492 11.9091 11.3714 12.3043 11.0963 12.4372Z",
        fill: "#ED3049"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.0963 12.4372L9.36293 13.2741L5.11188 9.68974C5.13862 9.66291 5.16893 9.64083 5.20043 9.62334C5.28787 9.57088 5.41258 9.55687 5.51862 9.59881L11.0671 11.7972C11.3492 11.9091 11.3713 12.3043 11.0963 12.4372Z",
        fill: "black",
        fillOpacity: "0.25"
    }));
module.exports["AirtableFilterIcon"] = $28bb8a947e2780b1$export$f6d383c62156550f;

});

parcelRegister("g022q", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $a288fd8865ee7b21$export$671541d0c7918cd9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.7805 16.7441C19.8977 16.7441 17.5609 19.081 17.5609 21.9638C17.5609 24.8465 19.8977 27.1835 22.7805 27.1835C25.6632 27.1835 28 24.8465 28 21.9638C28 19.081 25.6632 16.7441 22.7805 16.7441ZM9.21957 16.7445C6.33691 16.7445 4 19.081 4 21.9638C4 24.8465 6.33691 27.1835 9.21957 27.1835C12.1024 27.1835 14.4394 24.8465 14.4394 21.9638C14.4394 19.081 12.1024 16.7445 9.21957 16.7445ZM21.2195 10.2195C21.2195 13.1024 18.8827 15.4395 16.0001 15.4395C13.1172 15.4395 10.7804 13.1024 10.7804 10.2195C10.7804 7.33713 13.1172 5 16.0001 5C18.8827 5 21.2195 7.33713 21.2195 10.2195Z",
            fill: "#F06A6A"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.7805 16.7441C19.8977 16.7441 17.5609 19.081 17.5609 21.9638C17.5609 24.8465 19.8977 27.1835 22.7805 27.1835C25.6632 27.1835 28 24.8465 28 21.9638C28 19.081 25.6632 16.7441 22.7805 16.7441ZM9.21957 16.7445C6.33691 16.7445 4 19.081 4 21.9638C4 24.8465 6.33691 27.1835 9.21957 27.1835C12.1024 27.1835 14.4394 24.8465 14.4394 21.9638C14.4394 19.081 12.1024 16.7445 9.21957 16.7445ZM21.2195 10.2195C21.2195 13.1024 18.8827 15.4395 16.0001 15.4395C13.1172 15.4395 10.7804 13.1024 10.7804 10.2195C10.7804 7.33713 13.1172 5 16.0001 5C18.8827 5 21.2195 7.33713 21.2195 10.2195Z",
        fill: "#F06A6A"
    }));
var $a288fd8865ee7b21$export$2e2bcd8739ae039 = $a288fd8865ee7b21$export$671541d0c7918cd9;
module.exports["AsanaIcon"] = $a288fd8865ee7b21$export$671541d0c7918cd9;
module.exports["default"] = $a288fd8865ee7b21$export$2e2bcd8739ae039;

});

parcelRegister("lFtQw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $a9aed7b2a3096c97$export$5e2362bb78414664 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24px",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 43 40",
            version: "1.1",
            height: "24px"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
            fill: "#007EE5"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24px",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43 40",
        version: "1.1",
        height: "24px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
        fill: "#007EE5"
    }));
module.exports["DropboxIcon"] = $a9aed7b2a3096c97$export$5e2362bb78414664;

});

parcelRegister("7hnNi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $acb3a4e1a53b565b$export$54e0f4982aa79afe = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_3561_46561)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M9.2277 20.7767C10.6997 20.7767 11.8944 19.582 11.8944 18.11V15.4434H9.2277C7.7557 15.4434 6.56104 16.638 6.56104 18.11C6.56104 19.582 7.7557 20.7767 9.2277 20.7767Z",
            fill: "#0ACF83"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M6.56104 12.778C6.56104 11.306 7.7557 10.1113 9.2277 10.1113H11.8944V15.4447H9.2277C7.7557 15.4447 6.56104 14.25 6.56104 12.778Z",
            fill: "#A259FF"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M6.56104 7.44401C6.56104 5.97201 7.7557 4.77734 9.2277 4.77734H11.8944V10.1107H9.2277C7.7557 10.1107 6.56104 8.91601 6.56104 7.44401Z",
            fill: "#F24E1E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.8945 4.77734H14.5612C16.0332 4.77734 17.2279 5.97201 17.2279 7.44401C17.2279 8.91601 16.0332 10.1107 14.5612 10.1107H11.8945V4.77734Z",
            fill: "#FF7262"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M17.2279 12.778C17.2279 14.25 16.0332 15.4447 14.5612 15.4447C13.0892 15.4447 11.8945 14.25 11.8945 12.778C11.8945 11.306 13.0892 10.1113 14.5612 10.1113C16.0332 10.1113 17.2279 11.306 17.2279 12.778Z",
            fill: "#1ABCFE"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "25",
            viewBox: "3 3 18 19",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_3561_46561"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "16",
            height: "16",
            fill: "white",
            transform: "translate(4 4.77734)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "25",
        viewBox: "3 3 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_3561_46561)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.2277 20.7767C10.6997 20.7767 11.8944 19.582 11.8944 18.11V15.4434H9.2277C7.7557 15.4434 6.56104 16.638 6.56104 18.11C6.56104 19.582 7.7557 20.7767 9.2277 20.7767Z",
        fill: "#0ACF83"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M6.56104 12.778C6.56104 11.306 7.7557 10.1113 9.2277 10.1113H11.8944V15.4447H9.2277C7.7557 15.4447 6.56104 14.25 6.56104 12.778Z",
        fill: "#A259FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M6.56104 7.44401C6.56104 5.97201 7.7557 4.77734 9.2277 4.77734H11.8944V10.1107H9.2277C7.7557 10.1107 6.56104 8.91601 6.56104 7.44401Z",
        fill: "#F24E1E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.8945 4.77734H14.5612C16.0332 4.77734 17.2279 5.97201 17.2279 7.44401C17.2279 8.91601 16.0332 10.1107 14.5612 10.1107H11.8945V4.77734Z",
        fill: "#FF7262"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M17.2279 12.778C17.2279 14.25 16.0332 15.4447 14.5612 15.4447C13.0892 15.4447 11.8945 14.25 11.8945 12.778C11.8945 11.306 13.0892 10.1113 14.5612 10.1113C16.0332 10.1113 17.2279 11.306 17.2279 12.778Z",
        fill: "#1ABCFE"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_3561_46561"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(4 4.77734)"
    }))));
module.exports["FigmaIcon"] = $acb3a4e1a53b565b$export$54e0f4982aa79afe;

});

parcelRegister("bZjBf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e2d00d3ee49972a8$export$b31792ff95c3d83f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_6321_165951)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.8418 28C14.0498 28 15.8418 26.208 15.8418 24V20H11.8418C9.6338 20 7.8418 21.792 7.8418 24C7.8418 26.208 9.6338 28 11.8418 28Z",
            fill: "#0ACF83"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M7.8418 16C7.8418 13.792 9.6338 12 11.8418 12H15.8418V20H11.8418C9.6338 20 7.8418 18.208 7.8418 16Z",
            fill: "#A259FF"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M7.8418 8C7.8418 5.792 9.6338 4 11.8418 4H15.8418V12H11.8418C9.6338 12 7.8418 10.208 7.8418 8Z",
            fill: "#F24E1E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.8418 4H19.8418C22.0498 4 23.8418 5.792 23.8418 8C23.8418 10.208 22.0498 12 19.8418 12H15.8418V4Z",
            fill: "#FF7262"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M23.8418 16C23.8418 18.208 22.0498 20 19.8418 20C17.6338 20 15.8418 18.208 15.8418 16C15.8418 13.792 17.6338 12 19.8418 12C22.0498 12 23.8418 13.792 23.8418 16Z",
            fill: "#1ABCFE"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_6321_165951"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(4 4)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_6321_165951)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.8418 28C14.0498 28 15.8418 26.208 15.8418 24V20H11.8418C9.6338 20 7.8418 21.792 7.8418 24C7.8418 26.208 9.6338 28 11.8418 28Z",
        fill: "#0ACF83"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.8418 16C7.8418 13.792 9.6338 12 11.8418 12H15.8418V20H11.8418C9.6338 20 7.8418 18.208 7.8418 16Z",
        fill: "#A259FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7.8418 8C7.8418 5.792 9.6338 4 11.8418 4H15.8418V12H11.8418C9.6338 12 7.8418 10.208 7.8418 8Z",
        fill: "#F24E1E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.8418 4H19.8418C22.0498 4 23.8418 5.792 23.8418 8C23.8418 10.208 22.0498 12 19.8418 12H15.8418V4Z",
        fill: "#FF7262"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M23.8418 16C23.8418 18.208 22.0498 20 19.8418 20C17.6338 20 15.8418 18.208 15.8418 16C15.8418 13.792 17.6338 12 19.8418 12C22.0498 12 23.8418 13.792 23.8418 16Z",
        fill: "#1ABCFE"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_6321_165951"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(4 4)"
    }))));
module.exports["FigmaSearchResultIcon"] = $e2d00d3ee49972a8$export$b31792ff95c3d83f;

});

parcelRegister("32Uuv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $3981108bb122c147$export$e8e65f186ccd8749 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 2.14801C4.685 2.14801 2 4.83301 2 8.14801C2 10.803 3.7175 13.0455 6.1025 13.8405C6.4025 13.893 6.515 13.713 6.515 13.5555C6.515 13.413 6.5075 12.9405 6.5075 12.438C5 12.7155 4.61 12.0705 4.49 11.733C4.4225 11.5605 4.13 11.028 3.875 10.8855C3.665 10.773 3.365 10.4955 3.8675 10.488C4.34 10.4805 4.6775 10.923 4.79 11.103C5.33 12.0105 6.1925 11.7555 6.5375 11.598C6.59 11.208 6.7475 10.9455 6.92 10.7955C5.585 10.6455 4.19 10.128 4.19 7.83301C4.19 7.18051 4.4225 6.64051 4.805 6.22051C4.745 6.07051 4.535 5.45551 4.865 4.63051C4.865 4.63051 5.3675 4.47301 6.515 5.24551C6.995 5.11051 7.505 5.04301 8.015 5.04301C8.525 5.04301 9.035 5.11051 9.515 5.24551C10.6625 4.46551 11.165 4.63051 11.165 4.63051C11.495 5.45551 11.285 6.07051 11.225 6.22051C11.6075 6.64051 11.84 7.17301 11.84 7.83301C11.84 10.1355 10.4375 10.6455 9.1025 10.7955C9.32 10.983 9.5075 11.343 9.5075 11.9055C9.5075 12.708 9.5 13.353 9.5 13.5555C9.5 13.713 9.6125 13.9005 9.9125 13.8405C12.2825 13.0455 14 10.7955 14 8.14801C14 4.83301 11.315 2.14801 8 2.14801Z",
            fill: "var(--ds-icon, #292A2E)"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 2.14801C4.685 2.14801 2 4.83301 2 8.14801C2 10.803 3.7175 13.0455 6.1025 13.8405C6.4025 13.893 6.515 13.713 6.515 13.5555C6.515 13.413 6.5075 12.9405 6.5075 12.438C5 12.7155 4.61 12.0705 4.49 11.733C4.4225 11.5605 4.13 11.028 3.875 10.8855C3.665 10.773 3.365 10.4955 3.8675 10.488C4.34 10.4805 4.6775 10.923 4.79 11.103C5.33 12.0105 6.1925 11.7555 6.5375 11.598C6.59 11.208 6.7475 10.9455 6.92 10.7955C5.585 10.6455 4.19 10.128 4.19 7.83301C4.19 7.18051 4.4225 6.64051 4.805 6.22051C4.745 6.07051 4.535 5.45551 4.865 4.63051C4.865 4.63051 5.3675 4.47301 6.515 5.24551C6.995 5.11051 7.505 5.04301 8.015 5.04301C8.525 5.04301 9.035 5.11051 9.515 5.24551C10.6625 4.46551 11.165 4.63051 11.165 4.63051C11.495 5.45551 11.285 6.07051 11.225 6.22051C11.6075 6.64051 11.84 7.17301 11.84 7.83301C11.84 10.1355 10.4375 10.6455 9.1025 10.7955C9.32 10.983 9.5075 11.343 9.5075 11.9055C9.5075 12.708 9.5 13.353 9.5 13.5555C9.5 13.713 9.6125 13.9005 9.9125 13.8405C12.2825 13.0455 14 10.7955 14 8.14801C14 4.83301 11.315 2.14801 8 2.14801Z",
        fill: "var(--ds-icon, #292A2E)"
    }));
module.exports["GithubIcon"] = $3981108bb122c147$export$e8e65f186ccd8749;

});

parcelRegister("98L7N", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $13ba5083aa9fe05f$export$fa0f141eb732d2d7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.0001 4C9.3735 4 4 9.50847 4 16.3038C4 21.74 7.43839 26.3519 12.2064 27.9789C12.8061 28.0927 13.0263 27.7119 13.0263 27.387C13.0263 27.0936 13.0152 26.1244 13.01 25.0963C9.67157 25.8405 8.96712 23.6446 8.96712 23.6446C8.42125 22.2224 7.63472 21.8443 7.63472 21.8443C6.54595 21.0806 7.71679 21.0963 7.71679 21.0963C8.92181 21.1831 9.55632 22.3642 9.55632 22.3642C10.6266 24.2452 12.3636 23.7014 13.0484 23.387C13.1561 22.5918 13.4671 22.049 13.8102 21.7418C11.1449 21.4307 8.34295 20.3757 8.34295 15.6612C8.34295 14.3179 8.81172 13.2203 9.57937 12.3587C9.45477 12.0488 9.04402 10.7974 9.69561 9.10261C9.69561 9.10261 10.7033 8.77193 12.9965 10.3638C13.9537 10.0912 14.9803 9.95447 16.0001 9.94979C17.0199 9.95447 18.0473 10.0912 19.0063 10.3638C21.2967 8.77193 22.303 9.10261 22.303 9.10261C22.9562 10.7974 22.5452 12.0488 22.4206 12.3587C23.1901 13.2203 23.6557 14.3179 23.6557 15.6612C23.6557 20.3869 20.8484 21.4274 18.1762 21.732C18.6067 22.1138 18.9902 22.8626 18.9902 24.0105C18.9902 25.6568 18.9763 26.9817 18.9763 27.387C18.9763 27.7144 19.1923 28.098 19.8006 27.9772C24.566 26.3485 28 21.7381 28 16.3038C28 9.50847 22.6273 4 16.0001 4Z",
            fill: "var(--ds-icon, #292A2E)"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.0001 4C9.3735 4 4 9.50847 4 16.3038C4 21.74 7.43839 26.3519 12.2064 27.9789C12.8061 28.0927 13.0263 27.7119 13.0263 27.387C13.0263 27.0936 13.0152 26.1244 13.01 25.0963C9.67157 25.8405 8.96712 23.6446 8.96712 23.6446C8.42125 22.2224 7.63472 21.8443 7.63472 21.8443C6.54595 21.0806 7.71679 21.0963 7.71679 21.0963C8.92181 21.1831 9.55632 22.3642 9.55632 22.3642C10.6266 24.2452 12.3636 23.7014 13.0484 23.387C13.1561 22.5918 13.4671 22.049 13.8102 21.7418C11.1449 21.4307 8.34295 20.3757 8.34295 15.6612C8.34295 14.3179 8.81172 13.2203 9.57937 12.3587C9.45477 12.0488 9.04402 10.7974 9.69561 9.10261C9.69561 9.10261 10.7033 8.77193 12.9965 10.3638C13.9537 10.0912 14.9803 9.95447 16.0001 9.94979C17.0199 9.95447 18.0473 10.0912 19.0063 10.3638C21.2967 8.77193 22.303 9.10261 22.303 9.10261C22.9562 10.7974 22.5452 12.0488 22.4206 12.3587C23.1901 13.2203 23.6557 14.3179 23.6557 15.6612C23.6557 20.3869 20.8484 21.4274 18.1762 21.732C18.6067 22.1138 18.9902 22.8626 18.9902 24.0105C18.9902 25.6568 18.9763 26.9817 18.9763 27.387C18.9763 27.7144 19.1923 28.098 19.8006 27.9772C24.566 26.3485 28 21.7381 28 16.3038C28 9.50847 22.6273 4 16.0001 4Z",
        fill: "var(--ds-icon, #292A2E)"
    }));
module.exports["GithubSearchResultIcon"] = $13ba5083aa9fe05f$export$fa0f141eb732d2d7;

});

parcelRegister("6eZhJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $190477e423ed9574$export$856bad9032bbc5ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "37 37 115 80"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#4285f4",
            d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#34a853",
            d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#fbbc04",
            d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#ea4335",
            d: "M72 74V48l24 18 24-18v26L96 92"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#c5221f",
            d: "M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "37 37 115 80"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#4285f4",
        d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#34a853",
        d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fbbc04",
        d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#ea4335",
        d: "M72 74V48l24 18 24-18v26L96 92"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#c5221f",
        d: "M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
    }));
module.exports["GmailIcon"] = $190477e423ed9574$export$856bad9032bbc5ed;

});

parcelRegister("jPcqU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bcnPg = parcelRequire("bcnPg");

const $9fb963dee1d1b9af$export$5d128e0a6ffc0558 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $bcnPg.messages).googleCalendarLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#4285f4",
            d: "M100 340h74V174h166v-74H137q-37 0-37 35"
        });
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#1967d2",
            d: "M338 100v76h74v-41q0-35-35-35"
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#fbbc04",
            d: "M338 174h74v164h-74"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#188038",
            d: "M100 338v39q0 35 35 35h41v-74"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#34a853",
            d: "M174 338h164v74H174"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "#ea4335",
            d: "M338 412v-74h74"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "none",
            stroke: "#4285f4",
            strokeLinejoin: "bevel",
            strokeWidth: 15,
            d: "M204 229a25 22 1 1 1 25 27h-9 9a25 22 1 1 1-25 27m66-52 27-19h4v-7 103"
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else {
        t1 = $[2];
        t2 = $[3];
        t3 = $[4];
        t4 = $[5];
        t5 = $[6];
        t6 = $[7];
        t7 = $[8];
    }
    let t8;
    if ($[9] !== t0) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            "aria-label": t0,
            viewBox: "50 50 410 410 "
        }, t1, t2, t3, t4, t5, t6, t7);
        $[9] = t0;
        $[10] = t8;
    } else t8 = $[10];
    return t8;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "aria-label": formatMessage((0, $bcnPg.messages).googleCalendarLabel),
        viewBox: "50 50 410 410 "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#4285f4",
        d: "M100 340h74V174h166v-74H137q-37 0-37 35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#1967d2",
        d: "M338 100v76h74v-41q0-35-35-35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fbbc04",
        d: "M338 174h74v164h-74"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#188038",
        d: "M100 338v39q0 35 35 35h41v-74"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#34a853",
        d: "M174 338h164v74H174"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#ea4335",
        d: "M338 412v-74h74"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "none",
        stroke: "#4285f4",
        strokeLinejoin: "bevel",
        strokeWidth: 15,
        d: "M204 229a25 22 1 1 1 25 27h-9 9a25 22 1 1 1-25 27m66-52 27-19h4v-7 103"
    }));
};
var $9fb963dee1d1b9af$export$2e2bcd8739ae039 = $9fb963dee1d1b9af$export$5d128e0a6ffc0558;
module.exports["GoogleCalendarIcon"] = $9fb963dee1d1b9af$export$5d128e0a6ffc0558;
module.exports["default"] = $9fb963dee1d1b9af$export$2e2bcd8739ae039;

});

parcelRegister("34Ycr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $6c92f31409f7e023$export$e16bd899bb4eebf9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "2",
            y: "2",
            width: "20",
            height: "20",
            rx: "0.75",
            fill: "white",
            fillOpacity: "0.01"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_271_181643)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_271_181643)"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_271_181643)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M3.51203 18.5459L4.39404 20.1089C4.57732 20.438 4.84078 20.6965 5.15006 20.8845L8.30011 15.2905H2C2 15.6548 2.09164 16.0192 2.27491 16.3482L3.51203 18.5459Z",
            fill: "#0066DA"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12 8.70925L8.84994 3.11523C8.54066 3.30327 8.27721 3.56182 8.09393 3.89088L2.27491 14.2328C2.09501 14.5547 2.00024 14.9193 2 15.2904H8.30011L12 8.70925Z",
            fill: "#00AC47"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M18.85 20.8845C19.1593 20.6965 19.4227 20.438 19.606 20.1089L19.9725 19.4625L21.7251 16.3482C21.9084 16.0192 22 15.6548 22 15.2905H15.6995L17.0401 17.9935L18.85 20.8845Z",
            fill: "#EA4335"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12.0002 8.70932L15.1502 3.1153C14.8409 2.92727 14.4858 2.83325 14.1193 2.83325H9.88103C9.51447 2.83325 9.15938 2.93902 8.8501 3.1153L12.0002 8.70932Z",
            fill: "#00832D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.6997 15.2905H8.29996L5.1499 20.8845C5.45918 21.0726 5.81428 21.1666 6.18083 21.1666H17.8189C18.1854 21.1666 18.5405 21.0608 18.8498 20.8845L15.6997 15.2905Z",
            fill: "#2684FC"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M18.8156 9.06182L15.9061 3.89088C15.7228 3.56182 15.4593 3.30327 15.1501 3.11523L12 8.70925L15.6999 15.2904H21.9885C21.9885 14.9261 21.8969 14.5618 21.7136 14.2328L18.8156 9.06182Z",
            fill: "#FFBA00"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_271_181643"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_271_181643"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            x: "2",
            y: "2",
            width: "20",
            height: "20",
            rx: "0.75",
            fill: "white"
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t2, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_271_181643"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "18.3333",
            fill: "white",
            transform: "translate(2 2.83325)"
        }))));
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_271_181643)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_271_181643)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "2",
        y: "2",
        width: "20",
        height: "20",
        rx: "0.75",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_271_181643)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3.51203 18.5459L4.39404 20.1089C4.57732 20.438 4.84078 20.6965 5.15006 20.8845L8.30011 15.2905H2C2 15.6548 2.09164 16.0192 2.27491 16.3482L3.51203 18.5459Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12 8.70925L8.84994 3.11523C8.54066 3.30327 8.27721 3.56182 8.09393 3.89088L2.27491 14.2328C2.09501 14.5547 2.00024 14.9193 2 15.2904H8.30011L12 8.70925Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M18.85 20.8845C19.1593 20.6965 19.4227 20.438 19.606 20.1089L19.9725 19.4625L21.7251 16.3482C21.9084 16.0192 22 15.6548 22 15.2905H15.6995L17.0401 17.9935L18.85 20.8845Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.0002 8.70932L15.1502 3.1153C14.8409 2.92727 14.4858 2.83325 14.1193 2.83325H9.88103C9.51447 2.83325 9.15938 2.93902 8.8501 3.1153L12.0002 8.70932Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.6997 15.2905H8.29996L5.1499 20.8845C5.45918 21.0726 5.81428 21.1666 6.18083 21.1666H17.8189C18.1854 21.1666 18.5405 21.0608 18.8498 20.8845L15.6997 15.2905Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M18.8156 9.06182L15.9061 3.89088C15.7228 3.56182 15.4593 3.30327 15.1501 3.11523L12 8.70925L15.6999 15.2904H21.9885C21.9885 14.9261 21.8969 14.5618 21.7136 14.2328L18.8156 9.06182Z",
        fill: "#FFBA00"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_271_181643"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_271_181643"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "2",
        y: "2",
        width: "20",
        height: "20",
        rx: "0.75",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_271_181643"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "18.3333",
        fill: "white",
        transform: "translate(2 2.83325)"
    }))));
module.exports["GoogleDriveIcon"] = $6c92f31409f7e023$export$e16bd899bb4eebf9;

});

parcelRegister("7IRSQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $d38e60f18a381e01$export$99050685a064f8e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_6321_165888)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M4.96564 24.5692L6.11226 26.6153C6.35052 27.0461 6.69301 27.3845 7.09508 27.6307L11.1902 20.3076H3C3 20.7845 3.11913 21.2615 3.35739 21.6922L4.96564 24.5692Z",
            fill: "#0066DA"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16 11.6922L11.9049 4.36914C11.5029 4.61529 11.1604 4.95376 10.9221 5.38453L3.35739 18.923C3.12351 19.3445 3.00031 19.8218 3 20.3076H11.1901L16 11.6922Z",
            fill: "#00AC47"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M24.9052 27.6307C25.3073 27.3845 25.6498 27.0461 25.8881 26.6153L26.3646 25.7692L28.6429 21.6922C28.8812 21.2615 29.0003 20.7845 29.0003 20.3076H20.8096L22.5524 23.8461L24.9052 27.6307Z",
            fill: "#EA4335"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.0003 11.6923L20.0954 4.36923C19.6934 4.12308 19.2317 4 18.7552 4H13.2455C12.769 4 12.3073 4.13846 11.9053 4.36923L16.0003 11.6923Z",
            fill: "#00832D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M20.8095 20.3076H11.1898L7.09473 27.6307C7.49679 27.8769 7.95842 27.9999 8.43493 27.9999H23.5644C24.0409 27.9999 24.5025 27.8615 24.9046 27.6307L20.8095 20.3076Z",
            fill: "#2684FC"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M24.8603 11.7846L21.0779 5.01538C20.8396 4.58462 20.4971 4.24615 20.0951 4L16 11.3231L20.8099 19.9385H28.9851C28.9851 19.4615 28.866 18.9846 28.6277 18.5538L24.8603 11.7846Z",
            fill: "#FFBA00"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_6321_165888"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "26",
            height: "24",
            fill: "white",
            transform: "translate(3 4)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_6321_165888)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M4.96564 24.5692L6.11226 26.6153C6.35052 27.0461 6.69301 27.3845 7.09508 27.6307L11.1902 20.3076H3C3 20.7845 3.11913 21.2615 3.35739 21.6922L4.96564 24.5692Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16 11.6922L11.9049 4.36914C11.5029 4.61529 11.1604 4.95376 10.9221 5.38453L3.35739 18.923C3.12351 19.3445 3.00031 19.8218 3 20.3076H11.1901L16 11.6922Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M24.9052 27.6307C25.3073 27.3845 25.6498 27.0461 25.8881 26.6153L26.3646 25.7692L28.6429 21.6922C28.8812 21.2615 29.0003 20.7845 29.0003 20.3076H20.8096L22.5524 23.8461L24.9052 27.6307Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.0003 11.6923L20.0954 4.36923C19.6934 4.12308 19.2317 4 18.7552 4H13.2455C12.769 4 12.3073 4.13846 11.9053 4.36923L16.0003 11.6923Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M20.8095 20.3076H11.1898L7.09473 27.6307C7.49679 27.8769 7.95842 27.9999 8.43493 27.9999H23.5644C24.0409 27.9999 24.5025 27.8615 24.9046 27.6307L20.8095 20.3076Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M24.8603 11.7846L21.0779 5.01538C20.8396 4.58462 20.4971 4.24615 20.0951 4L16 11.3231L20.8099 19.9385H28.9851C28.9851 19.4615 28.866 18.9846 28.6277 18.5538L24.8603 11.7846Z",
        fill: "#FFBA00"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_6321_165888"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "26",
        height: "24",
        fill: "white",
        transform: "translate(3 4)"
    }))));
module.exports["GoogleDriveSearchResultIcon"] = $d38e60f18a381e01$export$99050685a064f8e;

});

parcelRegister("1irrG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $975fee259a77fd5e$export$8d789f76fde3e05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_271_181644)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
            fill: "#5753F3"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "2 2 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_271_181644"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "20",
            fill: "white",
            transform: "translate(4 4)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "2 2 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_271_181644)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
        fill: "#5753F3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_271_181644"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(4 4)"
    }))));
module.exports["LoomIcon"] = $975fee259a77fd5e$export$8d789f76fde3e05;

});

parcelRegister("7TNej", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $bd80d854350b7b19$export$38410c1d5582587e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M4 10C4 6.68629 6.68629 4 10 4H22C25.3137 4 28 6.68629 28 10V22C28 25.3137 25.3137 28 22 28H10C6.68629 28 4 25.3137 4 22V10Z",
            fill: "#FFDD33"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.9558 8.57495H17.7771L19.5927 11.7649L15.5985 8.57495H13.4198L15.417 12.4738L11.2412 8.57495H9.0625L11.2412 13.5378L9.0625 23.4625H11.2412L15.417 12.8288L13.4198 23.4625H15.5985L19.5927 12.1198L17.7771 23.4625H19.9558L23.95 11.0559L19.9558 8.57495Z",
            fill: "black"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M4 10C4 6.68629 6.68629 4 10 4H22C25.3137 4 28 6.68629 28 10V22C28 25.3137 25.3137 28 22 28H10C6.68629 28 4 25.3137 4 22V10Z",
        fill: "#FFDD33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.9558 8.57495H17.7771L19.5927 11.7649L15.5985 8.57495H13.4198L15.417 12.4738L11.2412 8.57495H9.0625L11.2412 13.5378L9.0625 23.4625H11.2412L15.417 12.8288L13.4198 23.4625H15.5985L19.5927 12.1198L17.7771 23.4625H19.9558L23.95 11.0559L19.9558 8.57495Z",
        fill: "black"
    }));
module.exports["MiroIcon"] = $bd80d854350b7b19$export$38410c1d5582587e;

});

parcelRegister("aR8pO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $671674a9f0b28cde$export$2de50228fb7919e4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M5 8.5C5 6.567 6.567 5 8.5 5H15.5C17.433 5 19 6.567 19 8.5V15.5C19 17.433 17.433 19 15.5 19H8.5C6.567 19 5 17.433 5 15.5V8.5Z",
            fill: "#FFDD33"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.3075 7.66882H13.0367L14.0957 9.5296L11.7658 7.66882H10.4949L11.6599 9.94317L9.22401 7.66882H7.95312L9.22401 10.5638L7.95312 16.3532H9.22401L11.6599 10.1502L10.4949 16.3532H11.7658L14.0957 9.73667L13.0367 16.3532H14.3075L16.6375 9.11604L14.3075 7.66882Z",
            fill: "black"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5 8.5C5 6.567 6.567 5 8.5 5H15.5C17.433 5 19 6.567 19 8.5V15.5C19 17.433 17.433 19 15.5 19H8.5C6.567 19 5 17.433 5 15.5V8.5Z",
        fill: "#FFDD33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.3075 7.66882H13.0367L14.0957 9.5296L11.7658 7.66882H10.4949L11.6599 9.94317L9.22401 7.66882H7.95312L9.22401 10.5638L7.95312 16.3532H9.22401L11.6599 10.1502L10.4949 16.3532H11.7658L14.0957 9.73667L13.0367 16.3532H14.3075L16.6375 9.11604L14.3075 7.66882Z",
        fill: "black"
    }));
module.exports["MiroFilterIcon"] = $671674a9f0b28cde$export$2de50228fb7919e4;

});

parcelRegister("6CAIO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $13600af329100947$export$694ff710b1e20299 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M6.44405 5.03539L19.7237 4.05453C21.355 3.91461 21.774 4.00893 22.7997 4.75459L27.0388 7.74085C27.7379 8.25444 27.9707 8.39436 27.9707 8.95355V25.3316C27.9707 26.358 27.598 26.9652 26.2931 27.0578L10.872 27.9919C9.89279 28.0382 9.42647 27.8983 8.9136 27.2448L5.79198 23.1855C5.23208 22.4384 5 21.8792 5 21.2255V6.66735C5 5.82809 5.37271 5.12826 6.44405 5.03539Z",
            fill: "white"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.7237 4.05477L6.44405 5.03563C5.37271 5.12826 5 5.82833 5 6.66735V21.2255C5 21.879 5.23208 22.4382 5.79198 23.1855L8.9136 27.2446C9.42647 27.8981 9.89279 28.0382 10.872 27.9917L26.2934 27.0581C27.5972 26.9652 27.9709 26.358 27.9709 25.3318V8.95379C27.9709 8.4234 27.7614 8.27052 27.1446 7.81789L22.7997 4.75459C21.7742 4.00893 21.355 3.91461 19.7237 4.05453V4.05477ZM11.2207 8.68572C9.96142 8.77043 9.67583 8.78963 8.96064 8.20813L7.14244 6.76191C6.95764 6.57472 7.05052 6.3412 7.51611 6.29464L20.2822 5.36178C21.3542 5.26818 21.9125 5.64185 22.3317 5.96825L24.5212 7.55462C24.6148 7.6019 24.8476 7.88101 24.5675 7.88101L11.3839 8.67468L11.2207 8.68572ZM9.75263 25.1919V11.2882C9.75263 10.681 9.93911 10.401 10.4973 10.3539L25.6396 9.46738C26.1532 9.42106 26.3853 9.74746 26.3853 10.3537V24.1647C26.3853 24.7719 26.2917 25.2855 25.4534 25.3318L10.9632 26.1718C10.1249 26.2181 9.75287 25.939 9.75287 25.1919H9.75263ZM24.0564 12.0337C24.1492 12.4536 24.0564 12.8736 23.6364 12.9216L22.938 13.0601V23.3254C22.3315 23.6518 21.7733 23.8383 21.3067 23.8383C20.5611 23.8383 20.3748 23.6048 19.8164 22.9054L15.2492 15.72V22.6719L16.694 22.999C16.694 22.999 16.694 23.839 15.5284 23.839L12.3148 24.0255C12.2212 23.8383 12.3148 23.372 12.6405 23.2791L13.4798 23.0463V13.8545L12.3151 13.7602C12.2215 13.3402 12.4543 12.7337 13.107 12.6867L16.5551 12.4546L21.307 19.7329V13.2939L20.0957 13.1547C20.0021 12.6404 20.3748 12.2667 20.8404 12.2211L24.0564 12.0337Z",
            fill: "black"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M6.44405 5.03539L19.7237 4.05453C21.355 3.91461 21.774 4.00893 22.7997 4.75459L27.0388 7.74085C27.7379 8.25444 27.9707 8.39436 27.9707 8.95355V25.3316C27.9707 26.358 27.598 26.9652 26.2931 27.0578L10.872 27.9919C9.89279 28.0382 9.42647 27.8983 8.9136 27.2448L5.79198 23.1855C5.23208 22.4384 5 21.8792 5 21.2255V6.66735C5 5.82809 5.37271 5.12826 6.44405 5.03539Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7237 4.05477L6.44405 5.03563C5.37271 5.12826 5 5.82833 5 6.66735V21.2255C5 21.879 5.23208 22.4382 5.79198 23.1855L8.9136 27.2446C9.42647 27.8981 9.89279 28.0382 10.872 27.9917L26.2934 27.0581C27.5972 26.9652 27.9709 26.358 27.9709 25.3318V8.95379C27.9709 8.4234 27.7614 8.27052 27.1446 7.81789L22.7997 4.75459C21.7742 4.00893 21.355 3.91461 19.7237 4.05453V4.05477ZM11.2207 8.68572C9.96142 8.77043 9.67583 8.78963 8.96064 8.20813L7.14244 6.76191C6.95764 6.57472 7.05052 6.3412 7.51611 6.29464L20.2822 5.36178C21.3542 5.26818 21.9125 5.64185 22.3317 5.96825L24.5212 7.55462C24.6148 7.6019 24.8476 7.88101 24.5675 7.88101L11.3839 8.67468L11.2207 8.68572ZM9.75263 25.1919V11.2882C9.75263 10.681 9.93911 10.401 10.4973 10.3539L25.6396 9.46738C26.1532 9.42106 26.3853 9.74746 26.3853 10.3537V24.1647C26.3853 24.7719 26.2917 25.2855 25.4534 25.3318L10.9632 26.1718C10.1249 26.2181 9.75287 25.939 9.75287 25.1919H9.75263ZM24.0564 12.0337C24.1492 12.4536 24.0564 12.8736 23.6364 12.9216L22.938 13.0601V23.3254C22.3315 23.6518 21.7733 23.8383 21.3067 23.8383C20.5611 23.8383 20.3748 23.6048 19.8164 22.9054L15.2492 15.72V22.6719L16.694 22.999C16.694 22.999 16.694 23.839 15.5284 23.839L12.3148 24.0255C12.2212 23.8383 12.3148 23.372 12.6405 23.2791L13.4798 23.0463V13.8545L12.3151 13.7602C12.2215 13.3402 12.4543 12.7337 13.107 12.6867L16.5551 12.4546L21.307 19.7329V13.2939L20.0957 13.1547C20.0021 12.6404 20.3748 12.2667 20.8404 12.2211L24.0564 12.0337Z",
        fill: "black"
    }));
module.exports["NotionIcon"] = $13600af329100947$export$694ff710b1e20299;

});

parcelRegister("2ocDV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $4d0e7c8f3f5fb3fc$export$ef1f2d131b16090c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M5.8801 5.63103L13.9736 5.03323C14.9678 4.94796 15.2232 5.00544 15.8483 5.4599L18.4319 7.27992C18.858 7.59294 18.9999 7.67822 18.9999 8.01902V18.0009C18.9999 18.6265 18.7727 18.9965 17.9774 19.053L8.57877 19.6223C7.98199 19.6505 7.69779 19.5652 7.38521 19.1669L5.48269 16.6929C5.14144 16.2376 5 15.8968 5 15.4983V6.62566C5 6.11416 5.22716 5.68764 5.8801 5.63103Z",
            fill: "white"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.9736 5.03338L5.8801 5.63118C5.22716 5.68764 5 6.11431 5 6.62566V15.4983C5 15.8966 5.14144 16.2374 5.48269 16.6929L7.38521 19.1668C7.69779 19.5651 7.98199 19.6505 8.57877 19.6221L17.9776 19.0531C18.7723 18.9965 19 18.6265 19 18.001V8.01917C19 7.69591 18.8723 7.60274 18.4964 7.32688L15.8483 5.4599C15.2233 5.00544 14.9678 4.94796 13.9736 5.03323V5.03338ZM8.7913 7.85579C8.02382 7.90742 7.84976 7.91912 7.41388 7.56471L6.30574 6.68329C6.19312 6.5692 6.24972 6.42688 6.53349 6.39851L14.314 5.82996C14.9674 5.77291 15.3076 6.00066 15.5631 6.19958L16.8975 7.16642C16.9546 7.19524 17.0965 7.36535 16.9258 7.36535L8.89076 7.84906L8.7913 7.85579ZM7.89657 17.9157V9.44193C7.89657 9.07187 8.01022 8.90117 8.35044 8.8725L17.5791 8.33218C17.8922 8.30395 18.0336 8.50288 18.0336 8.87236V17.2897C18.0336 17.6598 17.9766 17.9728 17.4656 18.001L8.63435 18.513C8.12343 18.5412 7.89671 18.3711 7.89671 17.9157H7.89657ZM16.6142 9.89624C16.6708 10.1522 16.6142 10.4082 16.3582 10.4374L15.9326 10.5218V16.7782C15.563 16.9771 15.2227 17.0908 14.9384 17.0908C14.4839 17.0908 14.3704 16.9485 14.0301 16.5222L11.2466 12.1429V16.3799L12.1271 16.5793C12.1271 16.5793 12.1271 17.0912 11.4167 17.0912L9.45814 17.2049C9.40109 17.0908 9.45814 16.8066 9.65662 16.75L10.1681 16.6081V11.006L9.45828 10.9485C9.40124 10.6925 9.54312 10.3229 9.94097 10.2942L12.0424 10.1528L14.9385 14.5887V10.6643L14.2003 10.5795C14.1433 10.266 14.3704 10.0383 14.6542 10.0105L16.6142 9.89624Z",
            fill: "black"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5.8801 5.63103L13.9736 5.03323C14.9678 4.94796 15.2232 5.00544 15.8483 5.4599L18.4319 7.27992C18.858 7.59294 18.9999 7.67822 18.9999 8.01902V18.0009C18.9999 18.6265 18.7727 18.9965 17.9774 19.053L8.57877 19.6223C7.98199 19.6505 7.69779 19.5652 7.38521 19.1669L5.48269 16.6929C5.14144 16.2376 5 15.8968 5 15.4983V6.62566C5 6.11416 5.22716 5.68764 5.8801 5.63103Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.9736 5.03338L5.8801 5.63118C5.22716 5.68764 5 6.11431 5 6.62566V15.4983C5 15.8966 5.14144 16.2374 5.48269 16.6929L7.38521 19.1668C7.69779 19.5651 7.98199 19.6505 8.57877 19.6221L17.9776 19.0531C18.7723 18.9965 19 18.6265 19 18.001V8.01917C19 7.69591 18.8723 7.60274 18.4964 7.32688L15.8483 5.4599C15.2233 5.00544 14.9678 4.94796 13.9736 5.03323V5.03338ZM8.7913 7.85579C8.02382 7.90742 7.84976 7.91912 7.41388 7.56471L6.30574 6.68329C6.19312 6.5692 6.24972 6.42688 6.53349 6.39851L14.314 5.82996C14.9674 5.77291 15.3076 6.00066 15.5631 6.19958L16.8975 7.16642C16.9546 7.19524 17.0965 7.36535 16.9258 7.36535L8.89076 7.84906L8.7913 7.85579ZM7.89657 17.9157V9.44193C7.89657 9.07187 8.01022 8.90117 8.35044 8.8725L17.5791 8.33218C17.8922 8.30395 18.0336 8.50288 18.0336 8.87236V17.2897C18.0336 17.6598 17.9766 17.9728 17.4656 18.001L8.63435 18.513C8.12343 18.5412 7.89671 18.3711 7.89671 17.9157H7.89657ZM16.6142 9.89624C16.6708 10.1522 16.6142 10.4082 16.3582 10.4374L15.9326 10.5218V16.7782C15.563 16.9771 15.2227 17.0908 14.9384 17.0908C14.4839 17.0908 14.3704 16.9485 14.0301 16.5222L11.2466 12.1429V16.3799L12.1271 16.5793C12.1271 16.5793 12.1271 17.0912 11.4167 17.0912L9.45814 17.2049C9.40109 17.0908 9.45814 16.8066 9.65662 16.75L10.1681 16.6081V11.006L9.45828 10.9485C9.40124 10.6925 9.54312 10.3229 9.94097 10.2942L12.0424 10.1528L14.9385 14.5887V10.6643L14.2003 10.5795C14.1433 10.266 14.3704 10.0383 14.6542 10.0105L16.6142 9.89624Z",
        fill: "black"
    }));
module.exports["NotionFilterIcon"] = $4d0e7c8f3f5fb3fc$export$ef1f2d131b16090c;

});

parcelRegister("5b9Mo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $3a498f079f856617$export$44884401d09e251c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "-1 0 26 26"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            id: "OneDrive"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            fill: "none",
            width: "24",
            height: "24"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.5,15l4.95-4.74A7.5,7.5,0,0,0,5.92,8C6,8,14.5,15,14.5,15Z",
            fill: "#0364BA"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M9.15,8.89h0A6,6,0,0,0,6,8H5.92a6,6,0,0,0-4.84,9.43L8.5,16.5l5.69-4.59Z",
            fill: "#0078D4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M19.45,10.26h-.32a4.84,4.84,0,0,0-1.94.4h0l-3,1.26L17.5,16l5.92,1.44a4.88,4.88,0,0,0-4-7.18Z",
            fill: "#1490DF"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M1.08,17.43A6,6,0,0,0,6,20H19.13a4.89,4.89,0,0,0,4.29-2.56l-9.23-5.53Z",
            fill: "#28A8EA"
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-1 0 26 26"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        id: "OneDrive"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        fill: "none",
        width: "24",
        height: "24"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5,15l4.95-4.74A7.5,7.5,0,0,0,5.92,8C6,8,14.5,15,14.5,15Z",
        fill: "#0364BA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.15,8.89h0A6,6,0,0,0,6,8H5.92a6,6,0,0,0-4.84,9.43L8.5,16.5l5.69-4.59Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.45,10.26h-.32a4.84,4.84,0,0,0-1.94.4h0l-3,1.26L17.5,16l5.92,1.44a4.88,4.88,0,0,0-4-7.18Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M1.08,17.43A6,6,0,0,0,6,20H19.13a4.89,4.89,0,0,0,4.29-2.56l-9.23-5.53Z",
        fill: "#28A8EA"
    })));
module.exports["OneDriveIcon"] = $3a498f079f856617$export$44884401d09e251c;

});

parcelRegister("4R0et", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $4f9c9d7b8c03be98$export$62b570fbaf793397 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
            fill: "#0364B8"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M27.7358 17.053C27.8457 16.7078 27.9334 16.3558 27.9983 15.9993C27.9984 15.821 27.903 15.6557 27.7486 15.5666L27.7389 15.5613L27.7358 15.5599L19.6078 10.9297C19.5728 10.907 19.5364 10.8861 19.4991 10.8674C19.1844 10.7114 18.8141 10.7114 18.4994 10.8674C18.4621 10.8861 18.4258 10.9069 18.3906 10.9297L10.2627 15.5599L10.2597 15.5613L10.2498 15.5666C10.0955 15.6557 10.0001 15.821 10.0002 15.9993C10.0652 16.3558 10.1529 16.7078 10.2627 17.053L18.8811 23.3563L27.7358 17.053Z",
            fill: "#0A2767"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.9988 7.74982H16.7491L15.2334 9.99982L16.7491 12.2496L21.9988 16.7493H26.4985V12.2496L21.9988 7.74982Z",
            fill: "#28A8EA"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.4996 7.74982H16.7493V12.2495H11.4996V7.74982Z",
            fill: "#0078D4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.9989 7.74982H26.4986V12.2495H21.9989V7.74982Z",
            fill: "#50D9FF"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.999 16.7492L16.7493 12.2496H11.4996V16.7492L16.7493 21.249L24.8728 22.5749L21.999 16.7492Z",
            fill: "#0364B8"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.7493 12.2496H21.9989V16.7492H16.7493V12.2496Z",
            fill: "#0078D4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.4996 16.7493H16.7493V21.2489H11.4996V16.7493Z",
            fill: "#064A8C"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.9989 16.7493H26.4986V21.2489H21.9989V16.7493Z",
            fill: "#0078D4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M19.1423 22.9124L10.2974 16.4628L10.6678 15.8111C10.6678 15.8111 18.7261 20.4008 18.849 20.4698C18.9509 20.5107 19.0654 20.5075 19.1648 20.4608C19.2795 20.3963 27.3632 15.7886 27.3632 15.7886L27.7352 16.4403L19.1423 22.9124Z",
            fill: "#0A2767",
            fillOpacity: "0.498039"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M27.7488 16.4321L27.7391 16.4381L27.7368 16.4396L19.6089 21.0699C19.2809 21.2813 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2843C27.8269 26.0732 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1777 27.9047 16.3431 27.7503 16.4321H27.7488Z",
            fill: "#1490DF"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M27.9985 25.3738V24.8204L20.5117 20.5546L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.8262 26.0723 27.9993 25.7333 27.9993 25.3731L27.9985 25.3738Z",
            fill: "black",
            fillOpacity: "0.047059"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M27.9611 25.661L19.7543 20.9858L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.7443 26.1312 27.8954 25.911 27.9618 25.6603L27.9611 25.661Z",
            fill: "black",
            fillOpacity: "0.098039"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M10.2621 16.4419V16.4344H10.2547L10.2321 16.4195C10.0866 16.3299 9.99823 16.1703 9.99965 15.9995V25.3754C9.99965 25.9916 10.5068 26.4988 11.1232 26.4988H26.8737C26.9673 26.4978 27.0606 26.4853 27.1511 26.4613C27.1982 26.4531 27.2437 26.4379 27.2862 26.4163C27.3021 26.4147 27.3174 26.4096 27.3311 26.4013C27.3925 26.3762 27.4505 26.3435 27.5036 26.3037L27.5336 26.2813L10.2621 16.4419Z",
            fill: "#28A8EA"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M17.4992 22.4993V10.2503C17.4976 9.70247 17.0473 9.25225 16.4995 9.25061H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V23.5019V23.4989H16.4995C17.0473 23.4973 17.4976 23.047 17.4992 22.4993Z",
            fill: "black",
            fillOpacity: "0.098039"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.7493 23.2491V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V24.2519V24.2489H15.7496C16.2973 24.2472 16.7477 23.797 16.7493 23.2491ZM16.7493 21.7493V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H15.7496C16.2973 22.7473 16.7477 22.2971 16.7493 21.7493ZM15.9993 21.7493V11.0002C15.9977 10.4525 15.5475 10.0022 14.9997 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H14.9997C15.5475 22.7473 15.9977 22.2971 15.9993 21.7493Z",
            fill: "black",
            fillOpacity: "0.2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
            fill: "#0078D4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M6.90014 14.1005C7.16577 13.5344 7.59472 13.0606 8.13155 12.7401C8.72643 12.3995 9.40377 12.2299 10.089 12.2497C10.7236 12.2357 11.35 12.3966 11.8993 12.7146C12.4163 13.0225 12.8327 13.4741 13.0977 14.0143C13.3864 14.6095 13.5304 15.2645 13.5177 15.9259C13.5318 16.6172 13.3835 17.3023 13.085 17.9261C12.8142 18.4854 12.3852 18.9533 11.8513 19.2715C11.2806 19.5995 10.6308 19.7648 9.97268 19.7492C9.32435 19.7646 8.6841 19.6019 8.12185 19.2789C7.60083 18.9705 7.17941 18.5185 6.90843 17.977C6.61792 17.3903 6.47228 16.7425 6.48395 16.0879C6.47108 15.4025 6.61366 14.7231 6.9009 14.1005H6.90014ZM8.2125 17.2938C8.35421 17.6517 8.59454 17.9623 8.90555 18.1892C9.22203 18.4109 9.60145 18.5252 9.98763 18.5155C10.3991 18.5318 10.8048 18.4138 11.1433 18.1795C11.4505 17.9526 11.6845 17.6404 11.8161 17.2818C11.964 16.8821 12.0369 16.4585 12.0313 16.0324C12.0359 15.6026 11.9674 15.1749 11.8289 14.768C11.7067 14.4017 11.4811 14.0783 11.1793 13.8374C10.8498 13.5913 10.4452 13.4662 10.0342 13.4834C9.63963 13.4731 9.2517 13.5881 8.9265 13.8118C8.6097 14.0395 8.36403 14.3527 8.2185 14.7148C7.89668 15.5438 7.89483 16.4636 8.21326 17.2938H8.2125Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M27.7358 17.053C27.8457 16.7078 27.9334 16.3558 27.9983 15.9993C27.9984 15.821 27.903 15.6557 27.7486 15.5666L27.7389 15.5613L27.7358 15.5599L19.6078 10.9297C19.5728 10.907 19.5364 10.8861 19.4991 10.8674C19.1844 10.7114 18.8141 10.7114 18.4994 10.8674C18.4621 10.8861 18.4258 10.9069 18.3906 10.9297L10.2627 15.5599L10.2597 15.5613L10.2498 15.5666C10.0955 15.6557 10.0001 15.821 10.0002 15.9993C10.0652 16.3558 10.1529 16.7078 10.2627 17.053L18.8811 23.3563L27.7358 17.053Z",
        fill: "#0A2767"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.9988 7.74982H16.7491L15.2334 9.99982L16.7491 12.2496L21.9988 16.7493H26.4985V12.2496L21.9988 7.74982Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4996 7.74982H16.7493V12.2495H11.4996V7.74982Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.9989 7.74982H26.4986V12.2495H21.9989V7.74982Z",
        fill: "#50D9FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.999 16.7492L16.7493 12.2496H11.4996V16.7492L16.7493 21.249L24.8728 22.5749L21.999 16.7492Z",
        fill: "#0364B8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.7493 12.2496H21.9989V16.7492H16.7493V12.2496Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4996 16.7493H16.7493V21.2489H11.4996V16.7493Z",
        fill: "#064A8C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.9989 16.7493H26.4986V21.2489H21.9989V16.7493Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.1423 22.9124L10.2974 16.4628L10.6678 15.8111C10.6678 15.8111 18.7261 20.4008 18.849 20.4698C18.9509 20.5107 19.0654 20.5075 19.1648 20.4608C19.2795 20.3963 27.3632 15.7886 27.3632 15.7886L27.7352 16.4403L19.1423 22.9124Z",
        fill: "#0A2767",
        fillOpacity: "0.498039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M27.7488 16.4321L27.7391 16.4381L27.7368 16.4396L19.6089 21.0699C19.2809 21.2813 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2843C27.8269 26.0732 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1777 27.9047 16.3431 27.7503 16.4321H27.7488Z",
        fill: "#1490DF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M27.9985 25.3738V24.8204L20.5117 20.5546L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.8262 26.0723 27.9993 25.7333 27.9993 25.3731L27.9985 25.3738Z",
        fill: "black",
        fillOpacity: "0.047059"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M27.9611 25.661L19.7543 20.9858L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.7443 26.1312 27.8954 25.911 27.9618 25.6603L27.9611 25.661Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M10.2621 16.4419V16.4344H10.2547L10.2321 16.4195C10.0866 16.3299 9.99823 16.1703 9.99965 15.9995V25.3754C9.99965 25.9916 10.5068 26.4988 11.1232 26.4988H26.8737C26.9673 26.4978 27.0606 26.4853 27.1511 26.4613C27.1982 26.4531 27.2437 26.4379 27.2862 26.4163C27.3021 26.4147 27.3174 26.4096 27.3311 26.4013C27.3925 26.3762 27.4505 26.3435 27.5036 26.3037L27.5336 26.2813L10.2621 16.4419Z",
        fill: "#28A8EA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M17.4992 22.4993V10.2503C17.4976 9.70247 17.0473 9.25225 16.4995 9.25061H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V23.5019V23.4989H16.4995C17.0473 23.4973 17.4976 23.047 17.4992 22.4993Z",
        fill: "black",
        fillOpacity: "0.098039"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.7493 23.2491V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V24.2519V24.2489H15.7496C16.2973 24.2472 16.7477 23.797 16.7493 23.2491ZM16.7493 21.7493V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H15.7496C16.2973 22.7473 16.7477 22.2971 16.7493 21.7493ZM15.9993 21.7493V11.0002C15.9977 10.4525 15.5475 10.0022 14.9997 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H14.9997C15.5475 22.7473 15.9977 22.2971 15.9993 21.7493Z",
        fill: "black",
        fillOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
        fill: "#0078D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M6.90014 14.1005C7.16577 13.5344 7.59472 13.0606 8.13155 12.7401C8.72643 12.3995 9.40377 12.2299 10.089 12.2497C10.7236 12.2357 11.35 12.3966 11.8993 12.7146C12.4163 13.0225 12.8327 13.4741 13.0977 14.0143C13.3864 14.6095 13.5304 15.2645 13.5177 15.9259C13.5318 16.6172 13.3835 17.3023 13.085 17.9261C12.8142 18.4854 12.3852 18.9533 11.8513 19.2715C11.2806 19.5995 10.6308 19.7648 9.97268 19.7492C9.32435 19.7646 8.6841 19.6019 8.12185 19.2789C7.60083 18.9705 7.17941 18.5185 6.90843 17.977C6.61792 17.3903 6.47228 16.7425 6.48395 16.0879C6.47108 15.4025 6.61366 14.7231 6.9009 14.1005H6.90014ZM8.2125 17.2938C8.35421 17.6517 8.59454 17.9623 8.90555 18.1892C9.22203 18.4109 9.60145 18.5252 9.98763 18.5155C10.3991 18.5318 10.8048 18.4138 11.1433 18.1795C11.4505 17.9526 11.6845 17.6404 11.8161 17.2818C11.964 16.8821 12.0369 16.4585 12.0313 16.0324C12.0359 15.6026 11.9674 15.1749 11.8289 14.768C11.7067 14.4017 11.4811 14.0783 11.1793 13.8374C10.8498 13.5913 10.4452 13.4662 10.0342 13.4834C9.63963 13.4731 9.2517 13.5881 8.9265 13.8118C8.6097 14.0395 8.36403 14.3527 8.2185 14.7148C7.89668 15.5438 7.89483 16.4636 8.21326 17.2938H8.2125Z",
        fill: "white"
    }));
module.exports["OutlookCalendarIcon"] = $4f9c9d7b8c03be98$export$62b570fbaf793397;

});

parcelRegister("8kImw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $ae306504cce4d4e7$export$53d8bcde0f28cd56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_271_181641)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_271_181641)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
            fill: "#036C70"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
            fill: "#1A9BA1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
            fill: "#37C6D0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
            fill: "#04868B"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
            fill: "white"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_271_181641"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "20",
            fill: "white",
            transform: "translate(2 2)"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_271_181641"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "20",
            fill: "white",
            transform: "translate(2 2)"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_271_181641)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_271_181641)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
        fill: "#04868B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_271_181641"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_271_181641"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    }))));
module.exports["SharePointIcon"] = $ae306504cce4d4e7$export$53d8bcde0f28cd56;

});

parcelRegister("12a6Y", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $6e9a81b4cff891e3$export$65b9e0ddb04a51a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_6321_165901)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.2797 17.7143C19.9787 17.7143 22.9774 14.6442 22.9774 10.8571C22.9774 7.07005 19.9787 4 16.2797 4C12.5807 4 9.58203 7.07005 9.58203 10.8571C9.58203 14.6442 12.5807 17.7143 16.2797 17.7143Z",
            fill: "#036C70"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.8602 23.4286C25.251 23.4286 27.9998 20.6144 27.9998 17.1429C27.9998 13.6714 25.251 10.8572 21.8602 10.8572C18.4695 10.8572 15.7207 13.6714 15.7207 17.1429C15.7207 20.6144 18.4695 23.4286 21.8602 23.4286Z",
            fill: "#1A9BA1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M17.1163 27.9999C19.7364 27.9999 21.8604 25.8253 21.8604 23.1428C21.8604 20.4603 19.7364 18.2856 17.1163 18.2856C14.4961 18.2856 12.3721 20.4603 12.3721 23.1428C12.3721 25.8253 14.4961 27.9999 17.1163 27.9999Z",
            fill: "#37C6D0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M17.395 10.1885V22.3828C17.3922 22.8065 17.1414 23.1872 16.7587 23.3485C16.6369 23.4013 16.5059 23.4285 16.3736 23.4285H12.3773C12.3718 23.3314 12.3718 23.24 12.3718 23.1428C12.3699 23.0474 12.3736 22.952 12.3829 22.8571C12.4851 21.0305 13.5842 19.4189 15.2239 18.6914V17.6285C11.5747 17.0365 9.08523 13.5279 9.66351 9.79181C9.66752 9.76593 9.67166 9.74007 9.67596 9.71425C9.70374 9.52153 9.74289 9.3307 9.79317 9.14282H16.3736C16.9368 9.14502 17.3929 9.61192 17.395 10.1885Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M15.8156 9.71436H9.67607C9.05586 13.4437 11.506 16.9816 15.1486 17.6166C15.2589 17.6358 15.3696 17.6522 15.4807 17.6658C13.7505 18.5058 12.4896 20.8915 12.3825 22.8572C12.3732 22.9521 12.3695 23.0475 12.3713 23.1429C12.3713 23.2401 12.3713 23.3315 12.3769 23.4286C12.387 23.6207 12.4112 23.8117 12.4495 24.0001H15.815C16.2289 23.9972 16.6007 23.7405 16.7583 23.3486C16.8098 23.2239 16.8364 23.0898 16.8364 22.9543V10.7601C16.8343 10.1837 16.3786 9.71687 15.8156 9.71436Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M15.8156 9.71436H9.67602C9.05594 13.444 11.5064 16.9821 15.1494 17.617C15.2239 17.63 15.2986 17.6417 15.3735 17.6521C13.6991 18.5526 12.4879 20.9327 12.383 22.8572H15.8156C16.3779 22.8529 16.8327 22.3872 16.837 21.8115V10.7601C16.8348 10.1835 16.3788 9.71655 15.8156 9.71436Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M15.2572 9.71436H9.67584C9.09032 13.2352 11.2452 16.6258 14.6265 17.5041C13.3462 19.0017 12.5609 20.8753 12.3828 22.8572H15.2572C15.8204 22.855 16.2765 22.3881 16.2786 21.8115V10.7601C16.2783 10.1827 15.8212 9.71468 15.2572 9.71436Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M5.02307 9.71436H15.256C15.821 9.71436 16.2791 10.1833 16.2791 10.7618V21.2384C16.2791 21.8168 15.821 22.2858 15.256 22.2858H5.02307C4.45804 22.2858 4 21.8168 4 21.2384V10.7618C4 10.1833 4.45804 9.71436 5.02307 9.71436Z",
            fill: "#04868B"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M8.56932 15.872C8.32956 15.7091 8.12929 15.4924 7.98383 15.2382C7.84287 14.9726 7.77262 14.6736 7.7801 14.3714C7.76755 13.9622 7.90243 13.5625 8.15907 13.2485C8.42876 12.9342 8.77736 12.7014 9.16707 12.5754C9.61123 12.4257 10.0764 12.352 10.544 12.3571C11.1589 12.3341 11.7729 12.4221 12.3579 12.6171V13.9314C12.1037 13.7737 11.8269 13.658 11.5375 13.5885C11.2235 13.5097 10.9013 13.4702 10.578 13.4708C10.2371 13.458 9.89841 13.5314 9.59181 13.6845C9.3551 13.7891 9.20161 14.0275 9.20112 14.2914C9.20015 14.4515 9.26023 14.6056 9.36856 14.7211C9.49651 14.8572 9.64787 14.968 9.81507 15.048C10.0011 15.1428 10.2802 15.2689 10.6523 15.4263C10.6933 15.4395 10.7332 15.4559 10.7717 15.4754C11.1379 15.6219 11.4912 15.8003 11.8277 16.0085C12.0825 16.1694 12.2964 16.3899 12.4517 16.652C12.611 16.949 12.6881 17.2848 12.675 17.6234C12.6932 18.0435 12.5676 18.457 12.32 18.7925C12.0732 19.101 11.7432 19.3284 11.3712 19.4463C10.9335 19.5867 10.4768 19.6546 10.0182 19.6474C9.60681 19.6493 9.19598 19.6149 8.79033 19.5445C8.44781 19.4872 8.11355 19.3866 7.79517 19.2451V17.8594C8.0995 18.0819 8.43951 18.2482 8.79982 18.3508C9.15892 18.4654 9.53221 18.5266 9.90829 18.5325C10.2564 18.5551 10.6038 18.4796 10.9129 18.3143C11.1295 18.1892 11.2612 17.9522 11.2556 17.6977C11.2571 17.5206 11.1887 17.3504 11.0659 17.2257C10.9132 17.0722 10.7364 16.9461 10.5429 16.8525C10.3197 16.7383 9.9909 16.5876 9.55667 16.4005C9.21122 16.2584 8.88047 16.0813 8.56932 15.872Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_6321_165901"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(4 4)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_6321_165901)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.2797 17.7143C19.9787 17.7143 22.9774 14.6442 22.9774 10.8571C22.9774 7.07005 19.9787 4 16.2797 4C12.5807 4 9.58203 7.07005 9.58203 10.8571C9.58203 14.6442 12.5807 17.7143 16.2797 17.7143Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.8602 23.4286C25.251 23.4286 27.9998 20.6144 27.9998 17.1429C27.9998 13.6714 25.251 10.8572 21.8602 10.8572C18.4695 10.8572 15.7207 13.6714 15.7207 17.1429C15.7207 20.6144 18.4695 23.4286 21.8602 23.4286Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M17.1163 27.9999C19.7364 27.9999 21.8604 25.8253 21.8604 23.1428C21.8604 20.4603 19.7364 18.2856 17.1163 18.2856C14.4961 18.2856 12.3721 20.4603 12.3721 23.1428C12.3721 25.8253 14.4961 27.9999 17.1163 27.9999Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M17.395 10.1885V22.3828C17.3922 22.8065 17.1414 23.1872 16.7587 23.3485C16.6369 23.4013 16.5059 23.4285 16.3736 23.4285H12.3773C12.3718 23.3314 12.3718 23.24 12.3718 23.1428C12.3699 23.0474 12.3736 22.952 12.3829 22.8571C12.4851 21.0305 13.5842 19.4189 15.2239 18.6914V17.6285C11.5747 17.0365 9.08523 13.5279 9.66351 9.79181C9.66752 9.76593 9.67166 9.74007 9.67596 9.71425C9.70374 9.52153 9.74289 9.3307 9.79317 9.14282H16.3736C16.9368 9.14502 17.3929 9.61192 17.395 10.1885Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M15.8156 9.71436H9.67607C9.05586 13.4437 11.506 16.9816 15.1486 17.6166C15.2589 17.6358 15.3696 17.6522 15.4807 17.6658C13.7505 18.5058 12.4896 20.8915 12.3825 22.8572C12.3732 22.9521 12.3695 23.0475 12.3713 23.1429C12.3713 23.2401 12.3713 23.3315 12.3769 23.4286C12.387 23.6207 12.4112 23.8117 12.4495 24.0001H15.815C16.2289 23.9972 16.6007 23.7405 16.7583 23.3486C16.8098 23.2239 16.8364 23.0898 16.8364 22.9543V10.7601C16.8343 10.1837 16.3786 9.71687 15.8156 9.71436Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M15.8156 9.71436H9.67602C9.05594 13.444 11.5064 16.9821 15.1494 17.617C15.2239 17.63 15.2986 17.6417 15.3735 17.6521C13.6991 18.5526 12.4879 20.9327 12.383 22.8572H15.8156C16.3779 22.8529 16.8327 22.3872 16.837 21.8115V10.7601C16.8348 10.1835 16.3788 9.71655 15.8156 9.71436Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M15.2572 9.71436H9.67584C9.09032 13.2352 11.2452 16.6258 14.6265 17.5041C13.3462 19.0017 12.5609 20.8753 12.3828 22.8572H15.2572C15.8204 22.855 16.2765 22.3881 16.2786 21.8115V10.7601C16.2783 10.1827 15.8212 9.71468 15.2572 9.71436Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5.02307 9.71436H15.256C15.821 9.71436 16.2791 10.1833 16.2791 10.7618V21.2384C16.2791 21.8168 15.821 22.2858 15.256 22.2858H5.02307C4.45804 22.2858 4 21.8168 4 21.2384V10.7618C4 10.1833 4.45804 9.71436 5.02307 9.71436Z",
        fill: "#04868B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.56932 15.872C8.32956 15.7091 8.12929 15.4924 7.98383 15.2382C7.84287 14.9726 7.77262 14.6736 7.7801 14.3714C7.76755 13.9622 7.90243 13.5625 8.15907 13.2485C8.42876 12.9342 8.77736 12.7014 9.16707 12.5754C9.61123 12.4257 10.0764 12.352 10.544 12.3571C11.1589 12.3341 11.7729 12.4221 12.3579 12.6171V13.9314C12.1037 13.7737 11.8269 13.658 11.5375 13.5885C11.2235 13.5097 10.9013 13.4702 10.578 13.4708C10.2371 13.458 9.89841 13.5314 9.59181 13.6845C9.3551 13.7891 9.20161 14.0275 9.20112 14.2914C9.20015 14.4515 9.26023 14.6056 9.36856 14.7211C9.49651 14.8572 9.64787 14.968 9.81507 15.048C10.0011 15.1428 10.2802 15.2689 10.6523 15.4263C10.6933 15.4395 10.7332 15.4559 10.7717 15.4754C11.1379 15.6219 11.4912 15.8003 11.8277 16.0085C12.0825 16.1694 12.2964 16.3899 12.4517 16.652C12.611 16.949 12.6881 17.2848 12.675 17.6234C12.6932 18.0435 12.5676 18.457 12.32 18.7925C12.0732 19.101 11.7432 19.3284 11.3712 19.4463C10.9335 19.5867 10.4768 19.6546 10.0182 19.6474C9.60681 19.6493 9.19598 19.6149 8.79033 19.5445C8.44781 19.4872 8.11355 19.3866 7.79517 19.2451V17.8594C8.0995 18.0819 8.43951 18.2482 8.79982 18.3508C9.15892 18.4654 9.53221 18.5266 9.90829 18.5325C10.2564 18.5551 10.6038 18.4796 10.9129 18.3143C11.1295 18.1892 11.2612 17.9522 11.2556 17.6977C11.2571 17.5206 11.1887 17.3504 11.0659 17.2257C10.9132 17.0722 10.7364 16.9461 10.5429 16.8525C10.3197 16.7383 9.9909 16.5876 9.55667 16.4005C9.21122 16.2584 8.88047 16.0813 8.56932 15.872Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_6321_165901"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(4 4)"
    }))));
module.exports["SharePointSearchResultIcon"] = $6e9a81b4cff891e3$export$65b9e0ddb04a51a1;

});

parcelRegister("eIKlJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e42c356ce14f4c64$export$b33fb54b08bb6422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_271_181639)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
            fill: "#36C5F0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
            fill: "#2EB67D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
            fill: "#ECB22E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
            fill: "#E01E5A"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_271_181639"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "20",
            fill: "white",
            transform: "translate(2 2)"
        })));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, t0, t1);
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_271_181639)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
        fill: "#E01E5A"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_271_181639"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    }))));
module.exports["SlackIcon"] = $e42c356ce14f4c64$export$b33fb54b08bb6422;

});

parcelRegister("77zKA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $70d0455a972efd67$export$9e3ecebaf98513b9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.7993 4C11.4726 4.00098 10.3989 5.07545 10.3999 6.39945C10.3989 7.72346 11.4736 8.79793 12.8003 8.79891H15.2006V6.40043C15.2016 5.07643 14.1269 4.00196 12.7993 4C12.8003 4 12.8003 4 12.7993 4V4ZM12.7993 10.3998H6.40034C5.07368 10.4008 3.99902 11.4753 4 12.7993C3.99804 14.1233 5.0727 15.1978 6.39936 15.1997H12.7993C14.1259 15.1988 15.2006 14.1243 15.1996 12.8003C15.2006 11.4753 14.1259 10.4008 12.7993 10.3998Z",
            fill: "#36C5F0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.0004 12.7993C28.0014 11.4753 26.9267 10.4008 25.6001 10.3998C24.2734 10.4008 23.1988 11.4753 23.1997 12.7993V15.1997H25.6001C26.9267 15.1988 28.0014 14.1243 28.0004 12.7993ZM21.6005 12.7993V6.39945C21.6015 5.07643 20.5278 4.00196 19.2011 4C17.8745 4.00098 16.7998 5.07545 16.8008 6.39945V12.7993C16.7988 14.1233 17.8735 15.1978 19.2001 15.1997C20.5268 15.1988 21.6015 14.1243 21.6005 12.7993Z",
            fill: "#2EB67D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.1992 27.9993C20.5258 27.9984 21.6005 26.9239 21.5995 25.5999C21.6005 24.2759 20.5258 23.2014 19.1992 23.2004H16.7988V25.5999C16.7978 26.9229 17.8725 27.9974 19.1992 27.9993ZM19.1992 21.5985H25.5991C26.9258 21.5975 28.0004 20.523 27.9995 19.199C28.0014 17.875 26.9268 16.8005 25.6001 16.7986H19.2002C17.8735 16.7996 16.7988 17.874 16.7998 19.198C16.7988 20.523 17.8725 21.5975 19.1992 21.5985Z",
            fill: "#ECB22E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 19.1998C3.99902 20.5238 5.07368 21.5982 6.40034 21.5992C7.727 21.5982 8.80166 20.5238 8.80068 19.1998V16.8003H6.40034C5.07368 16.8013 3.99902 17.8757 4 19.1998ZM10.3999 19.1998V25.5996C10.398 26.9236 11.4726 27.9981 12.7993 28.0001C14.1259 27.9991 15.2006 26.9246 15.1996 25.6006V19.2017C15.2016 17.8777 14.1269 16.8032 12.8003 16.8013C11.4726 16.8013 10.3989 17.8757 10.3999 19.1998C10.3999 19.2007 10.3999 19.1998 10.3999 19.1998Z",
            fill: "#E01E5A"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.7993 4C11.4726 4.00098 10.3989 5.07545 10.3999 6.39945C10.3989 7.72346 11.4736 8.79793 12.8003 8.79891H15.2006V6.40043C15.2016 5.07643 14.1269 4.00196 12.7993 4C12.8003 4 12.8003 4 12.7993 4V4ZM12.7993 10.3998H6.40034C5.07368 10.4008 3.99902 11.4753 4 12.7993C3.99804 14.1233 5.0727 15.1978 6.39936 15.1997H12.7993C14.1259 15.1988 15.2006 14.1243 15.1996 12.8003C15.2006 11.4753 14.1259 10.4008 12.7993 10.3998Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.0004 12.7993C28.0014 11.4753 26.9267 10.4008 25.6001 10.3998C24.2734 10.4008 23.1988 11.4753 23.1997 12.7993V15.1997H25.6001C26.9267 15.1988 28.0014 14.1243 28.0004 12.7993ZM21.6005 12.7993V6.39945C21.6015 5.07643 20.5278 4.00196 19.2011 4C17.8745 4.00098 16.7998 5.07545 16.8008 6.39945V12.7993C16.7988 14.1233 17.8735 15.1978 19.2001 15.1997C20.5268 15.1988 21.6015 14.1243 21.6005 12.7993Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.1992 27.9993C20.5258 27.9984 21.6005 26.9239 21.5995 25.5999C21.6005 24.2759 20.5258 23.2014 19.1992 23.2004H16.7988V25.5999C16.7978 26.9229 17.8725 27.9974 19.1992 27.9993ZM19.1992 21.5985H25.5991C26.9258 21.5975 28.0004 20.523 27.9995 19.199C28.0014 17.875 26.9268 16.8005 25.6001 16.7986H19.2002C17.8735 16.7996 16.7988 17.874 16.7998 19.198C16.7988 20.523 17.8725 21.5975 19.1992 21.5985Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 19.1998C3.99902 20.5238 5.07368 21.5982 6.40034 21.5992C7.727 21.5982 8.80166 20.5238 8.80068 19.1998V16.8003H6.40034C5.07368 16.8013 3.99902 17.8757 4 19.1998ZM10.3999 19.1998V25.5996C10.398 26.9236 11.4726 27.9981 12.7993 28.0001C14.1259 27.9991 15.2006 26.9246 15.1996 25.6006V19.2017C15.2016 17.8777 14.1269 16.8032 12.8003 16.8013C11.4726 16.8013 10.3989 17.8757 10.3999 19.1998C10.3999 19.2007 10.3999 19.1998 10.3999 19.1998Z",
        fill: "#E01E5A"
    }));
module.exports["SlackSearchResultIcon"] = $70d0455a972efd67$export$9e3ecebaf98513b9;

});

parcelRegister("7Wn3K", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $757e129a31a1aee2$export$1bcbc9c337da86da = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_3561_46629)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.0321 10H19.4879C19.9088 10 20.2501 10.3403 20.2501 10.76V14.8068C20.2501 16.3494 18.9959 17.6 17.4488 17.6H17.4355C15.8884 17.6002 14.634 16.3498 14.6338 14.8072C14.6338 14.8071 14.6338 14.8069 14.6338 14.8068V10.3972C14.6338 10.1778 14.8121 10 15.0321 10Z",
            fill: "#5059C9"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M18.0435 9.19961C19.0405 9.19961 19.8487 8.39372 19.8487 7.39961C19.8487 6.4055 19.0405 5.59961 18.0435 5.59961C17.0465 5.59961 16.2383 6.4055 16.2383 7.39961C16.2383 8.39372 17.0465 9.19961 18.0435 9.19961Z",
            fill: "#5059C9"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12.4274 9.20001C13.8675 9.20001 15.0349 8.03594 15.0349 6.6C15.0349 5.16406 13.8675 4 12.4274 4C10.9873 4 9.81982 5.16406 9.81982 6.6C9.81982 8.03594 10.9873 9.20001 12.4274 9.20001Z",
            fill: "#7B83EB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.904 10H8.54908C8.13313 10.0103 7.8041 10.3545 7.81375 10.7692V15.3848C7.75566 17.8737 9.73048 19.9391 12.2265 20C14.7226 19.9391 16.6974 17.8737 16.6393 15.3848V10.7692C16.649 10.3545 16.3199 10.0103 15.904 10Z",
            fill: "#7B83EB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M12.6276 10V16.468C12.6256 16.7646 12.4454 17.0311 12.1703 17.144C12.0827 17.1809 11.9886 17.2 11.8935 17.2H8.16671C8.11456 17.068 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.6276Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M12.2265 10V16.868C12.2265 16.9628 12.2074 17.0567 12.1703 17.144C12.0571 17.4183 11.7898 17.598 11.4924 17.6H8.35526C8.28706 17.468 8.22288 17.336 8.16671 17.2C8.11055 17.064 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M12.2265 10V16.068C12.2234 16.471 11.8965 16.797 11.4923 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.8253 10V16.068C11.8223 16.471 11.4954 16.797 11.0912 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H11.8253Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M12.628 7.93121V9.19121C12.5598 9.19521 12.4956 9.19921 12.4274 9.19921C12.3592 9.19921 12.2951 9.19522 12.2269 9.19121C12.0914 9.18225 11.9572 9.16083 11.8257 9.12721C11.0133 8.93539 10.3422 8.36732 10.0205 7.59922C9.9651 7.47023 9.92213 7.33629 9.89209 7.19922H11.8939C12.2987 7.20075 12.6265 7.52757 12.628 7.93121Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M11.8257 8.33161V9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.0916C11.4964 7.60115 11.8242 7.92798 11.8257 8.33161Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M3.73533 7.59961H11.0902C11.4964 7.59961 11.8256 7.92788 11.8256 8.33281V15.6664C11.8256 16.0713 11.4963 16.3996 11.0902 16.3996H3.73533C3.32921 16.3996 3 16.0713 3 15.6664V8.33281C3 7.92788 3.32922 7.59961 3.73533 7.59961Z",
            fill: "#5059C9"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M9.34796 10.3916H7.87769V14.3836H6.94098V10.3916H5.47754V9.61719H9.34796V10.3916Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "1 1 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_3561_46629"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "17.25",
            height: "16",
            fill: "white",
            transform: "translate(3 4)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "1 1 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_3561_46629)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.0321 10H19.4879C19.9088 10 20.2501 10.3403 20.2501 10.76V14.8068C20.2501 16.3494 18.9959 17.6 17.4488 17.6H17.4355C15.8884 17.6002 14.634 16.3498 14.6338 14.8072C14.6338 14.8071 14.6338 14.8069 14.6338 14.8068V10.3972C14.6338 10.1778 14.8121 10 15.0321 10Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M18.0435 9.19961C19.0405 9.19961 19.8487 8.39372 19.8487 7.39961C19.8487 6.4055 19.0405 5.59961 18.0435 5.59961C17.0465 5.59961 16.2383 6.4055 16.2383 7.39961C16.2383 8.39372 17.0465 9.19961 18.0435 9.19961Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.4274 9.20001C13.8675 9.20001 15.0349 8.03594 15.0349 6.6C15.0349 5.16406 13.8675 4 12.4274 4C10.9873 4 9.81982 5.16406 9.81982 6.6C9.81982 8.03594 10.9873 9.20001 12.4274 9.20001Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.904 10H8.54908C8.13313 10.0103 7.8041 10.3545 7.81375 10.7692V15.3848C7.75566 17.8737 9.73048 19.9391 12.2265 20C14.7226 19.9391 16.6974 17.8737 16.6393 15.3848V10.7692C16.649 10.3545 16.3199 10.0103 15.904 10Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M12.6276 10V16.468C12.6256 16.7646 12.4454 17.0311 12.1703 17.144C12.0827 17.1809 11.9886 17.2 11.8935 17.2H8.16671C8.11456 17.068 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.6276Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.2265 10V16.868C12.2265 16.9628 12.2074 17.0567 12.1703 17.144C12.0571 17.4183 11.7898 17.598 11.4924 17.6H8.35526C8.28706 17.468 8.22288 17.336 8.16671 17.2C8.11055 17.064 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.2265 10V16.068C12.2234 16.471 11.8965 16.797 11.4923 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.8253 10V16.068C11.8223 16.471 11.4954 16.797 11.0912 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H11.8253Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M12.628 7.93121V9.19121C12.5598 9.19521 12.4956 9.19921 12.4274 9.19921C12.3592 9.19921 12.2951 9.19522 12.2269 9.19121C12.0914 9.18225 11.9572 9.16083 11.8257 9.12721C11.0133 8.93539 10.3422 8.36732 10.0205 7.59922C9.9651 7.47023 9.92213 7.33629 9.89209 7.19922H11.8939C12.2987 7.20075 12.6265 7.52757 12.628 7.93121Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M11.8257 8.33161V9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.0916C11.4964 7.60115 11.8242 7.92798 11.8257 8.33161Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3.73533 7.59961H11.0902C11.4964 7.59961 11.8256 7.92788 11.8256 8.33281V15.6664C11.8256 16.0713 11.4963 16.3996 11.0902 16.3996H3.73533C3.32921 16.3996 3 16.0713 3 15.6664V8.33281C3 7.92788 3.32922 7.59961 3.73533 7.59961Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.34796 10.3916H7.87769V14.3836H6.94098V10.3916H5.47754V9.61719H9.34796V10.3916Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_3561_46629"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "17.25",
        height: "16",
        fill: "white",
        transform: "translate(3 4)"
    }))));
module.exports["TeamsIcon"] = $757e129a31a1aee2$export$1bcbc9c337da86da;

});

parcelRegister("ew2HG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $5359eba4c97f50d8$export$fa291efbf00e84d3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_6321_165930)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M20.7408 13H26.94C27.5257 13 28.0005 13.5104 28.0005 14.14V20.2102C28.0005 22.5242 26.2555 24.4 24.103 24.4H24.0846C21.932 24.4003 20.1868 22.5248 20.1865 20.2108C20.1865 20.2106 20.1865 20.2104 20.1865 20.2102V13.5958C20.1865 13.2667 20.4347 13 20.7408 13Z",
            fill: "#5059C9"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M24.9306 11.7999C26.3177 11.7999 27.4422 10.5911 27.4422 9.0999C27.4422 7.60873 26.3177 6.3999 24.9306 6.3999C23.5434 6.3999 22.4189 7.60873 22.4189 9.0999C22.4189 10.5911 23.5434 11.7999 24.9306 11.7999Z",
            fill: "#5059C9"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M17.1162 11.8C19.1198 11.8 20.7441 10.0539 20.7441 7.9C20.7441 5.74609 19.1198 4 17.1162 4C15.1126 4 13.4883 5.74609 13.4883 7.9C13.4883 10.0539 15.1126 11.8 17.1162 11.8Z",
            fill: "#7B83EB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.954 13H11.7211C11.1424 13.0154 10.6846 13.5317 10.698 14.1538V21.0772C10.6172 24.8106 13.3648 27.9086 16.8376 28C20.3103 27.9086 23.0579 24.8106 22.9771 21.0772V14.1538C22.9905 13.5317 22.5327 13.0154 21.954 13Z",
            fill: "#7B83EB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M17.3952 13V22.702C17.3925 23.1469 17.1417 23.5466 16.759 23.716C16.6371 23.7714 16.5061 23.8 16.3738 23.8H11.1887C11.1162 23.602 11.0492 23.404 10.9934 23.2C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H17.3952Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M16.8371 13V23.302C16.8371 23.4442 16.8105 23.585 16.759 23.716C16.6014 24.1274 16.2296 24.397 15.8157 24.4H11.4511C11.3562 24.202 11.2669 24.004 11.1887 23.8C11.1106 23.596 11.0492 23.404 10.9934 23.2C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H16.8371Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M16.8371 13V22.102C16.8328 22.7065 16.378 23.1954 15.8157 23.2H10.9934C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H16.8371Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M16.2789 13V22.102C16.2747 22.7065 15.8199 23.1954 15.2576 23.2H10.9934C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H16.2789Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M17.3954 9.89804V11.788C17.3005 11.794 17.2112 11.8 17.1163 11.8C17.0214 11.8 16.9321 11.794 16.8372 11.788C16.6488 11.7746 16.462 11.7425 16.2791 11.692C15.1489 11.4043 14.2151 10.5522 13.7675 9.40005C13.6905 9.20656 13.6307 9.00565 13.5889 8.80005H16.374C16.9372 8.80234 17.3932 9.29258 17.3954 9.89804Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M16.8373 10.4979V11.7879C16.6489 11.7745 16.4621 11.7423 16.2792 11.6919C15.149 11.4042 14.2152 10.5521 13.7676 9.3999H15.8159C16.3792 9.40219 16.8352 9.89244 16.8373 10.4979Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M16.8373 10.4979V11.7879C16.6489 11.7745 16.4621 11.7423 16.2792 11.6919C15.149 11.4042 14.2152 10.5521 13.7676 9.3999H15.8159C16.3792 9.40219 16.8352 9.89244 16.8373 10.4979Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M16.2792 10.4979V11.6919C15.149 11.4042 14.2152 10.5521 13.7676 9.3999H15.2578C15.821 9.40221 16.2771 9.89245 16.2792 10.4979Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M5.02306 9.3999H15.256C15.821 9.3999 16.2791 9.8923 16.2791 10.4997V21.5001C16.2791 22.1075 15.821 22.5999 15.256 22.5999H5.02306C4.45804 22.5999 4 22.1075 4 21.5001V10.4997C4 9.8923 4.45805 9.3999 5.02306 9.3999Z",
            fill: "#5059C9"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12.8322 13.5869H10.7866V19.5749H9.48336V13.5869H7.44727V12.4253H12.8322V13.5869Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_6321_165930"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(4 4)"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_6321_165930)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M20.7408 13H26.94C27.5257 13 28.0005 13.5104 28.0005 14.14V20.2102C28.0005 22.5242 26.2555 24.4 24.103 24.4H24.0846C21.932 24.4003 20.1868 22.5248 20.1865 20.2108C20.1865 20.2106 20.1865 20.2104 20.1865 20.2102V13.5958C20.1865 13.2667 20.4347 13 20.7408 13Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M24.9306 11.7999C26.3177 11.7999 27.4422 10.5911 27.4422 9.0999C27.4422 7.60873 26.3177 6.3999 24.9306 6.3999C23.5434 6.3999 22.4189 7.60873 22.4189 9.0999C22.4189 10.5911 23.5434 11.7999 24.9306 11.7999Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M17.1162 11.8C19.1198 11.8 20.7441 10.0539 20.7441 7.9C20.7441 5.74609 19.1198 4 17.1162 4C15.1126 4 13.4883 5.74609 13.4883 7.9C13.4883 10.0539 15.1126 11.8 17.1162 11.8Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.954 13H11.7211C11.1424 13.0154 10.6846 13.5317 10.698 14.1538V21.0772C10.6172 24.8106 13.3648 27.9086 16.8376 28C20.3103 27.9086 23.0579 24.8106 22.9771 21.0772V14.1538C22.9905 13.5317 22.5327 13.0154 21.954 13Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M17.3952 13V22.702C17.3925 23.1469 17.1417 23.5466 16.759 23.716C16.6371 23.7714 16.5061 23.8 16.3738 23.8H11.1887C11.1162 23.602 11.0492 23.404 10.9934 23.2C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H17.3952Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M16.8371 13V23.302C16.8371 23.4442 16.8105 23.585 16.759 23.716C16.6014 24.1274 16.2296 24.397 15.8157 24.4H11.4511C11.3562 24.202 11.2669 24.004 11.1887 23.8C11.1106 23.596 11.0492 23.404 10.9934 23.2C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H16.8371Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M16.8371 13V22.102C16.8328 22.7065 16.378 23.1954 15.8157 23.2H10.9934C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H16.8371Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M16.2789 13V22.102C16.2747 22.7065 15.8199 23.1954 15.2576 23.2H10.9934C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H16.2789Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M17.3954 9.89804V11.788C17.3005 11.794 17.2112 11.8 17.1163 11.8C17.0214 11.8 16.9321 11.794 16.8372 11.788C16.6488 11.7746 16.462 11.7425 16.2791 11.692C15.1489 11.4043 14.2151 10.5522 13.7675 9.40005C13.6905 9.20656 13.6307 9.00565 13.5889 8.80005H16.374C16.9372 8.80234 17.3932 9.29258 17.3954 9.89804Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M16.8373 10.4979V11.7879C16.6489 11.7745 16.4621 11.7423 16.2792 11.6919C15.149 11.4042 14.2152 10.5521 13.7676 9.3999H15.8159C16.3792 9.40219 16.8352 9.89244 16.8373 10.4979Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M16.8373 10.4979V11.7879C16.6489 11.7745 16.4621 11.7423 16.2792 11.6919C15.149 11.4042 14.2152 10.5521 13.7676 9.3999H15.8159C16.3792 9.40219 16.8352 9.89244 16.8373 10.4979Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M16.2792 10.4979V11.6919C15.149 11.4042 14.2152 10.5521 13.7676 9.3999H15.2578C15.821 9.40221 16.2771 9.89245 16.2792 10.4979Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5.02306 9.3999H15.256C15.821 9.3999 16.2791 9.8923 16.2791 10.4997V21.5001C16.2791 22.1075 15.821 22.5999 15.256 22.5999H5.02306C4.45804 22.5999 4 22.1075 4 21.5001V10.4997C4 9.8923 4.45805 9.3999 5.02306 9.3999Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.8322 13.5869H10.7866V19.5749H9.48336V13.5869H7.44727V12.4253H12.8322V13.5869Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_6321_165930"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(4 4)"
    }))));
module.exports["TeamsSearchResultIcon"] = $5359eba4c97f50d8$export$fa291efbf00e84d3;

});

parcelRegister("4aQS7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $76f7ee4fbf4e4884$export$4b1dce6f0fbd3e37 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "3 3 26 26",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.39008 15.0002H11.02C11.117 12.621 11.5575 10.4492 12.2472 8.78245C12.3552 8.52159 12.4707 8.26946 12.594 8.02828C9.793 9.22645 7.75112 11.8577 7.39008 15.0002ZM15.9997 5.3335C10.1086 5.3335 5.33301 10.1091 5.33301 16.0002C5.33301 21.8912 10.1086 26.6668 15.9997 26.6668C21.8907 26.6668 26.6663 21.8912 26.6663 16.0002C26.6663 10.1091 21.8907 5.3335 15.9997 5.3335ZM15.9997 7.3335C15.7983 7.3335 15.5142 7.42791 15.1575 7.79247C14.7976 8.16034 14.4274 8.74437 14.0953 9.54715C13.5201 10.9372 13.1178 12.84 13.0218 15.0002H18.9776C18.8816 12.84 18.4793 10.9372 17.9041 9.54715C17.5719 8.74437 17.2017 8.16034 16.8418 7.79247C16.4852 7.42791 16.2011 7.3335 15.9997 7.3335ZM20.9794 15.0002C20.8824 12.621 20.4418 10.4492 19.7521 8.78245C19.6442 8.52159 19.5286 8.26946 19.4054 8.02828C22.2063 9.22645 24.2482 11.8577 24.6093 15.0002H20.9794ZM18.9776 17.0002H13.0218C13.1178 19.1604 13.5201 21.0631 14.0953 22.4532C14.4274 23.2559 14.7976 23.84 15.1575 24.2079C15.5142 24.5724 15.7983 24.6668 15.9997 24.6668C16.2011 24.6668 16.4852 24.5724 16.8418 24.2079C17.2017 23.84 17.5719 23.2559 17.9041 22.4532C18.4793 21.0631 18.8816 19.1604 18.9776 17.0002ZM19.4054 23.972C19.5286 23.7309 19.6442 23.4787 19.7521 23.2179C20.4418 21.5511 20.8824 19.3793 20.9794 17.0002H24.6093C24.2482 20.1427 22.2063 22.7739 19.4054 23.972ZM12.594 23.972C12.4707 23.7309 12.3552 23.4787 12.2472 23.2179C11.5575 21.5511 11.117 19.3793 11.02 17.0002H7.39008C7.75112 20.1427 9.793 22.7739 12.594 23.972Z",
            fill: "currentColor"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "3 3 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.39008 15.0002H11.02C11.117 12.621 11.5575 10.4492 12.2472 8.78245C12.3552 8.52159 12.4707 8.26946 12.594 8.02828C9.793 9.22645 7.75112 11.8577 7.39008 15.0002ZM15.9997 5.3335C10.1086 5.3335 5.33301 10.1091 5.33301 16.0002C5.33301 21.8912 10.1086 26.6668 15.9997 26.6668C21.8907 26.6668 26.6663 21.8912 26.6663 16.0002C26.6663 10.1091 21.8907 5.3335 15.9997 5.3335ZM15.9997 7.3335C15.7983 7.3335 15.5142 7.42791 15.1575 7.79247C14.7976 8.16034 14.4274 8.74437 14.0953 9.54715C13.5201 10.9372 13.1178 12.84 13.0218 15.0002H18.9776C18.8816 12.84 18.4793 10.9372 17.9041 9.54715C17.5719 8.74437 17.2017 8.16034 16.8418 7.79247C16.4852 7.42791 16.2011 7.3335 15.9997 7.3335ZM20.9794 15.0002C20.8824 12.621 20.4418 10.4492 19.7521 8.78245C19.6442 8.52159 19.5286 8.26946 19.4054 8.02828C22.2063 9.22645 24.2482 11.8577 24.6093 15.0002H20.9794ZM18.9776 17.0002H13.0218C13.1178 19.1604 13.5201 21.0631 14.0953 22.4532C14.4274 23.2559 14.7976 23.84 15.1575 24.2079C15.5142 24.5724 15.7983 24.6668 15.9997 24.6668C16.2011 24.6668 16.4852 24.5724 16.8418 24.2079C17.2017 23.84 17.5719 23.2559 17.9041 22.4532C18.4793 21.0631 18.8816 19.1604 18.9776 17.0002ZM19.4054 23.972C19.5286 23.7309 19.6442 23.4787 19.7521 23.2179C20.4418 21.5511 20.8824 19.3793 20.9794 17.0002H24.6093C24.2482 20.1427 22.2063 22.7739 19.4054 23.972ZM12.594 23.972C12.4707 23.7309 12.3552 23.4787 12.2472 23.2179C11.5575 21.5511 11.117 19.3793 11.02 17.0002H7.39008C7.75112 20.1427 9.793 22.7739 12.594 23.972Z",
        fill: "currentColor"
    }));
module.exports["WebDomainIcon"] = $76f7ee4fbf4e4884$export$4b1dce6f0fbd3e37;

});

parcelRegister("1tbRi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cfdd9325530211fa$export$b16288f56aa4a879 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (_)=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "24",
            height: "25",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.5428 12.0273H8.26521C8.33797 10.243 8.6684 8.61411 9.18567 7.36406C9.26662 7.16841 9.35328 6.97932 9.44572 6.79843C7.34499 7.69706 5.81358 9.67046 5.5428 12.0273ZM12 4.77734C7.58172 4.77734 4 8.35907 4 12.7773C4 17.1956 7.58172 20.7773 12 20.7773C16.4183 20.7773 20 17.1956 20 12.7773C20 8.35907 16.4183 4.77734 12 4.77734ZM12 6.27734C11.849 6.27734 11.6359 6.34815 11.3684 6.62157C11.0985 6.89748 10.8208 7.3355 10.5717 7.93758C10.1403 8.98016 9.83856 10.4072 9.76656 12.0273H14.2334C14.1614 10.4072 13.8597 8.98016 13.4283 7.93758C13.1792 7.3355 12.9015 6.89748 12.6316 6.62157C12.3641 6.34815 12.151 6.27734 12 6.27734ZM15.7348 12.0273C15.662 10.243 15.3316 8.61411 14.8143 7.36406C14.7334 7.16841 14.6467 6.97931 14.5543 6.79843C16.655 7.69706 18.1864 9.67046 18.4572 12.0273H15.7348ZM14.2334 13.5273H9.76656C9.83856 15.1475 10.1403 16.5745 10.5717 17.6171C10.8208 18.2192 11.0985 18.6572 11.3684 18.9331C11.6359 19.2065 11.849 19.2773 12 19.2773C12.151 19.2773 12.3641 19.2065 12.6316 18.9331C12.9015 18.6572 13.1792 18.2192 13.4283 17.6171C13.8597 16.5745 14.1614 15.1475 14.2334 13.5273ZM14.5543 18.7563C14.6467 18.5754 14.7334 18.3863 14.8143 18.1906C15.3316 16.9406 15.662 15.3117 15.7348 13.5273H18.4572C18.1864 15.8842 16.655 17.8576 14.5543 18.7563ZM9.44572 18.7563C9.35328 18.5754 9.26662 18.3863 9.18567 18.1906C8.6684 16.9406 8.33797 15.3117 8.26521 13.5273H5.5428C5.81358 15.8842 7.34499 17.8576 9.44572 18.7563Z",
            fill: "currentColor"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5428 12.0273H8.26521C8.33797 10.243 8.6684 8.61411 9.18567 7.36406C9.26662 7.16841 9.35328 6.97932 9.44572 6.79843C7.34499 7.69706 5.81358 9.67046 5.5428 12.0273ZM12 4.77734C7.58172 4.77734 4 8.35907 4 12.7773C4 17.1956 7.58172 20.7773 12 20.7773C16.4183 20.7773 20 17.1956 20 12.7773C20 8.35907 16.4183 4.77734 12 4.77734ZM12 6.27734C11.849 6.27734 11.6359 6.34815 11.3684 6.62157C11.0985 6.89748 10.8208 7.3355 10.5717 7.93758C10.1403 8.98016 9.83856 10.4072 9.76656 12.0273H14.2334C14.1614 10.4072 13.8597 8.98016 13.4283 7.93758C13.1792 7.3355 12.9015 6.89748 12.6316 6.62157C12.3641 6.34815 12.151 6.27734 12 6.27734ZM15.7348 12.0273C15.662 10.243 15.3316 8.61411 14.8143 7.36406C14.7334 7.16841 14.6467 6.97931 14.5543 6.79843C16.655 7.69706 18.1864 9.67046 18.4572 12.0273H15.7348ZM14.2334 13.5273H9.76656C9.83856 15.1475 10.1403 16.5745 10.5717 17.6171C10.8208 18.2192 11.0985 18.6572 11.3684 18.9331C11.6359 19.2065 11.849 19.2773 12 19.2773C12.151 19.2773 12.3641 19.2065 12.6316 18.9331C12.9015 18.6572 13.1792 18.2192 13.4283 17.6171C13.8597 16.5745 14.1614 15.1475 14.2334 13.5273ZM14.5543 18.7563C14.6467 18.5754 14.7334 18.3863 14.8143 18.1906C15.3316 16.9406 15.662 15.3117 15.7348 13.5273H18.4572C18.1864 15.8842 16.655 17.8576 14.5543 18.7563ZM9.44572 18.7563C9.35328 18.5754 9.26662 18.3863 9.18567 18.1906C8.6684 16.9406 8.33797 15.3117 8.26521 13.5273H5.5428C5.81358 15.8842 7.34499 17.8576 9.44572 18.7563Z",
        fill: "currentColor"
    }));
module.exports["WebDomainSearchResultIcon"] = $cfdd9325530211fa$export$b16288f56aa4a879;

});

parcelRegister("gc2TU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $57b645d70d3ba419$export$9969d63eaadfddf7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M15.0857 11.8028V25.1868H4L15.0857 11.8028ZM15.0857 7C15.0857 8.47005 14.5017 9.8799 13.4622 10.9194C12.4227 11.9589 11.0129 12.5428 9.54284 12.5428C8.07279 12.5428 6.66295 11.9589 5.62346 10.9194C4.58398 9.8799 4 8.47005 4 7H15.0857ZM16.9119 25.188C16.9119 23.7179 17.4959 22.3081 18.5354 21.2686C19.5749 20.2291 20.9847 19.6451 22.4548 19.6451C23.9248 19.6451 25.3347 20.2291 26.3742 21.2686C27.4137 22.3081 27.9976 23.7179 27.9976 25.188H16.9119ZM16.9119 20.3851V7H28L16.9119 20.3839V20.3851Z",
            fill: "var(--ds-text-accent-teal-bolder, #164555)"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.0857 11.8028V25.1868H4L15.0857 11.8028ZM15.0857 7C15.0857 8.47005 14.5017 9.8799 13.4622 10.9194C12.4227 11.9589 11.0129 12.5428 9.54284 12.5428C8.07279 12.5428 6.66295 11.9589 5.62346 10.9194C4.58398 9.8799 4 8.47005 4 7H15.0857ZM16.9119 25.188C16.9119 23.7179 17.4959 22.3081 18.5354 21.2686C19.5749 20.2291 20.9847 19.6451 22.4548 19.6451C23.9248 19.6451 25.3347 20.2291 26.3742 21.2686C27.4137 22.3081 27.9976 23.7179 27.9976 25.188H16.9119ZM16.9119 20.3851V7H28L16.9119 20.3839V20.3851Z",
        fill: "var(--ds-text-accent-teal-bolder, #164555)"
    }));
var $57b645d70d3ba419$export$2e2bcd8739ae039 = $57b645d70d3ba419$export$9969d63eaadfddf7;
module.exports["ZendeskIcon"] = $57b645d70d3ba419$export$9969d63eaadfddf7;
module.exports["default"] = $57b645d70d3ba419$export$2e2bcd8739ae039;

});

parcelRegister("jR2a0", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");

const $1696e7ac1a27a098$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $1696e7ac1a27a098$export$f49dad89491f6bf2({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $1696e7ac1a27a098$var$DEFAULT_GRAPHQL_ENDPOINT }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    return (0, $gABt9.utils).requestService({
        url: url
    }, options);
}
module.exports["fetchAgg"] = $1696e7ac1a27a098$export$f49dad89491f6bf2;

});

parcelRegister("7Mvs5", function(module, exports) {

var $d5jV9 = parcelRequire("d5jV9");

const $c066fc52d7c2483e$export$26b8d9fa10eeb703 = (args)=>{
    const cacheInstance = (0, $d5jV9.getInstance)(args);
    const get = (key)=>key.length ? cacheInstance.get(key) : undefined;
    const set = (key, result)=>{
        if (key.length) cacheInstance.set(key, result);
    };
    const has = (key)=>cacheInstance.has(key);
    const clear = (key)=>cacheInstance.clear(key);
    const inMemoryDecorator = (key, supplier, expireWhen)=>{
        // Check if the key is already in the cache
        const cached = get(key);
        // If the key is in the cache, return the cached value
        if (cached) return cached;
        // If the key is not in the cache, call the supplier function
        const result = supplier();
        set(key, result);
        // If the promise is rejected, clear the cache
        result.catch(()=>{
            // If the promise is rejected, clear the cache
            cacheInstance.clear(key);
        });
        // Return the result
        // If the result should be expired, clear the cache
        return result.then((value)=>{
            if (expireWhen && expireWhen(value)) cacheInstance.clear(key);
            return value;
        });
    };
    return {
        get: get,
        set: set,
        has: has,
        clear: clear,
        inMemoryDecorator: inMemoryDecorator
    };
};
module.exports["inMemoryCache"] = $c066fc52d7c2483e$export$26b8d9fa10eeb703;

});

parcelRegister("3Q5mv", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $234d800bcbae3f2f$export$ffa5bf38ea9a76ee = (0, $87Lnp.z).enum([
    'true',
    'false'
]).transform((x)=>x === 'true');
const $234d800bcbae3f2f$export$236bfa8a18b6097 = (0, $87Lnp.z).string().transform((x)=>x.split(','));
const $234d800bcbae3f2f$export$1cbda5ccc2e23e06 = (0, $87Lnp.z).nativeEnum({
    Asana: 'asana',
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    GoogleDrive: 'drive',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Opsgenie: 'opsgenie',
    Sharepoint: 'sharepoint',
    Slack: 'slack',
    Trello: 'trello',
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Teams: 'teams',
    Figma: 'figma',
    Github: 'github',
    Loom: 'loom',
    OneDrive: 'onedrive',
    GoogleCalendar: 'google-calendar',
    Dropbox: 'dropbox',
    Gmail: 'gmail',
    OutlookCalendar: 'outlook-calendar',
    Airtable: 'airtable',
    Zendesk: 'zendesk',
    Notion: 'notion',
    Miro: 'miro'
});
const $234d800bcbae3f2f$export$f3a53bd43617a593 = $234d800bcbae3f2f$export$1cbda5ccc2e23e06.enum;
const $234d800bcbae3f2f$export$7a844b7429919d2 = (0, $87Lnp.z).nativeEnum({
    All: 'all'
});
const $234d800bcbae3f2f$export$ec20ab1a5eb36014 = $234d800bcbae3f2f$export$7a844b7429919d2.enum;
const $234d800bcbae3f2f$export$ddfc756f87e8324d = (0, $87Lnp.z).nativeEnum({
    Goal: 'goal',
    Learning: 'learning',
    Project: 'project',
    Tag: 'tag'
});
const $234d800bcbae3f2f$export$48b648eee115c3e5 = $234d800bcbae3f2f$export$ddfc756f87e8324d.enum;
const $234d800bcbae3f2f$export$578ac6cc3cc5997a = (0, $87Lnp.z).nativeEnum({
    WorkItem: 'work-item'
});
const $234d800bcbae3f2f$export$721015a6e24d06a0 = $234d800bcbae3f2f$export$578ac6cc3cc5997a.enum;
const $234d800bcbae3f2f$export$d872f0aa011c3a9d = (0, $87Lnp.z).nativeEnum({
    Answer: 'answer',
    Attachment: 'attachment',
    Blogpost: 'blogpost',
    Calendar: 'calendar',
    Comment: 'comment',
    Database: 'database',
    Document: 'document',
    Embed: 'embed',
    Folder: 'folder',
    Page: 'page',
    Question: 'question',
    Space: 'space',
    SpaceCalendar: 'space-calendar',
    Whiteboard: 'whiteboard'
});
const $234d800bcbae3f2f$export$98ac9eece9e68319 = $234d800bcbae3f2f$export$d872f0aa011c3a9d.enum;
const $234d800bcbae3f2f$export$340da7d4450f4487 = (0, $87Lnp.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
const $234d800bcbae3f2f$export$bcc0874ed7743007 = $234d800bcbae3f2f$export$340da7d4450f4487.enum;
const $234d800bcbae3f2f$export$2d13808294fd047f = (0, $87Lnp.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
const $234d800bcbae3f2f$export$847712e479ca402d = $234d800bcbae3f2f$export$2d13808294fd047f.enum;
const $234d800bcbae3f2f$export$dbec9fc36dbba98b = (0, $87Lnp.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
const $234d800bcbae3f2f$export$8c76eb96ebfefeac = $234d800bcbae3f2f$export$dbec9fc36dbba98b.enum;
const $234d800bcbae3f2f$export$e31a67e5bb829f5c = (0, $87Lnp.z).nativeEnum({
    Project: 'project',
    Issue: 'issue',
    Filter: 'filter',
    Dashboard: 'dashboard',
    Board: 'board'
});
const $234d800bcbae3f2f$export$e3ddf72248eaf972 = $234d800bcbae3f2f$export$e31a67e5bb829f5c.enum;
const $234d800bcbae3f2f$export$e3c670f5c4b4df75 = (0, $87Lnp.z).nativeEnum({
    Component: 'component'
});
const $234d800bcbae3f2f$export$39271a5a1b74da02 = $234d800bcbae3f2f$export$e3c670f5c4b4df75.enum;
const $234d800bcbae3f2f$export$15f07c0375d70d62 = (0, $87Lnp.z).nativeEnum({
    Board: 'board',
    Card: 'card'
});
const $234d800bcbae3f2f$export$309520b897e0c0b = $234d800bcbae3f2f$export$15f07c0375d70d62.enum;
const $234d800bcbae3f2f$export$78ff7f7a3ef7dca8 = (0, $87Lnp.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation'
});
const $234d800bcbae3f2f$export$d51b5367809bb96 = $234d800bcbae3f2f$export$78ff7f7a3ef7dca8.enum;
const $234d800bcbae3f2f$export$e362a3dbc1368cf2 = (0, $87Lnp.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation'
});
const $234d800bcbae3f2f$export$c69d59ad598aee72 = $234d800bcbae3f2f$export$e362a3dbc1368cf2.enum;
const $234d800bcbae3f2f$export$3d532d345dacbf34 = (0, $87Lnp.z).nativeEnum({
    Repository: 'repository',
    PullRequest: 'pull-request',
    Commit: 'commit',
    Branch: 'branch'
});
const $234d800bcbae3f2f$export$8de16d71f5b0d410 = $234d800bcbae3f2f$export$3d532d345dacbf34.enum;
const $234d800bcbae3f2f$export$c30d3299c2899a1f = (0, $87Lnp.z).nativeEnum({
    WebPage: 'web-page'
});
const $234d800bcbae3f2f$export$bf86d9f770860253 = $234d800bcbae3f2f$export$c30d3299c2899a1f.enum;
const $234d800bcbae3f2f$export$f4b8db47840ea062 = (0, $87Lnp.z).nativeEnum({
    Design: 'design'
});
const $234d800bcbae3f2f$export$66f84ff942de6e1f = $234d800bcbae3f2f$export$f4b8db47840ea062.enum;
const $234d800bcbae3f2f$export$915266ba4ee70164 = (0, $87Lnp.z).nativeEnum({
    Video: 'video'
});
const $234d800bcbae3f2f$export$56591a3ad34d704b = $234d800bcbae3f2f$export$915266ba4ee70164.enum;
const $234d800bcbae3f2f$export$8669b3074569e564 = (0, $87Lnp.z).nativeEnum({
    WorkItem: 'work-item'
});
const $234d800bcbae3f2f$export$fd3bdf5548c7bf84 = $234d800bcbae3f2f$export$8669b3074569e564.enum;
const $234d800bcbae3f2f$export$4f29dba8e623c3d1 = (0, $87Lnp.z).nativeEnum({
    ...$234d800bcbae3f2f$export$ec20ab1a5eb36014,
    ...$234d800bcbae3f2f$export$721015a6e24d06a0,
    ...$234d800bcbae3f2f$export$48b648eee115c3e5,
    ...$234d800bcbae3f2f$export$98ac9eece9e68319,
    ...$234d800bcbae3f2f$export$bcc0874ed7743007,
    ...$234d800bcbae3f2f$export$847712e479ca402d,
    ...$234d800bcbae3f2f$export$e3ddf72248eaf972,
    ...$234d800bcbae3f2f$export$39271a5a1b74da02,
    ...$234d800bcbae3f2f$export$309520b897e0c0b,
    ...$234d800bcbae3f2f$export$d51b5367809bb96,
    ...$234d800bcbae3f2f$export$c69d59ad598aee72,
    ...$234d800bcbae3f2f$export$66f84ff942de6e1f,
    ...$234d800bcbae3f2f$export$8de16d71f5b0d410,
    ...$234d800bcbae3f2f$export$56591a3ad34d704b,
    ...$234d800bcbae3f2f$export$bf86d9f770860253,
    ...$234d800bcbae3f2f$export$8c76eb96ebfefeac,
    ...$234d800bcbae3f2f$export$fd3bdf5548c7bf84
});
const $234d800bcbae3f2f$export$e2e108cbe2e4f865 = $234d800bcbae3f2f$export$4f29dba8e623c3d1.enum;
const $234d800bcbae3f2f$export$7c078c2ec2ab4e93 = (0, $87Lnp.z).nativeEnum({
    Anytime: 'anytime',
    Today: 'today',
    Yesterday: 'yesterday',
    Past7Days: 'past7Days',
    Past30Days: 'past30Days',
    PastYear: 'pastYear',
    Custom: 'custom'
});
const $234d800bcbae3f2f$export$e6747eee8f26f8c0 = $234d800bcbae3f2f$export$7c078c2ec2ab4e93.enum;
const $234d800bcbae3f2f$export$7b58b3b9a7b83d61 = (0, $87Lnp.z).object({
    text: (0, $87Lnp.z).optional((0, $87Lnp.z).string().max(200)),
    // TODO: >>>> Ask how long should be the max query string?
    originalQuery: (0, $87Lnp.z).optional((0, $87Lnp.z).string().max(200)),
    // Used to support "Did you mean" feature
    product: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe($234d800bcbae3f2f$export$1cbda5ccc2e23e06)),
    type: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe($234d800bcbae3f2f$export$4f29dba8e623c3d1)),
    // Last Modified
    lastModified: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe($234d800bcbae3f2f$export$7c078c2ec2ab4e93)),
    lastModified_lt: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $87Lnp.z).coerce.date())),
    lastModified_gt: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $87Lnp.z).coerce.date())),
    from: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    to: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    titleMatch: (0, $87Lnp.z).optional($234d800bcbae3f2f$export$ffa5bf38ea9a76ee),
    // Confluence filters
    contributors: (0, $87Lnp.z).optional($234d800bcbae3f2f$export$236bfa8a18b6097),
    owners: (0, $87Lnp.z).optional($234d800bcbae3f2f$export$236bfa8a18b6097),
    ancestor: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    spaces: (0, $87Lnp.z).optional($234d800bcbae3f2f$export$236bfa8a18b6097),
    verified: (0, $87Lnp.z).optional($234d800bcbae3f2f$export$ffa5bf38ea9a76ee),
    labels: (0, $87Lnp.z).optional($234d800bcbae3f2f$export$236bfa8a18b6097),
    // Jira Filters
    jAssignee: (0, $87Lnp.z).optional($234d800bcbae3f2f$export$236bfa8a18b6097),
    jProject: (0, $87Lnp.z).optional($234d800bcbae3f2f$export$236bfa8a18b6097),
    referrer: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    // sort
    sortField: (0, $87Lnp.z).optional((0, $87Lnp.z).enum([
        'latestModifiedDate',
        'createdDate'
    ])),
    sortOrder: (0, $87Lnp.z).optional((0, $87Lnp.z).enum([
        'ASC',
        'DESC'
    ]))
});
const $234d800bcbae3f2f$export$f374b5430ac28f4c = $234d800bcbae3f2f$export$7b58b3b9a7b83d61.keyof().enum;
const $234d800bcbae3f2f$export$ff67c0a0b67bb249 = [
    (queryParams)=>{
        if (queryParams.lastModified !== 'custom') {
            const { lastModified_gt: lastModified_gt, lastModified_lt: lastModified_lt, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    (queryParams)=>{
        const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt } = queryParams;
        if (lastModified_lt && lastModified_gt && lastModified_lt > lastModified_gt) {
            const { lastModified: lastModified, lastModified_gt: lastModified_gt, lastModified_lt: lastModified_lt, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    }
];
const $234d800bcbae3f2f$export$83efce6e50d7c43b = (0, $87Lnp.z).nativeEnum({
    ...$234d800bcbae3f2f$export$f3a53bd43617a593,
    ...$234d800bcbae3f2f$export$e2e108cbe2e4f865,
    ...$234d800bcbae3f2f$export$e6747eee8f26f8c0,
    ...$234d800bcbae3f2f$export$f374b5430ac28f4c
});
const $234d800bcbae3f2f$export$3d21d7040623da50 = $234d800bcbae3f2f$export$83efce6e50d7c43b.enum;
module.exports["productKeySchema"] = $234d800bcbae3f2f$export$1cbda5ccc2e23e06;
module.exports["ProductKey"] = $234d800bcbae3f2f$export$f3a53bd43617a593;
module.exports["ContentType"] = $234d800bcbae3f2f$export$e2e108cbe2e4f865;
module.exports["LastModified"] = $234d800bcbae3f2f$export$e6747eee8f26f8c0;
module.exports["searchQueryParamsBaseSchema"] = $234d800bcbae3f2f$export$7b58b3b9a7b83d61;
module.exports["searchQueryParamsValidators"] = $234d800bcbae3f2f$export$ff67c0a0b67bb249;

});

parcelRegister("9Ppk1", function(module, exports) {
const $d4998aae9877862b$var$SearchResultCompassComponent = `
... on SearchResultCompassComponent {
	lastModifiedDate
	ownerId
	tier
	component {
		description
		state
	}
}
`;
const $d4998aae9877862b$export$72cf2e1294c50ff4 = ()=>{
    return $d4998aae9877862b$var$SearchResultCompassComponent;
};
const $d4998aae9877862b$export$b8968ce5f9785283 = (partial)=>{
    return partial.__typename === 'SearchResultCompassComponent';
};
module.exports["getCompassPartials"] = $d4998aae9877862b$export$72cf2e1294c50ff4;
module.exports["isSearchCompassPartial"] = $d4998aae9877862b$export$b8968ce5f9785283;

});

parcelRegister("bzYTC", function(module, exports) {

var $5A1wD = parcelRequire("5A1wD");

/**
 * Hydrating the project avatar field causes additional latency so it is removed in this GraphQL Query
 * Investigation: https://hello.atlassian.net/wiki/x/iKKu8w
 */ const $d009c06b9bdba95e$var$SearchResultJiraProject = `
... on SearchResultJiraProject {
  projectId
  projectKey
  projectType
  lastModifiedDate
  project {
    webUrl
  }
}`;
const $d009c06b9bdba95e$export$aab3eed7c97209f8 = (partial)=>{
    return partial.__typename === 'SearchResultJiraProject';
};
const $d009c06b9bdba95e$export$1f4b5d2e43f14510 = `
... on SearchResultJiraIssue {
  id
  title
  type
  description
  url
  iconUrl
  lastModifiedDate
  status {
    id
    name
  }
  issue {
    webUrl
	key
    fieldsById(ids: ["project"]) {
      edges {
        node {
          __typename
          name
          ... on JiraProjectField {
            project {
              id
              name
			  projectType
            }
          }
        }
      }
    }
  }
  socialSignal(tenantId: $tenantId) {
	    signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
	    }
  }
  __typename
}
`;
const $d009c06b9bdba95e$export$65f412f3857c35e0 = (partial)=>{
    return {
        ...partial,
        url: partial.issue?.webUrl || partial.url
    };
};
const $d009c06b9bdba95e$export$85182d219d5a304f = (partial)=>({
        ...partial,
        url: partial.project?.webUrl || partial.url
    });
const $d009c06b9bdba95e$export$e221e36ba6e9f139 = (partial)=>{
    return partial.__typename === 'SearchResultJiraIssue';
};
const $d009c06b9bdba95e$export$9c283c2de8ddb8fb = (partial)=>{
    return partial.__typename === 'JiraProjectField' && partial.name === 'Project';
};
const $d009c06b9bdba95e$export$832b8ae8473ed171 = ``;
const $d009c06b9bdba95e$export$e0968d23c481cf04 = (partial)=>{
    return partial.__typename === 'SearchResultJiraFilter';
};
const $d009c06b9bdba95e$export$7860041bfeffea77 = ``;
const $d009c06b9bdba95e$export$3e9a71746a0d5ef1 = (partial)=>{
    return partial.__typename === 'SearchResultJiraDashboard';
};
const $d009c06b9bdba95e$export$f2ae751487c16c56 = `
... on SearchResultJiraBoard {
  boardId
  container {
		__typename
	}
  product
}
`;
const $d009c06b9bdba95e$export$98e434e98950249c = (partial)=>{
    return partial.__typename === 'SearchResultJiraBoard';
};
const $d009c06b9bdba95e$export$5a36738ca5faa27f = (partial)=>{
    return $d009c06b9bdba95e$export$aab3eed7c97209f8(partial) || $d009c06b9bdba95e$export$e221e36ba6e9f139(partial) || $d009c06b9bdba95e$export$e0968d23c481cf04(partial) || $d009c06b9bdba95e$export$3e9a71746a0d5ef1(partial) || $d009c06b9bdba95e$export$98e434e98950249c(partial);
};
const $d009c06b9bdba95e$export$d1f9da0e5c74ebcb = ()=>{
    return `
		${$d009c06b9bdba95e$var$SearchResultJiraProject}
		${$d009c06b9bdba95e$export$1f4b5d2e43f14510}
		${$d009c06b9bdba95e$export$832b8ae8473ed171}
		${$d009c06b9bdba95e$export$7860041bfeffea77}
		${$d009c06b9bdba95e$export$f2ae751487c16c56}
	`;
};
module.exports["isSearchResultJiraProject"] = $d009c06b9bdba95e$export$aab3eed7c97209f8;
module.exports["mapJiraIssuePartial"] = $d009c06b9bdba95e$export$65f412f3857c35e0;
module.exports["mapJiraProjectPartial"] = $d009c06b9bdba95e$export$85182d219d5a304f;
module.exports["isSearchResultJiraIssue"] = $d009c06b9bdba95e$export$e221e36ba6e9f139;
module.exports["isJiraProjectField"] = $d009c06b9bdba95e$export$9c283c2de8ddb8fb;
module.exports["isSearchResultJiraFilter"] = $d009c06b9bdba95e$export$e0968d23c481cf04;
module.exports["isSearchResultJiraDashboard"] = $d009c06b9bdba95e$export$3e9a71746a0d5ef1;
module.exports["isSearchResultJiraBoard"] = $d009c06b9bdba95e$export$98e434e98950249c;
module.exports["isSearchJiraPartial"] = $d009c06b9bdba95e$export$5a36738ca5faa27f;
module.exports["getJiraPartials"] = $d009c06b9bdba95e$export$d1f9da0e5c74ebcb;

});

parcelRegister("jpB6G", function(module, exports) {

var $htTgH = parcelRequire("htTgH");


var $jViGU = parcelRequire("jViGU");


var $lCzjG = parcelRequire("lCzjG");


var $37AYo = parcelRequire("37AYo");

const $d8f602ee9c16e666$export$d0fa02fe9eb5952 = {
    [(0, $lCzjG.TypeFilterValueKey).Document]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence,
            (0, $37AYo.ProductKeys).GoogleDrive,
            (0, $37AYo.ProductKeys).Sharepoint,
            (0, $37AYo.ProductKeys).OneDrive,
            (0, $37AYo.ProductKeys).Dropbox,
            (0, $37AYo.ProductKeys).Airtable,
            (0, $37AYo.ProductKeys).Notion
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:blogpost',
                'ati:cloud:confluence:page',
                'ati:cloud:confluence:attachment'
            ],
            drive: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            onedrive: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            sharepoint: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            dropbox: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            airtable: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            notion: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
        },
        subCategories: [
            (0, $lCzjG.TypeFilterValueKey).Document
        ]
    },
    [(0, $lCzjG.TypeFilterValueKey).Spreadsheet]: {
        products: [
            (0, $37AYo.ProductKeys).GoogleDrive,
            (0, $37AYo.ProductKeys).Sharepoint,
            (0, $37AYo.ProductKeys).OneDrive,
            (0, $37AYo.ProductKeys).Dropbox
        ],
        entities: {
            drive: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            onedrive: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            sharepoint: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            dropbox: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
        },
        subCategories: [
            (0, $lCzjG.TypeFilterValueKey).Spreadsheet
        ]
    },
    [(0, $lCzjG.TypeFilterValueKey).Presentation]: {
        products: [
            (0, $37AYo.ProductKeys).GoogleDrive,
            (0, $37AYo.ProductKeys).Sharepoint,
            (0, $37AYo.ProductKeys).OneDrive,
            (0, $37AYo.ProductKeys).Dropbox
        ],
        entities: {
            drive: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            onedrive: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            sharepoint: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            dropbox: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
        },
        subCategories: [
            (0, $lCzjG.TypeFilterValueKey).Presentation
        ]
    },
    [(0, $lCzjG.TypeFilterValueKey).Repository]: {
        products: [
            (0, $37AYo.ProductKeys).Bitbucket,
            (0, $37AYo.ProductKeys).Github
        ],
        entities: {
            github: [
                'ati:cloud:graph:repository'
            ],
            bitbucket: [
                'ati:cloud:graph:repository'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).PullRequest]: {
        products: [
            (0, $37AYo.ProductKeys).Bitbucket,
            (0, $37AYo.ProductKeys).Github
        ],
        entities: {
            github: [
                'ati:cloud:graph:pull-request'
            ],
            bitbucket: [
                'ati:cloud:graph:pull-request'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Branch]: {
        products: [
            (0, $37AYo.ProductKeys).Bitbucket,
            (0, $37AYo.ProductKeys).Github
        ],
        entities: {
            github: [
                'ati:cloud:graph:branch'
            ],
            bitbucket: [
                'ati:cloud:graph:branch'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Commit]: {
        products: [
            (0, $37AYo.ProductKeys).Bitbucket,
            (0, $37AYo.ProductKeys).Github
        ],
        entities: {
            github: [
                'ati:cloud:graph:commit'
            ],
            bitbucket: [
                'ati:cloud:graph:commit'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).WebPage]: {
        products: [
            (0, $37AYo.ProductKeys).AtlassianWebCrawler
        ],
        entities: {
            'atlassian-web-crawler': [
                'ati:cloud:graph:document'
            ]
        },
        subCategories: [
            (0, $lCzjG.TypeFilterValueKey).WebPage
        ]
    },
    [(0, $lCzjG.TypeFilterValueKey).Conversation]: {
        products: [
            (0, $37AYo.ProductKeys).Slack,
            (0, $37AYo.ProductKeys).Teams
        ],
        entities: {
            slack: (0, $jViGU.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
            teams: (0, $jViGU.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI)
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Message]: {
        products: [
            (0, $37AYo.ProductKeys).Slack,
            (0, $37AYo.ProductKeys).Teams
        ],
        entities: {
            slack: (0, $jViGU.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
            teams: (0, $jViGU.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI)
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Video]: {
        products: [
            (0, $37AYo.ProductKeys).Loom
        ],
        entities: {
            loom: (0, $jViGU.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI)
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Design]: {
        products: [
            (0, $37AYo.ProductKeys).Figma,
            (0, $37AYo.ProductKeys).Miro
        ],
        entities: {
            figma: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
            miro: (0, $jViGU.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI)
        },
        subCategories: [
            'file'
        ]
    },
    [(0, $lCzjG.TypeFilterValueKey).Page]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:page'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Blogpost]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:blogpost'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Attachment]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:attachment'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Space]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:space'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Comment]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:comment'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Whiteboard]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:whiteboard'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Database]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:database'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Embed]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:embed'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Folder]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:folder'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Calendar]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                (0, $jViGU.CONFLUENCE_CALENDAR_ENTITY_ATI)
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).SpaceCalendar]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                (0, $jViGU.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Question]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                (0, $jViGU.CONFLUENCE_QUESTION_ENTITY_ATI)
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Answer]: {
        products: [
            (0, $37AYo.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                (0, $jViGU.CONFLUENCE_ANSWER_ENTITY_ATI)
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Issue]: {
        products: [
            (0, $37AYo.ProductKeys).Jira,
            (0, $37AYo.ProductKeys).JiraProductDiscovery,
            (0, $37AYo.ProductKeys).JiraServiceManagement
        ],
        entities: {
            jira: [
                (0, $jViGU.JIRA_ISSUE_ENTITY_ATI)
            ],
            [(0, $37AYo.ProductKeys).JiraProductDiscovery]: [
                (0, $jViGU.JIRA_ISSUE_ENTITY_ATI)
            ],
            [(0, $37AYo.ProductKeys).JiraServiceManagement]: [
                (0, $jViGU.JIRA_ISSUE_ENTITY_ATI)
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Component]: {
        products: [
            (0, $37AYo.ProductKeys).Compass
        ],
        entities: {
            compass: [
                'ati:cloud:compass:component'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Board]: {
        products: [
            (0, $37AYo.ProductKeys).Trello
        ],
        entities: {
            trello: [
                'ati:cloud:trello:board'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Card]: {
        products: [
            (0, $37AYo.ProductKeys).Trello
        ],
        entities: {
            trello: [
                'ati:cloud:trello:card'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Project]: {
        products: [
            (0, $37AYo.ProductKeys).Jira,
            (0, $37AYo.ProductKeys).JiraProductDiscovery,
            (0, $37AYo.ProductKeys).JiraServiceManagement,
            (0, $37AYo.ProductKeys).Atlas
        ],
        entities: {
            jira: [
                (0, $jViGU.JIRA_PROJECT_ENTITY_ATI)
            ],
            [(0, $37AYo.ProductKeys).JiraProductDiscovery]: [
                (0, $jViGU.JIRA_PROJECT_ENTITY_ATI)
            ],
            [(0, $37AYo.ProductKeys).JiraServiceManagement]: [
                (0, $jViGU.JIRA_PROJECT_ENTITY_ATI)
            ],
            townsquare: [
                'ati:cloud:townsquare:project'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Goal]: {
        products: [
            (0, $37AYo.ProductKeys).Atlas
        ],
        entities: {
            townsquare: [
                'ati:cloud:townsquare:goal'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).Tag]: {
        products: [
            (0, $37AYo.ProductKeys).Atlas
        ],
        entities: {
            townsquare: [
                'ati:cloud:townsquare:tag'
            ]
        },
        subCategories: []
    },
    [(0, $lCzjG.TypeFilterValueKey).WorkItem]: {
        products: [
            (0, $37AYo.ProductKeys).Asana,
            (0, $37AYo.ProductKeys).Zendesk
        ],
        entities: {
            asana: (0, $jViGU.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            zendesk: (0, $jViGU.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI)
        },
        subCategories: []
    }
};
const $d8f602ee9c16e666$export$68b63b298725b685 = new Map([
    [
        (0, $37AYo.ProductKeys).Confluence,
        new Map([
            [
                (0, $lCzjG.TypeFilterValueKey).Document,
                [
                    'ati:cloud:confluence:blogpost',
                    'ati:cloud:confluence:page',
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Page,
                [
                    'ati:cloud:confluence:page'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Blogpost,
                [
                    'ati:cloud:confluence:blogpost'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Attachment,
                [
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Space,
                [
                    'ati:cloud:confluence:space'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Comment,
                [
                    'ati:cloud:confluence:comment'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Whiteboard,
                [
                    'ati:cloud:confluence:whiteboard'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Database,
                [
                    'ati:cloud:confluence:database'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Embed,
                [
                    'ati:cloud:confluence:embed'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Folder,
                [
                    'ati:cloud:confluence:folder'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Calendar,
                [
                    (0, $jViGU.CONFLUENCE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).SpaceCalendar,
                [
                    (0, $jViGU.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Question,
                [
                    (0, $jViGU.CONFLUENCE_QUESTION_ENTITY_ATI)
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Answer,
                [
                    (0, $jViGU.CONFLUENCE_ANSWER_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $37AYo.ProductKeys).Jira,
        new Map([
            [
                (0, $lCzjG.TypeFilterValueKey).Issue,
                [
                    (0, $jViGU.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Project,
                [
                    (0, $jViGU.JIRA_PROJECT_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $37AYo.ProductKeys).JiraProductDiscovery,
        new Map([
            [
                (0, $lCzjG.TypeFilterValueKey).Issue,
                [
                    (0, $jViGU.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Project,
                [
                    (0, $jViGU.JIRA_PROJECT_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $37AYo.ProductKeys).JiraServiceManagement,
        new Map([
            [
                (0, $lCzjG.TypeFilterValueKey).Issue,
                [
                    (0, $jViGU.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Project,
                [
                    (0, $jViGU.JIRA_PROJECT_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $37AYo.ProductKeys).Compass,
        new Map([
            [
                (0, $lCzjG.TypeFilterValueKey).Component,
                [
                    'ati:cloud:compass:component'
                ]
            ]
        ])
    ],
    [
        (0, $37AYo.ProductKeys).Trello,
        new Map([
            [
                (0, $lCzjG.TypeFilterValueKey).Board,
                [
                    'ati:cloud:trello:board'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Card,
                [
                    'ati:cloud:trello:card'
                ]
            ]
        ])
    ],
    [
        (0, $37AYo.ProductKeys).Atlas,
        new Map([
            [
                (0, $lCzjG.TypeFilterValueKey).Project,
                [
                    'ati:cloud:townsquare:project'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Goal,
                [
                    'ati:cloud:townsquare:goal'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Tag,
                [
                    'ati:cloud:townsquare:tag'
                ]
            ]
        ])
    ],
    [
        (0, $37AYo.ProductKeys).Bitbucket,
        new Map([
            [
                (0, $lCzjG.TypeFilterValueKey).Commit,
                [
                    'ati:cloud:graph:commit'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).PullRequest,
                [
                    'ati:cloud:graph:pull-request'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Repository,
                [
                    'ati:cloud:graph:repository'
                ]
            ],
            [
                (0, $lCzjG.TypeFilterValueKey).Branch,
                [
                    'ati:cloud:graph:branch'
                ]
            ]
        ])
    ]
]);
const $d8f602ee9c16e666$var$getNewTypeMapping = ()=>{
    const mappings = Object.fromEntries((0, $lCzjG.allTypeFilterValueKeys).map((TypeFilterValueKey)=>{
        const baseMapping = {
            entities: {},
            products: [],
            subCategories: []
        };
        return [
            TypeFilterValueKey,
            baseMapping
        ];
    }));
    // Add all the 1P products
    $d8f602ee9c16e666$export$68b63b298725b685.forEach((_, productKey1P)=>{
        $d8f602ee9c16e666$export$68b63b298725b685.get(productKey1P)?.forEach((_, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey1P);
            mappings[typeFilterValueKey].entities[productKey1P] = $d8f602ee9c16e666$export$68b63b298725b685.get(productKey1P)?.get(typeFilterValueKey);
        });
    });
    // Add all the 3P products
    (0, $htTgH.ThirdPartyConfigs).forEach((_, productKey3P)=>{
        const typeFilterValues3P = (0, $htTgH.ThirdPartyConfigs).get(productKey3P)?.typeFilterValues || [];
        typeFilterValues3P.forEach((typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey3P);
            mappings[typeFilterValueKey].entities[productKey3P] = (0, $lCzjG.TypeFilterTWGNounMapping).get(typeFilterValueKey)?.entities3P;
            mappings[typeFilterValueKey].subCategories = (0, $lCzjG.TypeFilterTWGNounMapping).get(typeFilterValueKey)?.subTypes3P || [];
        });
    });
    return mappings;
};
const $d8f602ee9c16e666$export$a7663ee59d66492f = ()=>$d8f602ee9c16e666$export$d0fa02fe9eb5952;
module.exports["getTypeMapping"] = $d8f602ee9c16e666$export$a7663ee59d66492f;

});

parcelRegister("ko90a", function(module, exports) {

var $6Tme9 = parcelRequire("6Tme9");

var $lowGd = parcelRequire("lowGd");

var $iTSOb = parcelRequire("iTSOb");


var $37AYo = parcelRequire("37AYo");


var $hz3c4 = parcelRequire("hz3c4");


var $fmYqM = parcelRequire("fmYqM");

const $045acf07e1b9afab$var$searchAssignee = async (query, config)=>{
    const searchClient = (0, $6Tme9.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchAssigneesResponse = await searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $lowGd.Scope).People
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const [searchAssigneeResults] = searchAssigneesResponse.response.rawData.scopes ?? [];
    const allAssignees = searchAssigneeResults.results.map((user)=>({
            picture: user.avatarUrl,
            name: user.name,
            id: `ari:cloud:identity::user/${user.id}`,
            accountId: user.id
        }));
    const userIds = new Set();
    const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId
        }));
    return assigneeOptions;
};
const $045acf07e1b9afab$var$productKeys1P = [
    (0, $37AYo.ProductKeys).Jira,
    (0, $37AYo.ProductKeys).JiraProductDiscovery,
    (0, $37AYo.ProductKeys).JiraServiceManagement
];
const $045acf07e1b9afab$var$originalProducts3P = [];
const $045acf07e1b9afab$var$products3PFromConfig = (0, $hz3c4.getProducts3PFromConfigForFilter)('assignee');
const $045acf07e1b9afab$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $045acf07e1b9afab$var$originalProducts3P;
};
const $045acf07e1b9afab$export$3dea766d36a8935f = (0, $fmYqM.createMultiSelectFilter)({
    id: 'assignee',
    products: [
        ...$045acf07e1b9afab$var$productKeys1P,
        ...$045acf07e1b9afab$var$getProducts3P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jAssignee',
        fetcher: async (queryParams, _)=>{
            const initialUsersResponse = await (0, $iTSOb.usersQuery)(queryParams);
            const allAssignees = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.id,
                    value: user.id,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return assigneeOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $045acf07e1b9afab$var$searchAssignee('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $045acf07e1b9afab$var$searchAssignee(query, config);
        }
    }
});
module.exports["filter"] = $045acf07e1b9afab$export$3dea766d36a8935f;

});

parcelRegister("hYdYN", function(module, exports) {

var $jR2a0 = parcelRequire("jR2a0");


var $7Mvs5 = parcelRequire("7Mvs5");

const $62efc92a37c62d1a$export$fe2cce9cc2f02a10 = (0, $7Mvs5.inMemoryCache)();
const $62efc92a37c62d1a$var$GQL_CF_PAGES_OPERATION_NAME = 'SearchPageConfluencePagesQuery';
const $62efc92a37c62d1a$var$getConfluencePagesQuery = ()=>`
query ${$62efc92a37c62d1a$var$GQL_CF_PAGES_OPERATION_NAME}($pageIds: [ID]!) {
  confluence {
    pages(ids: $pageIds) {
      id
      title
      type
      links {
        base
      }
    }
  }
}
`;
const $62efc92a37c62d1a$export$eeab7469706cab80 = (pageIds)=>{
    return $62efc92a37c62d1a$export$fe2cce9cc2f02a10.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    pageIds.join(','), async ()=>{
        if (pageIds.length === 0) return {
            data: {
                confluence: {
                    pages: []
                }
            }
        };
        const response = await (0, $jR2a0.fetchAgg)({
            graphQuery: $62efc92a37c62d1a$var$getConfluencePagesQuery(),
            variables: {
                pageIds: pageIds
            },
            operationName: $62efc92a37c62d1a$var$GQL_CF_PAGES_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};


var $9wFje = parcelRequire("9wFje");


var $37AYo = parcelRequire("37AYo");


var $hz3c4 = parcelRequire("hz3c4");


var $aXw0m = parcelRequire("aXw0m");

const $61fc91ab1240cc19$var$getContentId = (ari)=>{
    const EXTRACT_ID = /ari:.*?:.*?:.*?:.*?\/(.*)?.*/;
    const matches = ari.match(EXTRACT_ID);
    // content id of the ari
    return matches && matches.length > 1 ? matches[1] : '';
};
const $61fc91ab1240cc19$var$searchContent = async (query, config)=>{
    const location = `ari:cloud:confluence::site/${config.cloudId}`;
    const contentPagesResponse = await (0, $9wFje.searchEntitiesQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            query: query,
            first: 10,
            filters: {
                entities: [
                    'ati:cloud:confluence:page'
                ],
                locations: [
                    location
                ]
            }
        }
    });
    const allContentPages = contentPagesResponse.data?.search?.results.edges.map((content)=>({
            title: content.node.title,
            id: content.node.id
        })) || [];
    const contentOptions = allContentPages.map((content)=>{
        const contentId = $61fc91ab1240cc19$var$getContentId(content.id);
        return {
            trackingKey: contentId,
            value: contentId,
            label: content.title,
            queryParamValue: contentId
        };
    });
    return contentOptions;
};
const $61fc91ab1240cc19$var$productKeys1P = [
    (0, $37AYo.ProductKeys).Confluence
];
const $61fc91ab1240cc19$var$originalProducts3P = [];
const $61fc91ab1240cc19$var$products3PFromConfig = (0, $hz3c4.getProducts3PFromConfigForFilter)('content');
const $61fc91ab1240cc19$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $61fc91ab1240cc19$var$originalProducts3P;
};
const $61fc91ab1240cc19$export$3dea766d36a8935f = (0, $aXw0m.createSingleSelectFilter)({
    id: 'content',
    products: [
        ...$61fc91ab1240cc19$var$productKeys1P,
        ...$61fc91ab1240cc19$var$getProducts3P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'ancestor',
        fetcher: async (queryParams, config)=>{
            const initialContentARIs = queryParams.map((contentId)=>`ari:cloud:confluence:${config.cloudId}:page/${contentId}`);
            const initialContentResponse = await (0, $62efc92a37c62d1a$export$eeab7469706cab80)(initialContentARIs);
            const allContentPages = initialContentResponse.data?.confluence.pages.map((page)=>({
                    title: page.title,
                    id: page.id
                })) || [];
            const contentOptions = allContentPages.map((content)=>{
                const contentId = $61fc91ab1240cc19$var$getContentId(content.id);
                return {
                    trackingKey: contentId,
                    value: contentId,
                    label: content.title,
                    queryParamValue: contentId
                };
            });
            return contentOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $61fc91ab1240cc19$var$searchContent('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $61fc91ab1240cc19$var$searchContent(query, config);
        }
    }
});
module.exports["filter"] = $61fc91ab1240cc19$export$3dea766d36a8935f;

});

parcelRegister("bPX0r", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $d019604066435456$export$f63f2da3517cdf9c = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'contributors',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};


var $kv3qA = parcelRequire("kv3qA");

var $iTSOb = parcelRequire("iTSOb");


var $37AYo = parcelRequire("37AYo");


var $hz3c4 = parcelRequire("hz3c4");


var $fmYqM = parcelRequire("fmYqM");

const $28c8ecedf2391b53$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $28c8ecedf2391b53$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $28c8ecedf2391b53$var$loadRecommendedContributor = async (config)=>{
    const initialUsersQuery = (0, $iTSOb.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : [] // The current user should always be the first recommended user
    ]);
    const recommendedUserQuery = (0, $kv3qA.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $28c8ecedf2391b53$var$MAX_SMART_DEFAULT_OPTIONS
        }
    });
    const [initialUsersReponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersReponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId
        }));
    return recommendedUserOptions;
};
// fg('universal-contributor-filter') => false
const $28c8ecedf2391b53$var$isUniversalContributorFilter = false;
// Filter out Trello for milestone 1 (QS-4733)
const $28c8ecedf2391b53$var$productKeys1P = $28c8ecedf2391b53$var$isUniversalContributorFilter ? (0, $37AYo.all1pProductKeys).filter((key)=>key !== (0, $37AYo.ProductKeys).Trello) : [
    (0, $37AYo.ProductKeys).Confluence
];
const $28c8ecedf2391b53$var$originalProducts3P = [];
const $28c8ecedf2391b53$var$products3PFromConfig = (0, $hz3c4.getProducts3PFromConfigForFilter)('contributor');
const $28c8ecedf2391b53$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $28c8ecedf2391b53$var$originalProducts3P;
};
const $28c8ecedf2391b53$export$3dea766d36a8935f = (0, $fmYqM.createMultiSelectFilter)({
    id: 'contributor',
    // 1P only for now (excluding Trello)
    products: [
        ...$28c8ecedf2391b53$var$productKeys1P,
        ...$28c8ecedf2391b53$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: $28c8ecedf2391b53$var$isUniversalContributorFilter,
    queryParams: {
        key: 'contributors',
        fetcher: async (queryParams, _)=>{
            const initialUsersReponse = await (0, $iTSOb.usersQuery)([
                ...queryParams
            ]);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $28c8ecedf2391b53$var$loadRecommendedContributor(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query contributors with intl
            const response = await (0, $d019604066435456$export$f63f2da3517cdf9c)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $37AYo.ProductKeys).Confluence,
                maxNumberOfResults: $28c8ecedf2391b53$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) // TODO: log not found somewhere
            return [];
            return response.map((contributor)=>({
                    trackingKey: contributor.id,
                    value: contributor.id,
                    label: contributor.name,
                    avatarUrl: contributor.avatarUrl,
                    queryParamValue: contributor.id
                }));
        }
    }
});
module.exports["filter"] = $28c8ecedf2391b53$export$3dea766d36a8935f;

});

parcelRegister("h4cPw", function(module, exports) {

var $jR2a0 = parcelRequire("jR2a0");


var $7Mvs5 = parcelRequire("7Mvs5");

const $32d699b18e5e1d6d$export$a8f449a3d81f3a4c = (0, $7Mvs5.inMemoryCache)();
const $32d699b18e5e1d6d$var$GQL_CF_LABEL_OPERATION_NAME = 'SearchLabelsQuery';
const $32d699b18e5e1d6d$var$getConfluenceLabelsQuery = ()=>`
query ${$32d699b18e5e1d6d$var$GQL_CF_LABEL_OPERATION_NAME}($cloudId: ID! $searchText: String!, $limit: Int) {
  confluence {
    searchLabels(cloudId: $cloudId, searchText: $searchText, limit: $limit) @optIn(to: "ConfluenceExperimentalSearchLabels") {
	  otherLabels {
        label
      }
      suggestedLabels {
        label
      }
    }
  }
}
`;
const $32d699b18e5e1d6d$export$b9ea4761dac8a473 = (cloudId, searchText, limit)=>{
    return $32d699b18e5e1d6d$export$a8f449a3d81f3a4c.inMemoryDecorator(searchText, async ()=>{
        const response = await (0, $jR2a0.fetchAgg)({
            graphQuery: $32d699b18e5e1d6d$var$getConfluenceLabelsQuery(),
            variables: {
                cloudId: cloudId,
                searchText: searchText,
                limit: limit
            },
            operationName: $32d699b18e5e1d6d$var$GQL_CF_LABEL_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};



var $37AYo = parcelRequire("37AYo");


var $hz3c4 = parcelRequire("hz3c4");


var $fmYqM = parcelRequire("fmYqM");

const $2c922f8036fc1f5c$var$productKeys1P = [
    (0, $37AYo.ProductKeys).Confluence
];
const $2c922f8036fc1f5c$var$originalProducts3P = [];
const $2c922f8036fc1f5c$var$products3PFromConfig = (0, $hz3c4.getProducts3PFromConfigForFilter)('label');
const $2c922f8036fc1f5c$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $2c922f8036fc1f5c$var$originalProducts3P;
};
const $2c922f8036fc1f5c$export$3dea766d36a8935f = (0, $fmYqM.createMultiSelectFilter)({
    id: 'label',
    products: [
        ...$2c922f8036fc1f5c$var$productKeys1P,
        ...$2c922f8036fc1f5c$var$getProducts3P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'labels',
        fetcher: async (queryParams, _)=>{
            return queryParams.map((label)=>({
                    trackingKey: label,
                    value: label,
                    queryParamValue: label,
                    label: label
                }));
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query contributors with intl
            if (config.cloudId === undefined) return [];
            const initialLabelsResponse = await (0, $32d699b18e5e1d6d$export$b9ea4761dac8a473)(config.cloudId, query, 10);
            const suggestedLabels = initialLabelsResponse.data?.confluence.searchLabels.suggestedLabels || [];
            const otherLabels = initialLabelsResponse.data?.confluence.searchLabels.otherLabels || [];
            return [
                ...suggestedLabels,
                ...otherLabels
            ].map((label)=>({
                    trackingKey: label.label || '',
                    value: label.label || '',
                    queryParamValue: label.label || '',
                    label: label.label || ''
                })) ?? [];
        }
    }
});
module.exports["filter"] = $2c922f8036fc1f5c$export$3dea766d36a8935f;

});

parcelRegister("bkXhB", function(module, exports) {

var $37AYo = parcelRequire("37AYo");


var $3Q5mv = parcelRequire("3Q5mv");


var $hz3c4 = parcelRequire("hz3c4");


var $lCzjG = parcelRequire("lCzjG");


var $iueFH = parcelRequire("iueFH");

const $93969177520e6f95$export$711b0a1d273f9525 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMount: false,
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$93969177520e6f95$export$44d389225cc01eb5({
                initial: initial,
                state: state,
                config: // This has to be cast back to the correct state
                config
            }),
        getInitialState: (config)=>$93969177520e6f95$export$44d389225cc01eb5({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (filterState)=>{
            return filterState?.id === initial.id;
        },
        isSupportCustomValue: true
    };
};
const $93969177520e6f95$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const options = $93969177520e6f95$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        });
        const selectedOptions = options.filter((option)=>option.isSelected);
        const queryParamValue = selectedOptions.map((option)=>option.queryParamValue);
        const isCustomOptionSelected = selectedOptions.find((option)=>option.value === (0, $lCzjG.CUSTOM_OPTION_VALUE));
        const customValueQueryParam = isCustomOptionSelected && state.customValue ? state.customValue : {};
        return {
            [initial.queryParams.key]: queryParamValue,
            ...customValueQueryParam
        };
    };
};
const $93969177520e6f95$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $93969177520e6f95$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const isCustomOptionSelected = newOptions.find((option)=>option.value === (0, $lCzjG.CUSTOM_OPTION_VALUE))?.isSelected;
            const customValueParser = initial.queryParams.customValueParser;
            let customValue;
            if (isCustomOptionSelected) {
                if (customValueParser) customValue = customValueParser(queryParams);
                else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                        ...acc,
                        [field]: queryParams[field]?.at(0) ?? ''
                    }), {}) : {};
            }
            const filterWithNewOptions = filter.setOption(newOptions, customValue);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const hydratedQueryParams = $93969177520e6f95$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                }
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $93969177520e6f95$export$44d389225cc01eb5 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $iueFH.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $93969177520e6f95$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $93969177520e6f95$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $iueFH.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $93969177520e6f95$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $iueFH.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $iueFH.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iueFH.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $iueFH.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $iueFH.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $93969177520e6f95$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.selectedOption ? props.selectedOption.value === option.value : option.isSelected
        };
    };
const $93969177520e6f95$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option, customValue)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const selectedOption = optionsToChange.filter((o)=>o.isSelected).at(0);
        const queryParamOptions = state.queryParams.options.map($93969177520e6f95$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const initialOptions = state.initialOptions.options.map($93969177520e6f95$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($93969177520e6f95$var$updateOptionState({
            selectedOption: selectedOption
        }));
        return $93969177520e6f95$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                },
                customValue: customValue
            },
            config: config
        });
    };
};



var $kSwu1 = parcelRequire("kSwu1");

const $982250c93a172175$export$3f164da8f895a853 = (0, $kSwu1.defineMessages)({
    anytime: {
        id: "dynamic-cards-search-page.filter.last.updated.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "dynamic-cards-search-page.filter.last.updated.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "dynamic-cards-search-page.filter.last.updated.yesterday",
        defaultMessage: "Yesterday"
    },
    past7Days: {
        id: "dynamic-cards-search-page.filter.last.updated.past7Days",
        defaultMessage: "Past 7 days"
    },
    past30Days: {
        id: "dynamic-cards-search-page.filter.last.updated.past30Days",
        defaultMessage: "Past 30 days"
    },
    pastYear: {
        id: "dynamic-cards-search-page.filter.last.updated.pastYear",
        defaultMessage: "Past year"
    },
    custom: {
        id: "dynamic-cards-search-page.filter.last.updated.costum",
        defaultMessage: "Custom"
    }
});


const $e06058f0d16d6e0d$var$LAST_UPDATED_VALUES = [
    'today',
    'yesterday',
    'past7Days',
    'past30Days',
    'pastYear',
    'custom'
];
const $e06058f0d16d6e0d$var$sortCompareFn = (a, b)=>{
    return $e06058f0d16d6e0d$var$LAST_UPDATED_VALUES.indexOf(a.value) - $e06058f0d16d6e0d$var$LAST_UPDATED_VALUES.indexOf(b.value);
};
const $e06058f0d16d6e0d$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $e06058f0d16d6e0d$var$getLastUpdatedValue = ()=>{
    // fg('rovo-custom-date-range-picker') => true
    const isCustomRangePickEnabled = true;
    return $e06058f0d16d6e0d$var$LAST_UPDATED_VALUES.filter((value)=>{
        if (value === 'custom') return isCustomRangePickEnabled;
        return true;
    });
};
const $e06058f0d16d6e0d$var$productKeys1P = [
    (0, $37AYo.ProductKeys).Atlas,
    (0, $37AYo.ProductKeys).Confluence,
    (0, $37AYo.ProductKeys).Jira,
    (0, $37AYo.ProductKeys).JiraProductDiscovery,
    (0, $37AYo.ProductKeys).JiraServiceManagement,
    (0, $37AYo.ProductKeys).Compass
];
const $e06058f0d16d6e0d$var$originalProducts3P = [
    (0, $37AYo.ProductKeys).Figma,
    (0, $37AYo.ProductKeys).Github,
    (0, $37AYo.ProductKeys).GoogleDrive,
    (0, $37AYo.ProductKeys).Loom,
    (0, $37AYo.ProductKeys).OneDrive,
    (0, $37AYo.ProductKeys).Slack,
    (0, $37AYo.ProductKeys).Sharepoint,
    (0, $37AYo.ProductKeys).Teams,
    (0, $37AYo.ProductKeys).Dropbox
];
const $e06058f0d16d6e0d$var$products3PFromConfig = (0, $hz3c4.getProducts3PFromConfigForFilter)('lastUpdated');
const $e06058f0d16d6e0d$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $e06058f0d16d6e0d$var$originalProducts3P;
};
const $e06058f0d16d6e0d$export$3dea766d36a8935f = (0, $93969177520e6f95$export$711b0a1d273f9525)({
    id: 'lastUpdated',
    products: [
        ...$e06058f0d16d6e0d$var$productKeys1P,
        ...$e06058f0d16d6e0d$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'lastModified',
        fetcher: async (_, config)=>{
            return $e06058f0d16d6e0d$var$getLastUpdatedValue().map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $982250c93a172175$export$3f164da8f895a853)[value]) || (0, $982250c93a172175$export$3f164da8f895a853)[value].defaultMessage,
                    value: value,
                    queryParamValue: value
                }));
        },
        customValueParser: (queryParams)=>{
            const { to: to, from: from } = queryParams;
            const isToDateValid = $e06058f0d16d6e0d$var$isIsoDate(to?.[0]);
            const isFromDateValid = $e06058f0d16d6e0d$var$isIsoDate(from?.[0]);
            const toDate = isToDateValid && to?.[0] ? to?.[0] : '';
            const fromDate = isFromDateValid && from?.[0] ? from?.[0] : '';
            const invalidDateRange = (0, $hz3c4.getInvalidDateRange)(fromDate, toDate);
            if (!invalidDateRange) return {
                to: toDate,
                from: fromDate
            };
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: 'anytime',
                    label: config.intl?.formatMessage((0, $982250c93a172175$export$3f164da8f895a853)['anytime']) || (0, $982250c93a172175$export$3f164da8f895a853)['anytime'].defaultMessage,
                    value: 'anytime',
                    isDefault: true,
                    queryParamValue: (0, $3Q5mv.LastModified).Anytime
                },
                ...$e06058f0d16d6e0d$var$getLastUpdatedValue().map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $982250c93a172175$export$3f164da8f895a853)[value]) || (0, $982250c93a172175$export$3f164da8f895a853)[value].defaultMessage,
                        value: value,
                        queryParamValue: value
                    }))
            ];
        }
    },
    sortCompareFn: $e06058f0d16d6e0d$var$sortCompareFn,
    customValueFields: [
        'to',
        'from'
    ]
});
module.exports["filter"] = $e06058f0d16d6e0d$export$3dea766d36a8935f;

});

parcelRegister("7ayyq", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $d69693c749bf2cfd$export$148de59b68ce26ae = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'owners',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};


var $kv3qA = parcelRequire("kv3qA");

var $iTSOb = parcelRequire("iTSOb");


var $37AYo = parcelRequire("37AYo");


var $hz3c4 = parcelRequire("hz3c4");


var $fmYqM = parcelRequire("fmYqM");

const $27d377a32c4fa3d0$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $27d377a32c4fa3d0$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $27d377a32c4fa3d0$var$loadRecommendedOwner = async (config)=>{
    const initialUsersQuery = (0, $iTSOb.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : [] // The current user should always be the first recommended user
    ]);
    const recommendedUserQuery = (0, $kv3qA.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $27d377a32c4fa3d0$var$MAX_SMART_DEFAULT_OPTIONS
        }
    });
    const [initialUsersResponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersResponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId
        }));
    return recommendedUserOptions;
};
const $27d377a32c4fa3d0$var$productKeys1P = [
    (0, $37AYo.ProductKeys).Confluence
];
const $27d377a32c4fa3d0$var$originalProducts3P = [];
const $27d377a32c4fa3d0$var$products3PFromConfig = (0, $hz3c4.getProducts3PFromConfigForFilter)('owner');
const $27d377a32c4fa3d0$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $27d377a32c4fa3d0$var$originalProducts3P;
};
const $27d377a32c4fa3d0$export$3dea766d36a8935f = (0, $fmYqM.createMultiSelectFilter)({
    id: 'owner',
    products: [
        ...$27d377a32c4fa3d0$var$productKeys1P,
        ...$27d377a32c4fa3d0$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'owners',
        fetcher: async (queryParams, _)=>{
            const initialUsersReponse = await (0, $iTSOb.usersQuery)([
                ...queryParams
            ]);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $27d377a32c4fa3d0$var$loadRecommendedOwner(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return [];
            const response = await (0, $d69693c749bf2cfd$export$148de59b68ce26ae)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $37AYo.ProductKeys).Confluence,
                maxNumberOfResults: $27d377a32c4fa3d0$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) // TODO: log not found somewhere
            return [];
            return response.map((owner)=>({
                    trackingKey: owner.id,
                    value: owner.id,
                    label: owner.name,
                    avatarUrl: owner.avatarUrl,
                    queryParamValue: owner.id
                }));
        }
    }
});
module.exports["filter"] = $27d377a32c4fa3d0$export$3dea766d36a8935f;

});

parcelRegister("10JkG", function(module, exports) {

var $6Tme9 = parcelRequire("6Tme9");

var $jR2a0 = parcelRequire("jR2a0");


var $7Mvs5 = parcelRequire("7Mvs5");

const $6e6af2773f89a542$export$56d694fb8fe349ab = (0, $7Mvs5.inMemoryCache)();
const $6e6af2773f89a542$var$GQL_JIRA_PROJECTS_OPERATION_NAME = 'SearchPageJiraProjectQuery';
const $6e6af2773f89a542$var$jiraProjectsQueryString = `query ${$6e6af2773f89a542$var$GQL_JIRA_PROJECTS_OPERATION_NAME}($projectIds: [ID!]!) {
  jira {
    jiraProjects(ids: $projectIds) {
			projectId
      name
      avatar {
        small
      }
    }
  }
}`;
const $6e6af2773f89a542$export$fd1d4a933080bfe2 = (projectIds)=>{
    return $6e6af2773f89a542$export$56d694fb8fe349ab.inMemoryDecorator(projectIds.join(','), async ()=>{
        if (projectIds.length === 0) return {
            data: {
                jira: {
                    jiraProjects: []
                }
            }
        };
        const response = await (0, $jR2a0.fetchAgg)({
            graphQuery: $6e6af2773f89a542$var$jiraProjectsQueryString,
            variables: {
                projectIds: projectIds
            },
            operationName: $6e6af2773f89a542$var$GQL_JIRA_PROJECTS_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return $6e6af2773f89a542$var$filterProjectsWithoutId(response);
    });
};
const $6e6af2773f89a542$var$filterProjectsWithoutId = (response)=>{
    const filteredProjects = response.data?.jira.jiraProjects?.filter((project)=>project.projectId);
    return {
        ...response,
        data: {
            jira: {
                jiraProjects: filteredProjects
            }
        }
    };
};


var $lowGd = parcelRequire("lowGd");


var $37AYo = parcelRequire("37AYo");


var $hz3c4 = parcelRequire("hz3c4");


var $fmYqM = parcelRequire("fmYqM");

const $e469585672e2728a$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $e469585672e2728a$var$searchProject = async (query, config)=>{
    const searchClient = (0, $6Tme9.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchProjectsResponse = await searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $lowGd.Scope).JiraProject
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const searchedProjects = searchProjectsResponse.response.rawData.scopes.length > 0 ? searchProjectsResponse.response.rawData.scopes[0].results.map((projectResult)=>({
            projectId: projectResult.id,
            name: projectResult.name,
            avatar: {
                small: 'url' in projectResult.attributes.avatar ? projectResult.attributes.avatar.url : undefined
            }
        })) : [];
    const allProjects = searchedProjects;
    const projectOptions = allProjects.map((project)=>({
            trackingKey: $e469585672e2728a$var$projectIdToARI(config.cloudId || '', project.projectId),
            value: $e469585672e2728a$var$projectIdToARI(config.cloudId || '', project.projectId),
            label: project.name,
            avatarUrl: project.avatar?.small,
            queryParamValue: project.projectId
        }));
    return projectOptions;
};
const $e469585672e2728a$var$productKeys1P = [
    (0, $37AYo.ProductKeys).Jira,
    (0, $37AYo.ProductKeys).JiraProductDiscovery,
    (0, $37AYo.ProductKeys).JiraServiceManagement
];
const $e469585672e2728a$var$originalProducts3P = [];
const $e469585672e2728a$var$products3PFromConfig = (0, $hz3c4.getProducts3PFromConfigForFilter)('project');
const $e469585672e2728a$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $e469585672e2728a$var$originalProducts3P;
};
const $e469585672e2728a$export$3dea766d36a8935f = (0, $fmYqM.createMultiSelectFilter)({
    id: 'project',
    products: [
        ...$e469585672e2728a$var$productKeys1P,
        ...$e469585672e2728a$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'jProject',
        fetcher: async (queryParams, config)=>{
            const initialProjectARIs = queryParams.map((projectId)=>$e469585672e2728a$var$projectIdToARI(config.cloudId || '', projectId));
            const initialProjectsResponse = await (0, $6e6af2773f89a542$export$fd1d4a933080bfe2)(initialProjectARIs);
            const initialProjects = initialProjectsResponse.data?.jira.jiraProjects ?? [];
            const allProjects = initialProjects;
            const projectOptions = allProjects.map((project)=>({
                    trackingKey: $e469585672e2728a$var$projectIdToARI(config.cloudId || '', project.projectId),
                    value: $e469585672e2728a$var$projectIdToARI(config.cloudId || '', project.projectId),
                    label: project.name,
                    avatarUrl: project.avatar?.small,
                    queryParamValue: project.projectId
                }));
            return projectOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $e469585672e2728a$var$searchProject('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $e469585672e2728a$var$searchProject(query, config);
        }
    }
});
module.exports["filter"] = $e469585672e2728a$export$3dea766d36a8935f;

});

parcelRegister("lBu63", function(module, exports) {

var $jR2a0 = parcelRequire("jR2a0");


var $7Mvs5 = parcelRequire("7Mvs5");

const $661dfac3d9a92c31$export$f400862b5c7e6c62 = (0, $7Mvs5.inMemoryCache)();
const $661dfac3d9a92c31$var$GQL_CF_SPACES_OPERATION_NAME = 'SearchPageConfluenceSpacesQuery';
const $661dfac3d9a92c31$var$getConfluenceSpacesQuery = ()=>`
query ${$661dfac3d9a92c31$var$GQL_CF_SPACES_OPERATION_NAME}($spaceIds: [ID]!) {
  confluence {
    spaces(ids: $spaceIds) {
      id
      spaceId
      name
      key
      links {
        base
      }
      icon {
        path
      }
    }
  }
}
`;
const $661dfac3d9a92c31$export$d8fbf668d55936f8 = (spaceIds)=>{
    return $661dfac3d9a92c31$export$f400862b5c7e6c62.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    spaceIds.join(','), async ()=>{
        if (spaceIds.length === 0) return {
            data: {
                confluence: {
                    spaces: []
                }
            }
        };
        const response = await (0, $jR2a0.fetchAgg)({
            graphQuery: $661dfac3d9a92c31$var$getConfluenceSpacesQuery(),
            variables: {
                spaceIds: spaceIds
            },
            operationName: $661dfac3d9a92c31$var$GQL_CF_SPACES_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};


var $9wFje = parcelRequire("9wFje");




var $7tsC5 = parcelRequire("7tsC5");




const $130caa595895c3ab$var$operationName = 'SmartsRecommendedContainerQuery';
const $130caa595895c3ab$var$SmartsRecommendedContainerQuery = `
query ${$130caa595895c3ab$var$operationName}($userId: String!, $tenantId: String!) {
  smarts {
    results: recommendedContainer(
      recommendationsQuery: {
        context: {
          userId: $userId,
          tenantId: $tenantId,
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search",
          experience: "CgContainerNearbyUser"
        },
        requestingUserId: $userId
      }
    ) {
      id
      score
      container {
        createdDate
        id
        key
        name
        spaceId
        status
        type
        links {
          base
        }
        icon {
          path
        }
      }
    }
  }
}
`;
const $130caa595895c3ab$export$69a3209f1a06c04d = (0, $7Mvs5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $130caa595895c3ab$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $130caa595895c3ab$export$9d6625cf80401405 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>$130caa595895c3ab$export$69a3209f1a06c04d.inMemoryDecorator((0, $7tsC5.generateHashFromVariables)(variables), ()=>(0, $jR2a0.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $130caa595895c3ab$var$SmartsRecommendedContainerQuery,
            operationName: $130caa595895c3ab$var$operationName
        }), $130caa595895c3ab$var$expireWhen);



var $37AYo = parcelRequire("37AYo");


var $hz3c4 = parcelRequire("hz3c4");


var $fmYqM = parcelRequire("fmYqM");

const $d50f1e04383ea3f6$var$productKeys1P = [
    (0, $37AYo.ProductKeys).Confluence
];
const $d50f1e04383ea3f6$var$originalProducts3P = [];
const $d50f1e04383ea3f6$var$products3PFromConfig = (0, $hz3c4.getProducts3PFromConfigForFilter)('space');
const $d50f1e04383ea3f6$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $d50f1e04383ea3f6$var$originalProducts3P;
};
const $d50f1e04383ea3f6$export$3dea766d36a8935f = (0, $fmYqM.createMultiSelectFilter)({
    id: 'space',
    products: [
        ...$d50f1e04383ea3f6$var$productKeys1P,
        ...$d50f1e04383ea3f6$var$getProducts3P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'spaces',
        fetcher: async (_, config)=>{
            // use initial space ARIs from config as we can not directly use space value in queryParams
            const initialSpacesResponse = await (0, $661dfac3d9a92c31$export$d8fbf668d55936f8)(config.initialSpaceARIs || []);
            const allRecommendedSpaces = initialSpacesResponse.data?.confluence.spaces.map((space)=>({
                    key: space.key,
                    name: space.name,
                    ari: space.id,
                    avatarUrl: space.links?.base && space.icon?.path ? `${space.links.base}${space.icon.path}` : ''
                })) || [];
            return allRecommendedSpaces.map((space)=>({
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || ''
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const recommendedSpacesResponse = await (0, $130caa595895c3ab$export$9d6625cf80401405)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    userId: config.userId || '',
                    tenantId: config.cloudId || ''
                }
            });
            const allRecommendedSpaces = recommendedSpacesResponse.data?.smarts.results?.flatMap(({ container: container })=>{
                if (!(container && container.key)) return [];
                return [
                    {
                        key: container.key,
                        name: container.name,
                        ari: container.id,
                        avatarUrl: container.links?.base && container.icon?.path ? `${container.links.base}${container.icon.path}` : ''
                    }
                ];
            }) || [];
            const recommendedSpaceOptions = allRecommendedSpaces.map((space)=>{
                return {
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || ''
                };
            });
            return recommendedSpaceOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            const response = await (0, $9wFje.searchEntitiesQuery)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    query: query,
                    first: 15,
                    filters: {
                        entities: [
                            'ati:cloud:confluence:space'
                        ],
                        locations: [
                            `ari:cloud:confluence::site/${config.cloudId}`
                        ]
                    },
                    experience: 'full-page-search-space-filter'
                },
                includeSpaceKey: true
            });
            const { data: data } = response;
            if (!data) return [];
            return data.search?.results.edges.map(({ node: node })=>({
                    trackingKey: node.id || '',
                    value: node.key || '',
                    queryParamValue: node.key ?? '',
                    avatarUrl: node.iconUrl || undefined,
                    label: node.title
                })) ?? [];
        }
    }
});
module.exports["filter"] = $d50f1e04383ea3f6$export$3dea766d36a8935f;

});

parcelRegister("cqf3V", function(module, exports) {

var $37AYo = parcelRequire("37AYo");


var $hz3c4 = parcelRequire("hz3c4");


var $2Pix2 = parcelRequire("2Pix2");

const $86b62327dda4af9e$var$productKeys1P = [];
const $86b62327dda4af9e$var$originalProducts3P = [
    (0, $37AYo.ProductKeys).GoogleDrive,
    (0, $37AYo.ProductKeys).Sharepoint,
    (0, $37AYo.ProductKeys).Dropbox,
    (0, $37AYo.ProductKeys).GoogleCalendar,
    (0, $37AYo.ProductKeys).OneDrive
];
const $86b62327dda4af9e$var$products3PFromConfig = (0, $hz3c4.getProducts3PFromConfigForFilter)('onlyTitleMatch');
const $86b62327dda4af9e$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $86b62327dda4af9e$var$originalProducts3P;
};
const $86b62327dda4af9e$export$3dea766d36a8935f = (0, $2Pix2.createBooleanFilter)({
    id: 'onlyTitleMatch',
    queryParams: {
        key: 'titleMatch'
    },
    products: [
        ...$86b62327dda4af9e$var$productKeys1P,
        ...$86b62327dda4af9e$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $86b62327dda4af9e$export$3dea766d36a8935f;

});

parcelRegister("5EzaL", function(module, exports) {

var $37AYo = parcelRequire("37AYo");


var $hz3c4 = parcelRequire("hz3c4");


var $2Pix2 = parcelRequire("2Pix2");

const $8c42c689c26ee25d$var$productKeys1P = [
    (0, $37AYo.ProductKeys).Confluence
];
const $8c42c689c26ee25d$var$originalProducts3P = [];
const $8c42c689c26ee25d$var$products3PFromConfig = (0, $hz3c4.getProducts3PFromConfigForFilter)('verified');
const $8c42c689c26ee25d$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $8c42c689c26ee25d$var$originalProducts3P;
};
const $8c42c689c26ee25d$export$3dea766d36a8935f = (0, $2Pix2.createBooleanFilter)({
    id: 'verified',
    queryParams: {
        key: 'verified'
    },
    products: [
        ...$8c42c689c26ee25d$var$productKeys1P,
        ...$8c42c689c26ee25d$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $8c42c689c26ee25d$export$3dea766d36a8935f;

});

parcelRegister("gbbjP", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $37AYo = parcelRequire("37AYo");


var $aXw0m = parcelRequire("aXw0m");


var $gIjvj = parcelRequire("gIjvj");

const $cae08e4d8763692b$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $gIjvj.getAllTypeOptions)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault
        }));
};
const $cae08e4d8763692b$var$getInitialOptions = (config)=>{
    const allOptions = (0, $gIjvj.getAllTypeOptions)(config);
    return allOptions.map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault
        }));
};
const $cae08e4d8763692b$var$sortCompareFn = (a, b)=>{
    const allOption = (0, $gIjvj.getAllTypeOptions)({
        intl: undefined
    });
    return allOption.findIndex((option)=>option.queryParamValue === a.queryParamValue) - allOption.findIndex((option)=>option.queryParamValue === b.queryParamValue);
};
const $cae08e4d8763692b$export$3dea766d36a8935f = (0, $aXw0m.createSingleSelectFilter)({
    id: (0, $lCzjG.universalTypeFilterId),
    products: (0, $37AYo.allProductKeys),
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'type',
        fetcher: async (queryParams, config)=>{
            return $cae08e4d8763692b$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $cae08e4d8763692b$var$getInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            // NOTE: this is the first step of filtering options
            //  the store does product specific filtering
            return (0, $gIjvj.lookupOptions)(query, config);
        }
    },
    sortCompareFn: $cae08e4d8763692b$var$sortCompareFn
});
module.exports["filter"] = $cae08e4d8763692b$export$3dea766d36a8935f;

});

parcelRegister("4ut97", function(module, exports) {
const $248c347f59375e13$var$SearchDefaultResultAtlas = ``;
const $248c347f59375e13$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    key
    state {
      label
      value
    }
    dueDate {
      label
    }
  }
}
`;
const $248c347f59375e13$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    description
    key
    status {
      localizedLabel {
        messageId
      }
    }
    targetDate {
      label
    }
  }
}
`;
const $248c347f59375e13$export$1724df33341798e0 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasProject';
};
const $248c347f59375e13$export$1d556a3125797ca6 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasGoal';
};
const $248c347f59375e13$export$bff995b1cea89df3 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasTag';
};
const $248c347f59375e13$export$aa63de26c950cf0f = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchDefaultResult';
};
const $248c347f59375e13$export$750af6f011d7ee10 = (partial)=>{
    return $248c347f59375e13$export$1d556a3125797ca6(partial) || $248c347f59375e13$export$1724df33341798e0(partial) || $248c347f59375e13$export$bff995b1cea89df3(partial) || $248c347f59375e13$export$aa63de26c950cf0f(partial);
};
const $248c347f59375e13$export$272c689528faac47 = ()=>{
    return `
		${$248c347f59375e13$var$SearchResultAtlasGoal}
		${$248c347f59375e13$var$SearchResultAtlasProject}
		${$248c347f59375e13$var$SearchDefaultResultAtlas}
	`;
};
module.exports["isSearchResultAtlasProjectPartial"] = $248c347f59375e13$export$1724df33341798e0;
module.exports["isSearchResultAtlasGoalPartial"] = $248c347f59375e13$export$1d556a3125797ca6;
module.exports["isSearchAtlasPartial"] = $248c347f59375e13$export$750af6f011d7ee10;
module.exports["getAtlasPartials"] = $248c347f59375e13$export$272c689528faac47;

});

parcelRegister("lqSug", function(module, exports) {
const $2ecd498b970d7c17$var$SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
	lastModified
	isVerified
	space {
		id
		name
		webUiLink
	}
	__typename
	confluenceEntity {
		... on ConfluencePage {
			subtype
			properties(keys: ["cover-picture-id-published", "cover-picture-id-draft"]) {
				key
				value
			}
			ancestors {
				id
				title
				links {
					webUi
				}
			}
			metadata {
				titleEmojiPublished {
					id
					value
				}
			}
			commentCountSummary {
				total
			}
			likesSummary {
				count
			}
		}
		... on ConfluenceBlogPost {
			properties(keys: ["cover-picture-id-published", "cover-picture-id-draft"]) {
				key
				value
			}
			metadata {
				titleEmojiPublished {
					id
					value
				}
			}
		}
	}
	socialSignal(tenantId: $tenantId) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
}
`;
const $2ecd498b970d7c17$export$c89c057fd480d10c = (partial)=>{
    return partial.__typename === 'SearchConfluencePageBlogAttachment';
};
const $2ecd498b970d7c17$var$SearchConfluenceSpace = `
... on SearchConfluenceSpace {
	key
	lastModified
	iconPath
	socialSignal(tenantId: $tenantId) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}

	}
}
`;
const $2ecd498b970d7c17$export$4619f000f23ee8d1 = (partial)=>{
    return partial.__typename === 'SearchConfluenceSpace';
};
const $2ecd498b970d7c17$export$e4e5a86cb4c1e3e4 = (partial)=>{
    return $2ecd498b970d7c17$export$c89c057fd480d10c(partial) || $2ecd498b970d7c17$export$4619f000f23ee8d1(partial);
};
const $2ecd498b970d7c17$export$d1ddb94b35ac2d77 = ()=>{
    return `
		${$2ecd498b970d7c17$var$SearchConfluencePageBlogAttachment}
		${$2ecd498b970d7c17$var$SearchConfluenceSpace}
	`;
};
module.exports["isSearchConfluencePageBlogAttachment"] = $2ecd498b970d7c17$export$c89c057fd480d10c;
module.exports["isSearchConfluencePartial"] = $2ecd498b970d7c17$export$e4e5a86cb4c1e3e4;
module.exports["getConfluencePartials"] = $2ecd498b970d7c17$export$d1ddb94b35ac2d77;

});

parcelRegister("ah5yI", function(module, exports) {

var $7avaU = parcelRequire("7avaU");


var $j2fX0 = parcelRequire("j2fX0");


var $7ED6w = parcelRequire("7ED6w");


var $gVX3R = parcelRequire("gVX3R");


var $fN114 = parcelRequire("fN114");


var $2IndL = parcelRequire("2IndL");


var $e3Gso = parcelRequire("e3Gso");


var $aYMgt = parcelRequire("aYMgt");


var $8yv9u = parcelRequire("8yv9u");


var $fs9dB = parcelRequire("fs9dB");


var $2UJLP = parcelRequire("2UJLP");

const $6aa85f4a7f19dd8c$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $6aa85f4a7f19dd8c$var$SearchThirdPartyGraphDocumentPartial = `
... on SearchResultGraphDocument {
	excerpt,
	permissionLevel,
	initialContributors {
		name
	}
	subtype
	integrationId
	lastModifiedDate
	linkedEntities {
		id
		title
		excerpt,
		permissionLevel,
		subtype
		integrationId
		lastModifiedDate
		entity {
			${(0, $aYMgt.ExternalMessagePartial)}
		}
	}
	entity {
		${(0, $j2fX0.ExternalBranchPartial)}
		${(0, $7ED6w.ExternalCalendarEventPartial)}
		${(0, $gVX3R.ExternalCommitPartial)}
		${(0, $fN114.ExternalConversationPartial)}
		${(0, $2IndL.ExternalDesignPartial)}
		${(0, $e3Gso.ExternalDocumentPartial)}
		${(0, $aYMgt.ExternalMessagePartial)}
		${(0, $8yv9u.ExternalPullRequestPartial)}
		${(0, $fs9dB.ExternalRepositoryPartial)}
		${(0, $2UJLP.ExternalVideoPartial)}
	}
}
`;
var $6aa85f4a7f19dd8c$var$AccountStatus = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus[AccountStatus["active"] = 0] = "active";
    AccountStatus[AccountStatus["inactive"] = 1] = "inactive";
    AccountStatus[AccountStatus["closed"] = 2] = "closed";
    return AccountStatus;
}($6aa85f4a7f19dd8c$var$AccountStatus || {});
var $6aa85f4a7f19dd8c$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory[ExternalDocumentCategory["ARCHIVE"] = 0] = "ARCHIVE";
    ExternalDocumentCategory[ExternalDocumentCategory["AUDIO"] = 1] = "AUDIO";
    ExternalDocumentCategory[ExternalDocumentCategory["CODE"] = 2] = "CODE";
    ExternalDocumentCategory[ExternalDocumentCategory["DOCUMENT"] = 3] = "DOCUMENT";
    ExternalDocumentCategory[ExternalDocumentCategory["FOLDER"] = 4] = "FOLDER";
    ExternalDocumentCategory[ExternalDocumentCategory["FORM"] = 5] = "FORM";
    ExternalDocumentCategory[ExternalDocumentCategory["IMAGE"] = 6] = "IMAGE";
    ExternalDocumentCategory[ExternalDocumentCategory["OTHER"] = 7] = "OTHER";
    ExternalDocumentCategory[ExternalDocumentCategory["PDF"] = 8] = "PDF";
    ExternalDocumentCategory[ExternalDocumentCategory["PRESENTATION"] = 9] = "PRESENTATION";
    ExternalDocumentCategory[ExternalDocumentCategory["SHORTCUT"] = 10] = "SHORTCUT";
    ExternalDocumentCategory[ExternalDocumentCategory["SPREADSHEET"] = 11] = "SPREADSHEET";
    ExternalDocumentCategory[ExternalDocumentCategory["VIDEO"] = 12] = "VIDEO";
    ExternalDocumentCategory[ExternalDocumentCategory["WEB_PAGE"] = 13] = "WEB_PAGE";
    return ExternalDocumentCategory;
}($6aa85f4a7f19dd8c$var$ExternalDocumentCategory || {});
var $6aa85f4a7f19dd8c$var$ExternalWorkItemType = /*#__PURE__*/ function(ExternalWorkItemType) {
    ExternalWorkItemType["TASK"] = "TASK";
    ExternalWorkItemType["DEFAULT_TASK"] = "DEFAULT_TASK";
    ExternalWorkItemType["WORK_ITEM"] = "WORK_ITEM";
    ExternalWorkItemType["EPIC"] = "EPIC";
    ExternalWorkItemType["BUG"] = "BUG";
    ExternalWorkItemType["STORY"] = "STORY";
    ExternalWorkItemType["MILESTONE"] = "MILESTONE";
    ExternalWorkItemType["SECTION"] = "SECTION";
    ExternalWorkItemType["APPROVAL"] = "APPROVAL";
    ExternalWorkItemType["PROBLEM"] = "PROBLEM";
    ExternalWorkItemType["INCIDENT"] = "INCIDENT";
    ExternalWorkItemType["QUESTION"] = "QUESTION";
    ExternalWorkItemType["ISSUE"] = "ISSUE";
    ExternalWorkItemType["OTHER"] = "OTHER";
    return ExternalWorkItemType;
}($6aa85f4a7f19dd8c$var$ExternalWorkItemType || {});
var $6aa85f4a7f19dd8c$var$ExternalMembershipType = /*#__PURE__*/ function(ExternalMembershipType) {
    ExternalMembershipType["PRIVATE"] = "PRIVATE";
    ExternalMembershipType["PUBLIC"] = "PUBLIC";
    ExternalMembershipType["SHARED"] = "SHARED";
    return ExternalMembershipType;
}($6aa85f4a7f19dd8c$var$ExternalMembershipType || {});
var $6aa85f4a7f19dd8c$var$ExternalConversationType = /*#__PURE__*/ function(ExternalConversationType) {
    ExternalConversationType["CHANNEL"] = "CHANNEL";
    ExternalConversationType["DIRECT_MESSAGE"] = "DIRECT_MESSAGE";
    ExternalConversationType["GROUP_DIRECT_MESSAGE"] = "GROUP_DIRECT_MESSAGE";
    return ExternalConversationType;
}($6aa85f4a7f19dd8c$var$ExternalConversationType || {});
var $6aa85f4a7f19dd8c$var$ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["BRANCH"] = "branch";
    ResourceType["CALENDAR_EVENT"] = "calendar-event";
    ResourceType["COMMIT"] = "commit";
    ResourceType["CONVERSATION"] = "conversation";
    ResourceType["DESIGN"] = "design";
    ResourceType["DOCUMENT"] = "document";
    ResourceType["MESSAGE"] = "message";
    ResourceType["PULL_REQUEST"] = "pull-request";
    ResourceType["REPOSITORY"] = "repository";
    ResourceType["VIDEO"] = "video";
    ResourceType["WORK_ITEM"] = "work-item";
    return ResourceType;
}($6aa85f4a7f19dd8c$var$ResourceType || {});
const $6aa85f4a7f19dd8c$export$e169b729a14ad5f8 = ()=>{
    //TODO: update for GitHub graph entities
    return $6aa85f4a7f19dd8c$var$SearchThirdPartyGraphDocumentPartial;
};
const $6aa85f4a7f19dd8c$export$7dd4baba91338caa = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $6aa85f4a7f19dd8c$export$6c20afe8743cb761 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "conversation";
};
const $6aa85f4a7f19dd8c$export$8dc9be81b5b6266b = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "design";
};
const $6aa85f4a7f19dd8c$export$33e8c1bbf9148b0e = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "message";
};
const $6aa85f4a7f19dd8c$export$9cfcc6ca7fb6e839 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "video";
};
const $6aa85f4a7f19dd8c$export$9a3959a38fa67fd0 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "branch";
};
const $6aa85f4a7f19dd8c$export$ece3e91c16809748 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "commit";
};
const $6aa85f4a7f19dd8c$export$5ba84cc314040e0c = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "pull-request";
};
const $6aa85f4a7f19dd8c$export$9c4afe4ccb574692 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "repository";
};
const $6aa85f4a7f19dd8c$export$32c06ee7e0e9b79e = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "document";
};
const $6aa85f4a7f19dd8c$export$92306a022e0703e0 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "calendar-event";
};
const $6aa85f4a7f19dd8c$export$40f90006d8fc8dee = (partial)=>$6aa85f4a7f19dd8c$export$33e8c1bbf9148b0e(partial) && partial.integrationId === $6aa85f4a7f19dd8c$var$TEAMS_INTEGRATION_ARI;
const $6aa85f4a7f19dd8c$export$162dad7a1238d377 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "work-item";
};
module.exports["getGraphPartials"] = $6aa85f4a7f19dd8c$export$e169b729a14ad5f8;
module.exports["isSearchResultGraphEntity"] = $6aa85f4a7f19dd8c$export$7dd4baba91338caa;
module.exports["isConversationEntity"] = $6aa85f4a7f19dd8c$export$6c20afe8743cb761;
module.exports["isDesignEntity"] = $6aa85f4a7f19dd8c$export$8dc9be81b5b6266b;
module.exports["isMessageEntity"] = $6aa85f4a7f19dd8c$export$33e8c1bbf9148b0e;
module.exports["isVideoEntity"] = $6aa85f4a7f19dd8c$export$9cfcc6ca7fb6e839;
module.exports["isBranchEntity"] = $6aa85f4a7f19dd8c$export$9a3959a38fa67fd0;
module.exports["isCommitEntity"] = $6aa85f4a7f19dd8c$export$ece3e91c16809748;
module.exports["isPullRequestEntity"] = $6aa85f4a7f19dd8c$export$5ba84cc314040e0c;
module.exports["isRepositoryEntity"] = $6aa85f4a7f19dd8c$export$9c4afe4ccb574692;
module.exports["isDocumentEntity"] = $6aa85f4a7f19dd8c$export$32c06ee7e0e9b79e;
module.exports["isCalendarEventEntity"] = $6aa85f4a7f19dd8c$export$92306a022e0703e0;
module.exports["isWorkItemEntity"] = $6aa85f4a7f19dd8c$export$162dad7a1238d377;

});

parcelRegister("e7vVr", function(module, exports) {
const $776df126cdfbf364$var$SearchResultTrelloBoard = `
... on SearchResultTrelloBoard {
	type
	description
	lastModifiedDate
}
`;
const $776df126cdfbf364$export$d40aaa445b6f7858 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloBoard';
};
const $776df126cdfbf364$var$SearchResultTrelloCard = `
... on SearchResultTrelloCard {
	type
	description
	lastModifiedDate
	boardName
	commentsCount
}
`;
const $776df126cdfbf364$export$980cabf11d827509 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloCard';
};
const $776df126cdfbf364$export$6ed59678949b7701 = (partial)=>{
    return $776df126cdfbf364$export$d40aaa445b6f7858(partial) || $776df126cdfbf364$export$980cabf11d827509(partial);
};
const $776df126cdfbf364$export$73993ded7a48a460 = ()=>{
    return `
		${$776df126cdfbf364$var$SearchResultTrelloBoard}
		${$776df126cdfbf364$var$SearchResultTrelloCard}
	`;
};
module.exports["isSearchTrelloPartial"] = $776df126cdfbf364$export$6ed59678949b7701;
module.exports["getTrelloPartials"] = $776df126cdfbf364$export$73993ded7a48a460;

});

parcelRegister("hJYQM", function(module, exports) {
/**
 * @deprecated do not use or change this file, use the new third-party-graph-entity package instead
 */ const $507a7ed33fca80a5$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $507a7ed33fca80a5$var$MICROSOFT_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $507a7ed33fca80a5$var$SearchThirdPartyDocumentPartial = `
... on SearchResultGoogleDocument {
  lastModifiedDate
  excerpt
  permissionLevel
}
... on SearchResultGooglePresentation {
  lastModifiedDate
  excerpt
	permissionLevel
}
... on SearchResultGoogleSpreadsheet {
  lastModifiedDate
  excerpt
	permissionLevel
}
... on SearchResultGooglePresentation {
  lastModifiedDate
  excerpt
	permissionLevel
}
... on SearchResultGoogleSpreadsheet {
  lastModifiedDate
  excerpt
	permissionLevel
}
... on SearchResultMicrosoftDocument {
  lastModifiedDate
  excerpt
  permissionLevel
}
`;
const $507a7ed33fca80a5$var$SlackMessagePartial = `
... on SearchResultSlackMessage {
  lastModifiedDate
  subtype
  mentions {
    name
	externalId
  }
  initialContributors {
    name
  }
  linkedEntities {
	id
	title
	description
	initialContributors {
  	  name
	  externalId
	}
	mentions {
	  name
	  externalId
	}
  }
}
`;
const $507a7ed33fca80a5$export$a1e4e7e35d852037 = ()=>{
    return $507a7ed33fca80a5$var$SearchThirdPartyDocumentPartial;
};
const $507a7ed33fca80a5$export$2580337ea423563e = ()=>{
    return $507a7ed33fca80a5$var$SearchThirdPartyDocumentPartial;
};
const $507a7ed33fca80a5$export$dad2c93cb82acac0 = ()=>{
    return `${$507a7ed33fca80a5$var$SlackMessagePartial}`;
};
const $507a7ed33fca80a5$export$2b6b5ca2b503e8cd = (partial)=>partial.__typename === 'SearchResultMicrosoftDocument' || $507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$MICROSOFT_INTEGRATION_ARI;
const $507a7ed33fca80a5$export$ccb18eeab2a052be = (partial)=>$507a7ed33fca80a5$export$2b6b5ca2b503e8cd(partial) && partial.type === 'document' || $507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$MICROSOFT_INTEGRATION_ARI && partial.subtype === 'document';
const $507a7ed33fca80a5$export$aa6b9bf904d5faaa = (partial)=>$507a7ed33fca80a5$export$2b6b5ca2b503e8cd(partial) && partial.type === 'presentation' || $507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$MICROSOFT_INTEGRATION_ARI && partial.subtype === 'presentation';
const $507a7ed33fca80a5$export$6da7ca6e6bf249aa = (partial)=>$507a7ed33fca80a5$export$2b6b5ca2b503e8cd(partial) && partial.type === 'spreadsheet' || $507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$MICROSOFT_INTEGRATION_ARI && partial.subtype === 'spreadsheet';
const $507a7ed33fca80a5$export$bb2c616baa181494 = (partial)=>$507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$MICROSOFT_INTEGRATION_ARI;
const $507a7ed33fca80a5$export$927c2feba595f1cb = (partial)=>$507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$MICROSOFT_INTEGRATION_ARI && (partial.type === 'document' || partial.subtype === 'document');
const $507a7ed33fca80a5$export$6712295d6d2d4b9 = (partial)=>$507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$MICROSOFT_INTEGRATION_ARI && (partial.type === 'presentation' || partial.subtype === 'presentation');
const $507a7ed33fca80a5$export$b1c281e549a5f797 = (partial)=>$507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$MICROSOFT_INTEGRATION_ARI && (partial.type === 'spreadsheet' || partial.subtype === 'spreadsheet');
const $507a7ed33fca80a5$export$ac12fd23f64c998f = (partial)=>$507a7ed33fca80a5$export$e6a288d5cd4cda6(partial) || $507a7ed33fca80a5$export$5fa365506597a68f(partial) || $507a7ed33fca80a5$export$bb8318bfdc4716ee(partial);
const $507a7ed33fca80a5$export$e6a288d5cd4cda6 = (partial)=>partial.__typename === 'SearchResultGoogleDocument' || $507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$GOOGLE_INTEGRATION_ARI && partial.subtype === 'document';
const $507a7ed33fca80a5$export$5fa365506597a68f = (partial)=>partial.__typename === 'SearchResultGooglePresentation' || $507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$GOOGLE_INTEGRATION_ARI && partial.subtype === 'presentation';
const $507a7ed33fca80a5$export$bb8318bfdc4716ee = (partial)=>partial.__typename === 'SearchResultGoogleSpreadsheet' || $507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $507a7ed33fca80a5$var$GOOGLE_INTEGRATION_ARI && partial.subtype === 'spreadsheet';
const $507a7ed33fca80a5$export$2fedbabcc623299 = (partial)=>partial.__typename === 'SearchResultSlackMessage';
const $507a7ed33fca80a5$export$677950c93e2449ad = (partial)=>{
    return $507a7ed33fca80a5$export$ac12fd23f64c998f(partial) || $507a7ed33fca80a5$export$2b6b5ca2b503e8cd(partial) || $507a7ed33fca80a5$export$34ee1a2c0a1a45b7(partial);
};
const $507a7ed33fca80a5$export$34ee1a2c0a1a45b7 = (partial)=>partial.__typename === 'SearchResultGraphDocument';
module.exports["getGooglePartials"] = $507a7ed33fca80a5$export$a1e4e7e35d852037;
module.exports["getMicrosoftPartials"] = $507a7ed33fca80a5$export$2580337ea423563e;
module.exports["getSlackPartials"] = $507a7ed33fca80a5$export$dad2c93cb82acac0;
module.exports["isSharepointResult"] = $507a7ed33fca80a5$export$2b6b5ca2b503e8cd;
module.exports["isGraphDocument"] = $507a7ed33fca80a5$export$34ee1a2c0a1a45b7;
module.exports["isSharepointDocument"] = $507a7ed33fca80a5$export$ccb18eeab2a052be;
module.exports["isSharepointPresentation"] = $507a7ed33fca80a5$export$aa6b9bf904d5faaa;
module.exports["isSharepointSpreadsheet"] = $507a7ed33fca80a5$export$6da7ca6e6bf249aa;
module.exports["isGoogleResult"] = $507a7ed33fca80a5$export$ac12fd23f64c998f;
module.exports["isGoogleDocument"] = $507a7ed33fca80a5$export$e6a288d5cd4cda6;
module.exports["isGooglePresentation"] = $507a7ed33fca80a5$export$5fa365506597a68f;
module.exports["isGoogleSpreadsheet"] = $507a7ed33fca80a5$export$bb8318bfdc4716ee;
module.exports["isSlackMessage"] = $507a7ed33fca80a5$export$2fedbabcc623299;

});

parcelRegister("7tsC5", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $90ff6198a3715dec$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $90ff6198a3715dec$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $90ff6198a3715dec$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $90ff6198a3715dec$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $90ff6198a3715dec$export$5c07a4287a46fa1f;

});

parcelRegister("d5jV9", function(module, exports) {
const $68a42757800274ae$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
class $68a42757800274ae$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result) {
        const entry = new $68a42757800274ae$var$Entry({
            result: result,
            expirationTime: Date.now() + this.expiration,
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $68a42757800274ae$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
        } catch (e) {
        // TODO: Log error via sentry
        }
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $68a42757800274ae$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $68a42757800274ae$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $68a42757800274ae$export$8bedcca5bbd73999 = (args)=>{
    return new $68a42757800274ae$var$Cache(args);
};
module.exports["getInstance"] = $68a42757800274ae$export$8bedcca5bbd73999;

});

parcelRegister("kUPAS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b4d5f609656ba529$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    atlas: {
        id: "dynamic-cards-search-page.products.atlas",
        defaultMessage: "Atlas"
    },
    webPage: {
        id: "dynamic-cards-search-page.products.custom-website",
        defaultMessage: "Web page"
    },
    webPages: {
        id: "dynamic-cards-search-page.products.custom-websites",
        defaultMessage: "Web pages"
    },
    project: {
        id: "dynamic-cards-search-page.nouns.project",
        defaultMessage: "Project"
    },
    projects: {
        id: "dynamic-cards-search-page.nouns.projects",
        defaultMessage: "Projects"
    },
    goal: {
        id: "dynamic-cards-search-page.nouns.goal",
        defaultMessage: "Goal"
    },
    goals: {
        id: "dynamic-cards-search-page.nouns.goals",
        defaultMessage: "Goals"
    },
    tag: {
        id: "dynamic-cards-search-page.nouns.tag",
        defaultMessage: "Tag"
    },
    tags: {
        id: "dynamic-cards-search-page.nouns.tags",
        defaultMessage: "Tags"
    },
    sharepoint: {
        id: "dynamic-cards-search-page.products.sharepoint",
        defaultMessage: "SharePoint"
    },
    atlassianWebCrawler: {
        id: "dynamic-cards-search-page.products.atlassian-web-crawler",
        defaultMessage: "Atlassian Web Crawler"
    },
    confluence: {
        id: "dynamic-cards-search-page.products.confluence",
        defaultMessage: "Confluence"
    },
    jira: {
        id: "dynamic-cards-search-page.products.jira",
        defaultMessage: "Jira"
    },
    jiraProductDiscovery: {
        id: "dynamic-cards-search-page.products.jira-product-discovery",
        defaultMessage: "Jira Product Discovery"
    },
    jiraServiceManagement: {
        id: "dynamic-cards-search-page.products.jira-service-management",
        defaultMessage: "Jira Service Management"
    },
    bitbucket: {
        id: "dynamic-cards-search-page.products.bitbucket",
        defaultMessage: "Bitbucket"
    },
    trello: {
        id: "dynamic-cards-search-page.products.trello",
        defaultMessage: "Trello"
    },
    compass: {
        id: "dynamic-cards-search-page.products.compass",
        defaultMessage: "Compass"
    },
    googleDrive: {
        id: "dynamic-cards-search-page.products.google-drive",
        defaultMessage: "Google Drive"
    },
    teams: {
        id: "dynamic-cards-search-page.products.teams",
        defaultMessage: "Teams"
    },
    loom: {
        id: "dynamic-cards-search-page.products.loom",
        defaultMessage: "Loom"
    },
    oneDrive: {
        id: "dynamic-cards-search-page.products.onedrive",
        defaultMessage: "OneDrive"
    },
    slack: {
        id: "dynamic-cards-search-page.products.slack",
        defaultMessage: "Slack"
    },
    github: {
        id: "dynamic-cards-search-page.products.github",
        defaultMessage: "GitHub"
    },
    figma: {
        id: "dynamic-cards-search-page.products.figma",
        defaultMessage: "Figma"
    },
    dropbox: {
        id: "dynamic-cards-search-page.products.dropbox",
        defaultMessage: "Dropbox"
    },
    googleCalendar: {
        id: "dynamic-cards-search-page.products.google-calendar",
        defaultMessage: "Google Calendar"
    },
    gmail: {
        id: "dynamic-cards-search-page.products.gmail",
        defaultMessage: "Gmail"
    },
    outlookCalendar: {
        id: "dynamic-cards-search-page.products.outlook-calendar",
        defaultMessage: "Outlook Calendar"
    },
    airtable: {
        id: "dynamic-cards-search-page.products.airtable",
        defaultMessage: "Airtable"
    },
    asana: {
        id: "dynamic-cards-search-page.products.asana",
        defaultMessage: "Asana"
    },
    zendesk: {
        id: "dynamic-cards-search-page.products.zendesk",
        defaultMessage: "Zendesk"
    },
    notion: {
        id: "dynamic-cards-search-page.products.notion",
        defaultMessage: "Notion"
    },
    miro: {
        id: "dynamic-cards-search-page.products.miro",
        defaultMessage: "Miro"
    },
    microsoftSharepoint: {
        id: "dynamic-cards-search-page.products.microsoft-sharepoint",
        defaultMessage: "Microsoft SharePoint"
    }
});
module.exports["messages"] = $b4d5f609656ba529$export$defe85febe8b728c;

});

parcelRegister("jViGU", function(module, exports) {
const $4c7496ecddf83bdb$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
const $4c7496ecddf83bdb$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
const $4c7496ecddf83bdb$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
const $4c7496ecddf83bdb$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
const $4c7496ecddf83bdb$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
const $4c7496ecddf83bdb$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
const $4c7496ecddf83bdb$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
const $4c7496ecddf83bdb$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
const $4c7496ecddf83bdb$export$6ecda3d3ffc4c36b = [
    'ati:cloud:graph:repository',
    'ati:cloud:graph:pull-request',
    'ati:cloud:graph:commit',
    'ati:cloud:graph:branch'
];
const $4c7496ecddf83bdb$export$2113db8105db1e2f = 'ati:cloud:confluence:';
const $4c7496ecddf83bdb$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard'
];
const $4c7496ecddf83bdb$export$1d1f9443ac350d6f = [
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:folder'
];
const $4c7496ecddf83bdb$export$fd9583608bfd5225 = 'confluence.com.atlassian.confluence.extra.team-calendars:calendar-content-type';
const $4c7496ecddf83bdb$export$842fc5f4c9a103cc = 'confluence.com.atlassian.confluence.extra.team-calendars:space-calendars-view-content-type';
const $4c7496ecddf83bdb$export$85fae06d428ca65d = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:answer';
const $4c7496ecddf83bdb$export$de533c0a50cfcba1 = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:question';
const $4c7496ecddf83bdb$export$4fb210ecd60bcccb = 'ati:cloud:jira:issue';
const $4c7496ecddf83bdb$export$2d84b48cf0a2eca6 = 'ati:cloud:jira:project';
const $4c7496ecddf83bdb$export$b4a7e1c18385196d = [
    $4c7496ecddf83bdb$export$2d84b48cf0a2eca6,
    $4c7496ecddf83bdb$export$4fb210ecd60bcccb
];
const $4c7496ecddf83bdb$export$d3361702bd2fd562 = [
    'message'
];
const $4c7496ecddf83bdb$export$18938ead1fad4569 = [
    ...$4c7496ecddf83bdb$export$c87d62ed9387fa60,
    ...$4c7496ecddf83bdb$export$c07a1c127052b557,
    ...$4c7496ecddf83bdb$export$b4a7e1c18385196d
];
const $4c7496ecddf83bdb$export$423da9b1dcd76b7 = 15;
const $4c7496ecddf83bdb$export$405ff9c6ee9ee7de = 30;
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $4c7496ecddf83bdb$export$d520529b4595d46c;
module.exports["DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI"] = $4c7496ecddf83bdb$export$8bd7fa13a82672fe;
module.exports["DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI"] = $4c7496ecddf83bdb$export$a752b216a5b9069f;
module.exports["DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI"] = $4c7496ecddf83bdb$export$9d37c36d8b43baee;
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $4c7496ecddf83bdb$export$a3d7cddace4fe237;
module.exports["DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI"] = $4c7496ecddf83bdb$export$d810eae89914369b;
module.exports["CONFLUENCE_CALENDAR_ENTITY_ATI"] = $4c7496ecddf83bdb$export$fd9583608bfd5225;
module.exports["CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI"] = $4c7496ecddf83bdb$export$842fc5f4c9a103cc;
module.exports["CONFLUENCE_ANSWER_ENTITY_ATI"] = $4c7496ecddf83bdb$export$85fae06d428ca65d;
module.exports["CONFLUENCE_QUESTION_ENTITY_ATI"] = $4c7496ecddf83bdb$export$de533c0a50cfcba1;
module.exports["JIRA_ISSUE_ENTITY_ATI"] = $4c7496ecddf83bdb$export$4fb210ecd60bcccb;
module.exports["JIRA_PROJECT_ENTITY_ATI"] = $4c7496ecddf83bdb$export$2d84b48cf0a2eca6;
module.exports["DEFAULT_ENTITY_ATI"] = $4c7496ecddf83bdb$export$18938ead1fad4569;
module.exports["RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS"] = $4c7496ecddf83bdb$export$423da9b1dcd76b7;
module.exports["RESULT_LIMIT_FOR_SINGLE_PRODUCT"] = $4c7496ecddf83bdb$export$405ff9c6ee9ee7de;

});

parcelRegister("irdYS", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $kEOJV = parcelRequire("kEOJV");


var $2JxTe = parcelRequire("2JxTe");

const $94175eaa9a41ab9d$export$962b0679c5bd2c33 = {
    displayName: 'Airtable',
    id: 'airtable',
    resourceType: 'airtable-connector',
    icon: (0, $2JxTe.AirtableFilterIcon),
    searchResultIcon: (0, $kEOJV.AirtableIcon),
    integrationAri: 'ari:cloud:platform::integration/airtable',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Document
    ],
    requiresOauth: true,
    isEnabled: ()=>false
};
module.exports["airtableConfig"] = $94175eaa9a41ab9d$export$962b0679c5bd2c33;

});

parcelRegister("7Mllk", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $g022q = parcelRequire("g022q");

const $a5e98dcb60d51f47$export$72c8845a87b8934e = {
    displayName: 'Asana',
    id: 'asana',
    icon: (0, $g022q.default),
    integrationAri: 'ari:cloud:platform::integration/asana',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).WorkItem
    ],
    requiresOauth: true,
    isEnabled: ()=>false
};
module.exports["asanaConfig"] = $a5e98dcb60d51f47$export$72c8845a87b8934e;

});

parcelRegister("klGKb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lCzjG = parcelRequire("lCzjG");


var $4aQS7 = parcelRequire("4aQS7");


var $1tbRi = parcelRequire("1tbRi");


var $1Dxn6 = parcelRequire("1Dxn6");

const $c84d9949a8fd5243$export$fbd198cf40195606 = {
    displayName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1Dxn6.messages)['atlassian-web-crawler']),
    id: 'atlassian-web-crawler',
    resourceType: 'webcrawler-connector',
    icon: (0, $4aQS7.WebDomainIcon),
    searchResultIcon: (0, $1tbRi.WebDomainSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).WebPage
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["atlassianWebCrawlerConfig"] = $c84d9949a8fd5243$export$fbd198cf40195606;

});

parcelRegister("abZJs", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $lFtQw = parcelRequire("lFtQw");

const $8fcd582d95c45ea3$export$4a63cdb15a145936 = {
    displayName: 'Dropbox',
    id: 'dropbox',
    resourceType: 'dropbox-connector',
    icon: (0, $lFtQw.DropboxIcon),
    integrationAri: 'ari:cloud:platform::integration/dropbox',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Document,
        (0, $lCzjG.TypeFilterValueKey).Spreadsheet,
        (0, $lCzjG.TypeFilterValueKey).Presentation
    ],
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dropboxConfig"] = $8fcd582d95c45ea3$export$4a63cdb15a145936;

});

parcelRegister("1xLLa", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $7hnNi = parcelRequire("7hnNi");


var $bZjBf = parcelRequire("bZjBf");

const $54b9e8240777aa24$export$e821d8af66e3adab = {
    displayName: 'Figma',
    id: 'figma',
    resourceType: 'figma-connector',
    icon: (0, $7hnNi.FigmaIcon),
    searchResultIcon: (0, $bZjBf.FigmaSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/figma',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Design
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["figmaConfig"] = $54b9e8240777aa24$export$e821d8af66e3adab;

});

parcelRegister("dJiO9", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $32Uuv = parcelRequire("32Uuv");


var $98L7N = parcelRequire("98L7N");

const $fa81ed1bad73147d$export$71c63cb45707eee = {
    displayName: 'Github',
    id: 'github',
    resourceType: 'github-connector',
    icon: (0, $32Uuv.GithubIcon),
    searchResultIcon: (0, $98L7N.GithubSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/github',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Repository,
        (0, $lCzjG.TypeFilterValueKey).PullRequest,
        (0, $lCzjG.TypeFilterValueKey).Branch,
        (0, $lCzjG.TypeFilterValueKey).Commit
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["githubConfig"] = $fa81ed1bad73147d$export$71c63cb45707eee;

});

parcelRegister("1Kmth", function(module, exports) {

var $6eZhJ = parcelRequire("6eZhJ");

const $3446db033ef435cf$export$c771ac380e225e02 = {
    displayName: 'Gmail',
    id: 'gmail',
    resourceType: 'gmail-connector',
    icon: (0, $6eZhJ.GmailIcon),
    integrationAri: 'ari:cloud:platform::integration/gmail',
    requiresOauth: true,
    typeFilterValues: [],
    // fg('enable_3p_search_gmail') => false
    isEnabled: ()=>false
};
module.exports["gmailConfig"] = $3446db033ef435cf$export$c771ac380e225e02;

});

parcelRegister("53xPo", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $34Ycr = parcelRequire("34Ycr");


var $7IRSQ = parcelRequire("7IRSQ");

const $9b10098c063ccbea$export$6634ddcb22ed69a = {
    displayName: 'Google Drive',
    id: 'drive',
    resourceType: 'ai-3p-connector:google-workspace',
    icon: (0, $34Ycr.GoogleDriveIcon),
    searchResultIcon: (0, $7IRSQ.GoogleDriveSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/google',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Document,
        (0, $lCzjG.TypeFilterValueKey).Spreadsheet,
        (0, $lCzjG.TypeFilterValueKey).Presentation
    ],
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["googleDriveConfig"] = $9b10098c063ccbea$export$6634ddcb22ed69a;

});

parcelRegister("gcDyO", function(module, exports) {

var $jPcqU = parcelRequire("jPcqU");

const $0e360d66d59e4217$export$be326f2f9a08a3a4 = {
    displayName: 'Google Calendar',
    id: 'google-calendar',
    resourceType: 'google-calendar-connector',
    icon: (0, $jPcqU.default),
    integrationAri: 'ari:cloud:platform::integration/google-calendar',
    requiresOauth: true,
    // TODO: >>>> QS-5465: Uncomment when calendar nouns are ready to be ingested
    typeFilterValues: [],
    // typeFilterValues: [TypeFilterValueKey.Calendar],
    // fg('enable_3p_search_google_calendar') => false
    isEnabled: ()=>false
};
module.exports["googleCalendarConfig"] = $0e360d66d59e4217$export$be326f2f9a08a3a4;

});

parcelRegister("hwu7Y", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $1irrG = parcelRequire("1irrG");

const $7a95dc3c0490d2e1$export$9cb908560d4a0a78 = {
    displayName: 'Loom',
    id: 'loom',
    icon: (0, $1irrG.LoomIcon),
    integrationAri: 'ari:cloud:platform::integration/loom',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Video
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["loomConfig"] = $7a95dc3c0490d2e1$export$9cb908560d4a0a78;

});

parcelRegister("9t53P", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $7TNej = parcelRequire("7TNej");


var $aR8pO = parcelRequire("aR8pO");

const $376c79df3ebc2e65$export$b11bada05d439596 = {
    displayName: 'Miro',
    id: 'miro',
    resourceType: 'miro-connector',
    icon: (0, $7TNej.MiroIcon),
    searchResultIcon: (0, $aR8pO.MiroFilterIcon),
    integrationAri: 'ari:cloud:platform::integration/miro',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Design
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["miroConfig"] = $376c79df3ebc2e65$export$b11bada05d439596;

});

parcelRegister("gM79P", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $6CAIO = parcelRequire("6CAIO");


var $2ocDV = parcelRequire("2ocDV");

const $060fa29500cb92c5$export$ddf7404f556e473a = {
    displayName: 'Notion',
    id: 'notion',
    resourceType: 'notion-connector',
    icon: (0, $2ocDV.NotionFilterIcon),
    searchResultIcon: (0, $6CAIO.NotionIcon),
    integrationAri: 'ari:cloud:platform::integration/notion',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Document
    ],
    requiresOauth: true,
    isEnabled: ()=>false
};
module.exports["notionConfig"] = $060fa29500cb92c5$export$ddf7404f556e473a;

});

parcelRegister("5qT5Z", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $5b9Mo = parcelRequire("5b9Mo");

const $edec7158be29bff3$export$b3b3a7aaf94fe09 = {
    displayName: 'OneDrive',
    id: 'onedrive',
    resourceType: 'onedrive-connector',
    icon: (0, $5b9Mo.OneDriveIcon),
    integrationAri: 'ari:cloud:platform::integration/onedrive',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Document,
        (0, $lCzjG.TypeFilterValueKey).Spreadsheet,
        (0, $lCzjG.TypeFilterValueKey).Presentation
    ],
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["oneDriveConfig"] = $edec7158be29bff3$export$b3b3a7aaf94fe09;

});

parcelRegister("1zrs2", function(module, exports) {

var $4R0et = parcelRequire("4R0et");

const $68baa3909f1e5ec2$export$3e5044818f2e9ef3 = {
    displayName: 'Outlook Calendar',
    id: 'outlook-calendar',
    resourceType: 'outlook-connector',
    icon: (0, $4R0et.OutlookCalendarIcon),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    // TODO: >>>> QS-5465: Uncomment when calendar nouns are ready to be ingested
    typeFilterValues: [],
    // typeFilterValues: [TypeFilterValueKey.Calendar],
    requiresOauth: true,
    isEnabled: ()=>false
};
module.exports["outlookCalendarConfig"] = $68baa3909f1e5ec2$export$3e5044818f2e9ef3;

});

parcelRegister("jpmtj", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $8kImw = parcelRequire("8kImw");


var $12a6Y = parcelRequire("12a6Y");

const $7ac681146ed5b38d$export$eb46bb6c4f0e628c = {
    displayName: 'Microsoft Sharepoint',
    id: 'sharepoint',
    resourceType: 'ai-3p-connector:sharepoint-domain',
    icon: (0, $8kImw.SharePointIcon),
    searchResultIcon: (0, $12a6Y.SharePointSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Document,
        (0, $lCzjG.TypeFilterValueKey).Spreadsheet,
        (0, $lCzjG.TypeFilterValueKey).Presentation
    ],
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["sharepointConfig"] = $7ac681146ed5b38d$export$eb46bb6c4f0e628c;

});

parcelRegister("bbj14", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $eIKlJ = parcelRequire("eIKlJ");


var $77zKA = parcelRequire("77zKA");

const $fc44022503338f54$export$c33894e475506863 = {
    displayName: 'Slack',
    id: 'slack',
    resourceType: 'ai-3p-connector:slack-workspace',
    icon: (0, $eIKlJ.SlackIcon),
    searchResultIcon: (0, $77zKA.SlackSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/slack',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Conversation,
        (0, $lCzjG.TypeFilterValueKey).Message
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["slackConfig"] = $fc44022503338f54$export$c33894e475506863;

});

parcelRegister("2wdaB", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $7Wn3K = parcelRequire("7Wn3K");


var $ew2HG = parcelRequire("ew2HG");

const $258d6bcceef69a6d$export$a579e078acf13bef = {
    displayName: 'Teams',
    id: 'teams',
    resourceType: 'microsoft-teams-connector',
    icon: (0, $7Wn3K.TeamsIcon),
    searchResultIcon: (0, $ew2HG.TeamsSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).Conversation,
        (0, $lCzjG.TypeFilterValueKey).Message
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["teamsConfig"] = $258d6bcceef69a6d$export$a579e078acf13bef;

});

parcelRegister("f8VKw", function(module, exports) {

var $lCzjG = parcelRequire("lCzjG");


var $gc2TU = parcelRequire("gc2TU");

const $3598b2be265db0f1$export$74a2db0a5eb2da3f = {
    displayName: 'Zendesk',
    id: 'zendesk',
    icon: (0, $gc2TU.default),
    integrationAri: 'ari:cloud:platform::integration/zendesk',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future
    typeFilterValues: [
        (0, $lCzjG.TypeFilterValueKey).WorkItem
    ],
    requiresOauth: true,
    isEnabled: ()=>false
};
module.exports["zendeskConfig"] = $3598b2be265db0f1$export$74a2db0a5eb2da3f;

});

parcelRegister("bcnPg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $613081a05c2bf9aa$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    controlKey: {
        id: "dynamic-cards-search-page.icons.control-key",
        defaultMessage: "Ctrl"
    },
    googleCalendarLabel: {
        id: "dynamic-cards-search-page.icons.google-calendar-label",
        defaultMessage: "Google Calendar"
    }
});
module.exports["messages"] = $613081a05c2bf9aa$export$defe85febe8b728c;

});

parcelRegister("6Tme9", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $b85jh = parcelRequire("b85jh");

const $8ab8a81998733e9e$var$MAX_SITES_INITIAL_QUERY = 3;
const $8ab8a81998733e9e$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $8ab8a81998733e9e$var$MAX_SITES_INITIAL_QUERY);
};
class $8ab8a81998733e9e$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($8ab8a81998733e9e$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $8ab8a81998733e9e$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $b85jh.timed)(this.makePostRequest($8ab8a81998733e9e$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $gABt9.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$8ab8a81998733e9e$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$8ab8a81998733e9e$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $8ab8a81998733e9e$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $8ab8a81998733e9e$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $8ab8a81998733e9e$export$5d730b7aed1a3eb0;

});

parcelRegister("iTSOb", function(module, exports) {

var $jR2a0 = parcelRequire("jR2a0");


var $7Mvs5 = parcelRequire("7Mvs5");

const $c1a5736e75f7679d$export$69a3209f1a06c04d = (0, $7Mvs5.inMemoryCache)();
const $c1a5736e75f7679d$var$GQL_OPERATION_NAME = 'SearchPageUserQuery';
const $c1a5736e75f7679d$var$getUserQuery = ()=>`
query ${$c1a5736e75f7679d$var$GQL_OPERATION_NAME}($accountId: ID!) {
  user(accountId: $accountId) {
    id
    accountId
    name
    picture
  }
}
`;
const $c1a5736e75f7679d$export$25f4d46d5dabadfc = (accountId)=>{
    return $c1a5736e75f7679d$export$69a3209f1a06c04d.inMemoryDecorator(accountId, async ()=>{
        const response = await (0, $jR2a0.fetchAgg)({
            graphQuery: $c1a5736e75f7679d$var$getUserQuery(),
            variables: {
                accountId: accountId
            },
            operationName: $c1a5736e75f7679d$var$GQL_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
const $c1a5736e75f7679d$export$c3d7afa7f49d431e = (0, $7Mvs5.inMemoryCache)();
const $c1a5736e75f7679d$var$GQL_USERS_OPERATION_NAME = 'SearchPageUsersQuery';
const $c1a5736e75f7679d$var$getUsersQuery = ()=>`
query ${$c1a5736e75f7679d$var$GQL_USERS_OPERATION_NAME}($accountIds: [ID!]!) {
  users(accountIds: $accountIds) {
    id
    name
    picture
    accountId
  }
}
`;
const $c1a5736e75f7679d$export$ef7fb495aeba8901 = (accountIds)=>{
    return $c1a5736e75f7679d$export$c3d7afa7f49d431e.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per user id
    accountIds.join(','), async ()=>{
        const response = await (0, $jR2a0.fetchAgg)({
            graphQuery: $c1a5736e75f7679d$var$getUsersQuery(),
            variables: {
                accountIds: accountIds
            },
            operationName: $c1a5736e75f7679d$var$GQL_USERS_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["userQuery"] = $c1a5736e75f7679d$export$25f4d46d5dabadfc;
module.exports["usersQuery"] = $c1a5736e75f7679d$export$ef7fb495aeba8901;

});

parcelRegister("iueFH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $37AYo = parcelRequire("37AYo");


var $2Va9o = parcelRequire("2Va9o");

const $6b472c6e3a208812$export$ac822ab68badd883 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { filterId: filterId } = t0;
    let t1;
    if ($[0] !== filterId) {
        t1 = {
            filterId: filterId
        };
        $[0] = filterId;
        $[1] = t1;
    } else t1 = $[1];
    const [state, storeActions] = (0, $2Va9o.useSelectFilterStore)(t1);
    let t2;
    if ($[2] !== filterId || $[3] !== storeActions) {
        t2 = {
            setOption: (option, customValue)=>{
                const options = Array.isArray(option) ? option : [
                    option
                ];
                const optionChange = options.map($6b472c6e3a208812$var$_temp);
                return storeActions.setSelectFilterOption({
                    filterId: filterId,
                    optionChange: optionChange,
                    customValue: customValue
                });
            },
            loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                    filterId: filterId
                }),
            setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                    filterId: filterId,
                    query: query
                }),
            clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                    filterId: filterId,
                    query: ""
                }),
            clearOptions: ()=>storeActions.clearSelectFilterOptions({
                    filterId: filterId
                })
        };
        $[2] = filterId;
        $[3] = storeActions;
        $[4] = t2;
    } else t2 = $[4];
    const viewActions = t2;
    if (!state) {
        let t3;
        if ($[5] !== viewActions) {
            t3 = [
                ,
                viewActions
            ];
            $[5] = viewActions;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    const t3 = state.alwaysVisible === false;
    const t4 = state.lookup.isDefined;
    const t5 = state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading;
    const t6 = state.lookup.input;
    const t7 = state.options;
    let t8;
    if ($[7] !== state.options) {
        t8 = state.options.filter($6b472c6e3a208812$var$_temp2);
        $[7] = state.options;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== state.alwaysVisible || $[10] !== state.customValue || $[11] !== state.lookup.input || $[12] !== state.lookup.isActive || $[13] !== state.lookup.isDefined || $[14] !== state.options || $[15] !== state.selectedOptions || $[16] !== t3 || $[17] !== t5 || $[18] !== t8) {
        t9 = {
            defaultIsOpen: t3,
            isLookupDefined: t4,
            isLoading: t5,
            lookupInput: t6,
            options: t7,
            suggestedOptions: t8,
            selectedOptions: state.selectedOptions,
            isLookupActive: state.lookup.isActive,
            alwaysVisible: state.alwaysVisible,
            customValue: state.customValue
        };
        $[9] = state.alwaysVisible;
        $[10] = state.customValue;
        $[11] = state.lookup.input;
        $[12] = state.lookup.isActive;
        $[13] = state.lookup.isDefined;
        $[14] = state.options;
        $[15] = state.selectedOptions;
        $[16] = t3;
        $[17] = t5;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    const viewState = t9;
    let t10;
    if ($[20] !== viewActions || $[21] !== viewState) {
        t10 = [
            viewState,
            viewActions
        ];
        $[20] = viewActions;
        $[21] = viewState;
        $[22] = t10;
    } else t10 = $[22];
    return t10;
} : ({ filterId: filterId })=>{
    const [state, storeActions] = (0, $2Va9o.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option, customValue)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option_0)=>({
                    value: option_0.value,
                    isSelected: !option_0.isSelected
                }));
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                customValue: customValue
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                filterId: filterId
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupDefined: state.lookup.isDefined,
        isLoading: // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        lookupInput: state.lookup.input,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        options: state.options,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        suggestedOptions: state.options.filter((option_1)=>!option_1.isSelected && option_1.isSuggested),
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        selectedOptions: state.selectedOptions,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        customValue: state.customValue
    };
    return [
        viewState,
        viewActions
    ];
};
const $6b472c6e3a208812$export$eb312ee1d3a7a748 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(47);
    const { filterId: filterId, optionsToProducts: optionsToProducts } = t0;
    let t1;
    if ($[0] !== filterId) {
        t1 = {
            filterId: filterId
        };
        $[0] = filterId;
        $[1] = t1;
    } else t1 = $[1];
    const [state, storeActions] = (0, $2Va9o.useSelectFilterStore)(t1);
    let t2;
    if ($[2] !== filterId || $[3] !== storeActions) {
        t2 = {
            setOption: (option)=>{
                const options = Array.isArray(option) ? option : [
                    option
                ];
                const optionChange = options.map($6b472c6e3a208812$var$_temp3);
                return storeActions.setSelectFilterOption({
                    filterId: filterId,
                    optionChange: optionChange
                });
            },
            loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                    filterId: filterId
                }),
            setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                    filterId: filterId,
                    query: query
                }),
            clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                    filterId: filterId,
                    query: ""
                }),
            clearOptions: ()=>storeActions.clearSelectFilterOptions({
                    filterId: filterId
                })
        };
        $[2] = filterId;
        $[3] = storeActions;
        $[4] = t2;
    } else t2 = $[4];
    const viewActions = t2;
    if (!state) {
        let t3;
        if ($[5] !== viewActions) {
            t3 = [
                ,
                viewActions
            ];
            $[5] = viewActions;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    const selectedProductsAvailable = state.selectedProducts.length > 0;
    const products = selectedProductsAvailable ? state.selectedProducts : state.availableProducts;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[7] !== optionsToProducts || $[8] !== products || $[9] !== selectedProductsAvailable || $[10] !== state.allFilterExcludedProducts || $[11] !== state.alwaysVisible || $[12] !== state.initialOptions || $[13] !== state.lookup.input || $[14] !== state.lookup.isDefined || $[15] !== state.lookup.isLoading || $[16] !== state.options || $[17] !== state.queryParams.isLoading || $[18] !== state.selectedProducts[0]) {
        let t9;
        if ($[25] !== optionsToProducts || $[26] !== products) {
            t9 = (option_1)=>option_1.isDefault || option_1.isSelected || optionsToProducts[option_1.value]?.some((product)=>products.includes(product));
            $[25] = optionsToProducts;
            $[26] = products;
            $[27] = t9;
        } else t9 = $[27];
        let t10;
        if ($[28] !== state.selectedProducts[0]) {
            t10 = (option_2)=>!(state.selectedProducts[0] !== (0, $37AYo.ProductKeys).Atlas && (option_2.value === "goal" || option_2.value === "tag"));
            $[28] = state.selectedProducts[0];
            $[29] = t10;
        } else t10 = $[29];
        let t11;
        if ($[30] !== optionsToProducts || $[31] !== selectedProductsAvailable || $[32] !== state.allFilterExcludedProducts) {
            t11 = (option_3)=>!selectedProductsAvailable && optionsToProducts[option_3.value]?.length ? optionsToProducts[option_3.value].some((product_0)=>!state.allFilterExcludedProducts.includes(product_0)) : true;
            $[30] = optionsToProducts;
            $[31] = selectedProductsAvailable;
            $[32] = state.allFilterExcludedProducts;
            $[33] = t11;
        } else t11 = $[33];
        const filteredOptions = state.options.filter(t9).filter(t10).filter(t11);
        t3 = state.alwaysVisible === false;
        t4 = state.lookup.isDefined;
        t5 = state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading;
        t6 = state.lookup.input;
        t7 = filteredOptions;
        t8 = filteredOptions.filter($6b472c6e3a208812$var$_temp4);
        $[7] = optionsToProducts;
        $[8] = products;
        $[9] = selectedProductsAvailable;
        $[10] = state.allFilterExcludedProducts;
        $[11] = state.alwaysVisible;
        $[12] = state.initialOptions;
        $[13] = state.lookup.input;
        $[14] = state.lookup.isDefined;
        $[15] = state.lookup.isLoading;
        $[16] = state.options;
        $[17] = state.queryParams.isLoading;
        $[18] = state.selectedProducts[0];
        $[19] = t3;
        $[20] = t4;
        $[21] = t5;
        $[22] = t6;
        $[23] = t7;
        $[24] = t8;
    } else {
        t3 = $[19];
        t4 = $[20];
        t5 = $[21];
        t6 = $[22];
        t7 = $[23];
        t8 = $[24];
    }
    let t9;
    if ($[34] !== state.alwaysVisible || $[35] !== state.lookup.isActive || $[36] !== state.selectedOptions || $[37] !== t3 || $[38] !== t4 || $[39] !== t5 || $[40] !== t6 || $[41] !== t7 || $[42] !== t8) {
        t9 = {
            defaultIsOpen: t3,
            isLookupDefined: t4,
            isLoading: t5,
            lookupInput: t6,
            options: t7,
            suggestedOptions: t8,
            selectedOptions: state.selectedOptions,
            isLookupActive: state.lookup.isActive,
            alwaysVisible: state.alwaysVisible
        };
        $[34] = state.alwaysVisible;
        $[35] = state.lookup.isActive;
        $[36] = state.selectedOptions;
        $[37] = t3;
        $[38] = t4;
        $[39] = t5;
        $[40] = t6;
        $[41] = t7;
        $[42] = t8;
        $[43] = t9;
    } else t9 = $[43];
    const viewState = t9;
    let t10;
    if ($[44] !== viewActions || $[45] !== viewState) {
        t10 = [
            viewState,
            viewActions
        ];
        $[44] = viewActions;
        $[45] = viewState;
        $[46] = t10;
    } else t10 = $[46];
    return t10;
} : ({ filterId: filterId, optionsToProducts: optionsToProducts })=>{
    const [state, storeActions] = (0, $2Va9o.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option_0)=>({
                    value: option_0.value,
                    isSelected: !option_0.isSelected
                }));
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                filterId: filterId
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const selectedProductsAvailable = state.selectedProducts.length > 0;
    const products = selectedProductsAvailable ? state.selectedProducts : state.availableProducts;
    // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
    const filteredOptions = state.options.filter(// @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
    (option_1)=>option_1.isDefault || option_1.isSelected || optionsToProducts[option_1.value]?.some((product)=>products.includes(product)))// This is a temporary hack to filter out Atlas specific types, unless Atlas is the selected product
    .filter(// @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
    (option_2)=>!(state.selectedProducts[0] !== (0, $37AYo.ProductKeys).Atlas && (option_2.value === 'goal' || option_2.value === 'tag')))// Filtering out all options that are tied exclusively to allFilterExcludedProducts for universal types
    // @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
    .filter((option_3)=>!selectedProductsAvailable && optionsToProducts[option_3.value]?.length ? optionsToProducts[option_3.value].some((product_0)=>!state.allFilterExcludedProducts.includes(product_0)) : true);
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupDefined: state.lookup.isDefined,
        isLoading: // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        lookupInput: state.lookup.input,
        options: filteredOptions,
        // @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
        suggestedOptions: filteredOptions.filter((option_4)=>!option_4.isSelected && option_4.isSuggested),
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        selectedOptions: state.selectedOptions,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible
    };
    return [
        viewState,
        viewActions
    ];
};
const $6b472c6e3a208812$export$639eaf0f64f8fe4 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: $6b472c6e3a208812$export$50fdfeece43146fd({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $6b472c6e3a208812$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $6b472c6e3a208812$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: $6b472c6e3a208812$export$ad6c12f692e14555({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $6b472c6e3a208812$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: $6b472c6e3a208812$export$69017055aa8b346e({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: $6b472c6e3a208812$export$92164aa84e23cd67({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: $6b472c6e3a208812$export$d2312e68e1f5ad00({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: $6b472c6e3a208812$export$bf7199a9ebcb84a9({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: $6b472c6e3a208812$export$d0f857db6e3e26d7({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $6b472c6e3a208812$export$8e6bea29334a2099 = (type)=>{
    return type === 'single-select' || type === 'multi-select';
};
const $6b472c6e3a208812$export$50fdfeece43146fd = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $6b472c6e3a208812$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = filter.getOptions({
            isLookupActive: false
        });
        const newOptions = filter.getOptions({
            isLookupActive: state.lookup.isActive
        });
        const selectedOptions = allOptions.filter((option)=>option.isSelected);
        const newState = {
            ...state,
            options: newOptions,
            selectedOptions: selectedOptions,
            hasSelection: selectedOptions.length > 0,
            value: filter.getValue()
        };
        return newState;
    };
};
const $6b472c6e3a208812$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $6b472c6e3a208812$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const filterWithNewOptions = filter.setOption(newOptions);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const hydratedQueryParams = $6b472c6e3a208812$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                }
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $6b472c6e3a208812$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamValue = $6b472c6e3a208812$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.queryParamValue);
        return {
            [initial.queryParams.key]: queryParamValue
        };
    };
};
const $6b472c6e3a208812$export$ad6c12f692e14555 = ({ initial: initial, state: state, config: config })=>{
    return async (onStateChange)=>{
        if (state.didMount) {
            const newDropdownState = {
                ...state
            };
            onStateChange?.(newDropdownState);
            return $6b472c6e3a208812$export$639eaf0f64f8fe4({
                initial: initial,
                state: newDropdownState,
                config: config
            });
        }
        const newOptions = [
            ...state.initialOptions.options
        ];
        const fetcher = initial.initialOptions?.fetcher;
        if (fetcher) {
            const fetchingInitialOptionsState = {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    isLoading: true
                }
            };
            onStateChange?.(fetchingInitialOptionsState);
            try {
                const fetchedOptions = await fetcher(config);
                fetchedOptions.forEach((option)=>{
                    const mappedOption = {
                        isSelected: false,
                        trackingKey: option.trackingKey,
                        value: option.value,
                        queryParamValue: option.queryParamValue,
                        isSuggested: true,
                        isDefault: option.isDefault ?? false,
                        avatarUrl: option.avatarUrl,
                        label: option.label
                    };
                    newOptions.push(mappedOption);
                });
            } catch  {
                const fetchFailedState = {
                    ...state,
                    initialOptions: {
                        ...state.initialOptions,
                        isLoading: false
                    }
                };
                onStateChange?.(fetchFailedState);
            }
        }
        const newInitialOptionsState = {
            ...state,
            didMount: true,
            initialOptions: {
                ...state.initialOptions,
                options: newOptions,
                isLoading: false
            }
        };
        onStateChange?.(newInitialOptionsState);
        return $6b472c6e3a208812$export$639eaf0f64f8fe4({
            initial: initial,
            state: newInitialOptionsState,
            config: config
        });
    };
};
const $6b472c6e3a208812$export$d2312e68e1f5ad00 = ({ initial: initial, state: state })=>{
    return (options)=>{
        const allSelectedValues = new Set([
            ...state.queryParams.options.filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.initialOptions.options.filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.lookup.options.filter((lookupOption)=>lookupOption.isSelected).map((option)=>option.value)
        ]);
        if (options.isLookupActive) {
            const lookupResults = state.lookup.lookupResultOptions.map((option)=>({
                    ...option,
                    isSelected: allSelectedValues.has(option.value)
                }));
            return lookupResults;
        }
        const duplicateOptions = new Set();
        const newOptions = [
            ...state.queryParams.options,
            // Query Params first
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.options,
            ...state.initialOptions.options
        ].filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value) // remove duplicates
        ).map((option)=>({
                ...option,
                isSelected: allSelectedValues.has(option.value)
            }));
        if (initial.sortCompareFn) return newOptions.sort(initial.sortCompareFn);
        return newOptions;
    };
};
const $6b472c6e3a208812$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const optionsToChangeRecord = Object.fromEntries(optionsToChange.map((option)=>[
                option.value,
                option
            ]));
        const queryParamOptions = state.queryParams.options.map((option)=>{
            if (!optionsToChange.find((x)=>x.value === option.value)) return option;
            return {
                ...option,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
            };
        });
        const initialOptions = state.initialOptions.options.map((option)=>{
            if (!optionsToChange.find((x)=>x.value === option.value)) return option;
            return {
                ...option,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
            };
        });
        const duplicateOptions = new Set();
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value) // remove duplicates
        ).map((option)=>({
                ...option,
                isSuggested: true,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? option.isSelected
            }));
        return $6b472c6e3a208812$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $6b472c6e3a208812$export$69017055aa8b346e = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamOptions = state.queryParams.options.map((option)=>{
            const isSuggested = state.initialOptions.options.find((x)=>x.value === option.value)?.isSuggested ?? false;
            return {
                ...option,
                isSuggested: isSuggested,
                isSelected: false
            };
        });
        const initialOptions = state.initialOptions.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const lookupOptions = state.lookup.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        return $6b472c6e3a208812$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $6b472c6e3a208812$export$92164aa84e23cd67 = ({ initial: initial, state: state, config: config })=>{
    return async (query, onStateChange)=>{
        if (!initial.lookup || query.length === 0 || state.lookup.input === query) {
            const noQueryState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: false
                }
            };
            onStateChange?.(noQueryState);
            return $6b472c6e3a208812$export$639eaf0f64f8fe4({
                initial: initial,
                state: noQueryState,
                config: config
            });
        }
        const fetchingLookupOptionsState = {
            ...state,
            lookup: {
                ...state.lookup,
                input: query,
                isLoading: true,
                isActive: true
            }
        };
        onStateChange?.(fetchingLookupOptionsState);
        try {
            const fetchedLookupOptions = await initial.lookup.fetcher(query, config);
            const newLookupOptions = fetchedLookupOptions.map((option)=>{
                const mappedOption = {
                    isSelected: false,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label
                };
                return mappedOption;
            });
            const newLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    lookupResultOptions: newLookupOptions,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(newLookupOptionsState);
            return $6b472c6e3a208812$export$639eaf0f64f8fe4({
                initial: initial,
                state: newLookupOptionsState,
                config: config
            });
        } catch  {
            const failedLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(failedLookupOptionsState);
            return $6b472c6e3a208812$export$639eaf0f64f8fe4({
                initial: initial,
                state: failedLookupOptionsState,
                config: config
            });
        }
    };
};
const $6b472c6e3a208812$export$bf7199a9ebcb84a9 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        return $6b472c6e3a208812$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.value);
    };
};
const $6b472c6e3a208812$export$d0f857db6e3e26d7 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $6b472c6e3a208812$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = [
            ...filter.getOptions({
                isLookupActive: true
            }),
            ...filter.getOptions({
                isLookupActive: false
            })
        ].map((option)=>({
                value: option.value,
                isSelected: false
            }));
        return filter.setOption(allOptions);
    };
};
function $6b472c6e3a208812$var$_temp(option_0) {
    return {
        value: option_0.value,
        isSelected: !option_0.isSelected
    };
}
function $6b472c6e3a208812$var$_temp2(option_1) {
    return !option_1.isSelected && option_1.isSuggested;
}
function $6b472c6e3a208812$var$_temp3(option_0) {
    return {
        value: option_0.value,
        isSelected: !option_0.isSelected
    };
}
function $6b472c6e3a208812$var$_temp4(option_4) {
    return !option_4.isSelected && option_4.isSuggested;
}
module.exports["useSelectFilter"] = $6b472c6e3a208812$export$ac822ab68badd883;
module.exports["useUniversalSelectFilter"] = $6b472c6e3a208812$export$eb312ee1d3a7a748;
module.exports["getState"] = $6b472c6e3a208812$export$50fdfeece43146fd;
module.exports["getQueryParams"] = $6b472c6e3a208812$export$e2de15bbd9edf9c6;
module.exports["setQueryParams"] = $6b472c6e3a208812$export$7755017099c85a0d;
module.exports["loadInitialOptions"] = $6b472c6e3a208812$export$ad6c12f692e14555;
module.exports["setOption"] = $6b472c6e3a208812$export$b2a7969df3fe0aa3;
module.exports["clearOptions"] = $6b472c6e3a208812$export$69017055aa8b346e;
module.exports["setLookupInput"] = $6b472c6e3a208812$export$92164aa84e23cd67;
module.exports["getOptions"] = $6b472c6e3a208812$export$d2312e68e1f5ad00;
module.exports["getValue"] = $6b472c6e3a208812$export$bf7199a9ebcb84a9;
module.exports["deselectOptions"] = $6b472c6e3a208812$export$d0f857db6e3e26d7;
module.exports["isSelectFilter"] = $6b472c6e3a208812$export$8e6bea29334a2099;

});

parcelRegister("fmYqM", function(module, exports) {

var $iueFH = parcelRequire("iueFH");

const $c3c80c6f73a80b4f$export$9c05e038f495cba8 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'multi-select',
        didMount: false,
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$c3c80c6f73a80b4f$export$63027158d47e5479({
                initial: initial,
                state: state,
                config: // This has to be cast back to the correct state
                config
            }),
        getInitialState: (config)=>$c3c80c6f73a80b4f$export$63027158d47e5479({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (filterState)=>{
            return filterState?.id === initial.id;
        },
        isSupportCustomValue: false
    };
};
const $c3c80c6f73a80b4f$export$63027158d47e5479 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $iueFH.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $iueFH.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $iueFH.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $iueFH.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: (0, $iueFH.setOption)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $iueFH.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $iueFH.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iueFH.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $iueFH.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $iueFH.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
module.exports["createMultiSelectFilter"] = $c3c80c6f73a80b4f$export$9c05e038f495cba8;

});

parcelRegister("kv3qA", function(module, exports) {

var $jR2a0 = parcelRequire("jR2a0");


var $7tsC5 = parcelRequire("7tsC5");


var $7Mvs5 = parcelRequire("7Mvs5");

const $8925c181a478ef4f$var$operationName = 'FPSConfluenceSmartUsersQuery';
const $8925c181a478ef4f$var$SmartsRecommendedUserQuery = `
query ${$8925c181a478ef4f$var$operationName}($userId: String!, $tenantId: String!, $maxNumberOfResults: Int!) {
  smarts {
    results: recommendedUser(
      recommendationsQuery: {
        context: {
          userId: $userId
          tenantId: $tenantId
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search"
          experience: "CgUserNearbyUser"
        }
        requestingUserId: $userId
        maxNumberOfResults: $maxNumberOfResults
      }
    ) {
      id
      user {
        accountId
        name
        picture
      }
    }
  }
}
`;
const $8925c181a478ef4f$export$69a3209f1a06c04d = (0, $7Mvs5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $8925c181a478ef4f$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $8925c181a478ef4f$export$74adda2a74e06fa9 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>$8925c181a478ef4f$export$69a3209f1a06c04d.inMemoryDecorator((0, $7tsC5.generateHashFromVariables)(variables), ()=>(0, $jR2a0.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $8925c181a478ef4f$var$SmartsRecommendedUserQuery,
            operationName: $8925c181a478ef4f$var$operationName
        }), $8925c181a478ef4f$var$expireWhen);
module.exports["smartsRecommendedUserQuery"] = $8925c181a478ef4f$export$74adda2a74e06fa9;

});

parcelRegister("lowGd", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $0d7f3a442942b851$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $0d7f3a442942b851$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $0d7f3a442942b851$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $0d7f3a442942b851$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $0d7f3a442942b851$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $0d7f3a442942b851$export$775b6bb06e53a214;

});

parcelRegister("9wFje", function(module, exports) {

var $jR2a0 = parcelRequire("jR2a0");


var $7tsC5 = parcelRequire("7tsC5");


var $7Mvs5 = parcelRequire("7Mvs5");

const $20a40ecdd6707f96$var$operationName = 'SearchEntitiesQuery';
const $20a40ecdd6707f96$var$getSearchEntitiesQuery = ({ includeSpaceKey: includeSpaceKey })=>{
    const SearchConfluenceSpace = `
    ... on SearchConfluenceSpace {
      key
    }
  `;
    return `
  query ${$20a40ecdd6707f96$var$operationName}($experience: String!, $query: String!, $first: Int, $filters: SearchFilterInput!) {
    search {
      results: search(
        experience: $experience
        query: $query
        first: $first
        filters: $filters
      ) {
        edges {
          node {
            id
            title
            type
            url
            iconUrl
            ${includeSpaceKey ? SearchConfluenceSpace : ``}
          }
        }
      }
    }
  }
  `;
};
const $20a40ecdd6707f96$export$69a3209f1a06c04d = (0, $7Mvs5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $20a40ecdd6707f96$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $20a40ecdd6707f96$export$98f1867fd4cb2c65 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, includeSpaceKey: includeSpaceKey })=>$20a40ecdd6707f96$export$69a3209f1a06c04d.inMemoryDecorator((0, $7tsC5.generateHashFromVariables)(variables), ()=>(0, $jR2a0.fetchAgg)({
            variables: {
                first: 20,
                experience: '',
                ...variables
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $20a40ecdd6707f96$var$getSearchEntitiesQuery({
                includeSpaceKey: includeSpaceKey
            }),
            operationName: $20a40ecdd6707f96$var$operationName
        }), $20a40ecdd6707f96$var$expireWhen);
module.exports["searchEntitiesQuery"] = $20a40ecdd6707f96$export$98f1867fd4cb2c65;

});

parcelRegister("2Pix2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $2Va9o = parcelRequire("2Va9o");

const $8991ad99d3fdb5f3$export$c97cd60200241832 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { filterId: filterId } = t0;
    let t1;
    if ($[0] !== filterId) {
        t1 = {
            filterId: filterId
        };
        $[0] = filterId;
        $[1] = t1;
    } else t1 = $[1];
    const [state, storeActions] = (0, $2Va9o.useBooleanFilterStore)(t1);
    let t2;
    if ($[2] !== filterId || $[3] !== state || $[4] !== storeActions) {
        t2 = {
            toggle: ()=>{
                if (!state) return;
                storeActions.setBooleanFilterValue({
                    filterId: filterId,
                    value: !state.value
                });
            }
        };
        $[2] = filterId;
        $[3] = state;
        $[4] = storeActions;
        $[5] = t2;
    } else t2 = $[5];
    const viewActions = t2;
    if (!state) {
        let t3;
        if ($[6] !== viewActions) {
            t3 = [
                ,
                viewActions
            ];
            $[6] = viewActions;
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    const t3 = state.alwaysVisible === false;
    let t4;
    if ($[8] !== state.value || $[9] !== t3) {
        t4 = {
            value: state.value,
            autoFocus: t3
        };
        $[8] = state.value;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const viewState = t4;
    let t5;
    if ($[11] !== viewActions || $[12] !== viewState) {
        t5 = [
            viewState,
            viewActions
        ];
        $[11] = viewActions;
        $[12] = viewState;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ filterId: filterId })=>{
    const [state, storeActions] = (0, $2Va9o.useBooleanFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        toggle: ()=>{
            if (!state) return;
            storeActions.setBooleanFilterValue({
                filterId: filterId,
                value: !state.value
            });
        }
    };
    if (!state) return [
        ,
        viewActions
    ];
    const viewState = {
        value: state.value,
        autoFocus: state.alwaysVisible === false
    };
    return [
        viewState,
        viewActions
    ];
};
const $8991ad99d3fdb5f3$export$2963583aeb05fcae = (initial)=>{
    const initialState = {
        ...initial,
        type: 'boolean',
        value: false,
        hasSelection: false,
        universal: initial.universal
    };
    return {
        id: initial.id,
        type: initialState.type,
        products: initial.products,
        universal: initial.universal,
        queryParams: {
            key: initialState.queryParams.key
        },
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$8991ad99d3fdb5f3$export$cd193ee4357dee7f({
                initial: initial,
                state: state,
                config: // This has to be cast back to the correct state
                config
            }),
        getInitialState: (config)=>$8991ad99d3fdb5f3$export$cd193ee4357dee7f({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (filterState)=>{
            return filterState?.id === initial.id;
        },
        isSupportCustomValue: false
    };
};
const $8991ad99d3fdb5f3$export$cd193ee4357dee7f = ({ initial: initial, state: state, config: config })=>{
    const filterState = {
        ...state,
        hasSelection: state.value
    };
    return {
        ...filterState,
        setValue: $8991ad99d3fdb5f3$var$setValue({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: ()=>filterState.value,
        getState: ()=>filterState,
        queryParams: {
            key: initial.queryParams.key,
            get: $8991ad99d3fdb5f3$var$getQueryParams({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $8991ad99d3fdb5f3$var$setQueryParams({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        clear: $8991ad99d3fdb5f3$var$clear({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $8991ad99d3fdb5f3$var$setValue = ({ initial: initial, state: state, config: config })=>{
    return (value)=>{
        const newState = {
            ...state,
            value: value,
            hasSelection: value
        };
        return $8991ad99d3fdb5f3$export$cd193ee4357dee7f({
            initial: initial,
            state: newState,
            config: config
        });
    };
};
const $8991ad99d3fdb5f3$var$getQueryParams = ({ initial: initial, state: state })=>{
    return ()=>({
            [initial.queryParams.key]: state.value === true ? [
                'true'
            ] : undefined
        });
};
const $8991ad99d3fdb5f3$var$setQueryParams = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams)=>{
        const queryParamValue = queryParams[initial.queryParams.key];
        const booleanValue = queryParamValue?.at(0) === 'true' ? true : false;
        return $8991ad99d3fdb5f3$export$cd193ee4357dee7f({
            initial: initial,
            state: {
                ...state,
                value: booleanValue,
                hasSelection: booleanValue
            },
            config: config
        });
    };
};
const $8991ad99d3fdb5f3$var$clear = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $8991ad99d3fdb5f3$export$cd193ee4357dee7f({
            initial: initial,
            state: state,
            config: config
        });
        return filter.setValue(false);
    };
};
module.exports["useBooleanFilter"] = $8991ad99d3fdb5f3$export$c97cd60200241832;
module.exports["createBooleanFilter"] = $8991ad99d3fdb5f3$export$2963583aeb05fcae;

});

parcelRegister("aXw0m", function(module, exports) {

var $iueFH = parcelRequire("iueFH");

const $0059087ffd1d4e31$export$b77715d04a87c12b = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMount: false,
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$0059087ffd1d4e31$export$767f444f15b8d660({
                initial: initial,
                state: state,
                config: // This has to be cast back to the correct state
                config
            }),
        getInitialState: (config)=>$0059087ffd1d4e31$export$767f444f15b8d660({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (filterState)=>{
            return filterState?.id === initial.id;
        },
        isSupportCustomValue: false
    };
};
const $0059087ffd1d4e31$export$767f444f15b8d660 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $iueFH.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $iueFH.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $iueFH.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $iueFH.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $0059087ffd1d4e31$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $iueFH.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $iueFH.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iueFH.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $iueFH.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $iueFH.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $0059087ffd1d4e31$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.firstSelectedOption?.value === option.value
        };
    };
const $0059087ffd1d4e31$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        // Theoretically this should only ever give you one option to change
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const firstSelectedOption = optionsToChange.at(0);
        const isOptionAlreadySelected = state.options.filter((x)=>x.isSelected).find((x)=>x.value === firstSelectedOption?.value);
        if (isOptionAlreadySelected) // do nothing
        return $0059087ffd1d4e31$export$767f444f15b8d660({
            initial: initial,
            state: state,
            config: config
        });
        const queryParamOptions = state.queryParams.options.map($0059087ffd1d4e31$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const initialOptions = state.initialOptions.options.map($0059087ffd1d4e31$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($0059087ffd1d4e31$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        return $0059087ffd1d4e31$export$767f444f15b8d660({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
module.exports["createSingleSelectFilter"] = $0059087ffd1d4e31$export$b77715d04a87c12b;

});

parcelRegister("gIjvj", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $lCzjG = parcelRequire("lCzjG");


var $37AYo = parcelRequire("37AYo");


var $3Q5mv = parcelRequire("3Q5mv");


var $jpB6G = parcelRequire("jpB6G");


var $a4u49 = parcelRequire("a4u49");

const $1bd5b068aa481654$var$isProductEntitiesIncluded = (availableProducts, product, outboundAuthConfigs)=>{
    if (!(0, $37AYo.products)[product]) return false;
    else if ((0, $37AYo.products)[product]?.is3P) return availableProducts.includes(product) && !outboundAuthConfigs[product]?.userNeedsOAuth;
    else return availableProducts.includes(product);
};
const $1bd5b068aa481654$export$cf63d35399eb18ae = (query, config)=>{
    const allOptions = $1bd5b068aa481654$export$b220eb3fbdd854af(config);
    const matchingOptions = allOptions.filter((option)=>$1bd5b068aa481654$export$e902a1c7f3216533(query, option.label)).map((option)=>({
            label: option.label,
            trackingKey: option.value,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault
        }));
    return matchingOptions;
};
const $1bd5b068aa481654$export$e085e94f90daa6c8 = (products, selectedTypes, outboundAuthConfigs, availableProducts)=>{
    if ((0, $iDrrr.fg)('confluence_performance_improve_search_query')) return $1bd5b068aa481654$export$d9f0dc47e74a61d2({
        products: products,
        selectedTypes: selectedTypes,
        outboundAuthConfigs: outboundAuthConfigs,
        availableProducts: availableProducts
    });
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    const types = selectedTypes.length === 0 ? (0, $lCzjG.allTypeFilterValueKeys) : selectedTypes;
    const typeMapping = (0, $jpB6G.getTypeMapping)();
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    types.forEach((type)=>{
        const productToEntityMap = typeMapping[type].entities;
        products.forEach((product)=>{
            if ($1bd5b068aa481654$var$isProductEntitiesIncluded(products, product, outboundAuthConfigs)) productToEntityMap[product]?.forEach((ati)=>selectedEntities.add(ati));
        });
        // collect unselected entities
        otherProducts.forEach((product)=>{
            if ($1bd5b068aa481654$var$isProductEntitiesIncluded(otherProducts, product, outboundAuthConfigs)) productToEntityMap[product]?.forEach((ati)=>{
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            });
        });
    });
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = Array.from([
        ...selectedEntities,
        ...unselectedEntities
    ]).sort();
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    // This exists to narrow down the possible types for Dynamic Cards
    // This reduces the entities we use for the query to just these two
    const dynamicCardsAllowedATIs = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost'
    ];
    const entitiesForQuery = Array.from(selectedEntities).filter((entity)=>{
        return dynamicCardsAllowedATIs.includes(entity);
    }).sort();
    // Sorting helps a ton in testing
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $1bd5b068aa481654$var$getProductsWithEntities = (products, outboundAuthConfigs)=>{
    return products.reduce((acc, product)=>{
        if ($1bd5b068aa481654$var$isProductEntitiesIncluded(products, product, outboundAuthConfigs)) acc.push(product);
        return acc;
    }, []);
};
const $1bd5b068aa481654$export$d9f0dc47e74a61d2 = ({ products: products, selectedTypes: selectedTypes, outboundAuthConfigs: outboundAuthConfigs, availableProducts: availableProducts })=>{
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    const productsWithEntities = $1bd5b068aa481654$var$getProductsWithEntities(products, outboundAuthConfigs);
    const otherProductsWithEntities = $1bd5b068aa481654$var$getProductsWithEntities(otherProducts, outboundAuthConfigs);
    // Stuff that we can't be cached that easy
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    const types = selectedTypes.length === 0 ? (0, $lCzjG.allTypeFilterValueKeys) : selectedTypes;
    const typeMapping = (0, $jpB6G.getTypeMapping)();
    // Using normal-loop to reduce overhead and improve performance
    for(let i = 0; i < types.length; i++){
        const type = types[i];
        const productToEntityMap = typeMapping[type].entities;
        for(let h = 0; h < productsWithEntities.length; h++){
            const product = productsWithEntities[h];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                selectedEntities.add(ati);
            }
        }
        for(let j = 0; j < otherProductsWithEntities.length; j++){
            const product = productsWithEntities[j];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            }
        }
    }
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = Array.from([
        ...selectedEntities,
        ...unselectedEntities
    ]).sort();
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    // This exists to narrow down the possible types for Dynamic Cards
    // This reduces the entities we use for the query to just these two
    const dynamicCardsAllowedATIs = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost'
    ];
    const entitiesForQuery = Array.from(selectedEntities).filter((entity)=>{
        return dynamicCardsAllowedATIs.includes(entity);
    }).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $1bd5b068aa481654$export$e902a1c7f3216533 = (query, label)=>{
    return label.toLowerCase().includes(query.toLowerCase());
};
const $1bd5b068aa481654$export$b220eb3fbdd854af = (config)=>{
    const typeMapping = (0, $jpB6G.getTypeMapping)();
    const allOption = {
        products: [],
        label: config.intl?.formatMessage((0, $a4u49.typeLabels)['all']) || '',
        value: 'all',
        trackingKey: 'all',
        queryParamValue: (0, $3Q5mv.ContentType)['All'],
        isDefault: true
    };
    // This exists to narrow down the possible types for Dynamic Cards
    // This reduces the types we display in the filter to just these two
    const dynamicCardsAllowedTypes = [
        (0, $lCzjG.TypeFilterValueKey).Page,
        (0, $lCzjG.TypeFilterValueKey).Blogpost
    ];
    const typeOptions = (0, $lCzjG.allTypeFilterValueKeys).filter((type)=>{
        return dynamicCardsAllowedTypes.includes(type);
    }).map((type)=>({
            products: typeMapping[type].products,
            value: type,
            trackingKey: type,
            queryParamValue: type,
            isDefault: false,
            label: config.intl?.formatMessage((0, $a4u49.typeLabels)[type]) || ''
        }));
    return [
        allOption,
        ...typeOptions
    ];
};
module.exports["lookupOptions"] = $1bd5b068aa481654$export$cf63d35399eb18ae;
module.exports["getAllTypeOptions"] = $1bd5b068aa481654$export$b220eb3fbdd854af;
module.exports["getEntitiesForQuery"] = $1bd5b068aa481654$export$e085e94f90daa6c8;

});

parcelRegister("j2fX0", function(module, exports) {
const $b92cabfbea309373$export$5b6173385ccfaeaa = `
... on ExternalBranch {
    name
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalBranchPartial"] = $b92cabfbea309373$export$5b6173385ccfaeaa;

});

parcelRegister("7ED6w", function(module, exports) {
// TODO: >>>> [QS-5465] Add GQL Partial
const $777303d4b8027e9e$export$253480f0254db4f8 = `
`;
module.exports["ExternalCalendarEventPartial"] = $777303d4b8027e9e$export$253480f0254db4f8;

});

parcelRegister("gVX3R", function(module, exports) {
const $c5042acfc0d11406$export$3dcd3e619ad10a8c = `
... on ExternalCommit {
    author {
        user {
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository{
            name
        }
    }
}
`;
module.exports["ExternalCommitPartial"] = $c5042acfc0d11406$export$3dcd3e619ad10a8c;

});

parcelRegister("fN114", function(module, exports) {
const $5394018e7601835e$export$4597d51c3a28368e = `
... on ExternalConversation {
    id
    memberCount
    displayName
    membershipType
    workspace
    topic
    members {
        thirdPartyUser {
            id
            name
        }
        user {
            id
            name
        }
    }
}
`;
module.exports["ExternalConversationPartial"] = $5394018e7601835e$export$4597d51c3a28368e;

});

parcelRegister("2IndL", function(module, exports) {
const $a28783d3d39079df$export$5eda2cda79f28143 = `
... on ExternalDesign {
    thumbnail {
        externalUrl
    }
}
`;
module.exports["ExternalDesignPartial"] = $a28783d3d39079df$export$5eda2cda79f28143;

});

parcelRegister("e3Gso", function(module, exports) {
const $c721300b3226830a$export$6193eef58692a804 = `
... on ExternalDocument {
    type {
        iconUrl
    }
    parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalDocument {
        displayName
        url
        }
    }
}
`;
module.exports["ExternalDocumentPartial"] = $c721300b3226830a$export$6193eef58692a804;

});

parcelRegister("aYMgt", function(module, exports) {
const $8400af8d03900ca5$export$3b9ed83b2b731ba0 = `
... on ExternalMessage {
    lastUpdated
    description
    reactionCount
    attachments {
	    title
        mimeType
        thumbnailUrl
        url
    }
    createdBy {
        thirdPartyUser {
            id
            accountId
            externalId
            name
            email
        }
        user {
            id
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalConversation {
            id
            displayName
            memberCount
            membershipType
            type
            members {
                thirdPartyUser {
                    id
                    name
                }
            }
        }
    }
    associatedWith {
        edges {
            node {
                id
                createdBy {
                    thirdPartyUser {
                        id
                        accountId
                        externalId
                        name
                        email
                    }
                }
                entity {
					__typename
					... on ExternalConversation {
						id
						displayName
						channelId:externalId
					}
					... on ThirdPartyUser {
                        id
                        name
						externalId
                    }
                }
            }
        }
    }
}
`;
module.exports["ExternalMessagePartial"] = $8400af8d03900ca5$export$3b9ed83b2b731ba0;

});

parcelRegister("8yv9u", function(module, exports) {
const $834f0df3a8127289$export$fa7eefb2a03609fe = `
... on ExternalPullRequest {
    title
    lastUpdate
	pullRequestId
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalPullRequestPartial"] = $834f0df3a8127289$export$fa7eefb2a03609fe;

});

parcelRegister("fs9dB", function(module, exports) {
const $fa94a648f99e0c28$export$82972f33e243e789 = `
... on ExternalRepository {
    name
}
`;
module.exports["ExternalRepositoryPartial"] = $fa94a648f99e0c28$export$82972f33e243e789;

});

parcelRegister("2UJLP", function(module, exports) {
const $bd71c14cc08ac7a3$export$d872aa2b0db5eb10 = `
... on ExternalVideo {
    durationInSeconds
    thumbnailUrl
    chapters {
        title
        startTimeInSeconds
    }
    createdBy {
        thirdPartyUser {
            id
            email
            name
        }
        user {
            name
        }
    }
}
`;
module.exports["ExternalVideoPartial"] = $bd71c14cc08ac7a3$export$d872aa2b0db5eb10;

});

parcelRegister("1Dxn6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $6b6a8d2660c708b0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ['atlassian-web-crawler']: {
        id: "dynamic-cards-search-page.products.custom-website",
        defaultMessage: "Web page"
    }
});
module.exports["messages"] = $6b6a8d2660c708b0$export$defe85febe8b728c;

});

parcelRegister("b85jh", function(module, exports) {
const $9a404b4f6d4e2957$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $9a404b4f6d4e2957$export$d35186a762cd39c8;

});

parcelRegister("2Va9o", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");


var $9Ppk1 = parcelRequire("9Ppk1");

var $bzYTC = parcelRequire("bzYTC");

var $4XdCR = parcelRequire("4XdCR");


var $db9XH = parcelRequire("db9XH");


var $lCzjG = parcelRequire("lCzjG");


var $37AYo = parcelRequire("37AYo");


var $bU7gQ = parcelRequire("bU7gQ");


var $4mebe = parcelRequire("4mebe");


var $iueFH = parcelRequire("iueFH");


var $gIjvj = parcelRequire("gIjvj");


var $62FDZ = parcelRequire("62FDZ");

const $26df14207fbe0be0$var$initialState = {
    // Search Input states
    inputQuery: '',
    searchQuery: '',
    // Product States
    primaryProduct: null,
    // Filter States
    filters: {},
    filterSelectionOrder: [],
    selectedProducts: [],
    availableProducts: [],
    allFilterExcludedProducts: [],
    // Rest of store states
    resultsSort: {
        field: (0, $4XdCR.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
        order: (0, $4XdCR.SORT_ORDER).DESC
    },
    retryCount: 0,
    version: 1,
    queryUpdatedTime: Date.now(),
    isLoading: false,
    isJiraHydrationLoading: false,
    isCompassTeamsLoading: false,
    shownCount: 0,
    results: undefined,
    resultError: undefined,
    productResultCountMap: null,
    paginationTokens: [],
    isLoadingMore: false
};
const $26df14207fbe0be0$var$convertQueryParamsToStringArray = (queryParams, keys)=>{
    return keys.reduce((acc, key)=>{
        if (queryParams[key] === undefined) return acc;
        if (Array.isArray(queryParams[key])) return {
            ...acc,
            [key]: queryParams[key]
        };
        if (typeof queryParams[key] === 'string' || typeof queryParams[key] === 'boolean') return {
            ...acc,
            [key]: [
                queryParams[key].toString()
            ]
        };
        return acc;
    }, {});
};
const $26df14207fbe0be0$var$getUpdatedFilterSelectionOrder = (previousOrder, newFilterId, selected)=>{
    let filterSelectionOrder = new Set([
        ...previousOrder,
        newFilterId
    ]);
    if (!selected) filterSelectionOrder.delete(newFilterId);
    return [
        ...filterSelectionOrder
    ];
};
/**
 * Only these keys can get set before the updateQueryParams loop when updateQueryParams=true in setSearchStoreState
 */ const $26df14207fbe0be0$var$safeStateKeys = [
    'filterSelectionOrder',
    'retryCount',
    'paginationTokens'
];
/**
 * Please use setSearchStoreState instead of setState within the Search Store controller.
 *
 * This is because we treat the URL as the source of truth for some state. Filter value states are set in the URL directly and then we listen to URL state changs to represent them in our state.
 *
 * @param newState - state properties to set
 * @param {boolean} options.updateQueryParams - [false] Whether a setState call should trigger an URL update
 *
 * Notes on updateQueryParams:
 *
 * When false, this function acts like a standard setState
 * When true, this function will allow only the {safeStateKeys} to be set and will then use the provided query/filter etc state to set the URL directly, relying on the URL observer to complete the loop
 *
 * Non-url updates should NEVER trigger the setQueryParams callback. Otherwise, this will cause infinite loops or extra render cycles.
 **/ const $26df14207fbe0be0$var$setSearchStoreState = (newState, options)=>({ getState: getState, setState: setState }, { setQueryParams: setQueryParams, allFilters: allFilters, config: config })=>{
        // TODO future refactoring: we should instead query the newState object for any URL-state changes, then clean up the setState we perform, then update the URL. Then a consumer of this function will not need to care about any of this and can simply pass `newState` as expected
        if (!options?.updateQueryParams) {
            setState(newState);
            return;
        }
        // We still want to set variables in state that do NOT participate in the URL
        // Initially we'll allow-list this set, as the set of filters (the disallow set) will grow over time
        const safeNewState = Object.fromEntries(Object.entries(newState).filter(([key])=>$26df14207fbe0be0$var$safeStateKeys.includes(key)));
        if (Object.keys(safeNewState).length > 0) setState(safeNewState);
        const { searchQuery: newSearchQuery, inputQuery: newInputQuery } = newState;
        const { inputQuery: oldInputQuery } = getState();
        const { selectedProducts: selectedProducts, filters: allFilterStates, resultsSort: newResultsSort } = {
            ...getState(),
            ...newState
        };
        const staticFilters = Object.values(allFilters).filter((f)=>{
            const filterState = f.getInitialState(config).getState();
            return selectedProducts.length === 0 ? filterState.universal : filterState.products.some((product)=>selectedProducts.includes(product));
        });
        const filterQueryParamValues = staticFilters.map((staticFilter)=>{
            const filterState = allFilterStates[staticFilter.id];
            if (!staticFilter.isCompatible(filterState)) return {};
            return staticFilter.withState(filterState, config).queryParams.get();
        });
        const filterQueryParams = Object.assign({}, ...filterQueryParamValues);
        const text = [
            newSearchQuery,
            newInputQuery,
            oldInputQuery
        ].find(Boolean);
        const parsedQueryParams = (0, $bU7gQ.parseQueryParams)({
            product: selectedProducts?.[0],
            text: text !== '' ? text : undefined,
            ...filterQueryParams,
            ...newResultsSort && {
                sortField: newResultsSort.field,
                sortOrder: newResultsSort.order
            }
        }, {
            commaSeparatedValues: true
        });
        setQueryParams(parsedQueryParams);
    };
const $26df14207fbe0be0$export$f14fed79ef571627 = $26df14207fbe0be0$var$setSearchStoreState;
const $26df14207fbe0be0$var$privateStoreActions = {
    initialiseStore: ()=>async ({ dispatch: dispatch }, { allFilters: allFilters, queryParams: queryParams, config: config, setQueryParams: setQueryParams, availableProducts: availableProducts, allFilterExcludedProducts: allFilterExcludedProducts })=>{
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct, isMissingProductSelection: isMissingProductSelection } = (0, $62FDZ.FilterUtils)(allFilters, {});
            const selectedProducts = getSelectedProducts(queryParams);
            if (isMissingProductSelection(queryParams)) {
                setQueryParams({
                    ...queryParams,
                    product: selectedProducts[0]
                });
                return;
            }
            const { staticFilterValues: staticFiltersByProduct } = filtersByProduct(selectedProducts);
            const resolvedQueryParams = await Promise.allSettled(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            staticFiltersByProduct.map((staticFilter)=>{
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                return staticFilter.getInitialState(config).queryParams.set($26df14207fbe0be0$var$convertQueryParamsToStringArray(queryParams, queryParamsKeys));
            }));
            const filterStatesByProduct = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: filterStates } = (0, $62FDZ.FilterUtils)(staticFiltersByProduct, filterStatesByProduct);
            const sortField = queryParams.sortField || $26df14207fbe0be0$var$initialState.resultsSort.field;
            const sortOrder = queryParams.sortOrder || $26df14207fbe0be0$var$initialState.resultsSort.order;
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                filters: filterStates,
                resultsSort: {
                    field: sortField,
                    order: sortOrder
                },
                selectedProducts: selectedProducts,
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                availableProducts: availableProducts,
                allFilterExcludedProducts: allFilterExcludedProducts
            }, {
                updateQueryParams: false // onInit should not update the query params
            }));
        },
    // TODO QS-4438 move this out to be private/unsafe like setSearchStoreState
    updateStore: ()=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, queryParams: queryParams, config: config, availableProducts: availableProducts })=>{
            const { filters: filterStates, inputQuery: inputQuery, searchQuery: searchQuery, originalQuery: originalQuery } = getState();
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct } = (0, $62FDZ.FilterUtils)(allFilters, filterStates);
            const selectedProducts = getSelectedProducts(queryParams);
            const { staticFilterValues: staticFiltersByProduct, filterStates: filterStatesByProduct } = filtersByProduct(selectedProducts);
            const resolvedQueryParams = await Promise.allSettled(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            staticFiltersByProduct.map((staticFilter)=>{
                const filterState = filterStatesByProduct[staticFilter.id];
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                const queryParamStringArray = $26df14207fbe0be0$var$convertQueryParamsToStringArray(queryParams, queryParamsKeys);
                if (!staticFilter.isCompatible(filterState)) return staticFilter.getInitialState(config).queryParams.set(queryParamStringArray);
                return staticFilter.withState(filterState, config).queryParams.set(queryParamStringArray);
            }));
            const fullfilledFilterStates = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { getFiltersWithSelection: getFiltersWithSelection, filterStates: resolvedFilterStates } = (0, $62FDZ.FilterUtils)(staticFiltersByProduct, fullfilledFilterStates);
            // In order, ensure all filters with values are added to selection
            // Ensures filters enter selection order from resume-from-url
            // TODO: this should be done with the global ordering, but we don't have that in constants yet
            let { filterSelectionOrder: filterSelectionOrder } = getState();
            getFiltersWithSelection().map((filterId)=>{
                filterSelectionOrder = $26df14207fbe0be0$var$getUpdatedFilterSelectionOrder(filterSelectionOrder, filterId, resolvedFilterStates[filterId]?.hasSelection);
            });
            const sortField = queryParams.sortField || $26df14207fbe0be0$var$initialState.resultsSort.field;
            const sortOrder = queryParams.sortOrder || $26df14207fbe0be0$var$initialState.resultsSort.order;
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                filters: resolvedFilterStates,
                resultsSort: {
                    field: sortField,
                    order: sortOrder
                },
                selectedProducts: getSelectedProducts(queryParams),
                filterSelectionOrder: filterSelectionOrder,
                inputQuery: String(queryParams.text ?? inputQuery),
                searchQuery: String(queryParams.text ?? searchQuery),
                originalQuery: String(queryParams.originalQuery ?? originalQuery),
                availableProducts: availableProducts,
                paginationTokens: []
            }, {
                updateQueryParams: false
            } // onUpdate lifecycle should never update the query params
            ));
        },
    setFilter: (state, shouldSetQueryParams)=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, config: config })=>{
            const staticFilter = allFilters[state.id];
            const { filters: allFiltersState } = getState();
            if (!staticFilter.isCompatible(state)) return;
            const filterWithState = staticFilter.withState(state, config).getState();
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                filters: {
                    ...allFiltersState,
                    [staticFilter.id]: filterWithState
                }
            }, {
                updateQueryParams: shouldSetQueryParams
            }));
        },
    updateFilterSelectionOrder: (filterId, selected)=>async ({ dispatch: dispatch, getState: getState })=>{
            const { filterSelectionOrder: oldSelectionOrder } = getState();
            const newFilterSelectionOrder = $26df14207fbe0be0$var$getUpdatedFilterSelectionOrder(oldSelectionOrder, filterId, selected);
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                filterSelectionOrder: newFilterSelectionOrder
            }));
        }
};
const $26df14207fbe0be0$export$e324594224ef24da = {
    loadInitialSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState) || !(0, $iueFH.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilter = staticSelectFilter.withState(filterState, config);
            // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
            await newFilter.loadInitialOptions((stateChange)=>{
                dispatch($26df14207fbe0be0$var$privateStoreActions.setFilter(stateChange));
            });
        },
    clearSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState) || !(0, $iueFH.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilterState = staticSelectFilter.withState(filterState, config).clear().getState();
            dispatch($26df14207fbe0be0$var$privateStoreActions.setFilter(newFilterState, true));
            dispatch($26df14207fbe0be0$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    setSelectFilterOption: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState) || !(0, $iueFH.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilterState = staticSelectFilter.withState(filterState, config)// @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
            .setOption(props.optionChange, props.customValue).getState();
            dispatch($26df14207fbe0be0$var$privateStoreActions.setFilter(newFilterState, true));
            dispatch($26df14207fbe0be0$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    setSelectFilterLookupInput: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState) || !(0, $iueFH.isSelectFilter)(staticSelectFilter.type)) return;
            await staticSelectFilter.withState(filterState, config)// @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
            .setLookupInput(props.query, (stateChange)=>{
                dispatch($26df14207fbe0be0$var$privateStoreActions.setFilter(stateChange));
            });
        },
    setBooleanFilterValue: (props, privateActions = $26df14207fbe0be0$var$privateStoreActions)=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticBooleanFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticBooleanFilter.isCompatible(filterState)) return;
            if (staticBooleanFilter.type !== 'boolean') return;
            const newBooleanFilterState = staticBooleanFilter.withState(filterState, config).setValue(props.value).getState();
            dispatch(privateActions.setFilter(newBooleanFilterState, true));
            dispatch(privateActions.updateFilterSelectionOrder(props.filterId, newBooleanFilterState.hasSelection));
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    clearAllFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const staticFilters = Object.values(allFilters);
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                filters: $26df14207fbe0be0$var$clearFilters(allFilterStates, staticFilters, config),
                selectedProducts: [],
                filterSelectionOrder: []
            }, {
                updateQueryParams: true
            }));
        },
    clearAllAvailableFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticFilters = Object.values(allFilters);
            const { filters: allFilterStates } = getState();
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                filters: $26df14207fbe0be0$var$clearFilters(allFilterStates, staticFilters, config),
                filterSelectionOrder: [],
                resultsSort: $26df14207fbe0be0$var$initialState.resultsSort
            }, {
                updateQueryParams: true
            }));
        },
    // Product filter actions
    selectProductFilter: (productKey)=>({ getState: getState, dispatch: dispatch })=>{
            const { selectedProducts: selectedProducts, filters: filters, filterSelectionOrder: filterSelectionOrder } = getState();
            if (productKey && selectedProducts.includes(productKey)) return;
            const persistedFilters = {};
            // Persist selected universal filters if they are relevant to the selected product
            for (const [id, filter] of Object.entries(filters)){
                if (!filter) continue;
                if (filter.universal && filter.hasSelection && (!productKey || productKey && filter.products.includes(productKey))) persistedFilters[id] = filter;
            }
            // Type is a universal filter, but type needs to be cleared if we're filtering away from Atlas
            // This is because selecting a global noun sets product AND type values
            if (selectedProducts.includes((0, $37AYo.ProductKeys).Atlas)) delete persistedFilters[0, $lCzjG.universalTypeFilterId];
            // Universal filters being persisted also retain their ordering
            const newFilterSelectionOrder = filterSelectionOrder.filter((f)=>{
                return Object.keys(persistedFilters).includes(f);
            });
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                selectedProducts: productKey ? [
                    productKey
                ] : [],
                filterSelectionOrder: newFilterSelectionOrder,
                filters: persistedFilters,
                resultsSort: $26df14207fbe0be0$var$initialState.resultsSort
            }, {
                updateQueryParams: true
            }));
        },
    // TODO: >>>> QS-4163 After removing the old search store, merge selectProductFilter and unselectProductFilter
    // together as they do the same thing
    unselectProductFilter: (productKey)=>({ getState: getState, dispatch: dispatch })=>{
            const { selectedProducts: selectedProducts } = getState();
            if (selectedProducts.includes(productKey)) dispatch($26df14207fbe0be0$export$e324594224ef24da.selectProductFilter(undefined));
        },
    // Search Input Actions
    setInputQuery: (inputQuery)=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                inputQuery: inputQuery.trim()
            }));
        },
    setSearchQuery: (searchQuery)=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                searchQuery: searchQuery.trim()
            }, {
                updateQueryParams: true
            }));
        },
    triggerSearch: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { inputQuery: inputQuery, searchQuery: searchQuery, retryCount: retryCount, productResultCountMap: productResultCountMap } = getState();
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                productResultCountMap: searchQuery === inputQuery ? productResultCountMap : null
            }));
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                searchQuery: inputQuery,
                retryCount: searchQuery === inputQuery ? retryCount + 1 : 0
            }, {
                updateQueryParams: true
            }));
        },
    retrySearch: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                retryCount: getState().retryCount + 1
            }));
        },
    setResultsSort: ({ field: field, order: order })=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                resultsSort: {
                    field: field,
                    order: order
                },
                paginationTokens: []
            }, {
                updateQueryParams: true
            }));
        },
    resetSort: ()=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                resultsSort: $26df14207fbe0be0$var$initialState.resultsSort,
                paginationTokens: []
            }));
        },
    // Rest of Search Actions
    setQueryUpdatedTime: ()=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                queryUpdatedTime: Date.now()
            }));
        },
    incrementVersion: ()=>({ dispatch: dispatch, getState: getState })=>{
            const { version: version } = getState();
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                version: version + 1
            }));
        },
    setIsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                isLoading: isLoading
            }));
        },
    // Results actions
    setResults: (results, error, requestId)=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                isLoading: false,
                results: results,
                resultError: error,
                requestId: requestId
            }));
        },
    appendMoreResults: (results)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: currentResults } = getState();
            if (!currentResults || !results) return;
            const currentEdges = currentResults.edges;
            const newEdges = results.edges;
            const newResults = {
                ...currentResults,
                edges: currentEdges.concat(newEdges),
                pageInfo: results?.pageInfo
            };
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                results: newResults,
                isLoadingMore: false
            }));
        },
    setFetchFromCursor: (cursor)=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                paginationTokens: [
                    {
                        cursor: cursor
                    }
                ]
            }));
        },
    setIsLoadingMore: (isLoadingMore)=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                isLoadingMore: isLoadingMore
            }));
        },
    setJiraIssueFieldsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                isJiraHydrationLoading: isLoading
            }));
        },
    setJiraIssueDetails: (issueData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let hydratedResults = [];
            if (results?.edges && results.edges.length > 0 && issueData.length > 0) {
                hydratedResults = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $bzYTC.isSearchResultJiraIssue)(edge.node)) {
                        const id = edge.node.id;
                        const hydratedIssue = issueData.find((issue)=>issue.id === id);
                        if (edge.node.status && hydratedIssue) edge.node.status.name = hydratedIssue.statusField.status.name;
                    }
                    return edge;
                });
                dispatch($26df14207fbe0be0$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: hydratedResults
                    }
                }));
            }
        },
    setCompassTeamsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                isCompassTeamsLoading: isLoading
            }));
        },
    setCompassTeams: (teamData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let resultsWithTeamNames = [];
            if (results?.edges && results.edges.length > 0 && teamData.length > 0) {
                resultsWithTeamNames = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $9Ppk1.isSearchCompassPartial)(edge.node)) {
                        const teamId = (0, $4mebe.getTeamId)(edge.node.ownerId);
                        const team = teamData.find((team)=>team.id === teamId);
                        edge.node.ownerName = team?.displayName;
                    }
                    return edge;
                });
                dispatch($26df14207fbe0be0$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: resultsWithTeamNames
                    }
                }));
            }
        },
    resetResults: ()=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                isLoading: false,
                shownCount: 0,
                results: undefined,
                resultError: undefined,
                requestId: undefined
            }));
        },
    setAutoCorrection: (autoCorrection)=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                autoCorrection: autoCorrection
            }));
        },
    setProductResultCount: (totalCounts)=>({ dispatch: dispatch, getState: getState })=>{
            if (totalCounts === undefined) {
                dispatch($26df14207fbe0be0$var$setSearchStoreState({
                    productResultCountMap: null
                }));
                return;
            }
            const { productResultCountMap: oldProductResultCountMap } = getState();
            const productResultCountMap = totalCounts.reduce((acc, { product: product, count: count })=>{
                if (product) acc[product] = count;
                return acc;
            }, {});
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                productResultCountMap: {
                    ...oldProductResultCountMap,
                    ...productResultCountMap
                }
            }));
        },
    // For backwards compatibility
    clearHybridFilters: ()=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$export$e324594224ef24da.clearAllFilters());
        },
    /**
   * Considered unsafe since it's using queryParams to change the state.
   * Ideally we should set it directly in the state, but that requires introducing a new action.
   * This is because the cooresponding "Type" filter that this selects isn't available or easy to set from outside
   * The product=townsquare&type=project will correctly hydrate the filter from the URL after params are set though!
   *
   * We hope to improve Atlassian Home / global noun handling after GA
   *
   * @param value: a noun to be set
   */ unsafe_setAtlasNouns: (value)=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams })=>{
            dispatch($26df14207fbe0be0$var$setSearchStoreState({
                productResultCountMap: null
            }));
            if (!value) {
                const { product: product, type: type, ...queryParamsWithResetNounFilter } = queryParams;
                setQueryParams({
                    ...queryParamsWithResetNounFilter
                });
            } else {
                const { text: text, originalQuery: originalQuery, lastModified: lastModified } = queryParams;
                // We explicityly only keep text and lastModified
                setQueryParams({
                    product: (0, $37AYo.ProductKeys).Atlas,
                    type: value,
                    text: text,
                    originalQuery: originalQuery,
                    lastModified: lastModified
                });
            }
        }
};
const $26df14207fbe0be0$var$clearFilters = (allFilterStates, filters, config)=>{
    const clearedFilters = filters.map((filter)=>{
        const filterState = allFilterStates[filter.id];
        if (!filter.isCompatible(filterState)) return [];
        return [
            filter.id,
            filter.withState(filterState, config).clear().getState()
        ];
    });
    return Object.fromEntries(clearedFilters);
};
// Keep store private and use hooks to access state and actions
const $26df14207fbe0be0$var$Store = (0, $8s9DV.createStore)({
    initialState: $26df14207fbe0be0$var$initialState,
    actions: $26df14207fbe0be0$export$e324594224ef24da,
    name: 'dynamic-cards-search'
});
const $26df14207fbe0be0$export$b8f9c0e048639dd4 = (0, $kBr4q.createActionsHook)($26df14207fbe0be0$var$Store);
const $26df14207fbe0be0$export$bf072992274c9fb = (0, $j8on0.createContainer)($26df14207fbe0be0$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$privateStoreActions.initialiseStore());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch($26df14207fbe0be0$var$privateStoreActions.updateStore());
        },
    onCleanup: ()=>({ setState: setState })=>{
            setState($26df14207fbe0be0$var$initialState);
        }
});
const $26df14207fbe0be0$export$bd221a7c56b93941 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store);
const $26df14207fbe0be0$export$c5a5afdff2ff0385 = (0, $kBr4q.createActionsHook)($26df14207fbe0be0$var$Store);
const $26df14207fbe0be0$export$973ca22476b0e05f = (0, $kBr4q.createStateHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.filters
});
const $26df14207fbe0be0$export$da992673b1309795 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.inputQuery
});
const $26df14207fbe0be0$export$e985158d10c27e34 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.searchQuery
});
const $26df14207fbe0be0$export$c2380c4d76e63cc4 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.originalQuery
});
const $26df14207fbe0be0$export$ba2ad669c5b27bca = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.autoCorrection
});
const $26df14207fbe0be0$export$140d37088821fcb1 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.retryCount
});
const $26df14207fbe0be0$export$275c72361969d62c = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.productResultCountMap
});
const $26df14207fbe0be0$export$14279a3fbdb52451 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.results?.abTest
});
const $26df14207fbe0be0$export$34418e307d9100b4 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.results?.queryInfo
});
const $26df14207fbe0be0$export$8a4c65ea4f241b48 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.searchQuery ? (0, $db9XH.QueryState).POSTQUERY : (0, $db9XH.QueryState).PREQUERY
});
const $26df14207fbe0be0$export$a2b38489a4538322 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.queryUpdatedTime
});
const $26df14207fbe0be0$export$bda9ac73817ceec3 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.results
});
const $26df14207fbe0be0$export$1c9622ace43d770d = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.resultError
});
const $26df14207fbe0be0$export$49f5dec896c355cd = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.requestId
});
const $26df14207fbe0be0$export$4dface15d86304a4 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.isLoading
});
const $26df14207fbe0be0$export$f59185497e80e274 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.resultsSort
});
const $26df14207fbe0be0$export$826bdf756a8bf13a = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.selectedProducts
});
const $26df14207fbe0be0$export$387e1da2bc9c93cc = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.selectedProducts[0]
});
const $26df14207fbe0be0$export$8c11ef422551818 = (0, $kBr4q.createStateHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.isJiraHydrationLoading
});
const $26df14207fbe0be0$export$795623048d841bf2 = (0, $kBr4q.createStateHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.isCompassTeamsLoading
});
const $26df14207fbe0be0$export$8dc083eb9766b48 = (0, $kBr4q.createStateHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.availableProducts && state.availableProducts.length > 0
});
const $26df14207fbe0be0$export$e80788222dba30a3 = (0, $kBr4q.createStateHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.results?.pageInfo?.endCursor
});
const $26df14207fbe0be0$export$bedf78a7ab879711 = (0, $kBr4q.createStateHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.paginationTokens[0]?.cursor
});
const $26df14207fbe0be0$export$f258398dab7c75ba = (0, $kBr4q.createStateHook)($26df14207fbe0be0$var$Store, {
    selector: (state)=>state.isLoadingMore
});
const $26df14207fbe0be0$export$964e8498268f0fe3 = (0, $kBr4q.createStateHook)($26df14207fbe0be0$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.selectedProducts.at(0),
        (state)=>state.selectedProducts[0] ? [
                state.selectedProducts[0]
            ] : state.availableProducts,
        (state)=>state.availableProducts
    ], (selectedProduct, filteredProducts, availableProducts)=>({
            selectedProduct: selectedProduct,
            filteredProducts: filteredProducts,
            availableProducts: availableProducts
        }))
});
const $26df14207fbe0be0$export$6466dd1b74ba3dff = (productsToSearch, typeFilter, outboundAuthConfigs, availableProducts)=>{
    // This early return is to appease Typescript. The typeFilter is always defined and is always single select.
    if (!typeFilter || !(typeFilter.type === 'single-select')) return {
        selectedEntities: [],
        entitiesForQuery: [],
        entitiesForResultsCountQuery: []
    };
    const defaultOptionValue = typeFilter.options?.find((option)=>option.isDefault)?.value;
    const selectedTypes = typeFilter.value.filter((value)=>value !== defaultOptionValue).filter(Boolean);
    const { entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $gIjvj.getEntitiesForQuery)(productsToSearch, selectedTypes, outboundAuthConfigs, availableProducts);
    return {
        selectedEntities: selectedTypes,
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $26df14207fbe0be0$export$59086fbf0d8f8d2a = (0, $kBr4q.createStateHook)($26df14207fbe0be0$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>{
            // Filter out excluded products from "All" filter
            const allFilterIncludedProducts = state.availableProducts.filter((product)=>!state.allFilterExcludedProducts.includes(product));
            return state.selectedProducts[0] ? [
                state.selectedProducts[0]
            ] : allFilterIncludedProducts;
        },
        (state)=>state.filters[0, $lCzjG.universalTypeFilterId],
        (_, props)=>props.outboundAuthConfigs,
        (state)=>state.availableProducts
    ], (productsToSearch, typeFilter, outboundAuthConfigs, availableProducts)=>$26df14207fbe0be0$export$6466dd1b74ba3dff(productsToSearch, typeFilter, outboundAuthConfigs, availableProducts))
});
const $26df14207fbe0be0$export$aad641f503e4b4a8 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (!(0, $iueFH.isSelectFilter)(filter.type)) throw new Error('Not a select filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            availableProducts: state.availableProducts,
            allFilterExcludedProducts: state.allFilterExcludedProducts
        };
    }
});
const $26df14207fbe0be0$export$c724ec2cbd2fedce = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (filter?.type !== 'boolean') throw new Error('Not a boolean filter');
        return filter;
    }
});
const $26df14207fbe0be0$export$1c5018e1c1ce99ae = (filters)=>{
    const filterIdOrdering = (0, $lCzjG.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.universal ? [
            filter
        ] : [];
    });
};
const $26df14207fbe0be0$export$a8734449e402b6ca = (filters, selectedProducts)=>{
    const filterIdOrdering = (0, $lCzjG.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && selectedProducts.some((product)=>filter?.products.includes(product)) ? [
            filter
        ] : [];
    });
};
/**
 * All available filters in the initial ordering
 */ const $26df14207fbe0be0$var$getAllAvailableFilters = (filters, selectedProducts)=>{
    return selectedProducts.length === 0 ? $26df14207fbe0be0$export$1c5018e1c1ce99ae(filters) : $26df14207fbe0be0$export$a8734449e402b6ca(filters, selectedProducts);
};
/**
 * All available filters are always returned for inline, but the ordering depends on selection
 * The caller UI is responsible for deciding how many can be rendered by available width
 */ const $26df14207fbe0be0$var$getFilterIdsForInline = (filters, selectedProducts, filterSelectionOrder)=>{
    const allAvailableFilterIds = $26df14207fbe0be0$var$getAllAvailableFilters(filters, selectedProducts).map((a)=>a.id);
    // using the selection order, filter from the available (removes any invalid filters to show)
    let filtersForInline = filterSelectionOrder.filter((f)=>allAvailableFilterIds.includes(f));
    // then simply add the rest back (with a set for deduplication)
    return [
        ...new Set([
            ...filtersForInline,
            ...allAvailableFilterIds
        ])
    ];
};
const $26df14207fbe0be0$export$94c94f88577d66b2 = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: ({ filters: filters, selectedProducts: selectedProducts, filterSelectionOrder: filterSelectionOrder })=>{
        // All filters always show in the dropdown, in order
        const filtersInDropdown = $26df14207fbe0be0$var$getAllAvailableFilters(filters, selectedProducts).map((f)=>f.id);
        const filtersInLine = $26df14207fbe0be0$var$getFilterIdsForInline(filters, selectedProducts, filterSelectionOrder);
        return {
            filtersInDropdown: filtersInDropdown,
            filtersInLine: filtersInLine,
            filterSelectionOrder: filterSelectionOrder
        };
    }
});
const $26df14207fbe0be0$export$754cc306c2d9241e = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters, resultsSort: resultsSort })=>{
        const selectedFilters = Object.values(filters).filter((filter)=>filter?.hasSelection).filter((filter)=>{
            const isAtlasSelected = selectedProducts.includes((0, $37AYo.ProductKeys).Atlas);
            const isTypeFilter = filter?.id === (0, $lCzjG.universalTypeFilterId);
            return isAtlasSelected ? !isTypeFilter : true;
        });
        const { field: field, order: order } = resultsSort;
        const isSortedByDefault = field === $26df14207fbe0be0$var$initialState.resultsSort.field && order === $26df14207fbe0be0$var$initialState.resultsSort.order;
        return {
            selectedFilterCount: selectedFilters.length + (isSortedByDefault ? 0 : 1)
        };
    }
});
const $26df14207fbe0be0$export$210935c1afa2c65c = (0, $kBr4q.createHook)($26df14207fbe0be0$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters })=>{
        const hasSelectedProduct = selectedProducts[0];
        if (hasSelectedProduct) return true;
        return Object.values(filters).some((filter)=>filter?.hasSelection);
    }
});
module.exports["SearchStoreContainer"] = $26df14207fbe0be0$export$bf072992274c9fb;
module.exports["useSearchActions"] = $26df14207fbe0be0$export$c5a5afdff2ff0385;
module.exports["useFilters"] = $26df14207fbe0be0$export$973ca22476b0e05f;
module.exports["useInputQuery"] = $26df14207fbe0be0$export$da992673b1309795;
module.exports["useSearchQuery"] = $26df14207fbe0be0$export$e985158d10c27e34;
module.exports["useOriginalQuery"] = $26df14207fbe0be0$export$c2380c4d76e63cc4;
module.exports["useAutoCorrection"] = $26df14207fbe0be0$export$ba2ad669c5b27bca;
module.exports["useRetryCount"] = $26df14207fbe0be0$export$140d37088821fcb1;
module.exports["useResults"] = $26df14207fbe0be0$export$bda9ac73817ceec3;
module.exports["useResultsError"] = $26df14207fbe0be0$export$1c9622ace43d770d;
module.exports["useResultsRequestId"] = $26df14207fbe0be0$export$49f5dec896c355cd;
module.exports["useIsLoading"] = $26df14207fbe0be0$export$4dface15d86304a4;
module.exports["useResultsSort"] = $26df14207fbe0be0$export$f59185497e80e274;
module.exports["useSelectedProduct"] = $26df14207fbe0be0$export$387e1da2bc9c93cc;
module.exports["useIsJiraHydrationLoading"] = $26df14207fbe0be0$export$8c11ef422551818;
module.exports["useIsCompassTeamsLoading"] = $26df14207fbe0be0$export$795623048d841bf2;
module.exports["useIsSearchReady"] = $26df14207fbe0be0$export$8dc083eb9766b48;
module.exports["usePageEndCursor"] = $26df14207fbe0be0$export$e80788222dba30a3;
module.exports["useFetchFromCursor"] = $26df14207fbe0be0$export$bedf78a7ab879711;
module.exports["useIsLoadingMore"] = $26df14207fbe0be0$export$f258398dab7c75ba;
module.exports["useProducts"] = $26df14207fbe0be0$export$964e8498268f0fe3;
module.exports["useTypeEntities"] = $26df14207fbe0be0$export$59086fbf0d8f8d2a;
module.exports["useSelectFilterStore"] = $26df14207fbe0be0$export$aad641f503e4b4a8;
module.exports["useBooleanFilterStore"] = $26df14207fbe0be0$export$c724ec2cbd2fedce;
module.exports["useFiltersToDisplay"] = $26df14207fbe0be0$export$94c94f88577d66b2;
module.exports["useSelectedFilterCount"] = $26df14207fbe0be0$export$754cc306c2d9241e;

});

parcelRegister("a4u49", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d2d8bf6b15295f48$export$9f8e6b98f3e412c5 = (0, $kSwu1.defineMessages)({
    all: {
        id: "dynamic-cards-search-page.filter.type.all",
        defaultMessage: "All"
    },
    document: {
        id: "dynamic-cards-search-page.filter.type.documents",
        defaultMessage: "Documents"
    },
    spreadsheet: {
        id: "dynamic-cards-search-page.filter.type.spreadsheet",
        defaultMessage: "Spreadsheets"
    },
    presentation: {
        id: "dynamic-cards-search-page.filter.type.presentation",
        defaultMessage: "Presentations"
    },
    repository: {
        id: "dynamic-cards-search-page.filter.type.repository",
        defaultMessage: "Repositories"
    },
    'pull-request': {
        id: "dynamic-cards-search-page.filter.type.pull-request",
        defaultMessage: "Pull requests"
    },
    branch: {
        id: "dynamic-cards-search-page.filter.type.branch",
        defaultMessage: "Branches"
    },
    commit: {
        id: "dynamic-cards-search-page.filter.type.commit",
        defaultMessage: "Commits"
    },
    conversation: {
        id: "dynamic-cards-search-page.filter.type.conversation",
        defaultMessage: "Channels"
    },
    message: {
        id: "dynamic-cards-search-page.filter.type.message",
        defaultMessage: "Messages"
    },
    video: {
        id: "dynamic-cards-search-page.filter.type.video",
        defaultMessage: "Videos"
    },
    design: {
        id: "dynamic-cards-search-page.filter.type.design",
        defaultMessage: "Designs"
    },
    page: {
        id: "dynamic-cards-search-page.filter.type.page",
        defaultMessage: "Pages"
    },
    blogpost: {
        id: "dynamic-cards-search-page.filter.type.blogpost",
        defaultMessage: "Blog posts"
    },
    attachment: {
        id: "dynamic-cards-search-page.filter.type.attachment",
        defaultMessage: "Attachments"
    },
    space: {
        id: "dynamic-cards-search-page.filter.type.space",
        defaultMessage: "Spaces"
    },
    whiteboard: {
        id: "dynamic-cards-search-page.filter.type.whiteboard",
        defaultMessage: "Whiteboards"
    },
    issue: {
        id: "dynamic-cards-search-page.filter.type.issue",
        defaultMessage: "Issues"
    },
    project: {
        id: "dynamic-cards-search-page.filter.type.project",
        defaultMessage: "Projects"
    },
    goal: {
        id: "dynamic-cards-search-page.filter.type.goal",
        defaultMessage: "Goals"
    },
    tag: {
        id: "dynamic-cards-search-page.filter.type.tag",
        defaultMessage: "Tags"
    },
    'web-page': {
        id: "dynamic-cards-search-page.filter.type.web-page",
        defaultMessage: "Web pages"
    },
    comment: {
        id: "dynamic-cards-search-page.filter.type.comment",
        defaultMessage: "Comments"
    },
    database: {
        id: "dynamic-cards-search-page.filter.type.database",
        defaultMessage: "Databases"
    },
    embed: {
        id: "dynamic-cards-search-page.filter.type.embed",
        defaultMessage: "Smart Links"
    },
    folder: {
        id: "dynamic-cards-search-page.filter.type.folder",
        defaultMessage: "Folders"
    },
    calendar: {
        id: "dynamic-cards-search-page.filter.type.calendar",
        defaultMessage: "Calendars"
    },
    'space-calendar': {
        id: "dynamic-cards-search-page.filter.type.space-calendar",
        defaultMessage: "Space calendars"
    },
    answer: {
        id: "dynamic-cards-search-page.filter.type.answer",
        defaultMessage: "Answers"
    },
    question: {
        id: "dynamic-cards-search-page.filter.type.question",
        defaultMessage: "Questions"
    },
    component: {
        id: "dynamic-cards-search-page.filter.type.component",
        defaultMessage: "Components"
    },
    'work-item': {
        id: "dynamic-cards-search-page.filter.type.work-item",
        defaultMessage: "Work items"
    },
    board: {
        id: "dynamic-cards-search-page.filter.type.board",
        defaultMessage: "Board"
    },
    card: {
        id: "dynamic-cards-search-page.filter.type.card",
        defaultMessage: "Card"
    }
});
module.exports["typeLabels"] = $d2d8bf6b15295f48$export$9f8e6b98f3e412c5;

});

parcelRegister("db9XH", function(module, exports) {
/**
 * Mappings are typecasted with `as const` rather than using enums to
 * prevent reverse mappings generated by enums.
 */ const $e25b13fdafa0db3b$export$e8d1ded05852e864 = {
    source: 'source'
};
const $e25b13fdafa0db3b$export$d1fe2a1199482e6d = {
    release: 'release',
    product: 'product',
    cloudId: 'cloudId',
    userId: 'userId',
    primaryProduct: 'primaryProduct',
    experimentId: 'experimentId',
    experimentLayers: 'experimentLayers',
    abTestId: 'abTestId',
    isHello: 'isHello',
    version: 'version'
};
const $e25b13fdafa0db3b$export$ed78826c06dd24e3 = 'fabric-elements';
const $e25b13fdafa0db3b$export$ad44d4a0591d8dba = 'advancedSearchScreen';
const $e25b13fdafa0db3b$export$98bd2afc08f981ef = 'searchPage';
var $e25b13fdafa0db3b$export$1118b8908e5d0501 = /*#__PURE__*/ function(OptionIds) {
    OptionIds["TITLE"] = "title";
    OptionIds["ARCHIVED"] = "archived";
    OptionIds["ANCESTOR"] = "ancestor";
    OptionIds["TO"] = "to";
    OptionIds["FROM"] = "from";
    OptionIds["LAST_MODIFIED"] = "lastModified";
    return OptionIds;
}({});
const $e25b13fdafa0db3b$export$eed19b551669af14 = 'CURRENT';
const $e25b13fdafa0db3b$export$c936349447a77fe0 = 'ARCHIVED';
const $e25b13fdafa0db3b$export$a4c5cde0daa9b961 = 'crossProductSearch';
const $e25b13fdafa0db3b$export$2be5c31192ba8783 = 'all';
const $e25b13fdafa0db3b$export$cabdc1d3c523c88 = 'fullPageSearchErrorScreen';
var $e25b13fdafa0db3b$export$15029b2eda44c6a7 = /*#__PURE__*/ function(QueryState) {
    QueryState["POSTQUERY"] = "PostQuery";
    QueryState["PREQUERY"] = "PreQuery";
    return QueryState;
}({});
module.exports["ACTION_SUBJECT_PREFIX"] = $e25b13fdafa0db3b$export$98bd2afc08f981ef;
module.exports["QueryState"] = $e25b13fdafa0db3b$export$15029b2eda44c6a7;

});

parcelRegister("bU7gQ", function(module, exports) {

var $3Q5mv = parcelRequire("3Q5mv");

const $f5f791235c8b1b85$export$17d9a81ce3c86a85 = (urlSearchParams)=>{
    const queryParamsObject = Array.from(urlSearchParams.entries()).reduce((paramsObject, [paramKey, value])=>{
        return {
            ...paramsObject,
            [paramKey]: value
        };
    }, {});
    return queryParamsObject;
};
const $f5f791235c8b1b85$export$67c4cee80a3410cd = (queryParams, options)=>{
    const filteredParsedQueryParamEntries = Object.entries((0, $3Q5mv.searchQueryParamsBaseSchema).shape).map(([key, schema])=>{
        const queryParamValue = queryParams[key];
        const parsedRawValue = schema.safeParse(queryParamValue);
        if (parsedRawValue.success || !options?.commaSeparatedValues) return [
            key,
            parsedRawValue.data
        ];
        const commaSeparatedString = Array.isArray(queryParamValue) && queryParamValue.length ? queryParamValue.join(',') : undefined;
        const parsedString = schema.safeParse(commaSeparatedString);
        return [
            key,
            parsedString.success ? parsedString.data : null
        ];
    }).filter(([_, value])=>!(value === null || value === undefined));
    const parsedQueryParams = Object.fromEntries(filteredParsedQueryParamEntries);
    const validatedQueryParams = (0, $3Q5mv.searchQueryParamsValidators).reduce((queryParams, validator)=>validator(queryParams), parsedQueryParams);
    return validatedQueryParams;
};
const $f5f791235c8b1b85$export$60eb5b58f94d0071 = (oldQueryParams, newQueryParams)=>{
    const oldQueryParamEntries = Object.entries(oldQueryParams).filter(([_, value])=>!Array.isArray(value));
    const newQueryParamEntries = Object.entries(newQueryParams).filter(([_, value])=>!Array.isArray(value));
    const oldQueryParamArrayEntries = Object.entries(oldQueryParams).filter(([_, value])=>Array.isArray(value));
    const newQueryParamArrayEntries = Object.entries(newQueryParams).filter(([_, value])=>Array.isArray(value));
    const mergedQueryStringParamKeys = [
        ...new Set([
            ...oldQueryParamArrayEntries,
            ...newQueryParamArrayEntries
        ].map(([key])=>key))
    ];
    const mergedSearchQueryArrays = mergedQueryStringParamKeys.map((key)=>{
        return [
            key,
            [
                ...new Set([
                    ...oldQueryParams[key] ?? [],
                    ...newQueryParams[key] ?? [] // New query param array values take precedence
                ])
            ]
        ];
    });
    return {
        ...Object.fromEntries(oldQueryParamEntries),
        ...Object.fromEntries(newQueryParamEntries),
        ...Object.fromEntries(mergedSearchQueryArrays)
    };
};
const $f5f791235c8b1b85$export$fc8e8d0c43c32316 = (queryParams)=>{
    return Object.entries(queryParams).flatMap((queryParam)=>{
        const [key, value] = queryParam;
        if (Array.isArray(value)) return [
            [
                key,
                value.join(',')
            ]
        ];
        return [
            [
                key,
                value
            ]
        ];
    });
};
const $f5f791235c8b1b85$export$17404cc52c459484 = (queryParams)=>{
    const queryParamRawEntries = Object.entries(queryParams).flatMap((queryParam)=>{
        const [paramKey, value] = queryParam;
        if (value instanceof Date) {
            const dateFormatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            const dateFormatter = new Intl.DateTimeFormat('en-US', dateFormatOptions);
            const { month: month, day: day, year: year } = Object.fromEntries(dateFormatter.formatToParts(value).map((part)=>[
                    part.type,
                    part.value
                ]));
            return [
                [
                    paramKey,
                    `${year}-${month}-${day}`
                ]
            ];
        }
        if (value === false || value === true) return [
            [
                paramKey,
                String(value)
            ]
        ];
        if (Array.isArray(value)) return [
            [
                paramKey,
                value.join(',')
            ]
        ];
        return [
            [
                paramKey,
                value
            ]
        ];
    }).sort(([firstKey], [secondKey])=>firstKey < secondKey ? 1 : -1);
    return Object.fromEntries(queryParamRawEntries);
};
const $f5f791235c8b1b85$export$249cc09c933c4d7a = (queryParams)=>{
    const sanitizedQueryParams = Object.fromEntries(Object.entries(queryParams).filter(([_, value])=>value !== undefined));
    return new URLSearchParams($f5f791235c8b1b85$export$fc8e8d0c43c32316($f5f791235c8b1b85$export$17404cc52c459484(sanitizedQueryParams))).toString();
};
const $f5f791235c8b1b85$export$f30b1e6bbcaec160 = (queryParams)=>{
    return Object.fromEntries($f5f791235c8b1b85$export$fc8e8d0c43c32316($f5f791235c8b1b85$export$17404cc52c459484(queryParams)));
};
const $f5f791235c8b1b85$export$e247f217269cd2eb = (...queryParamArray)=>{
    const queryParamStrings = queryParamArray.map((queryParams)=>$f5f791235c8b1b85$export$249cc09c933c4d7a(queryParams));
    const allQueryParamsAreEqual = new Set(queryParamStrings).size === 1;
    return allQueryParamsAreEqual;
};
module.exports["parseQueryParams"] = $f5f791235c8b1b85$export$67c4cee80a3410cd;
module.exports["toQueryString"] = $f5f791235c8b1b85$export$249cc09c933c4d7a;
module.exports["toQueryParamsRaw"] = $f5f791235c8b1b85$export$f30b1e6bbcaec160;
module.exports["areAllEqualQueryParams"] = $f5f791235c8b1b85$export$e247f217269cd2eb;

});

parcelRegister("4mebe", function(module, exports) {

var $iJxD8 = parcelRequire("iJxD8");


var $5AmSa = parcelRequire("5AmSa");

const $44e71a9dbfe40201$export$e8eac31981efe1fb = (ari)=>{
    let teamId = null;
    if (!ari) return teamId;
    const isTeamsAri = (0, $5AmSa.TeamsTeamAri).check(ari);
    const isIdentityTeamsAri = (0, $iJxD8.IdentityTeamAri).check(ari);
    if (isTeamsAri) teamId = (0, $5AmSa.TeamsTeamAri).parse(ari).teamId;
    else if (isIdentityTeamsAri) teamId = (0, $iJxD8.IdentityTeamAri).parse(ari).teamId;
    if (teamId === 'unidentified') teamId = null;
    return teamId;
};
module.exports["getTeamId"] = $44e71a9dbfe40201$export$e8eac31981efe1fb;

});

parcelRegister("62FDZ", function(module, exports) {

var $3Q5mv = parcelRequire("3Q5mv");

const $81714bc2e26eeb94$var$notEmpty = (value)=>{
    return value !== null && value !== undefined;
};
const $81714bc2e26eeb94$export$a97e25c038594c73 = (staticFilters, filterStates)=>{
    const staticFilterValues = Array.isArray(staticFilters) ? staticFilters : Object.values(staticFilters);
    const staticFiltersRecord = Array.isArray(staticFilters) ? Object.fromEntries(staticFilters.map((staticFilter)=>[
            staticFilter.id,
            staticFilter
        ])) : staticFilters;
    const filterStateValues = Array.isArray(filterStates) ? filterStates : Object.values(filterStates).filter($81714bc2e26eeb94$var$notEmpty);
    const filterStatesRecord = Array.isArray(filterStates) ? Object.fromEntries(filterStates.map((filterState)=>[
            filterState.id,
            filterState
        ])) : filterStates;
    return {
        staticFilters: staticFiltersRecord,
        staticFilterValues: staticFilterValues,
        filterStates: filterStatesRecord,
        filterStateValues: filterStateValues,
        getSelectedProducts: (queryParams)=>{
            const queryParamKeys = Object.keys(queryParams);
            const productKey = (0, $3Q5mv.productKeySchema).safeParse(queryParams.product);
            if (productKey.success) return [
                productKey.data
            ];
            const allProductsWithSelections = staticFilterValues.filter((staticFilter)=>!staticFilter.universal) // Ignore universal filters as they are relevant to every product
            .filter((staticFilter)=>queryParamKeys.includes(staticFilter.queryParams.key)).map((staticFilter)=>staticFilter.products).flat();
            const selectedProducts = Array.from(new Set(allProductsWithSelections)); // might have to sort this based on some priority
            return selectedProducts;
        },
        isMissingProductSelection: (queryParams)=>{
            const selectedProducts = $81714bc2e26eeb94$export$a97e25c038594c73(staticFilters, filterStates).getSelectedProducts(queryParams);
            const productKey = (0, $3Q5mv.productKeySchema).safeParse(queryParams.product).data;
            return selectedProducts.length > 0 && !productKey;
        },
        filtersByProduct: (products)=>{
            const staticFiltersByProduct = staticFilterValues.filter((staticFilterValue)=>{
                if (!products.length) return staticFilterValue.universal; // Only universal filters are relevant if no apps are selected
                return staticFilterValue.products.some((product)=>products.includes(product));
            });
            const staticFiltersByProductKeys = staticFiltersByProduct.map((staticFilter)=>staticFilter.id);
            const filterStatesByProduct = filterStateValues.filter((filterState)=>staticFiltersByProductKeys.includes(filterState.id));
            return $81714bc2e26eeb94$export$a97e25c038594c73(staticFiltersByProduct, filterStatesByProduct);
        },
        getFiltersWithSelection: ()=>{
            const filterIDsWithSelection = filterStateValues.filter((x)=>x.hasSelection).map((x)=>x.id);
            return filterIDsWithSelection;
        }
    };
};
module.exports["FilterUtils"] = $81714bc2e26eeb94$export$a97e25c038594c73;

});


//# sourceMappingURL=cards-extension.9d3d7c3c.js.map
